webpackJsonp([234],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

bus.$listen = function (name, callback) {
    if (bus._events[name]) {
        bus.$off(name);
    }

    bus.$on(name, callback);
};

/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(78);





var shared = {
    state: {
        loaded: false, // component loaded (only once)
        ready: false, // data fetched (every time the location changes)

        client: null,
        location: null,
        project: null,

        mousedown: false,
        dragAction: 'select',

        editAction: null,
        pasting: false,

        selection: [],
        selectedCount: 0,
        selectionOffsets: [],

        days: [],
        items: {},

        availability: {},
        preview: null,
        hasPreview: false,

        users: {},
        duties: {},
        shifts: {},
        locations: {},
        tags: {},
        projects: null,

        clients: null,
        comments: [],
        notes: [],

        periods: {},
        period: null,
        from: null,
        until: null,

        weather: {},
        today: '',

        preset: false,

        coordinates: [] // holds the coordinates of the currently displayed items
    },

    getRoster: function getRoster(callback) {
        var _this = this;

        shared.state.ready = false;

        var loadClient = __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.params.id;

        // close toolbox in case it's still open
        __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('toolbox.close');

        // get current location if it's not set
        if (!__WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.current.location) {
            // try to get current active location of user
            __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].dispatch('app/reinit', function () {
                shared.state.location = __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.current.location;

                // still no location? user has no access to any location!
                if (!shared.state.location) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.redirect('overview');
                    return;
                }

                // location found! get roster!
                _this.getRoster(callback);
            });

            return;
        }

        shared.resetSelection();

        // get roster for location, from, until
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/api/items', {
            params: {
                scope: 'planning',
                location: shared.state.location,
                project: shared.state.project,
                period: shared.state.period
            } }).then(function (response) {
            shared.state.days = response.data.days;
            shared.state.items = response.data.items;

            if (!shared.state.loaded || loadClient) {
                // set client explicitly
                shared.state.client = response.data.client;
            }

            shared.state.users = response.data.users;
            shared.state.duties = _.keyBy(_.sortBy(response.data.duties, function (duty) {
                return duty.name.toLowerCase();
            }), 'id');
            shared.state.shifts = _.keyBy(_.sortBy(response.data.shifts, function (shift) {
                return shift.name.toLowerCase();
            }), 'id');
            shared.state.locations = _.keyBy(_.sortBy(response.data.locations, function (location) {
                return location.name.toLowerCase();
            }), 'id');
            shared.state.comments = response.data.comments;
            shared.state.notes = response.data.notes;
            shared.state.tags = response.data.tags;
            shared.state.availability = response.data.availability;

            shared.state.period = response.data.periods.default;
            shared.state.periods = response.data.periods.options;
            shared.state.from = response.data.periods.from;
            shared.state.until = response.data.periods.until;

            shared.state.preset = false;
            shared.state.loaded = true;
            shared.state.ready = true;

            if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule('weather')) {
                shared.state.weather = response.data.weather;
            }

            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/api/projects?only-active=true').then(function (response) {
                shared.state.projects = response.data;
            });

            __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('roster.loaded');

            if (typeof callback === 'function') callback();
        }).catch(function (error) {
            if (error.response.status == '409') {
                // try to get current active location of user
                __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].dispatch('app/reinit', function () {
                    shared.state.location = __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.current.location;

                    // still no location? user has no access to any location!
                    if (!shared.state.location) {
                        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.redirect('overview');
                        return;
                    }

                    // location found! get roster!
                    _this.getRoster(callback);
                });
            }
        });
    },
    getPreset: function getPreset(callback) {
        var _this2 = this;

        shared.state.ready = false;

        // close toolbox in case it's still open
        __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('toolbox.close');

        // get current location if it's not set
        if (!__WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.current.location) {
            // try to get current active location of user
            __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].dispatch('app/reinit', function () {
                shared.state.location = __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.current.location;

                // still no location? user has no access to any location!
                if (!shared.state.location) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.redirect('overview');
                    return;
                }

                // location found! get roster!
                _this2.getRoster(callback);
            });

            return;
        }

        shared.resetSelection();

        // get roster for location, from, until
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/api/items', {
            params: {
                scope: 'preset',
                location: shared.state.location
            } }).then(function (response) {
            shared.state.days = response.data.days;
            shared.state.items = response.data.items;

            shared.state.comments = response.data.comments;
            shared.state.notes = response.data.notes;
            shared.state.tags = response.data.tags;
            shared.state.availability = response.data.availability;

            shared.state.loaded = true;
            shared.state.ready = true;

            __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('roster.loaded');

            if (typeof callback === 'function') callback();
        }).catch(function (error) {
            if (error.response.status == '409') {
                // try to get current active location of user
                __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].dispatch('app/reinit', function () {
                    shared.state.location = __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.current.location;

                    // still no location? user has no access to any location!
                    if (!shared.state.location) {
                        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.redirect('overview');
                        return;
                    }

                    // location found! get roster!
                    _this2.getRoster(callback);
                });
            }
        });
    },
    getUser: function getUser(id) {
        return shared.state.users[id];
    },
    getDuty: function getDuty(id) {
        return shared.state.duties[id];
    },
    getShift: function getShift(id) {
        return shared.state.shifts[id];
    },
    getLocation: function getLocation(id) {
        return shared.state.locations[id];
    },
    getClient: function getClient(id) {
        return shared.state.clients ? shared.state.clients[id] : null;
    },
    getTag: function getTag(id) {
        return shared.state.tags[id];
    },
    getComments: function getComments(id) {
        return _.orderBy(shared.state.comments.filter(function (item) {
            return id === item.date;
        }), ['createdAt'], ['asc']);
    },
    removeComment: function removeComment(id) {
        shared.state.comments = _.remove(shared.state.comments, function (item) {
            return item.id !== id;
        });
    },
    hasApplications: function hasApplications(item) {
        if (!item.assigned && item.applications.length) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].modal.show(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].t('text.attention'), __WEBPACK_IMPORTED_MODULE_0_vue__["default"].t('warning.item_with_applications'));
            return true;
        }

        return false;
    },
    getNotes: function getNotes(date) {
        var note = _.find(shared.state.notes, { date: date });

        return note ? note.content : null;
    },
    resetSelection: function resetSelection(hard) {
        _.forEach(shared.state.items, function (item) {
            item.selected = false;
        });

        shared.state.dragAction = 'select';
        shared.state.selectedCount = 0;

        if (hard) {
            // hard reset will also
            shared.state.editAction = null;
            shared.state.pasting = false;
            shared.state.selection = [];
            shared.state.selectionOffsets = [];
        } else {
            // only remove coordination event listeners between
            // location switch or change of month via dropdown
            // (otherwise old item event listeners will keep firing)
            __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$off('roster.item.coords');
        }
    },
    revalidate: function revalidate(items) {
        if (!items) return;

        _.forEach(items, function (conflicts, id) {
            var item = _.find(shared.state.items, { 'id': id });

            // need to use $set to make item reactive
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(item, 'conflicts', conflicts);
        });
    },
    checkCarAssignment: function checkCarAssignment(item) {
        if (item.duty && item.duty.car && window.$onduro.getConfig('settings.driverAssign') === 'manual') {
            assignDriver(item);
        }
    },
    findAvailableDrivers: function findAvailableDrivers(rosterItems) {
        return rosterItems.filter(function (rosterItem) {
            return rosterItem.duty && !rosterItem.duty.car && !rosterItem.isDriver;
        });
    },
    assignDriver: function assignDriver(carItem) {
        var availableDrivers = findAvailableDrivers(window.$store.state.roster.items);

        if (availableDrivers.length === 1) {
            setDriver(carItem, availableDrivers[0]);
        } else if (availableDrivers.length > 1) {
            window.$modal.show({
                title: window.$t('Select a Driver'),
                content: availableDrivers.map(function (driver) {
                    return {
                        text: driver.user.name,
                        value: driver
                    };
                }),
                confirm: function confirm(selectedDriver) {
                    setDriver(carItem, selectedDriver);
                }
            });
        } else {
            window.$notify.error(window.$t('No available drivers found for this car.'));
        }
    },
    setDriver: function setDriver(carItem, driverItem) {
        carItem.driver = driverItem.id;
        driverItem.isDriver = true;

        window.$http.post('/api/assign-driver', {
            car_id: carItem.id,
            driver_id: driverItem.id
        }).then(function () {
            window.$notify.success(window.$t('Driver assigned successfully.'));
        }).catch(function (error) {
            console.error(error);
            window.$notify.error(window.$t('Failed to assign driver.'));
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (shared);

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_current__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_auth__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_meta__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_layout__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_sidebar__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_cache__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_temp__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_loader__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_chat__ = __webpack_require__(449);



// modules











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// build the store
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({

    modules: {
        app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
        current: __WEBPACK_IMPORTED_MODULE_3__modules_current__["a" /* default */],
        auth: __WEBPACK_IMPORTED_MODULE_4__modules_auth__["a" /* default */],
        meta: __WEBPACK_IMPORTED_MODULE_5__modules_meta__["a" /* default */],
        layout: __WEBPACK_IMPORTED_MODULE_6__modules_layout__["a" /* default */],
        sidebar: __WEBPACK_IMPORTED_MODULE_7__modules_sidebar__["a" /* default */],
        cache: __WEBPACK_IMPORTED_MODULE_8__modules_cache__["a" /* default */],
        temp: __WEBPACK_IMPORTED_MODULE_9__modules_temp__["a" /* default */],
        loader: __WEBPACK_IMPORTED_MODULE_10__modules_loader__["a" /* default */],
        chat: __WEBPACK_IMPORTED_MODULE_11__modules_chat__["a" /* default */]
    },

    strict: "production" !== 'production'

}));

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


// Import the base German locale
var baseLocales = __webpack_require__(79).default;
// Import the German country translations
var countries = __webpack_require__(496);

// Create a deep copy of the base locales
var locales = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(baseLocales));

// Add the common.countries section if it doesn't exist
if (!locales.common) {
    locales.common = {};
}
if (!locales.common.countries) {
    locales.common.countries = {};
}

// Add the country translations
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(locales.common.countries, countries);

/* harmony default export */ __webpack_exports__["default"] = (locales);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


// Import the base Dutch locale
var baseLocales = __webpack_require__(80).default;
// Import the Dutch country translations
var countries = __webpack_require__(497);

// Create a deep copy of the base locales
var locales = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(baseLocales));

// Add the common.countries section if it doesn't exist
if (!locales.common) {
    locales.common = {};
}
if (!locales.common.countries) {
    locales.common.countries = {};
}

// Add the country translations
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(locales.common.countries, countries);

/* harmony default export */ __webpack_exports__["default"] = (locales);

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return methods; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);





var mixin = {
    data: function data() {
        return {
            ready: false
        };
    },


    props: {
        channel: {
            required: true
        },

        chatStates: {
            required: false,
            default: []
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
        user: function user(_ref) {
            var current = _ref.current;
            return current.user;
        }
    }), {
        lastParticipant: function lastParticipant() {
            try {
                return this.lastChannel.lastChat.user.name;
            } catch (e) {
                return '';
            }
        },
        lastChannel: function lastChannel() {
            var last = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.last(this.unreadChats);

            if (typeof last !== 'undefined') return last.channel;
            return this.channel;
        },
        unreadCount: function unreadCount() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(this.unreadChats);
        },
        unreadChats: function unreadChats() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.chatStates, {
                'channel': {
                    'id': this.channel.id
                }
            });
        }
    }),

    methods: {
        refreshUnreadChats: function refreshUnreadChats(unreadChats, channelId) {
            var _this = this;

            var ids = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(unreadChats, function (chat) {
                return chat.readAt === null && chat.channel.id === channelId;
            }), function (item) {
                return item.statusId;
            });

            if (!ids.length) return;

            this.$http.silent().put('/api/memberships/unread-chats', {
                ids: ids,
                status: 'read',
                channel: channelId
            }).then(function (response) {
                _this.$store.commit('chat/SET_UNREAD_CHATS', response.data, { root: true });
            });
        },
        dateFormat: function dateFormat(format, date) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, format).calendar(null, {
                sameDay: 'HH:mm',
                lastDay: '[Yesterday]',
                lastWeek: 'dddd',
                sameElse: 'DD. MMMM YYYY'
            });
        }
    }
};

/* harmony default export */ __webpack_exports__["b"] = (mixin);
var computed = { computed: mixin.computed };
var methods = { methods: mixin.methods };

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__(123);






var languages = ['en', 'de', 'nl', 'pl'];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/*
 *  Require Authenticated User
 *
 *  First, checks if user is currently authenticated, then checks if the account set-up has been completed.
 *  Optionally, additional checks will be performed which will redirect to the given route or the overview page.
 *  If no callback is provided, the given route will be executed.
 */
function requireAuth(to, from, next, callback) {
    if (!__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.auth.authenticated) {
        next({
            path: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('login'),
            query: { redirect: to.fullPath }
        });
    } else if (!__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.account.setup) {
        // user is logged-in, but account set-up is not yet completed
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].modal.show('Account set-up incomplete', 'Your account has not been set-up completely. Please follow the link in your set-up email or contact support!', function () {
            __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('auth/logout', function (success) {
                next(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('login'));
            });
        });
    } else if (typeof callback == 'function') {
        // callback will return a LOOSE boolean value (could also be "2")
        if (callback()) {
            next();
        } else {
            // redirect to overview page
            next({ path: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('overview') });
        }
    } else {
        next();
    }
}

/**
 * Check for module rights and authorization
 * if 4th argument module is given, check for this instead of 'to.name'
 *
 * @param to
 * @param from
 * @param next
 * @param {String} module
 */
function requireModule(to, from, next, module) {
    var name = module ? module : to.name;

    requireAuth(to, from, next, function () {
        return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule(name);
    });
}

/**
 * Route components
 */
var Login = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/login/signin/Page', 'login.signin');
var Password = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/login/password/Page', 'login.password');
var Confirmation = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/login/confirmation/Page', 'login.confirmation');
var Reset = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/login/reset/Page', 'login.reset');
var Signup = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/login/signup/Page', 'login.signup');
var Confirm = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/login/confirm/Page', 'login.confirm');
var Accept = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/login/accept/Page', 'login.accept');
var Welcome = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/welcome/Page', 'welcome');
// const Register = loadComponent('./pages/register/Page', 'register');
var Demo = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/demo/Page', 'demo');
var TwoFactorSetup = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/login/2fa-setup/Page', '2fa.setup');
var TwoFactorVerify = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/login/2fa-verify/Page', '2fa.verify');

var Setup = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/setup/Page');
var Example = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/example', 'example');

var Overview = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/overview/Page', 'overview');
var Today = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/today/Page', 'today');
var Roster = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/roster/Page', 'roster');
var Planning = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/planning/Page', 'planning');
var Plannings = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/plannings/Page', 'plannings');
var Lists = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/lists/Page', 'lists');
var Availability = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/availability/Page', 'availability');
var Balances = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/balances/overview/Page', 'balances');
var BalancesDetails = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/balances/details/Page');
var Reports = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/reports/Page', 'reports');
var Profile = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/profile/Page', 'profile');
var Notifications = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/notifications/Page', 'notifications');
var Hours = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/hours/Page', 'hours');
var Contacts = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/contacts/Page', 'contacts');
var Team = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/team/overview/Page', 'team');
var TeamEdit = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/team/edit/Page');
var Resources = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/resources/overview/Page', 'resources');
var ResourcesEdit = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/resources/edit/Page');
var Log = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/log/Page', 'log');
var Modules = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/modules/Page', 'modules');
var Dashboard = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/dashboard/Page', 'dashboard');
var Clients = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/clients/overview/Page', 'clients');
var Company = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/company/Page', 'company');
var FreelancerInvoices = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/freelancer/Page', 'freelancer');
var Projects = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/projects/Page', 'projects');
// const ClientDetails = loadComponent('./pages/clients/details/Page');

var Chats = {
    Overview: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/chats/overview/Page', 'chats'),
    Details: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/chats/details/Page')
};

var Settings = {
    Layout: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/Page'),
    General: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/general/Page', 'settings.general'),
    Company: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/company/Page', 'settings.company'),
    Availability: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/availability/Page', 'settings.availability'),
    Expenses: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/expenses/Page', 'settings.expenses'),
    Locations: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/locations/Page', 'settings.locations'),
    Duties: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/duties/Page', 'settings.duties'),
    Contracts: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/contracts/Page', 'settings.contracts'),
    Shifts: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/shifts/Page', 'settings.shifts'),
    Costs: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/costs/Page', 'settings.costs'),
    Premiums: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/premiums/Page', 'settings.premiums'),
    Rates: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/rates/Page', 'settings.rates'),
    Tags: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/tags/Page', 'settings.tags'),
    Holidays: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/holidays/Page', 'settings.holidays'),
    Advanced: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/advanced/Page', 'settings.advanced'),
    Checkin: Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/settings/checkin/Page', 'settings.checkin')
};

var Subscription = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/subscription/Page', 'subscription');
var Invoice = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/invoice/Page', 'invoice');
var Statistics = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/statistics/Page', 'statistics');

var Documents = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/documents/overview/Page', 'documents');
var DocumentsDetail = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/documents/detail/Page', 'documents.detail');

var Checkins = Object(__WEBPACK_IMPORTED_MODULE_4__services__["a" /* loadComponent */])('./pages/checkins/Page', 'checkins');

/**
 * Routes
 */
var routes = [
/** BACKEND ROUTES **/
{
    path: '/',
    name: 'home',
    beforeEnter: function beforeEnter(to, from, next) {
        if (!__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.auth.authenticated) {
            next(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('login'));
        } else {
            next(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('overview'));
        }
    },

    meta: { section: 'backend' }
}, {
    path: '/:lang',
    beforeEnter: function beforeEnter(to, from, next) {
        if (!__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.auth.authenticated) {
            next(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('login'));
        } else {
            next(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('overview'));
        }
    },

    meta: { section: 'backend' }
},
// {
//     path: '/:lang/example',
//     component: Example,
//     beforeEnter: (to, from, next) => requireAuth(to, from, next, () =>
//     {
//         return store.state.app.env == 'local';
//     }),
//     meta: { section: 'backend' },
//     name: 'example',
// },
{
    path: '/:lang/overview',
    component: Overview,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'overview',
    alias: ['/:lang/startseite', '/:lang/overzicht']
}, {
    path: '/:lang/company',
    component: Company,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'company',
    alias: ['/:lang/unternehmen', '/:lang/bedrijf']
}, {
    path: '/:lang/check-ins',
    component: Checkins,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule('checkins') && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal() && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('supervisor');
        });
    },
    meta: { section: 'backend' },
    name: 'checkins'
}, {
    path: '/:lang/today',
    component: Today,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal();
        });
    },
    meta: { section: 'backend' },
    name: 'today',
    alias: ['/:lang/heute', '/:lang/vandaag']
}, {
    path: '/:lang/roster',
    component: Roster,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal();
        });
    },
    meta: { section: 'backend' },
    name: 'roster',
    alias: ['/:lang/dienstplan', '/:lang/rooster']
}, {
    path: '/:lang/roster/:location/:date',
    component: Roster,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal();
        });
    },
    meta: { section: 'backend' },
    name: 'roster.item',
    alias: ['/:lang/dienstplan/:location/:date', '/:lang/rooster/:location/:date']
}, {
    // this route must be before the next one!
    path: '/:lang/planning/overview/:client?',
    component: Plannings,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'plannings',
    alias: ['/:lang/planning/overzicht/:client?', '/:lang/planning/uebersicht/:client?']
}, {
    path: '/:lang/planning/:id?',
    component: Planning,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal() && (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('planner') || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('observer'));
        });
    },
    meta: { section: 'backend' },
    name: 'planning',
    alias: ['/:lang/planung/:id?']
}, {
    path: '/:lang/clients',
    component: Clients,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'clients',
    alias: ['/:lang/kunden', '/:lang/klanten']
},
// {
//     path: '/:lang/clients/:id',
//     component: ClientDetails,
//     beforeEnter: requireAuth,
//     meta: { section: 'backend' },
//     name: 'clients.edit',
//     alias: ['/:lang/kunden/:id','/:lang/klanten/:id'],
// },
{
    path: '/:lang/lists',
    component: Lists,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule('lists') && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('planner');
        });
    },
    meta: { section: 'backend' },
    name: 'lists',
    alias: ['/:lang/listen', '/:lang/lijsten']
}, {
    path: '/:lang/availability',
    component: Availability,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal() && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule('availability') && (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('planner') || __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.membership.availability);
        });
    },
    meta: { section: 'backend' },
    name: 'availability',
    alias: ['/:lang/verfuegbarkeit', '/:lang/beschikbaarheid']
}, {
    path: '/:lang/contacts',
    component: Contacts,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal() && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule('contacts') && (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRight('contacts.view') || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.getConfig('contacts.visibility'));
        });
    },
    meta: { section: 'backend' },
    name: 'contacts',
    alias: ['/:lang/adressbuch', '/:lang/adresboek']
}, {
    path: '/:lang/chats',
    component: Chats.Overview,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireModule(to, from, next, 'chats');
    },
    meta: { section: 'backend' },
    name: 'chats',
    alias: ['/:lang/unterhaltungen', '/:lang/berichten']
}, {
    path: '/:lang/chats/:channel',
    component: Chats.Details,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireModule(to, from, next, 'chats');
    },
    meta: { section: 'backend' },
    name: 'chats.details',
    alias: ['/:lang/unterhaltungen/:channel', '/:lang/berichten/:channel']
}, {
    path: '/:lang/balance',
    component: Balances,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'balances',
    alias: ['/:lang/zeitkonto', '/:lang/tijd-voor-tijd']
}, {
    path: '/:lang/balance/:id',
    component: BalancesDetails,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'balances.details',
    alias: ['/:lang/zeitkonto/:id', '/:lang/tijd-voor-tijd/:id']
}, {
    path: '/:lang/reports',
    component: Reports,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('accountant');
        });
    },
    meta: { section: 'backend' },
    name: 'reports',
    alias: ['/:lang/auswertung', '/:lang/rapportage']
}, {
    path: '/:lang/profile',
    component: Profile,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'profile',
    alias: ['/:lang/profil', '/:lang/profiel']
}, {
    path: '/:lang/notifications',
    component: Notifications,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal();
        });
    },
    meta: { section: 'backend' },
    name: 'notifications',
    alias: ['/:lang/benachrichtigungen', '/:lang/notificaties']
}, {
    path: '/:lang/timesheet',
    component: Hours,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal() && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule('hours');
        });
    },
    meta: { section: 'backend' },
    name: 'hours',
    alias: ['/:lang/stundenzettel', '/:lang/urenregistratie'],

    children: [{
        path: ':page',
        name: 'hours.page',
        meta: { section: 'backend' }
    }]
}, {
    path: '/:lang/employees',
    component: Team,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRight('user.edit');
        });
    },
    meta: { section: 'backend' },
    name: 'team',
    alias: ['/:lang/mitarbeiter', '/:lang/werknemers']
}, {
    path: '/:lang/freelancer-facturen',
    component: FreelancerInvoices,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule('freelancers') && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole(['owner', 'manager', 'accountant', 'freelancer']);
        });
    },
    meta: { section: 'backend' },
    name: 'freelancer',
    alias: ['/:lang/selbstandig-rechnungen', '/:lang/freelancer-invoices']
}, {
    path: '/:lang/projects',
    component: Projects,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule('projects') && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole(['owner', 'manager', 'accountant', 'freelancer']);
        });
    },
    meta: { section: 'backend' },
    name: 'projects',
    alias: ['/:lang/projekte', '/:lang/opdrachten']
}, {
    path: '/:lang/employees/:id',
    component: TeamEdit,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRight('user.edit');
        });
    },
    meta: { section: 'backend' },
    name: 'team.edit',
    alias: ['/:lang/mitarbeiter/:id', '/:lang/werknemers/:id']
}, {
    path: '/:lang/resources',
    component: Resources,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule('resources') && (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRight('user.edit') || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('planner'));
        });
    },
    meta: { section: 'backend' },
    name: 'resources',
    alias: ['/:lang/ressourcen', '/:lang/middelen']
}, {
    path: '/:lang/resources/:id',
    component: ResourcesEdit,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasModule('resources') && (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRight('user.edit') || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('planner'));
        });
    },
    meta: { section: 'backend' },
    name: 'resources.edit',
    alias: ['/:lang/ressourcen/:id', '/:lang/middelen/:id']
}, {
    path: '/:lang/log',
    component: Log,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'log',
    alias: ['/:lang/protokoll']
}, {
    path: '/:lang/modules',
    component: Modules,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal() && __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('owner', 'manager');
        });
    },
    meta: { section: 'backend' },
    name: 'modules',
    alias: ['/:lang/module'] // no dutch translation here, because dutch = english (otherwise error!)
}, {
    path: '/de/einstellungen',
    meta: { section: 'backend' },
    redirect: '/de/einstellungen/allgemein'
}, {
    path: '/nl/instellingen',
    meta: { section: 'backend' },
    redirect: '/nl/instellingen/algemeen'
}, {
    path: '/:lang/settings',
    name: 'settings',
    component: Settings.Layout,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('owner', 'manager');
        });
    },
    alias: ['/:lang/einstellungen', '/:lang/instellingen'],
    meta: { section: 'backend' },
    redirect: { name: 'settings.general' },

    children: [{
        path: 'general',
        name: 'settings.general',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/allgemein', '/:lang/instellingen/algemeen'],
        meta: { section: 'backend' },
        component: Settings.General
    }, {
        path: 'availability',
        name: 'settings.availability',
        beforeEnter: function beforeEnter(to, from, next) {
            return requireAuth(to, from, next, function () {
                return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal();
            });
        },
        alias: ['/:lang/einstellungen/verfuegbarkeit', '/:lang/instellingen/beschikbaarheid'],
        meta: { section: 'backend' },
        component: Settings.Availability
    }, {
        path: 'expenses',
        name: 'settings.expenses',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/unkosten', '/:lang/instellingen/onkosten'],
        meta: { section: 'backend' },
        component: Settings.Expenses
    }, {
        path: 'locations',
        name: 'settings.locations',
        beforeEnter: function beforeEnter(to, from, next) {
            return requireAuth(to, from, next, function () {
                return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal();
            });
        },
        alias: ['/:lang/einstellungen/standorte', '/:lang/instellingen/locaties'],
        meta: { section: 'backend' },
        component: Settings.Locations
    }, {
        path: 'functions',
        name: 'settings.duties',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/funktionen', '/:lang/instellingen/functies'],
        meta: { section: 'backend' },
        component: Settings.Duties
    }, {
        path: 'contracts',
        name: 'settings.contracts',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/vertraege', '/:lang/instellingen/contracten'],
        meta: { section: 'backend' },
        component: Settings.Contracts
    }, {
        path: 'shifts',
        name: 'settings.shifts',
        beforeEnter: function beforeEnter(to, from, next) {
            return requireAuth(to, from, next, function () {
                return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal();
            });
        },
        alias: ['/:lang/einstellungen/schichten', '/:lang/instellingen/shifts'],
        meta: { section: 'backend' },
        component: Settings.Shifts
    }, {
        path: 'costs',
        name: 'settings.costs',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/kostenstellen', '/:lang/instellingen/kostenplaatsen'],
        meta: { section: 'backend' },
        component: Settings.Costs
    }, {
        path: 'premiums',
        name: 'settings.premiums',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/zuschlaege', '/:lang/instellingen/toeslagen'],
        meta: { section: 'backend' },
        component: Settings.Premiums
    }, {
        path: 'rates',
        name: 'settings.rates',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/stundenloehne', '/:lang/instellingen/uurlonen'],
        meta: { section: 'backend' },
        component: Settings.Rates
    }, {
        path: 'tags',
        name: 'settings.tags',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/tags', '/:lang/instellingen/tags'],
        meta: { section: 'backend' },
        component: Settings.Tags
    }, {
        path: 'holidays',
        name: 'settings.holidays',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/feiertage', '/:lang/instellingen/feestdagen'],
        meta: { section: 'backend' },
        component: Settings.Holidays
    }, {
        path: 'advanced',
        name: 'settings.advanced',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/erweitert', '/:lang/instellingen/geavanceerd'],
        meta: { section: 'backend' },
        component: Settings.Advanced
    }, {
        path: 'check-in',
        name: 'settings.checkin',
        beforeEnter: requireAuth,
        alias: ['/:lang/einstellungen/check-in', '/:lang/instellingen/check-in'],
        meta: { section: 'backend' },
        component: Settings.Checkin
    }]
}, {
    path: '/:lang/subscription',
    component: Subscription,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('owner');
        });
    },
    meta: { section: 'backend' },
    name: 'subscription',
    alias: ['/:lang/abonnement']
}, {
    path: '/:lang/subscription/confirm',
    component: Subscription,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'subscription.confirm',
    alias: ['/:lang/abonnement/bestaetigen', '/:lang/abonnement/bevestigen']
}, {
    path: '/:lang/invoice/:id',
    component: Invoice,
    beforeEnter: requireAuth,
    meta: { section: 'invoice' },
    name: 'invoice',
    alias: ['/:lang/rechnung/:id', '/:lang/factuur/:id']
}, {
    path: '/:lang/statistics',
    component: Statistics,
    beforeEnter: function beforeEnter(to, from, next) {
        return requireAuth(to, from, next, function () {
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReal();
        });
    },
    meta: { section: 'backend' },
    name: 'statistics',
    alias: ['/:lang/statistiken', '/:lang/statistieken']
}, {
    path: '/:lang/documents',
    component: Documents,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'documents',
    alias: ['/:lang/dokumente', '/:lang/documenten']
}, {
    path: '/:lang/documents/:type',
    component: DocumentsDetail,
    beforeEnter: requireAuth,
    meta: { section: 'backend' },
    name: 'documents.detail',
    alias: ['/:lang/dokumente/:type', '/:lang/documenten/:type']
}, {
    path: '/:lang/i/:id/:hash',
    beforeEnter: function beforeEnter(to, from, next) {
        location.href = 'https://data.onduro.com/invoices/' + to.params.id + '/' + to.params.hash;
        next('/');
    }
},

/** FRONTEND ROUTES **/

{
    path: '/:lang/demo',
    component: Demo,
    name: 'demo',
    meta: { section: 'frontend' },
    beforeEnter: function beforeEnter(to, from, next) {
        if (__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.auth.authenticated) {
            next(to.query.redirect || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('overview'));
        } else {
            next();
        }
    }
},
// {
//     path: '/:lang/register',
//     component: Register,
//     name: 'register',
//     alias: ['/:lang/registrieren','/:lang/registreren'],
//     meta: { section: 'frontend' },
//     beforeEnter(to, from, next) {
//         if (store.state.auth.authenticated) {
//             next(to.query.redirect || Vue.onduro.route('overview'));
//         } else {
//             next();
//         }
//     },
// },
{
    path: '/:lang/login/signin',
    component: Login,
    name: 'login.signin',
    alias: ['/:lang/login/anmeldung', '/:lang/login/aanmelden'],
    meta: { section: 'frontend' },
    beforeEnter: function beforeEnter(to, from, next) {
        if (__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.auth.authenticated) {
            next(to.query.redirect || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('overview'));
        } else {
            next();
        }
    }
}, {
    path: '/:lang/login/forgot-password',
    component: Password,
    name: 'login.password',
    alias: ['/:lang/login/passwort-vergessen', '/:lang/login/wachtwoord-vergeten'],
    meta: { section: 'frontend' },
    beforeEnter: function beforeEnter(to, from, next) {
        if (__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.auth.authenticated) {
            next(to.query.redirect || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('overview'));
        } else {
            next();
        }
    }
}, {
    path: '/:lang/login/request-confirmation',
    component: Confirmation,
    name: 'login.confirmation',
    alias: ['/:lang/login/bestaetigungscode-anfordern', '/:lang/login/bevestigingscode-aanvragen'],
    meta: { section: 'frontend' },
    beforeEnter: function beforeEnter(to, from, next) {
        if (__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.auth.authenticated) {
            next(to.query.redirect || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('overview'));
        } else {
            next();
        }
    }
}, {
    path: '/:lang/login/reset-password/:code',
    component: Reset,
    name: 'login.reset',
    alias: ['/:lang/login/passwort-zuruecksetzen/:code', '/:lang/login/wachtwoord-opnieuw-instellen/:code'],
    meta: { section: 'frontend' },
    beforeEnter: function beforeEnter(to, from, next) {
        // make sure user is logged out on this page
        __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('auth/logout', function (success) {
            next();
        });
    }
}, {
    path: '/:lang/login/signup/:code',
    component: Signup,
    name: 'login.signup',
    alias: ['/:lang/login/registrieren/:code', '/:lang/login/registreren/:code'],
    meta: { section: 'frontend' },
    beforeEnter: function beforeEnter(to, from, next) {
        // make sure user is logged out on this page
        __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('auth/logout', function (success) {
            next();
        });
    }
}, {
    path: '/:lang/login/confirm-email/:code/:account?',
    component: Confirm,
    name: 'login.confirm',
    alias: ['/:lang/login/email-bestaetigen/:code/:account?', '/:lang/login/email-bevestigen/:code/:account?'],
    meta: { section: 'frontend' },
    beforeEnter: function beforeEnter(to, from, next) {
        // make sure user is logged out on this page
        __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('auth/logout', function (success) {
            next();
        });
    }
}, {
    path: '/:lang/login/accept-invitation/:code',
    component: Accept,
    name: 'login.accept',
    alias: ['/:lang/login/einladung-akzeptieren/:code', '/:lang/login/uitnodiging-accepteren/:code'],
    meta: { section: 'frontend' },
    beforeEnter: function beforeEnter(to, from, next) {
        // make sure user is logged out on this page
        __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('auth/logout', function (success) {
            next();
        });
    }
}, {
    path: '/:lang/login/2fa/verify',
    component: TwoFactorVerify,
    name: '2fa.verify',
    alias: ['/:lang/login/2fa/verifizieren', '/:lang/login/2fa/verifieren'],
    meta: { section: 'frontend' }
}, {
    path: '/:lang/login/2fa/setup',
    component: TwoFactorSetup,
    name: '2fa.setup',
    alias: ['/:lang/login/2fa/einrichten', '/:lang/login/2fa/inrichten'],
    meta: { section: 'frontend' }
},

/** EMPTY TEMPLATE **/

{
    path: '/:lang/welcome',
    component: Welcome,
    name: 'welcome',
    alias: ['/:lang/willkommen', '/:lang/welkom'],
    meta: { section: 'empty' },
    beforeEnter: function beforeEnter(to, from, next) {
        if (__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.auth.authenticated) {
            next(to.query.redirect || __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('overview'));
        } else {
            next();
        }
    }
}, {
    path: '/:lang/dashboard/:id/:hash',
    component: Dashboard,
    name: 'dashboard',
    meta: { section: 'empty' }
    // beforeEnter(to, from, next) {
    //     next();
    // },
},

/** SETUP ROUTES **/

{
    path: '/:lang/setup/:id/:token',
    name: 'setup',
    component: Setup,
    meta: { section: 'wizard' },
    beforeEnter: function beforeEnter(to, from, next) {
        __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('auth/logout', function (success) {
            next();
        });
    }
}, {
    path: '/:lang/logout',
    beforeEnter: function beforeEnter(to, from, next) {

        if (__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.layout.viewport == 'ml' || __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.layout.viewport == 'mp') {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].confirm.show(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].t('page.logout.confirm.headline'), __WEBPACK_IMPORTED_MODULE_0_vue__["default"].t('page.logout.confirm.body'), {
                confirm: function confirm() {
                    __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('auth/logout', function (success) {
                        next(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('login'));
                    });
                }
            }, {
                confirm: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].t('common.button.confirm'),
                decline: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].t('common.button.decline')
            });

            return false;
        }

        __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('auth/logout', function (success) {
            next(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('login'));
        });
    }
}];

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    routes: routes,
    mode: 'history'
    // scrollBehavior (to, from, savedPosition)
    // {
    //     console.info(savedPosition);
    //     if (savedPosition) {
    //         return savedPosition
    //     } else {
    //         return { x: 0, y: 0 }
    //     }
    // }
});

// sync router and store
Object(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */], router);

// configure default route handling
router.beforeEach(function (to, from, next) {
    /*
     * Route translation for URLs from email
     *
     * Usage: {{event.app_url}}/translate/{{customer.language}}?route=login/confirm&suffix={{event.code}}/{{event.hash}}
     * Example: .../translate/de?route=login/reset&suffix=52afeb7ad50a66b6eaa3d1827c08dce1
     */
    if (to.path.indexOf('/translate') === 0) {

        var lang = to.path.split('/')[2];

        if (['de', 'nl', 'en', 'pl'].indexOf(lang) !== -1) {
            var route = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route(to.query.route, null, lang);

            if (to.query.suffix) route += '/' + to.query.suffix;

            __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('meta/setLanguage', lang);

            next(route);
        } else {
            next('/');
        }
    }

    // handle url redirects
    else if (!__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.meta.lang || to.params.lang != __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.meta.lang) {

            // no locale set in path
            if (to.path == '/') {

                // try to get locale from localStorage
                var locale = localStorage.getItem('locale');

                if (!locale) {
                    var browserLang = navigator.language || navigator.userLanguage;
                    locale = languages.indexOf(browserLang) != -1 ? browserLang : 'en';
                }

                // no language set in path
                __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('meta/setLanguage', locale);
            } else if (!to.matched.length) {

                // try to get language from path
                var segments = to.path.split('/');

                if (languages.indexOf(segments[1]) !== -1) {
                    // language exists, redirect to home
                    next(segments[1]);
                } else {
                    // language does not exist, redirect to root
                    next('/');
                }
            } else if (languages.indexOf(to.params.lang) === -1) {

                // invalid language segment
                next('/');
            } else if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.translatedRoutePath(to, to.params.lang) != to.path) {

                // set language
                __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('meta/setLanguage', to.params.lang);

                // redirect to the correctly translated path
                next({
                    path: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.translatedRoutePath(to, to.params.lang),
                    query: to.query
                });
            } else {

                // set language from path
                __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('meta/setLanguage', to.params.lang);
            }
        }

    // wait for the "current" store to be loaded...
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.isReady(function () {
        if (window.Intercom) Intercom('update');
        next();
    });
});

router.afterEach(function (to, from, next) {
    // do stuff after route changed (!)
    if (__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.layout.mobile) __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('layout/hideNavigation');
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var locales = { "layout": { "subnav": { "settings": { "general": "Allgemein", "locations": "Dienstpl\xE4ne", "jobs": "Besch\xE4ftigungen", "duties": "Funktionen", "shifts": "Schichten", "availability": "Verf\xFCgbarkeit", "costs": "Kostenstellen", "rates": "Stundenl\xF6hne", "premiums": "Zuschl\xE4ge", "workspaces": "Arbeitsbereiche", "tags": "Tags", "holidays": "Feiertage" } }, "header": { "help": "Hilfe", "overview": "Herzlich Willkommen!", "contacts": "Adressbuch", "hours": "Stundenerfassung", "reports": "Auswertung", "profile": "Dein Profil" }, "calendar": { "roster": { "headline": "Freigegeben bis inklusive" }, "reports": { "headline": "Bis zu welchem Tag m\xF6chtest du abrechnen?" }, "mon": "MO", "tue": "DI", "wed": "MI", "thu": "DO", "fri": "FR", "sat": "SA", "sun": "SO" }, "footer": { "info": "\xC4nderungen noch nicht gespeichert.", "save": "\xC4nderungen speichern", "cancel": "Zur\xFCcksetzen", "saveWithDate": "Ver\xE4nderung pro Datum" } }, "route": { "overview": { "path": "startseite", "name": "Startseite" }, "roster": { "path": "dienstplan", "name": "Dienstplan" }, "lists": { "path": "listen", "name": "Listen" }, "availability": { "path": "verfuegbarkeit", "name": "Verf\xFCgbarkeit" }, "contacts": { "path": "adressbuch", "name": "Adressbuch" }, "chats": { "path": "unterhaltungen", "name": "Unterhaltungen", "details": { "name": "Unterhaltungen", "path": "unterhaltungen\/:channel" } }, "hours": { "path": "stundenzettel", "name": "Stundenzettel", "page": { "path": "stundenzettel\/:page", "name": "Stundenzettel" } }, "reports": { "path": "auswertung", "name": "Auswertung" }, "team": { "path": "mitarbeiter", "name": "Mitarbeiter", "edit": { "name": "Mitarbeiter", "path": "mitarbeiter\/:id" } }, "profile": { "path": "profil", "name": "Profil" }, "settings": { "path": "einstellungen", "name": "Einstellungen", "general": { "path": "einstellungen\/allgemein", "name": "Allgemein" }, "availability": { "path": "einstellungen\/verfuegbarkeit", "name": "Verf\xFCgbarkeit" }, "duties": { "path": "einstellungen\/funktionen", "name": "Funktionen" }, "holidays": { "path": "einstellungen\/feiertage", "name": "Feiertage" }, "locations": { "path": "einstellungen\/standorte", "name": "Dienstpl\xE4ne" }, "premiums": { "path": "einstellungen\/zuschlaege", "name": "Zuschl\xE4ge" }, "rates": { "path": "einstellungen\/stundenloehne", "name": "Stundenl\xF6hne" }, "shifts": { "path": "einstellungen\/schichten", "name": "Schichten" }, "expenses": { "name": "Unkosten", "path": "einstellungen\/unkosten" }, "costs": { "name": "Kostenstellen", "path": "einstellungen\/kostenstellen" }, "tags": { "name": "Tags", "path": "einstellungen\/tags" }, "vacation": { "name": "Urlaub", "path": "einstellungen\/urlaub" }, "contracts": { "name": "Vertragsvorlagen", "path": "einstellungen\/vertraege" }, "advanced": { "path": "einstellungen\/erweitert", "name": "Erweitert" }, "checkin": { "name": "Check-in", "path": "einstellungen\/check-in" }, "settings": { "path": "einstellungen\/unternehmen", "name": "Unternehmensseite" }, "company": { "name": "Unternehmensseite", "path": "einstellungen\/unternehmen" }, "invoice": { "name": "Rechnungen" } }, "modules": { "path": "modules", "name": "Module" }, "notifications": { "name": "Benachrichtigungen", "path": "benachrichtigungen" }, "projects": { "name": "Projekte", "path": "projekte", "edit": { "path": "projekte\/:id" } }, "login": { "accept": { "path": "login\/einladung-akzeptieren\/:code", "name": "Einladung akzeptieren" }, "confirm": { "path": "login\/email-bestaetigen\/:code\/:account?", "name": "E-mail best\xE4tigen" }, "confirmation": { "path": "login\/bestaetigungscode-anfordern", "name": "Best\xE4tigungscode anfordern" }, "password": { "path": "login\/passwort-vergessen", "name": "Passwort vergessen" }, "reset": { "path": "login\/passwort-zuruecksetzen\/:code", "name": "Password zur\xFCcksetzen" }, "signin": { "path": "login\/anmeldung", "name": "Anmeldung" }, "signup": { "path": "login\/registrieren\/:code", "name": "Registrieren" } }, "clients": { "name": "Kunden", "path": "kunden", "edit": { "path": "kunden\/:id" } }, "balances": { "name": "Zeitkonto", "path": "zeitkonto", "details": { "name": "Zeitkonto", "path": "zeitkonto\/:id" } }, "register": { "path": "registrieren", "name": "Account erstellen" }, "welcome": { "name": "Willkommen", "path": "willkommen" }, "terms": { "name": "Nutzungsbedingungen", "path": "nutzungsbedingungen" }, "privacy": { "name": "Datenschutzerkl\xE4rung", "path": "privacy" }, "legal": { "name": "Kontakt & Support", "path": "kontakt" }, "wizard": { "start": { "name": "Wizard", "path": "wizard\/start\/:id\/:token" }, "step": { "name": "Wizard", "path": "wizard\/step" }, "name": "Wizard", "path": "wizard" }, "subscription": { "name": "Kontoverwaltung", "path": "abonnement", "confirm": { "path": "abonnement\/bestaetigen" } }, "invoice": { "path": "rechnung\/:id" }, "vacation": { "name": "Urlaub", "path": "urlaub", "new": { "name": "Urlaub beantragen", "path": "urlaub\/neu" }, "details": { "path": "urlaub\/:id", "name": "Urlaub" } }, "setup": { "name": "Setup", "path": "setup\/:id\/:token" }, "example": { "path": "example" }, "contact": { "name": "Kontakt", "path": "kontakt" }, "statistics": { "name": "Statistiken", "path": "statistiken" }, "dashboard": { "name": "Dashboard", "path": "dashboard\/:id\/:hash" }, "today": { "name": "Tagesplan", "path": "heute" }, "planning": { "name": "Planung", "path": "planung" }, "dossiers": { "path": "mitarbeiter\/:id\/dossiers" }, "payslips": { "name": "Lohnabrechnungen", "path": "lohnabrechnungen" }, "documents": { "name": "Dokumente", "path": "dokumente", "detail": { "name": "Dokumente", "path": "dokumente\/:type" } }, "checkins": { "name": "Check-ins", "path": "check-ins" }, "demo": { "path": "demo", "name": "Demo" }, "log": { "name": "Protokoll", "path": "protokoll" }, "plannings": { "path": "planung\/uebersicht", "name": "\xDCbersicht" }, "resources": { "name": "Ressourcen", "path": "ressourcen", "edit": { "path": "ressourcen\/:id", "name": "Ressourcen" } }, "company": { "name": "Unternehmen", "path": "unternehmen" }, "2fa": { "setup": { "path": "login\/2fa\/einrichten", "name": "Zwei-Faktor Authentifizierung einrichten" }, "verify": { "path": "login\/2fa\/verifizieren", "name": "Zwei-Faktor Authentifizierung" } }, "freelancer_invoices": { "name": "Rechnungen f\xFCr Freelancer", "myInvoices": "Meine Rechnungen" }, "freelancer": { "name": "Rechnungen Freelancer", "path": "selbstandig-rechnungen" } }, "common": { "status": { "account": { "free": "aktiv", "trial": "Kostenlose Testphase", "active": "Aktives Abonnement", "expired": "Testphase abgelaufen", "cancelled": "Gek\xFCndigt", "deleted": "Gel\xF6scht", "license": "via Lizenz" }, "membership": { "active": "aktiviert", "inactive": "deaktiviert", "deleted": "gel\xF6scht" }, "user": { "active": "aktiviert", "inactive": "deaktiviert", "deactivate": "deaktivieren", "activate": "aktivieren" }, "item": { "planned": "geplant", "open": "offen", "pending": "unbest\xE4tigt", "approved": "best\xE4tigt", "denied": "abgelehnt" } }, "placeholder": { "email": "max@mustermann.de", "roster_name": "z.B. Hotel Sonnenschein", "company": "z.B. Hotel Sonnenschein GmbH", "full_name": "Max Mustermann", "address": "z.B. Hauptstra\xDFe 38", "dd": "TT", "mm": "MM", "yyyy": "JJJJ", "vat": "DE123456789" }, "filter": { "user": "Mitarbeiter", "duty": "Funktion", "location": "Dienstplan", "status": "Status" }, "availability": { "available": "verf\xFCgbar", "unavailable": "nicht verf\xFCgbar", "vacation": "Urlaub", "wish": "gerne arbeiten", "approved": "genehmigt", "denied": "verweigert", "limited": "eingeschr\xE4nkt verf\xFCgbar" }, "role": { "owner": "Kontoinhaber", "manager": "Kontoverwalter", "planner": "Dienstplaner", "user": "Mitarbeiter", "supervisor": "Stundenaufseher", "observer": "Beobachter", "freelancer": "Selbstst\xE4ndig" }, "button": { "cancel": "abbrechen", "submit": "Absenden", "okay": "Okay", "save": "Speichern", "delete": "L\xF6schen", "invite": "Mitarbeiter einladen", "reinvite": "Erneut Einladen", "confirm": "Best\xE4tigen", "decline": "Ablehnen", "send": "Absenden", "unsubscribe": "K\xFCndigen", "yes": "Ja", "add": "Hinzuf\xFCgen", "enroll": "Eintragen", "agree": "Einverstanden", "close": "Schlie\xDFen", "no": "Nein", "withdraw": "Austragen", "continue": "Weiter", "back": "Zur\xFCck", "deny": "Ablehnen", "done": "Fertig", "logout": "Logout", "next": "Weiter", "reset": "Zur\xFCcksetzen", "remove": "entfernen", "edit": "Bearbeiten", "complete": "Abschlie\xDFen", "download": "herunterladen", "accept": "Akzeptieren", "show": "anzeigen", "changegravatar": "Profilbild \xE4ndern", "apply": "Anwenden" }, "language": { "german": "deutsch", "dutch": "niederl\xE4ndisch", "english": "Englisch" }, "country": { "germany": "Deutschland", "netherlands": "Niederlande", "usa": "USA" }, "modules": { "basic": "Basismodul", "hours": "Zeiterfassung", "availability": "Verf\xFCgbarkeit", "appointments": "Terminplanung", "shifts": "Schichtplanung", "tags": "Tags", "rates": "Stundenlohn & Ausgaben", "balances": "Stundensaldo", "sickness": "Krankheit", "tentoo": "Tentoo Payroll", "lists": "Listen", "costs": "Kostenstellen", "chats": "Chats", "temper": "Temper", "blueprint": "Blaupause", "weather": "Wetter", "vacation": "Urlaub", "dashboard": "Dashboard", "today": "Tagesplan", "statistics": "Statistiken", "university": "Universit\xE4t", "dossiers": "Dossiers", "contacts": "Adressbuch", "planning": "Dienstplanung", "contracts": "Vertragsverwaltung", "onboarding": "Onboarding", "nmbrs": "Nmbrs", "payslips": "Lohnabrechnungen", "documents": "Dokumente", "checkins": "Check-ins", "clients": "Kunden", "resources": "Ressourcen", "calculations": "Berechnungen", "signature": "Stundenzettel unterschreiben", "newsletter": "Newsletter", "company": "Unternehmen", "freelancers": "Rechnungsstellung f\xFCr Freiberufler", "projects": "Projekte" }, "nojs": { "headline": "Bitte aktiviere JavaScript", "text": ["Damit ONDURO funktioniert, muss JavaScript in deinem Browser aktiviert sein.", "Stelle auch sicher, dass keine anderen Programme (Werbeblocker, Spamfilter o.\xC4.) den Zugriff auf diese Website blockieren."], "link": "Wie aktiviere ich JavaScript?" }, "email": { "default_subject": "Neue Nachricht von ONDURO" }, "notify": { "success": { "headline": "Gespeichert", "description": "Die \xC4nderungen wurden erfolgreich gespeichert." }, "delete": { "description": "Der Eintrag wurde erfolgreich gel\xF6scht!", "headline": "Gel\xF6scht" } }, "cut": "ausgeschnitten", "copied": "kopiert", "device": { "rotate": "Drehen Sie Ihren Bildschirm, um diese Funktion zu verwenden" }, "details": "Details", "link_copied": "Link kopiert in Zwischenablage. Dieser Link ist nur f\xFCr diesen Mitarbeiter PERS\xD6NLICH.", "text": { "businessNumber": "Umsatzsteuer-Identifikationsnummer", "vatNumber": "Steuernummer" } }, "label": { "type": "Typ", "name": "Name", "location": "Dienstplan", "hours": "Stunden", "rate": "Stundenlohn", "amount": "Betrag", "subtotal": "Summe", "total": "Gesamt", "distance": "Distanz", "euro": "\u20AC", "km": "km", "premium": "Zuschlag", "until": "bis", "date": "Datum", "day": "Tag", "cost": "Kostenstelle", "begin": "Beginn", "end": "Ende", "break": "Pause", "filter": "Filter", "status": "Status", "expenses": "Unkosten", "description": "Beschreibung", "items": "Dienste", "overtime": "\xDCberstunden", "salutation": "Anrede", "title": "Titel", "fname": "Vorname", "lname": "Nachname", "email": "E-Mail", "email_new": "Neue E-Mail", "email_confirm": "E-Mail wiederholen", "password": "Passwort", "password_old": "Altes Passwort", "password_new": "Neues Passwort", "password_confirm": "Passwort wiederholen", "company": "Firma", "users": "Nutzer", "icon": "Icon", "employee": "Mitarbeiter", "employees": "Mitarbeiter", "country": "Land", "language": "Sprache", "role": "Rolle", "access": "Zugriff", "phone": "Telefon", "mobile": "Mobil", "fax": "Fax \/ Notnummer", "address": "Adresse", "zip": "PLZ", "city": "Stadt", "identifier": "K\xFCrzel", "designation": "Bezeichnung", "color": "Farbe", "account_holder": "Kontoinhaber", "iban": "IBAN", "bic": "BIC", "time": "Zeit", "duration": "Dauer", "payer": "Verwalter", "display": "Dienstplanansicht", "interval": "Zeitraum", "quantity": "Anzahl", "work_time": "Arbeitszeiten", "action": "Aktion", "created_by": "Erstellt von", "weeks": "Wochen", "minimum": "mindestens", "tax_number": "Personalnummer", "full_name": "Vor- und Nachname", "rates": "Stundenl\xF6hne", "premiums": "Zuschl\xE4ge", "duties": "Funktionen", "salary": "Lohn", "eur_per_km": "\u20AC per km", "payroll": "Payroll", "sick_pay": "Lohnfortzahlung", "sickness": "Krankheit", "balance": "Saldo", "previous": "zuvor", "per_week": "pro Woche", "begin_of_week": "am Beginn von KW", "fallback": "Standard", "birthday": "Geburtstag", "vat": "USt-ID", "contacts": "Adressbuch", "public": "\xF6ffentlich", "private": "privat", "stats": { "planned": "geplant", "worked": "gearbeitet", "revenue": "Umsatz", "costs": "Kosten", "cost_revenue": "Kosten\/Einnahmen" }, "locations": "Dienstpl\xE4ne", "code": "Code", "days": "Tage", "invoice": "Rechnung", "client_number": "Kundennummer", "invoice_number": "Rechnungsnummer", "billing_period": "Rechnungszeitraum", "until_including": "bis inkl.", "sorting": "Sortierung", "vacation": "Urlaub", "requested": "Angefragt", "availability": "Verf\xFCgbarkeit", "unit": "Einheit", "requests": "Anfragen", "pending": "unbest\xE4tigt", "plusmin": "hinzu \/ weg", "dates": "Datum", "request": "Anfrage", "month": "Monat", "week": "Woche", "min_hours": "Mind.", "max_hours": "Max.", "print": "drucken", "moment": { "last": "letzte(n)", "current": "diese(n)", "next": "n\xE4chste(n)", "custom": "individuell" }, "year": "Jahr", "factor": "Faktor", "contact_list": "Kontakte", "group": "Gruppe", "contract_management": "Vertragsverwaltung", "contract_hours": "Vertragszeiten", "profile": "Profil", "settings": "Einstellungen", "dossier": "Dossier", "contract_start": "Eintrittsdatum", "contract_end": "Austrittsdatum", "template": "Vorlage", "payslips": "Lohnabrechnungen", "contract_full": "Vollzeit", "contract_part": "Teilzeit", "days_fixed": "Stunden pro Tag", "days_flex": "Tage pro Woche", "contract_vacation": "Urlaubstage", "file": "Datei", "documents": "Dokumente", "filetype": "Dateityp", "creator": "Ersteller", "fixed_salary": "Festgehalt", "hourly_salary": "Stundenlohn", "roster": "Dienstplan", "filled": "Gef\xFCllt", "checkin": "Check-in", "submitted": "eingereicht", "half_a_day": "halber tag", "hours_per_full_day": "Stunden pro Tag", "holiday": "Feiertag", "changed": "ge\xE4ndert", "empty": "leer", "fields": "Felder", "client": "Kunde", "start_date": "Anfang", "end_date": "Ende", "plannings": "Dienstpl\xE4ne", "clients": "Kunden", "all_clients": "alle Kunden", "budget": "Budget", "active": "aktiv", "inactive": "inaktiv", "archived": "archiviert", "finished": "beendet", "clear": "zur\xFCcksetzen", "comment": "Nachricht", "published": "Freigegeben", "unpublished": "nicht freigegeben", "signature": "Unterschrift", "url": "URL", "newsletter": "Aktueller Newsletter", "newsletters_old": "fr\xFChere Newsletter", "my_profile": "Mein Profil", "internal_note": "Interne Notiz", "visible": "sichtbar", "invisible": "unsichtbar", "2fa": "2FA", "2fa_reset": "klicken, um 2FA zur\xFCckzusetzen", "2fa_required": "2FA erforderlich, aber nicht eingerichtet", "notes": "Notizen", "invoice_email": "Rechnungs-E-Mail", "kvk_number": "Handelsregisternummer", "quick_date_filter": "Schnelles Filtern nach Datum", "invoice_interval": "Intervall f\xFCr die Rechnung", "select_client": "Kunde ausw\xE4hlen", "project_code": "Projektcode", "draft": "Entwurf", "recurrence": "Wiederkehrende Schichten hinzuf\xFCgen", "recurrence_type": "Wiederholungstyp", "daily": "T\xE4glich", "yearly": "J\xE4hrlich", "repeat_on": "Wiederholen am", "project_name": "Projektname", "start_time": "Startzeit", "end_time": "Endzeit", "projects": "Projekte", "all_day": "Ganzt\xE4gig", "the": "Der", "first": "Erste", "second": "Zweite", "third": "dritte", "fourth": "Vierte", "every": "Jeden", "last": "Letzte", "vat_percentage": "Mehrwertsteuer-Prozentsatz", "location_data": "Standort", "apply_premiums": "Es gelten Zulagen", "select_premium": "Zulagen ausw\xE4hlen", "hourly_rate": "Stundentarif", "invoicing_interval": "Einstellung der Rechnungsstellung", "invoicing_interval_weekly": "Automatische Rechnungsstellung; W\xF6chentliche Rechnungsstellung", "invoicing_interval_monthly": "Automatische Rechnungsstellung; monatliche Abrechnung", "invoicing_interval_manual": "Manuelle Rechnungsstellung", "create_new_duty": "Neue Funktion erstellen", "weekly_schedule": "W\xF6chentliches Programm", "enable": "Aktivieren", "edit_project": { "details": "Details Ge\xE4nderter Projektzeitplan" }, "start_date_edit": "\xC4nderungen \xFCbernehmen von", "start_date_edit_hint": "Alle Dienste, die ab diesem Datum angeboten werden, werden an den neuen Zeitplan angepasst. Dienste, die vor dem festgelegten Datum erbracht wurden, bleiben unver\xE4ndert.", "numberEmployees": "Anzahl der Mitarbeiter f\xFCr diese Schicht", "eur_per_minute": "\u20AC per Minute", "travel_allowance": "Reisekostenerstattung beantragen", "driver": "F\xE4hrer", "passenger": "Fahrg\xE4ste", "overwrite": "\xDCbertragung", "travel_expense_amount": "Betrag Reisekostenverg\xFCtung", "apply_after": "Anwenden nach", "compensation_calc_method": "Compensation Calculation Method", "include": "Einbeziehen", "deselect_all": "Alle Abw\xE4hlen", "select_all": "Alle Ausw\xE4hlen", "total_hours": "Gesamtstunden", "total_cost": "Gesamtkosten", "planning": "Dienstpl\xE4n", "project_location": "Projektstandort", "select_number_of_cars": "W\xE4hlen Sie die Anzahl der f\xFCr diese(n) Dienst(e) erforderlichen Firmenwagen pro Dienst", "override_rate": "\xDCberschreiben des festgelegten Stundensatzes", "person": "Person", "team_members": "Teammitglieder", "absence": "Abwesenheit\/Krankheit", "created_at": "Erstellt am", "register_absence": "Sich krank melden", "resource": "Asset ausw\xE4hlen oder auto", "required_capacity": "Erforderliche Kapazit\xE4t" }, "text": { "from": "von", "until": "bis", "open": "offen", "users": "Mitarbeiter", "no_results": "keine Ergebnisse", "sick": "krank", "or": "oder", "of": "von", "change": "\xE4ndern", "delete": "l\xF6schen", "optional": "optional", "yes": "ja", "no": "nein", "mr": "Herr", "mrs": "Frau", "dr": "Dr.", "prof": "Prof.", "profdr": "Prof. Dr.", "location": "Dienstplan", "contract": "Vertrag", "info": "Info", "duty": "Funktion", "shift": "Schicht", "account": "Konto", "cost": "Kostenstelle", "workspace": "Arbeitsbereich", "owner": "Kontoinhaber", "manager": "Kontoverwalter", "planner": "Dienstplaner", "user": "Nutzer", "placeholder": "Platzhalter", "placeholder_duties": "Dienste", "placeholder_shifts": "Schichten", "full_time": "Vollzeit", "part_time": "Teilzeit", "flex_time": "Flexibel", "monthly": "monatlich", "weekly": "w\xF6chentlich", "sunday": "Sonntag", "monday": "Montag", "release": "Freigabe", "released": "freigegebenen", "week": "Woche", "calendar_week": "Kalenderwoche", "calendar_week_short": "KW", "today": "heute", "yesterday": "gestern", "in": "in", "on": "am", "to": "nach", "since": "ab", "new": "Neues", "confirmed": "best\xE4tigt", "unconfirmed": "unbest\xE4tigt", "denied": "abgelehnt", "approve": "best\xE4tigen", "deny": "ablehnen", "himself": "sich selbst", "someone": "jemand", "previous": "fr\xFCher", "previous_period": "fr\xFCherer Zeitraum", "all": "alle", "filter": "Filter", "deactivate": "deaktivieren", "activate": "aktivieren", "expired": "unvollendet", "page": "Seite", "saving": "speichern", "more": "mehr", "none": "kein", "instead_of": "statt", "base_salary": "Basislohn", "empty": "(Noch) keine Daten vorhanden", "tag": "Tag", "item": "Dienst", "sure": "Bist du sicher?", "more_options": "zeige Optionen", "search": "Suche...", "import": "importieren", "help": "Hilfe", "days": "Tage", "day": "Tag", "legend": "Legende", "selection": { "more": "mehr", "select": "w\xE4hle", "all": "alle", "none": "keine", "displayed": "der <u>gefilterten<\/u> Optionen", "selected": "ausgew\xE4hlt", "select_all": "alles ausw\xE4hlen", "deselect_all": "alle abw\xE4hlen", "toggle": "ausw\xE4hlen/abw\xE4hlen" }, "invited": "eingeladen", "hide_options": "verberge Optionen", "month": ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], "loading": "Lade Daten...", "desc": "absteigend", "asc": "aufsteigend", "blueprint": "Blaupause", "hours": "Stunden", "daydays": "Tag|Tage", "hrs": "Std.", "changed": "ge\xE4ndert", "unsaved": "ungesicherte \xC4nderung|ungesicherte \xC4nderungen", "welcome": "Willkommen", "attention": "Achtung", "nowayback": "Das kann nicht r\xFCckg\xE4ngig gemacht werden. Bist du dir wirklich sicher?", "current": "aktuell", "dpa": "Datenverarbeitungsvereinbarung", "dpa_accept": "Ich akzeptiere Version 1.0 der Datenschutzvereinbarung im Auftrag von {company} und erkl\xE4re hiermit, dass ich dazu befugt bin.", "review": "Ansehen", "legal": { "not_signed": "Diese Vereinbarung wurde noch nicht akzeptiert.", "signed": "Diese Vereinbarung wurde am <b>{date}<\/b> akzeptiert von <b>{name}<\/b>." }, "you": "Du", "per_employee": "pro Mitarbeiter", "per_item": "pro gearbeitetem Dienst", "disapprove": "Ablehnen", "colleagues": "Kollegen", "billed_at": "abgerechnet am", "paid_at": "ausbezahlt am", "in_days": "in {days} Tagen", "tomorrow": "morgen", "no_times": "ohne Zeiten", "labels": "Labels", "paid": "ausbezahlt", "billed": "abgerechnet", "options": "Optionen", "progress": "Fortschritt", "contract_salary": "Vertrag & Lohn", "per": "pro", "show_details": "zeige Details", "hide_details": "Details ausblenden", "fulltime": "Vollzeit", "duration_permanent": "unbefristet", "duration_temporary": "befristet", "pay_out": "ausbezahlen", "fixed": "Fest", "contract_days_fixed": "regelm\xE4\xDFig", "contract_days_flex": "unregelm\xE4\xDFig", "per_workday": "pro Arbeitstag", "contract_template": "Vertragsvorlage", "message": "Nachricht", "per_year": "pro Jahr", "signed_by_employee": "unterzeichnet von Mitarbeiter", "nothing": "Nichts zu sehen hier...", "per_month": "pro Monat", "per_hour": "pro Stunde", "generate": "generieren", "no_documents": "Keine Dokumente vorhanden.", "no_checkins": "Momentan sind keine Check-ins vorhanden.", "confirm_checkout_membership": "Bist du sicher, dass du {name} auschecken m\xF6chtest?", "confirm_checkout": "Bist du sicher, dass du auschecken willst? Du kannst nicht nochmal einchecken f\xFCr den gleichen Dienst.", "checkin_successful": "Checkin erfolgreich um {time} Uhr", "already_checked_in": "Du bist bereits seit {time} Uhr eingecheckt", "checkin_successful_notice": "Du wurdest erfolgreich eingecheckt", "oclock": "{time} Uhr", "past-checkins": "Vergangene Check-ins", "details": "Details", "load_more": "Mehr laden", "no_location_data": "Keine Standortdaten verf\xFCgbar", "previous_page": "vorherige Seite", "next_page": "n\xE4chste Seite", "free": "frei", "added_via": "Eingetr. via", "rest_time": "Ruhezeit", "rest": "Ruhe", "planning_type": { "ongoing": "laufend", "temporary": "befristet" }, "conflict": "Konflikt", "between_and": "zwischen {start} und {end} Uhr", "per_duty": "pro Funktion", "totals": "Summen", "planned": "eingeplant", "period": "Periode", "filters_active": "Filter aktiv", "sign": "unterschreiben", "2fa_reset": "Der Benutzer hat die Zwei-Faktor-Authentifizierung bereits erfolgreich eingerichtet. M\xF6chtest du die Zwei-Faktor-Authentifizierung f\xFCr diesen Benutzer wirklich zur\xFCcksetzen?", "minutes": "Minuten", "tuesday": "Dienstag", "wednesday": "Mittwoch", "thursday": "Donnerstag", "friday": "Freitag", "saturday": "Samstag", "hint": { "project_type": { "ongoing": "F\xFCr Projekte ohne festes Enddatum. Schichten werden ein Jahr im Voraus hinzugef\xFCgt", "temporary": "F\xFCr zeitlich begrenzte Projekte mit festem Anfangs- und Enddatum" } }, "disable_project_grouping": "Projektgruppierung deaktivieren", "enable_project_grouping": "Projektgruppierung Aktivieren", "once": "Einmal", "default": "Standard", "fixed_compensation": "Feste Verg\xFCtung", "include_in_totals_tooltip": "Aktivieren oder deaktivieren Sie diese Option, um sie in die Summen einzubeziehen", "totals_only_selected_shifts": "Die Summen werden nur f\xFCr ausgew\xE4hlte Schichten berechnet", "enter_date_after": "Bitte w\xE4hlen Sie ein Datum nach", "and_before": "und vor", "planning_selected_at_project_level": "Planung ist auf Projektebene ausgew\xE4hlt", "project_details": "Projektdetails", "similar_items": "Andere an diesem Projekt heute", "no_similar_items": "Keine anderen Teammitglieder, die an diesem Projekt arbeiten" }, "page": { "team": { "headline": "Mitarbeiter", "registered": "registriert", "invited": "eingeladen", "add": "Mitarbeiter hinzuf\xFCgen", "delete": "Mitarbeiter l\xF6schen", "delete_confirm": "Willst du diesen Mitarbeiter wirklich endg\xFCltig l\xF6schen? Alle Daten werden unmittelbar und unwiderruflich gel\xF6scht!", "saved": "Die Daten wurden erfolgreich aktualisiert.", "activate_access": "Zugang aktivieren", "sidebar": { "general": "Allgemein", "text": "bald verf\xFCgbar...", "registered_since": "Registriert seit:", "last_online": "Zuletzt online:", "headline_duties": "Funktionen", "headline_locations": "Dienstpl\xE4ne", "tags_hint": "Klicke in das Feld um einen Tag hinzuzuf\xFCgen. Tag nicht vorhanden? Erstelle dann einen <a href=\"{href}\">neuen Tag</a>.", "no_duty": "hat noch keine Funktion!" }, "fieldset": { "personal_data": "Pers\xF6nliche Daten", "job": "Besch\xE4ftigung", "access": "Pers\xF6nlicher Zugriff", "contact": "Kontaktdaten", "role": "Rollen", "rights": "Weitere Rechte", "costs": "Kostenstellen", "hours": "Stundenerfassung", "availability": "Verf\xFCgbarkeit", "balance": "Stundenkonto" }, "availability": "Mitarbeiter kann Verf\xFCgbarkeit eintragen", "availability_hint": "W\xE4hle hier aus, welche Verf\xFCgbarkeit standardm\xE4\xDFig angezeigt werden soll, wenn <b>{name}</b> (noch) keine Verf\xFCgbarkeit eingetragen hat.", "availability_options": ["ist ohne Angabe", "verf\xFCgbar", "nicht verf\xFCgbar"], "balance": "Stundenkonto f\xFCr diesen Mitarbeiter aktivieren", "hours": "Mitarbeiter kann selbst Zeiten eintragen", "on_cost_label": "auf Kostenstelle", "cost_hint": "W\xE4hle alle Kostenstellen aus, \xFCber die <b>:name</b> Stunden abrechnen darf. Wird nur eine Kostenstelle gew\xE4hlt, muss der Mitarbeiter keine Auswahl in der Stundenabrechnung treffen. Alle Stunden werden automatisch auf die hier ausgew\xE4hlte Kostenstelle gebucht.", "cost_empty": "Es wurden noch keine Kostenstellen angelegt! Jetzt neue <a href=\"{href}\">Kostenstelle anlegen<\/a>.", "data_locked": "Manche bereits eingegebene pers\xF6nliche Daten k\xF6nnen nur noch vom Mitarbeiter selbst in seinem Profil ge\xE4ndert werden.", "not_verified": "<b>{name}<\/b> wurde erfolgreich eingeladen, hat die Registrierung aber noch nicht abgeschlossen.", "not_accepted": "<b>:name</b> wurde erfolgreich eingeladen, hat die Einladung jedoch noch nicht akzeptiert. Weil :name bereits mit anderen Accounts verkn\xFCpft ist, kannst du die E-Mail Adresse f\xFCr die Einladung (:email) nicht mehr \xE4ndern.", "no_access": "<b>:name<\/b> darf momentan nicht einloggen. Mit dem folgenden Button kann der Zugang wieder aktiviert werden.", "invitation_expired": "Die Einladung ist unvollendet. Du musst dem Mitarbeiter erneut eine Einladung zusenden.", "invitation_success": "Die Einladung wurde erfolgreich versandt.", "invitation_failed": { "hint": "wird bereits verwendet", "message": "Diese E-Mail Adresse wird bereits in einem anderen Account verwendet. Nimm bitte Kontakt auf mit <a href=\"support@onduro.com\">support@onduro.com<\/a>. Wir helfen dir gerne weiter." }, "text_owner": "Als Kontoinhaber brauchst du Zugriff.", "user": "Mitarbeiter", "user_is": "Mitarbeiter ist", "user_may": "Mitarbeiter darf", "tabs": { "other": "Weiteres", "infos": "Infos", "tags": "Tags", "rates": "Stundenlohn" }, "label": { "about": "\xDCber :name", "notes": "Interne Notizen", "access": "Zugangsdaten", "right_colleagues": "kann alle Kollegen im Dienstplan sehen", "right_placeholder": "darf sich selbst in offene Dienste eintragen", "right_hours": "darf Stunden f\xFCr andere Mitarbeiter eintragen", "payroll": "wird via {provider} ausbezahlt", "right_colleagues_restrict": "nur an Tagen wo Mitarbeiter selbst eingeplant ist", "absence\t": "Sich krankmelden", "absence": "Meldung von Abwesenheit\/Krankheit" }, "hint": { "role_owner": "darf alles verwalten", "role_manager": "darf Mitarbeiter und Einstellungen verwalten", "role_planner": "darf den Dienstplan erstellen", "role_supervisor": "best\xE4tigen, ablehnen und \xE4ndern von Stunden", "role_observer": "darf freigegebene Dienste in der Planung f\xFCr eigen Standorte sehen (aber nicht ver\xE4ndern)", "role_manager_restricted": ["darf keine Mitarbeiter- oder Kontoeinstellungen verwalten", "hat nur Zugriff auf eigene Dokumente"], "role_freelancer": "Ein Freiberufler hat die gleichen Rechte wie ein Angestellter, kann aber Rechnungen f\xFCr seine eigenen Arbeitsstunden erstellen.", "multiple_shifts": "Ben\xF6tigen Sie mehr Kapazit\xE4t f\xFCr diesen Dienst? Erstellen Sie diesen Dienst mehrmals.", "override_rate": "\xDCberschreiben Sie den Standard-Stundensatz f\xFCr diesen Dienst", "notes_visibility": "Diese Notiz ist f\xFCr alle Mitarbeiter in der Planung sichtbar" }, "empty": "Es wurden noch keine Mitarbeiter angelegt.", "email_existing": "Diese E-Mail Adresse existiert bereits f\xFCr einen anderen Mitarbeiter.", "blueprint": { "hash": "blaupause", "headline": "Blaupause", "info": "Das ist die Blaupause f\xFCr neue Mitarbeiter. Hier kannst du vorab speichern, welche Einstellungen ein neuer Mitarbeiter automatisch zugewiesen bekommt. Du kannst die Blaupause jederzeit durch einen Klick auf den Schalter rechts oben deaktivieren.", "active": "aktiv", "inactive": "inaktiv" }, "supervisor": "Mitarbeiter darf Stunden von Kollegen verwalten", "accountant": "Mitarbeiter erh\xE4lt Zugang zur Auswertung", "of_cost_label": "von Kostenstelle", "restrictions": { "locations": { "all": "f\xFCr alle Dienstpl\xE4ne", "own": "nur f\xFCr eigene Dienstpl\xE4ne", "some": "nur f\xFCr ausgew\xE4hlte Dienstpl\xE4ne" }, "duties": "nur f\xFCr Dienste mit eigenen <u>Funktionen</u>" }, "deactivate": { "confirm": { "headline": "Wirklich deaktivieren?" }, "text": "Deaktivierte Mitarbeiter k\xF6nnen sich nicht mehr einloggen oder eingeplant werden." }, "activate": { "confirm": { "headline": "Wirklich aktivieren?", "text": "Aktive Mitarbeiter sind eventuell mit Kosten verbunden. Mehr Informationen findest du in deinem Abonnement." } }, "vacation": "Mitarbeiter kann Urlaub anfragen", "import": "Nimm \xFCber den \"Hilfe\" Link Kontakt mit uns auf, um deine eigenen Mitarbeiter zu importieren. Wir wandeln dann erst deinen Demozugang in einen regul\xE4ren Account um.", "bulk_delete": "Mitarbeiter l\xF6schen", "delete_bulk_text": "Alle geplanten Dienste in der Zukunft werden f\xFCr diesen Benutzer entfernt! Historische Daten bleiben erhalten.", "bulk_text": "Bist du sicher, dass du die ausgew\xE4hlten Mitarbeiter {action} m\xF6chtest?", "bulk_invite": "Mitarbeiter einladen", "bulk_activate": "Mitarbeiter aktivieren", "bulk_deactivate": "Mitarbeiter deaktivieren", "invited_notify": "Auswahl wurde erfolgreich eingeladen.", "add_limit": "Du hast die maximale Anzahl an Mitarbeitern in deinem Paket erreicht. Deaktiviere Mitarbeiter oder aktualisiere dein Abonnement.", "dossier": { "sidebar_note": "Hier kannst du interne Informationen abspeichern zu diesem Mitarbeiter." }, "user_deactivated": "Mitarbeiter ist deaktiviert.", "settings": { "warn": "Bitte beachten: die folgenden Einstellungen werden erst wirksam, wenn der Mitarbeiter eingeladen wurde und seine Registrierung erfolgreich abgeschlossen hat." }, "invitation_no_email": "Du musst erst eine E-Mail-Adresse eingeben und speichern, um {name} Zugriff zu gew\xE4hren.", "invitation_invite": "{name} hat noch <u>keinen</u> Zugriff auf ONDURO. Klicke auf den folgenden Button, um {name} Zugriff via einem pers\xF6nlichen Login zu gew\xE4hren.", "profile": { "note": "Todo: Gehe zum Tab \"Einstellungen\" um {name} mindestens eine Funktion zuzuweisen." }, "bulk_edit": "Einstellungen bearbeiten", "contract": { "vacation": "Mitarbeiter darf Urlaub beantragen", "none": "Kein Vertrag festgelegt.", "salary": "Hier kannst du den Stundenlohn f\xFCr diesen Mitarbeiter \xE4ndern." }, "balance_overview": "Mitarbeiter darf Stundensaldi von anderen Mitarbeitern sehen", "expenses": { "general": "Mitarbeiter darf Unkosten deklarieren (in \u20AC)", "travel": "Mitarbeiter darf Reiskosten deklarieren (in km)" }, "registration_link": "Kopiere den Registrierungslink in die Zwischenablage", "hours_add": "darf Stunden erfassen ohne eingeplant zu sein", "invitation_conflict": "<b>Diese E-Mail-Adresse ist bereits mit einem Benutzer in einem anderen Konto verkn\xFCpft.</b><br><br>Entferne zuerst die E-Mail-Adresse im anderen Konto, bevor du den Benutzer in diesem Konto einl\xE4dst.<br><br>Oder entferne den Benutzer in <u>diesem</u> Konto und f\xFClle <b>direkt</b> beim Hinzuf\xFCgen des Benutzers eine E-Mail-Adresse ein.", "role_manager_restricted": "mit eingeschr\xE4nktem Zugriff", "signature_supervisor": "darf nur Unterschriften sammeln", "balance_holidays_always": "Feiertage immer an das Stundenkonto hinzuf\xFCgen", "absence": { "notes_placeholder\t": "Zus\xE4tzliche Notizen zur Abwesenheit (Optional)", "history": "Abwesenheitsverlauf", "delete": "Abwesenheit l\xF6schen", "delete_confirm": "Sind Sie sicher, dass Sie diesen Abwesenheitseintrag l\xF6schen m\xF6chten?", "export": "Als Excel herunterladen", "notes_placeholder": "Zus\xE4tzliche Notizen zur Abwesenheit...", "sidebar_note": "Erfassen Sie Mitarbeiterabwesenheiten wie Krankheit. Sie k\xF6nnen das Enddatum leer lassen und es sp\xE4ter hinzuf\xFCgen, wenn der Mitarbeiter zur\xFCckkehrt.", "actions": "Aktionen" } }, "roster": { "element": "Element", "undroppable": { "text": "kann hier nicht eingeplant werden.", "past": "Dieser Tag liegt in der Vergangenheit.", "billed": "Dieser Zeitraum ist bereits abgerechnet.", "confirm": "dennoch einplanen", "blocked": "Dieser Tag wurde geblockt.", "closed": "An diesem Tag wird nicht gearbeitet." }, "time": { "delete": { "error": { "headline": "Dienstzeit kann nicht gel\xF6scht werden." } }, "error": { "headline": "Zeiten k\xF6nnen nicht gespeichert werden.", "ERR_TIMES": "Du musst eine Start- und Endzeit eingeben.", "ERR_CONFIRMED": "Die vom Mitarbeiter eingetragene Dienstzeit wurde bereits best\xE4tigt.", "ERR_OVERLAP": "ist im angegebenen Zeitraum bereits f\xFCr einen Dienst eingetragen.", "ERR_OVERLAP_REMOVAL": "ist an diesem Tag bereits f\xFCr einen Dienst eingetragen. Die Zeit kann daher nicht entfernt werden.", "ERR_EQUAL": "Beginn- und Endzeit m\xFCssen sich unterscheiden.", "ERR_NEGATIVE": "Gesamtdauer darf nicht negativ sein. \xC4ndere die Pausenzeit." } }, "user": { "delete": { "error": { "headline": "Mitarbeiter kann nicht gel\xF6scht werden." } }, "has_hours": { "headline": "Dienst hat eingetragene Stunden!" }, "change": { "ERR_HOURS": "Es wurden bereits Stunden eingetragen f\xFCr diesen Dienst. Willst du diese Stunden l\xF6schen und den neuen Mitarbeiter zuweisen?" }, "remove": { "ERR_HOURS": "Es wurden bereits Stunden eingetragen f\xFCr diesen Dienst. Willst du diese Stunden zusammen mit dem Mitarbeiter entfernen?" }, "error": { "headline": "Mitarbeiter kann nicht gespeichert werden.", "ERR_CONFIRMED": "Die vom Mitarbeiter eingetragene Dienstzeit wurde bereits best\xE4tigt.", "ERR_OVERLAP": "ist im angegebenen Zeitraum bereits f\xFCr einen Dienst eingetragen." } }, "item": { "delete": { "error": { "headline": "Dienst kann nicht ausgetragen werden!" }, "ERR_HOURS": "Es wurden bereits Stunden eingetragen f\xFCr diesen Dienst. Dienst trotzdem zusammen mit den eingetragenen Stunden l\xF6schen?", "ERR_CONFIRMED": "Es wurden bereits Stunden eingetragen und best\xE4tigt f\xFCr diesen Dienst. Dienst trotzdem zusammen mit den eingetragenen Stunden l\xF6schen?" }, "has_hours": { "headline": "Dienst hat eingetragene Stunden!" }, "via_hours": "hinzugef\xFCgt \xFCber Zeiterfassung", "driver": "Markiert als Fahrer" }, "sick": { "ERR_HOURS": { "headline": "Dienst hat eingetragene Stunden!", "text": "Es wurden bereits Stunden eingetragen f\xFCr diesen Dienst. Eingetragene Stunden l\xF6schen und Krankheit eintragen?" }, "ERR_TIME": { "headline": "Dienst hat keine Zeiten!", "text": "Bei Krankheit ben\xF6tigt der Dienst eine Start- und Endzeit (oder Schicht)." } }, "shift": { "error": { "headline": "Schicht kann nicht gespeichert werden.", "ERR_CONFIRMED": "Die vom Mitarbeiter eingetragene Dienstzeit wurde bereits best\xE4tigt.", "ERR_OVERLAP": "ist im angegebenen Zeitraum bereits f\xFCr einen Dienst eingetragen." } }, "add": { "error": { "headline": "Dienst kann nicht eingeplant werden!", "headline_choose": "Mitarbeiter ist bereits im Dienst", "ERR_UNAVAILABLE_LIMITED": "ist an diesem Tag nur begrenzt verf\xFCgbar. Weiter?", "ERR_UNAVAILABLE_DENY": "kann an diesem Tag nicht eingeplant werden.", "ERR_UNAVAILABLE_WARN": "ist an diesem Tag nicht verf\xFCgbar. Trotzdem einplanen?", "ERR_EXISTING_FULL": "ist an diesem Tag bereits f\xFCr unbestimmte Zeit eingetragen. Solange der bestehende Dienst nicht mit Zeiten versehen wird kann kein neuer Dienst eingeplant werden.", "ERR_EXISTING_SHIFT": "ist an diesem Tag bereits f\xFCr eine Schicht eingetragen. Solange die bestehende Schicht nicht gel\xF6scht wird kann kein neuer Dienst eingeplant werden.", "headline_limited": "Mitarbeiter ist nur teilweise verf\xFCgbar" } }, "signin": { "error": { "headline": "Nicht m\xF6glich!", "text": "Du arbeitest bereits an diesem Tag!" } }, "signout": { "headline": "Austragung beantragt", "text": "Du bist weiterhin so lange f\xFCr diesen Dienst eingeplant, bis ein Dienstplaner deinen Antrag auf Austragung best\xE4tigt." }, "move": { "error": { "headline": "Dienst kann nicht verschoben werden!", "ERR_OVERLAP": "Der verschobene Dienst \xFCberschneidet sich mit einem anderen Dienst von", "ERR_CONFIRMED": "Die vom Mitarbeiter eingetragene Dienstzeit wurde bereits best\xE4tigt.", "ERR_OPEN_CHECKIN": "Dienst wurde noch nicht ausgecheckt." } }, "comments": { "error": { "headline": "Kommentar hinzuf\xFCgen", "text": "Bitte gib eine Nachricht ein." } }, "headline": "Dienstplan", "for": "f\xFCr", "from": "vom", "until": "bis", "current_week": "aktuelle Woche", "since_current_week": "ab aktueller Woche", "legend": "Legende", "ical_subscribe": { "headline": "Kalender abonnieren", "text": "Unter folgender Adresse kann der Kalender abonniert werden:" }, "release_error": "Der Freigabetermin konnte leider nicht gespeichert werden.", "context": { "headline": "Mitarbeiter einplanen:", "delete_text": "Hier hinziehen zum L\xF6schen!", "distance_hint": "Hierunter siehst du die Distanz von diesem Standort zur Adresse des Mitarbeiters.", "info_hint": "Hierunter siehst du, wie oft und wie lange ein Mitarbeiter f\xFCr einen bestimmten Dienst an diesem Standort schon eingeplant ist seit dem Freigabedatum." }, "tools": { "time": "Zeit", "shift": "Schicht", "duty": "Dienst", "user": "MA", "until": "bis", "application": "Mitarbeiter stellt Antrag auf Austragung dieses Dienstes.", "approve": "Genehmigen", "deny": "Ablehnen", "apply": "Bewerben", "cancel": "Doch nicht!", "signin": "Eintragen", "signout": "Austragen", "switch": "Tauschen", "work": "Doch arbeiten!", "empty_users": "keine Verf\xFCgbarkeit", "empty_duties": "keine Funktion w\xE4hlbar", "filtered_tags": "Achtung: Auswahl gefiltert auf Basis von Tags.", "tags_none": "F\xFCr den eingeplanten Mitarbeiter sind keine Tags verf\xFCgbar.", "tags_user": "Du kannst nur Tags hinzuf\xFCgen, die zum eingeplanten Mitarbeiter passen.", "tags_all": "Klicke in das Feld um einen Tag hinzuzuf\xFCgen. Tag nicht vorhanden? Erstelle dann einen <a href=\"{href}\">neuen Tag</a>.", "totals": "Gesamtanzahl aller geplanten (noch nicht freigegebenen) Dienste / Stunden von allen Dienstpl\xE4nen und Diensten", "sick": { "payment": "Lohn", "apply": "Krank", "undo": "Doch nicht krank", "payroll_payment": "F\xFCr diesen Mitarbeiter wird die Lohnfortzahlung im Krankheitsfall via Payroll verwaltet.", "balances_note": "Geplante Arbeitszeiten werden zu 100% im Stundensaldo angerechnet.", "needs_time": "Bei Krankheit ben\xF6tigt der Dienst eine Start- und Endzeit (oder Schicht). F\xFCge diese erst hinzu.", "no_costs": "F\xFCr diesen Mitarbeiter ist keine Stundenerfassung aktiviert.", "headline": "W\xE4hle die zutreffenden Einstellungen f\xFCr:", "balance": "Stunden f\xFCr Saldo", "hint": "W\xE4hle den entsprechenden Prozentsatz f\xFCr die Lohnfortzahlung im Krankheitsfall.", "balance_note": "Geplante Arbeitszeit wird zu 100% angerechnet im Stundenkonto.", "sko": "W\xE4hle den zutreffenden Typ der Abwesenheit." }, "revoke_application": "Bewerbung zur\xFCckziehen", "applied_at": "Beworben am<br>{date}" }, "placeholder": { "comment": "Interne Notiz (nur f\xFCr Planer und Beobachter sichtbar)" }, "matching": { "headline": "Offene Dienste f\xFCllen", "button": "Wizard", "info": "Offene Dienste werden im ausgew\xE4hlten Zeitraum mit verf\xFCgbaren Mitarbeitern gef\xFCllt.", "remove": "bereits eingetragene Mitarbeiter im angegebenen Zeitraum von Diensten entfernen", "error": "Startdatum muss nach Ver\xF6ffentlichungsdatum liegen.", "removed": "Mitarbeiter erfolgreich von <b>:removed<\/b> Diensten entfernt!", "matched": "Mitarbeiter erfolgreich in <b>:matched</b> Dienste gef\xFCllt! <b>:unmatched</b> Dienste konnten leider nicht bef\xFCllt werden." }, "flash": { "success": { "headline": "Geschafft!", "message": "Der Dienstplan ist jetzt freigegeben bis inklusive:<br><br><strong>:date<\/strong>" } }, "release": { "headline": "Dienstplan freigeben", "text": "Dienstplan freigeben bis inklusive: <b>{date}</b><br><br>Wenn du den Dienstplan bis zum gew\xE4hlten Datum freigibst, werden alle eingeplanten Mitarbeiter mit Zugang per E-Mail benachrichtigt und k\xF6nnen den freigegebenen Dienstplan bis zum Freigabedatum einsehen.<br><br>\xC4nderungen sind weiterhin m\xF6glich, erfolgen aber immer mit direkter Benachrichtigung der Mitarbeiter.", "success": "Der Dienstplan wurde erfolgreich freigegeben!" }, "revoke": { "headline": "Freigabe zur\xFCcksetzen", "text": "Dienstplan freigeben bis inklusive: <b>{date}</b><br><br>Wenn du die Freigabe bis zum gew\xE4hlten Datum zur\xFCcksetzt, werden alle eingeplanten Mitarbeiter mit Zugang per E-Mail \xFCber das zur\xFCckgesetzte Freigabedatum benachrichtigt.<br><br>Die Mitarbeiter k\xF6nnen dann ab sofort nur noch Dienste bis zum Freigabedatum einsehen." }, "duty": { "error": { "headline": "Funktion kann nicht ge\xE4ndert werden" } }, "bulk": { "selected": "Dienste ausgew\xE4hlt", "note": "Alle gew\xFCnschten Dienste ausgew\xE4hlt? W\xE4hle dann eine der folgenden Aktionen.", "pasting": "F\xFCge die Dienste irgendwo im Dienstplan ein.", "cut": "ausschneiden", "copy": "kopieren", "duplicate": "duplizieren", "match": "bef\xFCllen", "empty": "entleeren", "delete": "l\xF6schen", "error": { "resolve": "Du musst erst die Konflikte l\xF6sen!", "released": "Diese Aktion kann nicht im freigegebenen Dienstplan ausgef\xFChrt werden.", "paste_released": "Du kannst keine Dienste in den freigegebenen Dienstplan einsetzen.", "latency": "Einige der Dienste wurden ge\xE4ndert, w\xE4hrend du diese Aktion ausgef\xFChrt hast. Lade den Dienstplan neu und probier's dann nochmal." } }, "observer_note": "Du bist Beobachter in der Planung, darum kannst du keine Dienste \xE4ndern oder hinzuf\xFCgen.", "published_until": "Ver\xF6ffentlicht bis hier", "apply": { "error": { "text": "Du hast dich bereits f\xFCr diesen Dienst beworben", "headline": "Nicht m\xF6glich!" } }, "revoke_application": { "error": { "headline": "Nicht m\xF6glich!", "text": "Du hast dich nicht f\xFCr diesen Dienst beworben" } }, "preset": { "return": "zur\xFCck zur Planung", "template": "Vorlage bearbeiten", "info": "F\xFCr jeden Dienstplan kannst du bis zu 4 Wochen in die Vorlage eintragen. Anschlie\xDFend kannst du die Voreinstellungen einfach kopieren und in die aktuelle Planung einf\xFCgen.", "template_paste": "Vorlage einf\xFCgen" }, "to_projects": "Projekte verwalten" }, "reports": { "remove": { "headline": "Auswertung l\xF6schen", "text": "Willst du diese Auswertung wirklich l\xF6schen?" }, "save": { "headline": "Auswertung speichern" }, "saved": "Auswertung erfolgreich gespeichert!", "without": "ohne", "hours": "Stunden", "overview": { "headline": "Stundenauswertung", "empty": "Keine gespeicherten Auswertungen vorhanden.", "info": "Du kannst so viele Auswertungen erstellen, wie du magst. Auch mehrere im gleichen Zeitraum sind m\xF6glich. So kannst du z.B. eigene Auswertungen f\xFCr Mitarbeiter oder Dienstplan anlegen." }, "filter": { "headline": { "new": "Neue Auswertung", "existing": "Auswertung" }, "filter": "Filter anwenden", "more": "mehr Filter anzeigen", "empty": "Keine Ergebnisse in der selektierten Zeitspanne.", "stats": { "duties": "Dienste", "expected": "Geplant", "reported": "Eingetragen", "overtime": "\xDCberstunden", "salary": "Lohn" }, "show_details": "Zeige alle Details" }, "point": "Abrechnungszeitpunkt", "add": "Auswertung erstellen", "hints": "Hinweise", "unapproved": "Stunden in Klammern wurden zwar erfasst, aber noch nicht best\xE4tigt.", "missing": "Folgende Mitarbeiter haben im Abrechnungszeitraum noch nicht alle Stunden eingetragen:", "complete": "Alle Zeiten im ausgew\xE4hlten Zeitraum wurden erfasst!", "created_at": "erfasst am", "approved_at": "best\xE4tigt am", "approved_by": "best. durch", "sick_pay": "Lohnfortz.", "salary": "Lohnkosten", "actions": "Aktionen", "edit": "Stunden bearbeiten", "no_cost": "Stunden ohne Kostenstelle", "download": "Download", "xls_title": "Auswertung", "edit_hours": "Stunden bearbeiten", "back": "zur\xFCck zur \xDCbersicht", "no_hour": "Nicht registrierte Stunden", "download_warn": { "headline": "Nicht alle Stunden im ausgew\xE4hlten Zeitraum (unabh\xE4ngig vom 'Status' Filter) wurden genehmigt:", "open": "noch nicht eingetragen", "pending": "noch nicht best\xE4tigt", "planned": "in der Zukunft", "denied": "abgewiesen", "footer": "M\xF6chtest du die ausgew\xE4hlten Stunden dennoch herunterladen?" }, "labels": { "add": "Label hinzuf\xFCgen", "remove": "Label entfernen", "headline": "Labels bearbeiten" }, "export": { "headline": "Export zur Lohnabrechnung", "notice": "M\xF6chtest du wirklich die Lohnabrechnung f\xFCr alle Mitarbeiter und Standorte (unabh\xE4ngig der eingestellten Filter) im ausgew\xE4hlten Zeitraum durchf\xFChren? Hinweis: nur bisher unbezahlte Stunden werden ausbezahlt!", "warning": "Nicht alle Stunden wurden genehmigt. Die Lohnabrechnung kann nur erfolgen, wenn alle Stunden im ausgew\xE4hlten Zeitraum eingetragen und genehmigt wurden.", "incomplete": "Nicht alle Mitarbeiter sind vollst\xE4ndig registriert. F\xFCr Mitarbeiter, die nicht vollst\xE4ndig registriert sind, kann keine Lohnabrechnung erfolgen." }, "downloads": { "per_employee": "pro Mitarbeiter", "per_client": "pro Kunde", "per_planning": "pro Dienstplan", "billable": "Best\xE4tigt pro Dienstplan" }, "generateInvoice": { "title": "Rechnung generieren", "button": "Rechnungen erstellen", "period": "Rechnung f\xFCr den Zeitraum generieren", "until": "bis zu", "for_freelancers": "F\xFCr Freelancer:", "all_freelancers": "F\xFCr alle freelancers" } }, "lists": { "remove": { "headline": "Liste l\xF6schen", "text": "Willst du diese Liste wirklich l\xF6schen?" }, "save": { "headline": "Liste speichern" }, "saved": "Liste erfolgreich gespeichert!", "filter": { "headline": { "new": "Neue Liste", "existing": "Liste" }, "stats": { "items": "Dienste", "expected": "Stunden" }, "released_only": "nur ver\xF6ffentlichte Dienste", "placeholder": "Offene Dienste", "assigned": "Gef\xFCllte Dienste", "with_unpublished": "inkl. unver\xF6ffentlichte Dienste", "notes": "zeige Notizen" }, "overview": { "empty": "Keine gespeicherten Listen vorhanden.", "info": "Hier kannst du Listen erstellen auf Basis der eingeplanten Dienste.", "headline": "Listen" }, "add": "Liste erstellen", "xls_title": "Liste" }, "settings": { "role_manager": { "confirm": "Kontoverwalter haben Zugang zu ALLEN Mitarbeiterdaten und Einstellungen deines Accounts. Stelle sicher, dass der Mitarbeiter verantwortungsvoll mit seiner Rolle umgeht." }, "role_accountant": { "confirm": "Mitarbeiter mit Zugang zur Stundenauswertung k\xF6nnen die registrierten Stunden anderer Mitarbeiter einsehen. M\xF6glicherweise auch deren L\xF6hne und Ausgaben. Stelle sicher, dass der Mitarbeiter vertrauensvoll mit diesen Informationen umgeht." }, "general": { "headline": "Allgemeine Einstellungen", "fieldset": { "roster": "Basis", "invoice": "Rechnungsadresse", "expenses": "Unkosten und Reisekosten", "various": "Sonstiges" }, "expenses": { "general": "Mitarbeiter d\xFCrfen Unkosten deklarieren (in \u20AC)", "travel": "Mitarbeiter d\xFCrfen Reisekosten deklarieren", "travel_auto": "Reisekosten automatisch berechnen", "travel_note": "Aufgepasst: um Reiskosten automatisch berechnen zu k\xF6nnen muss eine Postleitzahl in den Dienstplaneinstellungen und bei Mitarbeitern eingetragen sein!", "assign_driver": "Weisen Sie den Fahrer wie folgt zu:", "driver_role": "Unterscheidung zwischen Fahrern und Fahrg\xE4sten", "passenger_threshold": "Entsch\xE4digung der Reisekosten von Fahrg\xE4sten nach" }, "placeholders": "Eintragung in einen Platzhalter muss durch einen Dienstplaner genehmigt werden (Option momentan nicht verf\xFCgbar)", "contacts_visibility_public": "\xF6ffentlich", "contacts_visibility_public_hint": "f\xFCr alle Nutzer des Accounts sichtbar", "contacts_visibility_private": "privat", "contacts_visibility_private_hint": "nur f\xFCr Manager und Dienstplaner sichtbar", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "vat_exempt": "nicht umsatzsteuerpflichtig", "roster": { "must_apply": "Mitarbeiter m\xFCssen sich f\xFCr einen Dienst bewerben", "hide_names": "Eingeschr\xE4nkte Dienstplaner (Namen ausblenden, kein Zugriff auf Planungs\xFCbersicht)" }, "2fa": "Zwei-Faktor Authentifizierung verpflichten f\xFCr Kontoinhaber, Kontoverwalter und Dienstplaner.", "invoice_interval": { "weekly": "W\xF6chentlich", "monthly": "Monatlich", "4weeks": "Vierzehnt\xE4gig" }, "auto_invoicing_hint": "Aktivieren Sie die automatische Rechnungsstellung, um nach jedem Intervall automatisch Rechnungen zu erstellen und zu versenden und nennen Sie die Freiberufler" }, "locations": { "headline": "Standorte", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Standort hinzuf\xFCgen", "edit": "Standort bearbeiten", "empty": "Noch kein Dienstplan angelegt.", "moved": "Die Einstellung \"Standorte\" wurde auf die Seite Planung verschoben. Du kannst deine Standorte dort ab sofort als \"Dienstpl\xE4ne\" hinzuf\xFCgen und bearbeiten.", "info": "Hinweis: Wir haben \"Standorte\" in \"Dienstpl\xE4ne\" umbenannt. Das gibt dir mehr Flexibilit\xE4t. Du kannst einen Dienstplan f\xFCr einen festen \"Standort\" oder einen tempor\xE4ren \"Auftrag\" erstellen." }, "jobs": { "headline": "Besch\xE4ftigungsverh\xE4ltnisse", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Besch\xE4ftigung hinzuf\xFCgen", "edit": "Besch\xE4ftigung bearbeiten", "empty": "Noch keine Besch\xE4ftigungen angelegt.", "type": { "full": "Vollzeit", "part": "Teilzeit", "temp": "Flexibel" } }, "duties": { "headline": "Funktionen", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Funktion hinzuf\xFCgen", "edit": "Funktion bearbeiten", "empty": "Noch keine Funktionen angelegt.", "rest_label": "h nach jedem Dienst" }, "shifts": { "headline": "Schichten", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Schicht hinzuf\xFCgen", "edit": "Schicht bearbeiten", "empty": "Noch keine Schichten angelegt." }, "costs": { "headline": "Kostenstellen", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Kostenstelle hinzuf\xFCgen", "edit": "Kostenstelle bearbeiten", "empty": "Noch keine Kostenstelle angelegt." }, "availability": { "headline": "Verf\xFCgbarkeit", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "users": { "fieldset": "Mitarbeiter", "label": { "before": "Verf\xFCgbarkeit muss mindestens", "after": "Woche(n) im Voraus eintragen werden." }, "hint": "Mitarbeiter k\xF6nnen ihre Verf\xFCgbarkeit innerhalb dieser Frist nicht mehr ver\xE4ndern." }, "planners": { "fieldset": "Dienstplaner", "label": "Einplanen von <u>nicht</u> verf\xFCgbaren Mitarbeitern im Dienstplan:", "deny": "verweigern", "warn": "warnen", "allow": "erlauben" }, "options": { "fieldset": "Weitere Optionen", "constrainable": { "label": "Mitarbeiter d\xFCrfen verf\xFCgbare Tage zeitlich beschr\xE4nken", "hint": "z.B. verf\xFCgbar ab 16:00 Uhr" }, "editable": "Dienstplaner d\xFCrfen Verf\xFCgbarkeit f\xFCr andere Mitarbeiter anpassen", "blank": "Nicht angegebene Verf\xFCgbarkeit als leer anzeigen", "vacation": "Mitarbeiter d\xFCrfen Urlaub beantragen" } }, "tags": { "headline": "Tags", "add": "Tag hinzuf\xFCgen", "edit": "Tag bearbeiten", "empty": "Noch keine Tags angelegt." }, "rates": { "headline": "Stundenl\xF6hne", "add": "Stundenlohn hinzuf\xFCgen", "edit": "Stundenlohn bearbeiten", "empty": "Noch keine Stundenl\xF6hne angelegt.", "hint": { "amount": "Brutto Stundenlohn", "factor": "Umrechnungsfaktor f\xFCr Kostenberechnung" } }, "premiums": { "headline": "Zuschl\xE4ge", "add": "Zuschlag hinzuf\xFCgen", "edit": "Zuschlag bearbeiten", "empty": "Noch keine Zuschl\xE4ge angelegt." }, "holidays": { "headline": "Feiertage", "empty": "Noch keine Feiertage angelegt.", "add": "Feiertag hinzuf\xFCgen", "notes": "W\xE4hle aus, welche Feiertage in deiner Firma anwendbar sind oder f\xFCge selbst Feiertage hinzu.", "edit": "Feiertag bearbeiten" }, "contracts": { "add": "Vorlage hinzuf\xFCgen", "edit": "Vertrag \xE4ndern", "empty": "Noch keine Vertragsvorlage angelegt.", "upload": "Vorlage hochladen", "change": "Vorlage \xE4ndern", "modal": { "info": "Hier k\xF6nnen Sie eine Vorlage im .doc oder .docx Format hochladen." } }, "checkin": { "fieldset": { "location": "Dienstplan", "time": "Check-in zeit", "open": "Offene Check-ins" }, "location": { "required": "Check-in nur mit Standort erlauben", "range": { "before": "Check-in nur im Umkreis von", "after": "Metern zulassen" } }, "before": { "min": { "before": "Mitarbeiter m\xFCssen mindestens", "after": "Minuten vor Dienstbeginn einchecken" }, "max": { "before": "Mitarbeiter d\xFCrfen max.", "after": "Minuten vor Dienstbeginn einchecken" } }, "handle": { "open": "Automatischer Check-out nach" }, "hints": { "range": "Diese Einstellung funktioniert nur mit einer vollst\xE4ndigen Adressangabe bei deinen Dienstpl\xE4nen." } } }, "availability": { "sidebar": { "change": "Auswahl \xE4ndern in", "selection": "Deine Auswahl", "deselect": "Auswahl aufheben", "constraints": "Zeitbeschr\xE4nkung", "status": "Urlaub Status", "hint": "Tipp: Halte die Control/Command-Taste gedr\xFCckt, um mehrere Tage auszuw\xE4hlen." }, "error": { "mixed_constraints": "Die Zeitbeschr\xE4nkung darf nicht unterschiedlich sein an den ausgew\xE4hlten Tagen.", "status": "Du musst einen Status f\xFCr den Urlaub ausw\xE4hlen.", "invalid_constraints": "Ung\xFCltige Zeitbeschr\xE4nkung.", "incomplete_constraints": "Zeitbeschr\xE4nkung an Urlaubstagen ben\xF6tigt Start- und Endzeit.", "conflict": "Die folgenden Daten konnten nicht aktualisiert werden, da der Dienstplaner bereits deine Verf\xFCgbarkeit ber\xFCcksichtigt hat.<ul><li>{dates}</li></ul><div class=\"note\">Nimm Kontakt auf mit deinem Dienstplaner um deine Verf\xFCgbarkeit dennoch zu \xE4ndern.</div>" }, "legend": { "vacation_requested": "Urlaub (angefragt)", "vacation_denied": "Urlaub (verweigert)", "vacation_approved": "Urlaub (genehmigt)", "holiday": "Feiertag" }, "from": "ab", "until": "bis", "headline": { "planner": "\xDCbersicht", "user": "Meine Verf\xFCgbarkeit" }, "button": { "overview": "Alle", "mine": "Meine" }, "tools": { "hint": "<b>Selektiere einen oder mehrere Tage</b> und w\xE4hle danach deine Verf\xFCgbarkeit.", "default": "Du bist ohne Angabe deiner Verf\xFCgbarkeit: <b>:availability</b>", "multiselect": "<b>Tipp:</b> Halte die \"Shift\"-Taste gedr\xFCckt um mehrere einzelne Tage zu selektieren.", "selection": { "you_have": "Du hast", "day": "Tag", "days": "Tage", "selected": "ausgew\xE4hlt" }, "vacation": { "headline": "Urlaubsanfrage bearbeiten", "approve": "freigeben", "deny": "ablehnen", "unapproved": "Der Urlaub ist noch nicht best\xE4tigt!", "denied": "Urlaubsanfrage wurde abgelehnt." }, "tooltip": { "pending": "Urlaub angefragt", "denied": "Urlaub abgelehnt" }, "constraints": { "headline": "F\xFCge eine Zeitbeschr\xE4nkung hinzu", "hint": "nur m\xF6glich, wenn du verf\xFCgbar bist" }, "change_to": "Auswahl \xE4ndern in", "reset": "Auswahl zur\xFCcksetzen", "request": "anfragen", "register": "eintragen" }, "dropdown": "Alle Dienstpl\xE4ne", "defaults": "Verf\xFCgbarkeit" }, "overview": { "welcome": { "headline": "Willkommen, {name}!", "text": "Vervollst\xE4ndige doch gleich als erstes dein Profil mit deinen aktuellen Kontaktdaten.<br><br><a href=\"{href}\" class=\"box-button\">Zum Profil</a>" }, "checklist": { "headline": "Erledige diese Schritte vor der Freigabe des Dienstplans:", "shifts": "Schichten anpassen", "duties": "Dienste einplanen", "users": "Mitarbeiter einladen", "publish": "Dienstplan freigeben" }, "headline": "Willkommen", "unbilled": "offener Stundeneintrag|offene Stundeneintr\xE4ge", "approve_hours": "Stunden best\xE4tigen", "sidebar": { "headline": "Meine n\xE4chsten Dienste", "empty": "Keine Dienste geplant.", "no_locations": "Du hast derzeit keinen Zugriff auf den Dienstplan, da du keinem Dienstplan zugewiesen wurdest." }, "unapproved": "zu genehmigende Stunden|zu genehmigende Stunden", "processable": "1 Urlaubsanfrage wartet noch auf Genehmigung.|{processable} Urlaubsanfragen warten noch auf Genehmigung.", "vacation_requests": "Urlaubsanfrage|Urlaubsanfragen" }, "balances": { "added": "hinzu", "note_overview": "Im Stundenkonto werden lediglich best\xE4tigte Stunden ber\xFCcksichtigt.", "note_current": "Dein derzeitiges Saldo betr\xE4gt: <em>{saldo} Stunden</em> Die Stunden der aktuellen Woche (ab {date}) z\xE4hlen nicht mit." }, "account": { "headline": "Accountverwaltung", "delete": "Konto l\xF6schen", "delete_confirm": "Willst du das Konto wirklich endg\xFCltig l\xF6schen? Alle Daten werden unmittelbar und unwiderruflich gel\xF6scht!", "unsubscribe": "Abonnement k\xFCndigen", "unsubscribe_confirm": "Willst du das Abonnement wirklich k\xFCndigen? Du kannst das Konto noch bis zum Ende des aktuellen Abrechnungszeitraums nutzen!", "saved": "Die Daten wurden erfolgreich aktualisiert.", "trial": { "expiration": "Du kannst ONDURO noch bis inklusive <strong>{expiration}<\/strong> gratis nutzen.", "days": "Das ist noch {days} Tag.|Das sind noch {days} Tage.", "expires_today": "Du kannst ONDURO nur noch heute gratis nutzen. Willst du weiterhin einfach und deutlich planen? Mache dann jetzt ein Abonnement!" }, "active_trial": { "note": "Du musst erst ab dem :period_start bezahlen. Die erste Rechnung erh\xE4ltst du dann am :invoice_date.", "box1": { "headline": "Gratis Testperiode", "until": "bis inklusive", "description": "Bis zu diesem Datum bezahlst du nichts!<br>Doch k\xFCndigen? Mach das dann bis sp\xE4testens an diesem Tag." }, "box2": { "headline": "Aktive Mitarbeiter", "period": "im aktuellen Rechnungszeitraum", "description": "Auf Basis dieser Anzahl wird dein Monatsbeitrag berechnet." } }, "active": { "note": "Du erh\xE4ltst die n\xE4chste Rechnung am <strong>{nextInvoice}</strong> f\xFCr den Zeitraum vom {billingStart} bis einschlie\xDFlich {billingEnd}. Bitte f\xFCge bis dahin deine aktuellen Rechnungsdaten unten hinzu!", "box1": { "headline": "Rechnungszeitraum", "until": "bis inklusive", "description": "Das sind noch :days Tage." }, "box2": { "headline": "Aktive Mitarbeiter", "period": "im aktuellen Rechnungszeitraum", "description": "Anzahl bereits aktiviertere + neu hinzugef\xFCgter / aktivierter Mitarbeiter." }, "box3": { "headline": "Zu ewartende Kosten", "period": "in n\xE4chster Rechnung", "description": "Zu erwartende Kosten auf Basis von aktivierten Mitarbeitern im aktuellen Rechnungszeitraum." } }, "cancelled": { "note": "Du kannst ONDURO noch bis inklusive <strong>{expiration_date}</strong> nutzen oder dein Konto sofort l\xF6schen.", "box1": { "headline": "Rechnungszeitraum", "until": "bis inklusive", "description": "Das sind noch :days Tage." }, "box2": { "headline": "Aktive Mitarbeiter", "period": "im aktuellen Rechnungszeitraum", "description": "Anzahl bereits aktiviertere + neu hinzugef\xFCgter / aktivierter Mitarbeiter." }, "box3": { "headline": "Zu ewartende Kosten", "period": "in letzter Rechnung", "description": "Zu erwartende Kosten auf Basis von aktivierten Mitarbeitern im aktuellen Rechnungszeitraum." }, "info": "Du empf\xE4ngst deine letzte Rechnung am <strong>:invoice_date</strong>. Der Betrag wird automatisch von deinem Konto abgebucht." }, "subscription": { "title": "Alles inklusive f\xFCr", "per_user": "pro aktivem Mitarbeiter", "per_month": "pro 30 Tage", "benefits": ["alle Funktionen inklusive", "stets volle Kosten\xFCbersicht", "jederzeit k\xFCndbar", "sicher bezahlen via Lastschrift"], "subscribe": "Jetzt abonnieren", "start": "die bezahlte Periode beginnt erst am", "success": "Dein Abonnement ist erfolgreich aktiviert!<br>Viel Spa\xDF mit ONDURO!" }, "unsubscription": { "success": "Dein Abonnement ist erfolgreich gek\xFCndigt!<br>Vielen Dank f\xFCr dein Vertrauen!" }, "support": "Noch Fragen? Schicke uns eine <a href=\"#\" class=\"box-intercom\">Nachricht<\/a>. Wir helfen dir gerne!", "sidebar": { "discount": { "headline": "Rabattcode" }, "status": { "headline": "Status", "text": "Diese Daten werden im Adressbuch angezeigt:", "free": "Dein Konto ist aktiv.", "trial": "Testperiode bis", "registered_since": "Registriert seit", "subscribed_since": "Abonniert seit" }, "owner": { "headline": "Verantwortlicher (DSGVO)" }, "invoices": "Rechnungen", "license_code": "Lizenzcode" }, "license": { "note": "Du nutzt ONDURO \xFCber einen Lizenzcode.", "error": "Dieser Lizenzcode ist ung\xFCltig oder abgelaufen." }, "demo": "Du nutzt ONDURO derzeit in der kostenlosen Demo." }, "profile": { "headline": "Dein Profil", "account": "Abonnement", "delete": "Profil l\xF6schen", "delete_confirm": "Willst du dein Profil wirklich endg\xFCltig l\xF6schen? Alle Daten werden unmittelbar und unwiderruflich gel\xF6scht!", "saved": "Dein Profil wurde erfolgreich aktualisiert.", "gravatar": "Registriere dich bei <a href=\"https://www.gravatar.com/\" target=\"_blank\">Gravatar</a> um ein Profilfoto hinzuzuf\xFCgen.", "fieldset": { "personal_data": "Pers\xF6nliche Daten", "address": "Adressbuch", "other": "Sonstiges" }, "about": { "label": "\xDCber dich", "placeholder": "Erfahrungen, Qualifikationen, etc.", "hint": "diese Angaben sind nur f\xFCr deine Dienstplaner sichtbar" }, "sidebar": { "address": { "headline": "Adressbuch", "text": "Nur die von dir hier eingegebenen Daten werden im Adressbuch angezeigt." }, "password": { "headline": "Passwort \xE4ndern", "text": "Um dein Passwort zu \xE4ndern, klicke bitte auf die folgende Schaltfl\xE4che und folge den Schritten im Dialogfeld.", "button": "Passwort \xE4ndern" }, "email": { "headline": "E-Mail Adresse \xE4ndern", "text": "Hat sich deine E-Mail Adresse ge\xE4ndert?", "button": "E-Mail Adresse \xE4ndern" } }, "picture": "Profilbild", "progress": "Du hast {filled} von {required} Pflichtfeldern ausgef\xFCllt. Noch {remaining} weitere auszuf\xFCllen!", "filled": "Du hast alle Pflichtfelder ausgef\xFCllt!", "contract": "Das ist dein Vertrag. Bitte downloaden, unterzeichnen und wieder hochladen.", "message": { "freelancerDataSuccess": "Profil und Freelancerdaten erfolgreich gespeichert" }, "apply_from": { "headlin": "Best\xE4tigung der \xC4nderung", "text": "Die \xC4nderungen werden sofort gespeichert. Hier k\xF6nnen Sie nach einem Datum suchen, ab dem diese \xC4nderungen in die Delta-Funktion \xFCbernommen werden.", "label": "Anwendung ab" } }, "notifications": { "fieldset": { "roster": "Dienstplan", "hours": "Stunden" }, "info": "Hier kannst du einstellen, welche Benachrichtigungen du empfangen m\xF6chtest.", "saved": "Deine Einstellungen wurden erfolgreich aktualisiert.", "roster_mine": { "label": "\xC4nderungen an meinen Diensten", "hint": "benachrichtigt dich, wenn es \xC4nderungen an deinen Diensten gibt" }, "item_changed": { "label": "\xC4nderungen an allen Diensten", "hint": "benachrichtigt dich bei jeglichen \xC4nderungen im freigegebenen Dienstplan" }, "unbilled": { "label": "Stunden eintragen", "hint": "erinnert dich, wenn du noch Stunden eintragen musst" }, "unapproved": { "label": "Stunden best\xE4tigen", "hint": "erinnert dich, wenn du noch Stunden best\xE4tigen musst" }, "open_duty": { "label": "Offene Dienste", "hint": "erinnert dich, wenn Dienste noch offen sind" }, "item_upcoming": { "label": "Kommende Dienste", "hint": "benachrichtigt dich einen Tag vor Dienstbeginn" } }, "hours": { "headline": { "mine": "Meine Stunden", "all": "Alle Stunden" }, "note": { "mine": "Du musst noch Stunden eintragen. Pr\xFCfe deine Arbeitszeiten, passe sie ggf. an und best\xE4tige sie dann durch einen Klick auf das H\xE4kchen.", "pending": "Diese Stunden m\xFCssen noch best\xE4tigt werden. Solange sie nicht best\xE4tigt sind, kannst du noch \xC4nderungen durchf\xFChren.", "approvable": "Diese Stunden m\xFCssen noch genehmigt oder abgelehnt werden.", "approved": "Best\xE4tigte Stunden werden pro Monat angezeigt. Du kannst den angezeigten Monat im Dropdown rechts oben \xE4ndern." }, "actionable": "Offene Stunden", "pending": "Unbest\xE4tigt", "approvable": "Zu genehmigen", "approved": "Best\xE4tigt", "empty": "alle Stunden sind verarbeitet", "no_cost": "ohne Kostenstelle", "error": { "times": "Bitte trage plausible Arbeitszeiten ein." }, "confirm_delete": "Vorsicht! Der mit diesen Zeiten verbundene Dienst wird permanent aus dem Dienstplan entfernt!", "comment": "Nachricht hinzuf\xFCgen...", "checkins": "Zu best\xE4tigen", "unsigned": "Nicht unterzeichnet" }, "update": { "headline": "ONDURO wurde aktualisiert", "text": "Die Anwendung wird durch einen Klick auf den folgenden Button automatisch aktualisiert.", "button": "Update laden" }, "history": { "item": { "added": "hat ein Element zum :released Dienstplan hinzugef\xFCgt:", "changed": "hat ein Element im :released Dienstplan ge\xE4ndert:", "removed": "hat ein Element vom :released Dienstplan gel\xF6scht:", "signed_in": "hat :who in einen Platzhalter eingetragen:", "signed_out": "hat :who aus einem Dienst ausgetragen:" }, "hour": { "added": "hat Stunden eingetragen:", "added_for": "hat Stunden f\xFCr :who eingetragen:", "changed": "hat eingetragene Stunden ge\xE4ndert:", "changed_for": "hat eingetragene Stunden f\xFCr :who ge\xE4ndert:", "approved": "hat eingetragene Stunden von :who best\xE4tigt:", "denied": "hat eingetragene Stunden von :who abgelehnt:" }, "roster": { "released": "hat den Dienstplan freigegeben:", "revoked": "hat das Freigabedatum des Dienstplans ge\xE4ndert zu:" } }, "contacts": { "no_access": "ohne Zugriff", "not_verified": "noch nicht registrier", "download": "Download" }, "modules": { "descriptions": { "basic": "Der Dienstplan dient als Basis f\xFCr die Planung.", "hours": "Lass Mitarbeiter ihre Stunden eintragen und erstelle Stundenauswertungen mit einem Klick.", "availability": "Lass Mitarbeiter ihre Verf\xFCgbarkeit eintragen.", "shifts": "F\xFCge Diensten zuvor definierte Schichten zu.", "tags": "Erstelle Tags f\xFCr Dienste oder Mitarbeiter.", "rates": "Lass Stundenl\xF6hne automatisch berechnen und Unkosten deklarieren.", "balances": "Erm\xF6gliche Stundenkonten und lasse Mitarbeiter stets das aktuelle Saldo einsehen.", "sickness": "Verarbeite Dienste die wegen Krankheit nicht gearbeitet wurden.", "tentoo": "Erm\xF6glicht die direkte Anbindung an Tentoo Payroll.", "costs": "Lass Stunden auf verschiedene Kostenstellen buchen.", "lists": "Erstelle einfach Listen von geplanten Diensten.", "chats": "Nachrichten schreiben zwischen Mitarbeitern", "temper": "Temper.works Integration", "blueprint": "Definiere Standardeinstellungen f\xFCr neue Mitarbeiter.", "weather": "7-t\xE4gige Wettervorhersage im Dienstplan. Ben\xF6tigt eine PLZ in den Dienstplaneinstellungen.", "vacation": "Urlaubsplanung und -verwaltung.", "dashboard": "Stellt ein Dashboard f\xFCr den heutigen Dienstplan bereit.", "today": "Erm\xF6glicht den Zugriff auf die Seite Tagesplan.", "statistics": "Erhalte Einblicke in geplante vs. gearbeitete Stunden, Geh\xE4lter und Kosten.", "university": "Erhalte sofort Hilfeartikel und lerne alles \xFCber ONDURO.", "dossiers": "Speichere zus\xE4tzliche Informationen von Mitarbeitern.", "contacts": "Zeigt das Adressbuch f\xFCr schnellen Zugang zu Kontaktinformationen.", "planning": "Erstelle und publiziere Dienstpl\xE4ne, lasse Mitarbeiter ihre Dienstpl\xE4ne einsehen.", "contracts": "Verwalte Vertr\xE4ge von Mitarbeitern.", "nmbrs": "Verwalte bestimmte Daten f\xFCr die Schnittstelle mit Nmbrs.", "onboarding": "Erm\xF6glicht das Bereitstellen von Onboarding-Informationen f\xFCr neue Mitarbeiter.", "payslips": "Erm\xF6glicht Mitarbeiter den Zugriff auf Lohnabrechnungen.", "documents": "Dokumentencenter f\xFCr Lohnabrechnungen, Nutzeruploads und Vertr\xE4ge.", "checkins": "Lasse Mitarbeiter in anstehende Dienste ein- und auschecken.", "clients": "Kundenverwaltung f\xFCr die Gruppierung von Dienstpl\xE4nen.", "resources": "Ressourcen verwalten und im Dienstplan hinzuf\xFCgen.", "calculations": "Automatisches berechnen von Summen \xFCber alle Dienstpl\xE4ne hinweg.", "signature": "Erm\xF6glicht das Unterschreiben von unbest\xE4tigten Stunden im Stundenzettel.", "newsletter": "F\xFCge dem Dashboard einen Newsletter hinzu, indem du eine URL zu deiner externen Newsletter-Quelle hinzuf\xFCgst.", "company": "Unternehmensseite f\xFCr Mitarbeiter.", "freelancers": "Erstellen und teilen Sie (automatisch) Rechnungen f\xFCr Freiberufler und zeigen Sie sie in einer praktischen \xDCbersicht an", "projects": "Das Projektmodul hilft bei der effizienten Verwaltung und Verfolgung von Projekten. Benutzer k\xF6nnen Projekte mit Details wie Kundeninformationen, Standort, Budget, Terminplanung und Rechnungsstellung erstellen, aktualisieren und \xFCberwachen. Es unterst\xFCtzt die Zuweisung von Schichten, die Erfassung von Arbeitsstunden und die Verwaltung von Reisekosten." }, "note": "Mit diesen Tools kannst du die Funktionalit\xE4t von ONDURO ausbreiten. W\xE4hle die Tools, die zu deinem Workflow passen.", "requires": "Abh\xE4ngig", "errors": { "dependency": "Das Tool kann nicht deaktiviert werden, da die folgenden Tools abh\xE4ngig davon sind", "dependent_on": "Tool ben\xF6tigt" } }, "logout": { "confirm": { "headline": "Logout", "body": "Willst du dich wirklich ausloggen?" } }, "invoice": { "footer": { "service_of": "ist ein Service von" }, "thanks": "Vielen Dank f\xFCr dein Vertrauen!", "charge_date": "Der Betrag wird am {chargeDate} automatisch von deinem Bankkonto abgebucht." }, "vacation": { "status": { "pending": "ausstehend", "processed": "verarbeitet", "approved": "genehmigt", "denied": "abgewiesen", "withdrawn": "zur\xFCckgezogen", "removed": "entfernt", "request": "Anfrage", "requested": "angefragt", "credit": "Gutschrift", "debit": "Soll", "new": "neu", "changed": "ge\xE4ndert" }, "new_request": "Urlaub", "new_credit": "Guthaben", "days_selected": "Tage ausgew\xE4hlt", "current_balance": "Dein verbleibendes Urlaubsguthaben betr\xE4gt:", "request": { "empty": "W\xE4hle die gew\xFCnschten Urlaubstage f\xFCr diese Anfrage im Kalender", "above": "oben", "right": "rechts" }, "duration": { "full": "ganzer Tag", "morning": "morgens", "afternoon": "nachmittags" }, "headline_new": "Neuer Urlaub", "note": { "start": "W\xE4hle einen Mitarbeiter aus der Liste, f\xFCr den du eine Anfrage erstellen m\xF6chtest.", "processed": "Deine Anfrage wurde bearbeitet.", "pending": "Deine Anfrage wird behandelt.<br><br>Du erh\xE4ltst eine Nachricht, sobald diese verarbeitet ist.", "tracking": "Hier kannst du angeben, wieviele Urlaub dem Mitarbeiter abgezogen wird f\xFCr die beantragten Urlaubstage.", "changed": "Du hast die Anfrage ge\xE4ndert. Vergesse nicht, die ge\xE4nderte Anfrage zu speichern." }, "amount": "Urlaub", "days": "Urlaubstage", "sidebar": { "current_balance": "Aktuelles Saldo", "deduct": "bezahlter Urlaub", "new_balance": "Neues Saldo", "average": "im Schnitt {average} pro Urlaubstag", "remaining_balance": "Restsaldo" }, "stats": "{days} Tage angefragt, {approved} genehmigt", "allow": "erlauben", "deny": "verweigern", "credit": "gutschreiben", "debit": "abziehen", "edit": "Saldo anpassen", "compensation": { "vacation": "bezahlter Urlaub", "overtime": "f\xFCr \xDCberstunden", "none": "unbezahlter Urlaub" }, "vacation_request": "Urlaubsantrag", "submit": "einreichen", "amount-paid-hours": "Anzahl der zu bezahlenden Stunden", "holiday-type": "Urlaubstyp", "empty": "Es gibt noch keine Urlaubsantr\xE4ge f\xFCr dieses Jahr.", "empty-planner": "Es gibt noch keine Urlaubsantr\xE4ge f\xFCr dieses Jahr oder du hast zu viele Filter ausgew\xE4hlt." }, "setup": { "contact": "Kontakt aufnehmen", "loading": "Daten abrufen...", "headline": "Noch ein Schritt", "error": { "SETUP_COMPLETED": "Du hast das Setup schon abgeschlossen. Klicke auf den folgenden Button um einzuloggen:", "INVALID_CREDENTIALS": "Irgendwas stimmt nicht. Nimm via unten stehenden Button Kontakt mit uns auf:", "general": "Wir konnten deine Daten nicht abrufen. Nimm via unten stehenden Button Kontakt mit uns auf:" } }, "statistics": { "sidebar": { "headline": "Zeitraum", "cluster": "Anzeigen nach" }, "tabs": { "details": "Details", "overview": "\xDCbersicht" }, "content": { "chosedata": "W\xE4hle einen Zeitraum aus um Daten anzuzeigen." } }, "today": { "working": "Wer arbeitet heute?", "empty": "Heute ist niemand eingeplant." }, "chats": { "new": { "headline": "Neue Nachricht" }, "participants": { "headline": "Teilnehmer" } }, "subscription": { "choose_plan": "W\xE4hle deinen Plan", "monthly": "pro Monat", "billing": { "before": "im Voraus", "after": "im Nachhinein" }, "cancel": "doch nicht", "subscribe": "Abonnement abschlie\xDFen", "change": "Plan \xE4ndern", "choose": "Plan ausw\xE4hlen", "chosen": "Derzeitiger Plan", "selection": "Neue Auswahl", "active_users": "aktive Mitarbeiter", "plans": { "fix": "Fest", "flex": "Flex", "legacy": "Veraltet", "custom": "Individuell" }, "more_info": "Mehr Informationen und Details zu den Tarifen findest du auf <a href=\"https:\/\/www.onduro.com\" target=\"_blank\">www.onduro.com<\/a>." }, "myroster": { "tabs": { "mine": "Meine Dienste", "open": "Offene Dienste", "all": "Alle Dienste" }, "empty": "Keine Dienste geplant.", "next_month": "zum n\xE4chsten Monat", "headline": "Dienstplan", "headline_mine": "Mein Dienst", "headline_open": "Offener Dienst", "sidebar": { "show_all": "zeige alle Tage", "show_locations": "zeige Standorte", "no_colleagues": "Es sind (noch) keine Kollegen geplant.", "note": "An den rot markierten Tagen bist du bereits eingeplant (siehe Tab \"meine Dienste\").", "warn": "Auf dem Tab \"meine Dienste\" findest du eine \xDCbersicht deiner Dienste (in allen Dienstpl\xE4nen)." }, "details": { "warn_multiple": "du bist in mehreren Diensten eingeplant an diesem Tag!", "signed_out": "Die Austragung deines Dienstes ist in Behandlung. Doch arbeiten? Klicke dann auf den folgenden Button:", "confirmed": "Du hast diesen Dienst best\xE4tigt am {date}.", "info_assigned": "Du bist bereits in einem anderen Dienst eingetragen an diesem Tag!|Du bist bereits in {items} anderen Diensten eingetragen an diesem Tag!", "info_placeholder": "Es gibt noch einen weiteren offenen Dienst an diesem Tag.|Es gibt noch {items} weitere offene Dienste an diesem Tag." }, "no_duty": "kein Dienst" }, "payslips": { "empty": "Es wurden noch keine Lohnabrechnungen f\xFCr dich hinterlegt." }, "documents": { "note": "Im Dokumentencenter kannst du alle Dokumente \xFCbersichtlich abrufen und anzeigen lassen. Du findest hier Dokumente der Lohnabrechnung sowie Vertr\xE4ge und Benutzeruploads. Hochladen und l\xF6schen kannst du diese Dokumente im Mitarbeiterprofil." }, "log": { "changed": "Die folgenden \xC4nderungen wurden vorgenommen:", "note": "Es k\xF6nnen maximal 30 Tage angezeigt werden.", "filter_keys": "Filtern auf \xC4nderungen in" }, "clients": { "add": "Kunde hinzuf\xFCgen", "edit": "Kunde bearbeiten" }, "plannings": { "title": "Dienstpl\xE4ne", "add": "Plan hinzuf\xFCgen", "edit": "Plan \xE4ndern", "tooltip": { "link": "Du bist nicht mit diesem Dienstplan verkn\xFCpft!", "inactive": "Inaktive Dienstpl\xE4ne k\xF6nnen nicht eingesehen werden." }, "button": "Dienstpl\xE4ne verwalten" }, "resources": { "add": "Ressource hinzuf\xFCgen", "delete": "Ressource l\xF6schen", "delete_confirm": "Willst du diese Ressource wirklich endg\xFCltig l\xF6schen? Alle Daten werden unmittelbar und unwiderruflich gel\xF6scht!" }, "login": { "2fa": { "setup": ["Scan diesen QR Code mit <b>Google Authenticator<\/b>:", "und f\xFClle danach den generierten Code ein:"], "lost": "Wenn du den Zugang zu deiner Google Authenticator App verloren hast, nimm Kontakt auf zu deinem Vorgesetzten um die Zwei-Faktor Authentifizierung erneut einzurichten.", "required": "Das Unternehmen, f\xFCr das du dich anmeldest, erfordert eine zweistufige Verifizierung. Diese musst du erst einrichten, bevor du dich anmelden kannst.", "failed": "Zwei-Faktor Authentifizierung fehlgeschlagen. Versuche es erneut." } }, "projects": { "add": "Projekt einf\xFCgen", "edit": "Projekt bearbeiten", "title": "Projekte", "travel_allowance": { "hint": "Wenden Sie die in den Einstellungen festgelegte Reisekostenpauschale vom Unternehmensstandort auf den Projektstandort an." } } }, "error": { "button": { "to_login": "zum Login", "to_homepage": "zur Startseite", "to_referrer": "zur vorigen Seite" }, "general": { "title": "Fehler", "check": "Bitte pr\xFCfe deine eingegebenen Daten.", "invalid": "Ung\xFCltige Angaben!" }, "cross_request": "Die Anfrage ist abgelaufen. Bitte versuche es noch einmal!", "403": { "title": "Zugriff verweigert", "headline": "Zugriff verweigert", "text": "Entweder du warst zu lange inaktiv oder hast nicht gen\xFCgend Rechte um diese Seite anzuzeigen. Bitte melde dich erneut an.", "text_membership": "Irgendwas ging schief, du wurdest daher sicherheitshalber ausgeloggt. Bitte logge dich erneut ein." }, "404": { "title": "Seite nicht gefunden", "headline": "Oha!", "text": ["Irgendwas ist schief gelaufen.", "Diese Seite existiert nicht. Bitte pr\xFCfe, ob die URL in der Adresszeile deines Browsers korrekt ist."] }, "408": { "title": "Zeitlimit \xFCberschritten", "headline": "Zeitlimit \xFCberschritten", "text": "Du warst zu lange inaktiv. Bitte melde dich erneut an." }, "503": { "title": "ONDURO ist gleich wieder da!", "headline": "Gleich wieder da...", "text": ["Die Website wird gerade aktualisiert.", "In ein paar Minuten ist ONDURO wieder zur\xFCck!"] }, "whoops": { "title": "Ooops", "headline": "Oooops, da ist was schief gelaufen!", "text": "Unser Supportteam ist informiert und wird sich so schnell wie m\xF6glich um eine L\xF6sung k\xFCmmern." }, "ajax": { "headline": "Javascript deaktiviert?", "text": "Javascript muss aktiviert sein, um diese Aktion auszuf\xFChren." }, "cookies": { "title": "Cookies deaktiviert", "headline": "Ich will Kekse!", "text": "Damit der Login funktioniert, m\xFCssen Cookies von deinem Browser akzeptiert werden. Falls du nicht wei\xDFt, wie Cookies aktiviert werden, lies bitte den folgenden Artikel: <a href=\"http://www.google.com/support/websearch/bin/answer.py?hl=de&answer=35851\">Aktivieren von Cookies</a>" }, "token_mismatch": { "headline": "Anfrage fehlgeschlagen", "text": "Du warst zu lange inaktiv. Bitte melde dich erneut an." }, "decrypt": { "headline": "Login fehlgeschlagen", "text": "Probierst du mit einem Passworttool einzuloggen (z.B. LastPass oder 1Password)? Probier es dann bitte nochmal ohne diese Tools!" }, "exception": { "session_validation": "Dein aktueller Dienstplan wurde gel\xF6scht. Du wurdest automatisch zu einem anderen aktiven Dienstplan umgeleitet." }, "fields": { "text": "W\xE4hle <b>mindestens ein</b> Feld" }, "422": { "gravatar": "Zul\xE4ssige Dateitypen sind: jpg, jpeg, png, gif <br> Das Bild darf nicht gr\xF6\xDFer als 2 MB sein" }, "413": "Datei ist zu gro\xDF (max. 4MB)" }, "widget": { "general": { "confirm": "Bist du dir sicher?" }, "premiums": { "headline": "Zuschlag", "base": "auf basis von", "days": "Tag(e)", "time": "Zeitfenster", "tags": "Tags", "holidays": "Feiertage" }, "rates": { "headline": "Stundenlohn", "note": "Zuschl\xE4ge werden immer vom Basislohn berechnet." }, "salary": { "headline": "Lohnkosten" }, "expenses": { "headline": "Ausgaben", "expense": "Ausgabe", "travel_expense": "Reisekosten", "travel_time": "Reisezeit" }, "hours": { "confirm_billable": { "headline": "Stundeneintrag best\xE4tigen", "text": "Der Mitarbeiter kann selbst seine Stunden eintragen, hat dies aber noch nicht gemacht. Willst du die Stunden f\xFCr den Mitarbeiter eintragen?", "error": "Nicht alle ausgew\xE4hlten Eintr\xE4ge konnten \xFCbermittelt werden. Pr\xFCfe bitte die Start- und Endzeiten.", "text_multi": "Bist du dir sicher, dass du die ausgew\xE4hlten Stunden absenden m\xF6chtest?" }, "deny": { "headline": "Stunden ablehnen", "text": "Der Mitarbeiter empf\xE4ngt eine automatische Nachricht \xFCber die abgelehnten Stunden. Wenn du m\xF6chtest, kannst du hier noch eine pers\xF6nliche Nachricht hinzuf\xFCgen:", "placeholder": "Schreibe hier eine pers\xF6nliche Nachricht..." } }, "locations": { "delete": { "headline": "Dienstplan l\xF6schen", "confirm": "M\xF6chtest du diesen Dienstplan wirklich l\xF6schen? Du verlierst dadurch unwideruflich Zugriff auf alle eingeplanten Elemente!" }, "step1": { "hint": "z.B. Hauptfiliale" }, "step2": { "text": "W\xE4hle Mitarbeiter aus, die bei <b>{name}</b> arbeiten." }, "deactivate_related": "Der Dienstplan kann nicht deaktiviert werden, da er mit :text freigegeben ist.", "delete_related": "Der Dienstplan kann nicht gel\xF6scht werden, da er mit :text freigegeben ist.", "delete_last": "Der Dienstplan kann nicht gel\xF6scht werden, da er der Einzige aktive ist.", "delete_unassigned": "Bevor der Dienstplan gel\xF6scht werden kann, musst du die folgenden Nutzer einem anderen Dienstplan zuweisen:<br><br><ul class=\"default\"><li>:users</li></ul>" }, "duties": { "delete": { "headline": "Funktion l\xF6schen", "confirm": "M\xF6chtest du diese Funktion wirklich l\xF6schen?" }, "step1": { "hint": { "name": "z.B. Barkeeper, Servicekraft, K\xFCchenchef", "identifier": "z.B. BAR, SER, K\xDCC" } }, "step2": { "text": "W\xE4hle Mitarbeiter aus, die die Funktion <b>{name}</b> aus\xFCben k\xF6nnen." }, "delete_related": "Die Funktion kann nicht gel\xF6scht werden, da sie mit :text verbunden ist." }, "shifts": { "delete": { "headline": "Schicht l\xF6schen", "confirm": "M\xF6chtest du diese Schicht wirklich l\xF6schen?" }, "text": "W\xE4hle <b>mindestens einen</b> Standort, wo diese Schicht in Gebrauch ist.", "hint": { "name": "z.B. Fr\xFChschicht, Nachtschicht", "identifier": "z.B. F, N" }, "delete_related": "Die Schicht kann nicht gel\xF6scht werden, da sie mit :text verbunden ist." }, "costs": { "delete": { "headline": "Kostenstelle l\xF6schen", "confirm": "M\xF6chtest du diese Kostenstelle wirklich l\xF6schen?" }, "hint": "z.B. Allgemein, Intern", "delete_related": "Diese Kostenstelle kann nicht gel\xF6scht werden, da sie mit :text verbunden ist. Entferne die Kostenstelle zuerst bei den entsprechenden Mitarbeitern.", "delete_fallback": "Diese Kostenstelle kannst du nicht l\xF6schen, da es die Standardkostenstelle ist.", "delete_hours": "Diese Kostenstelle kann nicht gel\xF6scht werden, da sie mit eingetragenen Stunden verbunden ist." }, "workspaces": { "delete": { "headline": "Arbeitsbereich l\xF6schen", "confirm": "M\xF6chtest du diesen Arbeitsbereich wirklich l\xF6schen? Du verlierst dadurch unwideruflich Zugriff auf alle eingeplanten Elemente!" } }, "tags": { "delete": { "headline": "Tag l\xF6schen", "confirm": "M\xF6chtest du diesen Tag wirklich l\xF6schen? Er wird von allen Diensten und Mitarbeitern entfernt." }, "step1": { "hint": "z.B. VIP" }, "step2": { "text": "W\xE4hle Mitarbeiter aus, die den Tag <b>{name}</b> erhalten." } }, "holidays": { "headline": "Feiertage" }, "change": { "email": { "headline": "E-Mail Adresse \xE4ndern", "success": "Deine E-Mail Adresse wurde erfolgreich ge\xE4ndert. Beim n\xE4chsten Login bitte ber\xFCcksichtigen!" }, "password": { "headline": "Passwort \xE4ndern", "success": "Dein Passwort wurde erfolgreich ge\xE4ndert. Beim n\xE4chsten Login bitte ber\xFCcksichtigen!" } }, "time": { "text": "Bitte w\xE4hle einen Zeitraum, in dem {name}\xA0noch verf\xFCgbar ist:", "error_overlap": "Die gew\xE4hlte Zeit \xFCberschneidet sich mit den bereits vorhandenen Diensten.", "error_unavailable": "Zeitweise einplanen ist momentan nicht m\xF6glich, da Mitarbeiter nicht verf\xFCgbar ist." }, "response": { "items": "eingeplanten Dienst|eingeplanten Diensten", "users": "Mitarbeiter|Mitarbeitern" }, "reports": { "hint": "z.B. Best\xE4tigte Stunden aller Mitarbeiter" }, "jobs": { "hint": "z.B. Manager on Duty", "delete_related": "Die Besch\xE4ftigung kann nicht gel\xF6scht werden, da sie mit :text verbunden ist." }, "users": { "step1": [], "step2": [], "step3": { "text": "W\xE4hle hier die Dienste aus, die <b>{fname}</b> ausf\xFChren darf:" }, "step4": { "text": "M\xF6chtest du, dass sich <b>{name}</b> am Dienstplan anmelden kann?", "label": { "access_yes": "Ja, {fname} soll pers\xF6nliche Zugangsdaten erhalten", "access_no": "Nein, {fname} ben\xF6tigt keinen Zugriff" }, "help": "Hilfe zu dieser Einstellung", "help_text": ["In der Regel sollten Mitarbeiter eigene Zugangsdaten erhalten. Somit k\xF6nnen sie sich anmelden, den aktuellen Dienstplan einsehen und  weitere Aktionen (je nach eingestellten Rechten) selbstst\xE4ndig ausf\xFChren.", "Mitarbeiter ohne Zugriff k\xF6nnen den Dienstplan nur als Ausdruck oder per E-Mail einsehen.", "Du kannst diese Einstellung jederzeit sp\xE4ter \xE4ndern."] }, "step5": { "text": "Wie lautet die E-Mail Adresse von <b>{name}<\/b>?", "info": "An diese Adresse wird die pers\xF6nliche Einladung an {name} gesendet.", "blueprint": "Die Blaupause f\xFCr neue Mitarbeiter ist aktiv! Die Einstellungen werden automatisch angewendet.", "success": "<b>{name} wurde erfolgreich hinzugef\xFCgt!</b><br>{fname} kann ab sofort eingeplant werden.", "success_verification": "<b>{name} wurde erfolgreich eingeladen!<\/b><br>{fname} kann ab sofort eingeplant werden." }, "delete_holder": "<b>{name}</b> kann nicht gel\xF6scht werden, da sonst keiner mehr den Account verwaltet." }, "contracts": { "delete": { "headline": "Vertrag l\xF6schen" }, "alternating": "gerade\/ungerade Wochen anders", "notes": { "days_fixed": "Volle Urlaubstage werden mit der Anzahl der Stunden in der obigen Tabelle angerechnet. Teilurlaube werden nach Stundenanzahl angerechnet.", "days_flex": "Gearbeitete Stunden werden w\xF6chentlich mit Urlaub aufgef\xFCllt bis zum Maximum der Vertragsstunden. Ein Urlaubstag wird bis zu maximal {hours} Stunden angerechnet.", "holidays": "Feiertage, die auf Arbeitstagen fallen, werden mit der in der obigen Tabelle angegebenen Stundenzahl angerechnet." } }, "download": { "headline": "Verf\xFCgbare Felder", "fields": { "fname": "Vorname", "lname": "Nachname", "email": "E-Mail", "mobile": "Mobiltelefon", "status": "Status", "date": "Datum", "from": "Von", "until": "Bis", "break": "Pause", "total": "Gesamt", "overtime": "+\/-", "rate": "Stundenlohn", "expenses_amount": "Anzahl der km", "expenses_compensation": "Verg\xFCtung pro km", "expenses_travel": "Reisekosten", "expenses": "Ausgaben", "sickness": "Krankheit", "employee_number": "Personalnummer", "birthday": "Geburtstag", "duty": "Funktion", "location": "Ort", "created_at": "Erstellt am", "approved_at": "Genehmigt am", "approved_by": "Genehmigt von", "expenses_other": "Weitere Ausgaben", "salary": "Lohn" }, "text": "W\xE4hlen Sie die Felder aus, die Sie in Ihrer heruntergeladenen Datei sehen m\xF6chten", "success": { "headline": "Download", "text": "Ihr Download ist gestartet" } }, "revenues": { "headline": "Umsatz am" }, "employees": { "note": "Der Mitarbeiter wird nicht sofort eingeladen. Du kannst auf der n\xE4chsten Seite erst alle Einstellungen anwenden und dann die Einladung verschicken.", "edit": "Achtung! Die ausgew\xE4hlten Einstellungen werden auf alle {amount} ausgew\xE4hlten Mitarbeiter angewendet!" }, "defaultavailability": { "delete": { "headline": "Standard Verf\xFCgbarkeit l\xF6schen", "confirm": "M\xF6chten Sie die Standard Verf\xFCgbarkeit wirklich l\xF6schen?" } }, "help": { "line1": "<b>Hast du eine Frage zur Lohnabrechnung oder deinem Dienstplan?<\/b><br>Nimm dann Kontakt auf mit deinem Teamleiter oder Arbeitgeber.<br><br><b>Hast du eine Frage zur Funktionsweise von ONDURO?<\/b><br>", "line2": "Antworten auf h\xE4ufig gestellte Fragen findest du in der <a href=\"#\" class=\"toggle-university\">University</a>!<br><br><b>Noch Fragen offen? Oder ander Fragen bez\xFCglich ONDURO?</b><br>", "line3": "Schicke uns dann eine Nachricht via <a href=\"mailto:support@onduro.com\">E-mail</a>.<br><br><small style=\"line-height: 1;color: #888;\">Wir bem\xFChen uns am gleichen Arbeitstag zu antworten. Manchmal kann es auch etwas l\xE4nger dauern weil wir z.B. gerade neue Features bauen oder Trainings geben f\xFCr neue Kunden.</small>" }, "add_hours": { "overlap": "Die Stunden \xFCberschneiden sich mit Diensten oder bereits eingetragenen Stunden. Dennoch hinzuf\xFCgen?" }, "clients": { "delete": { "confirm": "M\xF6chtest du diesen Kunden wirklich l\xF6schen? Alle verbundenen Dienstpl\xE4ne werden deaktiviert.", "headline": "Kunde l\xF6schen" } }, "plannings": { "ERR_DATES": { "confirm": "M\xF6chtest du die Daten wirklich \xE4ndern? Alle geplanten Elemente au\xDFerhalb der neuen Daten werden gel\xF6scht. Fortsetzen?" } }, "timechooser": { "not_plannable": "In diesem Zeitraum ist {name} am {date} <u><b>nicht<\/b><\/u> planbar:" }, "resources": { "step2": { "text": "Verkn\xFCpfen Ressourcen an die Funktion <b>{name}</b>." }, "planning": "Weise Betriebsmittel dem Dienstplan <b>{name}<\/b> zu." }, "assign_locations": { "headline": "Dienstpl\xE4ne verkn\xFCpfen" }, "signature": { "error": "Unterschrift und Name des Unterzeichners sind Pflichtfelder." } }, "validation": { "length": "zu kurz", "number": "keine Zahl vorhanden", "spaces": "keine Leerzeichen verwenden", "invalid_character": "ung\xFCltiges Zeichen", "required": "Muss ausgef\xFCllt sein.", "email": "Ung\xFCltiges E-Mail Format." }, "frontend": { "terms": "Nutzungsbedingungen", "legal": "Kontakt & Support", "privacy": "Datenschutz", "nav": { "functions": "Funktionen", "faq": "FAQ", "pricing": "Preise", "register": "Registrieren", "signin": "Login" }, "login": { "signin": { "headline": "Login", "forgot_password": "Passwort vergessen?", "submit": "Anmelden", "error": "Login nicht m\xF6glich. Bitte pr\xFCfe deine Eingabe.", "modal": { "headline": "Login fehlgeschlagen", "text": "Deine E-Mail Adresse ist noch nicht best\xE4tigt. Falls du die E-Mail mit dem Best\xE4tigungslink nicht erhalten hast, sieh bitte in deinem Spamordner nach oder lasse dir die E-Mail <a href=\"{href}\">erneut zusenden</a>.", "error": "Noch nicht best\xE4tigt." }, "throttle": { "headline": "Login fehlgeschlagen", "text": "Zu viele Loginversuche. Bitte versuche es noch einmal in ein paar Minuten." }, "hint": "Du musst dich zuerst anmelden.", "user_inactive": "Du hast keine aktives Nutzerkonto. Nehme bei Fragen hierzu Kontakt auf mit dem Kontoinhaber." }, "password": { "headline": "Passwort zur\xFCcksetzen", "text": "Bitte gib deine E-Mail Adresse ein, mit der du dich registriert hast. Du erh\xE4ltst dann weitere Informationen zum Erstellen deines neuen Passworts.", "success": "Bitte pr\xFCfe dein E-Mail Postfach!", "error": "Kein Nutzer mit dieser E-Mail Adresse registriert." }, "confirm": { "headline": "E-Mail Adresse best\xE4tigt", "text": "Wir haben dich gleich eingeloggt!", "back": "Los geht's" }, "accept": { "headline": "Einladung verifizieren", "text": "Einen kleinen Moment noch...", "back": "Los geht's" }, "confirm_fail": { "headline": "Best\xE4tigung fehlgeschlagen", "list": ["Hast du deine E-Mail Adresse bereits best\xE4tigt? Dann versuche bitte zun\xE4chst einmal dich <a href=\"{href}\">anzumelden</a>.", "Kopiere den Best\xE4tigungslink aus der E-Mail manuell per Copy &amp; Paste in die Adressleiste deines Browsers.", "Falls dies alles nicht hilft, fordere einen neuen <a href=\"{href}\">Best\xE4tigungslink</a> an"], "back": "zum Login" }, "confirmation": { "headline": "Best\xE4tigungscode anfordern", "text": "Bitte gib deine E-Mail Adresse ein, die du bei der Registrierung verwendet hast. Du erh\xE4ltst dann erneut eine E-Mail mit einem Best\xE4tigungslink.", "success": "Bitte pr\xFCfe dein E-Mail Postfach!", "error": "Kein Nutzer mit dieser E-Mail Adresse registriert." }, "reset": { "headline": "Passwort zur\xFCcksetzen", "text": "Bitte w\xE4hle ein neues Passwort:<ul><li>mindestens 8 Zeichen</li><li>inklusive Ziffern (0-9)</li><li>Klein- und Gro\xDFbuchstaben</li></ul>", "success": "Dein Passwort wurde erfolgreich ge\xE4ndert.", "error": "Der Code zum Zur\xFCcksetzen des Passworts konnte nicht identifiziert werden." }, "reset_fail": { "headline": "Passwort zur\xFCcksetzen fehlgeschlagen", "text": "Der Code zum Zur\xFCcksetzen deines Passworts ist abgelaufen, ung\xFCltig oder wurde bereits verwendet. Bitte pr\xFCfe die URL oder fordere einen <a href=\"{href}\">neuen Code</a> an.", "back": "zum Login" }, "signup": { "headline": "Account erstellen", "welcome": "Sch\xF6n, dass du 30 Tage gratis testen willst!", "note": "Hiermit erstellst du einen neuen Account f\xFCr deine Firma. Hast du schon Logindaten und willst nur einloggen? Gehe dann zum <a href=\"{href}\">Login</a>.", "text": "Bitte w\xE4hle dein pers\xF6nliches Passwort:", "help": "<b>Aufgepasst!</b> Ein sicheres Passwort enth\xE4lt mindestens 8 Zeichen bestehend aus Gro\xDF-, Kleinbuchstaben und Ziffern.", "password": "Gib hier ein Passwort ein", "password_confirm": "Wiederhole das Passwort", "submit": "Account erstellen", "success": "Du hast dich erfolgreich registriert und kannst dich ab sofort mit deiner E-Mail Adresse und deinem Passwort anmelden.", "accepted": "Du hast die Einladung erfolgreich akzeptiert und kannst dich mit deinem bestehenden Login anmelden.", "error": "Der Code f\xFCr die Registrierung konnte nicht identifiziert werden." }, "signup_fail": { "headline": "Registrierung fehlgeschlagen", "text": ["Der Code f\xFCr deine Registrierung ist ung\xFCltig, abgelaufen oder wurde bereits verwendet.", "Bitte fordere vom Kontoinhaber einen neuen Code an."], "back": "zum Login" }, "accept_fail": { "headline": "Einladung fehlgeschlagen", "text": "Der Code f\xFCr die Einladung ist abgelaufen, ung\xFCltig oder wurde bereits verwendet. Bitte fordere beim Kontoinhaber eine neue Einladung an." }, "password_reset": { "error": "Du hast noch kein Passwort. Bitte schlie\xDFe erst die Registrierung deines Nutzerkontos ab. Klicke dazu den Link in deiner Registrierungs-E-mail an." } }, "registration": { "defaults": { "account": "Firmenname", "location": "Hauptstandort", "contract": "Flexible Zeiten", "cost": "Allgemeine Kosten", "shifts": { "F": "Fr\xFCh", "M": "Mittag", "S": "Sp\xE4t" } }, "terms": "Ich akzeptiere die <a href=\"https://www.onduro.com/de/nutzungsbedingungen\" target=\"_blank\">Nutzungsbedingungen</a> und die <a href=\"https://www.onduro.com/de/privacy\" target=\"_blank\">Datenschutzerkl\xE4rung</a>.", "error_general": "Der Account kann momentan nicht angelegt werden. Bitte versuche es sp\xE4ter noch einmal.", "error_already_registered": "Du hast bereits einen Account bei ONDURO. M\xF6chtest du wirklich einen neuen Account anlegen?", "error_not_verified": "Deine E-Mail Adresse ist noch nicht verifiziert. M\xF6chtest du noch einmal eine E-Mail mit dem Verifizierungscode erhalten?", "done": { "headline": "Du hast Post!", "text": "Bitte klicke auf den Best\xE4tigungslink in der E-Mail, die wir dir gerade gesendet haben.", "notice": "PS: Sieh auch in deinem Spamordner nach!", "back": "zur\xFCck zur Homepage" }, "terms_owner": "Ich akzeptiere im Namen von {company} die <a href=\"https://www.onduro.com/de/nutzungsbedingungen\" target=\"_blank\">Nutzungsbedingungen</a>, die <a href=\"https://www.onduro.com/de/dpa\" target=\"_blank\">Datenverarbeitervereinbarung</a> und die <a href=\"https://www.onduro.com/de/privacy\" target=\"_blank\">Datenschutzerkl\xE4rung</a> und bin hierzu befugt." } }, "wizard": { "help": "Hilfe n\xF6tig?<br>Klick mich!", "nav": { "1": "Willkommen", "2": "Dein Konto", "3": "Unternehmen", "4": "Mitarbeiter", "5": "Funktionen", "6": "Module" }, "back": "zur\xFCck", "next": "weiter", "later": "Mach ich sp\xE4ter", "conclude": "weiter", "step1": { "headline": "Willkommen", "text": ["Wir richten jetzt deinen Dienstplan ein!", "Wenn du Fragen hast oder Hilfe brauchst,<br>klicke auf das Foto oben links."], "submit": "Los geht's", "later": "Jetzt nicht, ich mach das sp\xE4ter!" }, "step2": { "headline": "Dein Konto", "note": "Du hast schon ein Passwort f\xFCr ONDURO, du brauchst darum kein neues zu w\xE4hlen.", "password": { "label": "W\xE4hle ein Passwort", "placeholder": "mind. 6 Buchstaben und Ziffern" } }, "step3": { "headline": "Das Unternehmen", "company": { "label": "Wie hei\xDFt das Unternehmen?", "placeholder": "Firmenname" }, "branch": { "label": "In welcher Branche arbeitest du?", "options": { "gastronomy": "Gastronomie", "retail": "Retail", "healthcare": "Gesundheit", "other": "Sonstige" } } }, "step4": { "headline": "Mitarbeiter", "employees": { "label": "Wen m\xF6chtest du einplanen?", "placeholder": "Lars Schmidt, Maike Koch, Hans Peters, Anne Fischer" }, "hint": ["F\xFCge einen Namen pro Zeile ein oder getrennt durch Kommas.", "Du kannst auch sp\xE4ter noch Mitarbeiter hinzuf\xFCgen."] }, "step5": { "headline": "Funktionen", "duties": { "label": "Welche Funktionen gibt es bei {name}?", "placeholder": "Bar, K\xFCche, B\xFCro" }, "hint": ["F\xFCge eine Funktion pro Zeile ein oder getrennt durch Kommas.", "Du kannst auch sp\xE4ter noch Dienste hinzuf\xFCgen."] }, "step6": { "headline": "T\xE4tigkeiten", "text": "Welcher Mitarbeiter kann welche Funktion aus\xFCben?" }, "step7": { "headline": "Module", "text": ["Aktiviere hier alle Module, die du brauchst.", "Es werden <u>keine</u> weiteren Kosten f\xFCr Module berechnet."], "shifts": { "label": "Schichtplanung", "hint": "arbeite mit Schichten, z.B. \"Abend\" von 18:00 - 00:00" }, "hours": { "label": "Stundenerfassung & -auswertung", "hint": "lass Mitarbeiter Stunden eintragen und erstelle<br>ganz einfach \xFCbersichtliche Auswertungen" }, "availability": { "label": "Verf\xFCgbarkeit", "hint": "lass Mitarbeiter ihre Verf\xFCgbarkeit eintragen" } }, "step8": { "headline": "Fertig!", "text": ["Das war einfach, oder?", "Wenn du noch Fragen hast, schreib uns an:"], "submit": "Zu ONDURO", "flash": { "headline": "Willkommen, {name}!", "text": "<p>Du kannst jetzt gleich loslegen. Ziehe den Namen eines Mitarbeiters aus der rechten Spalte in den Dienstplan. Klicke anschlie\xDFend darauf um Zeiten hinzuzuf\xFCgen.</p><strong>Viel Spa\xDF mit ONDURO!</strong><small>Tip: Auf der Startseite haben wir noch ein paar Infos f\xFCr dich bereitgestellt.</small>" } } }, "tools": { "remove_item": { "text": "Willst du diesen Dienst wirklich l\xF6schen?", "headline": "Dienst l\xF6schen" } }, "notification": { "message_added": "Deine Nachricht wurde hinzugef\xFCgt!" }, "conflict": { "INVALID_DUTY": "Funktion ist (nicht mehr) g\xFCltig", "INVALID_SHIFT": "Schicht ist (nicht mehr) g\xFCltig", "INVALID_USER": "Mitarbeiter ist nicht planbar", "AVAILABILITY": "Mitarbeiter ist nicht verf\xFCgbar", "ERR_OVERLAP": "Dieser Dienst \xFCberschneidet sich mit einem anderen Dienst dieses Mitarbeiter", "ERR_EXISTING_FULL": "Dieser Mitarbeiter ist bereits eingeplant heute", "ERR_HOURS": "Es wurden bereits Stunden eingetragen f\xFCr diesen Dienst", "ERR_CONFIRMED": "Die vom Mitarbeiter eingetragene Dienstzeit wurde bereits best\xE4tigt", "message": "Bitte l\xF6se die folgenden Konflikte:", "NO_DUTY_SET": "Dieser Dienst ben\xF6tigt eine Funktion", "ERR_OVERLAP_REST": "Dieser Dienst \xFCberschneidet sich mit der Ruhezeit dieses Mitarbeiters" }, "meta": { "description": "ONDURO Loginseite" }, "onboarding": { "intro": ["Lass uns zusammen das meiste aus ONDURO herausholen.", "Das machen wir auf zwei Arten:"], "university": "In der University lernst du alles \xFCber ONDURO.<br>Schritt f\xFCr Schritt, in deinem Tempo.<br>Klick auf das Bild oben um zu starten.", "support": "Hast du noch Fragen?<br>Nehme dann Kontakt mit uns auf.<br>\xDCber den \"Hilfe\" Link oben rechts.", "cancel": "Nein danke, ich find's selbst raus.", "disable": { "headline": "Einf\xFChrung \xFCberspringen?", "text": "Du kannst jederzeit wieder zur University zur\xFCckkehren. Den Link findest du in der Navigation. Willst du die Einf\xFChrung jetzt ausschalten?" }, "loggedinas": "Momentan eingeloggt als:", "self": "das bist du", "switch": "Willst du sehen wie ein anderer Mitarbeiter ONDURO sieht? Klicke auf die folgenden Links um zwischen den Rollen zu wechseln.", "switch_to": "Wechseln zu:", "own_staff": "M\xF6chtest du deine eigenen Mitarbeiter importieren?", "get_in_touch": "Nimm via die Hilfefunktion oben Kontakt mit uns auf!", "role_manager": "Ein Manager kann fast alles, was der Kontoinhaber auch kann. Au\xDFer das Abonnement verwalten.", "role_planner": "Ein Dienstplaner darf den Dienstplan erstellen und andere Mitarbeiter einplanen.", "role_supervisor": "Als Stundenaufseher kannst du eingetragene Stunden deiner Mitarbeiter genehmigen oder ablehnen.", "role_user": "Mitarbeiter oder externe Freelancer k\xF6nnen haupts\xE4chlich Verf\xFCgbarkeiten eintragen, Dienstpl\xE4ne ansehen und Stunden eintragen.", "next_steps": "Wie geht's weiter?" }, "university": { "minified": "Zur\xFCck zur University...", "lets_begin": "Los geht's!", "headline": "Was m\xF6chtest du gerne lernen?", "no_lessons": "Keine Lektionen vorhanden f\xFCr diese Seite oder Suche.", "lesson": { "related": "Verwandte Themen", "try": "Selbst kurz probieren" }, "show_all": "Alle Lektionen anzeigen." }, "confirm": { "legal": { "statement": ["Ich, <b>{name}</b>, erkl\xE4re hiermit, dass ich", "die obenstehenden Bedingungen vollst\xE4ndig gelesen und verstanden habe; und", "diese akzeptiere namens <b>{company}<\/b>; und", "hierzu rechtlich befugt bin."], "too_small": "Dein Ger\xE4t ist zu klein, um dieses wichtige Dokument anzuzeigen. Verwende bitte deinen Computer.", "scroll_notice": "Achtung: das folgende Dokument kann gescrollt werden." }, "chat": { "delete": { "headline": "Sicher?", "text": "Danach wirst du keine Nachrichten in diesem Chat mehr sehen k\xF6nnen" } }, "resting": { "conflict": "Diese \xC4nderung steht im Konflikt mit der Ruhezeit f\xFCr {name}. Trotzdem ausf\xFChren?" } }, "tooltip": { "roster": { "notes": "F\xFCge weitere Informationen f\xFCr alle Dienste an diesem Tag hinzu. Der eingegebene Text wird mit den Diensten im Dienstplan angezeigt.", "tools": { "notes": "F\xFCge weitere Informationen f\xFCr diesen Dienst hinzu. Der eingegebene Text wird mit dem Dienst im Dienstplan angezeigt." }, "tab": { "all": "vom ausgew\xE4hlten Dienstplan" }, "internal": "Interne Notizen. Nicht f\xFCr Mitarbeiter sichtbar. Gebe Informationen f\xFCr die Auswertung ein, z. B. Auftragsnummer usw." }, "reports": { "labels": "Filtere den Status auf \"best\xE4tigt\" um Labels hinzuzuf\xFCgen." }, "contracts": { "days": { "flex": "Diese Informationen wird ONDURO zur Berechnung der Verg\xFCtung an Urlaubstagen verwenden.", "fixed": "Diese Informationen wird ONDURO zur Berechnung der Verg\xFCtung f\xFCr Urlaub und Feiertagen (an Werktagen) verwenden." } }, "date_info": "Du kannst in der Datumsauswahl auf die Jahreszahl klicken, um das Jahr schnell zu \xE4ndern.", "balance": { "holiday": "wird zum Saldo hinzugef\xFCgt f\xFCr jeden aktiven Feiertag an dem Mitarbeiter nicht arbeitet (bis max. die w\xF6chentliche Stundenzahl)", "holiday_always": "Stunden an Feiertagen immer hinzuf\xFCgen zum Stundensaldo (auch wenn der Arbeitnehmer hierdurch \xFCber seine Wochenstunden kommt)." }, "calculations": { "totals": "Hier werden die Gesamtsummen der ausgew\xE4hlten Woche \xFCber alle Dienstpl\xE4ne hinweg angezeigt.", "period": "W\xE4hle hier oder klicke auf ein Datum im Dienstplan, um den Zeitraum zu \xE4ndern." }, "beta": "Beta-Funktionalit\xE4t. Mit Vorsicht verwenden. Feedback willkommen!", "hours_per_week": "Stunden pro Woche" }, "soon": { "contracts": "Vertragsmanagement coming soon..." }, "button": { "reset_filters": "Filter zur\xFCcksetzen", "add_contract": "Vertrag hinzuf\xFCgen", "manage_plannings": "Dienstpl\xE4ne verwalten", "refresh": "Aktualisieren" }, "todo": { "invite": "Mitarbeiter einladen", "contract": "Vertrag zuweisen", "duty": "Funktion(en) zuweisen", "salary": "Gehalt festlegen", "profile": "F\xFClle die Pflichtfelder aus", "profile_employee": "Mitarbeiter hat Profil nicht vollst\xE4ndig ausgef\xFCllt", "contract_incomplete": "Vertrag unvollst\xE4ndig (erfordert: Datum, unterzeichneter Vertrag, Gehalt)", "certificates_expire": "Zertifikate sind abgelaufen" }, "folder": { "payslips": "Lohnabrechnungen", "sepa": "SEPA Dateien", "contracts": "Vertr\xE4ge", "uploads": "Benutzeruploads", "journals": "Lohnjournale", "annuals": "Andere", "others": "Weitere Dokumente", "others_description": "(Lohnsteuerbescheinigung, Meldungen zur Sozialversicherung, andere Dokumente)", "attendance_roster": "Attendance & Dienstplan" }, "cards": { "items": { "open": { "headline": "Offene Dienste" }, "applications": { "headline": "Bewerbungen" }, "no_open_duties": "Es gibt keine offenen Dienste", "no_open_applications": "Es gibt keine offenen Bewerbungen" } }, "warning": { "registration_incomplete": "Mitarbeiterregistrierung nicht vollst\xE4ndig!", "item_with_applications": "Dieser Dienst hat bereits Bewerber! Um ihn zu \xE4ndern, l\xF6schen ihn und erstellen einen neuen Dienst." }, "sko": { "malta": { "tk": ["Wenn du keine Versicherung hast, kannst du direkt", "hier eine bei der TK beantragen", "oder ein", "PDF mit weiteren Informationen herunterladen"] } }, "freelancer": "Selbstst\xE4ndig", "filter": { "date": { "this_month": "Diesen Monat", "last_month": "Letzter Monat", "this_quarter": "Dieses Quartal", "this_year": "Dieses Jahr", "last_year": "Letztes Jahr", "last_quarter": "Letztes Quartal" } }, "invoicesTable": { "invoice_number": "Rechnungsnummer", "date": "Datum", "total": "Gesamtbetrag", "freelancer": "Name Freelancer", "notFound": "Keine Rechnungen gefunden" }, "input": { "freelancer": { "autoInvoice": "Automatische Rechnungsstellung aktivieren?", "shiftVat": "Reverse-Charge-Verfahren" } }, "settings": { "invoices": "Rechnungen" }, "invoicing_interval": "Einstellung der Rechnungsstellung", "modules": { "descriptions": { "pro": "Das Projektmodul erm\xF6glicht eine effiziente Verwaltung und Nachverfolgung von Projekten. Benutzer k\xF6nnen Projekte mit Kundeninfos, Standort, Budget, Zeitplanung und Rechnungen erstellen und aktualisieren. Es unterst\xFCtzt die Aufgabenverteilung, Zeiterfassung und Reisekostenverwaltung. Durch automatische Planung und Echtzeit-Updates wird eine reibungslose Umsetzung sichergestellt." } } };/* harmony default export */ __webpack_exports__["default"] = (locales);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var locales = { "layout": { "subnav": { "settings": { "general": "Algemeen", "locations": "Planningen", "jobs": "Functies", "duties": "Functies", "shifts": "Shifts", "availability": "Beschikbaarheid", "costs": "Kostenplaatsen", "rates": "Uurlonen", "premiums": "Toeslagen", "workspaces": "Werkplekken", "tags": "Tags", "holidays": "Feestdagen" } }, "header": { "help": "Hulp", "overview": "Welkom!", "contacts": "Adresboek", "hours": "Uren registratie", "reports": "Rapportages", "profile": "Jouw profiel" }, "calendar": { "roster": { "headline": "Gepubliceerd t\/m" }, "reports": { "headline": "Kies de einddatum van je factuurperiode." }, "mon": "MA", "tue": "DI", "wed": "WO", "thu": "DO", "fri": "VR", "sat": "ZA", "sun": "ZO" }, "footer": { "info": "Wijzigingen nog niet opgeslagen.", "save": "Wijzigingen opslaan", "cancel": "Terugzetten", "saveWithDate": "Wijziging per datum" } }, "route": { "overview": { "path": "overzicht", "name": "Overzicht" }, "roster": { "path": "rooster", "name": "Rooster" }, "lists": { "path": "lijsten", "name": "Lijsten" }, "availability": { "path": "beschikbaarheid", "name": "Beschikbaarheid" }, "contacts": { "path": "adresboek", "name": "Adresboek" }, "chats": { "path": "berichten", "name": "Berichten", "details": { "name": "Berichten", "path": "berichten\/:channel" } }, "hours": { "path": "urenregistratie", "name": "Urenregistratie", "page": { "path": "urenregistratie\/:page", "name": "Urenregistratie" } }, "reports": { "path": "rapportage", "name": "Rapportage" }, "team": { "path": "werknemers", "name": "Werknemers", "edit": { "name": "Werknemers", "path": "werknemers\/:id" } }, "profile": { "path": "profiel", "name": "Profiel" }, "settings": { "path": "instellingen", "name": "Instellingen", "general": { "path": "instellingen\/algemeen", "name": "Algemeen" }, "availability": { "path": "instellingen\/beschikbaarheid", "name": "Beschikbaarheid" }, "duties": { "path": "instellingen\/functies", "name": "Functies" }, "holidays": { "path": "instellingen\/feestdagen", "name": "Feestdagen" }, "locations": { "path": "instellingen\/locaties", "name": "Planningen" }, "premiums": { "path": "instellingen\/toeslagen", "name": "Toeslagen" }, "rates": { "path": "instellingen\/uurlonen", "name": "Uurlonen" }, "shifts": { "path": "instellingen\/shifts", "name": "Shifts" }, "expenses": { "name": "Onkosten", "path": "instellingen\/onkosten" }, "costs": { "name": "Kostenplaatsen", "path": "instellingen\/kostenplaatsen" }, "tags": { "name": "Tags", "path": "instellingen\/tags" }, "vacation": { "name": "Verlof", "path": "instellingen\/verlof" }, "contracts": { "name": "Contract templates", "path": "instellingen\/contracten" }, "advanced": { "path": "instellingen\/geavanceerd", "name": "Geavanceerd" }, "checkin": { "name": "Check-in", "path": "instellingen\/check-in" }, "settings": { "path": "instellingen\/bedrijfspagina", "name": "Bedrijfspagina" }, "company": { "name": "Bedrijfspagina", "path": "instellingen\/bedrijfspagina" }, "invoice": { "name": "Facturen" } }, "modules": { "path": "modules", "name": "Modules" }, "notifications": { "name": "Notificaties", "path": "notificaties" }, "projects": { "name": "Opdrachten", "path": "opdrachten", "edit": { "path": "opdrachten\/:id" } }, "login": { "accept": { "path": "login\/uitnodiging-accepteren\/:code", "name": "Uitnodiging acceptere" }, "confirm": { "path": "login\/email-bevestigen\/:code\/:account?", "name": "E-mail bevestigen" }, "confirmation": { "path": "login\/bevestigingscode-aanvragen", "name": "Bevestigingscode aanvragen" }, "password": { "path": "login\/wachtwoord-vergeten", "name": "Wachtwoord vergeten" }, "reset": { "path": "login\/wachtwoord-opnieuw-instellen\/:code", "name": "Wachtwoord opnieuw instellen" }, "signin": { "path": "login\/aanmelden", "name": "Aanmelden" }, "signup": { "path": "login\/registreren\/:code", "name": "Registreren" } }, "clients": { "name": "Klanten", "path": "klanten", "edit": { "path": "klanten\/:id" } }, "balances": { "name": "Tijd-voor-tijd", "path": "tijd-voor-tijd", "details": { "name": "Tijd-voor-tijd", "path": "tijd-voor-tijd\/:id" } }, "register": { "path": "registreren", "name": "Account aanmaken" }, "welcome": { "name": "Welkom", "path": "welkom" }, "terms": { "name": "Gebruiksvoorwaarden", "path": "gebruiksvoorwaarden" }, "privacy": { "name": "Privacyverklaring", "path": "privacy" }, "legal": { "name": "Contact & Support", "path": "contact" }, "wizard": { "start": { "name": "Wizard", "path": "wizard\/start\/:id\/:token" }, "step": { "name": "Wizard", "path": "wizard\/step" }, "name": "Wizard", "path": "wizard" }, "subscription": { "name": "Accountbeheer", "path": "abonnement", "confirm": { "path": "abonnement\/bevestigen" } }, "invoice": { "path": "factuur\/:id" }, "vacation": { "name": "Verlof", "path": "verlof", "new": { "name": "Verlof aanvragen", "path": "verlof\/nieuw" }, "details": { "path": "verlof\/:id", "name": "Verlof" } }, "setup": { "name": "Setup", "path": "setup\/:id\/:token" }, "example": { "path": "example" }, "contact": { "name": "Contact", "path": "contact" }, "statistics": { "name": "Statistieken", "path": "statistieken" }, "dashboard": { "name": "Dashboard", "path": "dashboard\/:id\/:hash" }, "today": { "name": "Dagschema", "path": "vandaag" }, "planning": { "name": "Planning", "path": "planning" }, "dossiers": { "path": "werknemers\/:id\/dossiers" }, "payslips": { "name": "Loonstroken", "path": "loonstroken" }, "documents": { "name": "Documenten", "path": "documenten", "detail": { "name": "Documenten", "path": "documenten\/:type" } }, "checkins": { "name": "Check-ins", "path": "check-ins" }, "demo": { "path": "demo", "name": "Demo" }, "log": { "name": "Log", "path": "log" }, "plannings": { "path": "planning\/overzicht", "name": "Overzicht" }, "resources": { "name": "Bedrijfsmiddelen", "path": "middelen", "edit": { "path": "middelen\/:id", "name": "Bedrijfsmiddelen" } }, "company": { "name": "Bedrijfspagina", "path": "bedrijf" }, "2fa": { "setup": { "path": "login\/2fa\/inrichten", "name": "Twee-faktor authentificatie inrichten" }, "verify": { "path": "login\/2fa\/verifieren", "name": "Twee-faktor authentificatie" } }, "freelancer_invoices": { "name": "Facturen van Freelancers", "myInvoices": "Mijn facturen" }, "freelancer": { "name": "Freelancer Facturen", "path": "freelancer-facturen" } }, "common": { "status": { "account": { "free": "actief", "trial": "gratis proefperiode", "active": "abonnement actief", "expired": "proefperiode verlopen", "cancelled": "abonnement opgezegd", "deleted": "verwijderd", "license": "via Licentie" }, "membership": { "active": "geactiveerd", "inactive": "gedeactiveerd", "deleted": "verwijderd" }, "user": { "active": "geactiveerd", "inactive": "gedeactiveerd", "deactivate": "deactiveren", "activate": "activeren" }, "item": { "planned": "gepland", "open": "niet ingevuld", "pending": "onbevestigd", "approved": "bevestigd", "denied": "afgekeurd" } }, "placeholder": { "email": "jan@modaal.nl", "roster_name": "bijv. Caf\xE9 't Hoekje", "company": "bijv. Caf\xE9 't Hoekje Holding B.V.", "full_name": "Jan Modaal", "address": "bijv. Hoofdweg 38", "dd": "DD", "mm": "MM", "yyyy": "JJJJ", "vat": "NL123456789B01" }, "filter": { "user": "Medewerker", "duty": "Functie", "location": "Planning", "status": "Status" }, "availability": { "available": "beschikbaar", "unavailable": "niet beschikbaar", "vacation": "vakantie", "wish": "graag werken", "approved": "goedgekeurd", "denied": "geweigerd", "limited": "beperkt beschikbaar" }, "role": { "owner": "Accounthouder", "manager": "Beheerder", "planner": "Planner", "user": "Medewerker", "supervisor": "Urenbeheerder", "observer": "Waarnemer", "freelancer": "ZZP'er" }, "button": { "cancel": "annuleren", "submit": "Versturen", "okay": "OK", "save": "Opslaan", "delete": "Verwijderen", "invite": "medewerker uitnodigen", "reinvite": "Opnieuw Uitnodigen", "confirm": "Bevestigen", "decline": "Verwerpen", "send": "Versturen", "unsubscribe": "Opzeggen", "yes": "Ja", "add": "Toevoegen", "enroll": "Inschrijven", "agree": "Akkoord", "close": "Sluiten", "no": "Nee", "withdraw": "Uitschrijven", "continue": "Verder", "back": "Terug", "deny": "Afkeuren", "done": "Klaar", "logout": "Uitloggen", "next": "Verder", "reset": "Terugzetten", "remove": "verwijderen", "edit": "Bewerken", "complete": "Afronden", "download": "downloaden", "accept": "Accepteren", "show": "tonen", "changegravatar": "Profielfoto wijzigen", "apply": "Toepassen" }, "language": { "german": "Duits", "dutch": "Nederlands", "english": "Engels" }, "country": { "germany": "Duitsland", "netherlands": "Nederland", "usa": "VS" }, "modules": { "basic": "Basisrooster", "hours": "Urenregistratie", "availability": "Beschikbaarheid", "appointments": "Afspraaken", "shifts": "Shifts", "tags": "Tags", "rates": "Uurloon & onkosten", "balances": "Tijd voor tijd", "sickness": "Ziekte", "tentoo": "Tentoo Payroll", "lists": "Lijsten", "costs": "Kostenplaatsen", "chats": "Berichten", "temper": "Temper", "blueprint": "Blauwdruk", "weather": "Weer", "vacation": "Verlof", "dashboard": "Dashboard", "today": "Dagschema", "statistics": "Statistieken", "university": "University", "dossiers": "Dossiers", "contacts": "Adresboek", "planning": "Planning & rooster", "contracts": "Contractbeheer", "onboarding": "Onboarding", "nmbrs": "Nmbrs", "payslips": "Loonstroken", "documents": "Documenten", "checkins": "Check-ins", "clients": "Klanten", "resources": "Bedrijfsmiddelen", "calculations": "Berekeningen", "signature": "Urenstaat ondertekenen", "newsletter": "Nieuwsbrief", "company": "Bedrijf", "freelancers": "Factureren voor Freelancers", "projects": "Projecten" }, "nojs": { "headline": "Activeer JavaScript", "text": ["Om ONDURO te gebruiken moet JavaScript in je browser geactiveerd zijn.", "Zorg ervoor, dat geen andere programma's (zoals ad blockers, spam filters etc.) de toegang tot de website blokkeren."], "link": "Hoe activeer ik JavaScript?" }, "email": { "default_subject": "Nieuw bericht van ONDURO" }, "notify": { "success": { "headline": "Opgeslagen", "description": "De wijzigingen zijn succesvol opgeslagen." }, "delete": { "description": "Het item is succesvol verwijderd.", "headline": "Verwijderd" } }, "cut": "geknipt", "copied": "gekopieerd", "device": { "rotate": "Gelieve je scherm draaien om deze functie te gebruiken" }, "details": "Details", "link_copied": "Link gekopieerd naar klembord. Deze link is alleen voor deze werknemer PERSOONLIJK.", "text": { "businessNumber": "KvK nummer", "vatNumber": "BTW-ID" } }, "label": { "type": "Type", "name": "Naam", "location": "Planning", "hours": "Uren", "rate": "Uurloon", "amount": "Bedrag", "subtotal": "Subtotaal", "total": "Totaal", "distance": "Afstand", "euro": "\u20AC", "km": "km", "premium": "Toeslag", "until": "tot", "date": "Datum", "day": "Dag", "cost": "Kostenplaats", "begin": "Begin", "end": "Eind", "break": "Pauze", "filter": "Filter", "status": "Status", "expenses": "Onkosten", "description": "Omschrijving", "items": "Diensten", "overtime": "Overuren", "salutation": "Aanhef", "title": "Titel", "fname": "Voornaam", "lname": "Achternaam", "email": "E-mail", "email_new": "Nieuwe e-mail", "email_confirm": "E-mail herhalen", "password": "Wachtwoord", "password_old": "Oud wachtwoord", "password_new": "Nieuw wachtwoord", "password_confirm": "Wachtwoord herhalen", "company": "Bedrijfsnaam", "users": "Gebruiker", "icon": "Icon", "employee": "Medewerker", "employees": "medewerkers", "country": "Land", "language": "Taal", "role": "Rol", "access": "Toegang", "phone": "Telefoon", "mobile": "Mobiel", "fax": "Noodnummer", "address": "Adres", "zip": "Postcode", "city": "Plaats", "identifier": "Afkorting", "designation": "Naam", "color": "Kleur", "account_holder": "Accounthouder", "iban": "IBAN", "bic": "BIC", "time": "Tijd", "duration": "Duur", "payer": "Beheerder", "display": "Rooster weergave", "interval": "Periode", "quantity": "Aantal", "work_time": "Werktijden", "action": "Actie", "created_by": "Aangemaakt door", "weeks": "Weken", "minimum": "minstens", "tax_number": "Personeelsnummer", "full_name": "Je volledige naam", "rates": "Uurlonen", "premiums": "Toeslagen", "duties": "Functies", "salary": "Loon", "eur_per_km": "\u20AC per  km", "payroll": "Payroll", "sick_pay": "Loondoorbetaling", "sickness": "Ziekte", "balance": "Saldo", "previous": "vorig", "per_week": "per week", "begin_of_week": "begin van week", "fallback": "Standaard", "birthday": "Geboortedatum", "vat": "BTW nummer", "contacts": "Adresboek", "public": "openbaar", "private": "priv\xE9", "stats": { "planned": "gepland", "worked": "gewerkt", "revenue": "omzet", "costs": "kosten", "cost_revenue": "kosten\/omzet" }, "locations": "Planningen", "code": "Code", "days": "Dagen", "invoice": "Factuur", "client_number": "Klantnummer", "invoice_number": "Factuurnummer", "billing_period": "Factuurperiode", "until_including": "t\/m", "sorting": "Sortering", "vacation": "Verlof", "requested": "Aangevraagd", "availability": "Beschikbaarheid", "unit": "Eenheid", "requests": "Aanvragen", "pending": "onbevestigd", "plusmin": "af \/ bij", "dates": "Datum(s)", "request": "Aanvraag", "month": "maand", "week": "week", "min_hours": "Min.", "max_hours": "Max.", "print": "afdrukken", "moment": { "last": "vorige\/laatste", "current": "deze", "next": "volgende", "custom": "individueel" }, "year": "jaar", "factor": "Factor", "contact_list": "Contacten", "group": "Groep", "contract_management": "Contractbeheer", "contract_hours": "Contract uren", "profile": "Profiel", "settings": "Instellingen", "dossier": "Dossier", "contract_start": "Datum in-dienst", "contract_end": "Datum uit-dienst", "template": "Template", "payslips": "Loonstroken", "contract_full": "full-time", "contract_part": "part-time", "days_fixed": "Uren per dag", "days_flex": "Dagen per week", "contract_vacation": "Vakantiedagen", "file": "Bestand", "documents": "documenten", "fixed_salary": "vast salaris", "filetype": "Bestandstype", "creator": "Schepper", "hourly_salary": "uurloon", "roster": "Rooster", "filled": "Gevuld", "checkin": "Check-in", "submitted": "ingediend", "half_a_day": "halve dag", "hours_per_full_day": "uur per volle dag", "holiday": "Feestdag", "changed": "gewijzigd", "empty": "leeg", "fields": "velden", "client": "Klant", "start_date": "Begindatum", "end_date": "Einddatum", "plannings": "Planningen", "clients": "Klanten", "all_clients": "alle klanten", "budget": "Budget", "active": "actief", "inactive": "inactief", "archived": "gearchiveerd", "finished": "voltooid", "clear": "terugzetten", "comment": "Bericht", "published": "Gepubliceerd", "unpublished": "niet gepubliceerd", "signature": "Handtekening", "url": "URL", "newsletter": "Actuele nieuwsbrief", "newsletters_old": "vorige nieuwsbrieven", "my_profile": "Mijn Profiel", "internal_note": "Int. notitie", "visible": "zichtbaar", "invisible": "niet zichtbaar", "2fa": "2FA", "2fa_reset": "klik om 2FA te resetten", "2fa_required": "2FA vereist, maar niet ingesteld", "notes": "Notities", "invoice_email": "Factuur e-mail", "kvk_number": "KVK nummer", "quick_date_filter": "Filter snel op datum", "invoice_interval": "Interval factureren", "select_client": "Selecteer Klant", "project_code": "Projectcode", "draft": "Concept", "recurrence": "Herhalende diensten toevoegen", "recurrence_type": "Herhalingstype", "daily": "Dagelijks", "yearly": "Jaarlijks", "repeat_on": "Herhaal op", "project_name": "Projectnaam", "start_time": "Starttijd", "end_time": "Eindtijd", "projects": "Projecten", "all_day": "Hele dag", "the": "De", "first": "Eerste", "second": "Tweede", "third": "Derde", "fourth": "Vierde", "every": "Iedere", "last": "Laatste", "vat_percentage": "BTW-percentage", "location_data": "Locatie", "apply_premiums": "Toeslagen Toepassen", "select_premium": "Selecteer Toeslagen", "hourly_rate": "Uurtarief", "invoicing_interval": "Facturatie instelling", "invoicing_interval_weekly": "Automatisch facturen aan; Wekelijks factureren", "invoicing_interval_monthly": "Automatisch facturen aan; Maandelijks factureren", "invoicing_interval_manual": "Handmatig factureren", "create_new_duty": "Nieuwe functie aanmaken", "weekly_schedule": "Weekschema", "enable": "Aanzetten", "edit_project": { "details": "Details Gewijzigd Projectschema" }, "start_date_edit": "Wijzigingen toepassen vanaf", "start_date_edit_hint": "Alle diensten vanaf deze datum worden aangepast volgens het nieuwe schema. Diensten van voor de ingestelde datum blijven ongewijzigd.", "numberEmployees": "Aantal werknemers voor deze shift", "eur_per_minute": "\u20AC per minuut", "travel_allowance": "Reiskostenvergoeding toepassen", "driver": "Bestuurder", "passenger": "Passagier", "overwrite": "Overschrijven", "travel_expense_amount": "Bedrag Reiskostenvergoeding", "apply_after": "Toepassen na", "compensation_calc_method": "Eenheid vergoeding", "include": "Includeren", "deselect_all": "Alles deselecteren", "select_all": "Alles selecteren", "total_hours": "Totaal aantal uren", "total_cost": "Totale kosten", "planning": "Planning", "project_location": "Projectlocatie", "select_number_of_cars": "Selecteer het aantal bedrijfswagens per dienst dat nodig is voor deze dienst(en)", "override_rate": "Overschrijf ingestelde uurtarief", "person": "Persoon", "team_members": "Teamleden", "absence": "Verzuim\/Ziekte", "created_at": "Aangemaakt op", "register_absence": "Ziekmelden", "resource": "Selecteer bedrijfsmiddel", "required_capacity": "Vereiste capaciteit" }, "text": { "from": "van", "until": "tot", "open": "open", "users": "Medewerkers", "no_results": "geen resultaten", "sick": "ziek", "or": "of", "of": "van", "change": "wijzigen", "delete": "verwijder", "optional": "optioneel", "yes": "ja", "no": "nee", "mr": "Dhr.", "mrs": "Mvr.", "dr": "Dr.", "prof": "Prof.", "profdr": "Prof. Dr.", "location": "Planning", "contract": "Contract", "info": "Info", "duty": "Functie", "shift": "Shift", "account": "Account", "cost": "Kostenplaats", "workspace": "Werkplek", "owner": "Accounthouder", "manager": "Beheerder", "planner": "Planner", "user": "Gebruiker", "placeholder": "Open diensten", "placeholder_duties": "Open diensten", "placeholder_shifts": "Open shifts", "full_time": "Fulltime", "part_time": "Parttime", "flex_time": "Flexibel", "monthly": "maandelijks", "weekly": "wekelijks", "sunday": "Zondag", "monday": "Maandag", "release": "Publiceren", "released": "gepubliceerde", "week": "week", "calendar_week": "Weeknummer", "calendar_week_short": "WN", "today": "vandaag", "yesterday": "gisteren", "in": "in", "on": "op", "to": "naar", "since": "vanaf", "new": "Nieuw", "confirmed": "bevestigd", "unconfirmed": "onbevestigd", "denied": "afgekeurd", "approve": "bevestigen", "deny": "afkeuren", "total": "totaal", "himself": "zichzelf", "someone": "iemand", "previous": "eerder", "previous_period": "eerdere periode", "all": "alle", "filter": "filter", "deactivate": "deactiveren", "activate": "activeren", "expired": "onvoltooid", "page": "pagina", "saving": "opslaan", "more": "meer", "none": "geen", "instead_of": "i.p.v.", "base_salary": "Basissalaris", "empty": "(Nog) geen data beschikbaar", "tag": "Tag", "item": "Dienst", "sure": "Ben je zeker?", "more_options": "toon opties", "search": "Zoek naar...", "import": "importeren", "help": "Hulp", "days": "dagen", "day": "dag", "legend": "Legenda", "selection": { "more": "meer", "select": "selecteer", "all": "alle", "none": "geen", "displayed": "van de <u>gefilterde<\/u> opties", "selected": "geselecteerd", "select_all": "selecteer alles", "deselect_all": "deselecteer alles", "toggle": "selecteer\/deselecteer" }, "invited": "uitgenodigd", "hide_options": "opties verbergen", "month": ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"], "loading": "aan het laden...", "desc": "aflopend", "asc": "oplopend", "blueprint": "Blauwdruk", "hours": "uren", "daydays": "dag|dagen", "hrs": "uur", "changed": "gewijzigd", "unsaved": "wijziging niet opgeslagen|wijzigingen niet opgeslagen", "welcome": "Welkom", "attention": "Let op", "nowayback": "Dit kan niet ongedaan gemaakt worden. Weet je het echt zeker?", "current": "huidig", "dpa": "Verwerkersovereenkomst", "dpa_accept": "Ik accepteer versie 1.0 van de verwerkersovereenkomst namens {company} en ik ben hiertoe bevoegd.", "review": "Bekijk", "legal": { "not_signed": "Deze overeenkomst is nog niet geaccepteerd.", "signed": "Deze overeenkomst is op <b>{date}<\/b> geaccepteerd door <b>{name}<\/b>." }, "you": "Je", "per_employee": "per werknemer", "per_item": "per gewerkte dienst", "disapprove": "Weigeren", "colleagues": "Collega's", "billed_at": "gefactureerd op", "paid_at": "verloond op", "in_days": "over {days} dagen", "tomorrow": "morgen", "no_times": "zonder tijden", "labels": "Labels", "paid": "verloond", "billed": "gefactureerd", "options": "opties", "progress": "voortgang", "contract_salary": "Contract & Loon", "per": "per", "show_details": "toon details", "hide_details": "details verbergen", "fulltime": "full-time", "duration_permanent": "onbepaalde tijd", "duration_temporary": "bepaalde tijd", "pay_out": "vergoeden", "fixed": "Vast", "contract_days_fixed": "regelmatig", "contract_days_flex": "onregelmatig", "per_workday": "per werkdag", "contract_template": "Contractsjabloon", "message": "Bericht", "per_year": "per jaar", "signed_by_employee": "getekend door werknemer", "nothing": "Niks te zien hier...", "per_month": "per maand", "per_hour": "per uur", "generate": "genereren", "no_documents": "Geen documenten om te tonen.", "no_checkins": "Er zijn geen check-ins op dit moment.", "confirm_checkout_membership": "Weet je zeker dat je {name} wilt uitchecken?", "confirm_checkout": "Weet je zeker dat je wilt uitchecken? Je kan niet nog een keer inchecken voor deze dienst.", "checkin_successful": "Check-in succesful om {time} uur", "already_checked_in": "Je bent al ingecheckt sinds {time} uur", "checkin_successful_notice": "Je bent succesvol ingecheckt", "oclock": "{time} uur", "past-checkins": "Eerdere check-ins", "details": "Gegevens", "load_more": "Meer laden", "no_location_data": "Geen locatiegegevens beschikbaar", "previous_page": "vorige pagina", "next_page": "volgende pagina", "free": "vrij", "added_via": "Toegev. via", "rest_time": "Rusttijd", "rest": "Rust", "planning_type": { "ongoing": "doorlopend", "temporary": "tijdelijk" }, "conflict": "Conflict", "between_and": "tussen {start} en {end} uur", "per_duty": "per functie", "totals": "Totalen", "planned": "ingepland", "period": "Periode", "filters_active": "filters actief", "sign": "ondertekenen", "2fa_reset": "De gebruiker heeft twee-factor-authenticatie al succesvol ingesteld. Weet je zeker dat je twee-factor authenticatie voor deze gebruiker wilt terugzetten?", "minutes": "minuten", "tuesday": "Dinsdag", "wednesday": "Woensdag", "thursday": "Donderdag", "friday": "Vrijdag", "saturday": "Zaterdag", "hint": { "project_type": { "ongoing": "Voor projecten zonder vastgestelde einddatum. Shifts worden een jaar vooruit toegevoegd", "temporary": "Voor tijdelijke projecten, met een vastgestelde start- en einddatum" } }, "disable_project_grouping": "Groeperen per project uit", "enable_project_grouping": "Groeperen per project", "once": "Eenmalig", "default": "Standaard", "fixed_compensation": "Vaste vergoeding", "include_in_totals_tooltip": "Vink aan of uit om mee te nemen in totalen", "totals_only_selected_shifts": "Totalen worden alleen berekend voor geselecteerde diensten", "enter_date_after": "Voeg een datum toe na", "and_before": "en voor", "planning_selected_at_project_level": "Planning is geselecteerd op projectniveau", "project_details": "Projectdetails", "similar_items": "Anderen in dit project vandaag", "no_similar_items": "Geen andere teamleden die aan dit project werken" }, "page": { "team": { "headline": "Medewerkers", "registered": "geregistreerd", "invited": "uitgenodigd", "add": "Medewerker toevoegen", "delete": "Medewerker verwijderen", "delete_confirm": "Weet je zeker dat je deze medewerker wil verwijderen? Alle gegevens worden onherroepelijk verwijderd.", "saved": "Gegevens succesvol opgeslagen.", "activate_access": "Toegang activeren", "sidebar": { "general": "Algemeen", "text": "binnenkort beschikbaar...", "registered_since": "Geregistreerd sinds:", "last_online": "Laatst gezien:", "headline_duties": "Functies", "headline_locations": "Planningen", "tags_hint": "Klik in het vakje om een tag aan deze medewerker te koppelen. Tag niet gevonden? Hier kun je een <a href=\"{href}\">nieuwe tag toevoegen<\/a>.", "no_duty": "heeft nog geen functie!" }, "fieldset": { "personal_data": "Persoonlijke gegevens", "job": "Functie", "access": "Persoonlijke login", "contact": "Contactgegevens", "role": "Rollen", "rights": "Overige rechten", "costs": "Kostenplaatsen", "hours": "Urenregistratie", "availability": "Beschikbaarheid", "balance": "Tijd voor tijd" }, "availability": "Medewerker kan beschikbaarheid invullen", "availability_hint": "Kies hier welke beschikbaarheid standaard voor deze medewerker getoond wordt, als <b>{name}<\/b> (nog) geen beschikbaarheid opgegeven heeft.", "availability_options": ["is zonder opgave", "beschikbaar", "niet beschikbaar"], "balance": "Tijd-voor-tijd voor deze medewerker activeren", "hours": "Medewerker kan zelf uren opgeven", "on_cost_label": "op kostenplaats", "cost_hint": "Selecteer alle kostenplaatsen, waarin <b>:name</b> uren mag registreren. Als je er slechts \xE9\xE9n selecteert, hoeft de medewerker in de urenregistratie geen selectie te maken. Alle uren worden automatisch in de bijbehorende kostenplaats geregistreerd.", "cost_empty": "Er zijn nog geen kostenplaatsen aangemaakt! Maak nu een <a href=\"{href}\">kostenplaats aan<\/a>.", "data_locked": "Sommige reeds ingevulde persoonlijke gegevens kunnen alleen nog door de medewerker zelf in het profiel gewijzigd worden.", "not_verified": "<b>{name}<\/b> is succesvol uitgenodigd, maar heeft de registratie nog niet afgerond.", "not_accepted": "<b>:name<\/b> is succesvol uitgenodigd, maar heeft de uitnodiging nog niet geaccepteerd. Omdat :name al aan een ander account is gekoppeld kun je het e-mail adres (:email) voor de uitnodiging niet meer veranderen.", "no_access": "<b>:name<\/b> mag op dit moment niet inloggen. Met de volgende knop kun je de persoonlijke toegang weer activeren.", "invitation_expired": "De uitnodiging is onvoltooid. Je moet een nieuwe uitnodiging aan de medewerker versturen.", "invitation_success": "De uitnodiging is succesvol verstuurd.", "invitation_failed": { "hint": "is al in gebruik", "message": "Deze e-mail adres is al in gebruik door een ander account. Neem alsjeblieft contact op met <a href=\"support@onduro.com\">support@onduro.com<\/a>. We gaan dit graag voor je oplossen." }, "text_owner": "Als accounthouder moet je toegang hebben.", "user": "Medewerker", "user_is": "Medewerker is", "user_may": "Medewerker mag", "tabs": { "other": "Overig", "infos": "Info", "tags": "Tags", "rates": "Uurloon" }, "label": { "about": "Over :name", "notes": "Interne notities", "access": "Toegang", "right_colleagues": "mag alle collega's in het rooster zien", "right_placeholder": "mag zichzelf in open diensten inschrijven", "right_hours": "mag uren voor andere medewerkers invullen", "payroll": "wordt via {provider} uitbetaald", "right_colleagues_restrict": "alleen op dagen waar medewerker zelf ingepland is", "absence\t": "Ziekmelden", "absence": "Absentie\/ziekte melden" }, "hint": { "role_owner": "mag alles beheren", "role_manager": "mag alle medewerkers en instellingen beheren", "role_planner": "mag de planning beheren", "role_supervisor": "goedkeuren, afkeuren en wijzigen van uren", "role_observer": "mag gepubliceerde diensten op eigen locaties in de planning zien (maar niks aanpassen)", "role_manager_restricted": ["mag geen (medewerker) instellingen beheren", "heeft alleen toegang tot eigen documenten"], "role_freelancer": "Een ZZP'er heeft dezelfde rechten als een medewerker, maar kan facturen voor eigen gemaakte uren genereren.", "multiple_shifts": "Heb je meer capaciteit nodig voor deze dienst? Maak deze dienst meerdere keren aan.", "override_rate": "Overschrijf het standaard uurtarief voor deze dienst", "notes_visibility": "Deze notitie is zichtbaar voor alle medewerkers in de planning" }, "empty": "Er zijn nog geen medewerkers aangemaakt.", "email_existing": "Er is al een andere medewerker geregistreerd met dit e-mailadres.", "blueprint": { "hash": "blauwdruk", "headline": "Blauwdruk", "info": "Dit is een blauwdruk voor nieuwe medewerkers. Je kunt hier instellingen opslaan die vervolgens automatisch op nieuwe medewerker toegepast worden. Wil je de instellingen niet meer automatisch toepassen? Deactiveer dan de blauwdruk met het knopje rechts boven.", "active": "geactiveerd", "inactive": "gedeactiveerd" }, "supervisor": "Medewerker mag uren van collega's beheren", "accountant": "Medewerker heeft toegang tot rapportage", "of_cost_label": "van kostenplaats", "restrictions": { "locations": { "all": "voor alle planningen", "own": "alleen voor gekoppelde planningen", "some": "alleen voor geselecteerde planningen" }, "duties": "alleen voor diensten met eigen <u>functies<\/u>" }, "deactivate": { "confirm": { "headline": "Zeker deactiveren?" }, "text": "Gedeactiveerde medewerkers kunnen niet inloggen of ingepland worden." }, "activate": { "confirm": { "headline": "Zeker activeren?", "text": "Geactiveerde medewerkers zijn eventueel met kosten verbonden. Check de voorwaarden van je abonnement voor meer informatie." } }, "vacation": "Medewerker mag vakantie aanvragen", "import": "Om je eigen werknemers te importeren, neem via de \"Hulp\" link contact met ons op. We gaan dan eerst je demo toegang omzetten naar een reguliere account.", "bulk_delete": "Medewerkers verwijderen", "delete_bulk_text": "Alle geplande items in de toekomst worden voor deze gebruiker verwijderd! Historische gegevens worden bewaard.", "bulk_text": "Weet je zeker dat je geselecteerde werknemers wilt {action}?", "bulk_invite": "Medewerkers uitnodigen", "bulk_activate": "Medewerkers activeren", "bulk_deactivate": "Medewerkers deactiveren", "invited_notify": "Selectie is succesvol uitgenodigd.", "add_limit": "Je hebt het maximale aantal werknemers bereikt dat op je plan van toepassing is. Deactiveer medewerkers of upgrade je plan.", "dossier": { "sidebar_note": "Dit is waar je wat interne informatie kwijt kunt over deze werknemer." }, "user_deactivated": "Medewerker is gedeactiveerd.", "settings": { "warn": "Let op: de instellingen hieronder hebben pas effect zodra de werknemer uitgenodigd is en zijn registratie succesvol heeft afgerond." }, "invitation_no_email": "Je moet eerst een e-mailadres invoeren en opslaan om {name} toegang te verlenen.", "invitation_invite": "{name} heeft nog <u>geen<\/u> toegang tot ONDURO. Klik op de onderstaande knop om {name} toegang te verlenen via een eigen login.", "profile": { "note": "Todo: Ga naar de tab \"instellingen\" om {name} aan minstens \xE9\xE9n functie te koppelen." }, "bulk_edit": "Instellingen bewerken", "contract": { "vacation": "medewerker mag verlof aanvragen", "none": "Geen contract ingesteld.", "salary": "Hier kun je het uurloon voor deze werknemer wijzigen." }, "balance_overview": "Werknemer mag tijd-voor-tijd van andere werknemers zien", "expenses": { "general": "Medewerker mag onkosten declareren (in \u20AC)", "travel": "Medewerker mag reiskosten declareren (in km)" }, "registration_link": "Kopieer registratielink naar klembord", "hours_add": "mag uren opgeven zonder ingepland te zijn", "invitation_conflict": "<b>Dit e-mailadres is al gekoppeld aan een gebruiker in een ander account.<\/b><br><br>Verwijder eerst het e-mailadres in het andere account, voordat je de gebruiker in dit account uitnodigt.<br><br>Of verwijder de gebruiker in <u>dit<\/u> account en geef een e-mailadres op <b>tijdens<\/b> het toevoegen van de gebruiker.", "role_manager_restricted": "met beperkte toegang", "signature_supervisor": "mag alleen handtekeningen ophalen", "balance_holidays_always": "Feestdagen altijd toevoegen aan urensaldo", "absence": { "notes_placeholder\t": "Aanvullende notities over de afwezigheid (Optioneel)", "history": "Afwezigheidsgeschiedenis", "delete": "Afwezigheid verwijderen", "delete_confirm": "Weet je zeker dat je deze afwezigheidsregistratie wilt verwijderen?", "export": "Download als Excel", "notes_placeholder": "Aanvullende notities over de afwezigheid...", "sidebar_note": "Registreer afwezigheid van medewerkers zoals ziekte. Je kunt de einddatum leeg laten en later toevoegen wanneer de medewerker terugkeert.", "actions": "Acties" } }, "roster": { "element": "Item", "undroppable": { "text": "kan hier niet ingepland worden.", "past": "Deze dag is in het verleden.", "billed": "Deze periode is al gefactureerd.", "confirm": "toch inplannen", "blocked": "Deze dag is geblokkeerd.", "closed": "Op deze dag wordt niet gewerkt." }, "time": { "delete": { "error": { "headline": "Tijd kan niet verwijderd worden." } }, "error": { "headline": "Tijden kunnen niet opgeslagen worden.", "ERR_TIMES": "Je moet een start- en eindtijd invullen.", "ERR_CONFIRMED": "De ingevulde tijd van de medeweker is al bevestigd.", "ERR_OVERLAP": "is in deze periode al voor een dienst ingepland.", "ERR_OVERLAP_REMOVAL": "is op deze dag al voor een dienst ingepland. De tijd kan daardoor niet verwijderd worden.", "ERR_EQUAL": "Begin- en eindtijd moeten verschillen.", "ERR_NEGATIVE": "Totale duur mag niet negatief zijn. Pas de pauze aan." } }, "user": { "delete": { "error": { "headline": "Medewerker kan niet verwijderd worden." } }, "has_hours": { "headline": "Dienst heeft ingevulde uren!" }, "change": { "ERR_HOURS": "Er zijn al uren ingevuld voor deze dienst. Wil je deze uren verwijderen en de nieuwe medewerker toewijzen?" }, "remove": { "ERR_HOURS": "Er zijn al uren ingevuld voor deze dienst. Wil je deze uren samen met de medewerker verwijderen?" }, "error": { "headline": "Medewerker kan niet opgeslagen worden.", "ERR_CONFIRMED": "De door de medeweker ingevulde tijd is al bevestigd.", "ERR_OVERLAP": "is in deze periode al voor een dienst ingepland." } }, "item": { "delete": { "error": { "headline": "Dienst kan niet verwijderd worden." }, "ERR_HOURS": "Er zijn al uren ingevuld voor deze dienst. Dienst samen met de ingevulde uren verwijderen?", "ERR_CONFIRMED": "Er zijn al uren ingevuld en bevestigd voor deze dienst. Dienst samen met de ingevulde uren verwijderen?" }, "has_hours": { "headline": "Dienst heeft ingevulde uren!" }, "via_hours": "toegevoegd via urenregistratie", "driver": "Gemarkeerd als bestuurder" }, "sick": { "ERR_HOURS": { "headline": "Dienst heeft al ingevulde uren!", "text": "Er zijn al uren ingevuld voor deze dienst. Uren verwijderen en ziekte invullen?" }, "ERR_TIME": { "headline": "Dienst heeft geen werktijden!", "text": "Bij ziekte heeft de dienst een start- en eindtijd (of shift) nodig." } }, "shift": { "error": { "headline": "Shift kan niet opgeslagen worden.", "ERR_CONFIRMED": "De door de medeweker ingevulde tijd is al bevestigd.", "ERR_OVERLAP": "is in deze periode al voor een dienst ingepland." } }, "add": { "error": { "headline": "Dienst kan niet ingepland worden!", "headline_choose": "Medewerker staat al ingepland", "ERR_UNAVAILABLE_LIMITED": "is op deze dag beperkt beschikbaar. Doorgaan?", "ERR_UNAVAILABLE_DENY": "kan op deze dag niet ingepland worden.", "ERR_UNAVAILABLE_WARN": "is op deze dag niet beschikbaar. Toch inplannen?", "ERR_EXISTING_FULL": "is op deze dag al voor onbepaalde tijd ingepland. Zolang je hiervoor geen tijdstip invult, kun je geen nieuwe dienst voor deze medewerker inplannen.", "ERR_EXISTING_SHIFT": "is op deze dag al voor een shift ingepland. Je moet eerst de bestaande shift verwijderen om een nieuwe shift in te plannen.", "headline_limited": "Medewerker is niet de hele dag beschikbaar" } }, "signin": { "error": { "headline": "Niet mogelijk!", "text": "Je werkt al op deze dag!" } }, "signout": { "headline": "Uitschrijving aangevraagd", "text": "Je bent nog steeds voor deze dienst ingepland, totdat een planner je uitschrijving bevestigd." }, "move": { "error": { "headline": "Dienst kan niet gewijzigd worden!", "ERR_OVERLAP": "De gewijzigde dienst overlapt een andere dienst van", "ERR_CONFIRMED": "De door de medeweker ingevulde tijd is al bevestigd.", "ERR_OPEN_CHECKIN": "Dienst is nog niet uitgecheckt." } }, "comments": { "error": { "headline": "Bericht toevoegen", "text": "Vul een bericht in." } }, "headline": "Rooster", "for": "voor", "from": "van", "until": "tot", "current_week": "huidige week", "since_current_week": "vanaf huidige week", "legend": "Legenda", "ical_subscribe": { "headline": "Agenda abonneren", "text": "Abonneer met het onderstaande adres op de agenda:" }, "release_error": "Tijdens het publiceeren is iets misgegaan.", "context": { "headline": "Medewerker inplannen:", "delete_text": "Sleep hier om te verwijderen!", "distance_hint": "Hieronder zie je de afstand van deze locatie tot het adres van de medewerker.", "info_hint": "Hieronder zie je hoe vaak en hoe lang een medewerker voor een dienst op deze locatie al ingepland staat sinds het publicatiedatum." }, "tools": { "time": "Tijd", "shift": "Shift", "duty": "Dienst", "user": "Medw.", "until": "tot", "application": "Medewerker vraagt om voor deze dienst uitgeroosterd te worden.", "approve": "Accepteren", "deny": "Weigeren", "apply": "Aanvragen", "cancel": "Toch niet!", "signin": "Inschrijven", "signout": "Afmelden", "switch": "Ruilen", "work": "Toch werken!", "empty_users": "geen beschikbaarheid", "empty_duties": "geen functie beschikbaar", "filtered_tags": "Let op: selectie gefiltered op basis van tags!", "tags_none": "Voor de ingeplande medewerker zijn geen tags beschikbaar.", "tags_user": "Je kunt alleen tags toevoegen die bij de ingeplande medewerker passen.", "tags_all": "Klik in het vakje om een tag aan deze dienst te koppelen. Tag niet gevonden? Hier kun je een <a href=\"{href}\">nieuwe tag toevoegen<\/a>.", "totals": "Totale aantal geplande (nog niet gepubliceerde) diensten \/ uren van alle planningen en diensten", "sick": { "payment": "Loon", "apply": "Ziek", "undo": "Toch niet ziek", "payroll_payment": "Voor deze medewerker wordt de loondoorbetaling tijdens ziekte via payroll geregeld.", "needs_time": "Bij ziekte heeft de dienst een start- en eindtijd (of shift) nodig. Voeg deze eerst toe!", "no_costs": "Voor deze medewerker worden geen uren bijgehouden.", "headline": "Kies de toepasselijke instellingen voor:", "balance": "Tijd-voor-tijd uren", "hint": "Kies de toepasselijke percentage van loondoorbetaling tijdens ziekte.", "balance_note": "Geplande werktijden tellen 100% mee voor het tijd-voor-tijd saldo.", "sko": "Kies het type verlof via de dropdown." }, "revoke_application": "Sollicitatie intrekken", "applied_at": "Gesolliciteerd op<br>{date}" }, "placeholder": { "comment": "Interne notitie (alleen zichtbaar voor planners en waarnemers)" }, "matching": { "headline": "Open diensten matchen", "button": "Matching", "info": "Open diensten worden in de gekozen periode met beschikbare medewerkers gevuld.", "remove": "Medewerkers van reeds ingevulde diensten verwijderen", "error": "Startdatum moet later dan publicatiedatum zijn.", "removed": "Medewerkers succesvol van <b>:removed<\/b> diensten verwijderd!", "matched": "Medewerkers succesvol aan <b>:matched<\/b> diensten gematched! <b>:unmatched<\/b> diensten konden helaas niet gematched worden." }, "flash": { "success": { "headline": "Success!", "message": "Het rooster is nu gepubliceerd t\/m:<br><br><strong>:date<\/strong>" } }, "release": { "headline": "Planning publiceren", "text": "Rooster publiceren tot en met: <b>{date}</b><br><br>Als je het rooster tot en met de gekozen datum publiceert, worden alle ingeplande medewerkers met toegang per e-email ge\xEFnformeerd en kunnen het rooster bekijken.<br><br>Wijzigingen zijn op elk moment mogelijk, medewerkers krijgen automatisch bericht.", "success": "Het rooster is succesvol gepubliceerd!" }, "revoke": { "headline": "Publicatie terugtrekken", "text": "Rooster publiceren tot en met: <b>{date}</b><br><br>Als je een gepubliceerde planning wijzigt, worden alle ingeplande medewerkers met toegang per e-mail ge\xEFnformeerd over de nieuwe datum.<br><br>Medewerkers kunnen dan slechts diensten tot en met de gekozen datum zien." }, "duty": { "error": { "headline": "Functie kan niet gewijzigd worden" } }, "bulk": { "selected": "diensten geselecteerd", "note": "Klaar met je selectie? Kies dan uit de volgende acties.", "pasting": "Plak de diensten ergens in het rooster.", "cut": "knippen", "copy": "kopi\xEBren", "duplicate": "dupliceren", "match": "vullen", "empty": "leeghalen", "delete": "verwijderen", "error": { "resolve": "Je moet eerst de conflicten oplossen!", "released": "Deze actie kan niet in het gepubliceerde rooster uitgevoerd worden.", "paste_released": "Je kunt geen diensten in het gepubliceerde rooster plakken.", "latency": "Sommige diensten zijn gewijzigd terwijl je bezig was met deze actie. Ververs de rooster pagina en probeer het dan opnieuw." } }, "observer_note": "Je bent een waarnemer op de planningspagina. Daarom kun je de planning niet wijzigen.", "published_until": "Gepubliceerd tot hier", "apply": { "error": { "text": "Je hebt al gesolliciteerd voor deze dienst", "headline": "Niet mogelijk!" } }, "revoke_application": { "error": { "headline": "Niet mogelijk!", "text": "Je hebt niet gesolliciteerd op deze dienst" } }, "preset": { "return": "terug naar de planning", "template": "Template bewerken", "info": "Per planning kun je maximaal 4 weken invullen in de template. Vervolgens kun je de preset eenvoudig kopi\xEBren en in de huidige planning plakken.", "template_paste": "Template plakken" }, "to_projects": "Beheer projecten" }, "reports": { "remove": { "headline": "Rapport verwijderen", "text": "Wil je dit rapport echt verwijderen?" }, "save": { "headline": "Rapport opslaan" }, "saved": "Rapport succesvol opgeslagen!", "without": "zonder", "hours": "uren", "overview": { "headline": "Urenrapportage", "empty": "Geen opgeslagen rapportages beschikbaar.", "info": "Je kunt zo veel rapporten cre\xEBren als je wilt. Ook meerdere rapporten in dezelfde periode zijn mogelijk. Zo kun je bijv. rapporten per medewerker of planning aanmaken." }, "filter": { "headline": { "new": "Nieuw rapport", "existing": "Rapport" }, "filter": "Filter toepassen", "more": "meer filters weergeven", "empty": "Geen resultaten in de geselecteerde periode.", "stats": { "duties": "Diensten", "expected": "Gepland", "reported": "Ingevuld", "overtime": "Overuren", "salary": "Loon" }, "show_details": "Toon alle details" }, "add": "Rapport aanmaken", "point": "Factuur periode", "hints": "Opmerkingen", "unapproved": "De uren tussen haakjes zijn nog niet bevestigd.", "missing": "De volgende medewerkers hebben in deze periode nog niet alle uren ingevuld.", "complete": "Alle uren in de geselecteerde periode zijn ingevuld!", "created_at": "ingevuld", "approved_at": "bev. op", "approved_by": "bev. door", "sick_pay": "Loondoorbet.", "salary": "Loonkosten", "actions": "acties", "edit": "Uren bewerken", "no_cost": "Uren zonder kostenplaats", "download": "Download", "xls_title": "Rapport", "edit_hours": "Uren bewerken", "back": "terug naar overzicht", "no_hour": "Niet geregistreerde uren", "download_warn": { "headline": "In de geselecteerde periode zijn (ongeacht de 'status' filter) niet alle uren goedgekeurd:", "open": "nog niet ingevuld", "pending": "nog niet goedgekeurd", "planned": "in de toekomst", "denied": "afgekeurd", "footer": "Wil je de geselecteerde uren niettemin downloaden?" }, "labels": { "add": "Label toevoegen", "remove": "Label verwijderen", "headline": "Labels bewerken" }, "export": { "headline": "Export naar salarisverwerker", "notice": "Weet je zeker, dat je de verloning voor alle werknemers en locaties (ongeacht de ingestelde filters) in de geselecteerde periode wilt uitvoeren? Let op: allen uren die nog niet verloond zijn worden verloond!", "warning": "Niet alle uren zijn goedgekeurd. De verloning kan alleen plaatsvinden als alle uren in de geselecteerde periode ingevuld en goedgekeurd zijn.", "incomplete": "Niet alle medewerkers zijn volledig ingeschreven. Er kan geen salaris run plaatsvinden voor medewerkers die niet volledig zijn ingeschreven." }, "downloads": { "per_employee": "per medewerker", "per_client": "per klant", "per_planning": "per planning", "billable": "Bevestigd per planning" }, "generateInvoice": { "title": "Factuur genereren", "button": "Facturen genereren", "period": "Factuur genereren voor de periode", "until": "tot en met", "for_freelancers": "Voor freelancers:", "all_freelancers": "Voor alle freelancers" } }, "lists": { "remove": { "headline": "Lijst verwijderen", "text": "Wil je deze lijst echt verwijderen?" }, "save": { "headline": "Lijst opslaan" }, "saved": "Lijst succesvol opgeslagen!", "filter": { "headline": { "new": "Nieuwe lijst", "existing": "Lijst" }, "stats": { "items": "Diensten", "expected": "Uren" }, "released_only": "alleen gepubliceerde diensten", "placeholder": "Open diensten", "assigned": "Gevulde diensten", "with_unpublished": "toon niet gepubliceerde diensten", "notes": "toon notities" }, "overview": { "empty": "Geen opgeslagen lijsten beschikbaar.", "info": "Hier kun je lijsten aanmaken op basis van ingeplande diensten.", "headline": "Lijsten" }, "add": "Lijst aanmaken", "xls_title": "Lijst" }, "settings": { "role_manager": { "confirm": "Beheerders hebben toegang tot ALLE medewerker data en account instellingen. Zorg ervoor, dat deze medewerker verantwoord met zijn rol omgaat." }, "role_accountant": { "confirm": "Beheerders van rapportage hebben toegang tot de geregistreerde uren van andere medewerkers. Mogelijkerwijs ook tot data zoals salarissen of uitgaven. Zorg ervoor dat deze medewerker zorgvuldig met deze informatie omgaat." }, "general": { "headline": "Algemene instellingen", "fieldset": { "roster": "Basis", "invoice": "Factuuradres", "expenses": "Onkosten en reiskosten", "various": "Overig" }, "expenses": { "general": "Medewerkers mogen onkosten registreren (in\xA0\u20AC)", "travel": "Medewerkers mogen reiskosten declareren", "travel_auto": "Reiskosten automatisch berekenen", "travel_note": "Let op: om reiskosten automatisch te kunnen berekenen is een postcode bij de planning instellingen en in het profiel van de medewerker vereist!", "assign_driver": "Bestuurder op de volgende manier toewijzen:", "driver_role": "Onderscheid maken tussen bestuurders en passagiers", "passenger_threshold": "Reiskosten passagiers vergoeden na" }, "placeholders": "Aanmelding in open dienst moet goedgekeurt worden door een planner (optie tijdelijk niet beschikbaar)", "contacts_visibility_public": "openbaar", "contacts_visibility_public_hint": "voor iedereen in het account zichtbaar", "contacts_visibility_private": "priv\xE9", "contacts_visibility_private_hint": "alleen voor managers en planners zichtbaar", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "vat_exempt": "vrijgesteld van BTW", "roster": { "must_apply": "Medewerkers moeten op een dienst solliciteren", "hide_names": "Beperk planner rol (namen verbergen, geen toegang tot planningsoverzicht)" }, "2fa": "Twee-factor authentificatie verplichten voor account houders, beheerders en planners.", "invoice_interval": { "weekly": "Wekelijks", "monthly": "Maandelijks", "4weeks": "Vierwekelijks" }, "auto_invoicing_hint": "Schakel automatisch factureren in om automatisch na iedere interval de facturen te genereren en te versturen names de freelancers" }, "locations": { "headline": "Locaties", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Locatie toevoegen", "edit": "Locatie bewerken", "empty": "Nog geen planning aangemaakt.", "moved": "De instellingen voor \"locaties\" zijn verplaatst naar de planning pagina. Je kunt vanaf nu locaties toevoegen en bewerken via de \"planningen\" overzicht.", "info": "Let op: we hebben \"Locaties\" hernoemd naar \"Planningen\". Hierdoor ben je flexibler. Je kunt een planning aanmaken voor een vaste \"locatie\" of een tijdelijke \"opdracht\"." }, "jobs": { "headline": "Functies", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Functie toevoegen", "edit": "Functie bewerken", "empty": "Nog geen functie aangemaakt.", "type": { "full": "Fulltime", "part": "Parttime", "temp": "Flexibel" } }, "duties": { "headline": "Functies", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Functie toevoegen", "edit": "Functie bewerken", "empty": "Nog geen functies aangemaakt.", "rest_label": "uur na elke dienst" }, "shifts": { "headline": "Shifts", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Shift toevoegen", "edit": "Shift bewerken", "empty": "Nog geen shift aangemaakt." }, "costs": { "headline": "Kostenplaatsen", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Kostenplaats toevoegen", "edit": "Kostenplaats bewerken", "empty": "Nog geen kostenplaats aangemaakt." }, "availability": { "headline": "Beschikbaarheid", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "users": { "fieldset": "Medewerkers", "label": { "before": "Beschikbaarheid moet minstens", "after": "weken van tevoren ingevuld worden." }, "hint": "Medewerkers kunnen hun beschikbaarheid binnen deze periode niet meer veranderen." }, "planners": { "fieldset": "Planners", "label": "Inplannen van <u>niet<\/u> beschikbare medewerkers in het rooster:", "deny": "weigeren", "warn": "waarschuwen", "allow": "toestaan" }, "options": { "fieldset": "Overige opties", "constrainable": { "label": "Medewerkers mogen een specifieke tijd opgeven waarop ze beschikbaar zijn", "hint": "bijv. beschikbaar vanaf 16:00 uur" }, "editable": "Planners mogen de beschikbaarheid van andere medewerkers aanpassen", "blank": "Niet ingevulde beschikbaarheid leeg tonen", "vacation": "Medewerkers mogen vakantie aanvragen" } }, "tags": { "headline": "Tags", "add": "Tag toevoegen", "edit": "Tag bewerken", "empty": "Nog geen tags aangemaakt." }, "rates": { "headline": "Uurlonen", "add": "Uurloon toevoegen", "edit": "Uurloon bewerken", "empty": "Nog geen uurlonen aangemaakt.", "hint": { "amount": "bruto uurloon", "factor": "omrekenfactor voor kostenberekening" } }, "premiums": { "headline": "Toeslagen", "add": "Toeslag toevoegen", "edit": "Toeslag bewerken", "empty": "Nog geen toeslagen aangemaakt." }, "holidays": { "headline": "Feestdagen", "empty": "Nog geen feestdagen aangemaakt.", "add": "Feestdag toevoegen", "notes": "Kies zelf welke feestdagen van toepassing zijn binnen je bedrijf of voeg zelf feestdagen toe.", "edit": "Feestdag bewerken" }, "contracts": { "add": "Template toevoegen", "edit": "Contract wijzigen", "empty": "Nog geen contract template aangemaakt.", "upload": "Template uploaden", "change": "Template wijzigen", "modal": { "info": "Hier kunt u een sjabloon uploaden in de indeling .doc of .docx." } }, "checkin": { "fieldset": { "location": "Planning", "time": "Check-in tijd", "open": "Open check-ins" }, "location": { "required": "Alleen check-ins toestaan met locatie", "range": { "before": "Alleen check-ins toestaan binnen 500 meter", "after": "meter" } }, "before": { "min": { "before": "Werknemers moeten minstens", "after": "minuten voor begin van de dienst inchecken" }, "max": { "before": "Medewerkers kunnen max.", "after": "minuten voor begin van de dienst inchecken" } }, "handle": { "open": "Automatisch uitchecken na" }, "hints": { "range": "Deze instelling werkt alleen met volledige adresinformatie voor jouw plannings." } } }, "availability": { "sidebar": { "change": "Wijzig selectie naar", "selection": "Je selectie", "deselect": "annuleer selectie", "constraints": "Tijdsbeperking", "status": "Vakantie status", "hint": "Tip: Houd de control\/command-toets gedrukt om meerdere dagen te selecteren." }, "error": { "mixed_constraints": "De tijdsbeperking mag niet verschillen op geselecteerde dagen.", "status": "Je moet een vakantie status kiezen.", "invalid_constraints": "Ongeldige tijdsbeperking.", "incomplete_constraints": "Tijdsbeperking op vakantiedagen vereist start- en eindtijd.", "conflict": "De volgende data konden niet ge\xFCpdatet worden omdat de planner hier al met je eerder opgegeven beschikbaarheid rekening heeft gehouden.<ul><li>{dates}</li></ul><div class=\"note\">Neem contact op met je planner als je de beschikbaarheid alsnog wilt veranderen.</div>" }, "legend": { "vacation_requested": "vakantie (aangevraagd)", "vacation_denied": "vakantie (afgekeurd)", "vacation_approved": "vakantie (goedgekeurd)", "holiday": "feestdag" }, "from": "vanaf", "until": "tot", "headline": { "planner": "Overzicht", "user": "Mijn beschikbaarheid" }, "button": { "overview": "Alle", "mine": "Mijn" }, "tools": { "hint": "<b>Selecteer \xE9\xE9n of meer dagen</b> en kies daarna je beschikbaarheid.", "default": "Je bent zonder opgave van beschikbaarheid: <b>:availability<\/b>", "multiselect": "<b>Tip:<\/b> Houd \"Shift\"-toets ingedrukt om meerdere enkele dagen te selecteren.", "selection": { "you_have": "Je hebt", "day": "dag", "days": "dagen", "selected": "geselecteerd" }, "vacation": { "headline": "Vakantie bewerken", "approve": "goedkeuren", "deny": "afkeuren", "unapproved": "Je vakantie is nog niet bevestigd!", "denied": "Vakantieaanvraag is geweigerd." }, "tooltip": { "pending": "Vakantie aangevraagd", "denied": "Vakantie geweigerd" }, "constraints": { "headline": "Voeg een tijdsbeperking toe", "hint": "alleen mogelijk als je beschikbaar bent" }, "change_to": "Wijzig selectie naar", "reset": "Selectie verwijderen", "request": "aanvragen", "register": "invoeren" }, "dropdown": "Alle planningen", "defaults": "Beschikbaarheid" }, "overview": { "welcome": { "headline": "Welkom, {name}!", "text": "Vul meteen je contactgevens in<br>om je profiel te vooltooien.<br><br><a href=\"{href}\" class=\"box-button\">Naar Profiel<\/a>" }, "checklist": { "headline": "Volg deze stappen om je eerste rooster te publiceren:", "shifts": "Shifts aanpassen", "duties": "Diensten inplannen", "users": "Medewerkers uitnodigen", "publish": "Rooster publiceren" }, "headline": "Welkom", "unbilled": "op te geven uren|op te geven uren", "approve_hours": "Uren goedkeuren", "sidebar": { "headline": "Mijn volgende diensten", "empty": "Geen diensten gepland.", "no_locations": "Je hebt momenteel geen toegang tot het rooster omdat je aan geen planning gekoppeld bent." }, "unapproved": "goed te keuren uren|goed te keuren uren", "processable": "1 verlofaanvraag wacht nog op goedkeuring.|{processable} verlofaanvragen wachten nog op goedkeuring.", "vacation_requests": "verlofaanvraag|verlofaanvragen" }, "balances": { "added": "bij", "note_overview": "Alleen goedgekeurde uren tellen mee in het tijd-voor-tijd saldo.", "note_current": "Je saldo is momenteel: <em>{saldo} uren<\/em> De uren van de huidige week (vanaf {date}) tellen niet mee." }, "account": { "headline": "Accountbeheer", "delete": "Account verwijderen", "delete_confirm": "Weet je zeker dat je het account wil verwijderen? Alle gegevens worden onherroepelijk verwijderd.", "unsubscribe": "Abonnement opzeggen", "unsubscribe_confirm": "Weet je zeker dat je het abonnement wil opzeggen? Je kunt het account nog tot einde van je huidige factuurperiode verder gebruiken.", "saved": "Gegevens succesvol opgeslagen.", "trial": { "expiration": "Je kunt ONDURO nog tot en met <strong>{expiration}<\/strong> gratis gebruiken.", "days": "Dat is nog {days} dag.|Dat zijn nog {days} dagen.", "expires_today": "Je kunt ONDURO alleen nog vandaag gratis gebruiken. Wil je verder eenvoudig en helder plannen? Maak dan een abonnement aan!" }, "active_trial": { "note": "De betaalde periode gaat pas in vanaf :period_start. Je ontvangt je eerste factuur op :invoice_date.", "box1": { "headline": "Gratis proefperiode", "until": "t\/m", "description": "Tot deze datum betaal je niks!<br>Toch opzeggen? Doe dat dan uiterlijk voor deze datum." }, "box2": { "headline": "Actieve medewerkers", "period": "in huidige periode", "description": "Op basis van dit getal wordt je maandelijkse factuurbedrag berekend." } }, "active": { "note": "Je ontvangt de volgende factuur op <strong>{nextInvoice}<\/strong> voor het gebruik van {billingStart} t\/m {billingEnd}. Zorg ervoor dat je je huidige factuurgegevens hieronder hebt toegevoegd!", "box1": { "headline": "Huidige factuurperiode", "until": "t\/m", "description": "Dat zijn nog :days dagen." }, "box2": { "headline": "Actieve medewerkers", "period": "in huidige periode", "description": "Aantal reeds actieve + opnieuw toegevoegde \/ geactiveerde medewerkers." }, "box3": { "headline": "Te verwachte kosten", "period": "in volgende factuur", "description": "Te verwachte kosten op basis van de geactiveerde medewerkers in de huidige factuurperiode." } }, "cancelled": { "note": "Je kunt ONDURO nog tot en met <strong>{expiration_date}<\/strong> gebruiken of je account meteen verwijderen.", "box1": { "headline": "Laatste factuurperiode", "until": "t\/m", "description": "Dat zijn nog :days dagen." }, "box2": { "headline": "Actieve medewerkers", "period": "in huidige periode", "description": "Aantal reeds actieve + opnieuw toegevoegde \/ geactiveerde medewerkers." }, "box3": { "headline": "Te verwachte kosten", "period": "in laatste factuur", "description": "Te verwachte kosten op basis van de geactiveerde medewerkers in de huidige factuurperiode." }, "info": "Je ontvangt je laatste factuur op <strong>:invoice_date<\/strong>. Het bedrag wordt automatisch van je rekening afgeboekt." }, "subscription": { "title": "Alles inclusief voor", "per_user": "per actieve medewerker", "per_month": "per 30 dagen", "benefits": ["alle functies inclusief", "altijd overzicht van je kosten", "op elk moment opzegbaar", "veilig betalen via automatische incasso"], "subscribe": "Nu abonneren", "start": "je betaalde periode begint pas op", "success": "Je abonnement is succesvol aangemaakt!<br>Veel plezier met ONDURO!" }, "unsubscription": { "success": "Je abonnement is succesvol opgezegd!<br>Bedankt voor je vertrouwen!" }, "support": "Heb je vragen? Stuur ons een <a href=\"#\" class=\"box-intercom\">bericht<\/a>. Wij helpen je graag!", "sidebar": { "discount": { "headline": "Kortingscode" }, "status": { "headline": "Status", "text": "Volgende gegevens worden in het adresboek getoond:", "free": "Je account is actief.", "trial": "Proefperiode t\/m", "registered_since": "Geregistreerd sinds", "subscribed_since": "Geabonneerd sinds" }, "owner": { "headline": "Verwerkingsverantwoordelijke (AVG)" }, "invoices": "Facturen", "license_code": "Licentiecode" }, "license": { "note": "Je gebruikt ONDURO via een licentiecode.", "error": "Deze licentiecode is niet geldig of is verlopen." }, "demo": "Je gebruikt ONDURO momenteel via de gratis demo." }, "profile": { "headline": "Jouw profiel", "account": "Account", "delete": "Profiel verwijderen", "delete_confirm": "Weet je zeker dat je je account wil verwijderen? Alle gegevens worden onherroepelijk verwijderd.", "saved": "Je profiel is succesvol opgeslagen.", "gravatar": "Meld je aan op <a href=\"https:\/\/www.gravatar.com\/\" target=\"_blank\">Gravatar<\/a> om een profielfoto toe te voegen.", "fieldset": { "personal_data": "Persoonlijke gegevens", "address": "Adresboek", "other": "Overig" }, "about": { "label": "Over jou", "placeholder": "Ervaringen, kwalificaties, etc.", "hint": "deze informatie is alleen voor je planners zichtbaar" }, "sidebar": { "address": { "headline": "Adresboek", "text": "In het adresboek worden alleen de door jou ingevulde gegevens getoond." }, "password": { "headline": "Wachtwoord wijzigen", "text": "Om je wachtwoord te wijzigen, klik op de volgende button en volg de stappen in het dialoogvenster.", "button": "Wachtwoord wijzigen" }, "email": { "headline": "E-mail adres wijzigen", "text": "Is je e-mail veranderd?", "button": "E-mail adres wijzigen" } }, "picture": "Profielfoto", "progress": "Je hebt {filled} van de {required} verplichte velden ingevuld. Nog {remaining} te gaan!", "filled": "Je hebt alle verplichte velden ingevuld!", "contract": "Dit is jouw contract. Graag downloaden, tekenen en weer uploaden.", "message": { "freelancerDataSuccess": "Profiel en freelancergegevens succesvol opgeslagen" }, "apply_from": { "headlin": "Bevestig wijziging", "text": "De wijzigingen worden direct opgeslagen. Hier kunt u een dataum zoeken vanaf wanneer deze wijzigingen worden meegenomen in de Delta functie.", "label": "Toepassen vanaf" } }, "notifications": { "fieldset": { "roster": "Rooster", "hours": "Hours" }, "info": "Hier kun je instellen, welke notificaties je wilt ontvangen.", "saved": "Je instellingen zijn succesvol opgeslagen.", "roster_mine": { "label": "Wijziging van je eigen diensten", "hint": "je ontvangt een bericht, als je diensten gewijzigd worden" }, "item_changed": { "label": "Wijziging van elk dienst", "hint": "je ontvangt een bericht, als een dienst in het gepubliceerde rooster gewijzigd wordt" }, "unbilled": { "label": "Uren invullen", "hint": "je ontvangt een bericht, als je nog uren moet invullen" }, "unapproved": { "label": "Uren bevestigen", "hint": "je ontvangt een bericht, als je nog uren moet bevestigen" }, "open_duty": { "label": "Open diensten", "hint": "je ontvangt een bericht, als er nog diensten open zijn" }, "item_upcoming": { "label": "Aankomende diensten", "hint": "ontvang een notificatie \xE9\xE9n dag voor elke dienst" } }, "hours": { "headline": { "mine": "Mijn uren", "all": "Alle uren" }, "note": { "mine": "Deze uren moet je nog doorgeven. Check je werktijden (pas deze aan indien nodig) en klik vervolgens op het vinkje om de uren door te geven.", "pending": "Deze uren zijn in afwachting voor goedkeuring. Zolang ze niet bevestigd zijn, kun je nog wijzigingen aanbrengen.", "approvable": "Deze uren moeten nog goed- of afgekeurd worden.", "approved": "Deze uren zijn bevestigd en kunnen niet meer aangepast worden. Kies een maand in de dropdown rechtsboven om meer uren weer te geven." }, "actionable": "Op te geven", "pending": "In afwachting", "approvable": "Goed te keuren", "approved": "Bevestigd", "empty": "alle uren zijn verwerkt", "no_cost": "zonder kostenplaats", "error": { "times": "Vul geldige werkuren in." }, "confirm_delete": "Let op! De gerelateerde dienst zal permanent worden verwijderd uit het rooster!", "comment": "Bericht toevoegen...", "checkins": "Te bevestigen", "unsigned": "Niet ondertekend" }, "update": { "headline": "ONDURO is bijgewerkt", "text": "De applicatie wordt door een klik op de volgende knop automatisch bijgewerkt.", "button": "Update laden" }, "history": { "item": { "added": "heeft een item tot het :released rooster toegevoegd:", "changed": "heeft een item in het :released rooster gewijzigd:", "removed": "heeft een item van het :released rooster verwijderd:", "signed_in": "heeft :who in een open dienst aangemeld:", "signed_out": "heeft :who van een dienst afgemeld:" }, "hour": { "added": "heeft uren ingevuld:", "added_for": "heeft uren voor :who ingevuld:", "changed": "heeft ingevulde uren gewijzigd:", "changed_for": "heeft ingevulde uren voor :who gewijzigd:", "approved": "heeft ingevulde uren van :who bevestigd:", "denied": "heeft ingevulde uren van :who afgekeurd:" }, "roster": { "released": "heeft het rooster gepubliceerd:", "revoked": "heeft de gepubliceerde datum van het rooster veranderd:" } }, "contacts": { "no_access": "geen toegang", "not_verified": "not yet registrated", "download": "Download" }, "modules": { "descriptions": { "basic": "Het rooster dient als basis voor de planning.", "hours": "Laat medewerkers uren invullen en cre\xEBer rapportages met \xE9\xE9n klik.", "availability": "Laat medewerkers hun beschikbaarheid invullen.", "shifts": "Voeg shifts toe aan diensten.", "tags": "Voeg tags toe aan diensten en medewerkers.", "rates": "Laat uurlonen automatisch berekenen en onkosten opgeven.", "balances": "Maak tijd-voor-tijd mogelijk en laat medewerkers altijd hun huidige saldo inzien.", "sickness": "Verwerk diensten die vanwege ziekte niet gewerkt zijn.", "tentoo": "Koppel de goedgekeurde uren aan Tentoo Payroll.", "costs": "Laat uren op verschillende kostenplaatsen boeken.", "lists": "Cre\xEBer eenvoudig lijsten van geplande diensten.", "chats": "Berichten sturen onder werknemers", "temper": "Temper.works integratie", "blueprint": "Definieer standaardinstellingen voor nieuwe medewerkers.", "weather": "7 daagse weersvoorspelling in het rooster. Vereist postcode in de planning instellingen.", "vacation": "Verlof planning en beheer.", "dashboard": "Activeer een dashboard voor huidige planningen.", "today": "Activeer de pagina dagschema met duidelijke overzichten.", "statistics": "Krijg inzichten en statistieken van geplande en gewerkte uren, salarissen en kosten.", "university": "Ontvang direct hulpartikelen en ontdek alles over ONDURO.", "dossiers": "Bewaar aanvullende informatie van werknemers.", "contacts": "Toon de adresboek pagina voor snelle toegang tot contactgegevens.", "planning": "Cre\xEBer en publiceer roosters, laat medewerkers hun rooster inzien.", "contracts": "Beheer contracten voor medewerkers.", "nmbrs": "Beheer bepaalde gegevens voor de koppeling met Nmbrs.", "onboarding": "Verstrek onboarding-informatie voor nieuwe werknemers.", "payslips": "Bied loonstroken aan voor medewerkers.", "documents": "Documentencenter voor loonstroken, user uploads en contracten.", "checkins": "Laat medewerkers in- en uitchecken voor hun aanstaande diensten.", "clients": "Klantbeheer voor het groeperen van planningen.", "resources": "Bedrijfsmiddelen beheren en in de planning toevoegen.", "calculations": "Bereken automatisch totalen voor alle planningen.", "signature": "Voegt handtekeningen toe aan ingediende uren in de urenregistratie.", "newsletter": "Voeg een nieuwsbrief toe aan het dashboard door een url naar je externe nieuwsbrief bron op te nemen.", "company": "Toon een bedrijfspagina voor medewerkers.", "freelancers": "Genereer en deel (automatisch) facturen voor freelancers en bekijk ze in een handig overzicht", "projects": "De projectenmodule helpt projecten effici\xEBnt beheren en volgen. Gebruikers kunnen projecten aanmaken, bijwerken en monitoren met details zoals klantinformatie, locatie, budget, planning en facturering. Het ondersteunt shift toewijzing, werkurenregistratie en reiskostenbeheer." }, "note": "Met deze tools kun de functionaliteit van ONDURO uitbreiden. Kies de tools die bij jouw werkwijze passen. Wil je weten hoe je de tools het beste inzet? Neem dan contact met ons op!", "requires": "Vereist", "errors": { "dependency": "De tool kan niet gedeactiveerd worden, omdat onderstaande tools er afhankelijk van zijn", "dependent_on": "Tool vereist" } }, "logout": { "confirm": { "headline": "Logout", "body": "Wil je echt uitloggen?" } }, "invoice": { "footer": { "service_of": "is een service van" }, "thanks": "Bedankt voor je vertrouwen!", "charge_date": "Het bedrag wordt op {chargeDate} via automatisch incasso van je rekening afgeschreven." }, "vacation": { "status": { "pending": "in afwachting", "processed": "verwerkt", "approved": "goedgekeurd", "denied": "afgekeurd", "withdrawn": "ingetrokken", "removed": "verwijderd", "request": "aanvraag", "requested": "aangevraagd", "credit": "Credit", "debit": "debet", "new": "nieuw", "changed": "gewijzigd" }, "new_request": "Verlof", "new_credit": "Tegoed", "days_selected": "dagen geselecteerd", "current_balance": "Je resterende verlofsaldo is:", "request": { "empty": "Selecteer de gewenste dagen voor deze verlofaanvraag in de agenda", "above": "boven", "right": "rechts" }, "duration": { "full": "hele dag", "morning": "ochtend", "afternoon": "middag" }, "headline_new": "Nieuw Verlof", "note": { "start": "Selecteer een medewerker uit de lijst waarvoor je een aanvraag wil indienen.", "processed": "Je aanvraag is verwerkt.", "pending": "Je aanvraag is in behandeling.<br><br>Je ontvangt een bericht, zodra deze verwerkt is.", "tracking": "Hier kun je aangeven, hoeveel verlof de medewerker moet inleveren voor de aangevraagde vakantiedagen.", "changed": "Je hebt de aanvraag gewijzigd. Vergeet niet, de gewijzigde aanvraag op te slaan!" }, "amount": "Verlof", "days": "Vakantiedagen", "sidebar": { "current_balance": "Huidig saldo", "deduct": "betaald verlof", "new_balance": "Nieuw saldo", "average": "gemiddeld {average} per vakantiedag", "remaining_balance": "Resterend saldo" }, "stats": "{days} dagen aangevraagd, {approved} goedgekeurd", "allow": "toestaan", "deny": "weigeren", "credit": "crediteren", "debit": "debiteren", "edit": "Saldo bijwerken", "compensation": { "vacation": "betaald verlof", "overtime": "tijd-voor-tijd", "none": "onbetaald vrij" }, "vacation_request": "Vakantie aanvraag", "submit": "voorleggen", "amount-paid-hours": "Aantal uit te betalen uren", "holiday-type": "Type vakantie", "empty": "Er zijn nog geen vakantie-aanvragen voor dit jaar.", "empty-planner": "Er zijn nog geen vakantie-aanvragen voor dit jaar of je hebt teveel filters geselecteerd." }, "setup": { "contact": "Contact opnemen", "loading": "Ophalen van je data...", "headline": "Nog \xE9\xE9n stapje", "error": { "SETUP_COMPLETED": "Je hebt de set-up al afgerond! Klik op de onderstaande knop om in te loggen:", "INVALID_CREDENTIALS": "Er klopt iets niet. Neem via de onderstaande knop contact met ons op:", "general": "Er is iets misgegaan bij het ophalen van je data. Neem via de onderstaande knop contact met ons op:" } }, "statistics": { "sidebar": { "headline": "Periode", "cluster": "tros door" }, "tabs": { "details": "Details", "overview": "Overzicht" }, "content": { "chosedata": "Selecteer een periode om gegevens weer te geven." } }, "today": { "working": "Wie werkt er vandaag?", "empty": "Er staat niemand in de planning vandaag." }, "chats": { "new": { "headline": "Nieuw bericht" }, "participants": { "headline": "Deelnemer" } }, "subscription": { "choose_plan": "Kies je plan", "monthly": "per maand", "billing": { "before": "vooraf", "after": "achteraf" }, "cancel": "toch niet", "subscribe": "Sluit het abonnement af", "change": "Plan wijzigen", "choose": "Klik om te kiezen", "chosen": "Je huidige keuze", "selection": "Je nieuwe keuze", "active_users": "actieve medewerkers", "plans": { "fix": "Vast", "flex": "Flex", "legacy": "Oud", "custom": "Op maat" }, "more_info": "Kijk voor meer info en details over de tarieven op <a href=\"https:\/\/www.onduro.com\" target=\"_blank\">www.onduro.com<\/a>." }, "myroster": { "tabs": { "mine": "Mijn diensten", "open": "Open diensten", "all": "Alle diensten" }, "empty": "Geen diensten gepland.", "next_month": "naar volgende maand", "headline": "Rooster", "headline_mine": "Mijn dienst", "headline_open": "Open dienst", "sidebar": { "show_all": "toon alle dagen", "show_locations": "toon planningen", "no_colleagues": "Er staan (nog) geen collega's in de planning.", "note": "Op de rood omcirkelde dagen sta je al in de planning (zie tab \"mijn diensten\").", "warn": "Kijk op \"mijn diensten\" voor een overzicht van al jouw diensten (in alle planningen)." }, "details": { "warn_multiple": "je bent op deze dag voor meerdere diensten ingeroosterd!", "signed_out": "Je uitschriving van deze dienst is in behandeling. Wil je toch werken? Klik dan op de knop hieronder:", "confirmed": "Je hebt deze dienst bevestigd op {date}.", "info_assigned": "Je bent al op een andere dienst ingeroosterd op deze dag!|Je bent al op {items} andere diensten ingeroosterd op deze dag!", "info_placeholder": "Er is nog 1 open dienst op deze dag.|Er zijn nog {items} open diensten op deze dag." }, "no_duty": "geen dienst" }, "payslips": { "empty": "Er zijn nog geen loonstroken voor je gedeponeerd." }, "documents": { "note": "In het documenten center kun je eenvoudig alle documenten downloaden en weergeven. Hier vind je salarisdocumenten, contracten en user uploads. Je kunt deze documenten uploaden en verwijderen via het werknemersprofiel." }, "log": { "changed": "De volgende wijzigingen zijn doorgevoerd:", "note": "Maximaal 30 dagen kunnen getoond worden.", "filter_keys": "Filteren op wijzigingen in" }, "clients": { "add": "Klant toevoegen", "edit": "Klant bewerken" }, "plannings": { "title": "Planningen", "add": "Planning toevoegen", "edit": "Planning wijzigen", "tooltip": { "link": "Je bent niet gekoppeld aan deze planning!", "inactive": "Je kan geen inactieve planningen bekijken." }, "button": "Planningen beheren" }, "resources": { "add": "Bedrijfsmiddel toevoegen", "delete": "Bedrijfsmiddel verwijderen", "delete_confirm": "Weet je zeker dat je dit bedrijfsmiddel wil verwijderen? Alle gegevens worden onherroepelijk verwijderd." }, "login": { "2fa": { "setup": ["Scan de volgende qr code met <b>Google Authenticator<\/b>:", "en voer daarna de gegenereerde code in:"], "lost": "Als je de toegang tot je Google Authenticator app bent kwijtgeraakt, neem contact op met je manager om twee-factor authenticatie opnieuw in te stellen.", "required": "Het bedrijf waarvoor je inlogt vereist een twee-staps verificatie. Je moet deze eerst inrichten voordat je kunt inloggen.", "failed": "Twee-factor authentificatie mislukt. Probeer opnieuw." } }, "projects": { "add": "Project toevoegen", "edit": "Project bewerken", "title": "Projecten", "travel_allowance": { "hint": "Pas de reiskostenvergoeding toe zoals deze is ingesteld in de instellingen van de bedrijfslocatie naar de projectlocatie." } } }, "error": { "button": { "to_login": "naar login", "to_homepage": "naar startpagina", "to_referrer": "naar vorige pagina" }, "general": { "title": "Fout", "check": "Controleer je ingevoerde gegevens.", "invalid": "Ongeldige gegevens!" }, "cross_request": "De aanvraag is verlopen. Probeer het alsjeblieft opnieuw!", "403": { "title": "Toegang geweigerd", "headline": "Toegang geweigerd", "text": "Je was te lang niet actief of je bent niet gemachtigd om deze pagina te bekijken. Log opnieuw in.", "text_membership": "Er is iets misgegaan. Voor de veiligheid werd je uitgelogd. Meld je opnieuw aan." }, "404": { "title": "Pagina niet gevonden", "headline": "Oeps!", "text": ["Er is iets misgegaan.", "Deze pagina bestaat niet. Controleer of de URL in je adresbalk correct is."] }, "408": { "title": "Timeout", "headline": "Timeout", "text": "Je was te lang niet actief. Log opnieuw in." }, "503": { "title": "ONDURO is zo weer terug!", "headline": "Zo weer terug...", "text": ["De site wordt bijgewerkt.", "Over enkele minuten is ONDURO weer terug!"] }, "whoops": { "title": "Oeps", "headline": "Oeps, er is iets fout gegaan!", "text": "Ons support team is op de hoogte gesteld en we zullen hard werken om dit zo snel mogelijk op te lossen." }, "ajax": { "headline": "JavaScript geactiveerd?", "text": "JavaScript moet geactiveerd zijn om deze actie uit te voeren." }, "cookies": { "title": "Cookies niet geaccepteerd", "headline": "I want cookies!", "text": "Cookies worden niet geaccepteerd door je browser. Als je niet weet hoe je cookies kunt activeren, lees dan: <a href=\"http:\/\/www.google.com\/support\/websearch\/bin\/answer.py?hl=nl&answer=35851\">Cookies in- en uitschakelen<\/a>" }, "token_mismatch": { "headline": "Er is iets fout gegaan", "text": "Je was te lang niet actief. Probeer opnieuw in te loggen." }, "decrypt": { "headline": "Login mislukt", "text": "Probeer je met een wachtwoord tool in te loggen zoals LastPass of 1Password? Probeer dan eens zonder deze tools in te loggen!" }, "exception": { "session_validation": "Je actuele planning is verwijderd. Je bent automatisch naar een andere actieve planning doorgestuurd." }, "fields": { "text": "Kies <b>alstublieft ten minste \xE9\xE9n</b> veld" }, "422": { "gravatar": "Toegestane bestandstypen zijn: jpg, jpeg, png, gif <br> Afbeelding niet beperkt tot 2 MB" }, "413": "Bestand is te groot (max. 4MB)" }, "widget": { "general": { "confirm": "Weet je het zeker?" }, "premiums": { "headline": "Toeslag", "base": "op basis van", "days": "Dag(en)", "time": "Tijdvenster", "tags": "Tags", "holidays": "Feestdagen" }, "rates": { "headline": "Uurloon", "note": "Toeslagen worden altijd op het basis uurloon gerekend." }, "salary": { "headline": "Loonkosten" }, "expenses": { "headline": "Onkosten", "expense": "Onkosten", "travel_expense": "Reiskosten", "travel_time": "Reistijd" }, "hours": { "confirm_billable": { "headline": "Urenopgave bevestigen", "text": "De medewerker mag zelf uren invullen. Weet je zeker dat je de uren voor de medewerker wilt invullen?", "error": "Niet alle geselecteerde uren konden verstuurd worden. Check de start- en eindtijden.", "text_multi": "Ben je zeker, dat je de geselecteerde uren wilt versturen?" }, "deny": { "headline": "Uren afkeuren", "text": "De medewerker ontvangt automatisch bericht over de afkeuring. Als je wil, kun je hier nog een persoonlijk bericht toevoegen:", "placeholder": "Vul hier je persoonlijke bericht in..." } }, "locations": { "delete": { "headline": "Planning verwijderen", "confirm": "Wil je deze planning echt verwijderen? Je verliest daardoor onherroepelijk toegang tot alle geplande items" }, "step1": { "hint": "bijv. hoofdkantoor" }, "step2": { "text": "Selecteer medewerkers, die op <b>{name}<\/b> werken." }, "deactivate_related": "De planning kan niet worden gewijzigd, omdat hij met :text gepubliceerd is.", "delete_related": "De planning kan niet worden verwijderd, omdat hij met :text gepubliceerd is.", "delete_last": "De planning kan niet worden verwijderd, omdat hij de enige actieve is.", "delete_unassigned": "Voordat je deze planning kunt verwijderen, moeten de volgende gebruikers aan een andere planning gekoppeld worden:<br><br><ul class=\"default\"><li>:users<\/li><\/ul>" }, "duties": { "delete": { "headline": "Functie verwijderen", "confirm": "Wil je deze functie echt verwijderen?" }, "step1": { "hint": { "name": "bijv. barkeeper, service, keuken", "identifier": "bijv. BAR, SER, KEU" } }, "step2": { "text": "Selecteer medewerkers, die de functie <b>{name}<\/b> uitoefenen kunnen." }, "delete_related": "De functie kan niet verwijderd worden, omdat hij aan :text gekoppeld is." }, "shifts": { "delete": { "headline": "Shift verwijderen", "confirm": "Wil je deze shift echt verwijderen?" }, "text": "Kies <b>minstens \xE9\xE9n</b> locatie, waar deze shift van toepassing is.", "hint": { "name": "bijv. vroege dienst, nachtdienst", "identifier": "bijv. VD, ND" }, "delete_related": "De shift kan niet verwijderd worden, omdat hij aan :text gekoppeld is." }, "costs": { "delete": { "headline": "Kostenplaats verwijderen", "confirm": "Wil je deze kostenplaats echt verwijderen?" }, "hint": "bijv. algemeen, intern", "delete_related": "De kostenplaats kan niet verwijderd worden, omdat hij aan :text gekoppeld is. Verwijder de kostenplaats eerst bij de gekoppelde medewerkers.", "delete_fallback": "Deze kostenplaats kun je niet verwijderen omdat het de standaard kostenplaats is.", "delete_hours": "De kostenplaats kan niet verwijderd worden, omdat hij aan geregistreerde uren gekoppeld is." }, "workspaces": { "delete": { "headline": "Werkplek verwijderen", "confirm": "Wil je deze werkplek echt verwijderen? Je verliest daardoor onherroepelijk toegang tot alle geplande items!" } }, "tags": { "delete": { "headline": "Tag verwijderen", "confirm": "Wil je deze tag echt verwijderen? De tag wordt van alle diensten en medewerkers verwijderd." }, "step1": { "hint": "bijv. VIP" }, "step2": { "text": "Kies medewerkers, die de tag <b>{name}<\/b> krijgen." } }, "holidays": { "headline": "Feestdagen" }, "change": { "email": { "headline": "E-mail adres wijzigen", "success": "Je e-mail adres is succesvol gewijzigd. Let dus op bij je volgende login!" }, "password": { "headline": "Wachtwoord wijzigen", "success": "Je wachtwoord is succesvol gewijzigd. Let dus op bij je volgende login!" } }, "time": { "text": "Kies een tijdstip, waarop {name}\xA0nog wel beschikbaar is:", "error_overlap": "Het gekozen tijdstip overlapt een andere dienst.", "error_unavailable": "Tijdelijk inplannen is op dit moment nog niet mogelijk als de medewerker niet beschikbaar is." }, "response": { "items": "ingeplande dienst|ingeplande diensten", "users": "Medewerker|Medewerkers" }, "reports": { "hint": "bijv. Bevestigde uren van alle medewerkers" }, "jobs": { "hint": "bijv. manager on duty", "delete_related": "De functie kan niet verwijderd worden, omdat hij aan :text gekoppeld is." }, "users": { "step1": [], "step2": [], "step3": { "text": "Kies alle diensten, die <b>{fname}<\/b> uitvoeren mag:" }, "step4": { "text": "Wil je, dat <b>{name}<\/b> toegang tot het rooster krijgt?", "label": { "access_yes": "Ja, {fname} zal een persoonlijke login krijgen", "access_no": "Nee, {fname} heeft geen toegang nodig" }, "help": "Meer info over deze instelling", "help_text": ["Normaal gesproken zouden medewerkers hun eigen login krijgen, zodat ze zich kunnen aanmelden, het actuele rooster bekijken en verdere acties uitvoeren.", "Medewerkers zonder toegang kunnen het rooster alleen zien als je het uitprint of per e-mail verstuurt.", "Je kunt deze instelling op elk moment wijzigen."] }, "step5": { "text": "Wat is het e-mail adres van <b>{name}<\/b>?", "info": "De persoonlijke uitnodiging voor {name} wordt aan dit e-mail adres verstuurd.", "blueprint": "De blauwdruk voor nieuwe medewerkers is geactiveerd! Instellingen van de blauwdruk worden automatisch toegepast.", "success": "<b>{name} succesvol toegevoegd!<\/b><br>{fname} kan vanaf nu ingepland worden.", "success_verification": "<b>{name} succesvol uitgenodigd!<\/b><br>{fname} kan vanaf nu ingepland worden." }, "delete_holder": "<b>{name}<\/b> kan niet verwijderd worden, omdat anders niemand het account beheert." }, "contracts": { "delete": { "headline": "Contract verwijderen" }, "alternating": "even\/oneven weken verschillen", "notes": { "days_fixed": "Volle vakantiedagen worden met het aantal uren in de bovenstaande tabel vergoed. Gedeeltelijke vakantiedagen worden met het aantal uren vergoed.", "days_flex": "Gewerkte uren worden wekelijks aangevuld met vakantieuren tot een maximum van de contracturen. E\xE9n vakantiedag wordt tot maximaal {hours} uren vergoed.", "holidays": "Feestdagen die op werkdagen vallen worden met het aantal uren in de bovenstaande tabel vergoed." } }, "download": { "headline": "Beschikbare velden", "fields": { "fname": "Voornaam", "lname": "Achternaam", "email": "E-Mail", "mobile": "Mobiel", "status": "Status", "date": "Datum", "from": "Van", "until": "Tot", "break": "Pauze", "total": "Totaal", "overtime": "+\/-", "rate": "Uurloon", "expenses_amount": "Aantal km", "expenses_compensation": "Vergoeding per km", "expenses_travel": "Reiskosten", "expenses": "Uitgaven totaal", "sickness": "Ziekte", "employee_number": "Personeelnummer", "birthday": "Geboortedatum", "duty": "Functie", "location": "Locatie", "created_at": "Ingevuld", "approved_at": "Bev. op", "approved_by": "Bev. door", "expenses_other": "Overige onkosten", "salary": "Loon" }, "text": "Kies de velden die u in uw gedownloade bestand wilt zien", "success": { "headline": "Download", "text": "download" } }, "revenues": { "headline": "Omzet op" }, "employees": { "note": "De werknemer wordt niet meteen uitgenodigd. Je kunt op de volgende pagina eerst alle instellingen toepassen en dan de uitnodiging versturen.", "edit": "Let op! De geselecteerde instellingen worden op alle {amount} geselecteerde werknemers toegepast!" }, "defaultavailability": { "delete": { "headline": "Standaardbeschikbaarheid verwijderen", "confirm": "Wilt u deze standaardbeschikbaarheid echt verwijderen?" } }, "help": { "line1": "<b>Heb je een vraag over de verloning of je rooster?<\/b><br>Neem dan contact op met je werkgever of leidinggevende.<br><br><b>Heb je een vraag over de werkzwijze van ONDURO?<\/b><br>", "line2": "Antwoorden op veelgestelde vragen vind je in de <a href=\"#\" class=\"toggle-university\">university<\/a>!<br><br><b>Kom je er niet uit of heb je een andere vraag omtrent ONDURO?<\/b><br>", "line3": "Stuur ons dan een bericht via <a href=\"mailto:support@onduro.com\">e-mail<\/a>.<br><br><small style=\"line-height: 1;color: #888;\">We streven naar een antwoord op dezelfde werkdag. Soms duurt het ook iets langer omdat we bijv. druk bezig zijn met het verbeteren van ONDURO of onboarden van nieuwe klanten.<\/small>" }, "add_hours": { "overlap": "De uren overlappen met diensten of reeds ingevulde uren. Wil je de uren alsnog toevoegen?" }, "clients": { "delete": { "confirm": "Wil je deze klant echt verwijderen? Alle gekoppelde planningen worden op inactief gezet.", "headline": "Klant verwijderen" } }, "plannings": { "ERR_DATES": { "confirm": "Weet je zeker dat je de datums wilt wijzigen? Alle geplande items buiten de nieuwe datums worden verwijderd. Doorgaan?" } }, "timechooser": { "not_plannable": "Op de volgende tijdstippen is {name} op {date} <u><b>niet<\/b><\/u> planbaar:" }, "resources": { "step2": { "text": "Koppel bedrijfsmiddelen aan de functie <b>{name}<\/b>." }, "planning": "Koppel bedrijfsmiddelen aan de planning <b>{name}<\/b>." }, "assign_locations": { "headline": "Planningen koppelen" }, "signature": { "error": "Naam ondertekenaar en handtekening zijn vereist." } }, "validation": { "length": "te kort", "number": "geen cijfer gebruikt", "spaces": "geen spatie gebruiken", "invalid_character": "ongeldig karakter", "required": "is verplicht", "email": "is geen geldig e-mailadres" }, "frontend": { "terms": "Gebruiksvoorwaarden", "legal": "Contact & Support", "privacy": "Privacyverklaring", "nav": { "functions": "Functies", "faq": "FAQ", "pricing": "Prijzen", "register": "Registreren", "signin": "Inloggen" }, "login": { "signin": { "headline": "Inloggen", "forgot_password": "Wachtwoord vergeten?", "submit": "Inloggen", "error": "Aanmelden is niet gelukt. Probeer het nog een keer.", "modal": { "headline": "Inloggen mislukt", "text": "Je e-mail adres is nog niet bevestigd. Kijk in je spam folder als je de bevestigingsemail niet ontvangen hebt. Of <a href=\"{href}\">vraag het opnieuw aan<\/a>.", "error": "Nog niet bevestigd." }, "throttle": { "headline": "Inloggen mislukt", "text": "Je hebt te vaak foute login gegevens ingevuld. Wacht alsjeblieft een paar minuten en probeer het dan opnieuw." }, "hint": "You need to login first.", "user_inactive": "Je hebt geen actieve gebruikersaccount. Neem bij vragen hierover contact op met de beheerder van het account." }, "password": { "headline": "Wachtwoord opnieuw aanvragen", "text": "Vul hier het e-mail adres in, waarmee je geregistreerd bent. Je ontvangt dan alle informatie voor het opnieuw instellen van je wachtwoord.", "success": "Controleer je e-mail postvak!", "error": "Geen gebruiker geregistreerd met dit e-mail adres." }, "confirm": { "headline": "Uitnodiging geaccepteerd", "text": "We hebben je meteen ingelogd!", "back": "Verder" }, "confirm_fail": { "headline": "Bevestiging mislukt", "list": ["Heb je je e-mail adres al bevestigd? Probeer dan <a href=\"{href}\">in te loggen<\/a>.", "Kopieer de bevestigingslink uit de e-mail in de adresbalk van je browser.", "Als bovenstaande opties niet helpen, vraag een <a href=\"{href}\">nieuwe bevestigingslink<\/a> aan."], "back": "naar login" }, "confirmation": { "headline": "Bevestingscode aanvragen", "text": "Vul het e-mail adres in, die je gebruikt hebt bij het registreren. Je ontvangt dan een nieuwe bevestigingscode.", "success": "Controleer je e-mail postvak!", "error": "Geen gebruiker geregistreerd met dit e-mail adres." }, "reset": { "headline": "Wachtwoord aanmaken", "text": "Kies een nieuw wachtwoord:<br><ul><li>minstens 8 tekens<\/li><li>inclusief cijfers (0-9)<\/li><li>kleine letters en hoofdletters<\/li><\/ul>", "success": "Wachtwoord succesvol gewijzigd.", "error": "De code voor het aanmaken van een nieuw wachtwoord is ongeldig." }, "reset_fail": { "headline": "Wachtwoord aanmaken mislukt", "text": "De code voor het aanmaken van een nieuw wachtwoord is niet meer geldig of is al gebruikt. Controleer de URL of vraag een <a href=\"{href}\">nieuwe code<\/a> aan.", "back": "naar login" }, "signup": { "headline": "Account aanmaken", "welcome": "Leuk, dat je 30 dagen gratis wil testen!", "note": "Hiermee maak je een nieuw account aan voor je bedrijf. Heb je al logingegevens en wil je alleen inloggen? Ga dan naar de <a href=\"{href}\">login<\/a>.", "text": "Maak hier je persoonlijk wachtwoord aan:", "help": "<b>Let op!<\/b> Een veilig wachtwoord bevat minstens 8 karakters bestaande uit hoofdletters, kleine letters en cijfers.", "password": "Vul een wachtwoord in", "password_confirm": "Herhaal je wachtwoord", "submit": "Account aanmaken", "success": "Je bent succesvol geregistreerd. Log nu in met je e-mail adres en wachtwoord.", "accepted": "Je hebt de uitnodiging succesvol geaccepteerd. Log nu in met je e-mail adres en wachtwoord.", "error": "De code voor de registratie van een nieuw wachtwoord is ongeldig." }, "signup_fail": { "headline": "Registratie mislukt", "text": ["De code voor de registratie is niet meer geldig of is al gebruikt.", "Vraag bij de account beheerder een nieuwe code aan."], "back": "naar login" }, "accept": { "back": "Aan de slag", "headline": "Uitnodiging controleren", "text": "Een klein momentje nog..." }, "accept_fail": { "headline": "Uitnodiging mislukt", "text": "De code voor je uitnodiging is niet meer geldig of is al gebruikt. Vraag een nieuwe uitnodiging aan bij de beheerder van het account." }, "password_reset": { "error": "Je hebt nog geen wachtwoord. Rond eerst je account registratie af! Klik hiervoor op de link in je uitnodigingse-mail." } }, "registration": { "defaults": { "account": "Bedrijfsnaam", "location": "Hoofdlocatie", "contract": "0-uren contract", "cost": "Algemene kosten", "shifts": { "F": "Ochtend", "M": "Middag", "S": "Avond" } }, "terms": "Ik ga akkoord met de <a href=\"https:\/\/www.onduro.com\/nl\/gebruiksvoorwaarden\" target=\"_blank\">gebruiksvoorwaarden<\/a> en de <a href=\"https:\/\/www.onduro.com\/nl\/privacy\" target=\"_blank\">privacyverklaring<\/a>.", "error_general": "Je account kan op dit moment niet aangemaakt worden. Probeer het later opnieuw.", "error_already_registered": "Je hebt al een accout bij ONDURO. Wil je zeker een nieuw account aanmaken?", "error_not_verified": "Je e-mail adres is nog niet geverifieerd. Wil je nog een keer de e-mail met de bevestigingscode ontvangen?", "done": { "headline": "Check je e-mail!", "text": "Klik op de bevestigingslink in de e-mail, die we zojuist naar je gestuurd hebben.", "notice": "PS: Kijk ook in je spam folder!", "back": "terug naar de startpagina" }, "terms_owner": "Ik ga namens {company} akkoord met de <a href=\"https:\/\/www.onduro.com\/nl\/gebruiksvoorwaarden\" target=\"_blank\">gebruiksvoorwaarden<\/a>, de <a href=\"https:\/\/www.onduro.com\/nl\/dpa\" target=\"_blank\">verwerkersovereenkomst<\/a> en de <a href=\"https:\/\/www.onduro.com\/nl\/privacy\" target=\"_blank\">privacyverklaring<\/a> en ben hiertoe bevoegd." } }, "wizard": { "help": "Hulp nodig?<br>Klik mij!", "nav": { "1": "Welkom", "2": "Je account", "3": "Het bedrijf", "4": "Medewerkers", "5": "Functies", "6": "Modules" }, "back": "terug", "next": "volgende", "later": "doe ik later", "conclude": "volgende", "step1": { "headline": "Welkom", "text": ["We gaan nu je rooster inrichten!", "Als je vragen of hulp nodig hebt,<br>klik dan op de foto boven links."], "submit": "Aan de slag", "later": "Nu niet, ik ga later aan de slag!" }, "step2": { "headline": "Je account", "note": "Je hebt al een wachtwoord voor ONDURO, dus hoef je geen nieuwe te kiezen.", "password": { "label": "Kies een wachtwoord", "placeholder": "minimaal 6 letters en cijfers" } }, "step3": { "headline": "Het bedrijf", "company": { "label": "Hoe heet je bedrijf?", "placeholder": "Bedrijfsnaam" }, "branch": { "label": "In welke branche werk je?", "options": { "gastronomy": "Horeca", "retail": "Retail", "healthcare": "Zorg", "other": "Overig" } } }, "step4": { "headline": "Werknemers", "employees": { "label": "Wie wil je inroosteren?", "placeholder": "Lars Smit, Maaike Kuipers, Heintje Pieters, Anne Visser" }, "hint": ["Voeg \xE9en naam per regel in of gescheiden door komma's.", "Je kan ook later nog werknemers toevoegen."] }, "step5": { "headline": "Functies", "duties": { "label": "Welke functies bestaan er binnen {name}?", "placeholder": "Bar, Keuken, Kantoor" }, "hint": ["Voeg \xE9en functie per regel in of gescheiden door komma's.", "Je kan ook later nog diensten toevoegen."] }, "step6": { "headline": "Werkzaamheden", "text": "Welke werknemer past bij welke functie?" }, "step7": { "headline": "Modules", "text": ["Activeer hier alle modules, die je nodig hebt.", "Voor modules worden <u>geen<\/u> extra kosten in rekening gebracht."], "shifts": { "label": "Shift planning", "hint": "werk met shifts, bijv. \"Avond\" van 18:00 - 00:00" }, "hours": { "label": "Urenregistratie & rapportage", "hint": "laat werknemers uren invullen en cre\xEBer<br>gemakkelijk een overzichtsrapportage" }, "availability": { "label": "Beschikbaarheid", "hint": "laat werknemers hun beschibaarheid invullen" } }, "step8": { "headline": "Klaar!", "text": ["Dat was makkelijk, toch?", "Als je nog vragen hebt, neem dan contact met ons op:"], "submit": "Naar ONDURO", "flash": { "headline": "Welkom, {name}!", "text": "<p>Je kunt nu meteen aan de slag. Sleep de naam van een medewerker in het rooster en voeg vervolgens werktijden toe.<\/p><strong>Veel plezier met ONDURO!<\/strong><small>Tip: Op de overzichtspagina hebben we nog meer informatie voor je verzameld.<\/small>" } } }, "tools": { "remove_item": { "text": "Wil je deze dienst echt verwijderen?", "headline": "Dienst verwijderen" } }, "notification": { "message_added": "Je bericht is toegevoegd!" }, "conflict": { "INVALID_DUTY": "Functie is (niet meer) geldig", "INVALID_SHIFT": "Shift is (niet meer) geldig", "INVALID_USER": "Medewerker is niet planbaar", "AVAILABILITY": "Medewerker is niet beschikbaar", "ERR_OVERLAP": "Deze dienst overlapt met een andere dienst van deze medewerker", "ERR_EXISTING_FULL": "Deze medewerker staat al in de planning vandaag", "ERR_HOURS": "Er zijn al uren ingevuld voor deze dienst", "ERR_CONFIRMED": "De door de medeweker ingevulde tijd is al bevestigd", "message": "Gelieve de volgende conflicten oplossen:", "NO_DUTY_SET": "Deze dienst heeft een functie nodig", "ERR_OVERLAP_REST": "Deze dienst overlapt met de rustperiode van deze medewerker" }, "meta": { "description": "ONDURO login pagina" }, "onboarding": { "intro": ["Laten we ervoor zorgen, dat je het meeste uit ONDURO kunt halen.", "Dat doen we op twee manieren:"], "university": "In de university leer je alles over ONDURO.<br>Stapje voor stapje, op je eigen tempo.<br>Klik op het plaatje boven om te starten.", "support": "Heb je verder nog vragen?<br>Neem dan contact met ons op.<br>Via de \"Hulp\" link boven rechts.", "cancel": "Laat maar, ik zoek het zelf uit!", "disable": { "headline": "Onboarding uitschakelen?", "text": "Je kunt altijd weer bij de university terecht voor een handleiding via de link in de navigatie! Wil je voor nu de onboarding uitschakelen?" }, "loggedinas": "Je bent nu ingelogd als:", "self": "dit ben jezelf", "switch": "Benieuwd hoe de andere werknemers ONDURO zien? Klik dan onderstaande links om naar een andere rol te schakelen.", "switch_to": "Wisselen naar:", "own_staff": "Klaar om met je eigen personeel aan de slag te gaan?", "get_in_touch": "Bel ons op 06 238 816 72 en we bespreken de volgende stappen met je.", "role_manager": "Als beheerder mag je eigenlijk alles wat de eigenaar ook mag. Behalve het abonnement beheren.", "role_planner": "Als planner mag je in het rooster de planning maken en andere werknemers inplannen.", "role_supervisor": "Als leidinggevende (of: urenbeheerder) mag je de ingevulde uren van andere werknemers goed- of afkeuren.", "role_user": "Als werknemer of externe freelancer mag je eigenlijk vooral je beschikbaarheid opgeven, je rooster inzien en je uren opgeven.", "next_steps": "Hoe gaat het verder?" }, "university": { "minified": "Terug naar de university...", "lets_begin": "Laten we beginnen!", "headline": "Waar wil je meer over weten?", "no_lessons": "Er zijn geen lessen voor deze pagina of zoekopdracht.", "lesson": { "related": "Gerelateerde onderwerpen", "try": "Probeer het even" }, "show_all": "Toon alle lessen." }, "confirm": { "legal": { "statement": ["Ik, <b>{name}<\/b>, verklaar dat ik", "de bovenstaande voorwaarden volledig gelezen en begrepen heb; en", "deze accepteer namens <b>{company}<\/b>; en", "hiertoe wettelijk bevoegd ben."], "too_small": "Je apparaat is te klein om dit belangrijke document te laten zien, gebruik alsjeblieft je computer.", "scroll_notice": "Let op: onderstaand document kan worden gescrold." }, "chat": { "delete": { "headline": "Veilig?", "text": "Hierna kunt u geen berichten meer in deze chat zien" } }, "resting": { "conflict": "Deze wijziging is in strijd met de rustperiode voor {name}. Alsnog toepassen?" } }, "tooltip": { "roster": { "notes": "Voeg meer informatie toe voor alle diensten op deze dag. De ingevoerde tekst wordt bij de diensten in het rooster getoond.", "tools": { "notes": "Voeg meer informatie toe voor deze dienst. De ingevoerde tekst wordt bij de dienst in het rooster getoond." }, "tab": { "all": "van de geselecteerde planning" }, "internal": "Interne notities. Niet zichtbaar voor werknemers. Voer informatie in voor de rapportage, zoals opdrachtnummer etc." }, "reports": { "labels": "Filter status op \"bevestigd\" om labels toe te voegen." }, "contracts": { "days": { "flex": "Deze informatie zal ONDURO gebruiken om de vergoeding voor vakantie te berekenen.", "fixed": "Deze informatie zal ONDURO gebruiken om de vergoeding voor vakantie en feestdagen (tijdens werkdagen) te berekenen." } }, "date_info": "Je kunt in de datumprikker popup op het jaar boven klikken om het jaar snel te wijzigen.", "balance": { "holiday": "wordt toegevoegd aan het tijd-voor-tijd saldo voor elke actieve feestdag waar werknemer niet werkt (tot een maximum van de wekelijkse uren)", "holiday_always": "Uren voor feestdagen altijd toevoegen aan urensaldo (ook als de medewerker hiermee boven zijn wekelijkse uren komt)." }, "calculations": { "totals": "Hier worden de totalen getoond van de geselecteerde week over alle planningen heen.", "period": "Selecteer hier of klik op een datum in de planning om de periode te veranderen." }, "beta": "B\xE8ta-functionaliteit. Gebruik met zorg. Feedback welkom!", "hours_per_week": "uren per week" }, "soon": { "contracts": "Contractbeheer coming soon..." }, "button": { "reset_filters": "Filters resetten", "add_contract": "Contract toevoegen", "manage_plannings": "Planningen beheren", "refresh": "Verversen" }, "todo": { "invite": "Medewerker uitnodigen", "contract": "Contract toewijzen", "duty": "Functie(s) toewijzen", "salary": "Salaris instellen", "profile": "Verplichte profielvelden invullen", "profile_employee": "Medewerker heeft profiel nog niet helemaal ingevuld", "contract_incomplete": "Contract onvolledig (vereist: datum, getekende contract, salaris)", "certificates_expire": "Certificaten zijn afgelopen" }, "folder": { "payslips": "Loonstroken", "sepa": "SEPA bestanden", "contracts": "Contracten", "uploads": "Uploads van gebruikers", "journals": "Loonjournaalposten", "annuals": "Overige", "others": "Andere documenten", "others_description": "(certificaat inkomstenbelasting, meldingen sociale verzekeringen, andere documenten)", "attendance_roster": "Aanwezigheid en Rooster" }, "cards": { "items": { "open": { "headline": "Open diensten" }, "applications": { "headline": "Sollicitaties" }, "no_open_duties": "Er zijn geen open diensten", "no_open_applications": "Er zijn geen open sollicitaties" } }, "warning": { "registration_incomplete": "Inschrijving van medewerker niet afgerond!", "item_with_applications": "Deze dienst heeft al sollicitanten! Om de dienst te wijzigen, verwijder hem en maak een nieuwe aan." }, "sko": { "malta": { "tk": ["Als je geen verzekering hebt, kunt je", "deze hier aanvragen bij TK", "of een", "PDF downloaden met meer informatie"] } }, "freelancer": "ZZP'er", "filter": { "date": { "this_month": "Deze maand", "last_month": "Vorige maand", "this_quarter": "Dit kwartaal", "this_year": "Dit jaar", "last_year": "Vorig jaar", "last_quarter": "Vorig kwartaal" } }, "invoicesTable": { "invoice_number": "Factuurnummer", "date": "Datum", "total": "Totaal", "freelancer": "Naam Freelancer", "notFound": "Er zijn geen facturen gevonden" }, "input": { "freelancer": { "autoInvoice": "Automatisch Factureren Aanzetten?", "shiftVat": "BTW Verleggen" } }, "settings": { "invoices": "Facturen" }, "invoicing_interval": "Facturatie instelling", "modules": { "descriptions": { "pro": "De projectenmodule helpt projecten effici\xEBnt beheren en volgen. Gebruikers kunnen projecten aanmaken, bijwerken en monitoren met details zoals klantinformatie, locatie, budget, planning en facturering. Het ondersteunt taaktoewijzing, werkurenregistratie en reiskostenbeheer. Dankzij geautomatiseerde planning en realtime updates verloopt de uitvoering soepel." } } };/* harmony default export */ __webpack_exports__["default"] = (locales);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./locales.countries.de": 40,
	"./locales.countries.de.js": 40,
	"./locales.countries.nl": 41,
	"./locales.countries.nl.js": 41,
	"./locales.de": 79,
	"./locales.de.js": 79,
	"./locales.en": 278,
	"./locales.en.js": 278,
	"./locales.nl": 80,
	"./locales.nl.js": 80,
	"./locales.pl": 279,
	"./locales.pl.js": 279
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(521),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(500),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(526),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var constants = {
    loaderPrefix: 'ONDURO.loader.'
};

/* harmony default export */ __webpack_exports__["a"] = (constants);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


/**
 * Asynchronously load view (webpack lazy loading)
 */
var loadComponent = function loadComponent(path, route) {
    return function (resolve) {
        return __webpack_require__(458)(path + '.vue').then(function (module) {
            return resolve(module);
        }).catch(function (e) {

            // if error is not 404, it might be runtime error...
            console.info(e);

            if (true) {
                __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('app.updated', route);
            } else {
                console.error(e);
            }
        });
    };
};



/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(498),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(463),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(467),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(469),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(471),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(473),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(475),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(477),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(479),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(481),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(487),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(484),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(486),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(491),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(490),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(493),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(495),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 143,
	"./af.js": 143,
	"./ar": 144,
	"./ar-dz": 145,
	"./ar-dz.js": 145,
	"./ar-kw": 146,
	"./ar-kw.js": 146,
	"./ar-ly": 147,
	"./ar-ly.js": 147,
	"./ar-ma": 148,
	"./ar-ma.js": 148,
	"./ar-sa": 149,
	"./ar-sa.js": 149,
	"./ar-tn": 150,
	"./ar-tn.js": 150,
	"./ar.js": 144,
	"./az": 151,
	"./az.js": 151,
	"./be": 152,
	"./be.js": 152,
	"./bg": 153,
	"./bg.js": 153,
	"./bm": 154,
	"./bm.js": 154,
	"./bn": 155,
	"./bn-bd": 156,
	"./bn-bd.js": 156,
	"./bn.js": 155,
	"./bo": 157,
	"./bo.js": 157,
	"./br": 158,
	"./br.js": 158,
	"./bs": 159,
	"./bs.js": 159,
	"./ca": 160,
	"./ca.js": 160,
	"./cs": 161,
	"./cs.js": 161,
	"./cv": 162,
	"./cv.js": 162,
	"./cy": 163,
	"./cy.js": 163,
	"./da": 164,
	"./da.js": 164,
	"./de": 165,
	"./de-at": 166,
	"./de-at.js": 166,
	"./de-ch": 167,
	"./de-ch.js": 167,
	"./de.js": 165,
	"./dv": 168,
	"./dv.js": 168,
	"./el": 169,
	"./el.js": 169,
	"./en-au": 170,
	"./en-au.js": 170,
	"./en-ca": 171,
	"./en-ca.js": 171,
	"./en-gb": 172,
	"./en-gb.js": 172,
	"./en-ie": 173,
	"./en-ie.js": 173,
	"./en-il": 174,
	"./en-il.js": 174,
	"./en-in": 175,
	"./en-in.js": 175,
	"./en-nz": 176,
	"./en-nz.js": 176,
	"./en-sg": 177,
	"./en-sg.js": 177,
	"./eo": 178,
	"./eo.js": 178,
	"./es": 179,
	"./es-do": 180,
	"./es-do.js": 180,
	"./es-mx": 181,
	"./es-mx.js": 181,
	"./es-us": 182,
	"./es-us.js": 182,
	"./es.js": 179,
	"./et": 183,
	"./et.js": 183,
	"./eu": 184,
	"./eu.js": 184,
	"./fa": 185,
	"./fa.js": 185,
	"./fi": 186,
	"./fi.js": 186,
	"./fil": 187,
	"./fil.js": 187,
	"./fo": 188,
	"./fo.js": 188,
	"./fr": 189,
	"./fr-ca": 190,
	"./fr-ca.js": 190,
	"./fr-ch": 191,
	"./fr-ch.js": 191,
	"./fr.js": 189,
	"./fy": 192,
	"./fy.js": 192,
	"./ga": 193,
	"./ga.js": 193,
	"./gd": 194,
	"./gd.js": 194,
	"./gl": 195,
	"./gl.js": 195,
	"./gom-deva": 196,
	"./gom-deva.js": 196,
	"./gom-latn": 197,
	"./gom-latn.js": 197,
	"./gu": 198,
	"./gu.js": 198,
	"./he": 199,
	"./he.js": 199,
	"./hi": 200,
	"./hi.js": 200,
	"./hr": 201,
	"./hr.js": 201,
	"./hu": 202,
	"./hu.js": 202,
	"./hy-am": 203,
	"./hy-am.js": 203,
	"./id": 204,
	"./id.js": 204,
	"./is": 205,
	"./is.js": 205,
	"./it": 206,
	"./it-ch": 207,
	"./it-ch.js": 207,
	"./it.js": 206,
	"./ja": 208,
	"./ja.js": 208,
	"./jv": 209,
	"./jv.js": 209,
	"./ka": 210,
	"./ka.js": 210,
	"./kk": 211,
	"./kk.js": 211,
	"./km": 212,
	"./km.js": 212,
	"./kn": 213,
	"./kn.js": 213,
	"./ko": 214,
	"./ko.js": 214,
	"./ku": 215,
	"./ku.js": 215,
	"./ky": 216,
	"./ky.js": 216,
	"./lb": 217,
	"./lb.js": 217,
	"./lo": 218,
	"./lo.js": 218,
	"./lt": 219,
	"./lt.js": 219,
	"./lv": 220,
	"./lv.js": 220,
	"./me": 221,
	"./me.js": 221,
	"./mi": 222,
	"./mi.js": 222,
	"./mk": 223,
	"./mk.js": 223,
	"./ml": 224,
	"./ml.js": 224,
	"./mn": 225,
	"./mn.js": 225,
	"./mr": 226,
	"./mr.js": 226,
	"./ms": 227,
	"./ms-my": 228,
	"./ms-my.js": 228,
	"./ms.js": 227,
	"./mt": 229,
	"./mt.js": 229,
	"./my": 230,
	"./my.js": 230,
	"./nb": 231,
	"./nb.js": 231,
	"./ne": 232,
	"./ne.js": 232,
	"./nl": 233,
	"./nl-be": 234,
	"./nl-be.js": 234,
	"./nl.js": 233,
	"./nn": 235,
	"./nn.js": 235,
	"./oc-lnc": 236,
	"./oc-lnc.js": 236,
	"./pa-in": 237,
	"./pa-in.js": 237,
	"./pl": 238,
	"./pl.js": 238,
	"./pt": 239,
	"./pt-br": 240,
	"./pt-br.js": 240,
	"./pt.js": 239,
	"./ro": 241,
	"./ro.js": 241,
	"./ru": 242,
	"./ru.js": 242,
	"./sd": 243,
	"./sd.js": 243,
	"./se": 244,
	"./se.js": 244,
	"./si": 245,
	"./si.js": 245,
	"./sk": 246,
	"./sk.js": 246,
	"./sl": 247,
	"./sl.js": 247,
	"./sq": 248,
	"./sq.js": 248,
	"./sr": 249,
	"./sr-cyrl": 250,
	"./sr-cyrl.js": 250,
	"./sr.js": 249,
	"./ss": 251,
	"./ss.js": 251,
	"./sv": 252,
	"./sv.js": 252,
	"./sw": 253,
	"./sw.js": 253,
	"./ta": 254,
	"./ta.js": 254,
	"./te": 255,
	"./te.js": 255,
	"./tet": 256,
	"./tet.js": 256,
	"./tg": 257,
	"./tg.js": 257,
	"./th": 258,
	"./th.js": 258,
	"./tk": 259,
	"./tk.js": 259,
	"./tl-ph": 260,
	"./tl-ph.js": 260,
	"./tlh": 261,
	"./tlh.js": 261,
	"./tr": 262,
	"./tr.js": 262,
	"./tzl": 263,
	"./tzl.js": 263,
	"./tzm": 264,
	"./tzm-latn": 265,
	"./tzm-latn.js": 265,
	"./tzm.js": 264,
	"./ug-cn": 266,
	"./ug-cn.js": 266,
	"./uk": 267,
	"./uk.js": 267,
	"./ur": 268,
	"./ur.js": 268,
	"./uz": 269,
	"./uz-latn": 270,
	"./uz-latn.js": 270,
	"./uz.js": 269,
	"./vi": 271,
	"./vi.js": 271,
	"./x-pseudo": 272,
	"./x-pseudo.js": 272,
	"./yo": 273,
	"./yo.js": 273,
	"./zh-cn": 274,
	"./zh-cn.js": 274,
	"./zh-hk": 275,
	"./zh-hk.js": 275,
	"./zh-mo": 276,
	"./zh-mo.js": 276,
	"./zh-tw": 277,
	"./zh-tw.js": 277
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 142;

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var locales = { "layout": { "subnav": { "settings": { "general": "General", "locations": "Plannings", "jobs": "Jobs", "duties": "Functions", "shifts": "Shifts", "availability": "Availability", "costs": "Cost units", "rates": "Salaries", "premiums": "Premiums", "workspaces": "Workspaces", "tags": "Tags", "holidays": "Holidays" } }, "header": { "help": "Help", "overview": "Welcome!", "contacts": "Address book", "hours": "Hour registration", "reports": "Reporting", "profile": "Your profile" }, "calendar": { "roster": { "headline": "Published until (including)" }, "reports": { "headline": "Select an end date for the report." }, "mon": "MO", "tue": "TU", "wed": "WE", "thu": "TH", "fri": "FR", "sat": "SA", "sun": "SU" }, "footer": { "info": "You have unsaved changes.", "save": "Save changes", "cancel": "Reset", "saveWithDate": "Save and apply from date" } }, "route": { "overview": { "path": "overview", "name": "Overview" }, "roster": { "path": "roster", "name": "Roster" }, "lists": { "path": "lists", "name": "Lists" }, "availability": { "path": "availability", "name": "Availability" }, "contacts": { "path": "contacts", "name": "Contacts" }, "chats": { "path": "chats", "name": "Chats", "details": { "name": "Chats", "path": "chats\/:channel" } }, "hours": { "path": "timesheet", "name": "Timesheet", "page": { "path": "timesheet\/:page", "name": "Timesheet" } }, "reports": { "path": "reports", "name": "Reports" }, "team": { "path": "employees", "name": "Employees", "edit": { "name": "Employees", "path": "employees\/:id" } }, "profile": { "path": "profile", "name": "Profile" }, "settings": { "path": "settings", "name": "Settings", "general": { "path": "settings\/general", "name": "General" }, "availability": { "path": "settings\/availability", "name": "Availability" }, "duties": { "path": "settings\/functions", "name": "Functions" }, "holidays": { "path": "settings\/holidays", "name": "Holidays" }, "locations": { "path": "settings\/locations", "name": "Plannings" }, "premiums": { "path": "settings\/premiums", "name": "Premiums" }, "rates": { "path": "settings\/rates", "name": "Hourly rates" }, "shifts": { "path": "settings\/shifts", "name": "Shifts" }, "expenses": { "name": "Expenses", "path": "settings\/expenses" }, "costs": { "name": "Cost units", "path": "settings\/costs" }, "tags": { "name": "Tags", "path": "settings\/tags" }, "vacation": { "name": "Vacation", "path": "settings\/vacation" }, "contracts": { "name": "Contract templates", "path": "settings\/contracts" }, "advanced": { "path": "settings\/advanced", "name": "Advanced" }, "checkin": { "name": "Check-in", "path": "settings\/check-in" }, "settings": { "path": "settings\/company", "name": "Company Page" }, "company": { "name": "Company Page", "path": "settings\/company" }, "invoice": { "name": "Invoices" } }, "modules": { "path": "modules", "name": "Modules" }, "notifications": { "name": "Notifications", "path": "notifications" }, "projects": { "name": "Projects", "path": "projects", "edit": { "path": "projects\/:id" } }, "login": { "accept": { "path": "login\/accept-invitation\/:code", "name": "Accept Invitation" }, "confirm": { "path": "login\/confirm-email\/:code\/:account?", "name": "Confirm E-Mail" }, "confirmation": { "path": "login\/request-confirmation", "name": "Request Confirmation" }, "password": { "path": "login\/forgot-password", "name": "Forgot Password" }, "reset": { "path": "login\/reset-password\/:code", "name": "Reset Password" }, "signin": { "path": "login\/signin", "name": "Signin" }, "signup": { "path": "login\/signup\/:code", "name": "Signup" } }, "clients": { "name": "Clients", "path": "clients", "edit": { "path": "clients\/:id" } }, "balances": { "name": "Balance", "path": "balance", "details": { "name": "Balance", "path": "balance\/:id" } }, "register": { "path": "register", "name": "Create Account" }, "welcome": { "name": "Welcome", "path": "welcome" }, "terms": { "name": "Terms of use", "path": "terms" }, "privacy": { "name": "Privacy", "path": "privacy" }, "legal": { "name": "Contact & Support", "path": "contact" }, "wizard": { "start": { "name": "Wizard", "path": "wizard\/start\/:id\/:token" }, "step": { "name": "Wizard", "path": "wizard\/step" }, "name": "Wizard", "path": "wizard" }, "subscription": { "name": "Account", "path": "subscription", "confirm": { "path": "subscription\/confirm" } }, "invoice": { "path": "invoice\/:id" }, "vacation": { "name": "Vacation", "path": "vacation", "new": { "name": "Request time-off", "path": "vacation\/new" }, "details": { "path": "vacation\/:id", "name": "Time-off" } }, "setup": { "name": "Setup", "path": "setup\/:id\/:token" }, "example": { "path": "example" }, "contact": { "name": "Contact", "path": "contact" }, "statistics": { "name": "Statistics", "path": "statistics" }, "dashboard": { "name": "Dashboard", "path": "dashboard\/:id\/:hash" }, "today": { "name": "Day Schedule", "path": "today" }, "planning": { "name": "Planning", "path": "planning" }, "dossiers": { "path": "employees\/:id\/dossiers" }, "payslips": { "name": "Payslips", "path": "payslips" }, "documents": { "name": "Documents", "path": "documents", "detail": { "name": "Dokuments", "path": "documents\/:type" } }, "checkins": { "name": "Check-ins", "path": "check-ins" }, "demo": { "path": "demo", "name": "Demo" }, "log": { "name": "Log", "path": "log" }, "plannings": { "path": "planning\/overview", "name": "Overview" }, "resources": { "name": "Resources", "path": "resources", "edit": { "path": "resources\/:id", "name": "Resources" } }, "company": { "name": "Company", "path": "company" }, "2fa": { "setup": { "path": "login\/2fa\/setup", "name": "Two-factor authentication set-up" }, "verify": { "path": "login\/2fa\/verify", "name": "Two-factor authentication" } }, "freelancer_invoices": { "name": "Freelancer Invoices", "myInvoices": "My Invoices" }, "freelancer": { "name": "Freelancer Invoices", "path": "freelancer-invoices" } }, "common": { "status": { "account": { "free": "Active", "trial": "Free trial", "active": "Active subscription", "expired": "Trial expired", "cancelled": "Cancelled", "deleted": "Deleted", "license": "via License" }, "membership": { "active": "active", "inactive": "deactivated", "deleted": "deleted" }, "user": { "active": "active", "inactive": "inactive", "deactivate": "deactivate", "activate": "activate" }, "item": { "planned": "planned", "open": "open", "pending": "pending", "approved": "approved", "denied": "denied" } }, "placeholder": { "email": "john@doe.com", "roster_name": "e.g. ACME Corporation", "company": "e.g. ACME Corporation, Inc.", "full_name": "John Doe", "address": "e.g. Main Street 101", "dd": "DD", "mm": "MM", "yyyy": "YYYY", "vat": "IE1234567X" }, "filter": { "user": "Employee", "duty": "Function", "location": "Planning", "status": "Status" }, "availability": { "available": "available", "unavailable": "unavailable", "vacation": "vacation", "wish": "wish to work", "approved": "approved", "denied": "denied", "limited": "limited availability" }, "role": { "owner": "Owner", "manager": "Manager", "planner": "Planner", "user": "Employee", "supervisor": "Supervisor", "observer": "Observer", "freelancer": "Freelancer" }, "button": { "cancel": "cancel", "submit": "submit", "okay": "okay", "save": "save", "delete": "delete", "invite": "invite employee", "reinvite": "re-invite employee", "confirm": "Confirm", "decline": "Decline", "send": "Send", "unsubscribe": "Unsubscribe", "yes": "Yes", "add": "Add", "enroll": "Enroll", "agree": "Agree", "close": "Close", "no": "No", "withdraw": "Withdraw", "continue": "Continue", "back": "Back", "deny": "Deny", "done": "Done", "logout": "Logout", "next": "Next", "reset": "Reset", "remove": "remove", "edit": "Edit", "complete": "complete", "download": "download", "accept": "Accept", "show": "show", "changegravatar": "Change profile picture", "apply": "Apply" }, "language": { "german": "German", "dutch": "Dutch", "english": "English" }, "country": { "germany": "Germany", "netherlands": "The Netherlands", "usa": "USA" }, "modules": { "basic": "Basic", "hours": "Hour registration and reporting", "availability": "Availability", "appointments": "Appointments", "shifts": "Shifts", "tags": "Tags", "rates": "Salary & Expenses", "balances": "Balances", "sickness": "Sickness", "tentoo": "Tentoo Payroll", "lists": "Lists", "costs": "Cost units", "chats": "Chats", "temper": "Temper", "blueprint": "Blueprint", "weather": "Weather", "vacation": "Vacation", "dashboard": "Dashboard", "today": "Day Schedule", "statistics": "Statistics", "university": "University", "dossiers": "Dossiers", "contacts": "Contacts", "planning": "Planning & roster", "contracts": "Contract management", "onboarding": "Onboarding", "nmbrs": "Nmbrs", "payslips": "Payslips", "documents": "Documents", "checkins": "Check-ins", "clients": "Clients", "resources": "Resources", "calculations": "Calculations", "signature": "Sign Timesheet", "newsletter": "Newsletter", "company": "Company", "freelancers": "Invoicing for Freelancers", "projects": "Projects" }, "nojs": { "headline": "Please activate JavaScript", "text": ["To make ONDURO work, JavaScript must be activated in your browser.", "Please make sure, that no other programs (ad blocker, spam filter...) block access to this website."], "link": "How do I activate JavaScript?" }, "email": { "default_subject": "New message from ONDURO" }, "notify": { "success": { "headline": "Saved", "description": "The changes have been saved successfully." }, "delete": { "description": "The entry has been deleted successfully.", "headline": "Deleted" } }, "cut": "cut", "copied": "copied", "device": { "rotate": "Please turn your screen to use this function" }, "details": "Details", "link_copied": "Link copied to clipboard. This link is PERSONAL for this employee only.", "text": { "businessNumber": "Business Number", "vatNumber": "VAT ID" } }, "label": { "type": "Type", "name": "Name", "location": "Planning", "hours": "Hours", "rate": "Salary", "amount": "Amount", "subtotal": "Subtotal", "total": "Total", "distance": "Distance", "euro": "\u20AC", "km": "km", "premium": "Premium", "until": "until", "date": "Date", "day": "Day", "cost": "Cost unit", "begin": "Begin", "end": "End", "break": "Break", "filter": "Filter", "status": "Status", "expenses": "Expenses", "description": "Description", "items": "Items", "overtime": "Overtime", "salutation": "Salutation", "title": "Title", "fname": "First name", "lname": "Last name", "email": "Email", "email_new": "New email", "email_confirm": "Repeat email", "password": "Password", "password_old": "Old password", "password_new": "New password", "password_confirm": "Repeat password", "company": "Company", "users": "Users", "icon": "Icon", "employee": "Employee", "employees": "employees", "country": "Country", "language": "Language", "role": "Role", "access": "Access", "phone": "Phone", "mobile": "Mobile", "fax": "Emergency number", "address": "Address", "zip": "Zip", "city": "City", "identifier": "Abbreviation", "designation": "Label", "color": "Color", "account_holder": "Account holder", "iban": "IBAN", "bic": "BIC", "time": "Time", "duration": "Duration", "payer": "Manager", "display": "Roster display", "interval": "Timeframe", "quantity": "Quantity", "work_time": "Work times", "action": "Action", "created_by": "Created by", "weeks": "Weeks", "minimum": "at least", "tax_number": "Employee ID", "full_name": "First and last name", "rates": "Salaries", "premiums": "Premiums", "duties": "Functions", "salary": "Salary", "eur_per_km": "\u20AC per km", "payroll": "Payroll", "sick_pay": "Sick pay", "sickness": "Sickness", "balance": "Balance", "previous": "previous", "per_week": "per week", "begin_of_week": "begin of week", "fallback": "Default", "birthday": "Birthday", "vat": "VAT-ID", "contacts": "Contacts", "public": "public", "private": "private", "stats": { "planned": "planned", "worked": "worked", "revenue": "revenue", "costs": "costs", "cost_revenue": "cost\/revenue" }, "locations": "Plannings", "code": "Code", "days": "Days", "invoice": "Invoice", "client_number": "Client number", "invoice_number": "Invoice number", "billing_period": "Billing period", "until_including": "until incl.", "sorting": "Sorting", "vacation": "Time-off", "requested": "Requested", "availability": "Availability", "unit": "Unit", "requests": "Requests", "pending": "pending", "plusmin": "plus \/ min", "dates": "Date(s)", "request": "Request", "month": "month", "week": "week", "min_hours": "Min.", "max_hours": "Max.", "print": "print", "moment": { "last": "last", "current": "this", "next": "next", "custom": "custom" }, "year": "year", "factor": "Factor", "contact_list": "Contacts", "group": "Group", "contract_management": "Contract management", "contract_hours": "Contractual hours", "profile": "Profile", "settings": "Settings", "dossier": "Dossier", "contract_start": "Hire date", "contract_end": "End date", "template": "Template", "payslips": "Payslips", "contract_full": "full-time", "contract_part": "part-time", "days_fixed": "Hours per weekday", "days_flex": "Days per week", "contract_vacation": "Vacation days", "file": "File", "documents": "documents", "fixed_salary": "fixed salary", "filetype": "Filetype", "creator": "Creator", "hourly_salary": "hourly wage", "roster": "Roster", "filled": "Filled", "checkin": "Check-in", "submitted": "submitted", "half_a_day": "half a day", "hours_per_full_day": "hours per full day", "holiday": "Holiday", "changed": "changed", "empty": "empty", "fields": "fields", "client": "Client", "start_date": "Starting", "end_date": "Ending", "plannings": "Plannings", "clients": "Clients", "all_clients": "all clients", "budget": "Budget", "active": "active", "inactive": "inactive", "archived": "archived", "finished": "ended", "clear": "clear", "comment": "Comment", "published": "Published", "unpublished": "unpublished", "signature": "Signature", "url": "URL", "newsletter": "Current Newsletter", "newsletters_old": "previous newsletters", "my_profile": "My Profile", "internal_note": "Internal note", "visible": "visible", "invisible": "invisible", "2fa": "2FA", "2fa_reset": "click to reset 2FA", "2fa_required": "2FA required, but not set-up", "notes": "Notes", "invoice_email": "Invoice e-mail", "kvk_number": "Chamber of Commerce number", "quick_date_filter": "Quick date filter", "invoice_interval": "Invoice interval", "select_client": "Select Client", "project_code": "Project Code", "draft": "Draft", "recurrence": "Add recurring shifts", "recurrence_type": "Recurrence Type", "daily": "Daily", "yearly": "Yearly", "repeat_on": "Repeat On", "project_name": "Project Name", "start_time": "Start time", "end_time": "End Time", "projects": "Projects", "all_day": "All day", "the": "The", "first": "First", "second": "Second", "third": "Third", "fourth": "Fourth", "every": "Every", "last": "Last", "vat_percentage": "VAT percentage", "location_data": "Location", "apply_premiums": "Apply Premiums", "select_premium": "Select Premiums", "hourly_rate": "hourly rate", "invoicing_interval": "Invoicing setting", "invoicing_interval_weekly": "Automatically create invoices; Weekly billing", "invoicing_interval_monthly": "Automatically create invoices; Monthly billing", "invoicing_interval_manual": "Manual billing", "create_new_duty": "Create new duty", "weekly_schedule": "Week Schedule", "enable": "Enable", "edit_project": { "details": "Details Amended Project Schedule" }, "start_date_edit": "Apply changes from", "start_date_edit_hint": "All services from this date will be adjusted according to the new schedule. Services prior to the set date will remain unchanged.", "numberEmployees": "Number of Employees for this shift", "eur_per_minute": "\u20AC per minute", "travel_allowance": "Apply Travel Allowance", "driver": "Driver", "passenger": "Passenger", "overwrite": "Overwrite", "travel_expense_amount": "Travel Expense Amount", "apply_after": "Apply after", "compensation_calc_method": "Compensation Calculation Method", "include": "Include", "deselect_all": "Deselect All", "select_all": "Select All", "total_hours": "Total Hours", "total_cost": "Total Cost", "planning": "Planning", "project_location": "Project location", "select_number_of_cars": "Select the number of vehicles per shift needed for this shift(s)", "override_rate": "Override rate", "person": "Person", "team_members": "Team members", "absence": "Absence\/Disease", "created_at": "Created at", "register_absence": "Calling in sick", "resource": "Select asset or vehicle", "required_capacity": "Required capacity" }, "text": { "from": "from", "until": "until", "open": "open", "users": "Employees", "no_results": "no results", "sick": "sick", "or": "or", "of": "of", "change": "change", "delete": "delete", "optional": "optional", "yes": "yes", "no": "no", "mr": "Mr.", "mrs": "Mrs.", "dr": "Dr.", "prof": "Prof.", "profdr": "Prof. Dr.", "location": "Planning", "contract": "Contract", "info": "Info", "duty": "Function", "shift": "Shift", "account": "Account", "cost": "Cost unit", "workspace": "Workspace", "owner": "Owner", "manager": "Manager", "planner": "Planner", "user": "User", "placeholder": "Placeholder", "placeholder_duties": "Open items", "placeholder_shifts": "Open shifts", "full_time": "Full time", "part_time": "Part time", "flex_time": "Flexible", "monthly": "monthly", "weekly": "weekly", "sunday": "Sunday", "monday": "Monday", "release": "Publish", "released": "published", "week": "Week", "calendar_week": "Calendar week", "calendar_week_short": "W", "today": "today", "yesterday": "yesterday", "in": "in", "on": "on", "to": "to", "since": "since", "new": "New", "confirmed": "confirmed", "unconfirmed": "unconfirmed", "denied": "denied", "approve": "approve", "deny": "deny", "himself": "oneself", "someone": "someone", "previous": "previous", "previous_period": "previous period", "all": "all", "filter": "filter", "deactivate": "deactivate", "activate": "activate", "expired": "unfinished", "page": "Page", "saving": "save", "more": "more", "none": "none", "instead_of": "instead of", "base_salary": "Base salary", "empty": "No data available (yet)", "tag": "Tag", "item": "Item", "sure": "Are you sure?", "more_options": "show options", "search": "Search...", "import": "import", "help": "Help", "days": "days", "day": "day", "legend": "Legend", "selection": { "more": "more", "select": "select", "all": "all", "none": "none", "displayed": "of the <u>filtered<\/u> options", "selected": "selected", "select_all": "select all", "deselect_all": "deselect all", "toggle": "select\/deselect" }, "invited": "invited", "hide_options": "hide options", "month": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], "loading": "loading...", "desc": "descending", "asc": "ascending", "blueprint": "Blueprint", "hours": "hours", "daydays": "day|days", "hrs": "h", "changed": "changed", "unsaved": "unsaved change|unsaved changes", "welcome": "Welcome", "attention": "Attention", "nowayback": "This cannot be undone. Are you really sure?", "current": "current", "dpa": "Data Processing Agreement", "dpa_accept": "I accept version 1.0 of the data processing agreement on behalf of {company} and declare that I am legally authorized to do so.", "review": "Review", "legal": { "not_signed": "This agreement has not yet been accepted.", "signed": "This agreement has been accepted by <b>{name}<\/b> on <b>{date}<\/b>." }, "you": "You", "per_employee": "per employee", "per_item": "per worked shift", "disapprove": "Disapprove", "colleagues": "Colleagues", "billed_at": "billed at", "paid_at": "paid at", "in_days": "in {days} days", "tomorrow": "tomorrow", "no_times": "no timeframe", "labels": "Labels", "paid": "paid", "billed": "billed", "options": "options", "progress": "progress", "contract_salary": "Contract & Salary", "per": "per", "show_details": "show details", "hide_details": "hide details", "fulltime": "full-time", "duration_permanent": "permanent", "duration_temporary": "temporary", "pay_out": "pay out", "fixed": "Fixed", "contract_days_fixed": "regular", "contract_days_flex": "irregular", "per_workday": "per workday", "contract_template": "Contract template", "message": "Message", "per_year": "per year", "signed_by_employee": "signed by employee", "nothing": "Nothing to show here...", "per_month": "per month", "per_hour": "per hour", "generate": "generate", "no_documents": "No documents to show.", "no_checkins": "There are no check-ins at this moment.", "confirm_checkout_membership": "Are you sure you want to check-out {name}?", "confirm_checkout": "Are you sure you want to check-out? You cannot check-in for the same duty.", "checkin_successful": "Checkin successful at {time}", "already_checked_in": "You are already checked in since {time}", "checkin_successful_notice": "You have been successfully checked in", "oclock": "{time}", "past-checkins": "Past check-ins", "details": "Details", "load_more": "Load more", "no_location_data": "No location data available.", "previous_page": "previous page", "next_page": "next page", "free": "free", "added_via": "Added via", "rest_time": "Resting time", "rest": "Rest", "planning_type": { "ongoing": "ongoing", "temporary": "temporary" }, "conflict": "Conflict", "between_and": "between {start} and {end}", "per_duty": "per function", "totals": "Totals", "planned": "planned", "period": "Period", "filters_active": "filters active", "sign": "sign", "2fa_reset": "The user has already succesfully set-up two-factor authentication. Are you sure you want to reset two-factor authentication for this user?", "minutes": "minutes", "tuesday": "Tuesday", "wednesday": "Wednesday", "thursday": "Thursday", "friday": "Friday", "saturday": "Saturday", "hint": { "project_type": { "ongoing": "For projects with no set end date. Shifts are added one year in advance", "temporary": "For temporary projects, with a set start and end date" } }, "disable_project_grouping": "Disable Project Grouping", "enable_project_grouping": "Enable Project Grouping", "once": "Once", "default": "Default", "fixed_compensation": "Fixed compensation", "include_in_totals_tooltip": "Check or uncheck to include in totals", "totals_only_selected_shifts": "Totals are calculated only for selected shifts", "enter_date_after": "Enter a date after", "and_before": "and before", "planning_selected_at_project_level": "Planning is selected at project level", "project_details": "Project details", "similar_items": "Others on this project today", "no_similar_items": "No other team members working on this project" }, "page": { "team": { "headline": "Employees", "registered": "registered", "invited": "invited", "add": "Add employee", "delete": "Delete employee", "delete_confirm": "Do you really want to delete this employee? All data will be deleted immediately!", "saved": "The settings have been updated successfully.", "activate_access": "Activate access", "sidebar": { "general": "General", "text": "coming soon...", "registered_since": "Registered since:", "last_online": "Last seen:", "headline_duties": "Functions", "headline_locations": "Plannings", "tags_hint": "Click in the input field to add a tag. Tag not available? Create a <a href=\"{href}\">new tag<\/a>.", "no_duty": "has no function yet!" }, "fieldset": { "personal_data": "Personal data", "job": "Job", "access": "Login access", "contact": "Contact data", "role": "Roles", "rights": "Additional rights", "costs": "Cost units", "hours": "Timesheet", "availability": "Availability", "balance": "Balance" }, "availability": "Employee may enter availability", "availability_hint": "Please choose, the default availability, if <b>{name}<\/b> has not (yet) specified availability.", "availability_options": ["is by default", "available", "not available"], "balance": "Enable hourly balance for this employee", "hours": "Employee may register hours", "on_cost_label": "on cost unit", "cost_hint": "Choose all cost units, that <b>:name<\/b> may book hours on. If you choose only one, the employee does not have to make a selection during hour registration. All hours will be booked on the selected cost unit automatically.", "cost_empty": "No cost units have been created yet! Create a <a href=\"{href}\">cost unit<\/a> now.", "data_locked": "Some personal data entered by the employee can only be edited by the employee self on their profile page.", "not_verified": "<b>{name}<\/b> has been invited, but has not completed the registration.", "not_accepted": "<b>:name<\/b> has been invited, but has not yet accepted the invitation. Because :name is also connected to another account, you cannot change the email address (:email) used for the invitation.", "no_access": "<b>:name<\/b> has currently no access. By pressing the following button you can re-activate access.", "invitation_expired": "The invitation is unfinished. You have to re-send the invitation email.", "invitation_success": "Invitation successfully sent.", "invitation_failed": { "hint": "is already in use", "message": "This email is already in use within another account. Please contact <a href=\"support@onduro.com\">support@onduro.com<\/a>. We will help you out." }, "text_owner": "Access is mandatory for account owners.", "user": "Employee", "user_is": "Employee is", "user_may": "Employee may", "tabs": { "other": "Other", "infos": "Infos", "tags": "Tags", "rates": "Salary" }, "label": { "about": "About :name", "notes": "Internal notes", "access": "Access", "right_colleagues": "can see all colleagues in the roster", "right_placeholder": "can sign into open items (placeholders)", "right_hours": "can edit timesheet of other employees", "payroll": "is being payed out via {provider}", "right_colleagues_restrict": "only on days where employee is scheduled", "absence\t": "Absence Registration", "absence": "Reporting absence\/sickness" }, "hint": { "role_owner": "may manage everything", "role_manager": "may manage employees and settings", "role_planner": "may plan the roster", "role_supervisor": "approve, deny and edit timesheets", "role_observer": "can see published items on the planning page for selected locations (but not change anything)", "role_manager_restricted": ["cannot edit (employee) settings", "has only access to own documents"], "role_freelancer": "A Freelancer has the same rights as an employee, but can generate invoices for their own hours worked.", "multiple_shifts": "Do you need more capacity for this shift? Create this shift multiple times.", "override_rate": "Override the default hourly rate for this duty", "notes_visibility": "This note will be visible to all employees in the planning" }, "empty": "No employees created yet.", "email_existing": "This email address already exists for another employee.", "blueprint": { "hash": "blueprint", "headline": "Blueprint", "info": "This is the blueprint for new employees. You can decide, which settings a new employee will be assigned by default. You can activate or deactivate blueprints at any time by clicking on the switch at the top right.", "active": "active", "inactive": "inactive" }, "supervisor": "Employee may supervise timesheets of colleagues", "accountant": "Employee has access to reporting", "of_cost_label": "of cost unit", "restrictions": { "locations": { "all": "for all plannings", "own": "only for associated plannings", "some": "only for certain plannings" }, "duties": "only for items with own <u>functions<\/u>" }, "deactivate": { "confirm": { "headline": "Really deactivate?" }, "text": "Deactivated employees cannot be scheduled or login." }, "activate": { "confirm": { "headline": "Really activate?", "text": "Activated employees possibly cause subscription costs. Please check your subscription details." } }, "vacation": "Employee can request vacation", "import": "To import your own staff, please contact support via the \"Help\" link. We will upgrade your demo access to a regular account first.", "bulk_delete": "Delete employees", "delete_bulk_text": "All scheduled items in the future will be removed for this user! Historic data will be preserved.", "bulk_text": "Are you sure you want to {action} selected employees?", "bulk_invite": "Invite employees", "bulk_activate": "Activate employees", "bulk_deactivate": "Deactivate employees", "invited_notify": "Selection has been invited.", "add_limit": "You have reached the maximum amount of employees on your plan. Either deactivate employees or upgrade your plan.", "dossier": { "sidebar_note": "This is where you can store some internal information about this employee." }, "user_deactivated": "Employee is deactivated.", "settings": { "warn": "Please note: the settings below only take effect once the employee has been invited and successfully completed the registration." }, "invitation_no_email": "You must enter an email address and save it to grant {name} access.", "invitation_invite": "{name} has <u>no<\/u> access to ONDURO yet. Click the button below to grant {name} access via a personal login.", "profile": { "note": "Todo: Go to the tab \"settings\" to assign at least one function to {name}." }, "bulk_edit": "Edit settings", "contract": { "vacation": "employee may request vacatin", "none": "No contract set yet.", "salary": "You can change the hourly rate for this employee here." }, "balance_overview": "Allow employee to see balances of other employees", "expenses": { "general": "Employee may declare expenses (in \u20AC)", "travel": "Employee may declare travel expenses (in km)" }, "registration_link": "Copy registration link to clipboard", "hours_add": "may specify hours without being scheduled", "invitation_conflict": "<b>This e-mail address is already linked to a user in another account.<\/b><br><br>Remove the e-mail address in the other account first, before inviting the user in this account.<br><br>Or remove the user in <u>this<\/u> account and provide an e-mail address <b>while adding<\/b> the user.", "role_manager_restricted": "with limited access", "signature_supervisor": "may only collect signatures", "balance_holidays_always": "Always add holidays to hour balance", "absence": { "notes_placeholder\t": "Additional notes about the absence (Optional)", "history": "Absence History", "delete": "Delete Absence", "delete_confirm": "Are you sure you want to delete this absence record?", "export": "Download as Excel", "notes_placeholder": "Additional notes about the absence...", "sidebar_note": "Register employee absences such as sickness. You can leave the end date empty and add it later when the employee returns.", "actions": "Actions" } }, "roster": { "element": "Item", "undroppable": { "text": "cannot be scheduled here.", "past": "This day is in the past.", "billed": "This period has already been billed.", "confirm": "schedule anyway", "blocked": "This day has been blocked.", "closed": "This day is off." }, "time": { "delete": { "error": { "headline": "Times cannot be removed." } }, "error": { "headline": "Times cannot be saved.", "ERR_TIMES": "You have to provide a start and end time.", "ERR_CONFIRMED": "Registered hours for this item have already been approved.", "ERR_OVERLAP": "is already scheduled in the given period.", "ERR_OVERLAP_REMOVAL": "is already scheduled this day. Times cannot be removed.", "ERR_EQUAL": "Start and end time have to differ.", "ERR_NEGATIVE": "Total duration cannot be negative. Adjust break time." } }, "user": { "delete": { "error": { "headline": "Employee cannot be removed." } }, "has_hours": { "headline": "Item has registered hours!" }, "change": { "ERR_HOURS": "Hours have already been registered for this item. Do you want to remove these hours and assign another employee?" }, "remove": { "ERR_HOURS": "Hours have already been registered for this item. Do you want to remove these hours together with the employee?" }, "error": { "headline": "Employee cannot be saved.", "ERR_CONFIRMED": "Registered hours for this item have already been approved.", "ERR_OVERLAP": "is already scheduled in the given period." } }, "item": { "delete": { "error": { "headline": "Item cannot be removed." }, "ERR_HOURS": "Hours have already been registered for this item. Delete item anyway including registered hours?", "ERR_CONFIRMED": "Hours have already been registered and confirmed for this item. Delete item anyway including registered hours?" }, "has_hours": { "headline": "Item has registered hours!" }, "via_hours": "added via timesheet", "driver": "Marked as driver" }, "sick": { "ERR_HOURS": { "headline": "Item has registered hours!", "text": "Hours have already been registered for this item. Delete hours and mark as sick?" }, "ERR_TIME": { "headline": "Item has no working hours!", "text": "Working hours (or shifts) are required for items marked as sick." } }, "shift": { "error": { "headline": "Shift cannot be saved.", "ERR_CONFIRMED": "Registered hours for this item have already been approved.", "ERR_OVERLAP": "is already scheduled in the given period." } }, "add": { "error": { "headline": "Item cannot be scheduled!", "headline_choose": "Employee is already scheduled", "ERR_UNAVAILABLE_LIMITED": "has limited availability on that day. Continue?", "ERR_UNAVAILABLE_DENY": "cannot be scheduled on this day.", "ERR_UNAVAILABLE_WARN": "is not available on that day. Schedule anyway?", "ERR_EXISTING_FULL": "is already planned for an indefinite period on that day. As long as the existing item has no working times, no other item can be scheduled.", "ERR_EXISTING_SHIFT": "is already planned for a shift on that day. As long as the existing shift is not being removed, no other item can be scheduled.", "headline_limited": "Employee has limited availability" } }, "signin": { "error": { "headline": "Not possible!", "text": "You already work that day!" } }, "signout": { "headline": "Signout requested", "text": "You are still scheduled for this item until a planner confirms your request for sign-out." }, "move": { "error": { "headline": "Item cannot be moved!", "ERR_OVERLAP": "The moved item overlaps with another scheduled item of", "ERR_CONFIRMED": "Registered hours for this item have already been approved.", "ERR_OPEN_CHECKIN": "Item has not been checked-out." } }, "comments": { "error": { "headline": "Add comment", "text": "Please enter message." } }, "headline": "Roster", "for": "for", "from": "from", "until": "until", "current_week": "current week", "since_current_week": "since current week", "legend": "Legend", "ical_subscribe": { "headline": "Subscribe to calendar", "text": "You can subscribe to the calendar at the following address:" }, "release_error": "Roster could not be published.", "context": { "headline": "Schedule employee:", "delete_text": "Drag here to delete!", "distance_hint": "See below for distance between this location and employee's home address.", "info_hint": "See below how often and how long a employee has been scheduled at this location since the latest release date." }, "tools": { "time": "Time", "shift": "Shift", "duty": "Item", "user": "User", "until": "until", "application": "Employee requests to be signed out of this item.", "approve": "Approve", "deny": "Deny", "apply": "Apply", "cancel": "Cancel!", "signin": "Sign in", "signout": "Sign out", "switch": "Switch", "work": "Do work!", "empty_users": "no availability", "empty_duties": "no function available", "filtered_tags": "Attention: Selection filtered by tags", "tags_none": "No tags available for scheduled employee.", "tags_user": "You can only add tags that are available for the scheduled employee.", "tags_all": "Click in the input field to add a tag. Tag not available? Create a <a href=\"{href}\">new tag<\/a>.", "totals": "Total number of planned (not yet released) items \/ hours across all plannings and functions", "sick": { "payment": "Sick pay", "apply": "Sick", "undo": "Not sick", "payroll_payment": "Sick pay is controlled by payroll for this employee.", "needs_time": "Item needs a start and end time (or shift) in order to be marked as sick. Please add first.", "no_costs": "Time tracking not enabled for this employee.", "headline": "Choose the applicable settings for:", "balance": "Hours for balance", "hint": "Choose percentage of sick pay.", "balance_note": "Scheduled working hours will be credited 100% for the employee\\'s hour balance.", "sko": "Please choose the type of sick leave." }, "revoke_application": "Revoke application", "applied_at": "Applied at<br>{date}" }, "placeholder": { "comment": "Internal note (only visible for planners en observers)" }, "matching": { "headline": "Fill open shifts", "button": "Wizard", "info": "Open shifts will be filled with available employees within the chosen timeframe.", "remove": "remove scheduled employees from items in chosen timeframe", "error": "Start date must be after release date.", "removed": "Successfully remove employees from <b>:removed<\/b> items!", "matched": "Successfully matched employees to <b>:matched<\/b> items! <b>:unmatched<\/b> items could not be matched." }, "flash": { "success": { "headline": "Success!", "message": "The roster has been published until (including):<br><br><strong>:date<\/strong>" } }, "release": { "headline": "Release planning", "text": "Release roster until including: <b>{date}<\/b><br><br>If you choose to release the roster until the given date, all scheduled employees with access will be notified via email. They will be able to view the published roster until the release date.<br><br>It'll still be possible to make changes. Changes will trigger immediate notifications to affected employees.", "success": "The roster has been released succesfully!" }, "revoke": { "headline": "Revoke release", "text": "Release planning until including: <b>{date}<\/b><br><br>If you choose to revoke the roster to the given date, all scheduled employees with access will be notified about the changed release date via email.<br><br>Employees will only be able to see duties up until the new release date." }, "duty": { "error": { "headline": "Function cannot be changed" } }, "bulk": { "selected": "items selected", "note": "If you're done selecting, choose one of the following actions.", "pasting": "Paste the items somewhere in the roster!", "cut": "cut", "copy": "copy", "duplicate": "duplicate", "match": "match", "empty": "empty", "delete": "delete", "error": { "resolve": "You need to resolve the conflicts first!", "released": "You cannot perform this action in the published roster.", "paste_released": "You cannot paste items in the released roster!", "latency": "Some of the items have changed while you were performing this action. Please refresh the roster page and try again." } }, "observer_note": "You are an observer on the planning page. Therefore you cannot make changes to the planning.", "published_until": "Published until here", "apply": { "error": { "text": "You already applied for this item", "headline": "Not possible!" } }, "revoke_application": { "error": { "headline": "Not possible!", "text": "You have not applied for this item" } }, "preset": { "return": "return to planning", "template": "Edit template", "info": "For each planning, you can fill up to 4 weeks in the template. Then you can easily copy the preset and paste it into the current planning.", "template_paste": "Paste template" }, "to_projects": "Manage projects" }, "reports": { "remove": { "headline": "Delete report", "text": "Do you really want to delete this report?" }, "save": { "headline": "Save report" }, "saved": "Report saved successfully!", "without": "without", "hours": "Hours", "overview": { "headline": "Hour reporting", "empty": "No saved reports available.", "info": "You can create as many reports as you like. It's possible to create multiple reports for the same timeframe. This way you can create reports per employee or planning..." }, "filter": { "headline": { "new": "New report", "existing": "Report" }, "filter": "Apply filter", "more": "show more filters", "empty": "No results in given timeframe.", "stats": { "duties": "Items", "expected": "Planned", "reported": "Reported", "overtime": "Overtime", "salary": "Salary" }, "show_details": "Show all details" }, "point": "Reporting period", "add": "Create report", "hints": "Hints", "unapproved": "Hours in brackets have been registered, but not yet confirmed.", "missing": "The following employees have not yet registered hours in given timeframe:", "complete": "All hours have been registered in given timeframe!", "created_at": "created at", "approved_at": "approved at", "approved_by": "approved by", "sick_pay": "Sick pay", "salary": "Salary", "actions": "Actions", "edit": "Edit hours", "no_cost": "Hours without cost unit", "download": "Download", "xls_title": "Report", "edit_hours": "Edit hours", "back": "back to overview", "no_hour": "Unregistered hours", "download_warn": { "headline": "Not all hours (regardless of the 'status' filter) have been approved in the selected period:", "open": "not yet registered", "pending": "not yet approved", "planned": "in the future", "denied": "denied", "footer": "Do you still want to download the selected hours?" }, "labels": { "add": "Add label", "remove": "Remove label", "headline": "Edit labels" }, "export": { "headline": "Export to payroll", "notice": "Are you sure you want to trigger the payroll for all employees and locations (regardless of the set filters) in the selected period? Note: only unpaid hours will be paid!", "warning": "Not all hours have been approved. The payroll can only be triggered if all hours in the selected period have been filled in and approved.", "incomplete": "Not all employees are fully registered. No salary run can be executed for employees who are not fully registered." }, "downloads": { "per_employee": "per employee", "per_client": "per client", "per_planning": "per planning", "billable": "Approved per planning" }, "generateInvoice": { "title": "Generate Invoice", "button": "Create Invoices", "period": "Generate invoice for the period", "until": "until", "for_freelancers": "For freelancers:", "all_freelancers": "For all freelancers" } }, "lists": { "remove": { "headline": "Delete list", "text": "Do you really want to delete this list?" }, "save": { "headline": "Save list" }, "saved": "List saved successfully!", "filter": { "headline": { "new": "New list", "existing": "List" }, "stats": { "items": "items", "expected": "Hours" }, "released_only": "only published items", "placeholder": "Open duties", "assigned": "Assigned duties", "with_unpublished": "with unpublished items", "notes": "show notes" }, "overview": { "empty": "No saved lists available.", "info": "Create lists based on scheduled items.", "headline": "Lists" }, "add": "Create list", "xls_title": "List" }, "settings": { "role_manager": { "confirm": "Managers have access to ALL employee data and account settings. Make sure you trust this employee to handle this role responsibly." }, "role_accountant": { "confirm": "Accountants have access to hours entered by other employees. Possibly also to salaries and expenses. Make sure you trust this employee to handle this information with care." }, "general": { "headline": "General settings", "fieldset": { "roster": "Basic", "invoice": "Invoice address", "expenses": "Expenditures and travel expenses", "various": "Various" }, "expenses": { "general": "Employees may declare expenses (in \u20AC)", "travel": "Employees may declare travel expenses", "travel_auto": "Calculate travel expenses automatically", "travel_note": "Attention: to calculate travel expenses automatically, zip codes are mandatory in both the employee's profile and planning settings!", "assign_driver": "Assign the driver as follows:", "driver_role": "Distinguishing between drivers and passengers", "passenger_threshold": "Compensate travel expenses of passengers after" }, "placeholders": "Signup in placeholder must be confirmed by planner.", "contacts_visibility_public": "public", "contacts_visibility_public_hint": "visible for all employees of this account", "contacts_visibility_private": "private", "contacts_visibility_private_hint": "only visible for managers and planners", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "vat_exempt": "VAT exempt", "roster": { "must_apply": "Employees must apply for open duties", "hide_names": "Restrict planner role (hide names, no access to plannings overview)" }, "2fa": "Require two factor authentication for account owner, managers and planners", "invoice_interval": { "weekly": "Weekly", "monthly": "Monthly", "4weeks": "Four-weekly" }, "auto_invoicing_hint": "Enable automatic invoicing to automatically generate and send invoices after each interval names the freelancers" }, "locations": { "headline": "Locations", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Add location", "edit": "Edit location", "empty": "No planning added yet.", "moved": "The \"locations\" settings have been moved to the planning page. You can now add\/edit your locations from the \"plannings\" management page.", "info": "Note: we have renamed \"locations\" to \"plannings\". This gives you more flexibility. You can create a planning for a fixed \"location\" or a temporary \"project\"." }, "jobs": { "headline": "Jobs", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Add job", "edit": "Edit job", "empty": "No job created yet.", "type": { "full": "Full time", "part": "Part time", "temp": "Flexible" } }, "duties": { "headline": "Functions", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Add function", "edit": "Edit function", "empty": "No function created yet.", "rest_label": "h after each duty" }, "shifts": { "headline": "Shifts", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Add shift", "edit": "Edit shift", "empty": "No shift created yet." }, "costs": { "headline": "Cost units", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Add cost unit", "edit": "Edit cost unit", "empty": "No cost unit created yet." }, "availability": { "headline": "Availability", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "users": { "fieldset": "Employees", "label": { "before": "Availability must be entered", "after": "week(s) in advance." }, "hint": "Employees cannot change availability within this period." }, "planners": { "fieldset": "Planner", "label": "When trying to schedule <u>unavailable<\/u> employees in the roster:", "deny": "deny", "warn": "warn", "allow": "allow" }, "options": { "fieldset": "More options", "constrainable": { "label": "Employees may constrain availability hourly", "hint": "e.g. available from 16:00" }, "editable": "Planners my change availability of other employees", "blank": "Show availability not filled-in as empty", "vacation": "Employees may request vacation" } }, "tags": { "headline": "Tags", "add": "Add tag", "edit": "Edit tag", "empty": "No tags created yet." }, "rates": { "headline": "Salaries", "add": "Add salary", "edit": "Edit salary", "empty": "No salary created yet.", "hint": { "amount": "gross hourly salary", "factor": "conversion factor for cost calculation" } }, "premiums": { "headline": "Premiums", "add": "Add premium", "edit": "Edit premium", "empty": "No premiums created yet." }, "holidays": { "headline": "Holidays", "empty": "No holidays created yet.", "add": "Add holiday", "notes": "Please choose the appropriate holidays for your company or add custom holidays.", "edit": "Edit holiday" }, "contracts": { "add": "Add template", "edit": "Edit contract", "empty": "No contract template created yet.", "upload": "Upload template", "change": "Change template", "modal": { "info": "Here you can upload a template in .doc or .docx format." } }, "checkin": { "fieldset": { "location": "Planning", "time": "Check-in time", "open": "Open check-ins" }, "location": { "required": "Only allow check-ins with location", "range": { "before": "Only allow check-ins within", "after": "meters" } }, "before": { "min": { "before": "Employees must check-in at least", "after": "minutes before shift starts" }, "max": { "before": "Employees may check-in max.", "after": "minutes before shift starts" } }, "handle": { "open": "Automatic check-out after" }, "hints": { "range": "This setting works only with full address information for your plannings." } } }, "availability": { "sidebar": { "change": "Change selection to", "selection": "Your selection", "deselect": "cancel selection", "constraints": "Restrict time", "status": "Vacation status", "hint": "Tip: Hold the control\/command-key down to select multiple days." }, "error": { "mixed_constraints": "Time constraints may not differ on selected days.", "status": "You need to chose a vacation status.", "invalid_constraints": "Invalid time constraints.", "incomplete_constraints": "Time constraints on vacation days require start and end time.", "conflict": "The following dates could not be updated because the planner has already taken your previous availability into account.<ul><li>{dates}<\/li><\/ul><div class=\"note\">Get in touch with your planner to request any changes to your availability on these dates.<\/div>" }, "legend": { "vacation_requested": "vacation (requested)", "vacation_denied": "vacation (denied)", "vacation_approved": "vacation (approved)", "holiday": "holiday" }, "from": "from", "until": "until", "headline": { "planner": "Overview", "user": "My availability" }, "button": { "overview": "All", "mine": "Mine" }, "tools": { "hint": "<b>Select one or more days<\/b> to choose your availability.", "default": "By default you are: <b>:availability<\/b>", "multiselect": "<b>Tip:<\/b> Hold down the \"shift\" key to select multiple days.", "selection": { "you_have": "You have", "day": "day", "days": "days", "selected": "selected" }, "vacation": { "headline": "Process vacation request", "approve": "approve", "deny": "deny", "unapproved": "Your vacation is not yet approved!", "denied": "vacation denied" }, "tooltip": { "pending": "vacation pending", "denied": "vacation denied" }, "constraints": { "headline": "Add a time constraint", "hint": "only possible, when you're available" }, "change_to": "Change selection to", "reset": "reset selection", "request": "request", "register": "register" }, "dropdown": "All plannings", "defaults": "Availability" }, "overview": { "welcome": { "headline": "Welcome, {name}!", "text": "Start by completing your profile data.<br><br><a href=\"{href}\" class=\"box-button\">To profile<\/a>" }, "checklist": { "headline": "Complete these steps to publish your first roster:", "shifts": "Edit shifts", "duties": "Schedule items", "users": "Invite employees", "publish": "Publish roster" }, "headline": "Welcome", "unbilled": "unregistered hours|unregistered hours", "approve_hours": "Approve hours", "sidebar": { "headline": "My upcoming duties", "empty": "Nothing scheduled.", "no_locations": "You have no access to the roster currently, because you haven't been assigned to any planning." }, "unapproved": "pending approval|pending approvals", "processable": "1 vacation request is pending approval.|{processable} vacation request are pending approval.", "vacation_requests": "vacation request|vacation requests" }, "balances": { "added": "added", "note_overview": "Only approved hours are taken into account.", "note_current": "Your current balance is: <em>{saldo} hours<\/em> Hours of the current week (from {date}) are not taken into account." }, "account": { "headline": "Account management", "delete": "Delete account", "delete_confirm": "Are you sure you want to delete your account? All data will be irreversibly deleted!", "unsubscribe": "Cancel subscription", "unsubscribe_confirm": "Do you really want to cancel your subscription? You can continue to use your account until the end of the current billing cycle!", "saved": "All data saved successfully.", "trial": { "expiration": "You can use ONDURO free until <strong>{expiration}<\/strong>.", "days": "That's {days} more day.|That's {days} more days.", "expires_today": "You can use ONDURO free until today. Want to continue with easy staff scheduling? Make sure to activate your subscription!" }, "active_trial": { "note": "You only have to pay from :period_start. You will receive your first invoice on :invoice_date.", "box1": { "headline": "Free trial", "until": "until including", "description": "You don't have to pay anything until this date!<br>Want to cancel? Do it before this day." }, "box2": { "headline": "Active employees", "period": "in current billing cycle", "description": "Based on this number we'll calculate the invoice amount." } }, "active": { "note": "The next invoice will be generated on <strong>{nextInvoice}<\/strong> for the usage from {billingStart} until including {billingEnd}. Please make sure you have added your current billing information below!", "box1": { "headline": "Billing period", "until": "until including", "description": "That's :days more days." }, "box2": { "headline": "Active employees", "period": "in current billing cycle", "description": "Number of already activated + newly created \/ activated employees." }, "box3": { "headline": "Expected costs", "period": "in upcoming invoice", "description": "Expected costs based on activated employees in current billing cycle." } }, "cancelled": { "note": "You can use ONDURO until finally <strong>{expiration_date}<\/strong> or delete your account immediately.", "box1": { "headline": "Billing cycle", "until": "until including", "description": "That's :days more days." }, "box2": { "headline": "Active employees", "period": "in current billing cycle", "description": "Number of already activated + newly created \/ activated employees." }, "box3": { "headline": "Expected costs", "period": "in final invoice", "description": "Expected costs based on activated employees in current billing cycle." }, "info": "You will receive your final invoice on <strong>:invoice_date<\/strong>. The amount will be deducted automatically from your bank account." }, "subscription": { "title": "All inclusive for", "per_user": "per active employee", "per_month": "per 30 days", "benefits": ["including all functionality", "always full cost control", "cancel any time", "secure payment via direct debit"], "subscribe": "Subscribe now", "start": "the paid period begins on", "success": "Your subscription has been activated successfully!<br>Thank you!" }, "unsubscription": { "success": "Your subscription has been cancelled successfully!<br>Thanks for having been our customer!" }, "support": "Any questions? Send us a <a href=\"#\" class=\"box-intercom\">message<\/a>. We'll be glad to help!", "sidebar": { "discount": { "headline": "Discount code" }, "status": { "headline": "Status", "text": "This information will be shown in the address book:", "free": "Your account is active.", "trial": "Trial period until", "registered_since": "Registered since", "subscribed_since": "Subscribed since" }, "owner": { "headline": "Data Controller (GDPR)" }, "invoices": "Invoices", "license_code": "License code" }, "license": { "note": "You are using ONDURO via a license code.", "error": "This license code is not valid or has expired." }, "demo": "You are currently using ONDURO in the free demo." }, "profile": { "headline": "Your profile", "account": "Subscription", "delete": "Delete profile", "delete_confirm": "Do you really want to delete your profile? All data will be irreversibly deleted!", "saved": "Your profile has been updated successfully.", "gravatar": "Register at <a href=\"https:\/\/www.gravatar.com\/\" target=\"_blank\">Gravatar<\/a> to add your profile photo.", "fieldset": { "personal_data": "Personal data", "address": "Address book", "other": "Other" }, "about": { "label": "About you", "placeholder": "Experience, qualifications, etc.", "hint": "these details are only visible for planners" }, "sidebar": { "address": { "headline": "Address book", "text": "Only information provided by you will be shown in the address book." }, "password": { "headline": "Change password", "text": "To change your password, click on the following button and follow the steps in the dialogue.", "button": "Change password" }, "email": { "headline": "Change email address", "text": "Did your email address change?", "button": "Change email address" } }, "picture": "Profile picture", "progress": "You have completed {filled} of the {required} required fields. {remaining} fields to go!", "filled": "You have completed all required fields!", "contract": "This is your contract. Please download, sign and re-upload.", "message": { "freelancerDataSuccess": "Profile and freelancer data successfully saved" }, "apply_from": { "headlin": "Confirm change", "text": "The changes are saved immediately. Here you can search for a dateum from when these changes will be included in the Delta function.", "label": "Apply from" } }, "notifications": { "fieldset": { "roster": "Roster", "hours": "Hours" }, "info": "Choose here, which notifications you want to receive.", "saved": "Your settings have been updated successfully.", "roster_mine": { "label": "Schedule changes", "hint": "notifies you when there are any changes in your own schedule" }, "item_changed": { "label": "Item changes", "hint": "notifies you when any changes in the published roster occur" }, "unbilled": { "label": "Register hours", "hint": "reminds you of any hours, that need to be registered" }, "unapproved": { "label": "Approve hours", "hint": "reminds you of any hours, that need to be approved" }, "open_duty": { "label": "Open items", "hint": "reminds you of items with unassigned employees" }, "item_upcoming": { "label": "Upcoming shifts", "hint": "get a notification one day prior to scheduled shifts" } }, "hours": { "headline": { "mine": "My hours", "all": "All hours" }, "note": { "mine": "You have to register hours. Check your working hours, make changes if appropriate and approve by clicking on the checkmark.", "pending": "These hours are pending approval. You can still make changes while they're pending.", "approvable": "These hours still have to be approved or denied.", "approved": "Approved hours are displayed monthly. You can change the selected month in the dropdown above." }, "actionable": "To be registered", "pending": "Pending", "approvable": "To be approved", "approved": "Approved", "empty": "all hours have been registered", "no_cost": "no cost unit", "error": { "times": "Please fill in valid working hours." }, "confirm_delete": "Caution! The related shift will be permanently removed from the roster!", "comment": "Add comments...", "checkins": "To confirm", "unsigned": "Unsigned" }, "update": { "headline": "ONDURO has been updated", "text": "The application will be updated automatically by clicking on the following button.", "button": "Load update" }, "history": { "item": { "added": "added an item to the :released roster:", "changed": "changed an item in the :released roster:", "removed": "removed an item from the :released roster:", "signed_in": "signed :who into a placeholder:", "signed_out": "signed :who out of an item in the roster:" }, "hour": { "added": "has registered hours:", "added_for": "hat registered hours for :who:", "changed": "has changed registered hours:", "changed_for": "has changed registered hours for :who:", "approved": "has approved hours registered by :who:", "denied": "has denied registered hours from :who:" }, "roster": { "released": "released the roster:", "revoked": "changed the publication date of the roster:" } }, "contacts": { "no_access": "no access", "not_verified": "not yet registrated", "download": "Download" }, "modules": { "descriptions": { "basic": "The duty roster serves as the basis for the planning.", "hours": "Let employees register hours and create reports with one click.", "availability": "Let employees fill in their availability.", "shifts": "Enables pre-defined shifts for items in the roster.", "tags": "Create tags for roster items or employees.", "rates": "Automatically calculates hourly salaries and lets employees handle expenses.", "balances": "Enable hour balances and give employees access to their current balance.", "sickness": "Mark items as sick in the roster.", "tentoo": "Enables a direct connection to Tentoo Payroll.", "costs": "Assign hours to various cost units.", "lists": "Create lists based on scheduled items.", "chats": "Messaging among employees", "temper": "Integrate Temper.works", "blueprint": "Define default settings for new employees.", "weather": "7-day weather forecast in the roster. Requires zip code in planning settings.", "vacation": "Vacation planning and management.", "dashboard": "Provide a dashboard for today's planning.", "today": "Enable an overview page with a daily schedules.", "statistics": "Get insights and statistics about scheduled vs. worked hours, salaries and costs.", "university": "Get instant help articles and learn all about ONDURO.", "dossiers": "Store additional information of employees.", "contacts": "Show contacts page for easy access to employee's contact data.", "planning": "Create and publish rosters, let employees see their scheduled duties.", "contracts": "Manage contracts for employees.", "nmbrs": "Manage certain data for the Nmbrs export.", "onboarding": "Provide onboarding information for new employees.", "payslips": "Offer downloadable payslips to employees.", "documents": "Document center for payslips, user uploads and contracts.", "checkins": "Let employees check-in and out of their upcoming duties.", "clients": "Organize your plannings by clients.", "resources": "Manage resources and add them to the planning.", "calculations": "Automatically calculate totals across all plannings.", "signature": "Adds a signature pad to pending times in the timesheet.", "newsletter": "Add a newsletter to the dashboard by including a url to your external newsletter source.", "company": "Display a company page for employees.", "freelancers": "Generate and share (automatically) invoices for freelancers and view them in a convenient overview", "projects": "The projects module helps manage and track projects efficiently. Users can create, update and monitor projects with details such as client information, location, budget, scheduling and billing. It supports shift assignment, work hour recording and travel expense management." }, "note": "Extend ONDURO's functionality with these tools. Choose the tools that match your workflow.", "requires": "Requires", "errors": { "dependency": "This tool cannot be deactivated, because these tools are dependent on it", "dependent_on": "Tool requires" } }, "logout": { "confirm": { "headline": "Logout", "body": "Do you really want to logout?" } }, "invoice": { "footer": { "service_of": "is a service of" }, "thanks": "Thanks for being our customer!", "charge_date": "The amount will be debited from your bank account automatically on {chargeDate}." }, "vacation": { "status": { "pending": "pending", "processed": "processed", "approved": "approved", "denied": "denied", "withdrawn": "withdrawn", "removed": "removed", "request": "request", "requested": "requested", "credit": "credit", "debit": "debit", "new": "new", "changed": "changed" }, "new_request": "Vacation", "new_credit": "Credit", "days_selected": "days selected", "current_balance": "Your remaining paid time-off balance is:", "request": { "empty": "Choose available dates for this request from the calendar", "above": "above", "right": "on the right" }, "duration": { "full": "full day", "morning": "until noon", "afternoon": "from noon" }, "headline_new": "New Time-off", "note": { "start": "Please start by selecting an employee from the list!", "processed": "Your request has been processed.", "pending": "Your request is being reviewed.<br><br>You will be notified as soon as it is processed.", "tracking": "This is where you can determine how much paid time-off will be deducted from employee's vacation balance.", "changed": "Your have changed the request. Don't forget to save it!" }, "amount": "Time-off", "days": "Vacation days", "sidebar": { "current_balance": "Current balance", "deduct": "paid time-off", "new_balance": "New balance", "average": "average of {average} per vacation day", "remaining_balance": "Remaining balance" }, "stats": "{days} days requested, {approved} approved", "allow": "allow", "deny": "deny", "credit": "credit", "debit": "debit", "edit": "Update balance", "compensation": { "vacation": "paid time-off", "overtime": "for overtime", "none": "unpaid time-off" }, "vacation_request": "Vacation request", "submit": "submit", "amount-paid-hours": "Amount of paid hours", "holiday-type": "Holiday type", "empty": "There are no vacation requests for this year yet.", "empty-planner": "There are no vacation requests for this year yet or you have selected too many filters." }, "setup": { "contact": "Get in touch", "loading": "Loading your data...", "headline": "One more step", "error": { "SETUP_COMPLETED": "You have already completed the set-up! Click on the following button to log-in:", "INVALID_CREDENTIALS": "Something went wrong. Please get in touch with us via the following button:", "general": "We couldn't retrieve your data. Please get in touch with us via the following button:" } }, "statistics": { "sidebar": { "headline": "Timeframe", "cluster": "Cluster by" }, "tabs": { "details": "Details", "overview": "Overview" }, "content": { "chosedata": "Please pick a timeframe to receive some stats." } }, "today": { "working": "Who is working today?", "empty": "There's no one scheduled today." }, "chats": { "new": { "headline": "New chat" }, "participants": { "headline": "Chat participants" } }, "subscription": { "choose_plan": "Choose your plan", "monthly": "per month", "billing": { "before": "in advance", "after": "afterwards" }, "cancel": "cancel", "subscribe": "Subscribe to service", "change": "Change plan", "choose": "Click to choose", "chosen": "Current selection", "selection": "New selection", "active_users": "active employees", "plans": { "fix": "Fixed", "flex": "Flex", "legacy": "Legacy", "custom": "Custom" }, "more_info": "Check out <a href=\"https:\/\/www.onduro.com\" target=\"_blank\">www.onduro.com<\/a> for more infos en details about our plans." }, "myroster": { "tabs": { "mine": "My duties", "open": "Open duties", "all": "All duties" }, "empty": "Nothing scheduled.", "next_month": "to next month", "headline": "Roster", "headline_mine": "My duty", "headline_open": "Open duty", "sidebar": { "show_all": "show all days", "show_locations": "show plannings", "no_colleagues": "There are no colleagues scheduled (yet).", "note": "You are already scheduled on the circled days (see tab \"my duties\").", "warn": "Check the \"my duties\" tab for your personal schedule (across all plannings)." }, "details": { "warn_multiple": "you are scheduled for multiple duties this day!", "signed_out": "The cancellation of this duty is being processed. Changed your mind? Click on the button below to work this duty:", "confirmed": "You have confirmed this duty on {date}.", "info_assigned": "You are already scheduled in another duty that day!|You are already scheduled in {items} duties that day!", "info_placeholder": "There is 1 more open duty that day.|There are {items} more open duties that day" }, "no_duty": "no duty" }, "payslips": { "empty": "No payslips have yet been deposited for you." }, "documents": { "note": "In the document center, you can easily download and display all documents. Here you will find payroll documents as well as contracts and user uploads. You can upload and delete these documents in the employee profile." }, "log": { "changed": "The following changes have been made:", "note": "A maximum of 30 days can be shown.", "filter_keys": "Filter on changes in" }, "clients": { "add": "Add client", "edit": "Edit client" }, "plannings": { "title": "Plannings", "add": "Add planning", "edit": "Edit planning", "tooltip": { "link": "You are not linked to this planning!", "inactive": "You cannot view inactive plannings." }, "button": "Manage plannings" }, "resources": { "add": "Add resource", "delete": "Delete resource", "delete_confirm": "Do you really want to delete this resource? All data will be deleted immediately!" }, "login": { "2fa": { "setup": ["Scan the following qr code with <b>Google Authenticator<\/b>:", "and enter the generated code here:"], "lost": "If you've lost access to your Google Authenticator app, contact your manager to set up two-factor authentication again.", "required": "The company you are logging in for requires a two-step verification. You must first set this up before you can log in.", "failed": "Two-factor verification failed. Try again." } }, "projects": { "add": "Add project", "edit": "Edit Project", "title": "Projects", "travel_allowance": { "hint": "Apply the travel allowance as set in the settings from the company location to the project location." } } }, "error": { "button": { "to_login": "to login", "to_homepage": "to home page", "to_referrer": "to previous page" }, "general": { "title": "Error", "check": "Please check your input.", "invalid": "Invalid data!" }, "cross_request": "The request has expired. Please try again!", "403": { "title": "Access denied", "headline": "Access denied", "text": "Either you have been inactive for too long or you are not allowed to view this page. Please log in again.", "text_membership": "Something went wrong. You have been logged out automatically. Please log in again." }, "404": { "title": "Page not found", "headline": "Oops!", "text": ["Something went wrong.", "This page does not exist. Please check, if the URL in your browser's address bar is correct."] }, "408": { "title": "Timelimit exceeded", "headline": "Timelimit exceeded", "text": "You have been inactive for too long. Please log in again." }, "503": { "title": "ONDURO will be back shortly!", "headline": "Be right back...", "text": ["The website is being updated.", "In a few minutes ONDURO will be back!"] }, "whoops": { "title": "Ooops", "headline": "Oooops, something went wrong!", "text": "Our support team has been informed and will work on a solution asap." }, "ajax": { "headline": "Javascript deactivated?", "text": "Javascript has to be activated in order to perform this action." }, "cookies": { "title": "Cookies deactivated", "headline": "I want cookies!", "text": "In order for the login to work, your browser must accept cookies. Don't know how to activate cookies? Read all about it: <a href=\"http:\/\/www.google.com\/support\/websearch\/bin\/answer.py?hl=de&answer=35851\">How to activate cookies<\/a>" }, "token_mismatch": { "headline": "Something went wrong", "text": "You have been inactive for too long. Please log in again." }, "decrypt": { "headline": "Login failed", "text": "Are you trying to log in with a password tool such as LastPass or 1Password? Try logging in again without those tools." }, "exception": { "session_validation": "Your current planning has been removed. You have been re-directed automatically to another active planning." }, "fields": { "text": "Please <b>choose at least one<\/b> field" }, "422": { "gravatar": "Allowed filetypes are: jpg, jpeg, png, gif <br>Image must not be larger than 2mb" }, "413": "File too big (max. 4MB)" }, "widget": { "general": { "confirm": "Are you sure?" }, "premiums": { "headline": "Premium", "base": "based on", "days": "Day(s)", "time": "Timeframe", "tags": "Tags", "holidays": "Holidays" }, "rates": { "headline": "Salary", "note": "Premiums are always calculated on the base salary." }, "salary": { "headline": "Salary" }, "expenses": { "headline": "Expenses", "expense": "Expense", "travel_expense": "Travel expenses", "travel_time": "Travel time" }, "hours": { "confirm_billable": { "headline": "Confirm hour", "text": "The employee can register hours, but failed to do so. Would you like to register hours for the employee?", "error": "Not all of the selected items could be submitted. Please check begin and end times.", "text_multi": "Are you sure you want to submit all of the selected hours?" }, "deny": { "headline": "Deny hours", "text": "The employee will receive an automatic message about the denied hours. Optionally, you can add a personal message:", "placeholder": "Add a personal message..." } }, "locations": { "delete": { "headline": "Delete planning", "confirm": "Do you really want to delete this planning? You will lose access to all scheduled items immediately." }, "step1": { "hint": "e.g. headquarter" }, "step2": { "text": "Choose employees, that may work at <b>{name}<\/b>." }, "deactivate_related": "The planning cannot be deactivated, because it is published with :text.", "delete_related": "The planning cannot be deleted, because it is published with :text.", "delete_last": "The planning cannot be deleted, because it is the only remaining.", "delete_unassigned": "Before this planning can be deleted, you need to assign the following users to another planning:<br><br><ul class=\"default\"><li>:users<\/li><\/ul>" }, "duties": { "delete": { "headline": "Delete function", "confirm": "Do you really want to delete this function?" }, "step1": { "hint": { "name": "e.g. bar keeper, service staff, kitchen chef", "identifier": "e.g. BAR, SER, KIT" } }, "step2": { "text": "Choose employees, that can execute the function <b>{name}<\/b>." }, "delete_related": "This function cannot be deleted, because it is assigned to :text." }, "shifts": { "delete": { "headline": "Delete shift", "confirm": "Do you really want to delete this shift?" }, "text": "Choose <b>at least one<\/b> location, that makes use of this shift.", "hint": { "name": "e.g. morning, afternoon, evening", "identifier": "e.g. M, A, E" }, "delete_related": "The shift cannot be deleted, because it is assigned to :text." }, "costs": { "delete": { "headline": "Delete cost unit", "confirm": "Do you really want to delete this cost unit?" }, "hint": "e.g. general, internal, external", "delete_related": "This cost unit cannot be deleted, because it is assigned to :text employees. Remove the assignment first in the employee settings.", "delete_fallback": "This cost unit cannot be deleted, because it's the default.", "delete_hours": "This cost unit cannot be deleted, because it is assigned to registered hours." }, "workspaces": { "delete": { "headline": "Delete workspace", "confirm": "Do you really want to delete this workspace?" } }, "tags": { "delete": { "headline": "Delete tag", "confirm": "Do you really want to delete this tag? It will be unassigned from all items and employees." }, "step1": { "hint": "e.g. VIP" }, "step2": { "text": "Choose employees, that will receive the tag <b>{name}<\/b>." } }, "holidays": { "headline": "Holidays" }, "change": { "email": { "headline": "Change email address", "success": "Your email address has been changed successfully. Please keep that in mind during your next login." }, "password": { "headline": "Change password", "success": "Your password has been changed successfully. Please keep that in mind during your next login." } }, "time": { "text": "Please choose a time frame, in which {name}\xA0is available:", "error_overlap": "The chosen timeframe overlaps with another scheduled item.", "error_unavailable": "Scheduling at times is currently not possible, because employee is not available." }, "response": { "items": "scheduled item|scheduled items", "users": "employee|employees" }, "reports": { "hint": "e.g. approved hours of all employees" }, "jobs": { "hint": "e.g. manager on duty", "delete_related": "Job cannot be deleted, because it is assigned to :text." }, "users": { "step1": [], "step2": [], "step3": { "text": "Choose all functions, that <b>{fname}<\/b> may execute:" }, "step4": { "text": "Would you like, that <b>{name}<\/b> gets access to the roster?", "label": { "access_yes": "Yes, {fname} should receive a personal login", "access_no": "No, {fname} does not need access" }, "help": "Help with this setting", "help_text": ["Normally employees should receive access. This way, they can login, view their current roster and perform other actions based on their role and rights.", "Employees without access can only see the roster when printed or sent via email.", "You can always change this setting later."] }, "step5": { "text": "What's the email address of <b>{name}<\/b>?", "info": "The personal invitation to {name} will be sent to this email address.", "blueprint": "The blueprint for new employees is active! Blueprint settings will automatically be applied.", "success": "<b>{name} has been added successfully!<\/b><br>{fname} can be scheduled immediately.", "success_verification": "<b>{name} has been invited successfully!<\/b><br>{fname} can be scheduled immediately." }, "delete_holder": "<b>{name}<\/b> cannot be deleted, since no one else would be managing the account." }, "contracts": { "delete": { "headline": "Delete contract" }, "alternating": "even\/odd weeks differ", "notes": { "days_fixed": "Full vacation days are counted with the number of hours in the table above. Otherwise vacation will be counted hourly.", "days_flex": "Hours worked are supplemented weekly with holiday hours up to a maximum of the contract hours. One vacation day is reimbursed up to a maximum of {hours} hours.", "holidays": "Holidays that fall on working days are reimbursed with the number of hours in the above table." } }, "download": { "headline": "Available fields", "fields": { "fname": "Firstname", "lname": "Lastname", "email": "Email", "mobile": "Mobile", "status": "Status", "date": "Date", "from": "From", "until": "Until", "break": "Break", "total": "Total", "overtime": "+\/-", "rate": "Rate", "expenses_amount": "Expenses amount", "expenses_compensation": "Expenses compensation", "expenses_travel": "Expenses travel", "expenses": "Expenses", "sickness": "Sickness", "employee_number": "Personeelnummer", "birthday": "Birthday", "duty": "Duty", "location": "Location", "created_at": "Created at", "approved_at": "Approved at", "approved_by": "Approved by", "expenses_other": "Expenses other", "salary": "Salary" }, "text": "Choose the fields you wish to see in your downloaded file", "success": { "headline": "Download", "text": "Your download has started" } }, "revenues": { "headline": "Revenue on" }, "employees": { "note": "The employee will not be invited immediately. You can apply all settings on the next page first and then send the invitation.", "edit": "Caution! The selected settings will be applied to all {amount} selected employees!" }, "defaultavailability": { "delete": { "headline": "Delete default availability", "confirm": "Do you really want to delete this default availabilities" } }, "help": { "line1": "<b>Do you have a question about your salary or roster?<\/b><br>Please get in touch with your manager or employer.<br><br><b>Do you have a question about the functionality of ONDURO?<\/b><br>", "line2": "Answers on frequently asked questions can be found in our <a href=\"#\" class=\"toggle-university\">university<\/a>!<br><br><b>Still unsure or have another question regarding ONDURO?<\/b><br>", "line3": "Send us a message via <a href=\"mailto:support@onduro.com\">e-mail<\/a>.<br><br><small style=\"line-height: 1;color: #888;\">We strive to answer on the same business day. Sometimes it can take a little longer because we're busy building  new features or onboarding new clients.<\/small>" }, "add_hours": { "overlap": "The hours overlap with shifts or hours already entered. Do you still want to add the hours?" }, "clients": { "delete": { "confirm": "Do you really want to delete this client? All related plannings will be set to inactive.", "headline": "Delete client" } }, "plannings": { "ERR_DATES": { "confirm": "Are you sure you want to change the dates? All scheduled items outside the new dates will be deleted. Continue?" } }, "timechooser": { "not_plannable": "Between these timeframes on {date} is {name} <u><b>not<\/b><\/u> plannable:" }, "resources": { "step2": { "text": "Assign resources to the function <b>{name}<\/b>." }, "planning": "Assign resources to the planning <b>{name}<\/b>." }, "assign_locations": { "headline": "Assign plannings" }, "signature": { "error": "Both signature and name of signee are required." } }, "validation": { "length": "too short", "number": "no digit", "spaces": "no spaces please", "invalid_character": "invalid character", "required": "is required", "email": "Invalid email format" }, "frontend": { "terms": "Terms of use", "legal": "Contact & support", "privacy": "Privacy", "nav": { "functions": "Functions", "faq": "FAQ", "pricing": "Pricing", "register": "Register", "signin": "Login" }, "login": { "signin": { "headline": "Login", "forgot_password": "Forgot password?", "submit": "Login", "error": "Login unsuccessful. Please check your input.", "modal": { "headline": "Login failed", "text": "Your email address has not been verified yet. Didn't receive a verification email? Check your spam folder or have it <a href=\"{href}\">resent<\/a>.", "error": "Not yet verified." }, "throttle": { "headline": "Login failed", "text": "Too many login attempts. Please try again in a few minutes." }, "hint": "You need to login first.", "user_inactive": "You don't have an active user account. If you have questions about this, get in touch with the owner of the account." }, "password": { "headline": "Reset password", "text": "Please enter the email address used during registration. You will receive further instructions on how to reset your password via email.", "success": "Please check your email inbox!", "error": "No user registered with that email address." }, "confirm": { "headline": "Confirm email address", "text": "We logged you in right away!", "back": "Let's go" }, "accept": { "headline": "Verifying invitation", "text": "One moment please...", "back": "Let's go" }, "confirm_fail": { "headline": "Confirmation failed", "list": ["Did you already confirm your email address? Try to <a href=\"{href}\">login<\/a> first.", "Please copy the confirmation link from your email manually into the address bar of your browser.", "If that doesn't help, please <a href=\"{href}\">request a new confirmation link<\/a>."], "back": "to the login" }, "confirmation": { "headline": "Request confirmation code", "text": "Please enter the email address used during registration. We'll send you another confirmation code.", "success": "Please check your email inbox!", "error": "No user registered with that email address." }, "reset": { "headline": "Reset password", "text": "Please choose a new password:<br><ul><li>at least 8 characters<\/li><li>including digits (0-9)<\/li><li>lowercase and uppercase characters<\/li><\/ul>", "success": "Your password has been changed succesfully.", "error": "The password reset code could not be identified." }, "reset_fail": { "headline": "Password reset failed", "text": "The password reset code has expired, is invalid or has been used before. Please check the URL or request a <a href=\"{href}\">new code<\/a>.", "back": "to login" }, "signup": { "headline": "Create account", "welcome": "Awesome, that you want to try ONDURO free for 30 days!", "note": "This is to create a new account for your company. Do you already have an account and just want to log in? Go to <a href=\"{href}\">login<\/a>.", "text": "Please choose your personal password:", "help": "<b>Look out!<\/b> A secure password contains at least 8 characters with a mix of uppercase, lowercase letters and digits.", "password": "Choose a password", "password_confirm": "Repeat password", "submit": "Create account", "success": "Your registration was successful. From now on you can login with your email address and password.", "accepted": "You have successfully accepted the invitation. You can now log in with your email and password.", "error": "The registration code could not be identified." }, "signup_fail": { "headline": "Signup failed", "text": ["The registration code has expired, is invalid or has been used before.", "Please request a new code from the account owner."], "back": "to login" }, "accept_fail": { "headline": "Invitation failed", "text": "The invitation code has expired, is invalid or has been used before. Please request another invitation from your manager." }, "password_reset": { "error": "You don't have a password yet. Please complete your account set-up first by clicking on the link in your invitation e-mail." } }, "registration": { "defaults": { "account": "Company name", "location": "Headquarter", "contract": "0-hour contract", "cost": "General costs", "shifts": { "F": "Morning", "M": "Afternoon", "S": "Evening" } }, "terms": "I accept the <a href=\"https:\/\/www.onduro.com\/nl\/gebruiksvoorwaarden\" target=\"_blank\">terms of use<\/a> and the <a href=\"https:\/\/www.onduro.com\/nl\/privacy\" target=\"_blank\">privacy policy<\/a>.", "error_general": "Your account cannot be created at this moment. Please try again later.", "error_already_registered": "You already have an account at ONDURO. Do you really want to create another one?", "error_not_verified": "Your email address is not yet verified. Would you like to receive another verification email?", "done": { "headline": "You've got mail!", "text": "Please click on the verification link in the email we just sent to you.", "notice": "PS: Also check your spam folder!", "back": "back to home page" }, "terms_owner": "I hereby agree to the <a href=\"https:\/\/www.onduro.com\/nl\/gebruiksvoorwaarden\" target=\"_blank\">terms of use<\/a>, the <a href=\"https:\/\/www.onduro.com\/nl\/dpa\" target=\"_blank\">data processing agreement<\/a> and the <a href=\"https:\/\/www.onduro.com\/nl\/privacy\" target=\"_blank\">privacy policy<\/a> on behalf of {company} and I have legal authority to do so." } }, "wizard": { "help": "Need help?<br>Click me!", "nav": { "1": "Welcome", "2": "Your account", "3": "Company", "4": "Employees", "5": "Functions", "6": "Module" }, "back": "back", "next": "next", "later": "I'll do that later", "conclude": "next", "step1": { "headline": "Welcome", "text": ["We're gonna set-up your roster!", "Have questions or need help?<br>Click on the guy at the top left."], "submit": "Let's go", "later": "Not now, I'll do that later!" }, "step2": { "headline": "Your account", "note": "You already have a password for ONDURO, you don't need to choose another one.", "password": { "label": "Choose a password", "placeholder": "min. 6 characters and digits" } }, "step3": { "headline": "The company", "company": { "label": "What's the name of your company?", "placeholder": "Company name" }, "branch": { "label": "What's your industry?", "options": { "gastronomy": "Gastronomy", "retail": "Retail", "healthcare": "Healthcare", "other": "Other" } } }, "step4": { "headline": "Employees", "employees": { "label": "Who do you want to schedule?", "placeholder": "Lars Schmidt, Maike Koch, Hans Peters, Anne Fischer" }, "hint": ["Add one name per row or divided by commas.", "You can add more employees later at any time."] }, "step5": { "headline": "Functions", "duties": { "label": "Which functions exist at {name}?", "placeholder": "Bar, kitchen, office" }, "hint": ["Add one function per row or divided by commas.", "You can add more functions later at any time."] }, "step6": { "headline": "Activities", "text": "Which employee can execute which function?" }, "step7": { "headline": "Modules", "text": ["Activate all modules you'll need.", "There will be <u>no<\/u> extra charges for activated modules."], "shifts": { "label": "Shift planning", "hint": "work with shifts, e.g. \"Evening\" from 18:00 - 00:00" }, "hours": { "label": "Hour registration and reporting", "hint": "let employees register hours and<br>easily create hour reports" }, "availability": { "label": "Availability", "hint": "let employees fill in their availability" } }, "step8": { "headline": "Done!", "text": ["That was easy, right?", "Have some questions? Don't hesitate to contact us:"], "submit": "Go to ONDURO", "flash": { "headline": "Welcome, {name}!", "text": "<p>You can get started right away. Drag the name of an employee from the column on the right onto the roster. Then, click on the item to add working hours and more.<\/p><strong>Have fun with ONDURO!<\/strong><small>Tip: We gathered some more information for you on the overview page.<\/small>" } } }, "tools": { "remove_item": { "text": "Do you really want to delete this item?", "headline": "Delete item" } }, "notification": { "message_added": "Your message has been added!" }, "conflict": { "INVALID_DUTY": "Function is not valid (anymore)", "INVALID_SHIFT": "Shift is not valid (anymore)", "INVALID_USER": "Employee ist not plannable", "AVAILABILITY": "Employee is not available", "ERR_OVERLAP": "This item overlaps with another one for this employee", "ERR_EXISTING_FULL": "The employee is already scheduled today", "ERR_HOURS": "Hours have already been registered for this item", "ERR_CONFIRMED": "Registered hours for this item have already been approved", "message": "Please resolve the following conflicts:", "NO_DUTY_SET": "This item needs a function", "ERR_OVERLAP_REST": "This item overlaps with the rest period of this employee" }, "meta": { "description": "ONDURO login page" }, "onboarding": { "intro": ["Let's make sure, that you can get the most out of ONDURO.", "We do this in two ways:"], "university": "Learn how to use ONDURO in the university.<br>Step by step, in your own pace.<br>Click on the image above to get started.", "support": "Do you have questions?<br>Don't hesitate to contact us.<br>Via the \"help\" link at the top.", "cancel": "Nah, let me do it on my own.", "disable": { "headline": "Disable onboarding?", "text": "You can always return to the university by clicking the link in the navigation. Do you want to disable onboarding for now?" }, "loggedinas": "Currently logged in as:", "self": "this is you", "switch": "Curious how other employees see ONDURO? Click on the link underneath to switch roles.", "switch_to": "Switch to:", "own_staff": "Ready to import your own employees?", "get_in_touch": "Get in touch with us via the help link above!", "role_manager": "As manager you can do almost everything the account owner can do. Except managing the subscription.", "role_planner": "As planner you are able to schedule employees and publish the roster.", "role_supervisor": "As supervisor you can approve or deny the registered hours of other employees.", "role_user": "Employees or external freelancers mainly submit availabilities, check their roster or submit worked hours.", "next_steps": "What are the next steps?" }, "university": { "minified": "Back to the university...", "lets_begin": "Let's begin!", "headline": "What do you want to learn?", "no_lessons": "There are no lessons for this page or search.", "lesson": { "related": "Related topics", "try": "Try a bit yourself" }, "show_all": "Show all lessons." }, "confirm": { "legal": { "statement": ["I, <b>{name}<\/b>, declare that", "I have fully read and understood the terms above; and", "I accept these on behalf of <b>{company}<\/b>; and", "I have full legal authority to do so."], "too_small": "Your device is too small to show this important document, please use your computer.", "scroll_notice": "Attention: The document below can be scrolled." }, "chat": { "delete": { "headline": "Are you sure?", "text": "After that, you will not be able to see any messages in this chat anymore" } }, "resting": { "conflict": "This change conflicts with the rest period for {name}. Apply anyway?" } }, "tooltip": { "roster": { "notes": "Attach more information for all items on this day. The entered text will be displayed with the items in the roster.", "tools": { "notes": "Attach more information to this item. The entered text will be displayed with the item in the roster." }, "tab": { "all": "of selected planning" }, "internal": "Internal notes. They will not be visible to the employee. Enter information for reporting, such as order number etc." }, "reports": { "labels": "Filter status by \"approved\" to add labels." }, "contracts": { "days": { "flex": "ONDURO will use this information to calculate salaries on vacation days.", "fixed": "ONDURO will use this information to calculate salaries on vacation days or holidays (on workdays)." } }, "date_info": "You can click on the year number in the date picker popup to quickly change the year.", "balance": { "holiday": "will be added to employees balance on every active holiday where employee does not work (up to the weekly hours)", "holiday_always": "Always add hours to the hour balance for public holidays (even if the employee exceeds weekly hours)." }, "calculations": { "totals": "This panel shows the totals of the selected week across all plannings.", "period": "Select here or click on a date in the planning to change the period." }, "beta": "Beta functionality. Use with care. Feedback welcome!", "hours_per_week": "hours per week" }, "soon": { "contracts": "Contract management coming soon..." }, "button": { "reset_filters": "reset filters", "add_contract": "Add contract", "manage_plannings": "Manage plannings", "refresh": "Refresh" }, "todo": { "invite": "Invite employee", "contract": "Assign a contract", "duty": "Assign function(s)", "salary": "Assign salary", "profile": "Complete required profile fields", "profile_employee": "Employee has not completed profile", "contract_incomplete": "Contract incomplete (requires: dates, signed contract, salary)", "certificates_expire": "Certificates expired" }, "folder": { "payslips": "Payslips", "sepa": "SEPA files", "contracts": "Contracts", "uploads": "User uploads", "journals": "Salary journals", "annuals": "Other", "others": "Additional documents", "others_description": "(Wage tax certificate, social insurance certificate, other documents)", "attendance_roster": "Attendance & Rooster" }, "cards": { "items": { "open": { "headline": "Open services" }, "applications": { "headline": "Applications" }, "no_open_duties": "There are no open duties", "no_open_applications": "There are no open applications" } }, "warning": { "registration_incomplete": "Employee registration incomplete!", "item_with_applications": "This item already has applications! In order to change it, delete it and create a new one." }, "sko": { "malta": { "tk": ["If you don't have insurance, you can", "apply for one here at TK", "or", "download a PDF with further information"] } }, "freelancer": "Freelancer", "filter": { "date": { "this_month": "This month", "last_month": "Last month", "this_quarter": "This quarter", "this_year": "This year", "last_year": "Last year", "last_quarter": "Last quarter" } }, "invoicesTable": { "invoice_number": "Invoice Number", "date": "Date", "total": "Total", "freelancer": "Name Freelancer", "notFound": "No invoices found" }, "input": { "freelancer": { "autoInvoice": "Enable Automatic Invoicing?", "shiftVat": "Shift VAT" } }, "settings": { "invoices": "Invoices" }, "invoicing_interval": "Invoicing setting", "modules": { "descriptions": { "pro": "The projects module helps efficiently manage and track projects. Users can create, update, and monitor projects with details like client info, location, budget, scheduling, and invoicing. It supports duty assignments, work hours tracking, and travel expense management. With automated scheduling and real-time updates, it ensures smooth project execution." } } };/* harmony default export */ __webpack_exports__["default"] = (locales);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var locales = { "layout": { "subnav": { "settings": { "general": "General", "locations": "Plannings", "jobs": "Jobs", "duties": "Functions", "shifts": "Shifts", "availability": "Availability", "costs": "Cost units", "rates": "Salaries", "premiums": "Premiums", "workspaces": "Workspaces", "tags": "Tags", "holidays": "Holidays" } }, "header": { "help": "Help", "overview": "Welcome!", "contacts": "Address book", "hours": "Hour registration", "reports": "Reporting", "profile": "Your profile" }, "calendar": { "roster": { "headline": "Published until (including)" }, "reports": { "headline": "Select an end date for the report." }, "mon": "MO", "tue": "TU", "wed": "WE", "thu": "TH", "fri": "FR", "sat": "SA", "sun": "SU" }, "footer": { "info": "You have unsaved changes.", "save": "Save changes", "cancel": "Reset" } }, "route": { "overview": { "path": "overview", "name": "Overview" }, "roster": { "path": "roster", "name": "Roster" }, "lists": { "path": "lists", "name": "Lists" }, "availability": { "path": "availability", "name": "Availability" }, "contacts": { "path": "contacts", "name": "Contacts" }, "chats": { "path": "chats", "name": "Chats", "details": { "name": "Chats", "path": "chats\/:channel" } }, "hours": { "path": "timesheet", "name": "Timesheet", "page": { "path": "timesheet\/:page", "name": "Timesheet" } }, "reports": { "path": "reports", "name": "Reports" }, "team": { "path": "employees", "name": "Employees", "edit": { "name": "Employees", "path": "employees\/:id" } }, "profile": { "path": "profile", "name": "Profile" }, "settings": { "path": "settings", "name": "Settings", "general": { "path": "settings\/general", "name": "General" }, "availability": { "path": "settings\/availability", "name": "Availability" }, "duties": { "path": "settings\/functions", "name": "Functions" }, "holidays": { "path": "settings\/holidays", "name": "Holidays" }, "locations": { "path": "settings\/locations", "name": "Plannings" }, "premiums": { "path": "settings\/premiums", "name": "Premiums" }, "rates": { "path": "settings\/rates", "name": "Hourly rates" }, "shifts": { "path": "settings\/shifts", "name": "Shifts" }, "expenses": { "name": "Expenses", "path": "settings\/expenses" }, "costs": { "name": "Cost units", "path": "settings\/costs" }, "tags": { "name": "Tags", "path": "settings\/tags" }, "vacation": { "name": "Vacation", "path": "settings\/vacation" }, "contracts": { "name": "Contract templates", "path": "settings\/contracts" }, "advanced": { "path": "settings\/advanced", "name": "Advanced" }, "checkin": { "name": "Check-in", "path": "settings\/check-in" } }, "modules": { "path": "modules", "name": "Modules" }, "notifications": { "name": "Notifications", "path": "notifications" }, "projects": { "name": "Projects", "path": "projects", "edit": { "path": "projects\/:id" } }, "login": { "accept": { "path": "login\/accept-invitation\/:code", "name": "Accept Invitation" }, "confirm": { "path": "login\/confirm-email\/:code\/:account?", "name": "Confirm E-Mail" }, "confirmation": { "path": "login\/request-confirmation", "name": "Request Confirmation" }, "password": { "path": "login\/forgot-password", "name": "Forgot Password" }, "reset": { "path": "login\/reset-password\/:code", "name": "Reset Password" }, "signin": { "path": "login\/signin", "name": "Signin" }, "signup": { "path": "login\/signup\/:code", "name": "Signup" } }, "clients": { "name": "Clients", "path": "clients", "edit": { "path": "clients\/:id" } }, "balances": { "name": "Balance", "path": "balance", "details": { "name": "Balance", "path": "balance\/:id" } }, "register": { "path": "register", "name": "Create Account" }, "welcome": { "name": "Welcome", "path": "welcome" }, "terms": { "name": "Terms of use", "path": "terms" }, "privacy": { "name": "Privacy", "path": "privacy" }, "legal": { "name": "Contact & Support", "path": "contact" }, "wizard": { "start": { "name": "Wizard", "path": "wizard\/start\/:id\/:token" }, "step": { "name": "Wizard", "path": "wizard\/step" }, "name": "Wizard", "path": "wizard" }, "subscription": { "name": "Account", "path": "subscription", "confirm": { "path": "subscription\/confirm" } }, "invoice": { "path": "invoice\/:id" }, "vacation": { "name": "Vacation", "path": "vacation", "new": { "name": "Request time-off", "path": "vacation\/new" }, "details": { "path": "vacation\/:id", "name": "Time-off" } }, "setup": { "name": "Setup", "path": "setup\/:id\/:token" }, "example": { "path": "example" }, "contact": { "name": "Contact", "path": "contact" }, "statistics": { "name": "Statistics", "path": "statistics" }, "dashboard": { "name": "Dashboard", "path": "dashboard\/:id\/:hash" }, "today": { "name": "Day Schedule", "path": "today" }, "planning": { "name": "Planning", "path": "planning" }, "dossiers": { "path": "employees\/:id\/dossiers" }, "payslips": { "name": "Payslips", "path": "payslips" }, "documents": { "name": "Documents", "path": "documents", "detail": { "name": "Dokuments", "path": "documents\/:type" } }, "checkins": { "name": "Check-ins", "path": "check-ins" }, "demo": { "path": "demo", "name": "Demo" }, "log": { "name": "Log", "path": "log" }, "plannings": { "path": "planning\/overview", "name": "Overview" }, "resources": { "name": "Resources", "path": "resources", "edit": { "path": "resources\/:id", "name": "Resources" } } }, "common": { "status": { "account": { "free": "Active", "trial": "Free trial", "active": "Active subscription", "expired": "Trial expired", "cancelled": "Cancelled", "deleted": "Deleted", "license": "via License" }, "membership": { "active": "active", "inactive": "deactivated", "deleted": "deleted" }, "user": { "active": "active", "inactive": "inactive", "deactivate": "deactivate", "activate": "activate" }, "item": { "planned": "planned", "open": "open", "pending": "pending", "approved": "approved", "denied": "denied" } }, "placeholder": { "email": "john@doe.com", "roster_name": "e.g. ACME Corporation", "company": "e.g. ACME Corporation, Inc.", "full_name": "John Doe", "address": "e.g. Main Street 101", "dd": "DD", "mm": "MM", "yyyy": "YYYY", "vat": "IE1234567X" }, "filter": { "user": "Employee", "duty": "Function", "location": "Planning", "status": "Status" }, "availability": { "available": "available", "unavailable": "unavailable", "vacation": "vacation", "wish": "wish to work", "approved": "approved", "denied": "denied", "limited": "limited availability" }, "role": { "owner": "Owner", "manager": "Manager", "planner": "Planner", "user": "Employee", "supervisor": "Supervisor", "observer": "Observer" }, "button": { "cancel": "cancel", "submit": "submit", "okay": "okay", "save": "save", "delete": "delete", "invite": "invite employee", "reinvite": "re-invite employee", "confirm": "Confirm", "decline": "Decline", "send": "Send", "unsubscribe": "Unsubscribe", "yes": "Tak", "add": "Add", "enroll": "Enroll", "agree": "Agree", "close": "Close", "no": "Nie", "withdraw": "Withdraw", "continue": "Continue", "back": "Back", "deny": "Deny", "done": "Done", "logout": "Logout", "next": "Next", "reset": "Reset", "remove": "remove", "edit": "Edit", "complete": "complete", "download": "download", "accept": "Accept", "show": "show", "changegravatar": "Change profile picture", "apply": "Apply" }, "language": { "german": "German", "dutch": "Dutch", "english": "English" }, "country": { "germany": "Germany", "netherlands": "The Netherlands", "usa": "USA" }, "modules": { "basic": "Basic", "hours": "Hour registration and reporting", "availability": "Availability", "appointments": "Appointments", "shifts": "Shifts", "tags": "Tags", "rates": "Salary & Expenses", "balances": "Balances", "sickness": "Sickness", "tentoo": "Tentoo Payroll", "lists": "Lists", "costs": "Cost units", "chats": "Chats", "temper": "Temper", "blueprint": "Blueprint", "weather": "Weather", "vacation": "Vacation", "dashboard": "Dashboard", "today": "Day Schedule", "statistics": "Statistics", "university": "University", "dossiers": "Dossiers", "contacts": "Contacts", "planning": "Planning & roster", "contracts": "Contract management", "onboarding": "Onboarding", "nmbrs": "Nmbrs", "payslips": "Payslips", "documents": "Documents", "checkins": "Check-ins", "clients": "Clients", "resources": "Resources", "calculations": "Calculations", "signature": "Sign Timesheet" }, "nojs": { "headline": "Please activate JavaScript", "text": ["To make ONDURO work, JavaScript must be activated in your browser.", "Please make sure, that no other programs (ad blocker, spam filter...) block access to this website."], "link": "How do I activate JavaScript?" }, "email": { "default_subject": "New message from ONDURO" }, "notify": { "success": { "headline": "Saved", "description": "The changes have been saved successfully." }, "delete": { "description": "The entry has been deleted successfully.", "headline": "Deleted" } }, "cut": "cut", "copied": "copied", "device": { "rotate": "Please turn your screen to use this function" }, "details": "Details", "link_copied": "Link copied to clipboard. This link is PERSONAL for this employee only." }, "label": { "type": "Type", "name": "Name", "location": "Planning", "hours": "Hours", "rate": "Salary", "amount": "Amount", "subtotal": "Subtotal", "total": "Total", "distance": "Distance", "euro": "\u20AC", "km": "km", "premium": "Premium", "until": "until", "date": "Date", "day": "Day", "cost": "Cost unit", "begin": "Begin", "end": "End", "break": "Break", "filter": "Filter", "status": "Status", "expenses": "Expenses", "description": "Description", "items": "Items", "overtime": "Overtime", "salutation": "Salutation", "title": "Title", "fname": "First name", "lname": "Last name", "email": "Email", "email_new": "New email", "email_confirm": "Repeat email", "password": "Password", "password_old": "Old password", "password_new": "New password", "password_confirm": "Repeat password", "company": "Company", "users": "Users", "icon": "Icon", "employee": "Employee", "employees": "employees", "country": "Country", "language": "Language", "role": "Role", "access": "Access", "phone": "Phone", "mobile": "Mobile", "fax": "Emergency number", "address": "Address", "zip": "Zip", "city": "City", "identifier": "Abbreviation", "designation": "Label", "color": "Color", "account_holder": "Account holder", "iban": "IBAN", "bic": "BIC", "time": "Time", "duration": "Duration", "payer": "Manager", "display": "Roster display", "interval": "Timeframe", "quantity": "Quantity", "work_time": "Work times", "action": "Action", "created_by": "Created by", "weeks": "Weeks", "minimum": "at least", "tax_number": "Employee ID", "full_name": "First and last name", "rates": "Salaries", "premiums": "Premiums", "duties": "Functions", "salary": "Salary", "eur_per_km": "\u20AC per km", "payroll": "Payroll", "sick_pay": "Sick pay", "sickness": "Sickness", "balance": "Balance", "previous": "previous", "per_week": "per week", "begin_of_week": "begin of week", "fallback": "Default", "birthday": "Birthday", "vat": "VAT-ID", "contacts": "Contacts", "public": "public", "private": "private", "stats": { "planned": "planned", "worked": "worked", "revenue": "revenue", "costs": "costs", "cost_revenue": "cost\/revenue" }, "locations": "Plannings", "code": "Code", "days": "Days", "invoice": "Invoice", "client_number": "Client number", "invoice_number": "Invoice number", "billing_period": "Billing period", "until_including": "until incl.", "sorting": "Sorting", "vacation": "Time-off", "requested": "Requested", "availability": "Availability", "unit": "Unit", "requests": "Requests", "pending": "pending", "plusmin": "plus \/ min", "dates": "Date(s)", "request": "Request", "month": "month", "week": "week", "min_hours": "Min.", "max_hours": "Max.", "print": "print", "moment": { "last": "last", "current": "this", "next": "next", "custom": "custom" }, "year": "year", "factor": "Factor", "contact_list": "Contacts", "group": "Group", "contract_management": "Contract management", "contract_hours": "Contractual hours", "profile": "Profile", "settings": "Settings", "dossier": "Dossier", "contract_start": "Hire date", "contract_end": "End date", "template": "Template", "payslips": "Payslips", "contract_full": "full-time", "contract_part": "part-time", "days_fixed": "Hours per weekday", "days_flex": "Days per week", "contract_vacation": "Vacation days", "file": "File", "documents": "documents", "fixed_salary": "fixed salary", "filetype": "Filetype", "creator": "Creator", "hourly_salary": "hourly wage", "roster": "Roster", "filled": "Filled", "checkin": "Check-in", "submitted": "submitted", "half_a_day": "half a day", "hours_per_full_day": "hours per full day", "holiday": "Holiday", "changed": "changed", "empty": "empty", "fields": "fields", "client": "Client", "start_date": "Starting", "end_date": "Ending", "plannings": "Plannings", "clients": "Clients", "all_clients": "all clients", "budget": "Budget", "active": "active", "inactive": "inactive", "archived": "archived", "finished": "ended", "clear": "clear", "comment": "Comment", "published": "published", "unpublished": "unpublished" }, "text": { "from": "from", "until": "until", "open": "open", "users": "Employees", "no_results": "no results", "sick": "sick", "or": "or", "of": "of", "change": "change", "delete": "delete", "optional": "optional", "yes": "tak", "no": "nie", "mr": "Mr.", "mrs": "Mrs.", "dr": "Dr.", "prof": "Prof.", "profdr": "Prof. Dr.", "location": "Planning", "contract": "Contract", "info": "Info", "duty": "Function", "shift": "Shift", "account": "Account", "cost": "Cost unit", "workspace": "Workspace", "owner": "Owner", "manager": "Manager", "planner": "Planner", "user": "User", "placeholder": "Placeholder", "placeholder_duties": "Open items", "placeholder_shifts": "Open shifts", "full_time": "Full time", "part_time": "Part time", "flex_time": "Flexible", "monthly": "monthly", "weekly": "weekly", "sunday": "Sunday", "monday": "Monday", "release": "Publish", "released": "published", "week": "Week", "calendar_week": "Calendar week", "calendar_week_short": "W", "today": "today", "yesterday": "yesterday", "in": "in", "on": "on", "to": "to", "since": "since", "new": "New", "confirmed": "confirmed", "unconfirmed": "unconfirmed", "denied": "denied", "approve": "approve", "deny": "deny", "himself": "oneself", "someone": "someone", "previous": "previous", "previous_period": "previous period", "all": "all", "filter": "filter", "deactivate": "deactivate", "activate": "activate", "expired": "unfinished", "page": "Page", "saving": "save", "more": "more", "none": "none", "instead_of": "instead of", "base_salary": "Base salary", "empty": "No data available (yet)", "tag": "Tag", "item": "Item", "sure": "Are you sure?", "more_options": "show options", "search": "Search...", "import": "import", "help": "Help", "days": "days", "day": "day", "legend": "Legend", "selection": { "more": "more", "select": "select", "all": "all", "none": "none", "displayed": "of the <u>filtered<\/u> options", "selected": "selected", "select_all": "select all", "deselect_all": "deselect all", "toggle": "select\/deselect" }, "invited": "invited", "hide_options": "hide options", "month": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], "loading": "loading...", "desc": "descending", "asc": "ascending", "blueprint": "Blueprint", "hours": "hours", "daydays": "day|days", "hrs": "h", "changed": "changed", "unsaved": "unsaved change|unsaved changes", "welcome": "Welcome", "attention": "Attention", "nowayback": "This cannot be undone. Are you really sure?", "current": "current", "dpa": "Data Processing Agreement", "dpa_accept": "I accept version 1.0 of the data processing agreement on behalf of {company} and declare that I am legally authorized to do so.", "review": "Review", "legal": { "not_signed": "This agreement has not yet been accepted.", "signed": "This agreement has been accepted by <b>{name}<\/b> on <b>{date}<\/b>." }, "you": "You", "per_employee": "per employee", "per_item": "per worked shift", "disapprove": "Disapprove", "colleagues": "Colleagues", "billed_at": "billed at", "paid_at": "paid at", "in_days": "in {days} days", "tomorrow": "tomorrow", "no_times": "no timeframe", "labels": "Labels", "paid": "paid", "billed": "billed", "options": "options", "progress": "progress", "contract_salary": "Contract & Salary", "per": "per", "show_details": "show details", "hide_details": "hide details", "fulltime": "full-time", "duration_permanent": "permanent", "duration_temporary": "temporary", "pay_out": "pay out", "fixed": "fixed", "contract_days_fixed": "regular", "contract_days_flex": "irregular", "per_workday": "per workday", "contract_template": "Contract template", "message": "Message", "per_year": "per year", "signed_by_employee": "signed by employee", "nothing": "Nothing to show here...", "per_month": "per month", "per_hour": "per hour", "generate": "generate", "no_documents": "No documents to show.", "no_checkins": "There are no check-ins at this moment.", "confirm_checkout_membership": "Are you sure you want to check-out {name}?", "confirm_checkout": "Are you sure you want to check-out? You cannot check-in for the same duty.", "checkin_successful": "Checkin successful at {time}", "already_checked_in": "You are already checked in since {time}", "checkin_successful_notice": "You have been successfully checked in", "oclock": "{time}", "past-checkins": "Past check-ins", "details": "Details", "load_more": "Load more", "no_location_data": "No location data available.", "previous_page": "previous page", "next_page": "next page", "free": "free", "added_via": "Added via", "rest_time": "Resting time", "rest": "Rest", "planning_type": { "ongoing": "ongoing", "temporary": "temporary" }, "conflict": "Conflict", "between_and": "between {start} and {end}", "per_duty": "per function", "totals": "Totals", "planned": "planned", "period": "Period", "filters_active": "filters active" }, "page": { "team": { "headline": "Employees", "registered": "registered", "invited": "invited", "add": "Add employee", "delete": "Delete employee", "delete_confirm": "Do you really want to delete this employee? All data will be deleted immediately!", "saved": "The settings have been updated successfully.", "activate_access": "Activate access", "sidebar": { "general": "General", "text": "coming soon...", "registered_since": "Registered since:", "last_online": "Last seen:", "headline_duties": "Functions", "headline_locations": "Plannings", "tags_hint": "Click in the input field to add a tag. Tag not available? Create a <a href=\"{href}\">new tag<\/a>.", "no_duty": "has no function yet!" }, "fieldset": { "personal_data": "Personal data", "job": "Job", "access": "Login access", "contact": "Contact data", "role": "Roles", "rights": "Additional rights", "costs": "Cost units", "hours": "Timesheet", "availability": "Availability", "balance": "Balance" }, "availability": "Employee may enter availability", "availability_hint": "Please choose, the default availability, if <b>{name}<\/b> has not (yet) specified availability.", "availability_options": ["is by default", "available", "not available"], "balance": "Enable hourly balance for this employee", "hours": "Employee may register hours", "on_cost_label": "on cost unit", "cost_hint": "Choose all cost units, that <b>:name<\/b> may book hours on. If you choose only one, the employee does not have to make a selection during hour registration. All hours will be booked on the selected cost unit automatically.", "cost_empty": "No cost units have been created yet! Create a <a href=\"{href}\">cost unit<\/a> now.", "data_locked": "Some personal data entered by the employee can only be edited by the employee self on their profile page.", "not_verified": "<b>{name}<\/b> has been invited, but has not completed the registration.", "not_accepted": "<b>:name<\/b> has been invited, but has not yet accepted the invitation. Because :name is also connected to another account, you cannot change the email address (:email) used for the invitation.", "no_access": "<b>:name<\/b> has currently no access. By pressing the following button you can re-activate access.", "invitation_expired": "The invitation is unfinished. You have to re-send the invitation email.", "invitation_success": "Invitation successfully sent.", "invitation_failed": { "hint": "is already in use", "message": "This email is already in use within another account. Please contact <a href=\"support@onduro.com\">support@onduro.com<\/a>. We will help you out." }, "text_owner": "Access is mandatory for account owners.", "user": "Employee", "user_is": "Employee is", "user_may": "Employee may", "tabs": { "other": "Other", "infos": "Infos", "tags": "Tags", "rates": "Salary" }, "label": { "about": "About :name", "notes": "Internal notes", "access": "Access", "right_colleagues": "can see all colleagues in the roster", "right_placeholder": "can sign into open items (placeholders)", "right_hours": "can edit timesheet of other employees", "payroll": "is being payed out via {provider}", "right_colleagues_restrict": "only on days where employee is scheduled" }, "hint": { "role_owner": "may manage everything", "role_manager": "may manage employees and settings", "role_planner": "may plan the roster", "role_supervisor": "approve, deny and edit timesheets", "role_observer": "can see published items on the planning page for selected locations (but not change anything)", "role_manager_restricted": ["cannot edit (employee) settings", "has only access to own documents"] }, "empty": "No employees created yet.", "email_existing": "This email address already exists for another employee.", "blueprint": { "hash": "blueprint", "headline": "Blueprint", "info": "This is the blueprint for new employees. You can decide, which settings a new employee will be assigned by default. You can activate or deactivate blueprints at any time by clicking on the switch at the top right.", "active": "active", "inactive": "inactive" }, "supervisor": "Employee may supervise timesheets of colleagues", "accountant": "Employee has access to reporting", "of_cost_label": "of cost unit", "restrictions": { "locations": { "all": "for all plannings", "own": "only for associated plannings", "some": "only for certain plannings" }, "duties": "only for items with own <u>functions<\/u>" }, "deactivate": { "confirm": { "headline": "Really deactivate?" }, "text": "Deactivated employees cannot be scheduled or login." }, "activate": { "confirm": { "headline": "Really activate?", "text": "Activated employees possibly cause subscription costs. Please check your subscription details." } }, "vacation": "Employee can request vacation", "import": "To import your own staff, please contact support via the \"Help\" link. We will upgrade your demo access to a regular account first.", "bulk_delete": "Delete employees", "delete_bulk_text": "All scheduled items in the future will be removed for this user! Historic data will be preserved.", "bulk_text": "Are you sure you want to {action} selected employees?", "bulk_invite": "Invite employees", "bulk_activate": "Activate employees", "bulk_deactivate": "Deactivate employees", "invited_notify": "Selection has been invited.", "add_limit": "You have reached the maximum amount of employees on your plan. Either deactivate employees or upgrade your plan.", "dossier": { "sidebar_note": "This is where you can store some internal information about this employee." }, "user_deactivated": "Employee is deactivated.", "settings": { "warn": "Please note: the settings below only take effect once the employee has been invited and successfully completed the registration." }, "invitation_no_email": "You must enter an email address and save it to grant {name} access.", "invitation_invite": "{name} has <u>no<\/u> access to ONDURO yet. Click the button below to grant {name} access via a personal login.", "profile": { "note": "Todo: Go to the tab \"settings\" to assign at least one function to {name}." }, "bulk_edit": "Edit settings", "contract": { "vacation": "employee may request vacatin", "none": "No contract set yet.", "salary": "You can change the hourly rate for this employee here." }, "balance_overview": "Allow employee to see balances of other employees", "expenses": { "general": "Employee may declare expenses (in \u20AC)", "travel": "Employee may declare travel expenses (in km)" }, "registration_link": "Copy registration link to clipboard", "hours_add": "May specify hours without being scheduled", "invitation_conflict": "<b>This e-mail address is already linked to a user in another account.<\/b><br><br>Remove the e-mail address in the other account first, before inviting the user in this account.<br><br>Or remove the user in <u>this<\/u> account and provide an e-mail address <b>while adding<\/b> the user.", "role_manager_restricted": "with limited access" }, "roster": { "element": "Item", "undroppable": { "text": "cannot be scheduled here.", "past": "This day is in the past.", "billed": "This period has already been billed.", "confirm": "schedule anyway", "blocked": "This day has been blocked.", "closed": "This day is off." }, "time": { "delete": { "error": { "headline": "Times cannot be removed." } }, "error": { "headline": "Times cannot be saved.", "ERR_TIMES": "You have to provide a start and end time.", "ERR_CONFIRMED": "Registered hours for this item have already been approved.", "ERR_OVERLAP": "is already scheduled in the given period.", "ERR_OVERLAP_REMOVAL": "is already scheduled this day. Times cannot be removed.", "ERR_EQUAL": "Start and end time have to differ.", "ERR_NEGATIVE": "Total duration cannot be negative. Adjust break time." } }, "user": { "delete": { "error": { "headline": "Employee cannot be removed." } }, "has_hours": { "headline": "Item has registered hours!" }, "change": { "ERR_HOURS": "Hours have already been registered for this item. Do you want to remove these hours and assign another employee?" }, "remove": { "ERR_HOURS": "Hours have already been registered for this item. Do you want to remove these hours together with the employee?" }, "error": { "headline": "Employee cannot be saved.", "ERR_CONFIRMED": "Registered hours for this item have already been approved.", "ERR_OVERLAP": "is already scheduled in the given period." } }, "item": { "delete": { "error": { "headline": "Item cannot be removed." }, "ERR_HOURS": "Hours have already been registered for this item. Delete item anyway including registered hours?", "ERR_CONFIRMED": "Hours have already been registered and confirmed for this item. Delete item anyway including registered hours?" }, "has_hours": { "headline": "Item has registered hours!" }, "via_hours": "added via timesheet" }, "sick": { "ERR_HOURS": { "headline": "Item has registered hours!", "text": "Hours have already been registered for this item. Delete hours and mark as sick?" }, "ERR_TIME": { "headline": "Item has no working hours!", "text": "Working hours (or shifts) are required for items marked as sick." } }, "shift": { "error": { "headline": "Shift cannot be saved.", "ERR_CONFIRMED": "Registered hours for this item have already been approved.", "ERR_OVERLAP": "is already scheduled in the given period." } }, "add": { "error": { "headline": "Item cannot be scheduled!", "headline_choose": "Employee is already scheduled", "ERR_UNAVAILABLE_LIMITED": "has limited availability on that day. Continue?", "ERR_UNAVAILABLE_DENY": "cannot be scheduled on this day.", "ERR_UNAVAILABLE_WARN": "is not available on that day. Schedule anyway?", "ERR_EXISTING_FULL": "is already planned for an indefinite period on that day. As long as the existing item has no working times, no other item can be scheduled.", "ERR_EXISTING_SHIFT": "is already planned for a shift on that day. As long as the existing shift is not being removed, no other item can be scheduled.", "headline_limited": "Employee has limited availability" } }, "signin": { "error": { "headline": "Not possible!", "text": "You already work that day!" } }, "signout": { "headline": "Signout requested", "text": "You are still scheduled for this item until a planner confirms your request for sign-out." }, "move": { "error": { "headline": "Item cannot be moved!", "ERR_OVERLAP": "The moved item overlaps with another scheduled item of", "ERR_CONFIRMED": "Registered hours for this item have already been approved.", "ERR_OPEN_CHECKIN": "Item has not been checked-out." } }, "comments": { "error": { "headline": "Add comment", "text": "Please enter message." } }, "headline": "Roster", "for": "for", "from": "from", "until": "until", "current_week": "current week", "since_current_week": "since current week", "legend": "Legend", "ical_subscribe": { "headline": "Subscribe to calendar", "text": "You can subscribe to the calendar at the following address:" }, "release_error": "Roster could not be published.", "context": { "headline": "Schedule employee:", "delete_text": "Drag here to delete!", "distance_hint": "See below for distance between this location and employee's home address.", "info_hint": "See below how often and how long a employee has been scheduled at this location since the latest release date." }, "tools": { "time": "Time", "shift": "Shift", "duty": "Item", "user": "User", "until": "until", "application": "Employee requests to be signed out of this item.", "approve": "Approve", "deny": "Deny", "apply": "Apply", "cancel": "Cancel!", "signin": "Sign in", "signout": "Sign out", "switch": "Switch", "work": "Do work!", "empty_users": "no availability", "empty_duties": "no function available", "filtered_tags": "Attention: Selection filtered by tags", "tags_none": "No tags available for scheduled employee.", "tags_user": "You can only add tags that are available for the scheduled employee.", "tags_all": "Click in the input field to add a tag. Tag not available? Create a <a href=\"{href}\">new tag<\/a>.", "totals": "Total number of planned (not yet released) items \/ hours across all plannings and functions", "sick": { "payment": "Sick pay", "apply": "Sick", "undo": "Not sick", "payroll_payment": "Sick pay is controlled by payroll for this employee.", "needs_time": "Item needs a start and end time (or shift) in order to be marked as sick. Please add first.", "no_costs": "Time tracking not enabled for this employee.", "headline": "Choose the applicable settings for:", "balance": "Hours for balance", "hint": "Choose percentage of sick pay.", "balance_note": "Scheduled working hours will be credited 100% for the employee\\'s hour balance.", "sko": "Please choose the type of sick leave." }, "revoke_application": "Revoke application", "applied_at": "Applied at<br>{date}" }, "placeholder": { "comment": "Internal note (only visible for planners en observers)" }, "matching": { "headline": "Fill open shifts", "button": "Wizard", "info": "Open shifts will be filled with available employees within the chosen timeframe.", "remove": "remove scheduled employees from items in chosen timeframe", "error": "Start date must be after release date.", "removed": "Successfully remove employees from <b>:removed<\/b> items!", "matched": "Successfully matched employees to <b>:matched<\/b> items! <b>:unmatched<\/b> items could not be matched." }, "flash": { "success": { "headline": "Success!", "message": "The roster has been published until (including):<br><br><strong>:date<\/strong>" } }, "release": { "headline": "Release planning", "text": "Release roster until including: <b>{date}<\/b><br><br>If you choose to release the roster until the given date, all scheduled employees with access will be notified via email. They will be able to view the published roster until the release date.<br><br>It'll still be possible to make changes. Changes will trigger immediate notifications to affected employees.", "success": "The roster has been released succesfully!" }, "revoke": { "headline": "Revoke release", "text": "Release planning until including: <b>{date}<\/b><br><br>If you choose to revoke the roster to the given date, all scheduled employees with access will be notified about the changed release date via email.<br><br>Employees will only be able to see duties up until the new release date." }, "duty": { "error": { "headline": "Function cannot be changed" } }, "bulk": { "selected": "items selected", "note": "If you're done selecting, choose one of the following actions.", "pasting": "Paste the items somewhere in the roster!", "cut": "cut", "copy": "copy", "duplicate": "duplicate", "match": "match", "empty": "empty", "delete": "delete", "error": { "resolve": "You need to resolve the conflicts first!", "released": "You cannot perform this action in the published roster.", "paste_released": "You cannot paste items in the released roster!", "latency": "Some of the items have changed while you were performing this action. Please refresh the roster page and try again." } }, "observer_note": "You are an observer on the planning page. Therefore you cannot make changes to the planning.", "published_until": "Published until here", "apply": { "error": { "text": "You already applied for this item", "headline": "Not possible!" } }, "revoke_application": { "error": { "headline": "Not possible!", "text": "You have not applied for this item" } }, "preset": { "return": "return to planning", "template": "Edit template", "info": "For each planning, you can fill up to 4 weeks in the template. Then you can easily copy the preset and paste it into the current planning.", "template_paste": "Paste template" } }, "reports": { "remove": { "headline": "Delete report", "text": "Do you really want to delete this report?" }, "save": { "headline": "Save report" }, "saved": "Report saved successfully!", "without": "without", "hours": "Hours", "overview": { "headline": "Hour reporting", "empty": "No saved reports available.", "info": "You can create as many reports as you like. It's possible to create multiple reports for the same timeframe. This way you can create reports per employee or planning..." }, "filter": { "headline": { "new": "New report", "existing": "Report" }, "filter": "Apply filter", "more": "show more filters", "empty": "No results in given timeframe.", "stats": { "duties": "Items", "expected": "Planned", "reported": "Reported", "overtime": "Overtime", "salary": "Salary" }, "show_details": "Show all details" }, "point": "Reporting period", "add": "Create report", "hints": "Hints", "unapproved": "Hours in brackets have been registered, but not yet confirmed.", "missing": "The following employees have not yet registered hours in given timeframe:", "complete": "All hours have been registered in given timeframe!", "created_at": "created at", "approved_at": "approved at", "approved_by": "approved by", "sick_pay": "Sick pay", "salary": "Salary", "actions": "Actions", "edit": "Edit hours", "no_cost": "Hours without cost unit", "download": "Download", "xls_title": "Report", "edit_hours": "Edit hours", "back": "back to overview", "no_hour": "Unregistered hours", "download_warn": { "headline": "Not all hours (regardless of the 'status' filter) have been approved in the selected period:", "open": "not yet registered", "pending": "not yet approved", "planned": "in the future", "denied": "denied", "footer": "Do you still want to download the selected hours?" }, "labels": { "add": "Add label", "remove": "Remove label", "headline": "Edit labels" }, "export": { "headline": "Export to payroll", "notice": "Are you sure you want to trigger the payroll for all employees and locations (regardless of the set filters) in the selected period? Note: only unpaid hours will be paid!", "warning": "Not all hours have been approved. The payroll can only be triggered if all hours in the selected period have been filled in and approved.", "incomplete": "Not all employees are fully registered. No salary run can be executed for employees who are not fully registered." }, "downloads": { "per_employee": "per employee", "per_client": "per client", "per_planning": "per planning", "billable": "Approved per planning" } }, "lists": { "remove": { "headline": "Delete list", "text": "Do you really want to delete this list?" }, "save": { "headline": "Save list" }, "saved": "List saved successfully!", "filter": { "headline": { "new": "New list", "existing": "List" }, "stats": { "items": "items", "expected": "Hours" }, "released_only": "only published items", "placeholder": "Open duties", "assigned": "Assigned duties", "with_unpublished": "with unpublished items" }, "overview": { "empty": "No saved lists available.", "info": "Create lists based on scheduled items.", "headline": "Lists" }, "add": "Create list", "xls_title": "List" }, "settings": { "role_manager": { "confirm": "Managers have access to ALL employee data and account settings. Make sure you trust this employee to handle this role responsibly." }, "role_accountant": { "confirm": "Accountants have access to hours entered by other employees. Possibly also to salaries and expenses. Make sure you trust this employee to handle this information with care." }, "general": { "headline": "General settings", "fieldset": { "roster": "Basic", "invoice": "Invoice address", "expenses": "Expenditures and travel expenses", "various": "Various" }, "expenses": { "general": "Employees may declare expenses (in \u20AC)", "travel": "Employees may declare travel expenses (in km)", "travel_auto": "Calculate travel expenses automatically", "travel_note": "Attention: to calculate travel expenses automatically, zip codes are mandatory in both the employee's profile and planning settings!" }, "placeholders": "Signup in placeholder must be confirmed by planner.", "contacts_visibility_public": "public", "contacts_visibility_public_hint": "visible for all employees of this account", "contacts_visibility_private": "private", "contacts_visibility_private_hint": "only visible for managers and planners", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "vat_exempt": "VAT exempt", "roster": { "must_apply": "Employees must apply for open duties", "hide_names": "Restrict planner role (hide names, no access to plannings overview)" } }, "locations": { "headline": "Locations", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Add location", "edit": "Edit location", "empty": "No planning added yet.", "moved": "The \"locations\" settings have been moved to the planning page. You can now add\/edit your locations from the \"plannings\" management page.", "info": "Note: we have renamed \"locations\" to \"plannings\". This gives you more flexibility. You can create a planning for a fixed \"location\" or a temporary \"project\"." }, "jobs": { "headline": "Jobs", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Add job", "edit": "Edit job", "empty": "No job created yet.", "type": { "full": "Full time", "part": "Part time", "temp": "Flexible" } }, "duties": { "headline": "Functions", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Add function", "edit": "Edit function", "empty": "No function created yet.", "rest_label": "h after each duty" }, "shifts": { "headline": "Shifts", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Add shift", "edit": "Edit shift", "empty": "No shift created yet." }, "costs": { "headline": "Cost units", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "add": "Add cost unit", "edit": "Edit cost unit", "empty": "No cost unit created yet." }, "availability": { "headline": "Availability", "note": "Lorem ipsum dolor sit amet, consetetuer adipiscing elit.", "users": { "fieldset": "Employees", "label": { "before": "Availability must be entered", "after": "week(s) in advance." }, "hint": "Employees cannot change availability within this period." }, "planners": { "fieldset": "Planner", "label": "When trying to schedule <u>unavailable<\/u> employees in the roster:", "deny": "deny", "warn": "warn", "allow": "allow" }, "options": { "fieldset": "More options", "constrainable": { "label": "Employees may constrain availability hourly", "hint": "e.g. available from 16:00" }, "editable": "Planners my change availability of other employees", "blank": "Show availability not filled-in as empty", "vacation": "Employees may request vacation" } }, "tags": { "headline": "Tags", "add": "Add tag", "edit": "Edit tag", "empty": "No tags created yet." }, "rates": { "headline": "Salaries", "add": "Add salary", "edit": "Edit salary", "empty": "No salary created yet.", "hint": { "amount": "gross hourly salary", "factor": "conversion factor for cost calculation" } }, "premiums": { "headline": "Premiums", "add": "Add premium", "edit": "Edit premium", "empty": "No premiums created yet." }, "holidays": { "headline": "Holidays", "empty": "No holidays created yet.", "add": "Add holiday", "notes": "Please choose the appropriate holidays for your company or add custom holidays.", "edit": "Edit holiday" }, "contracts": { "add": "Add template", "edit": "Edit contract", "empty": "No contract template created yet.", "upload": "Upload template", "change": "Change template", "modal": { "info": "Here you can upload a template in .doc or .docx format." } }, "checkin": { "fieldset": { "location": "Planning", "time": "Check-in time", "open": "Open check-ins" }, "location": { "required": "Only allow check-ins with location", "range": { "before": "Only allow check-ins within", "after": "meters" } }, "before": { "min": { "before": "Employees must check-in at least", "after": "minutes before shift starts" }, "max": { "before": "Employees may check-in max.", "after": "minutes before shift starts" } }, "handle": { "open": "Automatic check-out after" }, "hints": { "range": "This setting works only with full address information for your plannings." } } }, "availability": { "sidebar": { "change": "Change selection to", "selection": "Your selection", "deselect": "cancel selection", "constraints": "Restrict time", "status": "Vacation status", "hint": "Tip: Hold the control\/command-key down to select multiple days." }, "error": { "mixed_constraints": "Time constraints may not differ on selected days.", "status": "You need to chose a vacation status.", "invalid_constraints": "Invalid time constraints.", "incomplete_constraints": "Time constraints on vacation days require start and end time.", "conflict": "The following dates could not be updated because the planner has already taken your previous availability into account.<ul><li>{dates}<\/li><\/ul><div class=\"note\">Get in touch with your planner to request any changes to your availability on these dates.<\/div>" }, "legend": { "vacation_requested": "vacation (requested)", "vacation_denied": "vacation (denied)", "vacation_approved": "vacation (approved)", "holiday": "holiday" }, "from": "from", "until": "until", "headline": { "planner": "Overview", "user": "My availability" }, "button": { "overview": "All", "mine": "Mine" }, "tools": { "hint": "<b>Select one or more days<\/b> to choose your availability.", "default": "By default you are: <b>:availability<\/b>", "multiselect": "<b>Tip:<\/b> Hold down the \"shift\" key to select multiple days.", "selection": { "you_have": "You have", "day": "day", "days": "days", "selected": "selected" }, "vacation": { "headline": "Process vacation request", "approve": "approve", "deny": "deny", "unapproved": "Your vacation is not yet approved!", "denied": "vacation denied" }, "tooltip": { "pending": "vacation pending", "denied": "vacation denied" }, "constraints": { "headline": "Add a time constraint", "hint": "only possible, when you're available" }, "change_to": "Change selection to", "reset": "reset selection", "request": "request", "register": "register" }, "dropdown": "All plannings", "defaults": "Availability" }, "overview": { "welcome": { "headline": "Welcome, {name}!", "text": "Start by completing your profile data.<br><br><a href=\"{href}\" class=\"box-button\">To profile<\/a>" }, "checklist": { "headline": "Complete these steps to publish your first roster:", "shifts": "Edit shifts", "duties": "Schedule items", "users": "Invite employees", "publish": "Publish roster" }, "headline": "Welcome", "unbilled": "unregistered hours|unregistered hours", "approve_hours": "Approve hours", "sidebar": { "headline": "My upcoming duties", "empty": "Nothing scheduled.", "no_locations": "You have no access to the roster currently, because you haven't been assigned to any planning." }, "unapproved": "pending approval|pending approvals", "processable": "1 vacation request is pending approval.|{processable} vacation request are pending approval.", "vacation_requests": "vacation request|vacation requests" }, "balances": { "added": "added", "note_overview": "Only approved hours are taken into account.", "note_current": "Your current balance is: <em>{saldo} hours<\/em> Hours of the current week (from {date}) are not taken into account." }, "account": { "headline": "Account management", "delete": "Delete account", "delete_confirm": "Are you sure you want to delete your account? All data will be irreversibly deleted!", "unsubscribe": "Cancel subscription", "unsubscribe_confirm": "Do you really want to cancel your subscription? You can continue to use your account until the end of the current billing cycle!", "saved": "All data saved successfully.", "trial": { "expiration": "You can use ONDURO free until <strong>{expiration}<\/strong>.", "days": "That's {days} more day.|That's {days} more days.", "expires_today": "You can use ONDURO free until today. Want to continue with easy staff scheduling? Make sure to activate your subscription!" }, "active_trial": { "note": "You only have to pay from :period_start. You will receive your first invoice on :invoice_date.", "box1": { "headline": "Free trial", "until": "until including", "description": "You don't have to pay anything until this date!<br>Want to cancel? Do it before this day." }, "box2": { "headline": "Active employees", "period": "in current billing cycle", "description": "Based on this number we'll calculate the invoice amount." } }, "active": { "note": "The next invoice will be generated on <strong>{nextInvoice}<\/strong> for the usage from {billingStart} until including {billingEnd}. Please make sure you have added your current billing information below!", "box1": { "headline": "Billing period", "until": "until including", "description": "That's :days more days." }, "box2": { "headline": "Active employees", "period": "in current billing cycle", "description": "Number of already activated + newly created \/ activated employees." }, "box3": { "headline": "Expected costs", "period": "in upcoming invoice", "description": "Expected costs based on activated employees in current billing cycle." } }, "cancelled": { "note": "You can use ONDURO until finally <strong>{expiration_date}<\/strong> or delete your account immediately.", "box1": { "headline": "Billing cycle", "until": "until including", "description": "That's :days more days." }, "box2": { "headline": "Active employees", "period": "in current billing cycle", "description": "Number of already activated + newly created \/ activated employees." }, "box3": { "headline": "Expected costs", "period": "in final invoice", "description": "Expected costs based on activated employees in current billing cycle." }, "info": "You will receive your final invoice on <strong>:invoice_date<\/strong>. The amount will be deducted automatically from your bank account." }, "subscription": { "title": "All inclusive for", "per_user": "per active employee", "per_month": "per 30 days", "benefits": ["including all functionality", "always full cost control", "cancel any time", "secure payment via direct debit"], "subscribe": "Subscribe now", "start": "the paid period begins on", "success": "Your subscription has been activated successfully!<br>Thank you!" }, "unsubscription": { "success": "Your subscription has been cancelled successfully!<br>Thanks for having been our customer!" }, "support": "Any questions? Send us a <a href=\"#\" class=\"box-intercom\">message<\/a>. We'll be glad to help!", "sidebar": { "discount": { "headline": "Discount code" }, "status": { "headline": "Status", "text": "This information will be shown in the address book:", "free": "Your account is active.", "trial": "Trial period until", "registered_since": "Registered since", "subscribed_since": "Subscribed since" }, "owner": { "headline": "Data Controller (GDPR)" }, "invoices": "Invoices", "license_code": "License code" }, "license": { "note": "You are using ONDURO via a license code.", "error": "This license code is not valid or has expired." }, "demo": "You are currently using ONDURO in the free demo." }, "profile": { "headline": "Your profile", "account": "Subscription", "delete": "Delete profile", "delete_confirm": "Do you really want to delete your profile? All data will be irreversibly deleted!", "saved": "Your profile has been updated successfully.", "gravatar": "Register at <a href=\"https:\/\/www.gravatar.com\/\" target=\"_blank\">Gravatar<\/a> to add your profile photo.", "fieldset": { "personal_data": "Personal data", "address": "Address book", "other": "Other" }, "about": { "label": "About you", "placeholder": "Experience, qualifications, etc.", "hint": "these details are only visible for planners" }, "sidebar": { "address": { "headline": "Address book", "text": "Only information provided by you will be shown in the address book." }, "password": { "headline": "Change password", "text": "To change your password, click on the following button and follow the steps in the dialogue.", "button": "Change password" }, "email": { "headline": "Change email address", "text": "Did your email address change?", "button": "Change email address" } }, "picture": "Profile picture", "progress": "You have completed {filled} of the {required} required fields. {remaining} fields to go!", "filled": "You have completed all required fields!", "contract": "This is your contract. Please download, sign and re-upload." }, "notifications": { "fieldset": { "roster": "Roster", "hours": "Hours" }, "info": "Choose here, which notifications you want to receive.", "saved": "Your settings have been updated successfully.", "roster_mine": { "label": "Schedule changes", "hint": "notifies you when there are any changes in your own schedule" }, "item_changed": { "label": "Item changes", "hint": "notifies you when any changes in the published roster occur" }, "unbilled": { "label": "Register hours", "hint": "reminds you of any hours, that need to be registered" }, "unapproved": { "label": "Approve hours", "hint": "reminds you of any hours, that need to be approved" }, "open_duty": { "label": "Open items", "hint": "reminds you of items with unassigned employees" }, "item_upcoming": { "label": "Upcoming shifts", "hint": "get a notification one day prior to scheduled shifts" } }, "hours": { "headline": { "mine": "My hours", "all": "All hours" }, "note": { "mine": "You have to register hours. Check your working hours, make changes if appropriate and approve by clicking on the checkmark.", "pending": "These hours are pending approval. You can still make changes while they're pending.", "approvable": "These hours still have to be approved or denied.", "approved": "Approved hours are displayed monthly. You can change the selected month in the dropdown above." }, "actionable": "To be registered", "pending": "Pending", "approvable": "To be approved", "approved": "Approved", "empty": "all hours have been registered", "no_cost": "no cost unit", "error": { "times": "Please fill in valid working hours." }, "confirm_delete": "Caution! The related shift will be permanently removed from the roster!", "comment": "Add comments...", "checkins": "To confirm" }, "update": { "headline": "ONDURO has been updated", "text": "The application will be updated automatically by clicking on the following button.", "button": "Load update" }, "history": { "item": { "added": "added an item to the :released roster:", "changed": "changed an item in the :released roster:", "removed": "removed an item from the :released roster:", "signed_in": "signed :who into a placeholder:", "signed_out": "signed :who out of an item in the roster:" }, "hour": { "added": "has registered hours:", "added_for": "hat registered hours for :who:", "changed": "has changed registered hours:", "changed_for": "has changed registered hours for :who:", "approved": "has approved hours registered by :who:", "denied": "has denied registered hours from :who:" }, "roster": { "released": "released the roster:", "revoked": "changed the publication date of the roster:" } }, "contacts": { "no_access": "no access", "not_verified": "not yet registrated", "download": "Download" }, "modules": { "descriptions": { "basic": "The duty roster serves as the basis for the planning.", "hours": "Let employees register hours and create reports with one click.", "availability": "Let employees fill in their availability.", "shifts": "Enables pre-defined shifts for items in the roster.", "tags": "Create tags for roster items or employees.", "rates": "Automatically calculates hourly salaries and lets employees handle expenses.", "balances": "Enable hour balances and give employees access to their current balance.", "sickness": "Mark items as sick in the roster.", "tentoo": "Enables a direct connection to Tentoo Payroll.", "costs": "Assign hours to various cost units.", "lists": "Create lists based on scheduled items.", "chats": "Messaging among employees", "temper": "Integrate Temper.works", "blueprint": "Define default settings for new employees.", "weather": "7-day weather forecast in the roster. Requires zip code in planning settings.", "vacation": "Vacation planning and management.", "dashboard": "Provide a dashboard for today's planning.", "today": "Enable an overview page with a daily schedules.", "statistics": "Get insights and statistics about scheduled vs. worked hours, salaries and costs.", "university": "Get instant help articles and learn all about ONDURO.", "dossiers": "Store additional information of employees.", "contacts": "Show contacts page for easy access to employee's contact data.", "planning": "Create and publish rosters, let employees see their scheduled duties.", "contracts": "Manage contracts for employees.", "nmbrs": "Manage certain data for the Nmbrs export.", "onboarding": "Provide onboarding information for new employees.", "payslips": "Offer downloadable payslips to employees.", "documents": "Document center for payslips, user uploads and contracts.", "checkins": "Let employees check-in and out of their upcoming duties.", "clients": "Organize your plannings by clients.", "resources": "Manage resources and add them to the planning.", "calculations": "Automatically calculate totals across all plannings.", "signature": "Adds a signature pad to pending times in the timesheet." }, "note": "Extend ONDURO's functionality with these tools. Choose the tools that match your workflow.", "requires": "Requires", "errors": { "dependency": "This tool cannot be deactivated, because these tools are dependent on it", "dependent_on": "Tool requires" } }, "logout": { "confirm": { "headline": "Logout", "body": "Do you really want to logout?" } }, "invoice": { "footer": { "service_of": "is a service of" }, "thanks": "Thanks for being our customer!", "charge_date": "The amount will be debited from your bank account automatically on {chargeDate}." }, "vacation": { "status": { "pending": "pending", "processed": "processed", "approved": "approved", "denied": "denied", "withdrawn": "withdrawn", "removed": "removed", "request": "request", "requested": "requested", "credit": "credit", "debit": "debit", "new": "new", "changed": "changed" }, "new_request": "Vacation", "new_credit": "Credit", "days_selected": "days selected", "current_balance": "Your remaining paid time-off balance is:", "request": { "empty": "Choose available dates for this request from the calendar", "above": "above", "right": "on the right" }, "duration": { "full": "full day", "morning": "until noon", "afternoon": "from noon" }, "headline_new": "New Time-off", "note": { "start": "Please start by selecting an employee from the list!", "processed": "Your request has been processed.", "pending": "Your request is being reviewed.<br><br>You will be notified as soon as it is processed.", "tracking": "This is where you can determine how much paid time-off will be deducted from employee's vacation balance.", "changed": "Your have changed the request. Don't forget to save it!" }, "amount": "Time-off", "days": "Vacation days", "sidebar": { "current_balance": "Current balance", "deduct": "paid time-off", "new_balance": "New balance", "average": "average of {average} per vacation day", "remaining_balance": "Remaining balance" }, "stats": "{days} days requested, {approved} approved", "allow": "allow", "deny": "deny", "credit": "credit", "debit": "debit", "edit": "Update balance", "compensation": { "vacation": "paid time-off", "overtime": "for overtime", "none": "unpaid time-off" }, "vacation_request": "Vacation request", "submit": "submit", "amount-paid-hours": "Amount of paid hours", "holiday-type": "Holiday type", "empty": "There are no vacation requests for this year yet.", "empty-planner": "There are no vacation requests for this year yet or you have selected too many filters." }, "setup": { "contact": "Get in touch", "loading": "Loading your data...", "headline": "One more step", "error": { "SETUP_COMPLETED": "You have already completed the set-up! Click on the following button to log-in:", "INVALID_CREDENTIALS": "Something went wrong. Please get in touch with us via the following button:", "general": "We couldn't retrieve your data. Please get in touch with us via the following button:" } }, "statistics": { "sidebar": { "headline": "Timeframe", "cluster": "Cluster by" }, "tabs": { "details": "Details", "overview": "Overview" }, "content": { "chosedata": "Please pick a timeframe to receive some stats." } }, "today": { "working": "Who is working today?", "empty": "There's no one scheduled today." }, "chats": { "new": { "headline": "New chat" }, "participants": { "headline": "Chat participants" } }, "subscription": { "choose_plan": "Choose your plan", "monthly": "per month", "billing": { "before": "in advance", "after": "afterwards" }, "cancel": "cancel", "subscribe": "Subscribe to service", "change": "Change plan", "choose": "Click to choose", "chosen": "Current selection", "selection": "New selection", "active_users": "active employees", "plans": { "fix": "Fixed", "flex": "Flex", "legacy": "Legacy", "custom": "Custom" }, "more_info": "Check out <a href=\"https:\/\/www.onduro.com\" target=\"_blank\">www.onduro.com<\/a> for more infos en details about our plans." }, "myroster": { "tabs": { "mine": "My duties", "open": "Open duties", "all": "All duties" }, "empty": "Nothing scheduled.", "next_month": "to next month", "headline": "Roster", "headline_mine": "My duty", "headline_open": "Open duty", "sidebar": { "show_all": "show all days", "show_locations": "show plannings", "no_colleagues": "There are no colleagues scheduled (yet).", "note": "You are already scheduled on the circled days (see tab \"my duties\").", "warn": "Check the \"my duties\" tab for your personal schedule (across all plannings)." }, "details": { "warn_multiple": "you are scheduled for multiple duties this day!", "signed_out": "The cancellation of this duty is being processed. Changed your mind? Click on the button below to work this duty:", "confirmed": "You have confirmed this duty on {date}.", "info_assigned": "You are already scheduled in another duty that day!|You are already scheduled in {items} duties that day!", "info_placeholder": "There is 1 more open duty that day.|There are {items} more open duties that day" }, "no_duty": "no duty" }, "payslips": { "empty": "No payslips have yet been deposited for you." }, "documents": { "note": "In the document center, you can easily download and display all documents. Here you will find payroll documents as well as contracts and user uploads. You can upload and delete these documents in the employee profile." }, "log": { "changed": "The following changes have been made:", "note": "A maximum of 30 days can be shown.", "filter_keys": "Filter on changes in" }, "clients": { "add": "Add client", "edit": "Edit client" }, "plannings": { "title": "Plannings", "add": "Add planning", "edit": "Edit planning", "tooltip": { "link": "You are not linked to this planning!", "inactive": "You cannot view inactive plannings." }, "button": "Manage plannings" }, "resources": { "add": "Add resource", "delete": "Delete resource", "delete_confirm": "Do you really want to delete this resource? All data will be deleted immediately!" } }, "error": { "button": { "to_login": "to login", "to_homepage": "to home page", "to_referrer": "to previous page" }, "general": { "title": "Error", "check": "Please check your input.", "invalid": "Invalid data!" }, "cross_request": "The request has expired. Please try again!", "403": { "title": "Access denied", "headline": "Access denied", "text": "Either you have been inactive for too long or you are not allowed to view this page. Please log in again.", "text_membership": "Something went wrong. You have been logged out automatically. Please log in again." }, "404": { "title": "Page not found", "headline": "Oops!", "text": ["Something went wrong.", "This page does not exist. Please check, if the URL in your browser's address bar is correct."] }, "408": { "title": "Timelimit exceeded", "headline": "Timelimit exceeded", "text": "You have been inactive for too long. Please log in again." }, "503": { "title": "ONDURO will be back shortly!", "headline": "Be right back...", "text": ["The website is being updated.", "In a few minutes ONDURO will be back!"] }, "whoops": { "title": "Ooops", "headline": "Oooops, something went wrong!", "text": "Our support team has been informed and will work on a solution asap." }, "ajax": { "headline": "Javascript deactivated?", "text": "Javascript has to be activated in order to perform this action." }, "cookies": { "title": "Cookies deactivated", "headline": "I want cookies!", "text": "In order for the login to work, your browser must accept cookies. Don't know how to activate cookies? Read all about it: <a href=\"http:\/\/www.google.com\/support\/websearch\/bin\/answer.py?hl=de&answer=35851\">How to activate cookies<\/a>" }, "token_mismatch": { "headline": "Something went wrong", "text": "You have been inactive for too long. Please log in again." }, "decrypt": { "headline": "Login failed", "text": "Are you trying to log in with a password tool such as LastPass or 1Password? Try logging in again without those tools." }, "exception": { "session_validation": "Your current planning has been removed. You have been re-directed automatically to another active planning." }, "fields": { "text": "Please <b>choose at least one<\/b> field" }, "422": { "gravatar": "Allowed filetypes are: jpg, jpeg, png, gif <br>Image must not be larger than 2mb" }, "413": "File too big (max. 4MB)" }, "widget": { "general": { "confirm": "Are you sure?" }, "premiums": { "headline": "Premium", "base": "based on", "days": "Day(s)", "time": "Timeframe", "tags": "Tags", "holidays": "Holidays" }, "rates": { "headline": "Salary", "note": "Premiums are always calculated on the base salary." }, "salary": { "headline": "Salary" }, "expenses": { "headline": "Expenses", "expense": "Expense", "travel_expense": "Travel expenses", "travel_time": "Travel time" }, "hours": { "confirm_billable": { "headline": "Confirm hour", "text": "The employee can register hours, but failed to do so. Would you like to register hours for the employee?", "error": "Not all of the selected items could be submitted. Please check begin and end times.", "text_multi": "Are you sure you want to submit all of the selected hours?" }, "deny": { "headline": "Deny hours", "text": "The employee will receive an automatic message about the denied hours. Optionally, you can add a personal message:", "placeholder": "Add a personal message..." } }, "locations": { "delete": { "headline": "Delete planning", "confirm": "Do you really want to delete this planning? You will lose access to all scheduled items immediately." }, "step1": { "hint": "e.g. headquarter" }, "step2": { "text": "Choose employees, that may work at <b>{name}<\/b>." }, "deactivate_related": "The planning cannot be deactivated, because it is published with :text.", "delete_related": "The planning cannot be deleted, because it is published with :text.", "delete_last": "The planning cannot be deleted, because it is the only remaining.", "delete_unassigned": "Before this planning can be deleted, you need to assign the following users to another planning:<br><br><ul class=\"default\"><li>:users<\/li><\/ul>" }, "duties": { "delete": { "headline": "Delete function", "confirm": "Do you really want to delete this function?" }, "step1": { "hint": { "name": "e.g. bar keeper, service staff, kitchen chef", "identifier": "e.g. BAR, SER, KIT" } }, "step2": { "text": "Choose employees, that can execute the function <b>{name}<\/b>." }, "delete_related": "This function cannot be deleted, because it is assigned to :text." }, "shifts": { "delete": { "headline": "Delete shift", "confirm": "Do you really want to delete this shift?" }, "text": "Choose <b>at least one<\/b> location, that makes use of this shift.", "hint": { "name": "e.g. morning, afternoon, evening", "identifier": "e.g. M, A, E" }, "delete_related": "The shift cannot be deleted, because it is assigned to :text." }, "costs": { "delete": { "headline": "Delete cost unit", "confirm": "Do you really want to delete this cost unit?" }, "hint": "e.g. general, internal, external", "delete_related": "This cost unit cannot be deleted, because it is assigned to :text employees. Remove the assignment first in the employee settings.", "delete_fallback": "This cost unit cannot be deleted, because it's the default.", "delete_hours": "This cost unit cannot be deleted, because it is assigned to registered hours." }, "workspaces": { "delete": { "headline": "Delete workspace", "confirm": "Do you really want to delete this workspace?" } }, "tags": { "delete": { "headline": "Delete tag", "confirm": "Do you really want to delete this tag? It will be unassigned from all items and employees." }, "step1": { "hint": "e.g. VIP" }, "step2": { "text": "Choose employees, that will receive the tag <b>{name}<\/b>." } }, "holidays": { "headline": "Holidays" }, "change": { "email": { "headline": "Change email address", "success": "Your email address has been changed successfully. Please keep that in mind during your next login." }, "password": { "headline": "Change password", "success": "Your password has been changed successfully. Please keep that in mind during your next login." } }, "time": { "text": "Please choose a time frame, in which {name}\xA0is available:", "error_overlap": "The chosen timeframe overlaps with another scheduled item.", "error_unavailable": "Scheduling at times is currently not possible, because employee is not available." }, "response": { "items": "scheduled item|scheduled items", "users": "employee|employees" }, "reports": { "hint": "e.g. approved hours of all employees" }, "jobs": { "hint": "e.g. manager on duty", "delete_related": "Job cannot be deleted, because it is assigned to :text." }, "users": { "step1": [], "step2": [], "step3": { "text": "Choose all functions, that <b>{fname}<\/b> may execute:" }, "step4": { "text": "Would you like, that <b>{name}<\/b> gets access to the roster?", "label": { "access_yes": "Yes, {fname} should receive a personal login", "access_no": "No, {fname} does not need access" }, "help": "Help with this setting", "help_text": ["Normally employees should receive access. This way, they can login, view their current roster and perform other actions based on their role and rights.", "Employees without access can only see the roster when printed or sent via email.", "You can always change this setting later."] }, "step5": { "text": "What's the email address of <b>{name}<\/b>?", "info": "The personal invitation to {name} will be sent to this email address.", "blueprint": "The blueprint for new employees is active! Blueprint settings will automatically be applied.", "success": "<b>{name} has been added successfully!<\/b><br>{fname} can be scheduled immediately.", "success_verification": "<b>{name} has been invited successfully!<\/b><br>{fname} can be scheduled immediately." }, "delete_holder": "<b>{name}<\/b> cannot be deleted, since no one else would be managing the account." }, "contracts": { "delete": { "headline": "Delete contract" }, "alternating": "even\/odd weeks differ", "notes": { "days_fixed": "Full vacation days are counted with the number of hours in the table above. Otherwise vacation will be counted hourly.", "days_flex": "Hours worked are supplemented weekly with holiday hours up to a maximum of the contract hours. One vacation day is reimbursed up to a maximum of {hours} hours.", "holidays": "Holidays that fall on working days are reimbursed with the number of hours in the above table." } }, "download": { "headline": "Available fields", "fields": { "fname": "Firstname", "lname": "Lastname", "email": "Email", "mobile": "Mobile", "status": "Status", "date": "Date", "from": "From", "until": "Until", "break": "Break", "total": "Total", "overtime": "+\/-", "rate": "Rate", "expenses_amount": "Expenses amount", "expenses_compensation": "Expenses compensation", "expenses_travel": "Expenses travel", "expenses": "Expenses", "sickness": "Sickness", "employee_number": "Personeelnummer", "birthday": "Birthday", "duty": "Duty", "location": "Location", "created_at": "Created at", "approved_at": "Approved at", "approved_by": "Approved by", "expenses_other": "Expenses other", "salary": "Salary" }, "text": "Choose the fields you wish to see in your downloaded file", "success": { "headline": "Download", "text": "Your download has started" } }, "revenues": { "headline": "Revenue on" }, "employees": { "note": "The employee will not be invited immediately. You can apply all settings on the next page first and then send the invitation.", "edit": "Caution! The selected settings will be applied to all {amount} selected employees!" }, "defaultavailability": { "delete": { "headline": "Delete default availability", "confirm": "Do you really want to delete this default availabilities" } }, "help": { "line1": "<b>Do you have a question about your salary or roster?<\/b><br>Please get in touch with your manager or employer.<br><br><b>Do you have a question about the functionality of ONDURO?<\/b><br>", "line2": "Answers on frequently asked questions can be found in our <a href=\"#\" class=\"toggle-university\">university<\/a>!<br><br><b>Still unsure or have another question regarding ONDURO?<\/b><br>", "line3": "Send us a message via <a href=\"mailto:support@onduro.com\">e-mail<\/a>.<br><br><small style=\"line-height: 1;color: #888;\">We strive to answer on the same business day. Sometimes it can take a little longer because we're busy building  new features or onboarding new clients.<\/small>" }, "add_hours": { "overlap": "The hours overlap with shifts or hours already entered. Do you still want to add the hours?" }, "clients": { "delete": { "confirm": "Do you really want to delete this client? All related plannings will be set to inactive.", "headline": "Delete client" } }, "plannings": { "ERR_DATES": { "confirm": "Are you sure you want to change the dates? All scheduled items outside the new dates will be deleted. Continue?" } }, "timechooser": { "not_plannable": "Between these timeframes on {date} is {name} <u><b>not<\/b><\/u> plannable:" }, "resources": { "step2": { "text": "Assign resources to the function <b>{name}<\/b>." }, "planning": "Assign resources to the planning <b>{name}<\/b>." }, "assign_locations": { "headline": "Assign plannings" }, "signature": { "error": "Both signature and name of signee are required." } }, "validation": { "length": "too short", "number": "no digit", "spaces": "no spaces please", "invalid_character": "invalid character", "required": "is required", "email": "Invalid email format" }, "frontend": { "terms": "Terms of use", "legal": "Contact & support", "privacy": "Privacy", "nav": { "functions": "Functions", "faq": "FAQ", "pricing": "Pricing", "register": "Register", "signin": "Login" }, "login": { "signin": { "headline": "Login", "forgot_password": "Forgot password?", "submit": "Login", "error": "Login unsuccessful. Please check your input.", "modal": { "headline": "Login failed", "text": "Your email address has not been verified yet. Didn't receive a verification email? Check your spam folder or have it <a href=\"{href}\">resent<\/a>.", "error": "Not yet verified." }, "throttle": { "headline": "Login failed", "text": "Too many login attempts. Please try again in a few minutes." }, "hint": "You need to login first.", "user_inactive": "You don't have an active user account. If you have questions about this, get in touch with the owner of the account." }, "password": { "headline": "Reset password", "text": "Please enter the email address used during registration. You will receive further instructions on how to reset your password via email.", "success": "Please check your email inbox!", "error": "No user registered with that email address." }, "confirm": { "headline": "Confirm email address", "text": "We logged you in right away!", "back": "Let's go" }, "accept": { "headline": "Verifying invitation", "text": "One moment please...", "back": "Let's go" }, "confirm_fail": { "headline": "Confirmation failed", "list": ["Did you already confirm your email address? Try to <a href=\"{href}\">login<\/a> first.", "Please copy the confirmation link from your email manually into the address bar of your browser.", "If that doesn't help, please <a href=\"{href}\">request a new confirmation link<\/a>."], "back": "to the login" }, "confirmation": { "headline": "Request confirmation code", "text": "Please enter the email address used during registration. We'll send you another confirmation code.", "success": "Please check your email inbox!", "error": "No user registered with that email address." }, "reset": { "headline": "Reset password", "text": "Please choose a new password:<br><ul><li>at least 8 characters<\/li><li>including digits (0-9)<\/li><li>lowercase and uppercase characters<\/li><\/ul>", "success": "Your password has been changed succesfully.", "error": "The password reset code could not be identified." }, "reset_fail": { "headline": "Password reset failed", "text": "The password reset code has expired, is invalid or has been used before. Please check the URL or request a <a href=\"{href}\">new code<\/a>.", "back": "to login" }, "signup": { "headline": "Create account", "welcome": "Awesome, that you want to try ONDURO free for 30 days!", "note": "This is to create a new account for your company. Do you already have an account and just want to log in? Go to <a href=\"{href}\">login<\/a>.", "text": "Please choose your personal password:", "help": "<b>Look out!<\/b> A secure password contains at least 8 characters with a mix of uppercase, lowercase letters and digits.", "password": "Choose a password", "password_confirm": "Repeat password", "submit": "Create account", "success": "Your registration was successful. From now on you can login with your email address and password.", "accepted": "You have successfully accepted the invitation. You can now log in with your email and password.", "error": "The registration code could not be identified." }, "signup_fail": { "headline": "Signup failed", "text": ["The registration code has expired, is invalid or has been used before.", "Please request a new code from the account owner."], "back": "to login" }, "accept_fail": { "headline": "Invitation failed", "text": "The invitation code has expired, is invalid or has been used before. Please request another invitation from your manager." }, "password_reset": { "error": "You don't have a password yet. Please complete your account set-up first by clicking on the link in your invitation e-mail." } }, "registration": { "defaults": { "account": "Company name", "location": "Headquarter", "contract": "0-hour contract", "cost": "General costs", "shifts": { "F": "Morning", "M": "Afternoon", "S": "Evening" } }, "terms": "I accept the <a href=\"https:\/\/www.onduro.com\/nl\/gebruiksvoorwaarden\" target=\"_blank\">terms of use<\/a> and the <a href=\"https:\/\/www.onduro.com\/nl\/privacy\" target=\"_blank\">privacy policy<\/a>.", "error_general": "Your account cannot be created at this moment. Please try again later.", "error_already_registered": "You already have an account at ONDURO. Do you really want to create another one?", "error_not_verified": "Your email address is not yet verified. Would you like to receive another verification email?", "done": { "headline": "You've got mail!", "text": "Please click on the verification link in the email we just sent to you.", "notice": "PS: Also check your spam folder!", "back": "back to home page" }, "terms_owner": "I hereby agree to the <a href=\"https:\/\/www.onduro.com\/nl\/gebruiksvoorwaarden\" target=\"_blank\">terms of use<\/a>, the <a href=\"https:\/\/www.onduro.com\/nl\/dpa\" target=\"_blank\">data processing agreement<\/a> and the <a href=\"https:\/\/www.onduro.com\/nl\/privacy\" target=\"_blank\">privacy policy<\/a> on behalf of {company} and I have legal authority to do so." } }, "wizard": { "help": "Need help?<br>Click me!", "nav": { "1": "Welcome", "2": "Your account", "3": "Company", "4": "Employees", "5": "Functions", "6": "Module" }, "back": "back", "next": "next", "later": "I'll do that later", "conclude": "next", "step1": { "headline": "Welcome", "text": ["We're gonna set-up your roster!", "Have questions or need help?<br>Click on the guy at the top left."], "submit": "Let's go", "later": "Not now, I'll do that later!" }, "step2": { "headline": "Your account", "note": "You already have a password for ONDURO, you don't need to choose another one.", "password": { "label": "Choose a password", "placeholder": "min. 6 characters and digits" } }, "step3": { "headline": "The company", "company": { "label": "What's the name of your company?", "placeholder": "Company name" }, "branch": { "label": "What's your industry?", "options": { "gastronomy": "Gastronomy", "retail": "Retail", "healthcare": "Healthcare", "other": "Other" } } }, "step4": { "headline": "Employees", "employees": { "label": "Who do you want to schedule?", "placeholder": "Lars Schmidt, Maike Koch, Hans Peters, Anne Fischer" }, "hint": ["Add one name per row or divided by commas.", "You can add more employees later at any time."] }, "step5": { "headline": "Functions", "duties": { "label": "Which functions exist at {name}?", "placeholder": "Bar, kitchen, office" }, "hint": ["Add one function per row or divided by commas.", "You can add more functions later at any time."] }, "step6": { "headline": "Activities", "text": "Which employee can execute which function?" }, "step7": { "headline": "Modules", "text": ["Activate all modules you'll need.", "There will be <u>no<\/u> extra charges for activated modules."], "shifts": { "label": "Shift planning", "hint": "work with shifts, e.g. \"Evening\" from 18:00 - 00:00" }, "hours": { "label": "Hour registration and reporting", "hint": "let employees register hours and<br>easily create hour reports" }, "availability": { "label": "Availability", "hint": "let employees fill in their availability" } }, "step8": { "headline": "Done!", "text": ["That was easy, right?", "Have some questions? Don't hesitate to contact us:"], "submit": "Go to ONDURO", "flash": { "headline": "Welcome, {name}!", "text": "<p>You can get started right away. Drag the name of an employee from the column on the right onto the roster. Then, click on the item to add working hours and more.<\/p><strong>Have fun with ONDURO!<\/strong><small>Tip: We gathered some more information for you on the overview page.<\/small>" } } }, "tools": { "remove_item": { "text": "Do you really want to delete this item?", "headline": "Delete item" } }, "notification": { "message_added": "Your message has been added!" }, "conflict": { "INVALID_DUTY": "Function is not valid (anymore)", "INVALID_SHIFT": "Shift is not valid (anymore)", "INVALID_USER": "Employee ist not plannable", "AVAILABILITY": "Employee is not available", "ERR_OVERLAP": "This item overlaps with another one for this employee", "ERR_EXISTING_FULL": "The employee is already scheduled today", "ERR_HOURS": "Hours have already been registered for this item", "ERR_CONFIRMED": "Registered hours for this item have already been approved", "message": "Please resolve the following conflicts:", "NO_DUTY_SET": "This item needs a function", "ERR_OVERLAP_REST": "This item overlaps with the rest period of this employee" }, "meta": { "description": "ONDURO login page" }, "onboarding": { "intro": ["Let's make sure, that you can get the most out of ONDURO.", "We do this in two ways:"], "university": "Learn how to use ONDURO in the university.<br>Step by step, in your own pace.<br>Click on the image above to get started.", "support": "Do you have questions?<br>Don't hesitate to contact us.<br>Via the \"help\" link at the top.", "cancel": "Nah, let me do it on my own.", "disable": { "headline": "Disable onboarding?", "text": "You can always return to the university by clicking the link in the navigation. Do you want to disable onboarding for now?" }, "loggedinas": "Currently logged in as:", "self": "this is you", "switch": "Curious how other employees see ONDURO? Click on the link underneath to switch roles.", "switch_to": "Switch to:", "own_staff": "Ready to import your own employees?", "get_in_touch": "Get in touch with us via the help link above!", "role_manager": "As manager you can do almost everything the account owner can do. Except managing the subscription.", "role_planner": "As planner you are able to schedule employees and publish the roster.", "role_supervisor": "As supervisor you can approve or deny the registered hours of other employees.", "role_user": "Employees or external freelancers mainly submit availabilities, check their roster or submit worked hours.", "next_steps": "What are the next steps?" }, "university": { "minified": "Back to the university...", "lets_begin": "Let's begin!", "headline": "What do you want to learn?", "no_lessons": "There are no lessons for this page or search.", "lesson": { "related": "Related topics", "try": "Try a bit yourself" }, "show_all": "Show all lessons." }, "confirm": { "legal": { "statement": ["I, <b>{name}<\/b>, declare that", "I have fully read and understood the terms above; and", "I accept these on behalf of <b>{company}<\/b>; and", "I have full legal authority to do so."], "too_small": "Your device is too small to show this important document, please use your computer.", "scroll_notice": "Attention: The document below can be scrolled." }, "chat": { "delete": { "headline": "Are you sure?", "text": "After that, you will not be able to see any messages in this chat anymore" } }, "resting": { "conflict": "This change conflicts with the rest period for {name}. Apply anyway?" } }, "tooltip": { "roster": { "notes": "Attach more information for all items on this day. The entered text will be displayed with the items in the roster.", "tools": { "notes": "Attach more information to this item. The entered text will be displayed with the item in the roster." }, "tab": { "all": "of selected planning" } }, "reports": { "labels": "Filter status by \"approved\" to add labels." }, "contracts": { "days": { "flex": "ONDURO will use this information to calculate salaries on vacation days.", "fixed": "ONDURO will use this information to calculate salaries on vacation days or holidays (on workdays)." } }, "date_info": "You can click on the year number in the date picker popup to quickly change the year.", "balance": { "holiday": "will be added to employees balance on every active holiday where employee does not work" }, "calculations": { "totals": "This panel shows the totals of the selected week across all plannings.", "period": "Select here or click on a date in the planning to change the period." }, "beta": "Beta functionality. Use with care. Feedback welcome!", "hours_per_week": "hours per week" }, "soon": { "contracts": "Contract management coming soon..." }, "button": { "reset_filters": "reset filters", "add_contract": "Add contract", "manage_plannings": "Manage plannings", "refresh": "Refresh" }, "todo": { "invite": "Invite employee", "contract": "Assign a contract", "duty": "Assign function(s)", "salary": "Assign salary", "profile": "Complete required profile fields", "profile_employee": "Employee has not completed profile", "contract_incomplete": "Contract incomplete (requires: dates, signed contract, salary)", "certificates_expire": "Certificates expired" }, "folder": { "payslips": "Payslips", "sepa": "SEPA files", "contracts": "Contracts", "uploads": "User uploads", "journals": "Salary journals", "annuals": "Other", "others": "Additional documents", "others_description": "(Wage tax certificate, social insurance certificate, other documents)" }, "cards": { "items": { "open": { "headline": "Open services" }, "applications": { "headline": "Applications" }, "no_open_duties": "There are no open duties", "no_open_applications": "There are no open applications" } }, "warning": { "registration_incomplete": "Employee registration incomplete!", "item_with_applications": "This item already has applications! In order to change it, delete it and create a new one." }, "sko": { "malta": { "tk": ["If you don't have insurance, you can", "apply for one here at TK", "or", "download a PDF with further information"] } } };/* harmony default export */ __webpack_exports__["default"] = (locales);

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(502),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(504),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(506),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(508),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(510),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        /**
         * inArray wrapper
         */
        inArray: function inArray(collection, key) {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.indexOf(collection, key) !== -1;
        },
        empty: function empty(obj) {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(obj);
        },
        map: function map(obj, arg) {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(obj, arg);
        }
    }
});

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(512),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(517),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(523),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(528),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(530),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(532),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(534),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(537),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(539),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(541),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(542),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(544),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(546),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(547)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-753c2fc1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(551),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(564),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */,
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(566),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(568),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(572),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(574),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(576),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(578),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(580),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(582),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(616),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(615),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(586),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(590),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(592),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(594),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(596),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(598),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(600),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(602),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(604),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(606),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(608),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(610),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(612),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(614),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(618),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Reuseable collections for dropdowns
 **/

var collections = {
    /**
     * Minutes for pause
     *
     * @param {Boolean}
     * @param {Boolean} withUnit
     * @return {{}}
     */
    pause: function pause(withUnit) {
        var pauses = {},
            unit = withUnit ? ' m' : '';

        // 0 = dash (–)
        pauses[0] = '\u2014';

        for (var i = 15; i <= 120; i += 15) {
            pauses[i.toString() + unit] = i.toString() + unit;
        }

        return pauses;
    },


    /**
     * Minutes for timepicker dropdown
     *
     * @param {Boolean} withUnit
     * @returns {{}}
     */
    minutes: function minutes(withUnit) {
        var minutes = {},
            unit = withUnit ? ' m' : '';

        for (var i = 0; i <= 60; i += 15) {
            minutes[i.toString() + unit] = i < 10 ? '0' + i : i.toString() + unit;
        }

        return minutes;
    },


    /**
     * Hours for timepicker dropdown
     *
     * @returns {{}}
     */
    hours: function hours(withUnit) {
        var hours = {},
            unit = withUnit ? ' h' : '';

        for (var i = 0; i < 24; i++) {
            hours[i.toString() + unit] = i < 10 ? '0' + i : i.toString() + unit;
        }

        return hours;
    },


    /**
     * Returns collection prepared for v-select component input
     *
     * @param selection
     * @param {Collection} collection, expects collection of objects having name and id
     */
    tags: function tags(selection, collection) {
        var _collection = [];

        collection.forEach(function (item) {
            _collection.push({
                label: item.name,
                value: item.id
            });
        });

        _collection = _.sortBy(_collection, 'label');

        return _.differenceBy(_collection, selection, 'value');
    },


    /**
     * Weeks for dropdwon
     *
     * @returns {{}}
     */
    weeks: function weeks() {
        var weeks = {};

        for (var i = 1; i < 54; i++) {
            weeks[i] = i;
        }

        return weeks;
    },


    /**
     * Returns an object of years based on starting point
     *
     * @param {mixed} present representing base year to calculate with. If boolean (true) year of the present year is used
     * @param {number} back years to go back
     * @param {number} future years to go into the future
     * @returns {{}}
     */
    years: function years(present, back, future) {
        var today = new Date().getFullYear(),
            years = {};

        if (typeof present != 'boolean' && typeof present != 'undefined' || present === false) today = present;

        for (var i = back * -1; i <= future; i++) {
            years[(today + i).toString()] = today + i;
        }

        return years;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (collections);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shared = {
    state: {
        filter: 'open',
        selectedLocations: [],
        selectedEmployees: [],
        memberships: [],
        data: [],
        multipleCosts: false, // set to true if currently displayed hours have multiple costs to choose from (need to show cost column then!)
        multipleLocations: false,
        sorting: 'desc',

        comments: [],
        comment: null
    },

    getComments: function getComments(id) {
        return _.orderBy(shared.state.comments.filter(function (item) {
            return id === item.item.id;
        }), ['localized'], ['asc']);
    },
    removeComment: function removeComment(id) {
        shared.state.comments = _.remove(shared.state.comments, function (item) {
            return item.id !== id;
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (shared);

/***/ }),
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var labels = {
    nl: {
        about: 'Over mij',
        address: 'Straat & huisnummer',
        address_extra: 'Adress extra',
        birth_country: 'Geboorteland',
        birth_place: 'Geboorteplaats',
        birthday: 'Geboortedatum',
        bravo_number: 'Bravonummer',
        children: 'Kinderen?',
        children_amount: 'Aantal kinderen',
        church_tax: 'Geloofsgemeenschap',
        city: 'Plaats',
        contract_end: 'Datum uit dienst',
        contract_hours: 'Uren per week',
        contract_start: 'Datum in dienst',
        contract_type: 'Contracttype',
        cost_center: 'Kostenplaats',
        cost_center_code: 'Kostenplaats (code)',
        cost_center_name: 'Kostenplaats (naam)',
        country: 'Land',
        education_level: 'Hoogste schooldiploma',
        email: 'Email',
        employee_number: 'Personeelsnummer',
        employee_type: 'Werknemerstype',
        fax: 'Fax',
        fname: 'Voornaam',
        gender: 'Geslacht',
        health_insurance_last: 'Laatste wettelijke ziektekostenverzekering',
        health_insurance_last_unknown: 'onbekend / niet verzekerd',
        health_insurance_law: 'Ziektekostenverzekering',
        health_insurance_private: 'Ziektekostenverzekering',
        health_insurance_proof: 'Bewijs van ziektekostenverzekering',
        health_insurance_type: 'Type verzekering',
        iban: 'IBAN',
        job_title: 'Functieomschrijving',
        lname: 'Achternaam',
        lname_maiden: 'Meisjesnaam',
        marital_status: 'Getrouwd?',
        mobile: 'Mobiel',
        nationality: 'Nationaliteit',
        pass_number: 'Pasnummer',
        payee: 'Begunstigde',
        payroll: 'Payroll',
        phone: 'Telefoon',
        profession_level: 'Hoogste beroepskwalificatie',
        residence_permit_expiration: 'Verblijfsvergunning tot',
        residence_permit_issued: 'Verblijfsvergunning uitgegeven op',
        residence_permit_issuer: 'Verblijfsvergunning uitgegeven door',
        residence_permit_proof: 'Verblijfsvergunning',
        ssn: 'Burgerservicenummer',
        student_proof: 'Bewijs van inschrijving',
        tax_class: 'Tariefgroep',
        tax_number: 'Fiscaal identificatienummer',
        title: 'Titel',
        work_permit_expiration: 'Werkvergunning tot',
        work_permit_issued: 'Werkvergunning uitgegeven op',
        work_permit_issuer: 'Werkvergunning uitgegeven door',
        work_permit_proof: 'Werkvergunning',
        zip: 'Postcode'
    },
    en: {
        about: 'About me',
        address: 'Street & house number',
        address_extra: 'c/o',
        birth_country: 'Country of birth',
        birth_place: 'Place of birth',
        birthday: 'Date of birth',
        bravo_number: 'Bravo number',
        children: 'Children?',
        children_amount: 'Number of exemptions for children',
        church_tax: 'Employee church tax',
        city: 'City',
        contract_end: 'End date',
        contract_hours: 'Hours per week',
        contract_start: 'Hire date',
        contract_type: 'Contract type',
        cost_center: 'Cost center',
        cost_center_code: 'Cost center (code)',
        cost_center_name: 'Cost center (name)',
        country: 'Country',
        education_level: 'Highest education level',
        email: 'E-mail',
        employee_number: 'Employee number',
        employee_type: 'Employee type',
        fax: 'Fax',
        fname: 'First name',
        gender: 'Gender',
        health_insurance_last: 'Last insurance provider by law',
        health_insurance_last_unknown: 'unknown / not insured',
        health_insurance_law: 'Health insurance provider',
        health_insurance_private: 'Health insurance provider',
        health_insurance_proof: 'Proof of insurance',
        health_insurance_type: 'Insurance type',
        iban: 'IBAN',
        job_title: 'Job title',
        lname: 'Last name',
        lname_maiden: 'Maiden name',
        marital_status: 'Married?',
        mobile: 'Mobile',
        nationality: 'Nationality',
        pass_number: 'Pass number',
        payee: 'Payee',
        payroll: 'Payroll',
        phone: 'Phone',
        profession_level: 'Highest professional qualification',
        residence_permit_expiration: 'Residence permit until',
        residence_permit_issued: 'Residence permit issued on',
        residence_permit_issuer: 'Residence permit issued by',
        residence_permit_proof: 'Residence permit',
        ssn: 'Social security number',
        student_proof: 'Proof of study',
        tax_class: 'Tax class',
        tax_number: 'Tax number',
        title: 'Title',
        work_permit_expiration: 'Work permit until',
        work_permit_issued: 'Work permit issued on',
        work_permit_issuer: 'Work permit issued by',
        work_permit_proof: 'Work permit',
        zip: 'Zip code'
    },
    de: {
        about: 'Über mich',
        address: 'Straße und Hausnummer',
        address_extra: 'Anschriftenzusatz',
        birth_country: 'Geburtsland',
        birth_place: 'Geburtsort',
        birthday: 'Geburtsdatum',
        bravo_number: 'Bravo Nummer',
        children: 'Kinder?',
        children_amount: 'Anzahl der Kinder',
        church_tax: 'Konfessions&shy;zugehörigkeit',
        city: 'Ort',
        contract_end: 'Austrittsdatum',
        contract_hours: 'Wöchentliche Arbeitszeit',
        contract_start: 'Eintrittsdatum',
        contract_type: 'Arbeitsverhältnis',
        cost_center: 'Kostenstelle',
        cost_center_code: 'Kostenstelle (Code)',
        cost_center_name: 'Kostenstelle (Bezeichnung)',
        country: 'Land',
        education_level: 'Höchster Schulabschluss',
        email: 'E-mail',
        employee_number: 'Personalnummer',
        employee_type: 'Arbeitnehmertyp',
        fax: 'Fax',
        fname: 'Vorname',
        gender: 'Geschlecht',
        health_insurance_last: 'Letzte gesetzliche Krankenkasse',
        health_insurance_last_unknown: 'unbekannt / unversichert',
        health_insurance_law: 'Gesetzliche Krankenkasse',
        health_insurance_private: 'Private Krankenkasse',
        health_insurance_proof: 'Beitragsbescheinigung',
        health_insurance_type: 'Versicherungsklasse',
        iban: 'IBAN',
        job_title: 'Beschäftigungstyp',
        lname: 'Nachname',
        lname_maiden: 'Geburtsname',
        marital_status: 'Verheiratet?',
        mobile: 'Mobil',
        nationality: 'Nationalität',
        pass_number: 'Pass Nummer',
        payee: 'Kontoinhaber',
        payroll: 'Payroll',
        phone: 'Telefon',
        profession_level: 'Höchster beruflicher Ausbildungsabschluss',
        residence_permit_expiration: 'Aufenthaltserlaubnis bis',
        residence_permit_issued: 'Aufenthaltserlaubnis erteilt am',
        residence_permit_issuer: 'Aufenthaltserlaubnis erteilt durch',
        residence_permit_proof: 'Aufenthaltserlaubnis',
        ssn: 'Sozialversicherungs&shy;nummer',
        student_proof: 'Studentenbescheinigung',
        tax_class: 'Steuerklasse',
        tax_number: 'Steuer Identifikations&shy;nummer',
        title: 'Akademischer Grad',
        work_permit_expiration: 'Arbeitserlaubnis bis',
        work_permit_issued: 'Arbeitserlaubnis erteilt am',
        work_permit_issuer: 'Arbeitserlaubnis erteilt durch',
        work_permit_proof: 'Arbeitserlaubnis',
        zip: 'Postleitzahl'
    },
    pl: {
        about: 'About me',
        address: 'Ulica i numer domu',
        address_extra: 'Dodatek adresowy',
        birth_country: 'Kraj urodzenia',
        birth_place: 'Miejsce urodzenia',
        birthday: 'Data urodzenia',
        bravo_number: 'Bravo number',
        children: 'Czy masz dzieci?',
        children_amount: 'Liczba dzieci',
        church_tax: 'Employee church tax',
        city: 'Lokalizacja',
        contract_end: 'End date',
        contract_hours: 'Godziny pracy',
        contract_start: 'Hire date',
        contract_type: 'Typ kontraktu',
        cost_center: 'Centrum kosztów',
        cost_center_code: 'Centrum kosztów (kod)',
        cost_center_name: 'Centrum kosztów (nazwa)',
        country: 'Kraj',
        education_level: 'Highest education level',
        email: 'E-mail',
        employee_number: 'Numer personelu',
        employee_type: 'Typ pracownika',
        fax: 'Fax',
        fname: 'Imię',
        gender: 'Płeć',
        health_insurance_last: 'Ostatnia ustawowa kasa chorych',
        health_insurance_last_unknown: 'onbekend / niet verzekerd',
        health_insurance_law: 'Ustawowe ubezpieczenie zdrowotne',
        health_insurance_private: 'Prywatne ubezpieczenie zdrowotne',
        health_insurance_proof: 'Wyciąg ze składek',
        health_insurance_type: 'Klasa ubezpieczenia',
        iban: 'IBAN',
        job_title: 'Stanowisko',
        lname: 'Nazwisko rodowe',
        lname_maiden: 'Nazwisko panieńskie',
        marital_status: 'Żonaty?',
        mobile: 'Numer telefonu komórkowego',
        nationality: 'Narodowość',
        pass_number: 'Pass number',
        payee: 'Właściciel konta',
        payroll: 'Payroll',
        phone: 'Numer telefonu komórkowego',
        profession_level: 'Highest professional qualification',
        residence_permit_expiration: 'Zezwolenie na pobyt udzielone do',
        residence_permit_issued: 'Zezwolenie na pobyt wydane dnia',
        residence_permit_issuer: 'Zezwolenie na pobyt wydane przez',
        residence_permit_proof: 'Zezwolenie na pobyt',
        ssn: 'Numer ubezpieczenia społecznego',
        student_proof: 'Czy masz ważne świadectwo ukończenia studiów (matury)?',
        tax_class: 'Klasa podatkowa',
        tax_number: 'Tax number',
        title: 'Title',
        work_permit_expiration: 'Zezwolenie na pracę wydane do',
        work_permit_issued: 'Zezwolenie na pracę wydane dnia',
        work_permit_issuer: 'Zezwolenie na pracę wydane przez',
        work_permit_proof: 'Zezwolenie na pracę',
        zip: 'Kod pocztowy'
    }
};

/* harmony default export */ __webpack_exports__["a"] = (labels);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App__);




var __svg__ = { filename: __webpack_require__.p +"static/svg-sprite/84749ac8a0d6298f43600feb73c5f11fsvg-symbols.svg" };

__webpack_require__(639)(__svg__);

// Vue.config.debug = false;
// Vue.config.devtools = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({

    el: '#app',
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_2__components_App___default.a);
    },
    store: __WEBPACK_IMPORTED_MODULE_1__bootstrap__["b" /* store */],
    router: __WEBPACK_IMPORTED_MODULE_1__bootstrap__["a" /* router */],

    data: {
        hasTouch: false
    },

    mounted: function mounted() {
        moment().locale(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.lang);

        window.addEventListener('load', this.getViewportSize);
        window.addEventListener('resize', this.getViewportSize);
        window.addEventListener('touchstart', this.setHasTouch);

        // the following snippet can be used when user returns to browser tab
        // document.addEventListener('visibilitychange', function()
        // {
        //     if (document.visibilityState == 'visible') { }
        // });
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('load', this.getViewportSize);
        window.removeEventListener('resize', this.getViewportSize);
    },


    methods: {
        setHasTouch: function setHasTouch() {
            this.hasTouch = true;

            // remove event listener once fired, otherwise it'll kill scrolling performance
            window.removeEventListener('touchstart', this.setHasTouch);
        },


        // sets viewport property based on viewport width
        getViewportSize: function getViewportSize() {
            this.$store.dispatch('layout/setViewport');
            this.$store.dispatch('layout/setMainContentHeight');
        }
    },

    components: { App: __WEBPACK_IMPORTED_MODULE_2__components_App___default.a }

});

/***/ }),
/* 347 */,
/* 348 */,
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_vue__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage_fallback__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_local_storage_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_local_storage_fallback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_filters__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_http__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_modal__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_flash__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_widget__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_confirm__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_current__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_onduro__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_notify__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_loader__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_tools__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plugins_notes__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_tooltip__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_chatbox__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_calendar__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__plugins_timepicker__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__plugins_university__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_i18n__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__plugins_validation__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__vuex_store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__filters__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__plugins_localStore__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__plugins_vue2_dnd__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__router__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_wysiwyg__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_globals__ = __webpack_require__(637);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_26__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_22__vuex_store__["a"]; });



if (true) {
    __WEBPACK_IMPORTED_MODULE_1__sentry_vue__["init"]({
        Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["default"],
        dsn: 'https://1c48b60aff2646fa9ac1e191058a3a59@sentry.io/189653',
        release: "95e9b7caf261111b3b2f022c59f91aa8da11e37e".trim(),
        environment: "production"
    });
}

// localStorage drop-in replacement fallback

if (!('localStorage' in window)) window.localStorage = __WEBPACK_IMPORTED_MODULE_2_local_storage_fallback___default.a;



























window._ = __webpack_require__(27);
window.moment = __webpack_require__(0);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_i18n___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__plugins_http__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__plugins_modal__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__plugins_flash__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__plugins_widget__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__plugins_current__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__plugins_confirm__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__plugins_onduro__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__plugins_notify__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__plugins_loader__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21__plugins_validation__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14__plugins_notes__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__plugins_tools__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__plugins_chatbox__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17__plugins_calendar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18__plugins_timepicker__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19__plugins_university__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24__plugins_localStore__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25__plugins_vue2_dnd__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__plugins_tooltip__["a" /* default */]);

// https://github.com/chmln/vue-wysiwyg
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27_vue_wysiwyg___default.a, {
    hideModules: {
        'code': true,
        'link': true,
        'separator': true
    },
    forcePlainTextOnPaste: true
});

// try to login user and initialize current store
__WEBPACK_IMPORTED_MODULE_22__vuex_store__["a" /* default */].dispatch('auth/checkAuth');

// Load global components


// handler for missing translations
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.missingHandler = function (lang, key, vm) {
    if (false) console.info('missing translation', lang, key);
};



/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(122);






var Http = {};

// use this var to make sure not to show other error messages while user is being logged out due to inactivity
var loggingOut = false;

// register axios globally
// window.axios = axios;

/*
* Load decorator for loader animation in v-loader directive areas
* Ajax calls with loader animation in a specific area need to be prefixed with the prototype method 'loader'.
* Loader accepts an argument 'area'. Area should be a unique identifier for the area that should contain the loader animation. E.g. 'sidebar'
*
* To make the area 'sidebar' listen to the loader event, it must provide the vue-directive 'v-loader'.
* You can find more information on how to use this directive at '@src/js/plugins/loader.js'.
*/
var loader = function loader(area) {
    var axiosInstance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();

    var requestInterceptors = request({
        up: function up() {
            return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].loader.areaUp(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].loaderPrefix + area);
        },
        down: function down() {
            return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].loader.areaDown(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].loaderPrefix + area);
        }
    });

    var responseInterceptors = response({
        down: function down() {
            return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].loader.areaDown(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* default */].loaderPrefix + area);
        }
    });

    // axios REQUEST interceptor
    axiosInstance.interceptors.request.use(requestInterceptors[0], requestInterceptors[1]);

    // axios RESPONSE interceptor
    axiosInstance.interceptors.response.use(responseInterceptors[0], responseInterceptors[1]);

    return axiosInstance;
},
    silent = function silent() {
    var axiosInstance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();

    return axiosInstance;
},
    request = function request(callbacks) {
    return [function (config) {
        callbacks.up();
        return config;
    }, function (error) {
        callbacks.down();
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    }];
},
    response = function response(callbacks) {
    return [function (response) {
        callbacks.down();
        return response;
    }, function (error) {
        if (loggingOut) return;

        if (error.response.status == 401 && error.response.data.logout) {
            loggingOut = true;

            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].modal.show(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].t('error.token_mismatch.text'), function () {
                __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].dispatch('auth/logout', function (success) {
                    loggingOut = false;
                    window.location = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].onduro.route('login.signin');
                });
            });
        } else if (error.response.status == 503 || error.response.status == 504) {
            __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].dispatch('app/maintenance', true);
        } else if (error.response.status != 422 && error.response.status != 409 && error.response.status != 413) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].notify.error(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].t('error.whoops.title'), __WEBPACK_IMPORTED_MODULE_2_vue__["default"].t('error.whoops.headline'));
        }

        callbacks.down();

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    }];
};

Http.install = function (Vue, options) {
    // Axios interceptors for general loader
    var requestInterceptors = request({
        up: function up() {
            return Vue.loader.up();
        },
        down: function down() {
            return Vue.loader.down();
        }
    });

    var responseInterceptors = response({
        down: function down() {
            return Vue.loader.down();
        }
    });

    // axios REQUEST interceptor
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(requestInterceptors[0], requestInterceptors[1]);

    // axios RESPONSE interceptor
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(responseInterceptors[0], responseInterceptors[1]);

    // register global methods
    Vue.http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a;

    // instance methods
    Vue.prototype.$http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a;

    // Add loaderaware
    Vue.http.__proto__.loader = loader;
    Vue.prototype.$http.__proto__.loader = loader;

    // Add silent requests
    Vue.http.__proto__.silent = silent;
    Vue.prototype.$http.__proto__.silent = silent;
};

/* harmony default export */ __webpack_exports__["a"] = (Http);

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_events__ = __webpack_require__(2);




var state = {
    ready: false,
    modules: [],
    updated: null,
    loaded: null,
    env: 'production',
    touchDevice: false,
    os: null,
    mouseDown: false,
    university: false,
    maintenance: false,
    baseUrl: ''
};

var actions = {
    init: function init(_ref, callback) {
        var dispatch = _ref.dispatch,
            commit = _ref.commit;

        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/api/app/init').then(function (response) {
            commit('current/INIT', response.data, { root: true });
            commit('INIT', response.data);
            commit('SET_READY', true);

            __WEBPACK_IMPORTED_MODULE_2__events_events__["a" /* default */].$emit('app.authenticated');

            if (!__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.layout.viewport) dispatch('layout/setViewport', null, { root: true });

            if (callback) callback();
        }).catch(function (error) {
            // server is in maintenance mode
            if (error.response && error.response.status == 503 || error.response.status == 504) {
                commit('MAINTENANCE', true);
                commit('SET_READY', true);
                return;
            }

            // something went wrong... log user out
            dispatch('auth/logout', function () {
                window.location.href = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('login.signin');
            }, { root: true });
        });
    },
    reinit: function reinit(_ref2, callback) {
        var dispatch = _ref2.dispatch,
            commit = _ref2.commit;

        // don't show loader on re-init

        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get('/api/app/init').then(function (response) {
            commit('current/INIT', response.data, { root: true });
            commit('REINIT', response.data);

            if (callback) callback();
        }).catch(function (error) {
            // server is in maintenance mode
            if (error.response.status == 503 || error.response.status == 504) {
                commit('MAINTENANCE', true);
                commit('SET_READY', true);
                return;
            }

            // something went wrong... log user out
            dispatch('auth/logout', function () {
                window.location.href = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.route('login.signin');
            }, { root: true });
        });
    },
    mouseDown: function mouseDown(_ref3, status) {
        var dispatch = _ref3.dispatch,
            commit = _ref3.commit;

        commit('MOUSE_DOWN', status);
    },
    loader: function loader(_ref4, show) {
        var dispatch = _ref4.dispatch,
            commit = _ref4.commit;

        commit('LOADER', show);
    },
    maintenance: function maintenance(_ref5, status) {
        var dispatch = _ref5.dispatch,
            commit = _ref5.commit;

        commit('MAINTENANCE', status);
    }
};

var mutations = {
    INIT: function INIT(state, data) {
        state.modules = data.app.modules;
        state.updated = data.app.updated;
        state.loaded = data.app.loaded;

        var user = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.current.user;
        var account = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.current.account;
        var services = data.app.services;

        if (location.hostname.match('localhost') || location.hostname.match('.onduro.test')) {
            state.env = 'local';
            state.baseUrl = 'http://localhost';
        } else if (location.hostname.match('mobile')) {
            state.env = 'mobile';
            state.touchDevice = true;
            state.baseUrl = 'https://mobile.onduro.com';
        } else if (location.hostname.match('alpha')) {
            state.env = 'alpha';
            state.baseUrl = 'https://alpha.onduro.com';
        } else if (location.hostname.match('beta')) {
            state.env = 'beta';
            state.baseUrl = 'https://beta.onduro.com';
        } else if (location.hostname.match('test')) {
            state.env = 'test';
            state.baseUrl = 'https://test.onduro.com';
        }

        var userAgent = window.navigator.userAgent.toLowerCase();

        if (/android/i.test(userAgent)) {
            state.touchDevice = true;
            state.os = 'android';
        }

        if (/ipad|iphone|ipod/i.test(userAgent)) {
            state.touchDevice = true;
            state.os = 'ios';
        }

        if (services.intercom && !__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.auth.fake) {
            window.intercomSettings = {
                app_id: services.intercom,
                user_id: user.intercom,
                name: user.name,
                email: user.email,
                custom_launcher_selector: ".box-intercom",
                created_at: user.createdAt,
                user_hash: user.intercomHmac,
                language_override: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.lang,
                company: {
                    id: account.intercom,
                    name: account.name,
                    demo: account.demo,
                    demo_activated: 'true',
                    beta: account.beta ? 'true' : 'false',
                    created_at: account.createdAt,
                    plan: account.status,
                    modules: account.modules.join('|'),
                    country: account.settings.country,
                    dpa: account.agreements.dpa
                },
                biller: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('biller') ? 'true' : 'false',
                accountant: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('accountant') ? 'true' : 'false',
                supervisor: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('supervisor') ? 'true' : 'false',
                role_owner: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('owner') ? 'true' : 'false',
                role_manager: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole(['owner', 'manager']) ? 'true' : 'false',
                role_planner: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].onduro.hasRole('planner') ? 'true' : 'false',
                language: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.lang
            };

            (function () {
                var w = window;
                var ic = w.Intercom;
                if (typeof ic === "function") {
                    ic('reattach_activator');
                    ic('update', intercomSettings);
                } else {
                    var d = document;
                    var i = function i() {
                        i.c(arguments);
                    };
                    i.q = [];
                    i.c = function (args) {
                        i.q.push(args);
                    };
                    w.Intercom = i;

                    // launch intercom
                    var s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = '//widget.intercom.io/widget/' + services.intercom;

                    var x = d.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);
                }
            })();
        } else {
            // unload intercom
            window.Intercom = null;
        }
    },
    REINIT: function REINIT(state, data) {
        state.modules = data.app.modules;
        state.updated = data.app.updated;
        state.loaded = data.app.loaded;
    },
    SET_READY: function SET_READY(state, ready) {
        state.ready = ready;
    },
    MOUSE_DOWN: function MOUSE_DOWN(state, status) {
        state.mouseDown = status;
    },
    MAINTENANCE: function MAINTENANCE(state, status) {
        state.maintenance = status;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_vue__ = __webpack_require__(49);





// pre-populate everything thats is needed reactive right from the start!
var state = {
    locale: '',
    account: {
        availability: {
            deadline: '',
            editable: false,
            constraints: false,
            vacation: false
        },
        setup: 1
    },
    accounts: {},
    location: null,
    project: null,
    membership: {},
    user: {}
};

var actions = {
    init: function init(_ref, data) {
        var commit = _ref.commit;

        commit('INIT', data);
    },
    reset: function reset(_ref2) {
        var commit = _ref2.commit;

        commit('RESET');
    },
    updateGravatar: function updateGravatar(_ref3, image) {
        var commit = _ref3.commit;

        commit('UPDATE_GRAVATAR', image);
    },
    updateLocale: function updateLocale(_ref4, data) {
        var commit = _ref4.commit;

        commit('UPDATE_LOCALE', data);
    },
    updateModules: function updateModules(_ref5, data) {
        var commit = _ref5.commit;

        commit('UPDATE_MODULES', data);
    },
    addModule: function addModule(_ref6, identifier) {
        var commit = _ref6.commit;

        commit('ADD_MODULE', identifier);
    },
    removeModule: function removeModule(_ref7, identifier) {
        var commit = _ref7.commit;

        commit('REMOVE_MODULE', identifier);
    },
    updateUser: function updateUser(_ref8, data) {
        var commit = _ref8.commit;

        commit('UPDATE_USER', data);
    },
    updateMembership: function updateMembership(_ref9, data) {
        var commit = _ref9.commit;

        commit('UPDATE_MEMBERSHIP', data);
    },
    updateLocation: function updateLocation(_ref10, data) {
        var commit = _ref10.commit;

        commit('UPDATE_LOCATION', data);
    },
    updateProject: function updateProject(_ref11, data) {
        var commit = _ref11.commit;

        commit('UPDATE_PROJECT', data);
    },
    updateAccount: function updateAccount(_ref12, data) {
        var commit = _ref12.commit;

        commit('UPDATE_ACCOUNT', data);
    },
    updatePreference: function updatePreference(_ref13, payload) {
        var commit = _ref13.commit;

        commit('UPDATE_PREFERENCE', payload);
    },
    updateCheckin: function updateCheckin(_ref14, payload) {
        var commit = _ref14.commit;

        commit('UPDATE_CHECKIN', payload);
    }
};

var mutations = {
    INIT: function INIT(state, data) {
        state.locale = data.current.locale;
        state.account = data.current.account;
        state.accounts = data.current.accounts;
        state.location = data.current.location;
        state.membership = data.current.membership;
        state.user = data.current.user;
        state.profile = data.current.profile;
        state.project = data.current.project;

        if (state.locale != __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.meta.lang) {
            // user's language preference differs from current language
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('meta/setLanguage', state.locale, { root: true });

            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].onduro.switchLanguage(state.locale, true); // replace route
        }

        if (__WEBPACK_IMPORTED_MODULE_3__sentry_vue__) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_vue__["setContext"]('app', {
                user: data.current.user.name,
                account: data.current.account.name
            });

            __WEBPACK_IMPORTED_MODULE_3__sentry_vue__["setTag"]('version', "95e9b7");
        }
    },
    RESET: function RESET(state) {
        state.location = null;
        state.membership = {};
        state.user = {};
    },
    UPDATE_LOCALE: function UPDATE_LOCALE(state, locale) {
        state.locale = locale;
    },
    UPDATE_GRAVATAR: function UPDATE_GRAVATAR(state, image) {
        state.user.gravatar = image;
    },
    UPDATE_MODULES: function UPDATE_MODULES(state, data) {
        state.account.modules = data;
    },
    ADD_MODULE: function ADD_MODULE(state, identifier) {
        if (state.account.modules.indexOf(identifier) == -1) {
            state.account.modules.push(identifier);
        }
    },
    REMOVE_MODULE: function REMOVE_MODULE(state, identifier) {
        var key = state.account.modules.indexOf(identifier);

        if (key !== -1) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.account.modules, key);
        }
    },
    UPDATE_USER: function UPDATE_USER(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.user, data);
    },
    UPDATE_MEMBERSHIP: function UPDATE_MEMBERSHIP(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.membership, data);
    },
    UPDATE_ACCOUNT: function UPDATE_ACCOUNT(state, data) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.account, data);
    },
    UPDATE_LOCATION: function UPDATE_LOCATION(state, data) {
        state.location = data;
    },
    UPDATE_PROJECT: function UPDATE_PROJECT(state, data) {
        state.project = data;
    },
    UPDATE_PREFERENCE: function UPDATE_PREFERENCE(state, payload) {
        state.membership.preferences[payload.identifier] = payload.value;
    },
    UPDATE_CHECKIN: function UPDATE_CHECKIN(state, payload) {
        state.membership.checkedIn = payload;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_laravel_echo__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sentry_vue__ = __webpack_require__(49);






var state = {
    authenticated: false,
    token: null, // this is the X-CSRF-TOKEN
    fake: false
};

var actions = {
    checkAuth: function checkAuth(_ref) {
        var commit = _ref.commit;

        var token = localStorage.getItem('auth_token');

        if (token) {
            commit('LOGIN', {
                token: token
            });
        } else {
            __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('current/reset');
            commit('app/SET_READY', true, { root: true });
        }
    },
    login: function login(_ref2, payload) {
        var commit = _ref2.commit;

        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('/api/auth/login', {
            email: payload.email,
            password: payload.password,
            token: payload.token,
            locale: __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.meta.lang,
            mobile: location.hostname.match('mobile') ? true : false // this is needed in order to send a long-lasting cookie in the response
        }).then(function (response) {
            if (location.hostname.match('beta') && !response.data.beta) {
                // beta access not allowed
                commit('LOGOUT', {
                    // callback needs to be wrapped in a function, otherwise it will be triggered immediately,
                    // since we are including the response object in the function parameter
                    callback: payload.error ? function () {
                        payload.error(response);
                    } : null
                });

                return;
            }

            try {
                localStorage.setItem('auth_token', response.data.csrfToken);
            } catch (e) {
                captureMessage('Could not write [auth_token] to localStorage.', { level: 'info' });

                alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
            }

            commit('LOGIN', {
                token: response.data.csrfToken,
                callback: payload.success ? payload.success : null
            });
        }).catch(function (error) {
            commit('LOGOUT', {
                // callback needs to be wrapped in a function, otherwise it will be triggered immediately,
                // since we are including the response object in the function parameter
                callback: payload.error ? function () {
                    payload.error(error.response);
                } : null
            });
        });
    },
    autoLogin: function autoLogin(_ref3, payload) {
        var commit = _ref3.commit;

        try {
            localStorage.setItem('auth_token', payload.csrfToken);
        } catch (e) {
            captureMessage('Could not write [auth_token] to localStorage.', { level: 'info' });

            alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
        }

        commit('LOGIN', {
            token: payload.csrfToken,
            callback: payload.callback ? payload.callback : null
        });
    },


    // invoke fake user limitations
    fake: function fake(_ref4) {
        var commit = _ref4.commit;

        commit('FAKE');
    },


    // remove fake user limitations
    real: function real(_ref5) {
        var commit = _ref5.commit;

        commit('REAL');
    },
    logout: function logout(_ref6, callback) {
        var commit = _ref6.commit;

        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post('/api/auth/logout').then(function (response) {
            commit('LOGOUT', {
                callback: callback ? callback : null
            });
        }).catch(function (error) {
            commit('LOGOUT', {
                callback: callback ? callback : null
            });
        });
    }
};

var mutations = {
    LOGIN: function LOGIN(state, payload) {
        state.authenticated = true;
        state.token = payload.token;

        window.Pusher = __webpack_require__(431);

        window.Echo = new __WEBPACK_IMPORTED_MODULE_3_laravel_echo__["a" /* default */]({
            broadcaster: 'pusher',
            key: "production" == 'development' || location.hostname.match('test') ? '5ba6032fb1b5bebd6c9c' : 'c489323fb6f37412c460',
            authEndpoint: '/api/auth/broadcast',
            namespace: 'Onduro.Events',
            cluster: 'eu',
            csrfToken: payload.token,
            encrypted: true
        });

        // set axios headers
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.defaults.headers.common['X-CSRF-TOKEN'] = payload.token;
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.defaults.headers.common['X-ONDURO-MOBILE'] = location.hostname.match('mobile') ? true : false;

        setSocketId();

        // adds overflow:hidden to body
        document.body.classList.add('in-app');

        if (localStorage.getItem('fake')) state.fake = true;

        __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('app/init', payload.callback);

        __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch('chat/setUnreadChats');

        // replace 'ONDURO | Login'
        document.title = 'ONDURO';
    },
    FAKE: function FAKE(state) {
        if (window.Intercom) {
            Intercom('shutdown');
            window.Intercom = null;
        }

        state.fake = true;
        localStorage.setItem('fake', true);
    },
    REAL: function REAL(state) {
        state.fake = false;
        localStorage.removeItem('fake');
    },
    LOGOUT: function LOGOUT(state, payload) {
        state.authenticated = false;
        state.token = null;
        state.fake = false;

        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].university.close();

        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.defaults.headers.common['X-CSRF-TOKEN'] = '';
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.defaults.headers.common['X-ONDURO-MOBILE'] = '';
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.defaults.headers.common['X-Socket-ID'] = '';

        localStorage.removeItem('fake');
        localStorage.removeItem('auth_token');

        if (__WEBPACK_IMPORTED_MODULE_4__sentry_vue__) {
            __WEBPACK_IMPORTED_MODULE_4__sentry_vue__["configureScope"](function (scope) {
                return scope.clear();
            });
        }

        if (window.Echo) {
            window.Echo.disconnect();
            window.Echo = null;

            __WEBPACK_IMPORTED_MODULE_2__events_events__["a" /* default */].$emit('auth.loggedout');
        }

        if (window.Intercom) Intercom('shutdown');

        // removes overflow:hidden to body
        document.body.classList.remove('in-app');

        __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].commit('app/SET_READY', true, { root: true });

        if (payload.callback) payload.callback();
    }
};

function setSocketId() {
    setTimeout(function () {
        var socketId = window.Echo.socketId();

        if (socketId) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.defaults.headers.common['X-Socket-ID'] = socketId;
        } else {
            // try again...
            setSocketId();
        }
    }, 200);
}

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 430 */,
/* 431 */,
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_browser__ = __webpack_require__(34);



var state = {
    lang: ''
};

var actions = {
    setLanguage: function setLanguage(_ref, lang) {
        var dispatch = _ref.dispatch,
            commit = _ref.commit;

        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.lang = lang;
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.defaults.headers.common['Accept-Language'] = lang;

        dispatch('current/updateLocale', lang, { root: true });

        try {
            localStorage.setItem('locale', lang);
        } catch (e) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["i" /* captureMessage */])('Could not write [locale] to localStorage.', { level: 'info' });

            alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
        }

        commit('SET_LANGUAGE', lang);
    }
};

var mutations = {
    SET_LANGUAGE: function SET_LANGUAGE(state, lang) {
        state.lang = lang;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__(14);




var state = {
    mobile: false,
    viewport: null,
    hasNavigation: false,
    hasFooterBar: false,
    rosterView: null,
    mainContentHeight: null
};

var actions = {
    setViewport: function setViewport(_ref) {
        var commit = _ref.commit;

        commit('SET_VIEWPORT');
    },
    toggleNavigation: function toggleNavigation(_ref2) {
        var commit = _ref2.commit;

        commit('TOGGLE_NAVIGATION');
    },
    showNavigation: function showNavigation(_ref3) {
        var commit = _ref3.commit;

        commit('SHOW_NAVIGATION');
    },
    hideNavigation: function hideNavigation(_ref4) {
        var commit = _ref4.commit;

        commit('HIDE_NAVIGATION');
    },
    showFooterBar: function showFooterBar(_ref5) {
        var commit = _ref5.commit;

        commit('SHOW_FOOTER_BAR');
    },
    hideFooterBar: function hideFooterBar(_ref6) {
        var commit = _ref6.commit;

        commit('HIDE_FOOTER_BAR');
    },
    setMainContentHeight: function setMainContentHeight(_ref7) {
        var commit = _ref7.commit;

        var main = document.querySelector('.content'),
            height = 0;

        if (main) height = main.clientHeight;

        commit('SET_MAIN_CONTENT_HEIGHT', height);
    },
    rosterView: function rosterView(_ref8, payload) {
        var commit = _ref8.commit;

        var value = payload,
            update = true;

        if ((typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(payload)) === 'object') {
            update = payload.update;
            value = payload.value;
        }

        if (update) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.put('/api/memberships/' + __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].state.current.membership.id + '/preferences', {
                key: 'roster.view',
                value: value
            });
        }

        commit('ROSTER_VIEW', value);
    }
};

var mutations = {
    SET_VIEWPORT: function SET_VIEWPORT(state) {
        var width = window.innerWidth;

        if (width <= 400) {
            state.viewport = 'mp';
        } else if (width <= 600) {
            state.viewport = 'ml';
        } else if (width <= 800) {
            state.viewport = 'tp';
        } else if (width <= 1200) {
            state.viewport = 'tl';
        } else {
            state.viewport = 'd';
        }

        state.mobile = state.viewport != 'd' && state.viewport != 'tl';
    },
    TOGGLE_NAVIGATION: function TOGGLE_NAVIGATION(state) {
        state.hasNavigation = !state.hasNavigation;
    },
    SHOW_NAVIGATION: function SHOW_NAVIGATION(state) {
        state.hasNavigation = true;
    },
    HIDE_NAVIGATION: function HIDE_NAVIGATION(state) {
        state.hasNavigation = false;
    },
    SHOW_FOOTER_BAR: function SHOW_FOOTER_BAR(state) {
        state.hasFooterBar = true;
    },
    HIDE_FOOTER_BAR: function HIDE_FOOTER_BAR(state) {
        state.hasFooterBar = false;
    },
    ROSTER_VIEW: function ROSTER_VIEW(state, value) {
        state.rosterView = value;
    },
    SET_MAIN_CONTENT_HEIGHT: function SET_MAIN_CONTENT_HEIGHT(state, value) {
        state.mainContentHeight = value;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// default states
var defaults = {
    type: null,
    position: null,
    tab: {
        activeTab: 0,
        mainContentTab: false
    }
};

// initial state
var state = {
    type: defaults.type,
    position: defaults.position,
    tab: {
        activeTab: 0,
        mainContentTab: false
    }
};

var actions = {
    // Set type of sidebar
    setType: function setType(_ref, type) {
        var commit = _ref.commit;

        commit('SET_TYPE', type);
    },


    // Reset type of sidebar to default
    resetType: function resetType(_ref2) {
        var commit = _ref2.commit;

        commit('RESET_TYPE');
    },


    // Set position key for sidebar
    setPosition: function setPosition(_ref3, position) {
        var commit = _ref3.commit;

        commit('SET_POSITION', position);
    },


    // Reset position key of sidebar to default
    resetPosition: function resetPosition(_ref4) {
        var commit = _ref4.commit;

        commit('RESET_POSITION');
    },


    // Reset sidebar
    reset: function reset(_ref5) {
        var commit = _ref5.commit;

        commit('RESET_TYPE');
        commit('RESET_ACTIVE_TAB');
        commit('RESET_MAIN_CONTENT_TAB');
    },


    // Set active tab index
    setActiveTab: function setActiveTab(_ref6, index) {
        var commit = _ref6.commit;

        commit('SET_ACTIVE_TAB', index);
    },


    // Set value if tabs have a content tab
    mainContentTab: function mainContentTab(_ref7, val) {
        var commit = _ref7.commit;

        commit('MAIN_CONTENT_TAB', val);
    }
};

var mutations = {
    SET_TYPE: function SET_TYPE(state, type) {
        state.type = type;
    },
    RESET_TYPE: function RESET_TYPE(state) {
        state.type = defaults.type;
    },
    SET_POSITION: function SET_POSITION(state, position) {
        if (position == 'top') state.position = 'top';
        // else if (position == 'right') state.position = 'right';
        // else if (position == 'left') state.position = 'left';
        else state.position = 'bottom';
    },
    RESET_POSITION: function RESET_POSITION(state) {
        state.position = defaults.position;
    },
    SET_ACTIVE_TAB: function SET_ACTIVE_TAB(state, index) {
        state.tab.activeTab = index;
    },
    RESET_ACTIVE_TAB: function RESET_ACTIVE_TAB(state) {
        state.tab.activeTab = defaults.tab.activeTab;
    },
    MAIN_CONTENT_TAB: function MAIN_CONTENT_TAB(state, val) {
        state.tab.mainContentTab = val;
    },
    RESET_MAIN_CONTENT_TAB: function RESET_MAIN_CONTENT_TAB(state) {
        state.tab.mainContentTab = defaults.tab.mainContentTab;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


var state = {
    data: {}
};

var actions = {
    write: function write(_ref, data) {
        var commit = _ref.commit;


        commit('WRITE', data);
    },
    updateEntry: function updateEntry(_ref2, data) {
        var commit = _ref2.commit;


        commit('UPDATE_ENTRY', data);
    }
};

var mutations = {
    WRITE: function WRITE(state, data) {

        if (typeof data.key == 'undefined') {
            console.error('Key for cache is missing');
            return false;
        }

        state.data[data.key] = data.payload;
    },
    UPDATE_ENTRY: function UPDATE_ENTRY(state, data) {

        if (typeof data.key == 'undefined' || typeof data.path == 'undefined') {
            console.error('Key for temp is missing');
            return false;
        }

        var obj = _.update(state.data[data.key], data.path, function () {
            return data.entry;
        });

        // Remove reactivity from temp object
        state.data[data.key] = typeof obj != 'undefined' ? obj : state.data[data.key];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);



var state = {
    data: {}
};

var actions = {
    write: function write(_ref, data) {
        var commit = _ref.commit;


        commit('WRITE', data);
    },
    updateEntry: function updateEntry(_ref2, data) {
        var commit = _ref2.commit;


        commit('UPDATE_ENTRY', data);
    }
};

var mutations = {
    WRITE: function WRITE(state, data) {

        if (typeof data.key == 'undefined') {
            console.error('Key for temp is missing');
            return false;
        }

        // Remove reactivity from temp object
        state.data[data.key] = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.payload));
    },
    UPDATE_ENTRY: function UPDATE_ENTRY(state, data) {

        if (typeof data.key == 'undefined' || typeof data.path == 'undefined') {
            console.error('Key for temp is missing');
            return false;
        }

        var obj = _.update(state.data[data.key], data.path, function () {
            return data.entry;
        });

        // Remove reactivity from temp object
        state.data[data.key] = typeof obj != 'undefined' ? obj : state.data[data.key];
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 447 */,
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);



// pre-populate everything thats is needed reactive right from the start!
var state = {
    count: 0,
    areas: {}
};

var actions = {
    up: function up(_ref) {
        var commit = _ref.commit;

        commit('UP');
    },
    down: function down(_ref2) {
        var commit = _ref2.commit;

        commit('DOWN');
    },
    areaUp: function areaUp(_ref3, area) {
        var commit = _ref3.commit;

        commit('AREA_UP', area);
    },
    areaDown: function areaDown(_ref4, area) {
        var commit = _ref4.commit;

        commit('AREA_DOWN', area);
    }
};

var mutations = {
    UP: function UP(state) {
        state.count++;
    },
    DOWN: function DOWN(state) {
        var count = state.count - 1;
        state.count = Math.max(count, 0);
    },
    AREA_UP: function AREA_UP(state, area) {
        if (typeof state.areas[area] === 'undefined') state.areas[area] = 0;
        // If value is zero, up was called first time
        if (state.areas[area] === 0) __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit(area, 'on');
        state.areas[area]++;
    },
    AREA_DOWN: function AREA_DOWN(state, area) {
        var count = state.areas[area] - 1;
        state.areas[area] = Math.max(count, 0);
        // If value is zero, down was called last time
        if (state.areas[area] === 0) __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit(area, 'off');
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var state = {
    unreadChats: [],
    activeChannel: null,
    activeChannelInfos: {}
};

var actions = {
    //    fakeUpdateUnreadChats ({commit})
    //    {
    //        commit('FAKE_UPDATE_UNREAD_CHATS');
    //    },

    setUnreadChats: function setUnreadChats(_ref) {
        var commit = _ref.commit;

        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.silent().get('/api/memberships/unread-chats').then(function (response) {
                commit('SET_UNREAD_CHATS', response.data);
                resolve(response.data);
            }).catch(function (error) {
                reject('failed');
            });
        });
    },
    setActiveChannel: function setActiveChannel(_ref2, channelId) {
        var commit = _ref2.commit;

        commit('SET_ACTIVE_CHANNEL', channelId);
    },
    setActiveChannelInfos: function setActiveChannelInfos(_ref3, channelInfos) {
        var commit = _ref3.commit;

        commit('SET_ACTIVE_CHANNEL_INFOS', channelInfos);
    }
};

var mutations = {
    SET_UNREAD_CHATS: function SET_UNREAD_CHATS(state, chats) {
        state.unreadChats = chats;
    },
    SET_ACTIVE_CHANNEL: function SET_ACTIVE_CHANNEL(state, channelId) {
        state.activeChannel = channelId;
    },
    SET_ACTIVE_CHANNEL_INFOS: function SET_ACTIVE_CHANNEL_INFOS(state, channelInfos) {
        state.activeChannelInfos = channelInfos;
    }
};

var getters = {
    countUnread: function countUnread(state) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(state.unreadChats, function (item) {
            return item.channel.id !== state.activeChannel;
        }).length;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var Modal = {};

/**
 * Modal plugin
 *
 * @param Vue
 * @param options
 */
Modal.install = function (Vue, options) {
    var methods = {
        /**
         * Show modal and set content
         *
         * @param {String} headline
         * @param {String} content
         * @param {Function} callback
         */
        show: function show(headline, content, callback, blank, wide) {
            this.headline = '';
            this.content = '';
            this.callback = '';

            if (arguments.length == 2 && typeof arguments[1] == 'function') {
                this.content = headline;
                this.callback = content;
            } else if (arguments.length == 1) {
                this.content = headline;
            } else {
                this.headline = headline;
                this.content = content;
                this.callback = callback;
            }

            // push modal on event bus
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('modal.open', this.headline, this.content, this.callback, blank, wide);
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('modal.close');
        }
    };

    // register global methods
    Vue.modal = methods;

    // register instance methods
    Vue.prototype.$modal = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var Flash = {};

/**
 * Flash plugin
 *
 * @param Vue
 * @param options
 */
Flash.install = function (Vue, options) {
    var methods = {
        /**
         * Show flash and set content
         *
         * @param {String} headline
         * @param {String} content
         * @param {Function} callback
         */
        show: function show(headline, content, callback) {
            this.headline = '';
            this.content = '';
            this.callback = '';

            if (arguments.length == 2 && typeof arguments[1] == 'function') {
                this.content = headline;
                this.callback = content;
            } else if (arguments.length == 1) {
                this.content = headline;
            } else {
                this.headline = headline;
                this.content = content;
                this.callback = callback;
            }

            // push flash on event bus
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('flash.open', this.headline, this.content, this.callback);
        }
    };

    // register global methods
    Vue.flash = methods;

    // register instance methods
    Vue.prototype.$flash = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (Flash);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var Widget = {};

/**
 * Widget plugin
 *
 * @param Vue
 * @param options
 */
Widget.install = function (Vue, options) {
    var plugin = {
        inactive: false,

        /**
         * Open widget by given name
         *
         * @param name
         * @param args
         */
        open: function open(name, args, dismissable) {
            plugin.inactive = false;
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('widget.open', name, args, dismissable);
        },


        /**
         * Hide widget. Widget does not get removed from dom
         */
        deactivate: function deactivate() {
            plugin.inactive = true;
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('widget.deactivate');
        },


        /**
         * Show widget.
         */
        activate: function activate() {
            plugin.inactive = false;
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('widget.activate');
        },


        /**
         * External close method
         */
        close: function close() {
            plugin.inactive = false;
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('widget.close');
        }
    };

    // register plugin globally
    Vue.widget = plugin;
    Vue.prototype.$widget = plugin;
};

/* harmony default export */ __webpack_exports__["a"] = (Widget);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var Confirm = {};

/**
 * Confirm plugin
 *
 * @param Vue
 * @param options
 */
Confirm.install = function (Vue, options) {
    var methods = {
        /**
         * Show confirm and set content
         *
         * @param {String} headline
         * @param {String} content
         * @param {Object} callback
         * @param {Object} label
         */
        show: function show(headline, content, callback, label, html) {
            // push confirm on event bus
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('confirm.open', headline, content, callback, label, html);
        }
    };

    // register global methods
    Vue.confirm = methods;

    // register instance methods
    Vue.prototype.$confirm = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (Confirm);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuex_store__ = __webpack_require__(14);


var Current = {};

/**
 * Current plugin
 *
 * @param Vue
 * @param options
 */
Current.install = function (Vue, options) {
  // register global methods
  Vue.current = __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].state.current;

  // register instance methods
  Vue.prototype.$current = __WEBPACK_IMPORTED_MODULE_0__vuex_store__["a" /* default */].state.current;
};

/* harmony default export */ __webpack_exports__["a"] = (Current);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vuex_store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blueimp_md5__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_blueimp_md5__);





window.inArray = function (needle, haystack) {
    if (!(haystack instanceof Array)) throw 'window.inArray: haystack is not an Array';

    return haystack.indexOf(needle) !== -1;
};

window.isset = function (val) {
    if (typeof val == 'undefined') return false;
    if (val == null) return false;
    return true;
};

var ONDURO = {};

ONDURO.install = function (Vue, options) {
    var methods = {
        /*
         * App Ready Function
         *
         * This function ensures, that the "current" store is fully initialized
         * for usage in the routes "beforeEnter" hook.
         */
        isReady: function isReady(callback) {
            var _this = this;

            if (__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.app.ready) {
                callback();
                return;
            }

            setTimeout(function () {
                if (__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.app.ready) {
                    callback();
                    return;
                }

                _this.isReady(callback);
            }, 200);
        },


        /*
         *  Check if current membership is in the shadow
         */
        isShadow: function isShadow() {
            return __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.membership.shadow;
        },

        /*
         *  Check if current membership is not in the shadow
         */
        isReal: function isReal() {
            return !this.isShadow();
        },

        /*
         *  Check if current account has (any) certain module(s)
         *
         *  Usage:
         *  $onduro.hasModule('some_role')                        // string
         *  $onduro.hasModule(['any', 'of', 'these', 'modules'])  // array
         */
        hasModule: function hasModule(identifier) {
            var modules = __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.account.modules;

            if (identifier instanceof Array) {
                return _.intersection(identifier, modules).length;
            } else {
                return inArray(identifier, modules);
            }
        },

        /*
         *  Check if current user has ANY certain role(s)
         *
         *  Usage:
         *  $onduro.hasRole('some_role')                        // string
         *  $onduro.hasRole('this_role', 'or_this_one')         // arguments
         *  $onduro.hasRole(['any', 'of', 'these', 'roles'])    // array
         */
        hasRole: function hasRole() {
            var roles = __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.membership.roles;

            var identifiers = arguments;

            if (identifiers.length == 1) {
                if (arguments[0] instanceof Array) {
                    identifiers = arguments[0];
                } else {
                    return inArray(arguments[0], roles);
                }
            }

            var hasRole = false;
            _.forOwn(identifiers, function (identifier) {
                if (inArray(identifier, roles)) hasRole = true;
            });

            return hasRole;
        },

        isSkoUser: function isSkoUser() {
            if (__WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.user.email.indexOf('@onduro.com') !== -1) return true;
            return __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.account.sko && __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.user.email.indexOf('@sk-office.net') !== -1;
        },
        shorten: function shorten(text) {
            var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
            var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';

            var chars = window.innerWidth * max / 100 / 40 * 4;
            return text.length > chars ? text.substr(0, chars - 3) + suffix : text;
        },


        hasRight: function hasRight(identifier) {
            var rights = __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.membership.rights;

            return inArray(identifier, rights);
        },

        getConfig: function getConfig(identifier) {
            return __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.account.config[identifier];
        },

        getPreference: function getPreference(identifier) {
            return __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].state.current.membership.preferences[identifier];
        },

        redirect: function redirect(name, params) {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(this.route(name, params));
        },
        route: function route(path, params, lang) {
            lang = lang || Vue.config.lang;

            var name = path.replace('/', '.');

            params = params ? '/' + params : '';

            if (name == 'login') name = 'login.signin';

            var translation = _getTranslation('route.' + name + '.path', lang);

            if (translation !== false) {
                // remove params from translation
                translation = translation.split('/:')[0];

                return '/' + lang + '/' + translation + params;
            }

            return '/' + lang + '/' + path + params;
        },


        // returns the translated route path from any given (invalid) path
        translatedRoutePath: function translatedRoutePath(route, lang) {
            var name = route.name;

            if (!name) return '/' + lang;

            if (name == 'login') name = 'login.signin';

            var translatedPath = '/:lang/' + _getTranslation('route.' + name + '.path', lang);

            if (translatedPath) {
                var segments = route.path.split('/');
                var params = route.matched.slice(-1)[0].path.split('/'); // take last matched route
                var translated = translatedPath.split('/');

                var path = params.map(function (segment, index) {
                    if (segment.indexOf(':') === 0) {
                        return segments[index];
                    } else {
                        return translated[index];
                    }
                });

                return path.join('/');
            }

            return this.route(name);
        },


        /**
         * Decorator for $store[cache/temp:write]
         *
         * @param key
         * @param payload
         * @param temp
         */
        writeCache: function writeCache(key, payload, temp) {
            var _store = temp ? 'temp' : 'cache';

            __WEBPACK_IMPORTED_MODULE_1__vuex_store__["a" /* default */].dispatch(_store + '/write', {
                key: key,
                payload: payload
            });
        },


        /**
         * Remove observer from object to clear reactivity
         *
         * @param obj
         */
        untrack: function untrack(obj) {
            return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
        },


        /**
         * Compare to vue objects
         *
         * @param a
         * @param b
         * @returns {boolean}
         */
        compare: function compare(a, b) {
            return __WEBPACK_IMPORTED_MODULE_3_blueimp_md5___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_.map(a, function (n) {
                return n == '' ? null : n;
            }))) == __WEBPACK_IMPORTED_MODULE_3_blueimp_md5___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_.map(b, function (n) {
                return n == '' ? null : n;
            })));
        },


        /**
         * Convert minutes having unit to number in minutes
         */
        timeToNumber: function timeToNumber(val) {
            if (!val) return 0;

            var num = val.toString();

            if (num.indexOf(':') != -1) {
                var segments = num.split(':');
                num = parseInt(segments[0]) * 60 + parseInt(segments[1]);
            } else if (val.toString().toLowerCase().indexOf('h') != -1 && val.toString().toLowerCase().indexOf('m')) {
                //@TODO split string and calculate
            } else num = parseInt(num);

            return num || 0;
        },
        numberToTime: function numberToTime(val) {
            var hours = val / 60,
                minutes = val % 60;

            hours = val > 0 ? Math.floor(hours) : Math.ceil(hours);

            return (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes);
        },
        makeDuration: function makeDuration(time) {
            return time.end < time.start ? (time.end || 0) - (time.start || 0) - (time.break || 0) + 1440 : (time.end || 0) - (time.start || 0) - (time.break || 0);
        },


        /**
         * convert time to time string 00 h 00 m
         * @param val
         * @returns {string}
         */
        totalString: function totalString(val) {
            var hours = val / 60,
                minutes = val % 60;

            hours = val > 0 ? Math.floor(hours) : Math.ceil(hours);

            return hours + ' h ' + minutes + ' m';
        },


        /**
         * Translate current route to defined language
         *
         * @param lang
         * @returns {string}
         */
        switchLanguage: function switchLanguage(lang, replace) {
            // make sure locales are loaded
            if (lang === 'de') {
                // Use the extended German locale file with country translations
                Vue.locale(lang, __webpack_require__(40).default);
            } else if (lang === 'nl') {
                // Use the extended Dutch locale file with country translations
                Vue.locale(lang, __webpack_require__(41).default);
            } else {
                Vue.locale(lang, __webpack_require__(81)("./locales." + lang).default);
            }

            document.querySelector('meta[name=description]').setAttribute('content', Vue.t('meta.description'));

            var name = __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].app.$route.name,
                params = __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].app.$route.params,
                translation = _getTranslation('route.' + name + '.path', lang);

            // standard route
            var route = '/' + lang + '/' + name;

            if (translation !== false) {
                if (params) {
                    // make sure to replace params, such as :id in the translated url
                    _.forIn(params, function (value, key) {
                        translation = translation.replace(':' + key, value);
                    });
                }

                route = '/' + lang + '/' + translation;
            }

            if (replace) __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace(route);
            return route;
        }
    };

    // private methods
    function _getTranslation(key, lang) {
        if (!lang) lang = Vue.config.lang;

        // translation does not exist for this language
        if (['en', 'de', 'nl', 'pl'].indexOf(lang) == -1) return false;

        var locales = void 0;
        if (lang === 'de') {
            // Use the extended German locale file with country translations
            locales = __webpack_require__(40).default;
        } else if (lang === 'nl') {
            // Use the extended Dutch locale file with country translations
            locales = __webpack_require__(41).default;
        } else {
            locales = __webpack_require__(81)("./locales." + lang).default;
        }

        var translation = key.split('.').reduce(function (o, i) {
            if (o === false) return false;

            if (i in o) {
                return o[i];
            } else {
                return false;
            }
        }, locales);

        return translation;
    }

    // register global methods
    Vue.onduro = methods;

    // instance methods
    Vue.prototype.$onduro = methods;

    // register global assets
    // Vue.directive('my-directive', {});

    // register global mixins
    // Vue.mixin({ methods: ... });
};

/* harmony default export */ __webpack_exports__["a"] = (ONDURO);

/***/ }),
/* 456 */,
/* 457 */,
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./components/App.vue": [
		124
	],
	"./components/chartjs/Bar.vue": [
		647,
		71
	],
	"./components/chartjs/Line.vue": [
		648,
		70
	],
	"./components/global/Action.vue": [
		89
	],
	"./components/global/Bubble.vue": [
		280
	],
	"./components/global/ButtonBack.vue": [
		281
	],
	"./components/global/Calendar.vue": [
		282
	],
	"./components/global/ChannelList.vue": [
		283
	],
	"./components/global/ChannelListGroup.vue": [
		284
	],
	"./components/global/ChannelListSingle.vue": [
		286
	],
	"./components/global/Chat.vue": [
		287
	],
	"./components/global/ChatBubble.vue": [
		288
	],
	"./components/global/Chatbox.vue": [
		82
	],
	"./components/global/Confirm.vue": [
		128
	],
	"./components/global/Container.vue": [
		289
	],
	"./components/global/DatePickerModal.vue": [
		763,
		87
	],
	"./components/global/Dates.vue": [
		290
	],
	"./components/global/Dropdown.vue": [
		291
	],
	"./components/global/Error.vue": [
		292
	],
	"./components/global/Flash.vue": [
		126
	],
	"./components/global/FooterBar.vue": [
		293
	],
	"./components/global/Gravatar.vue": [
		294
	],
	"./components/global/GravatarGroup.vue": [
		295
	],
	"./components/global/Icon.vue": [
		296
	],
	"./components/global/ItemChatbox.vue": [
		297
	],
	"./components/global/Lesson.vue": [
		132
	],
	"./components/global/Loader.vue": [
		129
	],
	"./components/global/LoginAside.vue": [
		139
	],
	"./components/global/MainContent.vue": [
		298
	],
	"./components/global/MainHeader.vue": [
		136
	],
	"./components/global/Modal.vue": [
		125
	],
	"./components/global/Notes.vue": [
		299
	],
	"./components/global/Notification.vue": [
		130
	],
	"./components/global/Numeric.vue": [
		300
	],
	"./components/global/Percents.vue": [
		301
	],
	"./components/global/Pikaday.vue": [
		90
	],
	"./components/global/Presence.vue": [
		649,
		232
	],
	"./components/global/Profile.vue": [
		302
	],
	"./components/global/Rangepicker.vue": [
		304
	],
	"./components/global/Search.vue": [
		305
	],
	"./components/global/Selection.vue": [
		306
	],
	"./components/global/Sidebar.vue": [
		307
	],
	"./components/global/SubHeader.vue": [
		308
	],
	"./components/global/Tab.vue": [
		309
	],
	"./components/global/Tabs.vue": [
		310
	],
	"./components/global/Timeframe.vue": [
		311
	],
	"./components/global/Timepicker.vue": [
		312
	],
	"./components/global/Toolbox.vue": [
		313
	],
	"./components/global/Tools.vue": [
		314
	],
	"./components/global/Tooltip.vue": [
		133
	],
	"./components/global/University.vue": [
		131
	],
	"./components/global/Widget.vue": [
		127
	],
	"./components/global/dashboard/Card.vue": [
		330
	],
	"./components/global/dashboard/Filter.vue": [
		644,
		231
	],
	"./components/global/dashboard/OpenApplications.vue": [
		656,
		36
	],
	"./components/global/dashboard/OpenItems.vue": [
		657,
		69
	],
	"./components/global/tools/Conflicts.vue": [
		317
	],
	"./components/global/tools/Duty.vue": [
		320
	],
	"./components/global/tools/Employee.vue": [
		326
	],
	"./components/global/tools/Flags.vue": [
		325
	],
	"./components/global/tools/Internal.vue": [
		316
	],
	"./components/global/tools/NewDuty.vue": [
		328
	],
	"./components/global/tools/NewShift.vue": [
		327
	],
	"./components/global/tools/NewUser.vue": [
		329
	],
	"./components/global/tools/Notes.vue": [
		315
	],
	"./components/global/tools/Project.vue": [
		324
	],
	"./components/global/tools/Shift.vue": [
		319
	],
	"./components/global/tools/Sick.vue": [
		323
	],
	"./components/global/tools/Tags.vue": [
		322
	],
	"./components/global/tools/Times.vue": [
		318
	],
	"./components/global/tools/User.vue": [
		321
	],
	"./components/modals/AbsenceRegistration.vue": [
		658,
		86
	],
	"./components/modules/Navigation.vue": [
		137
	],
	"./components/modules/SubNavigation.vue": [
		659,
		230
	],
	"./components/widgets/addContract.vue": [
		764,
		128
	],
	"./components/widgets/addHours.vue": [
		765,
		229
	],
	"./components/widgets/assignLocations.vue": [
		766,
		85
	],
	"./components/widgets/changeEmail.vue": [
		767,
		228
	],
	"./components/widgets/changePassword.vue": [
		768,
		227
	],
	"./components/widgets/chatParticipants.vue": [
		769,
		226
	],
	"./components/widgets/checkin.vue": [
		770,
		225
	],
	"./components/widgets/checkins.vue": [
		771,
		224
	],
	"./components/widgets/clientProject.vue": [
		772,
		15
	],
	"./components/widgets/clients.vue": [
		773,
		84
	],
	"./components/widgets/contractTemplate.vue": [
		774,
		83
	],
	"./components/widgets/contracts.vue": [
		775,
		82
	],
	"./components/widgets/costs.vue": [
		660,
		223
	],
	"./components/widgets/defaultAvailability.vue": [
		776,
		222
	],
	"./components/widgets/denyHours.vue": [
		777,
		221
	],
	"./components/widgets/duties.vue": [
		778,
		127
	],
	"./components/widgets/employeeNumber.vue": [
		779,
		220
	],
	"./components/widgets/employees.vue": [
		780,
		219
	],
	"./components/widgets/employeesEdit.vue": [
		781,
		126
	],
	"./components/widgets/expenses.vue": [
		782,
		218
	],
	"./components/widgets/holidays.vue": [
		783,
		217
	],
	"./components/widgets/launchDashboard.vue": [
		784,
		216
	],
	"./components/widgets/location.vue": [
		785,
		215
	],
	"./components/widgets/locations.vue": [
		786,
		214
	],
	"./components/widgets/newChat.vue": [
		787,
		213
	],
	"./components/widgets/planningMemberships.vue": [
		788,
		212
	],
	"./components/widgets/planningResources.vue": [
		789,
		211
	],
	"./components/widgets/plannings.vue": [
		790,
		210
	],
	"./components/widgets/premiums.vue": [
		791,
		209
	],
	"./components/widgets/premiumsOverview.vue": [
		792,
		208
	],
	"./components/widgets/profileLocations.vue": [
		793,
		207
	],
	"./components/widgets/projects.vue": [
		794,
		206
	],
	"./components/widgets/rates.vue": [
		795,
		205
	],
	"./components/widgets/report.vue": [
		796,
		125
	],
	"./components/widgets/resources.vue": [
		797,
		204
	],
	"./components/widgets/revenues.vue": [
		798,
		124
	],
	"./components/widgets/salary.vue": [
		799,
		203
	],
	"./components/widgets/shifts.vue": [
		800,
		42
	],
	"./components/widgets/signature.vue": [
		801,
		67
	],
	"./components/widgets/switcher.vue": [
		802,
		202
	],
	"./components/widgets/tags.vue": [
		803,
		201
	],
	"./components/widgets/timechooser.vue": [
		804,
		200
	],
	"./components/widgets/userProfile.vue": [
		805,
		81
	],
	"./pages/availability/Page.vue": [
		806,
		7
	],
	"./pages/availability/components/Sidebar.vue": [
		661,
		123
	],
	"./pages/availability/components/SubHeader.vue": [
		662,
		122
	],
	"./pages/availability/planner/Availability.vue": [
		663,
		41
	],
	"./pages/availability/planner/Cell.new.vue": [
		807,
		121
	],
	"./pages/availability/planner/Cell.vue": [
		650,
		120
	],
	"./pages/availability/user/Availability.vue": [
		664,
		40
	],
	"./pages/availability/user/Cell.vue": [
		651,
		119
	],
	"./pages/balances/details/Page.vue": [
		808,
		34
	],
	"./pages/balances/details/components/Sidebar.vue": [
		665,
		199
	],
	"./pages/balances/details/components/SubHeader.vue": [
		666,
		198
	],
	"./pages/balances/overview/Page.vue": [
		809,
		33
	],
	"./pages/balances/overview/components/Sidebar.vue": [
		667,
		197
	],
	"./pages/balances/overview/components/SubHeader.vue": [
		668,
		196
	],
	"./pages/chats/details/Page.vue": [
		810,
		66
	],
	"./pages/chats/details/components/SubHeader.vue": [
		669,
		195
	],
	"./pages/chats/overview/Page.vue": [
		811,
		65
	],
	"./pages/chats/overview/components/SubHeader.vue": [
		670,
		194
	],
	"./pages/checkins/Page.vue": [
		812,
		10
	],
	"./pages/checkins/components/CheckinTime.vue": [
		673,
		193
	],
	"./pages/checkins/components/Item.vue": [
		652,
		80
	],
	"./pages/checkins/components/Sidebar.vue": [
		672,
		35
	],
	"./pages/checkins/components/SubHeader.vue": [
		671,
		192
	],
	"./pages/clients/overview/Page.vue": [
		813,
		28
	],
	"./pages/clients/overview/components/Sidebar.vue": [
		674,
		118
	],
	"./pages/clients/overview/components/SubHeader.vue": [
		675,
		191
	],
	"./pages/company/Page.vue": [
		814,
		22
	],
	"./pages/contacts/Page.vue": [
		815,
		64
	],
	"./pages/contacts/components/SubHeader.vue": [
		676,
		190
	],
	"./pages/dashboard/Hour.vue": [
		677,
		117
	],
	"./pages/dashboard/Page.vue": [
		816,
		29
	],
	"./pages/demo/Page.vue": [
		817,
		79
	],
	"./pages/documents/detail/Page.vue": [
		818,
		27
	],
	"./pages/documents/detail/components/Sidebar.vue": [
		679,
		116
	],
	"./pages/documents/detail/components/SubHeader.vue": [
		678,
		115
	],
	"./pages/documents/overview/Page.vue": [
		819,
		39
	],
	"./pages/documents/overview/components/Sidebar.vue": [
		820,
		189
	],
	"./pages/documents/overview/components/SubHeader.vue": [
		680,
		188
	],
	"./pages/example.vue": [
		821,
		78
	],
	"./pages/freelancer/Page.vue": [
		822,
		2
	],
	"./pages/freelancer/components/Sidebar.vue": [
		681,
		77
	],
	"./pages/freelancer/components/SubHeader.vue": [
		823,
		187
	],
	"./pages/hours/Page.vue": [
		824,
		14
	],
	"./pages/hours/components/HoursItem.vue": [
		684,
		186
	],
	"./pages/hours/components/Item.vue": [
		825,
		185
	],
	"./pages/hours/components/Sidebar.vue": [
		682,
		184
	],
	"./pages/hours/components/SubHeader.vue": [
		683,
		183
	],
	"./pages/hours/components/tab/biller.vue": [
		826,
		182
	],
	"./pages/hours/components/tab/supervisor.vue": [
		827,
		181
	],
	"./pages/invoice/Page.vue": [
		828,
		180
	],
	"./pages/lists/Page.vue": [
		829,
		3
	],
	"./pages/lists/components/Sidebar.vue": [
		685,
		114
	],
	"./pages/lists/components/SubHeader.vue": [
		686,
		179
	],
	"./pages/log/Page.vue": [
		830,
		26
	],
	"./pages/log/components/Sidebar.vue": [
		687,
		113
	],
	"./pages/log/components/SubHeader.vue": [
		688,
		178
	],
	"./pages/login/2fa-setup/Page.vue": [
		831,
		112
	],
	"./pages/login/2fa-verify/Page.vue": [
		832,
		111
	],
	"./pages/login/accept/Page.vue": [
		833,
		177
	],
	"./pages/login/confirm/Page.vue": [
		834,
		176
	],
	"./pages/login/confirmation/Page.vue": [
		835,
		175
	],
	"./pages/login/password/Page.vue": [
		836,
		174
	],
	"./pages/login/reset/Page.vue": [
		837,
		173
	],
	"./pages/login/signin/Page.vue": [
		838,
		110
	],
	"./pages/login/signup/Page.vue": [
		839,
		172
	],
	"./pages/modules/Page.vue": [
		840,
		19
	],
	"./pages/modules/components/Module.vue": [
		689,
		171
	],
	"./pages/modules/components/Sidebar.vue": [
		690,
		170
	],
	"./pages/modules/components/SubHeader.vue": [
		691,
		169
	],
	"./pages/notifications/Page.vue": [
		841,
		32
	],
	"./pages/notifications/components/Sidebar.vue": [
		692,
		168
	],
	"./pages/notifications/components/SubHeader.vue": [
		693,
		167
	],
	"./pages/overview/Page.vue": [
		842,
		4
	],
	"./pages/overview/components/Sidebar.vue": [
		695,
		166
	],
	"./pages/overview/components/SubHeader.vue": [
		694,
		165
	],
	"./pages/payslips/Page.vue": [
		843,
		21
	],
	"./pages/payslips/components/Sidebar.vue": [
		696,
		76
	],
	"./pages/payslips/components/SubHeader.vue": [
		697,
		164
	],
	"./pages/planning/Page.vue": [
		844,
		1
	],
	"./pages/planning/components/AssignDriver.vue": [
		698,
		63
	],
	"./pages/planning/components/Assigned.vue": [
		703,
		62
	],
	"./pages/planning/components/Availability.vue": [
		705,
		163
	],
	"./pages/planning/components/Calculations.vue": [
		699,
		162
	],
	"./pages/planning/components/Copied.vue": [
		702,
		61
	],
	"./pages/planning/components/Item.vue": [
		642,
		161
	],
	"./pages/planning/components/Placeholder.vue": [
		704,
		60
	],
	"./pages/planning/components/ProjectPopover.vue": [
		707,
		75
	],
	"./pages/planning/components/Sidebar.vue": [
		700,
		160
	],
	"./pages/planning/components/SubHeader.vue": [
		701,
		109
	],
	"./pages/planning/components/Weather.vue": [
		706,
		159
	],
	"./pages/plannings/Page.vue": [
		845,
		25
	],
	"./pages/plannings/components/Sidebar.vue": [
		708,
		108
	],
	"./pages/plannings/components/SubHeader.vue": [
		709,
		158
	],
	"./pages/profile/Page.vue": [
		846,
		31
	],
	"./pages/profile/components/Sidebar.vue": [
		710,
		157
	],
	"./pages/profile/components/SubHeader.vue": [
		711,
		156
	],
	"./pages/projects/Page.vue": [
		847,
		18
	],
	"./pages/projects/components/Sidebar.vue": [
		712,
		107
	],
	"./pages/projects/components/SubHeader.vue": [
		713,
		155
	],
	"./pages/register/Page.vue": [
		848,
		154
	],
	"./pages/reports/Page.vue": [
		849,
		9
	],
	"./pages/reports/components/Item.vue": [
		653,
		106
	],
	"./pages/reports/components/Report.vue": [
		716,
		38
	],
	"./pages/reports/components/Sidebar.vue": [
		715,
		105
	],
	"./pages/reports/components/SubHeader.vue": [
		714,
		104
	],
	"./pages/resources/edit/Page.vue": [
		850,
		24
	],
	"./pages/resources/edit/components/Sidebar.vue": [
		718,
		103
	],
	"./pages/resources/edit/components/SubHeader.vue": [
		717,
		153
	],
	"./pages/resources/overview/Page.vue": [
		851,
		23
	],
	"./pages/resources/overview/components/Sidebar.vue": [
		720,
		102
	],
	"./pages/resources/overview/components/SubHeader.vue": [
		719,
		152
	],
	"./pages/roster/Page.vue": [
		852,
		6
	],
	"./pages/roster/components/Content.vue": [
		721,
		11
	],
	"./pages/roster/components/Day.vue": [
		645,
		13
	],
	"./pages/roster/components/Detail.vue": [
		643,
		74
	],
	"./pages/roster/components/Item.vue": [
		646,
		37
	],
	"./pages/roster/components/Sidebar.vue": [
		722,
		73
	],
	"./pages/roster/components/SubHeader.vue": [
		723,
		72
	],
	"./pages/settings/Page.vue": [
		853,
		68
	],
	"./pages/settings/advanced/Page.vue": [
		854,
		59
	],
	"./pages/settings/advanced/components/SubHeader.vue": [
		724,
		151
	],
	"./pages/settings/availability/Page.vue": [
		855,
		58
	],
	"./pages/settings/availability/components/SubHeader.vue": [
		725,
		150
	],
	"./pages/settings/checkin/Page.vue": [
		856,
		57
	],
	"./pages/settings/checkin/components/SubHeader.vue": [
		726,
		149
	],
	"./pages/settings/contracts/Page.vue": [
		857,
		56
	],
	"./pages/settings/contracts/components/SubHeader.vue": [
		727,
		148
	],
	"./pages/settings/costs/Page.vue": [
		858,
		55
	],
	"./pages/settings/costs/components/SubHeader.vue": [
		728,
		147
	],
	"./pages/settings/duties/Page.vue": [
		859,
		54
	],
	"./pages/settings/duties/components/SubHeader.vue": [
		729,
		146
	],
	"./pages/settings/expenses/Page.vue": [
		860,
		53
	],
	"./pages/settings/expenses/components/SubHeader.vue": [
		730,
		145
	],
	"./pages/settings/general/Page.vue": [
		861,
		52
	],
	"./pages/settings/general/components/SubHeader.vue": [
		731,
		144
	],
	"./pages/settings/holidays/Page.vue": [
		862,
		51
	],
	"./pages/settings/holidays/components/SubHeader.vue": [
		732,
		143
	],
	"./pages/settings/locations/Page.vue": [
		863,
		50
	],
	"./pages/settings/locations/components/SubHeader.vue": [
		733,
		142
	],
	"./pages/settings/premiums/Page.vue": [
		864,
		49
	],
	"./pages/settings/premiums/components/SubHeader.vue": [
		734,
		141
	],
	"./pages/settings/rates/Page.vue": [
		865,
		48
	],
	"./pages/settings/rates/components/SubHeader.vue": [
		735,
		140
	],
	"./pages/settings/shifts/Page.vue": [
		866,
		47
	],
	"./pages/settings/shifts/components/SubHeader.vue": [
		736,
		139
	],
	"./pages/settings/tags/Page.vue": [
		867,
		46
	],
	"./pages/settings/tags/components/SubHeader.vue": [
		737,
		138
	],
	"./pages/setup/Page.vue": [
		868,
		137
	],
	"./pages/statistics/Page.vue": [
		869,
		5
	],
	"./pages/statistics/components/Sidebar.vue": [
		741,
		101
	],
	"./pages/statistics/components/SubHeader.vue": [
		740,
		136
	],
	"./pages/statistics/components/TabDetails.vue": [
		739,
		45
	],
	"./pages/statistics/components/TabOverview.vue": [
		738,
		12
	],
	"./pages/subscription/Page.vue": [
		870,
		30
	],
	"./pages/subscription/components/Sidebar.vue": [
		742,
		135
	],
	"./pages/subscription/components/SubHeader.vue": [
		743,
		134
	],
	"./pages/team/edit/Page.vue": [
		871,
		0
	],
	"./pages/team/edit/components/SubHeader.vue": [
		744,
		133
	],
	"./pages/team/edit/sidebars/absence.vue": [
		758,
		100
	],
	"./pages/team/edit/sidebars/contract.vue": [
		754,
		44
	],
	"./pages/team/edit/sidebars/dossier.vue": [
		756,
		99
	],
	"./pages/team/edit/sidebars/payslips.vue": [
		757,
		98
	],
	"./pages/team/edit/sidebars/profile.vue": [
		752,
		97
	],
	"./pages/team/edit/sidebars/salary.vue": [
		755,
		96
	],
	"./pages/team/edit/sidebars/settings.vue": [
		753,
		95
	],
	"./pages/team/edit/tabs/Absence.vue": [
		751,
		20
	],
	"./pages/team/edit/tabs/Contract.vue": [
		746,
		94
	],
	"./pages/team/edit/tabs/Dossier.vue": [
		749,
		93
	],
	"./pages/team/edit/tabs/Payslips.vue": [
		750,
		92
	],
	"./pages/team/edit/tabs/Profile.vue": [
		745,
		91
	],
	"./pages/team/edit/tabs/Salary.vue": [
		747,
		90
	],
	"./pages/team/edit/tabs/Settings.vue": [
		748,
		89
	],
	"./pages/team/overview/Page.vue": [
		872,
		17
	],
	"./pages/team/overview/components/Sidebar.vue": [
		760,
		88
	],
	"./pages/team/overview/components/SubHeader.vue": [
		759,
		132
	],
	"./pages/today/Page.vue": [
		873,
		8
	],
	"./pages/today/components/Sidebar.vue": [
		762,
		16
	],
	"./pages/today/components/SubHeader.vue": [
		761,
		131
	],
	"./pages/today/components/tab/employees.vue": [
		654,
		130
	],
	"./pages/today/components/tab/locations.vue": [
		655,
		43
	],
	"./pages/welcome/Page.vue": [
		874,
		129
	],
	"./templates/Backend.vue": [
		135
	],
	"./templates/Empty.vue": [
		134
	],
	"./templates/Frontend.vue": [
		138
	],
	"./templates/Invoice.vue": [
		141
	],
	"./templates/Wizard.vue": [
		140
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 458;
module.exports = webpackAsyncContext;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */,
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_Modal__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_Flash__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_Flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_Flash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_Widget__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_Widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_Widget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_Confirm__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_Confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_Confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_Loader__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_Notification__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_Notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_Notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_University__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_University___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__global_University__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_Lesson__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_Lesson___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__global_Lesson__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__global_Tooltip__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__global_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__global_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__templates_Empty__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__templates_Empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__templates_Empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__templates_Backend__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__templates_Backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__templates_Backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__templates_Frontend__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__templates_Frontend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__templates_Frontend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__templates_Wizard__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__templates_Wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__templates_Wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__templates_Invoice__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__templates_Invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__templates_Invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_channelChat__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Application',

    mixins: [__WEBPACK_IMPORTED_MODULE_17__helpers_channelChat__["c" /* methods */]],

    data: function data() {
        return {
            updated: false,
            redirectTo: null,
            listeners: false // Echo event listeners mounted?
        };
    },
    mounted: function mounted() {
        var _this = this;

        var lang = this.$store.state.meta.lang;

        // just to show how to access the store directly
        console.info('The current language locale is: ' + lang);

        var locales = void 0;
        if (lang === 'de') {
            // Use the extended German locale file with country translations
            locales = __webpack_require__(40).default;
        } else if (lang === 'nl') {
            // Use the extended Dutch locale file with country translations
            locales = __webpack_require__(41).default;
        } else {
            locales = __webpack_require__(81)("./locales." + lang).default;
        }

        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].locale(lang, locales);

        if (lang != 'en') __webpack_require__(142)("./" + lang);

        __WEBPACK_IMPORTED_MODULE_16__events_events__["a" /* default */].$listen('app.updated', function (route) {
            _this.updated = true;
            if (route) _this.redirectTo = route;
        });
    },
    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_16__events_events__["a" /* default */].$listen('auth.loggedout', function () {
            _this2.listeners = false;
        });

        __WEBPACK_IMPORTED_MODULE_16__events_events__["a" /* default */].$listen('app.authenticated', function () {
            if (_this2.authenticated && !_this2.listeners) {
                _this2.receiveUnreadChats();

                console.info('Websocket active.');

                Echo.channel('app').listen('AppUpdated', function (e) {
                    // only allow to update given environment (or all, if e.env is not set)
                    if (e.env && e.env != _this2.environment) return;

                    if (_this2.$store.state.app.loaded < e.updated) {
                        _this2.updated = true;
                    }
                });

                Echo.channel('account.' + _this2.$store.state.current.account.id).listen('Reinit', function (e) {
                    _this2.$store.dispatch('app/reinit', function () {
                        _this2.$store.dispatch('chat/setUnreadChats');
                    });
                }).listen('Broadcast.LocationUpdated', function (e) {
                    _this2.$store.dispatch('app/reinit', function () {
                        _this2.$store.dispatch('chat/setUnreadChats');
                    });
                });

                Echo.channel('membership.' + _this2.$store.state.current.membership.id).listen('Logout', function (e) {
                    _this2.$store.dispatch('auth/logout', function () {
                        //                            Echo.channel('notification.' + this.$store.state.current.membership.id).leave()
                        _this2.$router.push(_this2.$onduro.route('login.signin'));
                    });
                }).listen('CheckoutBySupervisor', function (e) {
                    _this2.$store.dispatch('current/updateCheckin', false);
                }).listen('CheckinRefresh', function (e) {
                    __WEBPACK_IMPORTED_MODULE_16__events_events__["a" /* default */].$emit('reload-checkins');
                });

                Echo.channel('notification.' + _this2.$store.state.current.membership.id).listen('ChatNotification', function (e) {
                    _this2.$store.dispatch('chat/setUnreadChats').then(function (unreadChats) {
                        if (_this2.activeChannel) _this2.refreshUnreadChats(unreadChats, _this2.activeChannel);else _this2.receiveUnreadChats();
                    });
                });

                _this2.listeners = true;
            }
        });
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_18_vuex__["b" /* mapState */])({
        authenticated: function authenticated(_ref) {
            var auth = _ref.auth;
            return auth.authenticated;
        },
        hasNavigation: function hasNavigation(_ref2) {
            var layout = _ref2.layout;
            return layout.hasNavigation;
        },
        hasFooterBar: function hasFooterBar(_ref3) {
            var layout = _ref3.layout;
            return layout.hasFooterBar;
        },
        viewport: function viewport(_ref4) {
            var layout = _ref4.layout;
            return layout.viewport;
        },
        current: function current(_ref5) {
            var _current = _ref5.current;
            return _current;
        },
        ready: function ready(_ref6) {
            var app = _ref6.app;
            return app.ready;
        },
        environment: function environment(_ref7) {
            var app = _ref7.app;
            return app.env;
        },
        touchDevice: function touchDevice(_ref8) {
            var app = _ref8.app;
            return app.touchDevice;
        },
        maintenance: function maintenance(_ref9) {
            var app = _ref9.app;
            return app.maintenance;
        },
        activeChannel: function activeChannel(_ref10) {
            var chat = _ref10.chat;
            return chat.activeChannel;
        },
        unreadChats: function unreadChats(_ref11) {
            var chat = _ref11.chat;
            return chat.unreadChats;
        }
    }), {
        backend: function backend() {
            return this.$route.meta.section == 'backend' && this.authenticated;
        },
        frontend: function frontend() {
            return this.$route.meta.section == 'frontend' || false;
        },
        empty: function empty() {
            return this.$route.meta.section == 'empty' || false;
        },
        wizard: function wizard() {
            return this.$route.meta.section == 'wizard';
        },
        invoice: function invoice() {
            return this.$route.meta.section == 'invoice' || false;
        },
        login: function login() {
            return !this.authenticated && !this.empty && !this.wizard;
        }
    }),

    methods: {
        updateApp: function updateApp() {
            if (this.redirectTo) {
                window.location.href = this.$onduro.route(this.redirectTo);
            } else {
                window.location.reload(true);
            }
        },
        receiveUnreadChats: function receiveUnreadChats() {
            var _this3 = this;

            var ids = _.map(_.filter(this.unreadChats, function (chat) {
                return chat.receivedAt === null;
            }), function (item) {
                return item.statusId;
            });

            if (!ids.length) return;

            this.$http.silent().put('/api/memberships/unread-chats', {
                ids: ids,
                status: 'received'
            }).then(function (response) {
                _this3.$store.commit('chat/SET_UNREAD_CHATS', response.data, { root: true });
            });
        }
    },

    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_2__global_Modal___default.a,
        Flash: __WEBPACK_IMPORTED_MODULE_3__global_Flash___default.a,
        Widget: __WEBPACK_IMPORTED_MODULE_4__global_Widget___default.a,
        Loader: __WEBPACK_IMPORTED_MODULE_6__global_Loader___default.a,
        Invoice: __WEBPACK_IMPORTED_MODULE_15__templates_Invoice___default.a,
        Notification: __WEBPACK_IMPORTED_MODULE_7__global_Notification___default.a,
        Confirm: __WEBPACK_IMPORTED_MODULE_5__global_Confirm___default.a,
        Empty: __WEBPACK_IMPORTED_MODULE_11__templates_Empty___default.a,
        Backend: __WEBPACK_IMPORTED_MODULE_12__templates_Backend___default.a,
        Frontend: __WEBPACK_IMPORTED_MODULE_13__templates_Frontend___default.a,
        Wizard: __WEBPACK_IMPORTED_MODULE_14__templates_Wizard___default.a,
        University: __WEBPACK_IMPORTED_MODULE_8__global_University___default.a,
        Lesson: __WEBPACK_IMPORTED_MODULE_9__global_Lesson___default.a,
        Tooltip: __WEBPACK_IMPORTED_MODULE_10__global_Tooltip___default.a
    }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Modal',

    data: function data() {
        return {
            show: false,
            headline: '',
            content: '',
            callback: null,
            blank: false,
            wide: false,
            printable: false
        };
    },
    created: function created() {
        var _this = this;

        /**
         * Open modal dialog.
         * Adds event listener to window object for key esc
         *
         * @param {String} headline
         * @param {String} content
         * @param {Function} callback
         */
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$on('modal.open', function (headline, content, callback, blank, wide) {
            _this.headline = headline || '';
            _this.content = content;
            _this.callback = callback;
            _this.blank = blank ? true : false;
            _this.wide = wide ? true : false;

            _this.show = true;

            window.addEventListener('keyup', _this.closeEsc, false);
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$on('modal.close', function () {
            _this.close();
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$on('modal.printable', function (setting) {
            _this.printable = setting;
        });
    },


    methods: {
        /**
         * Close dialog and remove event listener from window
         */
        close: function close() {
            window.removeEventListener('keyup', this.closeEsc, false);

            this.show = false;

            if (this.$widget.inactive) this.$widget.activate();

            if (typeof this.callback == 'function') this.callback();

            this.headline = '';
            this.content = '';
            this.callback = null;
        },


        /**
         * Triggers close method
         *
         * @param {Object} e
         */
        closeEsc: function closeEsc(e) {
            if (e.keyCode === 27) {
                this.close();
            }
        },
        print: function print() {
            var win = window.open();
            win.document.write(this.content);
            win.print();
        }
    }
});

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-top"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-content",
    class: _vm.wide ? 'modal-content--wide' : null
  }, [(_vm.headline !== '') ? _c('div', {
    staticClass: "head"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    class: _vm.blank ? 'body body--blank' : 'body',
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.printable) ? _c('action', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('label.print')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('action', {
    attrs: {
      "color": "green",
      "focus": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n                    OKAY\n                ")])], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Flash',

    data: function data() {
        return {
            show: false,
            headline: '',
            content: '',
            callback: null
        };
    },
    created: function created() {
        var _this = this;

        /**
         * Open flash dialog.
         * Adds event listener to window object for key esc
         *
         * @param {String} headline
         * @param {String} content
         * @param {Function} callback
         */
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$on('flash.open', function (headline, content, callback) {
            _this.headline = headline || '';
            _this.content = content;
            _this.callback = callback;

            _this.show = true;

            window.addEventListener('keyup', _this.closeEsc, false);
        });
    },


    methods: {
        /**
         * Close dialog and remove event listener from window
         */
        close: function close() {
            window.removeEventListener('keyup', this.closeEsc, false);
            this.show = false;
            if (typeof this.callback == 'function') this.callback();

            this.headline = '';
            this.content = '';
            this.callback = null;
        },


        /**
         * Triggers close method
         *
         * @param {Object} e
         */
        closeEsc: function closeEsc(e) {
            if (e.keyCode === 27) {
                this.close();
            }
        }
    }
});

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flash"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "flash-background",
    on: {
      "click": _vm.close
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-top"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "flash-content"
  }, [(_vm.headline !== '') ? _c('div', {
    staticClass: "head"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(123);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Widget',

    data: function data() {
        return {
            show: false,
            content: '',
            args: null,
            properties: null,
            hide: false,
            dismissable: false
        };
    },
    created: function created() {
        var _this = this;

        /**
         * Open widget dialog.
         *
         * @param {String} content
         * @param {Object} args
         */
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$on('widget.open', function (content, args, dismissable) {
            _this.args = args;
            _this.content = content;
            _this.dismissable = dismissable;

            _this.show = true;
        });

        /**
         * Close widget
         */
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$on('widget.close', this.close);

        /**
         * Reactivate widget
         */
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$on('widget.activate', this.activate);

        /**
         * Deactivate widget
         */
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$on('widget.deactivate', this.deactivate);
    },


    methods: {
        /**
         * Close dialog and remove event listener from window
         */
        close: function close(state) {
            this.show = false;
            this.headline = '';
            this.content = '';
            this.args = null;
        },


        /**
         * Hide widget. Widget does not get removed from dom
         */
        deactivate: function deactivate() {
            this.hide = true;
        },


        /**
         * Show widget.
         */
        activate: function activate() {
            this.hide = false;
        },


        /**
         * Dismiss (hide by clicking on modal background)
         */
        dismiss: function dismiss() {
            if (this.dismissable) this.close();
        }
    },

    components: {
        /*
         * Application Widgets
         */
        addContract: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/addContract'),
        addHours: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/addHours'),
        assignLocations: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/assignLocations'),
        changeEmail: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/changeEmail'),
        changePassword: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/changePassword'),
        chatParticipants: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/chatParticipants'),
        checkin: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/checkin'),
        checkins: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/checkins'),
        clientProject: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/clientProject'),
        clients: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/clients'),
        contracts: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/contracts'),
        contractTemplate: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/contractTemplate'),
        costs: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/costs'),
        datePickerModal: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/global/DatePickerModal'),
        defaultAvailability: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/defaultAvailability'),
        denyHours: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/denyHours'),
        duties: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/duties'),
        employeeNumber: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/employeeNumber'),
        employees: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/employees'),
        employeesEdit: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/employeesEdit'),
        expenses: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/expenses'),
        holidays: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/holidays'),
        launchDashboard: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/launchDashboard'),
        location: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/location'),
        locations: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/locations'),
        newChat: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/newChat'),
        planningMemberships: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/planningMemberships'),
        plannings: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/plannings'),
        premiums: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/premiums'),
        premiumsOverview: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/premiumsOverview'),
        profileLocations: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/profileLocations'),
        rates: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/rates'),
        report: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/report'),
        revenues: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/revenues'),
        salary: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/salary'),
        shifts: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/shifts'),
        switcher: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/switcher'),
        tags: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/tags'),
        timechooser: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/timechooser'),
        userProfile: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/userProfile'),
        resources: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/resources'),
        signature: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/signature'),
        planningResources: Object(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* loadComponent */])('./components/widgets/planningResources')
    }
});

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget modal",
    class: {
      'hide': _vm.hide
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dismiss.apply(null, arguments)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-top"
    },
    on: {
      "after-leave": _vm.activate
    }
  }, [(_vm.show) ? _c(_vm.content, {
    tag: "component",
    attrs: {
      "args": _vm.args
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Confirm',

    data: function data() {
        return {
            show: false,
            html: false,
            legal: false,
            hash: null,
            confirmed: false,
            accepted: false,
            headline: '',
            content: '',
            callbackConfirm: null,
            callbackDecline: null,
            labelConfirm: '',
            labelDecline: ''
        };
    },
    created: function created() {
        var _this = this;

        /**
         * Open confirm dialog.
         * Adds event listener to window object for key esc
         *
         * @param {String} headline
         * @param {String} content | {Object} legal
         * @param {Object} callback { confirm: Function, decline: Function }
         * @param {Object} label { confirm: String, decline: String }
         * @param {Object} html (bool)
         */
        __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$on('confirm.open', function (headline, content, callback, label, html) {
            _this.headline = headline;
            _this.content = content;
            _this.callbackConfirm = callback && callback.confirm !== 'undefined' ? callback.confirm : null;
            _this.callbackDecline = callback && callback.decline !== 'undefined' ? callback.decline : null;
            _this.labelConfirm = label && label.confirm !== 'undefined' ? label.confirm : _this.$t('text.yes');
            _this.labelDecline = label && label.decline !== 'undefined' ? label.decline : _this.$t('text.no');

            _this.show = true;
            _this.confirmed = false;
            _this.html = html ? true : false;

            // content = {iframe: 'https...', print: 'https...', accepted: true}
            _this.legal = (typeof content === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(content)) === 'object' ? true : false;
            _this.hash = Date.now(); // cache buster for iframe ?hash

            window.addEventListener('keyup', _this.closeEsc, false);
            window.addEventListener('keyup', _this.confirmEnter, false);
        });
    },


    methods: {
        /**
         * Close dialog and remove event listener from window
         */
        close: function close() {
            window.removeEventListener('keyup', this.closeEsc, false);
            window.removeEventListener('keyup', this.confirmEnter, false);
            this.show = false;

            this.headline = '';
            this.content = '';
            this.labelConfirm = '';
            this.labelDecline = '';
            this.callbackConfirm = null;
            this.callbackDecline = null;
        },


        /**
         * Triggers decline method on escape
         *
         * @param {Object} e
         */
        closeEsc: function closeEsc(e) {
            if (e.keyCode === 27) {
                this.decline();
            }
        },


        /**
         * Triggers confirm method on enter
         *
         * @param {Object} e
         */
        confirmEnter: function confirmEnter(e) {
            if (e.keyCode === 13) {
                this.confirm();
            }
        },


        /**
         * Trigger confirm callback
         */
        confirm: function confirm() {
            if (this.legal && !this.confirmed) {
                alert('Please check the box in order to accept.');
                return;
            }

            if (typeof this.callbackConfirm === 'function') this.callbackConfirm();

            this.close();
        },


        /**
         * Trigger decline callback
         */
        decline: function decline() {
            if (typeof this.callbackDecline === 'function') this.callbackDecline();

            this.close();
        },


        /**
         * Trigger print callback
         */
        print: function print() {
            window.open(this.content.print);
        }
    }
});

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['confirm', 'modal', _vm.legal ? 'legal' : '']
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.decline
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce-in"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-content"
  }, [(_vm.legal) ? _c('div', {
    staticClass: "too-small"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('confirm.legal.too_small')) + "\n                "), _c('action', {
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.okay')))])], 1) : _vm._e(), _vm._v(" "), (_vm.headline !== '') ? _c('div', {
    staticClass: "head"
  }, [_c('h2', [_vm._v("\n                    " + _vm._s(_vm.headline) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.legal) ? _c('div', {
    staticClass: "legal-body"
  }, [_c('div', {
    staticClass: "legal-content"
  }, [_c('div', {
    staticClass: "scroll-notice"
  }, [_vm._v(_vm._s(_vm.$t('confirm.legal.scroll_notice')))]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": _vm.content.iframe + '?' + _vm.hash,
      "width": "100%",
      "height": "100%",
      "scrolling": "yes"
    }
  })]), _vm._v(" "), (!_vm.content.accepted) ? _c('div', {
    staticClass: "legal-statement"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmed),
      expression: "confirmed"
    }],
    attrs: {
      "type": "checkbox",
      "value": "yes",
      "name": "confirmation",
      "id": "confirmation"
    },
    domProps: {
      "checked": Array.isArray(_vm.confirmed) ? _vm._i(_vm.confirmed, "yes") > -1 : (_vm.confirmed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.confirmed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "yes",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.confirmed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.confirmed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.confirmed = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirmation"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('confirm.legal.statement.0', {
        name: _vm.$store.state.current.user.name
      }))
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('confirm.legal.statement.1')))]), _vm._v(" "), _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('confirm.legal.statement.2', {
        company: _vm.$store.state.current.account.name
      }))
    }
  }), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('confirm.legal.statement.3')))])])])]) : _vm._e()]) : [(_vm.html && _vm.content) ? _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.html && _vm.content) ? _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    " + _vm._s(_vm.content) + "\n                ")]) : _vm._e()], _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.legal && _vm.content.print) ? _c('action', {
    staticClass: "left",
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.print.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('label.print')) + "\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.legal || (_vm.legal && !_vm.content.accepted)) ? _c('action', {
    attrs: {
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.labelConfirm) + "\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.legal || (_vm.legal && !_vm.content.accepted)) ? _c('action', {
    attrs: {
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.decline.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.labelDecline) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.legal && _vm.content.accepted) ? _c('action', {
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.button.close')) + "\n                ")]) : _vm._e()], 1)], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Loader',

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
        loaderCount: function loaderCount(state) {
            return state.loader.count;
        }
    })),

    data: function data() {
        return {
            loading: false
        };
    },


    watch: {
        loaderCount: {
            handler: function handler(val) {
                if (val > 0 && this.loading === false) {
                    this.loading = true;
                }

                if (val <= 0 && this.loading === true) {
                    this.loading = false;
                }
            }
        }
    }
});

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "delay"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none",
      "stroke-width": "2",
      "stroke-miterlimit": "10"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Notification',

    data: function data() {
        return {
            queue: [],
            minWait: 3500,
            open: 0
        };
    },
    created: function created() {
        var _this = this;

        /**
         * @param {String} headline
         * @param {String} description
         * @param {String} icon
         * @param {String} type
         */
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$on('notification.open', function (headline, description, icon, type) {
            _this.queue.push({
                headline: headline && typeof headline == 'string' ? headline : '',
                description: description && typeof description == 'string' ? description : '',
                icon: icon || '',
                type: type || 'default',
                show: false
            });

            var index = _this.queue.length - 1;

            // give user 50 miliseconds per letter to read
            _this.queue[index].duration = Math.max((_this.queue[index].headline.length + _this.queue[index].description.length) * 50, _this.minWait);

            _this.queue[index].show = true;
            _this.open++;

            setTimeout(function () {
                _this.queue[index].show = false;
                _this.open--;
            }, _this.queue[index].duration);
        });
    },


    watch: {
        open: function open(val) {
            // this will reset the queue
            if (val == 0) this.queue = [];
        }
    }
});

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notify"
  }, [_vm._l((_vm.queue), function(note, index) {
    return [_c('transition', {
      attrs: {
        "name": "notify"
      }
    }, [(note.show) ? _c('div', {
      staticClass: "notification",
      class: 'notification--' + note.type
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (note.icon.length),
        expression: "note.icon.length"
      }]
    }, [_c('icon', {
      attrs: {
        "name": note.icon
      }
    })], 1), _vm._v(" "), (note.headline.length) ? _c('span', [_vm._v(_vm._s(note.headline))]) : _vm._e(), _vm._v(" "), (note.description.length) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(note.description)
      }
    }) : _vm._e()]) : _vm._e()])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'University',

    data: function data() {
        return {
            show: false,
            loaded: false,
            search: '',
            all: false,
            lessons: [],
            minified: false
        };
    },


    computed: {
        demo: function demo() {
            return this.$store.state.current.account.demo;
        },
        onboarding: function onboarding() {
            return this.$store.state.current.membership.onboarding;
        },
        headline: function headline() {
            if (this.onboarding) return this.$t('university.lets_begin');

            return this.$t('university.headline');
        },
        filtered: function filtered() {
            var _this = this;

            // reject, if...
            var lessons = _.reject(this.lessons, function (lesson) {
                if (!_this.search && _this.all) return false;

                // is this a lesson for the demo?
                var demo = inArray('demo', lesson.flags);

                // ... demo is active, but lesson is not for demo (or vice versa)
                if (_this.demo && !demo) return true;
                if (!_this.demo && demo) return true;

                // ...search term does not match
                if (_this.search && !lesson.name.match(new RegExp(_this.search, 'i'))) {
                    return true;
                }

                // PAGE
                // ...lesson has page constraints and does not match page context (search is global, though!)
                if (!_this.search && lesson.pages.length && !inArray(_this.$route.name, lesson.pages)) {
                    return true;
                }

                // ROLE
                // ...lesson has role constraints and does not match role context
                if (lesson.roles.length && !_this.$onduro.hasRole(lesson.roles)) {
                    return true;
                }

                // MODULE
                // ...lesson has module constraints and does not match module context
                if (lesson.modules.length && !_this.$onduro.hasModule(lesson.modules)) {
                    return true;
                }

                // CONFIG
                // ...lesson has config constraints and does not match config context
                if (lesson.configs.length) {
                    var count = 0;
                    _.forEach(lesson.configs, function (config) {
                        if (_this.$onduro.getConfig(config)) count++;
                    });

                    if (lesson.configs.length != count) return true;
                }

                return false;
            });

            // order by priority
            lessons = _.orderBy(lessons, 'priority', 'desc');

            return lessons;
        }
    },

    created: function created() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('university.open', function () {
            _this2.open();
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('university.close', function () {
            _this2.close();
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('university.toggle', function () {
            _this2.show ? _this2.close() : _this2.open();
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('university.minify', function () {
            _this2.minified = true;
        });
    },
    destroyed: function destroyed() {
        // events do not have to be turned off anymore,
        // since we are using the "$listen" method on 
        // the events bus

        // events.$off('university.open');
        // events.$off('university.close');
        // events.$off('university.toggle');

        window.removeEventListener('keyup', this.closeEsc, false);
    },


    watch: {
        '$route.name': function $routeName(val) {
            this.all = false;
        }
    },

    methods: {
        open: function open() {
            var _this3 = this;

            this.all = false;
            this.show = true;
            this.loaded = false;

            this.$http.get('/api/lessons').then(function (response) {
                _this3.lessons = response.data;
                _this3.$university.lessons = response.data;

                _this3.$nextTick(function () {
                    __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('university.loaded', _this3.filtered[0]);
                });

                _this3.loaded = true;
            });

            window.addEventListener('keyup', this.closeEsc, false);
        },
        expand: function expand() {
            this.minified = false;

            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('university.expand');
        },
        close: function close() {
            this.search = '';
            this.show = false;

            window.removeEventListener('keyup', this.closeEsc, false);
        },
        showAll: function showAll() {
            this.search = '';
            this.all = true;
        },
        learn: function learn(lesson) {
            this.$university.lesson(lesson);
        },
        closeEsc: function closeEsc(e) {
            if (e.keyCode === 27) {
                if (this.search) {
                    this.search = '';
                    return;
                }

                this.close();
            }
        }
    }
});

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: ['university', _vm.minified ? 'is-minified' : '']
  }, [(_vm.minified) ? _c('div', {
    on: {
      "click": _vm.expand
    }
  }, [_vm._v(_vm._s(_vm.$t('university.minified')))]) : _c('div', [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }), _vm._v(" "), (!_vm.onboarding) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('text.search')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('action', {
    attrs: {
      "icon": "cancel",
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }), _vm._v(" "), (_vm.loaded) ? _c('div', {
    staticClass: "lessons"
  }, [_vm._l((_vm.filtered), function(lesson) {
    return _c('div', {
      class: ['lesson', lesson.viewed ? 'is-viewed' : ''],
      on: {
        "click": function($event) {
          return _vm.learn(lesson)
        }
      }
    }, [(lesson.viewed) ? _c('icon', {
      staticClass: "status",
      attrs: {
        "name": "check"
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(lesson.name))])], 1)
  }), _vm._v(" "), (!_vm.filtered.length) ? _c('div', [_vm._v("\n                    " + _vm._s(_vm.$t('university.no_lessons')) + "\n                    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showAll()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('university.show_all')))])]) : _vm._e()], 2) : _c('div', {
    staticClass: "lessons"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.$t('text.loading')) + "\n                ")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



window.removeEventListener('keyup', this.keyListener, false);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Lesson',

    data: function data() {
        return {
            show: false,
            id: null,
            headline: '',
            content: '',
            links: [],
            callback: null,
            viewed: false,
            action: false,
            lessons: []
        };
    },
    created: function created() {
        var _this = this;

        /**
         * Open lesson.
         * Adds event listener to window object for key esc
         *
         * @param {String} headline
         * @param {String} content
         * @param {Function} callback
         */
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('lesson.open', function (lesson, callback) {
            _this.id = lesson.id;
            _this.headline = lesson.name || '';
            _this.content = lesson.content;
            _this.links = lesson.links || [];
            _this.viewed = lesson.viewed;
            _this.action = lesson.action;
            _this.callback = callback;

            _this.lessons = _this.$university.lessons;

            _this.show = true;

            _this.$http.put('/api/lessons/' + lesson.id + '/view', {
                membership: _this.$store.state.current.membership.id
            });

            if (lesson.page) {
                _this.$router.push(_this.$onduro.route(lesson.page));
            }

            if (lesson.id == 'XmWkjRkeGL') {
                // disable onboarding
                _this.$http.put('/api/memberships/' + _this.$store.state.current.membership.id + '/onboarding').then(function (response) {
                    _this.$store.dispatch('current/updateMembership', {
                        onboarding: 0
                    });
                });
            }

            window.addEventListener('keyup', _this.keyListener, false);
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('university.expand', function () {
            _this.show = true;
        });
    },


    computed: {
        previous: function previous() {
            var key = _.findKey(this.lessons, { id: this.id });

            if (key > 0) return this.lessons[key - 1];

            return false;
        },
        next: function next() {
            var key = _.findKey(this.lessons, { id: this.id });
            var next = parseInt(key) + 1;

            if (next < this.lessons.length) return this.lessons[next];

            return false;
        }
    },

    methods: {
        confirm: function confirm() {
            this.close();
        },
        learn: function learn(link) {
            var lesson = _.find(this.$university.lessons, { id: link.id });

            if (!lesson) {
                this.$modal.show('Cannot find lesson');
            } else {
                this.$university.lesson(lesson);
            }
        },
        previousStep: function previousStep() {
            this.markViewed();
            this.$university.lesson(this.previous);
        },
        nextStep: function nextStep() {
            this.markViewed();
            this.$university.lesson(this.next);
        },
        back: function back() {
            this.markViewed();

            // remove current item
            this.$university.history.splice(-1, 1);

            var id = this.$university.history[this.$university.history.length - 1];
            var lesson = _.find(this.$university.lessons, { id: id });

            // remove previous item (since it will be added back right away)
            this.$university.history.splice(-1, 1);

            this.$university.lesson(lesson);
        },
        performAction: function performAction() {
            this.show = false;

            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('university.minify');
        },


        /**
         * Close dialog and remove event listener from window
         */
        close: function close() {
            this.markViewed();

            this.$university.history = [];

            window.removeEventListener('keyup', this.keyListener, false);

            this.show = false;

            if (typeof this.callback == 'function') this.callback();

            this.headline = '';
            this.content = '';
            this.links = [];
            this.callback = null;
        },
        keyListener: function keyListener(e) {
            switch (e.keyCode) {
                case 27:
                    this.close();
                    break;

                case 37:
                    if (this.previous) this.previousStep();
                    break;

                case 39:
                    if (this.next) this.nextStep();
                    break;
            }
        },
        markViewed: function markViewed() {
            var key = _.findKey(this.lessons, { id: this.id });

            if (key) {
                this.$set(this.lessons[key], 'viewed', true);
            }
        }
    }
});

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal modal--lesson"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-content"
  }, [(_vm.headline !== '') ? _c('div', {
    staticClass: "head"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _vm._v(" "), (_vm.viewed) ? _c('icon', {
    staticClass: "status",
    attrs: {
      "name": "check"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), (_vm.links.length) ? _c('div', {
    staticClass: "links"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('university.lesson.related')))]), _vm._v(" "), _c('ul', _vm._l((_vm.links), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.learn(link)
        }
      }
    }, [_vm._v(_vm._s(link.name))])])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.action) ? _c('action', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "color": "orange"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.performAction.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('university.lesson.try')))]) : _vm._e(), _vm._v(" "), _c('action', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.done')))]), _vm._v(" "), (_vm.previous && _vm.next) ? _c('action', {
    attrs: {
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.previousStep.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.back')))]) : _vm._e(), _vm._v(" "), (_vm.next) ? _c('action', {
    attrs: {
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextStep.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('label.moment.next')))]) : _vm._e()], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//



var settings = function settings() {
    return {
        content: '',
        show: false,
        top: 0,
        left: 0,
        style: ''
    };
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Tooltip',

    data: settings,

    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$listen('tooltip.show', function (payload) {
            _this.content = payload.content;
            _this.show = true;

            _this.$nextTick(function () {
                _this.getBestPosition(payload.trigger, _this.$refs.tooltip);
            });
        });

        __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$listen('tooltip.hide', function () {
            _this.reset();
        });
    },


    methods: {
        coordinates: function coordinates(el) {
            var rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            return { top: rect.top + scrollTop, left: rect.left + scrollLeft, width: rect.width, height: rect.height, rect: rect };
        },
        reset: function reset() {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, settings());
        },
        getBestPosition: function getBestPosition(tr, to) {
            var trigger = this.coordinates(tr),
                tooltip = this.coordinates(to),
                topTop = trigger.top - tooltip.height - 10,
                topMiddle = trigger.top + trigger.height / 2 - tooltip.height / 2,
                topBottom = trigger.rect.bottom + 10,
                leftLeft = trigger.left - tooltip.width - 10,
                leftMiddle = trigger.left + trigger.width / 2 - tooltip.width / 2,
                leftRight = trigger.rect.right + 10,
                top = topTop,
                left = leftMiddle,
                vCenter = false,
                hCenter = false,
                style = 'is-top';

            // Is top or bottom bouncing?
            if (topTop < 0) {
                if (topBottom + tooltip.height + 10 >= window.innerHeight) {
                    top = topMiddle;
                    vCenter = true;
                } else {
                    top = topBottom;
                    style = 'is-bottom';
                }
            } else {
                // Use top
                top = topTop;
                style = 'is-top';
            }

            // Is left or right bouncing?
            if (leftMiddle < 0 || leftMiddle + tooltip.width + 10 >= window.innerWidth) {
                if (leftLeft >= 0) {
                    left = leftLeft;
                    style = 'is-left';
                } else if (leftMiddle + tooltip.width + 10 <= window.innerWidth) {
                    left = leftRight;
                    style = 'is-right';
                }

                if (topMiddle + tooltip.height + 10 >= window.innerHeight) {
                    top = topMiddle - tooltip.height / 2 - 20;
                    style = '';
                } else if (topMiddle < 0) {
                    top = topMiddle + tooltip.height / 2 + 20;
                    style = '';
                } else {
                    top = topMiddle;
                }

                vCenter = true;
            } else {
                if (vCenter) {
                    left = leftLeft;
                }
            }

            // All bad? Use top left
            if (vCenter && hCenter) {
                left = 0;
                top = 0;
                style = '';
            }

            this.top = top;
            this.left = left;
            this.style = style;
        }
    }
});

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.content && _vm.show) ? _c('div', {
    ref: "tooltip",
    staticClass: "tooltip",
    class: _vm.style,
    style: ({
      top: _vm.top + 'px',
      left: _vm.left + 'px'
    })
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tooltip-tip"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Empty'
});

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_MainHeader__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_MainHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_global_MainHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_Navigation__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modules_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_events__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Backend',

    data: function data() {
        return {
            selected: null
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        hasUniversity: function hasUniversity() {
            return this.current.locale == 'nl';
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        viewport: function viewport(_ref) {
            var layout = _ref.layout;
            return layout.viewport;
        },
        current: function current(_ref2) {
            var _current = _ref2.current;
            return _current;
        },
        account: function account(_ref3) {
            var current = _ref3.current;
            return current.account.id;
        }
    })),

    created: function created() {
        this.selected = this.current.account.id;
        this.$store.dispatch('layout/setMainContentHeight');
    },


    updated: _.debounce(function () // Prevent update called twice
    {
        this.$store.dispatch('layout/setMainContentHeight');
    }, 150),

    watch: {
        account: function account(val) {
            this.selected = val;
        }
    },

    methods: {
        updateAccount: function updateAccount() {
            this.$http.put('/api/switch/account/' + this.selected, {
                mobile: location.hostname.match('mobile') ? true : false
            }).then(function (response) {
                window.location.reload(true);
            });
        },
        toggleUniversity: function toggleUniversity() {
            this.$university.toggle();
        },
        showUniversity: function showUniversity() {
            this.$modal.close();
            this.$university.toggle();
        },
        hasMultipleAccounts: function hasMultipleAccounts() {
            return this.current.accounts.length > 1;
        },
        mouseDown: function mouseDown($event) {
            this.$store.dispatch('app/mouseDown', true);
            __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('mouse.down');
        },
        mouseUp: function mouseUp($event) {
            this.$store.dispatch('app/mouseDown', false);
            __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('mouse.up');
        },
        mouseMove: function mouseMove($event) {
            if (this.$store.state.app.mouseDown) {
                __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('mouse.drag', $event);
            }
        },
        showHelp: function showHelp() {
            var _this = this;

            var html = this.$t('widget.help.line1');

            if (this.hasUniversity) {
                html += this.$t('widget.help.line2');
            }

            html += this.$t('widget.help.line3');

            if (this.$current.profile == 'Ryanair') {
                html = '<b>Do you have any questions in regards to your contract or you would like to change your data?</b> Please raise a <u>Zendesk inquiry</u> to the Human Resources Department at Malta Air.';
            }

            if (this.$current.profile == 'Fiveguys') {
                html = '<b>Do you have any questions in regards to your contract or you would like to raise directly with Five Guys</b>? Please contact your manager or the human resources department at Five Guys.<br><br>Do you have questions <u>in regards to your profile data or salary payments</u>, please <a href="mailto:fiveguys@onduro.com">click here</a> to get in touch with the salary department.<br><br>For any <u>technical questions</u> please reach out to us by <a href="mailto:support@onduro.com">clicking here</a>.';
            }

            if (this.$current.profile == 'Pier14') {
                html = '<b>Do you have any questions in regards to your contract or you would like to raise directly with Pier 14</b>? Please contact your manager or the human resources department at Pier 14.<br><br>Do you have questions <u>in regards to your profile data or salary payments</u>, please <a href="mailto:pier14@onduro.com">click here</a> to get in touch with the salary department.<br><br>For any <u>technical questions</u> please reach out to us by support@onduro.com.';
            }

            if (this.$current.profile == 'Gieck') {
                html = '<b>Do you have any questions in regards to your contract or you would like to raise directly with Gieck</b>? Please contact your manager or the human resources department at Gieck.<br><br>Do you have questions <u>in regards to your profile data or salary payments</u>, please <a href="mailto:support@onduro.com">click here</a> to get in touch with the salary department.<br><br>For any <u>technical questions</u> please reach out to us by <a href="mailto:support@onduro.com">clicking here</a>.';
            }

            this.$modal.show(this.$t('text.help'), html);

            this.$nextTick(function () {
                var link = document.querySelector('.toggle-university');
                if (link) link.addEventListener('click', _this.showUniversity);
            });
        }
    },

    components: {
        MainHeader: __WEBPACK_IMPORTED_MODULE_2__components_global_MainHeader___default.a,
        Navigation: __WEBPACK_IMPORTED_MODULE_3__components_modules_Navigation___default.a
    }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MainHeader',

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        viewport: function viewport(_ref) {
            var layout = _ref.layout;
            return layout.viewport;
        }
    }))
});

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [(_vm.viewport == 'ml' || _vm.viewport == 'mp') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$store.dispatch('layout/toggleNavigation')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "menu",
      "viewBox": "0 0 24 24"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Navigation',

    data: function data() {
        return {
            touching: false
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        version: function version() {
            return "95e9b7";
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        authenticated: function authenticated(_ref) {
            var auth = _ref.auth;
            return auth.authenticated;
        },
        viewport: function viewport(_ref2) {
            var layout = _ref2.layout;
            return layout.viewport;
        },
        hasNavigation: function hasNavigation(_ref3) {
            var layout = _ref3.layout;
            return layout.hasNavigation;
        },
        appReady: function appReady(_ref4) {
            var app = _ref4.app;
            return app.ready;
        },
        availability: function availability(_ref5) {
            var current = _ref5.current;
            return current.membership.availability;
        },
        balance: function balance(_ref6) {
            var current = _ref6.current;
            return current.membership.balance;
        },
        current: function current(_ref7) {
            var _current = _ref7.current;
            return _current;
        }
    }), {
        showAvailability: function showAvailability() {
            return this.$onduro.hasModule('availability') && (this.$onduro.hasRole('planner') || this.availability);
        }
    }),

    methods: {
        showTooltip: function showTooltip(key) {
            if (!this.hasNavigation) return this.$t(key);

            return null;
        },
        showNavigation: function showNavigation() {
            // method must be triggered by mouse event only
            if (this.touching) return;

            this.$store.dispatch('layout/showNavigation');
        },
        hideNavigation: function hideNavigation() {
            // method must be triggered by mouse event only
            if (this.touching) return;

            this.$store.dispatch('layout/hideNavigation');
        },
        toggleNavigation: function toggleNavigation() {
            this.$store.dispatch('layout/toggleNavigation');
            this.touching = false;
        },
        switchLanguage: function switchLanguage(lang) {
            // store lang on user profile
            this.$http.put('/api/switch/locale/' + lang);

            // // update moment.js locale
            // if (lang != 'en')
            // {
            //     require('moment/locale/' + lang);
            //     moment().locale(lang);
            //     console.info('mom', lang);
            // }
        },
        refresh: function refresh() {
            // force hard reload
            window.location.reload(true);
        }
    }
});

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav-main",
    class: {
      owner: _vm.$onduro.hasRole('owner')
    }
  }, [_c('a', {
    staticClass: "toggle-menu",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleNavigation()
      },
      "touchstart": function($event) {
        _vm.touching = true
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "menu",
      "viewBox": "0 0 24 24"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    staticClass: "link-home",
    attrs: {
      "to": _vm.$onduro.route('overview')
    }
  }, [_c('icon', {
    attrs: {
      "name": "logo",
      "viewBox": "0 0 842 170"
    }
  })], 1), _vm._v(" "), (_vm.appReady) ? _c('ul', [_c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('overview')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.overview.name')),
      expression: "showTooltip('route.overview.name')"
    }],
    attrs: {
      "name": "inbox"
    }
  }), _vm._v(_vm._s(_vm.$t('route.overview.name')) + "\n            ")], 1)], 1), _vm._v(" "), _c('li', [(_vm.$onduro.hasModule('company') && (_vm.$onduro.getConfig('company.visible') || _vm.$onduro.hasRole('manager'))) ? _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('company')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.company.name')),
      expression: "showTooltip('route.company.name')"
    }],
    attrs: {
      "name": "company"
    }
  }), _vm._v(_vm._s(_vm.$t('route.company.name')) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$onduro.hasModule('checkins') && _vm.$onduro.hasRole('supervisor')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('checkins')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.checkins.name')),
      expression: "showTooltip('route.checkins.name')"
    }],
    attrs: {
      "name": "checkin"
    }
  }), _vm._v(_vm._s(_vm.$t('route.checkins.name'))), _c('i', {
    staticClass: "beta"
  }, [_vm._v("BETA")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.isReal() && _vm.$onduro.hasModule('today') && _vm.$onduro.hasRole(['planner', 'observer'])) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('today')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.today.name')),
      expression: "showTooltip('route.today.name')"
    }],
    attrs: {
      "name": "spot"
    }
  }), _vm._v(_vm._s(_vm.$t('route.today.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('li', [(_vm.$onduro.isReal() && _vm.$onduro.hasModule('clients') && _vm.$onduro.hasRole('planner', 'manager', 'owner')) ? _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('clients')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.clients.name')),
      expression: "showTooltip('route.clients.name')"
    }],
    attrs: {
      "name": "apartment"
    }
  }), _vm._v(_vm._s(_vm.$t('route.clients.name')) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _c('li', [(_vm.$onduro.isReal() && _vm.$onduro.hasModule('projects') && _vm.$onduro.hasRole('planner', 'manager', 'owner')) ? _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('projects')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('page.projects.title')),
      expression: "showTooltip('page.projects.title')"
    }],
    attrs: {
      "name": "project"
    }
  }), _vm._v(_vm._s(_vm.$t('page.projects.title')) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$onduro.isReal() && _vm.$onduro.hasModule('planning') && _vm.$onduro.hasRole('planner', 'observer') && _vm.$store.state.current.membership.locations.length) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('planning')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.planning.name')),
      expression: "showTooltip('route.planning.name')"
    }],
    attrs: {
      "name": _vm.$onduro.hasRole('planner') ? 'calendar' : 'eye'
    }
  }), _vm._v(_vm._s(_vm.$t('route.planning.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.isReal() && _vm.$onduro.hasModule('planning') && _vm.$store.state.current.membership.locations.length) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('roster')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.roster.name')),
      expression: "showTooltip('route.roster.name')"
    }],
    attrs: {
      "name": "assignment"
    }
  }), _vm._v(_vm._s(_vm.$t('route.roster.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('lists') && _vm.$onduro.hasRole('planner')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('lists')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.lists.name')),
      expression: "showTooltip('route.lists.name')"
    }],
    attrs: {
      "name": "list"
    }
  }), _vm._v(_vm._s(_vm.$t('route.lists.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.isReal() && _vm.showAvailability) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('availability')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.availability.name')),
      expression: "showTooltip('route.availability.name')"
    }],
    attrs: {
      "name": "checkmark"
    }
  }), _vm._v(_vm._s(_vm.$t('route.availability.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.isReal() && _vm.$onduro.hasModule('contacts') && (_vm.$onduro.hasRight('contacts.view') || _vm.$onduro.getConfig('contacts.visibility'))) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('contacts')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.contacts.name')),
      expression: "showTooltip('route.contacts.name')"
    }],
    attrs: {
      "name": "phone"
    }
  }), _vm._v(_vm._s(_vm.$t('route.contacts.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('chats')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('chats')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.chats.name')),
      expression: "showTooltip('route.chats.name')"
    }],
    attrs: {
      "name": "chat"
    }
  }), _vm._v(_vm._s(_vm.$t('route.chats.name')) + "\n                "), _c('chat-bubble', {
    attrs: {
      "getter": "chat/countUnread",
      "limit": "99"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.isReal() && _vm.$onduro.hasModule('hours') && _vm.$onduro.hasRole('biller', 'supervisor')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('hours')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.hours.name')),
      expression: "showTooltip('route.hours.name')"
    }],
    attrs: {
      "name": "clock"
    }
  }), _vm._v(_vm._s(_vm.$t('route.hours.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('balances') && (_vm.balance || _vm.$onduro.hasRight('balances.overview'))) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('balances')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.balances.name')),
      expression: "showTooltip('route.balances.name')"
    }],
    attrs: {
      "name": "balance"
    }
  }), _vm._v(_vm._s(_vm.$t('route.balances.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('hours') && _vm.$onduro.hasRole('accountant')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('reports')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.reports.name')),
      expression: "showTooltip('route.reports.name')"
    }],
    attrs: {
      "name": "calculator"
    }
  }), _vm._v(_vm._s(_vm.$t('route.reports.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.isReal() && _vm.$onduro.hasModule('statistics') && _vm.$onduro.hasRole(['accountant', 'owner'])) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('statistics')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.statistics.name')),
      expression: "showTooltip('route.statistics.name')"
    }],
    attrs: {
      "name": "stats"
    }
  }), _vm._v(_vm._s(_vm.$t('route.statistics.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.viewport !== 'd' || !_vm.$onduro.hasRole(['owner', 'planner', 'manager'])) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('profile')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.profile.name')),
      expression: "showTooltip('route.profile.name')"
    }],
    attrs: {
      "name": "profile"
    }
  }), _vm._v(_vm._s(_vm.$t('route.profile.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('documents')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('documents')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.documents.name')),
      expression: "showTooltip('route.documents.name')"
    }],
    attrs: {
      "name": "insert-drive-file"
    }
  }), _vm._v(_vm._s(_vm.$t('route.documents.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasRight('user.edit')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('team')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.team.name')),
      expression: "showTooltip('route.team.name')"
    }],
    attrs: {
      "name": "team"
    }
  }), _vm._v(_vm._s(_vm.$t('route.team.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('freelancers') && _vm.$onduro.hasRole(['accountant', 'owner', 'freelancer', 'manager'])) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('freelancer')
    }
  }, [_c('icon', {
    attrs: {
      "name": "list"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('route.freelancer.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('resources') && (_vm.$onduro.hasRight('user.edit') || _vm.$onduro.hasRole('planner'))) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('resources')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.resources.name')),
      expression: "showTooltip('route.resources.name')"
    }],
    attrs: {
      "name": "car"
    }
  }), _vm._v(_vm._s(_vm.$t('route.resources.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$current.account.sko && _vm.$onduro.hasRole('owner', 'manager')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('log')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.log.name')),
      expression: "showTooltip('route.log.name')"
    }],
    attrs: {
      "name": "log"
    }
  }), _vm._v(_vm._s(_vm.$t('route.log.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasRole('owner', 'manager') && !_vm.$current.membership.restrictions.manager.limited) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('settings')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.settings.name')),
      expression: "showTooltip('route.settings.name')"
    }],
    attrs: {
      "name": "cog"
    }
  }), _vm._v(_vm._s(_vm.$t('route.settings.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$onduro.isReal() && _vm.$onduro.hasRole('owner', 'manager') && !_vm.$current.account.sko) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('modules')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.modules.name')),
      expression: "showTooltip('route.modules.name')"
    }],
    attrs: {
      "name": "modules"
    }
  }), _vm._v(_vm._s(_vm.$t('route.modules.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.current.user.demo) ? _c('li', {
    staticClass: "help"
  }, [_c('a', {
    staticClass: "router-link box-intercom",
    attrs: {
      "href": "mailto:support@onduro.com"
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('text.help')),
      expression: "showTooltip('text.help')"
    }],
    attrs: {
      "name": "help"
    }
  }), _vm._v(_vm._s(_vm.$t('text.help')) + "\n            ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasRole('owner')) ? _c('li', [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.$onduro.route('subscription')
    }
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.showTooltip('route.subscription.name')),
      expression: "showTooltip('route.subscription.name')"
    }],
    attrs: {
      "name": "company"
    }
  }), _vm._v(_vm._s(_vm.$t('route.subscription.name')) + "\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.current.user.super) ? _c('li', [_c('a', {
    staticClass: "router-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$widget.open('switcher')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "switch"
    }
  }), _vm._v("Switch\n            ")], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "languages"
  }, [_c('router-link', {
    class: _vm.$store.state.meta.lang == 'de' ? 'is-active' : '',
    attrs: {
      "to": _vm.$onduro.switchLanguage('de')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('de')
      }
    }
  }, [_vm._v("DE")]), _vm._v(" |\n            "), _c('router-link', {
    class: _vm.$store.state.meta.lang == 'nl' ? 'is-active' : '',
    attrs: {
      "to": _vm.$onduro.switchLanguage('nl')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('nl')
      }
    }
  }, [_vm._v("NL")]), _vm._v(" |\n            "), _c('router-link', {
    class: _vm.$store.state.meta.lang == 'en' ? 'is-active' : '',
    attrs: {
      "to": _vm.$onduro.switchLanguage('en')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('en')
      }
    }
  }, [_vm._v("EN")]), _vm._v(" "), (_vm.$current.profile == 'Pier14') ? [_vm._v("\n                | "), _c('router-link', {
    class: _vm.$store.state.meta.lang == 'pl' ? 'is-active' : '',
    attrs: {
      "to": _vm.$onduro.switchLanguage('pl')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('pl')
      }
    }
  }, [_vm._v("PL")])] : _vm._e()], 2), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "version",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.refresh.apply(null, arguments)
      }
    }
  }, [_vm._v("V #" + _vm._s(_vm.version))])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "mousedown": _vm.mouseDown,
      "mouseup": _vm.mouseUp,
      "mousemove": _vm.mouseMove
    }
  }, [_c('navigation', {
    ref: "navigation"
  }), _vm._v(" "), _c('main', [_c('main-header', [_c('div', {
    class: ['account', _vm.hasMultipleAccounts() ? 'multiple' : '']
  }, [(_vm.hasMultipleAccounts()) ? _c('icon', {
    attrs: {
      "name": "arrow-down"
    }
  }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.current.account.name) + "\n                "), (_vm.hasMultipleAccounts()) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAccount]
    }
  }, _vm._l((_vm.current.accounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.id
      }
    }, [_vm._v(_vm._s(account.name))])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.viewport == 'd') ? _c('router-link', {
    attrs: {
      "to": _vm.$onduro.route('profile')
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.current.user.name) + "\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.current.user.demo) ? _c('a', {
    staticClass: "help",
    on: {
      "click": function($event) {
        return _vm.showHelp()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('text.help')))]) : _vm._e(), _vm._v(" "), (_vm.hasUniversity) ? _c('a', {
    class: ['box-university', _vm.$store.state.current.account.demo ? 'btn btn--orange' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toggleUniversity
    }
  }, [_vm._v("University")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn logout",
    attrs: {
      "to": _vm.$onduro.route('logout')
    }
  }, [(_vm.viewport == 'mp' || _vm.viewport == 'ml') ? _c('icon', {
    attrs: {
      "name": "logout"
    }
  }) : _c('span', [_vm._v("Logout")])], 1)], 1)]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_LoginAside__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_LoginAside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_LoginAside__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Frontend',

    components: {
        LoginAside: __WEBPACK_IMPORTED_MODULE_0__components_global_LoginAside___default.a
    }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Login-aside',

    data: function data() {
        return {};
    },


    computed: {
        locale: function locale() {
            var lang = this.$store.state.current.locale;

            // there's no translation for English yet
            return lang == 'en' ? 'nl' : lang;
        },
        mobile: function mobile() {
            return location.hostname.match('mobile') ? true : false;
        }
    },

    methods: {
        goHome: function goHome() {
            // click / tap on logo forces hard reload
            window.location.href = this.$onduro.route('login');
        }
    }
});

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "login-aside"
  }, [_c('header', [_c('a', {
    staticClass: "link-home",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goHome()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "logo",
      "viewBox": "0 0 115 22"
    }
  })], 1), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": _vm.$onduro.switchLanguage('de')
    }
  }, [_vm._v("DE")]), _vm._v(" | "), _c('router-link', {
    attrs: {
      "to": _vm.$onduro.switchLanguage('nl')
    }
  }, [_vm._v("NL")]), _vm._v(" | "), _c('router-link', {
    attrs: {
      "to": _vm.$onduro.switchLanguage('en')
    }
  }, [_vm._v("EN")])], 1)]), _vm._v(" "), _c('footer', [_c('a', {
    attrs: {
      "href": 'https://www.onduro.com' + _vm.$onduro.route('terms', null, _vm.locale),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('route.terms.name')) + "\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'https://www.onduro.com' + _vm.$onduro.route('privacy', null, _vm.locale),
      "target": "_blank"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('route.privacy.name')) + "\n        ")]), _vm._v(" "), (!_vm.mobile) ? _c('a', {
    attrs: {
      "href": 'https://www.onduro.com' + _vm.$onduro.route('contact', null, _vm.locale)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('route.contact.name')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.mobile) ? _c('a', {
    attrs: {
      "href": "https://www.onduro.com"
    }
  }, [_vm._v("www.onduro.com")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('login-aside'), _vm._v(" "), _c('main', [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Wizard'
});

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Invoice'
});

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page-invoice",
    attrs: {
      "role": "main"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = {"af":"Afghanistan","al":"Albanien","dz":"Algerien","ad":"Andorra","ao":"Angola","ar":"Argentinien","am":"Armenien","au":"Australien","at":"Österreich","az":"Aserbaidschan","bs":"Bahamas","bh":"Bahrain","bd":"Bangladesch","bb":"Barbados","by":"Weißrussland","be":"Belgien","bz":"Belize","bj":"Benin","bt":"Bhutan","bo":"Bolivien","ba":"Bosnien und Herzegowina","bw":"Botswana","br":"Brasilien","bn":"Brunei","bg":"Bulgarien","bf":"Burkina Faso","bi":"Burundi","kh":"Kambodscha","cm":"Kamerun","ca":"Kanada","cv":"Kap Verde","cf":"Zentralafrikanische Republik","td":"Tschad","cl":"Chile","cn":"China","co":"Kolumbien","km":"Komoren","cg":"Kongo","cd":"Demokratische Republik Kongo","cr":"Costa Rica","ci":"Elfenbeinküste","hr":"Kroatien","cu":"Kuba","cy":"Zypern","cz":"Tschechische Republik","dk":"Dänemark","dj":"Dschibuti","dm":"Dominica","do":"Dominikanische Republik","ec":"Ecuador","eg":"Ägypten","sv":"El Salvador","gq":"Äquatorialguinea","er":"Eritrea","ee":"Estland","et":"Äthiopien","fj":"Fidschi","fi":"Finnland","fr":"Frankreich","ga":"Gabun","gm":"Gambia","ge":"Georgien","de":"Deutschland","gh":"Ghana","gr":"Griechenland","gd":"Grenada","gt":"Guatemala","gn":"Guinea","gw":"Guinea-Bissau","gy":"Guyana","ht":"Haiti","hn":"Honduras","hu":"Ungarn","is":"Island","in":"Indien","id":"Indonesien","ir":"Iran","iq":"Irak","ie":"Irland","il":"Israel","it":"Italien","jm":"Jamaika","jp":"Japan","jo":"Jordanien","kz":"Kasachstan","ke":"Kenia","ki":"Kiribati","kp":"Nordkorea","kr":"Südkorea","kw":"Kuwait","kg":"Kirgisistan","la":"Laos","lv":"Lettland","lb":"Libanon","ls":"Lesotho","lr":"Liberia","ly":"Libyen","li":"Liechtenstein","lt":"Litauen","lu":"Luxemburg","mk":"Nordmazedonien","mg":"Madagaskar","mw":"Malawi","my":"Malaysia","mv":"Malediven","ml":"Mali","mt":"Malta","mh":"Marshallinseln","mr":"Mauretanien","mu":"Mauritius","mx":"Mexiko","fm":"Mikronesien","md":"Moldawien","mc":"Monaco","mn":"Mongolei","me":"Montenegro","ma":"Marokko","mz":"Mosambik","mm":"Myanmar","na":"Namibia","nr":"Nauru","np":"Nepal","nl":"Niederlande","nz":"Neuseeland","ni":"Nicaragua","ne":"Niger","ng":"Nigeria","no":"Norwegen","om":"Oman","pk":"Pakistan","pw":"Palau","pa":"Panama","pg":"Papua-Neuguinea","py":"Paraguay","pe":"Peru","ph":"Philippinen","pl":"Polen","pt":"Portugal","qa":"Katar","ro":"Rumänien","ru":"Russland","rw":"Ruanda","kn":"St. Kitts und Nevis","lc":"St. Lucia","vc":"St. Vincent und die Grenadinen","ws":"Samoa","sm":"San Marino","st":"São Tomé und Príncipe","sa":"Saudi-Arabien","sn":"Senegal","rs":"Serbien","sc":"Seychellen","sl":"Sierra Leone","sg":"Singapur","sk":"Slowakei","si":"Slowenien","sb":"Salomonen","so":"Somalia","za":"Südafrika","ss":"Südsudan","es":"Spanien","lk":"Sri Lanka","sd":"Sudan","sr":"Suriname","sz":"Eswatini","se":"Schweden","ch":"Schweiz","sy":"Syrien","tw":"Taiwan","tj":"Tadschikistan","tz":"Tansania","th":"Thailand","tl":"Timor-Leste","tg":"Togo","to":"Tonga","tt":"Trinidad und Tobago","tn":"Tunesien","tr":"Türkei","tm":"Turkmenistan","tv":"Tuvalu","ug":"Uganda","ua":"Ukraine","ae":"Vereinigte Arabische Emirate","gb":"Vereinigtes Königreich","us":"Vereinigte Staaten","uy":"Uruguay","uz":"Usbekistan","vu":"Vanuatu","va":"Vatikanstadt","ve":"Venezuela","vn":"Vietnam","ye":"Jemen","zm":"Sambia","zw":"Simbabwe"}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = {"af":"Afghanistan","al":"Albanië","dz":"Algerije","ad":"Andorra","ao":"Angola","ar":"Argentinië","am":"Armenië","au":"Australië","at":"Oostenrijk","az":"Azerbeidzjan","bs":"Bahama's","bh":"Bahrein","bd":"Bangladesh","bb":"Barbados","by":"Wit-Rusland","be":"België","bz":"Belize","bj":"Benin","bt":"Bhutan","bo":"Bolivia","ba":"Bosnië en Herzegovina","bw":"Botswana","br":"Brazilië","bn":"Brunei","bg":"Bulgarije","bf":"Burkina Faso","bi":"Burundi","kh":"Cambodja","cm":"Kameroen","ca":"Canada","cv":"Kaapverdië","cf":"Centraal-Afrikaanse Republiek","td":"Tsjaad","cl":"Chili","cn":"China","co":"Colombia","km":"Comoren","cg":"Congo","cd":"Democratische Republiek Congo","cr":"Costa Rica","ci":"Ivoorkust","hr":"Kroatië","cu":"Cuba","cy":"Cyprus","cz":"Tsjechië","dk":"Denemarken","dj":"Djibouti","dm":"Dominica","do":"Dominicaanse Republiek","ec":"Ecuador","eg":"Egypte","sv":"El Salvador","gq":"Equatoriaal-Guinea","er":"Eritrea","ee":"Estland","et":"Ethiopië","fj":"Fiji","fi":"Finland","fr":"Frankrijk","ga":"Gabon","gm":"Gambia","ge":"Georgië","de":"Duitsland","gh":"Ghana","gr":"Griekenland","gd":"Grenada","gt":"Guatemala","gn":"Guinee","gw":"Guinee-Bissau","gy":"Guyana","ht":"Haïti","hn":"Honduras","hu":"Hongarije","is":"IJsland","in":"India","id":"Indonesië","ir":"Iran","iq":"Irak","ie":"Ierland","il":"Israël","it":"Italië","jm":"Jamaica","jp":"Japan","jo":"Jordanië","kz":"Kazachstan","ke":"Kenia","ki":"Kiribati","kp":"Noord-Korea","kr":"Zuid-Korea","kw":"Koeweit","kg":"Kirgizië","la":"Laos","lv":"Letland","lb":"Libanon","ls":"Lesotho","lr":"Liberia","ly":"Libië","li":"Liechtenstein","lt":"Litouwen","lu":"Luxemburg","mk":"Noord-Macedonië","mg":"Madagaskar","mw":"Malawi","my":"Maleisië","mv":"Maldiven","ml":"Mali","mt":"Malta","mh":"Marshalleilanden","mr":"Mauritanië","mu":"Mauritius","mx":"Mexico","fm":"Micronesië","md":"Moldavië","mc":"Monaco","mn":"Mongolië","me":"Montenegro","ma":"Marokko","mz":"Mozambique","mm":"Myanmar","na":"Namibië","nr":"Nauru","np":"Nepal","nl":"Nederland","nz":"Nieuw-Zeeland","ni":"Nicaragua","ne":"Niger","ng":"Nigeria","no":"Noorwegen","om":"Oman","pk":"Pakistan","pw":"Palau","pa":"Panama","pg":"Papoea-Nieuw-Guinea","py":"Paraguay","pe":"Peru","ph":"Filipijnen","pl":"Polen","pt":"Portugal","qa":"Qatar","ro":"Roemenië","ru":"Rusland","rw":"Rwanda","kn":"Saint Kitts en Nevis","lc":"Saint Lucia","vc":"Saint Vincent en de Grenadines","ws":"Samoa","sm":"San Marino","st":"Sao Tomé en Principe","sa":"Saudi-Arabië","sn":"Senegal","rs":"Servië","sc":"Seychellen","sl":"Sierra Leone","sg":"Singapore","sk":"Slowakije","si":"Slovenië","sb":"Salomonseilanden","so":"Somalië","za":"Zuid-Afrika","ss":"Zuid-Soedan","es":"Spanje","lk":"Sri Lanka","sd":"Soedan","sr":"Suriname","sz":"Eswatini","se":"Zweden","ch":"Zwitserland","sy":"Syrië","tw":"Taiwan","tj":"Tadzjikistan","tz":"Tanzania","th":"Thailand","tl":"Oost-Timor","tg":"Togo","to":"Tonga","tt":"Trinidad en Tobago","tn":"Tunesië","tr":"Turkije","tm":"Turkmenistan","tv":"Tuvalu","ug":"Oeganda","ua":"Oekraïne","ae":"Verenigde Arabische Emiraten","gb":"Verenigd Koninkrijk","us":"Verenigde Staten","uy":"Uruguay","uz":"Oezbekistan","vu":"Vanuatu","va":"Vaticaanstad","ve":"Venezuela","vn":"Vietnam","ye":"Jemen","zm":"Zambia","zw":"Zimbabwe"}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', {
    class: {
      'has-navigation': _vm.hasNavigation,
      'has-footer-bar': _vm.hasFooterBar,
      'page-login': _vm.login,
      'page-empty': _vm.empty,
      'page-backend': _vm.backend && !_vm.empty,
        'page-wizard': _vm.wizard,
        'touch-device': _vm.touchDevice,
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.updated) ? _c('div', {
    staticClass: "update-notification"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('page.update.headline')))]), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('page.update.text'))), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.updateApp()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.update.button')))])]) : _vm._e(), _vm._v(" "), (_vm.maintenance) ? _c('div', {
    staticClass: "update-notification"
  }, [_c('h1', [_vm._v("ONDURO will be right back!")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("We're performing a maintenance update and will be back in a moment.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Please try again later or by clicking on the button below.")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.updateApp()
      }
    }
  }, [_vm._v("Reload")])]) : _vm._e(), _vm._v(" "), (_vm.empty) ? _c('empty') : _vm._e(), _vm._v(" "), (_vm.backend && !_vm.maintenance) ? _c('backend') : _vm._e(), _vm._v(" "), (_vm.frontend) ? _c('frontend') : _vm._e(), _vm._v(" "), (_vm.wizard) ? _c('wizard') : _vm._e(), _vm._v(" "), (_vm.invoice) ? _c('invoice') : _vm._e(), _vm._v(" "), _c('modal', {
    ref: "modal"
  }), _vm._v(" "), _c('flash', {
    ref: "flash"
  }), _vm._v(" "), _c('widget', {
    ref: "modal"
  }), _vm._v(" "), _c('loader', {
    ref: "loader"
  }), _vm._v(" "), _c('toolbox', {
    ref: "toolbox"
  }), _vm._v(" "), _c('confirm', {
    ref: "confirm"
  }), _vm._v(" "), _c('notification', {
    ref: "notification"
  }), _vm._v(" "), (_vm.authenticated) ? _c('university', {
    ref: "university"
  }) : _vm._e(), _vm._v(" "), _c('lesson', {
    ref: "lesson"
  }), _vm._v(" "), _c('tooltip')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "max-width": "90%"
    },
    attrs: {
      "src": "/static/maintenance.gif"
    }
  })])
}]}

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Action',

    props: {
        color: String,
        icon: String,
        label: String,

        mobile: {
            type: Boolean,
            default: false
        },

        mobileOnly: {
            type: Boolean,
            default: false
        },

        focus: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        /**
         * Return btn class
         * @returns {string}
         */
        btnClass: function btnClass() {
            var _return = [];

            if (this.color) _return.push('btn--' + this.color.replace('btn--', ''));

            if (this.mobile) _return.push('btn--icon-only');

            if (this.icon) _return.push('btn-' + this.icon);

            if (this.mobileOnly) _return.push('btn--icon-only-mobile');

            return _return.join(' ');
        },


        /**
         * Show slot if defined
         * @returns {boolean}
         */
        hasSlot: function hasSlot() {
            return typeof this.$slots.default !== 'undefined';
        }
    },

    mounted: function mounted() {
        if (this.focus) {
            this.$refs.okay.focus();
        }
    }
});

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    ref: "okay",
    staticClass: "btn",
    class: _vm.btnClass,
    attrs: {
      "type": "button"
    }
  }, [(_vm.icon) ? _c('icon', {
    attrs: {
      "name": _vm.icon,
      "viewBox": "0 0 24 24"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasSlot) ? _c('span', [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.label && !_vm.hasSlot) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Bubble',

    props: ['count', 'color']
});

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.count) ? _c('div', {
    staticClass: "bubble",
    class: _vm.color !== '' ? 'bubble--' + _vm.color : ''
  }, [_c('span', [_vm._v(_vm._s(_vm.count))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'BackButton',

    props: {
        path: {
            type: String,
            required: true
        }
    },

    methods: {
        /**
         * Trigger window history back function
         */
        navigate: function navigate() {
            this.$router.push(this.$onduro.route(this.path));
        }
    }
});

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigate.apply(null, arguments)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrow-back"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Calendar',

    props: ['payload'],

    data: function data() {
        return {
            month: null,
            year: null,
            headline: '',
            today: null,
            releaseDate: null,
            calendar: {},
            shared: __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].state
        };
    },


    computed: {
        releasedUntil: function releasedUntil() {
            return __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].getLocation(this.shared.location).releasedUntil;
        }
    },

    created: function created() {
        this.init();

        this.headline = this.$t('text.loading');
    },


    methods: {
        init: function init() {
            this.today = moment().format('YYYY-MM-DD');

            var released = moment(this.releasedUntil);

            this.releaseDate = released.format('DD-MM-YYYY');
            this.month = released.format('MM') * 1;
            this.year = released.format('YYYY');

            this.fetchCalendar();
        },
        fetchCalendar: function fetchCalendar() {
            var _this = this;

            this.$http.get('/api/calendar/' + this.month + '/' + this.year).then(function (response) {
                _this.headline = response.data.headline;
                _this.calendar = response.data.calendar;
            });
        },
        chooseDate: function chooseDate(day) {
            if (this.isChooseable(day)) {
                var type = day.date <= this.releasedUntil ? 'revoke' : 'release';

                if (typeof this.payload.callback == 'function') this.payload.callback(type, day.date, day.localized);
            }
        },
        prevMonth: function prevMonth() {
            this.month = this.month - 1;

            if (this.month == 0) {
                this.month = 12;
                this.year = parseInt(this.year) - 1;
            }

            this.fetchCalendar();
        },
        nextMonth: function nextMonth() {
            this.month = this.month + 1;

            if (this.month == 13) {
                this.month = 1;
                this.year = parseInt(this.year) + 1;
            }

            this.fetchCalendar();
        },
        getClasses: function getClasses(day) {
            var classes = [];

            if (day.date <= this.releasedUntil) {
                classes.push('is-released');

                if (day.date == this.releasedUntil) {
                    classes.push('is-release-date');
                } else if (day.date >= this.today) {
                    classes.push('is-revokable');
                }
            }

            if (day.date < this.today) {
                classes.push('is-inactive');
            }

            if (day.off) classes.push('is-off');

            return classes;
        },
        isChooseable: function isChooseable(day) {
            // release date is not chooseable
            if (day.date == this.releasedUntil) return false;

            // cannot release roster to the past
            if (day.date < this.today) return false;

            return true;
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.close');
        }
    }
});

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbox-calendar"
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', [_c('action', {
    attrs: {
      "icon": "prev",
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prevMonth.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.init
    }
  }, [_vm._v(_vm._s(_vm.headline))]), _vm._v(" "), _c('div', [_c('action', {
    attrs: {
      "icon": "next",
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextMonth.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.mon')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.tue')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.wed')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.thu')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.fri')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.sat')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.sun')))])]), _vm._v(" "), _vm._l((_vm.calendar), function(days, week) {
    return _c('tr', _vm._l((days), function(day) {
      return _c('td', {
        class: _vm.getClasses(day),
        on: {
          "click": function($event) {
            return _vm.chooseDate(day)
          }
        }
      }, [_vm._v(_vm._s(day.day))])
    }), 0)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('layout.calendar.roster.headline')) + " " + _vm._s(_vm.releaseDate) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ChannelList',

    data: function data() {
        return {
            channels: []
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        unreadChats: function unreadChats(_ref) {
            var chat = _ref.chat;
            return chat.unreadChats;
        }
    }), {
        unreadCount: function unreadCount() {
            return this.$store.getters['chat/countUnread'];
        },
        sortedChannels: function sortedChannels() {
            return _.orderBy(this.channels, ['lastUpdated'], 'desc');
        }
    }),

    created: function created() {
        this.getChannels();
    },

    methods: {
        getChannels: function getChannels() {
            var _this = this;

            this.$http.silent().get('/api/channels').then(function (response) {
                _this.channels = response.data;
            });
        }
    },

    watch: {
        unreadCount: function unreadCount() {
            this.getChannels();
        }
    }
});

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "channel-list"
  }, _vm._l((_vm.sortedChannels), function(channel) {
    return _c('li', {
      directives: [{
        name: "loader",
        rawName: "v-loader",
        value: ({
          listen: ("channel-" + (channel.id))
        }),
        expression: "{ listen: `channel-${channel.id}` }"
      }],
      key: channel.id
    }, [_c(channel.type === 'group' ? 'channel-list-group' : 'channel-list-single', {
      tag: "component",
      attrs: {
        "channel": channel,
        "chat-states": _vm.unreadChats
      }
    })], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_lodash__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_channelChat__ = __webpack_require__(51);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ChannelListGroup',

    mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers_lodash__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__helpers_channelChat__["b" /* default */]],

    computed: {
        gravatars: function gravatars() {
            return _.map(this.channel.participants, function (item) {
                return item.user.gravatar;
            });
        }
    }
});

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ready),
      expression: "ready"
    }],
    attrs: {
      "to": _vm.$onduro.route('chats', _vm.channel.id)
    }
  }, [_c('div', {
    staticClass: "profile"
  }, [_c('gravatar-group', {
    attrs: {
      "emails": _vm.gravatars,
      "own-user": _vm.channel.id
    },
    on: {
      "loaded": function($event) {
        _vm.ready = true
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "channel-list-details",
    class: {
      'unread': _vm.unreadCount > 0
    }
  }, [(!_vm.empty(_vm.lastChannel.lastChat)) ? _c('time', {
    attrs: {
      "datetime": _vm.lastChannel.lastChat.createdAt
    }
  }, [_vm._v(_vm._s(_vm.dateFormat('YYYY-MM-DD HH:mm:ss', _vm.lastChannel.lastChat.createdAt)))]) : _c('time', {
    attrs: {
      "datetime": _vm.channel.createdAt
    }
  }, [_vm._v(_vm._s(_vm.dateFormat('YYYY-MM-DD HH:mm:ss', _vm.channel.createdAt)))]), _vm._v(" "), _c('chat-bubble', {
    staticClass: "bubble--blue",
    attrs: {
      "count": _vm.unreadCount,
      "limit": "99"
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.channel.title))]), _c('br'), _vm._v(" "), (!_vm.empty(_vm.lastChannel.lastChat)) ? _c('small', {
    staticClass: "text-light"
  }, [(_vm.lastChannel.lastChat.mine) ? _c('b', [_vm._v(_vm._s(_vm.$t('text.you')) + ": ")]) : _c('b', [_vm._v(_vm._s(_vm.lastParticipant) + ": ")]), _vm._v("\n                " + _vm._s(_vm.lastChannel.lastChat.message) + "\n            ")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_lodash__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_channelChat__ = __webpack_require__(51);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ChannelListSingle',

    mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers_lodash__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__helpers_channelChat__["b" /* default */]],

    computed: {
        gravatar: function gravatar() {
            var _this = this;

            return _.filter(this.channel.participantsWithTrashed, function (item) {
                return item.user.id !== _this.user.id;
            })[0].user.gravatar;
        }
    }
});

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ready),
      expression: "ready"
    }],
    attrs: {
      "to": _vm.$onduro.route('chats', _vm.channel.id)
    }
  }, [_c('div', {
    staticClass: "profile"
  }, [_c('gravatar', {
    attrs: {
      "email": _vm.gravatar
    },
    on: {
      "loaded": function($event) {
        _vm.ready = true
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "channel-list-details",
    class: {
      'unread': _vm.unreadCount > 0
    }
  }, [(!_vm.empty(_vm.lastChannel.lastChat)) ? _c('time', {
    attrs: {
      "datetime": _vm.lastChannel.lastChat.createdAt
    }
  }, [_vm._v(_vm._s(_vm.dateFormat('YYYY-MM-DD HH:mm:ss', _vm.lastChannel.lastChat.createdAt)))]) : _c('time', {
    attrs: {
      "datetime": _vm.channel.createdAt
    }
  }, [_vm._v(_vm._s(_vm.dateFormat('YYYY-MM-DD HH:mm:ss', _vm.channel.createdAt)))]), _vm._v(" "), _c('chat-bubble', {
    staticClass: "bubble--blue",
    attrs: {
      "count": _vm.unreadCount,
      "limit": "99"
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.channel.title))]), _c('br'), _vm._v(" "), (!_vm.empty(_vm.lastChannel.lastChat)) ? _c('small', {
    staticClass: "text-light"
  }, [(_vm.lastChannel.lastChat.mine) ? _c('b', [_vm._v(_vm._s(_vm.$t('text.you')) + ": ")]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.lastChannel.lastChat.message) + "\n            ")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_channelChat__ = __webpack_require__(51);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Chat',

    mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_channelChat__["a" /* computed */], __WEBPACK_IMPORTED_MODULE_3__helpers_channelChat__["c" /* methods */]],

    data: function data() {
        return {
            timeouts: {},
            typing: [],
            participants: [],
            chats: [],
            message: ''
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
        unreadChats: function unreadChats(_ref) {
            var chat = _ref.chat;
            return chat.unreadChats;
        },
        user: function user(_ref2) {
            var current = _ref2.current;
            return current.membership.id;
        }
    }), {
        channel: function channel() {
            return {
                id: this.$route.params.channel
            };
        },
        clusteredParticipants: function clusteredParticipants() {
            var clustered = {},
                unqKey = '_ca';

            _.forEach(this.participants, function (participant) {
                if (typeof clustered['' + participant.createdAt + unqKey] === 'undefined') clustered['' + participant.createdAt + unqKey] = [];

                clustered['' + participant.createdAt + unqKey].push({ createdAt: participant.createdAt, user: participant.user });
            });

            return clustered;
        },
        clusteredHistoryParticipants: function clusteredHistoryParticipants() {
            var clustered = {},
                unqKey = '_da';

            _.forEach(this.participants, function (participant) {
                if (participant.deletedAt === null) return;

                if (typeof clustered['' + participant.deletedAt + unqKey] === 'undefined') clustered['' + participant.deletedAt + unqKey] = [];

                clustered['' + participant.deletedAt + unqKey].push({ deletedAt: participant.deletedAt, user: participant.user });
            });

            return clustered;
        },
        sortedChats: function sortedChats() {
            var participants = this.clusteredParticipants,
                historyParticipants = this.clusteredHistoryParticipants,
                chats = _.keyBy(this.chats, 'createdAt');

            return _.merge(chats, participants, historyParticipants);
        },
        clusteredChats: function clusteredChats() {
            var _this = this;

            var clustered = [],
                creator = null,
                iterator = -1,
                sortedKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.sortedChats).sort().reverse();

            _.forEach(sortedKeys, function (key) {
                if (typeof _this.sortedChats[key].user === 'undefined' && typeof _this.sortedChats[key].mine === 'undefined') {
                    iterator++;
                    creator = null;
                    clustered[iterator] = _this.sortedChats[key];
                } else {
                    if (_this.sortedChats[key].user.id === creator) {
                        clustered[iterator].push(_this.sortedChats[key]);
                    } else {
                        creator = _this.sortedChats[key].user.id;
                        iterator++;
                        clustered[iterator] = [];
                        clustered[iterator].push(_this.sortedChats[key]);
                    }
                }
            });

            return clustered;
        },
        typingParticipants: function typingParticipants() {
            var typer = [];

            _.forEach(this.typing, function (p) {
                if (!!p.typing) {
                    typer.push(p);
                }
            });

            return typer;
        }
    }),

    created: function created() {
        var _this2 = this;

        this.$http.silent().get('/api/channels/' + this.channel.id).then(function (response) {
            _this2.$store.dispatch('chat/setActiveChannelInfos', response.data.channel);
            _this2.chats = response.data.chats;
            _this2.participants = response.data.participants;
            _this2.typing = _.map(_this2.participants, function (o) {
                return {
                    name: o.user.name,
                    id: o.user.id,
                    typing: false
                };
            });
        }).catch(function (error) {
            _this2.$onduro.redirect('chats');
        });

        Echo.private('chat.' + this.channel.id).listenForWhisper('typing', function (e) {
            var index = _.findIndex(_this2.typing, { id: e.user });

            if (index !== -1) {
                _this2.typing[index].typing = e.typing;

                if (typeof _this2.timeouts[e.user] !== 'undefined') clearTimeout(_this2.timeouts[e.user]);

                // remove is typing indicator after 0.9s
                _this2.timeouts[e.user] = setTimeout(function () {
                    _this2.clearTyper(index);
                }, 900);
            }
        });
    },
    mounted: function mounted() {
        var _this3 = this;

        this.$refs['textarea'].focus();
        this.$store.dispatch('chat/setActiveChannel', this.channel.id);
        this.refreshUnreadChats(this.unreadChats, this.channel.id);

        Echo.private('channel.' + this.channel.id).listen('ChatMessageSent', function (e) {
            e.chat.mine = false; // broadcast events are always for others only
            _this3.updateChats(e.chat);
        }).listen('StatusUpdate', function (e) {
            _this3.refreshReadStatus(e);
        });
    },
    beforeDestroy: function beforeDestroy() {
        this.$store.dispatch('chat/setActiveChannel', null);
        this.$store.dispatch('chat/setActiveChannelInfos', {});
    },


    methods: {
        intersection: function intersection(o1, o2) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(o1).filter({}.hasOwnProperty.bind(o2));
        },
        countStatus: function countStatus(key, statuses) {
            return {
                total: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(statuses).length,
                status: _.map(_.filter(statuses, function (status) {
                    return status[key] !== null;
                }), key).length
            };
        },
        isRead: function isRead(statuses) {
            if (!statuses) return false;

            var countStatuses = this.countStatus('readAt', statuses);

            return countStatuses.total === countStatuses.status;
        },
        isReceived: function isReceived(statuses) {
            if (!statuses) return false;

            var countStatuses = this.countStatus('receivedAt', statuses);

            return countStatuses.status >= 1;
        },
        updateChats: function updateChats(chat) {
            this.chats.push(chat);
        },
        submit: function submit() {
            var _this4 = this;

            this.$http.post('/api/channels/' + this.channel.id + '/chats', {
                message: this.message
            }).then(function (response) {
                _this4.updateChats(response.data);
            }).catch(function (error) {
                console.log(error);
            });

            this.message = '';
        },
        reverse: function reverse(val) {
            return val.slice().reverse();
        },
        refreshReadStatus: function refreshReadStatus(data) {
            var _this5 = this;

            var i = 0;

            if (data.status === 'read') {
                return _.forEach(this.chats, function (chat) {
                    if (chat.mine && !_this5.isRead(chat.statuses)) {
                        var index = _.findIndex(chat.statuses, { membershipId: data.membership });

                        if (index !== -1) _this5.chats[i].statuses[index].readAt = 'true';
                    }

                    i++;
                });
            }

            return _.forEach(this.chats, function (chat) {
                if (chat.mine && !_this5.isReceived(chat.statuses)) {
                    var index = _.findIndex(chat.statuses, { membershipId: data.membership });

                    if (index !== -1) _this5.chats[i].statuses[index].receivedAt = 'true';
                }

                i++;
            });
        },
        isCreator: function isCreator(user) {
            return _.find(this.participants, { user: { id: user.id } }).role === 'creator';
        },
        isTyping: function isTyping(e) {
            var _this6 = this;

            var channel = Echo.private('chat.' + this.channel.id),
                filter = [9, 91, 18, 27];

            if (filter.indexOf(e.keyCode) !== -1) return;

            setTimeout(function () {
                channel.whisper('typing', {
                    user: _this6.user,
                    typing: true
                });
            }, 300);
        },
        clearTyper: function clearTyper(index) {
            this.typing[index].typing = false;
        }
    }
});

/***/ }),
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-wrapper"
  }, [_c('div', {
    staticClass: "chats"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "span"
    }
  }, _vm._l((_vm.typingParticipants), function(typer) {
    return _c('span', {
      key: typer.id,
      staticClass: "chat-typer"
    }, [_vm._v(_vm._s(typer.name) + " is typing ...")])
  }), 0), _vm._v(" "), _vm._l((_vm.clusteredChats), function(clustered) {
    return _c('div', {
      staticClass: "chats-group"
    }, _vm._l((_vm.reverse(clustered)), function(chat, $index) {
      return _c('div', {
        class: {
          'chat--mine': chat.mine,
            'chat': typeof chat.mine !== 'undefined',
            'chat-status': typeof chat.mine === 'undefined'
        }
      }, [(typeof chat.mine !== 'undefined') ? _c('span', [($index === 0 && !chat.mine) ? _c('b', [_vm._v(_vm._s(chat.user.name))]) : _vm._e(), _vm._v("\n                    " + _vm._s(chat.message) + "\n                    "), _c('small', {
        staticClass: "time"
      }, [_vm._v(_vm._s(_vm._f("readableDate")(chat.createdAt, 'YYYY-MM-DD HH:mm:ss', 'HH:mm')))]), _vm._v(" "), (chat.mine) ? _c('span', {
        staticClass: "status"
      }, [(_vm.isRead(chat.statuses) || _vm.isReceived(chat.statuses)) ? _c('span', {
        class: {
          'status-read': _vm.isRead(chat.statuses)
        }
      }, [_c('icon', {
        attrs: {
          "name": "check"
        }
      }), _vm._v(" "), _c('icon', {
        attrs: {
          "name": "check"
        }
      })], 1) : _c('span', [_c('icon', {
        attrs: {
          "name": "check"
        }
      })], 1)]) : _vm._e()]) : _c('span', [(chat.createdAt && !_vm.isCreator(chat.user)) ? _c('i', [_vm._v(_vm._s(_vm._f("readableDate")(chat.createdAt, 'YYYY-MM-DD HH:mm:ss', 'DD. MMMM YYYY, HH:mm:ss')) + " " + _vm._s(chat.user.name) + " ist beigetreten")]) : _vm._e(), _vm._v(" "), (chat.createdAt && _vm.isCreator(chat.user)) ? _c('i', [_vm._v(_vm._s(_vm._f("readableDate")(chat.createdAt, 'YYYY-MM-DD HH:mm:ss', 'DD. MMMM YYYY, HH:mm:ss')) + " " + _vm._s(chat.user.name) + " hat den Chat erstellt")]) : _vm._e(), _vm._v(" "), (chat.deletedAt) ? _c('i', [_vm._v(_vm._s(_vm._f("readableDate")(chat.deletedAt, 'YYYY-MM-DD HH:mm:ss', 'DD. MMMM YYYY, HH:mm:ss')) + " " + _vm._s(chat.user.name) + " ist ausgetreten")]) : _vm._e()])])
    }), 0)
  })], 2), _vm._v(" "), _c('footer', {
    staticClass: "new-message"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    ref: "textarea",
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keydown": [_vm.isTyping, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if (!$event.shiftKey) { return null; }
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "title": _vm.$t('common.button.send')
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('icon', {
    attrs: {
      "name": "send"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ChantBubble',

    props: ['getter', 'limit', 'count'],

    computed: {
        chatCount: function chatCount() {
            var count = this.getter ? this.$store.getters[this.getter] : this.count;

            if (count === 0) return false;
            return count > this.limit ? '+' + this.limit : count;
        }
    }
});

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-zoom"
    }
  }, [_c('bubble', {
    attrs: {
      "count": _vm.chatCount
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_planning_shared__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Chatbox',

    props: ['payload'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_4__pages_planning_shared__["a" /* default */].state,
            initialized: false,
            message: '',

            typing: false
        };
    },
    mounted: function mounted() {
        this.init();
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
        touchDevice: function touchDevice(_ref) {
            var app = _ref.app;
            return app.touchDevice;
        }
    }), {
        placeholder: function placeholder() {
            return this.$t('page.roster.placeholder.comment');
        },
        date: function date() {
            return this.payload;
        }
    }),

    watch: {
        payload: function payload() {
            this.init();
        }
    },

    methods: {
        init: function init() {
            this.message = '';
            this.scrollToBottom();
            this.initialized = true;
        },

        scrollToBottom: function scrollToBottom() {
            var _this = this;

            this.$nextTick(function () {
                _this.$refs.posts.scrollTop = _this.$refs.posts.scrollHeight;

                _this.$nextTick(function () {
                    _this.$refs.message.focus();
                });
            });
        },
        getComments: function getComments() {
            return __WEBPACK_IMPORTED_MODULE_4__pages_planning_shared__["a" /* default */].getComments(this.payload);
        },
        deleteComment: function deleteComment(id) {
            var _this2 = this;

            this.$http.delete('/api/messages/' + id).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4__pages_planning_shared__["a" /* default */].removeComment(id);
                _this2.scrollToBottom();
            });
        },
        canDelete: function canDelete(user) {
            return this.$store.state.current.user.id === user.id || this.$onduro.hasRole(['owner', 'manager']);
        },
        submitMessage: function submitMessage(date) {
            var _this3 = this;

            if (!this.message) return;

            this.$http.post('/api/messages', {
                'location': this.shared.location,
                'date': date,
                'comment': this.message
            }).then(function (response) {
                _this3.message = '';
                _this3.shared.comments.push(response.data);
                _this3.scrollToBottom();
            });
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_3__events_events__["a" /* default */].$emit('toolbox.close');
        },
        setFocus: function setFocus() {
            __WEBPACK_IMPORTED_MODULE_3__events_events__["a" /* default */].$emit('input.focus', true);
            this.typing = true;
        },
        setBlur: function setBlur() {
            //            events.$emit('input.focus', false);
            this.typing = false;
        }
    }
});

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['tools', _vm.typing && _vm.touchDevice ? 'is-typing' : ''],
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close()
      }
    }
  }, [_c('div', {
    ref: "posts",
    staticClass: "posts"
  }, [_c('div', {
    staticClass: "posts-inner"
  }, _vm._l((_vm.getComments(_vm.date)), function(post) {
    return _c('div', {
      staticClass: "post"
    }, [_c('div', {
      staticClass: "details"
    }, [_c('span', [_vm._v(_vm._s(post.user.name))]), _vm._v(" "), _c('time', {
      attrs: {
        "datetime": post.createdAt
      }
    }, [_vm._v(_vm._s(post.localized))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(post.message))])]), _vm._v(" "), (_vm.canDelete(post.user)) ? _c('icon', {
      attrs: {
        "name": "delete"
      },
      nativeOn: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteComment(post.id)
        }
      }
    }) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.message),
      expression: "message",
      modifiers: {
        "trim": true
      }
    }],
    ref: "message",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "focus": _vm.setFocus,
      "blur": [_vm.setBlur, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), (_vm.typing && _vm.touchDevice) ? _c('action', {
    staticClass: "cancel",
    attrs: {
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.message.blur()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.cancel')))]) : _vm._e(), _vm._v(" "), _c('action', {
    staticClass: "close",
    attrs: {
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.close')))]), _vm._v(" "), _c('action', {
    staticClass: "submit",
    attrs: {
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitMessage(_vm.date)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.add')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Container',

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        sidebarType: function sidebarType(_ref) {
            var sidebar = _ref.sidebar;
            return sidebar.type;
        }
    }))
});

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      'container--flex': _vm.sidebarType == 'flex',
        'container--tabs': _vm.sidebarType == 'tabs',
        'container--fixed': _vm.sidebarType == 'fixed',
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pikaday__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Pikaday',

    props: {
        date: {
            default: null
        },

        format: {
            type: String,
            default: 'll'
        },

        minDate: {
            default: null
        },

        maxDate: {
            default: null
        },

        setDefaultDate: {
            default: true
        },

        firstDay: {
            default: 1
        },

        showWeekNumber: {
            default: true
        },

        disabled: {
            default: false
        }
    },

    data: function data() {
        return {
            pikaday: null,
            lang: {
                de: {
                    previousMonth: 'voriger Monat',
                    nextMonth: 'nächster Monat',
                    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                    weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                    weekdaysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
                },

                nl: {
                    previousMonth: 'vorige maand',
                    nextMonth: 'volgende maand',
                    months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
                    weekdays: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
                    weekdaysShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za']
                },

                en: {
                    previousMonth: 'previous month',
                    nextMonth: 'next month',
                    months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
                    weekdays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
                    weekdaysShort: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa']
                }
            }
        };
    },
    mounted: function mounted() {
        var vm = this;
        var id = this.$attrs.id;

        this.pikaday = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
            i18n: this.lang[this.$store.state.meta.lang],
            field: this.$refs.pikaday,
            format: this.format,
            setDefaultDate: this.setDefaultDate,
            defaultDate: this.date ? moment(this.date).toDate() : null,
            //maxDate: this.maxDate,
            maxDate: moment(this.maxDate).toDate(),
            //minDate: this.minDate,
            minDate: moment(this.minDate).toDate(),
            firstDay: this.firstDay,
            showWeekNumber: this.showWeekNumber,
            yearRange: [1950, 2050],
            onSelect: function onSelect(val) {
                if (val instanceof Date) {
                    val = moment(val).format('YYYY-MM-DD');
                }

                vm.$emit('change', val, id);
            }
        });
    },


    watch: {
        date: function date(val) {
            this.pikaday.setMinDate(null);
            this.pikaday.setMaxDate(null);
            var date = val == null ? null : moment(val).toDate();
            this.pikaday.setDate(date, true);
        },
        minDate: function minDate(val) {
            var date = val == null ? null : moment(val).toDate();
            this.pikaday.setMinDate(date);
        },
        maxDate: function maxDate(val) {
            var date = val == null ? null : moment(val).toDate();
            this.pikaday.setMaxDate(moment(date).toDate());
        }
    },

    methods: {
        clearPicker: function clearPicker() {
            this.pikaday.setDate(null, true);
            this.$emit('change', null, this.$attrs.id);
        }
    }
});

/***/ }),
/* 525 */,
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    ref: "pikaday",
    attrs: {
      "type": "text",
      "placeholder": "__ . __ . ____",
      "readonly": "",
      "disabled": _vm.disabled
    }
  }), (_vm.date) ? _c('icon', {
    staticClass: "pikaday-clear",
    attrs: {
      "name": "close"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearPicker()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Calendar',

    props: {
        /*
         * The callback property handles the selected dates
         * array and provides it in the callback function:
         * callbackName(selectedDates)
         */
        callback: {
            required: false,
            type: Function
        },

        /*
         * Set current year and month of calendar
         * in order to prevent reset at init()
         */
        date: {
            required: false,
            type: String
        },

        /*
         * Selection mode for calendar.
         * Multi allows multiple timeframes
         * Range allows defined ranges from day, to years
         * Single allows only on timeframe
         * Readonly allows only display of selected dates
         */
        mode: {
            required: false,
            type: String,
            default: 'multi'
        },

        range: {
            required: this.mode === 'range',
            type: String
        },

        /*
         * Blocks certain dates in the selection
         * @array ['2018-05-12']
         */
        blocked: {
            required: false,
            type: Array,
            default: function _default() {
                return [];
            }
        },

        /*
         * Pre-selects certain dates in the calendar
         * @array ['2018-05-12']
         */
        selected: {
            required: false,
            type: Array,
            default: function _default() {
                return [];
            }
        },

        /*
         * Circle selected dates
         */
        circled: {
            required: false,
            type: Boolean,
            default: false
        },

        /*
         * Higlight certain dates in the calendar
         * @array ['2018-05-12']
         */
        highlight: {
            required: false,
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },

    data: function data() {
        return {
            month: null,
            year: null,
            headline: '',
            today: null,
            calendar: {},
            mousedown: false,
            selection: [],
            withdrawn: [],
            selectAction: 'select',

            hovered: null,
            first: null, // = from
            last: null, // = until

            altKey: false,
            initializing: true
        };
    },
    created: function created() {
        var _this = this;

        this.init();

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('calendar.set', function (dates) {
            _this.selection = dates;
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('calendar.reset', function () {
            _this.resetSelection();
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('calendar.add', function (day) {
            _this.add(day);
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('calendar.remove', function (day) {
            _this.remove(day);
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('calendar.prev', function () {
            _this.prevMonth();
        });

        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('calendar.next', function () {
            _this.nextMonth();
        });

        // set current year/month from date
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$listen('calendar.date', function (date) {
            _this.gotoDate(date);
        });

        if (this.selected.length) {
            this.selection = this.selected;

            if (this.mode === 'range') {
                if (this.range === 'week') {
                    this.first = this.selected[0];
                    this.last = moment(this.selected[0], 'YYYY-MM-DD').add(6, 'days').format('YYYY-MM-DD');
                    this.markRange();
                }
            }
        }

        window.addEventListener('keydown', this.keyHandler, false);
        window.addEventListener('keyup', this.keyHandler, false);
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$off('calendar.set');
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$off('calendar.reset');
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$off('calendar.add');
        __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$off('calendar.remove');

        window.removeEventListener('keydown', this.keyHandler, false);
        window.removeEventListener('keyup', this.keyHandler, false);
    },


    methods: {
        init: function init() {
            // set today
            this.today = moment().format('YYYY-MM-DD');

            // calendar has pre-selected dates
            if (this.selected.length > 0 && (this.mode === 'single' || this.mode === 'range') && this.mode != 'readonly') {
                // jump to month/year of first day in selection
                this.first = this.selected[0];

                this.gotoDate(this.first);
            } else if (this.date) {
                this.gotoDate(this.date);
            } else {
                this.gotoToday();
            }

            this.initializing = false;
        },
        gotoToday: function gotoToday() {
            this.gotoDate(this.today);
        },
        gotoDate: function gotoDate(date) {
            this.month = moment(date).format('MM') * 1;
            this.year = moment(date).format('YYYY');

            this.fetchCalendar();
        },


        /*
         *  Sort days by date
         *
         *  This is not automatically done by the browser, since Object.keys()
         *  is not consistent across browsers!
         */
        sortDays: function sortDays(days) {
            return _.sortBy(days, 'date');
        },
        fetchCalendar: function fetchCalendar() {
            var calendar = {};
            var week = {};

            var first = moment(this.year + '-' + ("00" + this.month).slice(-2) + '-01', "YYYY-MM-DD");
            var last = first.clone().endOf('month');

            if (first.isoWeekday() != 1) // 1 = MONDAY
                {
                    var before = first.clone();

                    do {
                        before.subtract(1, 'days');

                        var date = before.format('YYYY-MM-DD');

                        week[date] = {
                            day: before.format('D'),
                            date: date,
                            off: true,
                            today: this.today == date,
                            localized: before.format('LL')
                        };
                    } while (before.isoWeekday() != 1);

                    _.sortBy(week, 'date');
                }

            for (var time = first.clone(); time <= last; time.add(1, 'days')) {
                var date = time.format('YYYY-MM-DD');

                week[date] = {
                    day: time.format('D'),
                    date: date,
                    off: false,
                    today: this.today == date,
                    localized: time.format('LL')
                };

                if (time.isoWeekday() == 7) // 7 = SUNDAY
                    {
                        calendar[time.isoWeek()] = week;
                        week = {};
                    }
            }

            if (last.isoWeekday() != 7) // 7 = SUNDAY
                {
                    var after = last.clone();

                    do {
                        after.add(1, 'days');

                        var date = after.format('YYYY-MM-DD');

                        week[date] = {
                            day: after.format('D'),
                            date: date,
                            off: true,
                            today: this.today == date,
                            localized: after.format('LL')
                        };
                    } while (after.isoWeekday() != 7);

                    calendar[after.isoWeek()] = week;
                }

            this.headline = first.format('MMMM') + ' ' + this.year;
            this.calendar = calendar;

            if (!this.initializing) {
                __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('calendar.changed', {
                    month: this.month,
                    year: this.year
                });
            }
        },
        prevMonth: function prevMonth() {
            this.month = this.month - 1;

            if (this.month == 0) {
                this.month = 12;
                this.year = parseInt(this.year) - 1;
            }

            this.fetchCalendar();
        },
        nextMonth: function nextMonth() {
            this.month = this.month + 1;

            if (this.month == 13) {
                this.month = 1;
                this.year = parseInt(this.year) + 1;
            }

            this.fetchCalendar();
        },
        getClasses: function getClasses(day) {
            var classes = [];

            if (day.date < this.today) {
                // classes.push('is-inactive');
            }

            if (day.date > this.first && day.date <= this.hovered && !this.last && !this.altKey) {
                classes.push('is-period');
            }

            if (this.isSelected(day)) {
                if (this.circled) {
                    classes.push('is-circled');
                } else {
                    classes.push('is-selected');
                }
            }

            if (this.isHighlighted(day)) {
                classes.push('is-highlighted');
            }

            if (day.date == this.today) {
                classes.push('is-today');
            }

            if (this.isBlocked(day)) {
                classes.push('is-blocked');
            }

            if (day.off) classes.push('is-off');

            return classes;
        },
        isBlocked: function isBlocked(day) {
            return this.blocked.indexOf(day.date) != -1;
        },
        isChooseable: function isChooseable(day) {
            // cannot choose in the past
            return day.date >= this.today;
        },
        isSelected: function isSelected(day) {
            return this.selection.indexOf(day.date) != -1;
        },
        isHighlighted: function isHighlighted(day) {
            return this.highlight.indexOf(day.date) != -1;
        },
        resetSelection: function resetSelection() {
            this.selection = [];
        },
        select: function select($event, day) {
            this.mousedown = true;

            if (this.mode === 'readonly') {
                // if readonly, just handle single click callback
                if (typeof this.callback == 'function') this.callback(day.date);
                return;
            }

            if (this.isBlocked(day)) return;

            var selected = this.isSelected(day);
            this.selectAction = selected ? 'deselect' : 'select';

            if (this.mode === 'single') {
                if (!this.first && !this.last) {
                    if (this.selection.length > 0) this.resetSelection();

                    this.first = day.date;
                    this.add(day);
                } else {
                    if (this.first && !this.last) {
                        if (day.date <= this.first) {
                            this.resetSelection();

                            if (day.date === this.first) return this.first = null;

                            this.add(day);
                            this.first = day.date;
                        } else {
                            this.markRange(day);
                        }
                    }
                }
            } else if (this.mode === 'range') {
                if (this.range === 'day') {
                    this.resetSelection();
                    this.add(day);
                    this.first = day.date;
                }

                if (this.range === 'week') {
                    this.resetSelection();
                    this.first = moment(day.date, 'YYYY-MM-DD').startOf('week').format('YYYY-MM-DD');
                    this.last = moment(day.date, 'YYYY-MM-DD').endOf('week').format('YYYY-MM-DD');
                    this.markRange();
                }

                if (this.range === 'month') {
                    this.resetSelection();
                    this.first = moment(day.date, 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD');
                    this.last = moment(day.date, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD');
                    this.markRange();
                }
            } else {
                if (selected && !this.first) {
                    this.remove(day);
                    return;
                }

                if (this.first && this.last) {
                    this.first = null;
                    this.last = null;
                }

                if ($event.altKey) {
                    selected ? this.remove(day) : this.add(day);

                    this.first = null;
                    this.last = null;

                    return;
                }

                if (!this.first && !this.last) {
                    this.first = day.date;
                    this.add(day);
                } else if (this.first && !this.last) {
                    if (day.date < this.first) {
                        // remove first date
                        this.remove({ date: this.first });

                        // replace first date
                        this.first = day.date;
                        this.add(day);
                        return;
                    }

                    this.markRange(day);
                }
            }

            this.handleCallback();
        },
        markRange: function markRange(endDay) {
            if (typeof endDay !== 'undefined') this.last = endDay.date;

            var startDate = moment(this.first);
            var endDate = moment(this.last);

            while (startDate.isBefore(endDate) || startDate.isSame(endDate)) {
                this.add({ date: startDate.format('YYYY-MM-DD') });
                startDate.add(1, 'days');
            }

            this.first = null;
            this.last = null;
        },
        dragSelect: function dragSelect(day) {
            if (this.mode === 'range' || this.mode === 'readonly') return;

            this.hovered = day.date;

            if (!this.mousedown || this.mode !== 'multi') return;

            // if (this.period && ! this.last) return;

            if (this.isBlocked(day)) return;

            if (this.selectAction == 'select') {
                this.add(day);

                this.last = day.date;
            } else {
                this.remove(day);
            }

            this.handleCallback();
        },
        add: function add(day) {
            if (this.selection.indexOf(day.date) == -1) {
                this.selection.push(day.date);
                this.selection.sort();
            }
        },
        remove: function remove(day) {
            var key = this.selection.indexOf(day.date);

            if (key != -1) this.selection.splice(key, 1);
        },
        doneSelecting: function doneSelecting() {
            this.mousedown = false;
            this.hovered = null;
        },
        handleCallback: function handleCallback() {
            if (typeof this.callback == 'function') this.callback(this.selection);
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.close');
        },
        keyHandler: function keyHandler(e) {
            if (e.type == 'keydown' && e.keyCode == 27 && this.first && !this.last) {
                // remove first date
                this.remove({ date: this.first });

                this.first = null;
            }

            if (e.keyCode == 18) {
                this.altKey = e.type == 'keydown' ? true : false;
            }
        }
    },

    watch: {
        selected: {
            handler: function handler(val) {
                this.selection = val;
                this.first = val[0];

                if (this.mode != 'readonly') this.gotoDate(this.first);
            }
        }
    }
});

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-calendar module-calendar--dates",
    on: {
      "mouseup": _vm.doneSelecting,
      "mouseleave": _vm.doneSelecting
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', [_c('action', {
    attrs: {
      "icon": "prev",
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prevMonth.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.gotoToday
    }
  }, [_vm._v(_vm._s(_vm.headline))]), _vm._v(" "), _c('div', [_c('action', {
    attrs: {
      "icon": "next",
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextMonth.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.mon')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.tue')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.wed')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.thu')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.fri')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.sat')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('layout.calendar.sun')))])]), _vm._v(" "), _vm._l((_vm.calendar), function(days, week) {
    return _c('tr', _vm._l((_vm.sortDays(days)), function(day) {
      return _c('td', {
        class: _vm.getClasses(day),
        on: {
          "mousedown": function($event) {
            $event.stopPropagation();
            return _vm.select($event, day)
          },
          "mouseenter": function($event) {
            return _vm.dragSelect(day)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(day.day))])])
    }), 0)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Dropdown',

    data: function data() {
        return {
            open: false,
            selected: '',
            style: 'dropdown--framed'
        };
    },


    props: {
        items: {
            type: [Object, Array],
            default: []
        },

        select: {
            type: [String, Number, Date],
            default: null
        },

        noBorder: {
            type: Boolean,
            default: false
        },

        label: {
            type: [String, Number, Date]
        },

        grouped: {
            type: Boolean,
            default: false
        },

        focus: {
            type: [Function, Boolean],
            default: false
        },

        blur: {
            type: [Function, Boolean],
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        },

        defaultValue: {
            type: String,
            default: '—'
        },

        keepDefault: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        showDefault: function showDefault() {
            var _this = this;

            if (this.defaultValue && this.keepDefault) return true;
            return this.selected == null && typeof _.find(this.items, function (item) {
                return item == _this.defaultValue;
            }) == 'undefined';
        },
        classObject: function classObject() {
            var _class = {};

            if (this.open) _class['is-open'] = true;

            if (this.disabled) _class['disabled'] = true;

            if (this.style !== '' && !this.noBorder) _class[this.style] = true;

            return _class;
        },
        display: function display() {
            if (this.grouped) {
                for (var i in this.items) {
                    var label = _.find(this.items[i], { value: this.select });
                    if (label) return label.label || this.defaultValue;
                }
            } else {
                return this.items[this.select] || this.defaultValue;
            }
        }
    },

    methods: {
        /**
         * Select item
         *
         * @param key, key of selected item
         * @param {Boolean} silent, if event should be send or not
         */
        selectItem: function selectItem(key, silent) {
            this.$emit('changed', key);
        },


        /**
         * Close dropdown
         */
        closeEsc: function closeEsc(e) {
            if (e.keyCode == 27) this.toggle();
        },


        /**
         * Toggle open state
         */
        toggle: function toggle() {
            this.open = !this.open;

            if (this.open) {
                window.addEventListener('keyup', this.closeEsc, false);
            } else {
                window.removeEventListener('keyup', this.closeEsc, false);
            }
        },
        focusHandler: function focusHandler() {
            typeof this.focus === 'function' ? this.focus() : null;
        },
        blurHandler: function blurHandler() {
            typeof this.blur === 'function' ? this.blur() : null;
        }
    },

    watch: {
        select: {
            handler: function handler(val, oldVal) {
                this.selected = val;
            },


            immediate: true
        }
    }
});

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown",
    class: _vm.classObject
  }, [(_vm.label) ? _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', [_c('icon', {
    attrs: {
      "name": "chevron_down",
      "viewBox": "0 0 24 24"
    }
  }), _vm._v("\n\n        " + _vm._s(_vm.display) + "\n\n        "), (!_vm.grouped) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectItem(_vm.selected)
      }],
      "focus": _vm.focusHandler,
      "blur": _vm.blurHandler
    }
  }, [(_vm.showDefault) ? _c('option', {
    attrs: {
      "disabled": !_vm.keepDefault
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.defaultValue))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(label, val) {
    return _c('option', {
      domProps: {
        "value": val
      }
    }, [_vm._v(_vm._s(label))])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectItem(_vm.selected)
      }],
      "focus": _vm.focusHandler,
      "blur": _vm.blurHandler
    }
  }, _vm._l((_vm.items), function(options, key) {
    return _c('optgroup', {
      attrs: {
        "label": key
      }
    }, _vm._l((options), function(option) {
      return _c('option', {
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.label))])
    }), 0)
  }), 0)], 1)])
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Error',

    props: {
        message: {
            required: false,
            type: String
        }
    },

    computed: {
        hasError: function hasError() {
            return this.message != '';
        }
    }
});

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.hasError) ? _c('div', {
    staticClass: "hint error"
  }, [_vm._v("\n        " + _vm._s(_vm.message) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_events__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FooterBar',

    mounted: function mounted() {
        this.captureSave();
    },
    destroyed: function destroyed() {
        this.$store.dispatch('layout/hideFooterBar');
    },


    methods: {
        // Add ctrl + s shortcut
        captureSave: function captureSave() {
            var _this = this;

            document.addEventListener('keydown', function (e) {
                if (_this.hasFooterBar && (window.navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey) && e.keyCode === 83) {
                    e.preventDefault();
                    _this.$emit('submit');
                }
            }, false);
        },
        emitSubmitWithDate: function emitSubmitWithDate() {
            __WEBPACK_IMPORTED_MODULE_2__events_events__["a" /* default */].$emit('submitWithDate');
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        hasFooterBar: function hasFooterBar(_ref) {
            var layout = _ref.layout;
            return layout.hasFooterBar;
        }
    }))
});

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "bounce-up"
    }
  }, [(_vm.hasFooterBar) ? _c('footer', {
    staticClass: "footer-bar"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('layout.footer.info')))]), _vm._v(" "), _c('action', {
    attrs: {
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('reset')
      }
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.$t('layout.footer.cancel')))])]), _vm._v(" "), (_vm.$route.name === 'team.edit') ? _c('action', {
    attrs: {
      "color": "orange"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitSubmitWithDate.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('layout.footer.saveWithDate')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('action', {
    attrs: {
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('submit')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('layout.footer.save')) + "\n        ")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blueimp_md5__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_no_gravatar_jpg__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_no_gravatar_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_no_gravatar_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Gravatar',

    data: function data() {
        return {
            image: __WEBPACK_IMPORTED_MODULE_1__assets_img_no_gravatar_jpg___default.a
        };
    },


    props: {
        email: '',
        local: {
            default: false
        },

        user: {
            default: false
        }
    },

    created: function created() {
        this.getGravatar(this.email);
    },


    methods: {
        /**
         * Get the gravatar from provider
         *
         * @param {String} email
         * @returns {string}
         */
        getGravatar: function getGravatar(email) {
            var _this = this;

            var url = '/api/gravatar';

            if (this.user) url += '/' + this.user + '/user';

            if (this.local) {
                this.$http.get(url, { responseType: 'arraybuffer' }).then(function (response) {
                    if (response.status === 200) {
                        var image = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
                            return data + String.fromCharCode(byte);
                        }, ''));

                        _this.imgLoaded();

                        return _this.image = 'data:' + response.headers['content-type'].toLowerCase() + ';base64,' + image;
                    }

                    _this.imgLoaded();

                    return _this.image = __WEBPACK_IMPORTED_MODULE_1__assets_img_no_gravatar_jpg___default.a;
                });
            } else {
                var user = email || '',
                    hash = __WEBPACK_IMPORTED_MODULE_0_blueimp_md5___default()(user.trim().toLowerCase());

                this.imgLoaded();

                return this.image = '//www.gravatar.com/avatar/' + hash + '?d=mm';
            }
        },
        imgLoaded: function imgLoaded() {
            this.$emit('loaded', true);
        }
    }
});

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD//gA7Q1JFQVRPUjogZ2QtanBlZyB2MS4wICh1c2luZyBJSkcgSlBFRyB2NjIpLCBxdWFsaXR5ID0gOTAK/9sAQwADAgIDAgIDAwMDBAMDBAUIBQUEBAUKBwcGCAwKDAwLCgsLDQ4SEA0OEQ4LCxAWEBETFBUVFQwPFxgWFBgSFBUU/9sAQwEDBAQFBAUJBQUJFA0LDRQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQU/8AAEQgAUABQAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/aAAwDAQACEQMRAD8A+t+KKPxo/GgA70Yo/Gj8aADFH4VesdC1HUl3WtjcXCf344yV/PGKW+0HUtNXddWNzbp/fkjIX88YoAofhR+FH40fjQAfhR+FH40fjQAUUUUAFepeAPh5D9li1LVYhK8g3Q27j5VXszDuT6f5HA+FtOXVvEWn2rjMcko3j1UckfkDX0MBgYHAoARVCKFUBVHAA6ClZQwKkZBGCDS0UAec+Pvh3BJay6lpUQimjBeW3QYVx3Kjsfbv/PyqvpuvnvxfpqaT4l1C1QbY0lJUDsrfMB+RoAyKKKKACiiigDa8GXq6f4p02eQgIJQpJ7Bvlz+tfQP4V8yDg17P4A8cw65ZxWV5IE1KMbfmP+uA7j39R+NAHaUfhSUUAL+FeA+OL1NQ8WalNGQU83YCO+0Bf6V6b498cQ6BZyWlrIJNSkXaApz5QP8AEff0FeKk5OTyTQAUUUUAH40fjRU1naTX93DbQIXmlYIijuTQBc0Dw/eeI74W1mm49XkbhUHqTXsHhz4eaXoCpI8YvbscmaYZAP8Asr0H8/etHwv4cg8M6XHaxANIfmllxy7dz9PStigA/Gk/GlooA5bxJ8PdL19XkWMWd43PnwjGT/tL0P8AP3rx/X/D954cvjbXibT1SReVceoNfRFZHijw5B4m0uS1lAWQfNFLjlG7H6etAHz5+NH41NeWk1hdzW06FJonKMp7EGoaACvQfhBowudTudRkXK2y7I8j+Nup/Afzrz6vafhRaCDwmkgHM8zufwO3/wBloA7Kiij8KACkpaSgBaSj8KKAPJvi/owttTttRjXC3K7JMf3l6H8R/KvPq9p+K1qJ/CbyEcwTI4P1O3/2avFqAP/Z"

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "gravatar",
    class: {
      'gravatar-x2': _vm.local
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blueimp_md5__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_blueimp_md5__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'GravatarGroup',

    props: {
        emails: ''
    },

    methods: {
        /**
         * Get the gravatar from provider
         *
         * @param {String} email
         * @returns {string}
         */
        getGravatar: function getGravatar(email) {
            var user = email || '',
                hash = __WEBPACK_IMPORTED_MODULE_0_blueimp_md5___default()(user.trim().toLowerCase());

            return '//www.gravatar.com/avatar/' + hash + '?d=mm';
        },
        imgLoaded: function imgLoaded() {
            this.$emit('loaded', true);
        }
    }
});

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "gravatar-group"
  }, _vm._l(((Math.min(4, _vm.emails.length))), function(i) {
    return _c('img', {
      attrs: {
        "src": _vm.getGravatar(_vm.emails[i - 1])
      },
      on: {
        "load": _vm.imgLoaded
      }
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 *  Inject svg from sprite, based on name (svg-filename)
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Icon',

    props: {
        'name': { type: String, required: true },
        'viewBox': { type: String },
        'titleTag': { type: String }
    },

    computed: {
        reference: function reference() {
            return '#' + this.name;
        }
    }
});

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: 'icon ico-' + _vm.name,
    attrs: {
      "viewBox": _vm.viewBox || '0 0 100 100'
    }
  }, [(_vm.titleTag) ? _c('title', [_vm._v(_vm._s(_vm.titleTag))]) : _vm._e(), _vm._v(" "), _c('use', {
    attrs: {
      "xlink:href": _vm.reference
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_Chatbox__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_Chatbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_Chatbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_hours_shared__ = __webpack_require__(332);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ItemChatbox',

    extends: __WEBPACK_IMPORTED_MODULE_1__components_global_Chatbox___default.a,

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_3__pages_hours_shared__["a" /* default */].state
        };
    },


    computed: {
        placeholder: function placeholder() {
            return this.$t('page.hours.comment');
        }
    },

    methods: {
        getComments: function getComments() {
            return __WEBPACK_IMPORTED_MODULE_3__pages_hours_shared__["a" /* default */].getComments(this.payload);
        },
        deleteComment: function deleteComment(id) {
            var _this = this;

            this.$http.delete('/api/item/messages/' + id).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_3__pages_hours_shared__["a" /* default */].removeComment(id);
                _this.scrollToBottom();
            });
        },
        submitMessage: function submitMessage(date) {
            var _this2 = this;

            if (!this.message) return;

            this.$http.post('/api/item/messages', {
                'item': this.payload,
                'message': this.message
            }).then(function (response) {
                _this2.message = '';
                _this2.shared.comments.push(response.data);
                _this2.scrollToBottom();

                // setTimeout(() => this.close(), 1000);
            });
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_2__events_events__["a" /* default */].$emit('toolbox.close');
        }
    }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MainContent',

    props: ['blank'],

    data: function data() {
        return {
            style: ''
        };
    },
    created: function created() {
        this.style = typeof this.blank == 'undefined' ? this.style : 'content-main--blank';
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        showContent: function showContent() {
            // Hide content if tabbed view with main content tab
            if (this.isMobile && this.mainContentTab) {
                return this.activeTab == 0;
            }

            return true;
        },


        // Is viewport in mobile mode
        isMobile: function isMobile() {
            return this.viewport != 'd' && this.viewport != 'tl';
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        viewport: function viewport(_ref) {
            var layout = _ref.layout;
            return layout.viewport;
        },
        activeTab: function activeTab(_ref2) {
            var sidebar = _ref2.sidebar;
            return sidebar.tab.activeTab;
        },
        mainContentTab: function mainContentTab(_ref3) {
            var sidebar = _ref3.sidebar;
            return sidebar.tab.mainContentTab;
        }
    }))
});

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showContent) ? _c('div', {
    staticClass: "content-main",
    class: _vm.style
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Notes',

    props: ['payload'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__["a" /* default */].state,
            notes: ''
        };
    },


    computed: {
        date: function date() {
            return this.payload;
        }
    },

    created: function created() {
        this.init();
    },


    watch: {
        payload: function payload() {
            this.init();
        }
    },

    methods: {
        init: function init() {
            this.notes = __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__["a" /* default */].getNotes(this.date);

            __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('tooltip.hide');
        },
        save: function save(remove) {
            var _this = this;

            var notes = remove ? '' : this.notes;

            this.$http.put('/api/locations/' + this.shared.location + '/notes/' + this.date, {
                content: notes
            }).then(function (response) {
                var key = _.findIndex(_this.shared.notes, { date: _this.date });

                if (key !== -1) {
                    if (!notes) {
                        _this.$delete(_this.shared.notes, key);
                    } else {
                        // replace item
                        _this.$set(_this.shared.notes, key, { date: _this.date, content: notes });
                    }
                } else if (notes) {
                    // add item
                    _this.shared.notes.push({ date: _this.date, content: notes });
                }

                _this.$tools.close();
            });
        },
        remove: function remove() {
            this.save(true); // remove
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('toolbox.close');
        },
        handleKeys: function handleKeys(e) {
            // no CTRL or CMD key pressed
            if (!(e.metaKey || e.ctrlKey)) return;

            var key = e.which || e.keyCode || 0;

            // select all (CTRL+A)
            if (key == 65) {
                // prevent roster items from being selected
                e.stopPropagation();
            }
        }
    }
});

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools",
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "tools-tab tools-tab-notes"
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.$t('tooltip.roster.notes')),
      expression: "$t('tooltip.roster.notes')"
    }],
    attrs: {
      "name": "info"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    attrs: {
      "placeholder": _vm.$t('tooltip.roster.notes'),
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "keydown": _vm.handleKeys,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.notes) ? _c('a', {
    staticClass: "remove btn btn--red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.remove()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.delete')))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn--green",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.save')))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['value'],

    data: function data() {
        return {
            internal: null
        };
    },
    mounted: function mounted() {
        this.internal = this.convertToDecimalString(this.value);
    },


    watch: {
        internal: function internal(val, old) {
            this.$emit('input', this.makeFloat(val));
        }
    },

    methods: {
        makeFloat: function makeFloat(value) {
            if (value == 0) return 0;
            if (value === null) return null;

            var float = value;

            float = float.toString();
            float = parseFloat(float.replace(',', '.').replace(' ', ''));

            if (!float || isNaN(float)) return null;

            return float;
        },
        convertToDecimalString: function convertToDecimalString(value) {
            var float = this.makeFloat(value);

            return float ? float.toFixed(2).replace('.', ',') : float;
        },
        blurEvent: function blurEvent() {
            this.internal = this.convertToDecimalString(this.internal);
        }
    }
});

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internal),
      expression: "internal"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.internal)
    },
    on: {
      "blur": _vm.blurEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.internal = $event.target.value
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Percents',

    props: {
        base: {
            type: [String]
        },

        compare: {
            type: [String]
        }
    },

    computed: {
        name: function name() {
            if (this.total === 1) return 'arrow-upward';
            if (this.total === -1) return 'arrow-downward';
        },
        total: function total() {
            if (parseFloat(this.base) > parseFloat(this.compare)) return 1;
            if (parseFloat(this.base) === parseFloat(this.compare)) return 0;
            if (parseFloat(this.base) < parseFloat(this.compare)) return -1;
        },
        percent: function percent() {
            if (this.compare === '0.00') return 0.00;
            return (parseFloat(this.base) - parseFloat(this.compare)) / Math.abs(parseFloat(this.compare)) * 100;
        }
    }
});

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.compare !== '0.00') ? _c('i', {
    staticClass: "percents",
    class: {
      positive: _vm.total >= 0,
        negative: _vm.total === -1
    }
  }, [(_vm.total !== 0) ? _c('icon', {
    attrs: {
      "name": _vm.name
    }
  }) : _vm._e(), _vm._v(" "), (_vm.total !== 0) ? [_vm._v(_vm._s(_vm._f("percentage")(_vm.percent)))] : [_vm._v("0%")]], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lists_labels__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lists_countries__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lists_insurances__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Profile',

    props: ['endpoint', 'profile', 'employee'],

    data: function data() {
        return {
            initialized: false,

            selection: {}, // stores v-select selection (object)
            uploads: {}, // stores uploaded files

            addDocument: false,
            addUpload: {},
            documentType: null, // the document type to be uploaded
            documentTypes: [],

            mobile: location.hostname.match('mobile') ? true : false,

            lists: {
                labels: __WEBPACK_IMPORTED_MODULE_5__lists_labels__["a" /* default */],
                countries: __WEBPACK_IMPORTED_MODULE_6__lists_countries__["a" /* default */],
                insurances: __WEBPACK_IMPORTED_MODULE_7__lists_insurances__["a" /* default */]
            }
        };
    },
    created: function created() {
        var _this = this;

        this.initialize();

        __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('profile.changed', this.changed.length);
        __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('profile.remaining', this.remaining.length);
        __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('profile.filled', this.filled.length);

        __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$listen('profile.submit', this.submitForm);
        __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$listen('profile.reset', this.resetForm);
        __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$listen('submitWithDate', function () {
            return _this.submitForm('date');
        });
    },


    watch: {
        filled: function filled(val) {
            __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('profile.filled', val.length);
        },
        remaining: function remaining(val) {
            __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('profile.remaining', val.length);
        },
        changed: function changed(val) {
            __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('profile.changed', val.length);

            if (val.length) {
                this.$store.dispatch('layout/showFooterBar');
            } else {
                this.$store.dispatch('layout/hideFooterBar');
            }
        },


        isFreelancer: {
            immediate: true,
            handler: function handler(newValue) {
                this.profile.values['is_freelancer'] = newValue;
                this.profile.values['auto_invoice'] = this.profile.data['auto_invoice'];
                this.profile.values['vat_shifted'] = this.profile.data['vat_shifted'];
                this.profile.values['business_number'] = this.profile.data['business_number'];
                this.profile.values['vat_number'] = this.profile.data['vat_number'];
                this.profile.values['iban'] = this.profile.data['iban'];
            }
        }

    },

    computed: {
        isFreelancer: function isFreelancer() {
            return this.employee.roles.includes('freelancer');
        },
        Vue: function Vue() {
            return __WEBPACK_IMPORTED_MODULE_8_vue__["default"];
        },
        isManager: function isManager() {
            return this.$onduro.hasRole('manager') && this.$route.name != 'profile';
        },
        fields: function fields() {
            return _.keyBy(_.flatten(_.map(this.profile.template, 'fields')), 'id');
        },
        required: function required() {
            var _this2 = this;

            return _.filter(this.fields, function (field) {
                return _this2.isRequired(field);
            });
        },
        remaining: function remaining() {
            var _this3 = this;

            return _.filter(this.required, function (field) {
                // only empty string, null or undefined is considered empty
                // boolean (false) or integer 0 might be valid values
                var empty = _.isNil(_this3.profile.values[field.id]) || _this3.profile.values[field.id] === '';

                if (field.type == 'upload') {
                    empty = !_this3.isUploaded(field.id);
                }

                return _this3.isRequired(field) && empty;
            });
        },
        filled: function filled() {
            return _.difference(this.required, this.remaining);
        },
        changed: function changed() {
            var _this4 = this;

            var changed = [];

            _.forEach(this.fields, function (field) {
                // stringify in order to make valid comparison of observed objects
                if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this4.profile.values[field.id]) != __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this4.getDefaultValue(field))) changed.push(field.id);
            });

            return changed;
        },


        // get "hr_..." documents
        hrDocuments: function hrDocuments() {
            return _.pickBy(this.uploads, function (files, key) {
                return key.indexOf('hr_') === 0;
            });
        }
    },

    methods: {
        initialize: function initialize() {
            // make sure profile is loaded
            if (_.size(this.profile)) {
                this.setDefaults();

                this.documentTypes = this.profile.documentTypes;

                // prevent multiple initializations
                this.initialized = true;
            }
        },
        getClasses: function getClasses(field) {
            return ['row', field.class || null, this.isRequired(field) ? 'required' : null, this.isRequiredForEmployee(field) ? 'required-employee' : null, this.isPristine(field) ? 'pristine' : null, field.left || field.type != 'checkbox' && this.label(field).length > 30 ? 'row--left' : null // move label to left if it's too long
            ];
        },
        resetForm: function resetForm() {
            this.setDefaults();
        },
        updateDate: function updateDate(date, id) {
            this.$set(this.profile.values, id, date);
        },
        isUploaded: function isUploaded(key) {
            return this.uploads[key] ? true : false;
        },
        downloadFile: function downloadFile(key) {
            var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            window.location.href = '/api/uploads/' + this.uploads[key][index].id + '?token=' + this.$store.state.auth.token;
        },
        uploadFile: function uploadFile(e, field) {
            var _this5 = this;

            if (!this.profile.membership) {
                this.$notify.error();
                return;
            }

            var files = e.target.files || e.dataTransfer.files;

            if (!files.length) return;

            this.errorUpload = false;
            this.processing = true;

            var reader = new FileReader();
            reader.readAsDataURL(files[0]);

            var formData = new FormData();

            if (field === 'document') {
                formData.append('key', this.documentType);
                formData.append('type', 'hr');
            } else {
                formData.append('key', field.id);
            }

            formData.append('file', files[0]);

            this.$http.post('/api/memberships/' + this.profile.membership + '/upload', formData).then(function (response) {
                if (!_this5.uploads[response.data.key]) {
                    _this5.$set(_this5.uploads, response.data.key, []);
                }

                _this5.uploads[response.data.key].push(response.data);

                _this5.documentType = null;
                _this5.addDocument = false;
                _this5.$set(_this5.addUpload, field.id, false);
            }).catch(function (error) {
                if (error.response.status == 413) {
                    _this5.$notify.error(_this5.$t('error.general.title'), _this5.$t('error.413'));
                } else {
                    // file upload failed
                    _this5.$notify.error();
                }
            });
        },
        deleteUpload: function deleteUpload(key) {
            var _this6 = this;

            var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            this.$http.delete('/api/uploads/' + this.uploads[key][index].id).then(function (response) {
                // remove from uploads
                _this6.$delete(_this6.uploads[key], index);

                if (_this6.uploads[key].length === 0) {
                    _this6.$delete(_this6.uploads, key);
                }
            }).catch(function (error) {
                // file deletion failed
                _this6.$notify.error();
            });
        },
        submitForm: function submitForm() {
            var _this7 = this;

            var button = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

            // if (this.profile.values['is_freelancer']) {
            //     this.profile.values['freelancer'] = {
            //         business_number: this.profile.values['business_number'],
            //         vat_number: this.profile.values['vat_number'],
            //         auto_invoice: this.profile.values['auto_invoice'],
            //         iban: this.profile.values['iban']
            //     };
            // }

            var endpoint = this.endpoint ? this.endpoint : '/api/memberships/' + this.profile.membership + '/profile';

            if (button == 'date') {
                this.$confirm.show(this.$t('page.profile.apply_from.headlin'), '<p>' + this.$t("page.profile.apply_from.text") + '</p><label>' + this.$t("page.profile.apply_from.label") + ':<input type="date" id="apply_from" /></label>', {
                    confirm: function confirm() {
                        var input = document.getElementById('apply_from');
                        var date = input ? input.value : null;

                        if (date) {
                            _this7.profile.values.apply_from = date;
                        }

                        _this7.$http.put(endpoint, _this7.profile.values).then(function (response) {
                            _this7.profile.data = _this7.$onduro.untrack(_this7.profile.values);
                            __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('profile.stored', response.data);
                            _this7.$v.resetErrors();
                            _this7.$notify.success();
                        }).catch(function (error) {
                            if (error.response.status == 422 && error.response.data) {
                                _this7.$notify.error(_this7.$t('error.general.invalid'), _this7.$t('error.general.check'));
                                _this7.$v.setErrors(error.response.data);
                            }
                        });
                    }
                }, {
                    confirm: this.$t('common.button.save'),
                    decline: this.$t('common.button.cancel')
                }, true);
            } else {
                this.$http.put(endpoint, this.profile.values).then(function (response) {
                    _this7.profile.data = _this7.$onduro.untrack(_this7.profile.values);
                    __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('profile.stored', response.data);
                    _this7.$v.resetErrors();
                    _this7.$notify.success();
                }).catch(function (error) {
                    if (error.response.status == 422 && error.response.data) {
                        _this7.$notify.error(_this7.$t('error.general.invalid'), _this7.$t('error.general.check'));
                        _this7.$v.setErrors(error.response.data);
                    }
                });
            }
        },
        setDefaults: function setDefaults() {
            var _this8 = this;

            _.forEach(this.fields, function (field) {
                _this8.$set(_this8.profile.values, field.id, _this8.getDefaultValue(field));

                if (field.type == 'auto') {
                    // set selection object
                    _this8.selection[field.id] = _this8.getSelection(field);
                }
            });

            this.uploads = this.profile.uploads;
        },
        hasFields: function hasFields(fieldset) {
            var _this9 = this;

            var visible = 0;

            _.forEach(fieldset.fields, function (field) {
                if (_this9.showField(field)) visible += 1;
            });

            return _.size(fieldset.fields) && visible; // minimum 1 visible field
        },
        label: function label(field) {
            if (field.label) return field.label[this.$lang];
            return this.lists.labels[this.$lang][field.id] || '';
        },
        condition: function condition(field) {
            var _this10 = this;

            if (_.isArray(field.if)) {
                var allConditionsMet = true;

                // multiple conditions
                _.forEach(field.if, function (condition) {
                    var fieldCopy = _.clone(field);

                    // set current condition as condition
                    fieldCopy.if = condition;

                    if (!_this10.condition(fieldCopy)) allConditionsMet = false;
                });

                return allConditionsMet;
            }

            switch (field.if.condition) {
                case '!=':
                case '<>':
                    return this.profile.values[field.if.field] != field.if.value;
                    break;

                case '<':
                    return this.profile.values[field.if.field] < field.if.value;
                    break;

                case '>':
                    return this.profile.values[field.if.field] > field.if.value;
                    break;

                case '<=':
                    return this.profile.values[field.if.field] <= field.if.value;
                    break;

                case '>=':
                    return this.profile.values[field.if.field] >= field.if.value;
                    break;

                case 'in':
                    if (!this.profile.values[field.if.field]) return false;
                    return field.if.value.indexOf(this.profile.values[field.if.field]) != -1;
                    break;

                case 'not_in':
                    if (!this.profile.values[field.if.field]) return false;
                    return field.if.value.includes(this.profile.values[field.if.field]) ? false : true;
                    break;

                case 'exists':
                    if (this.profile.values[field.if.field]) return true;
                    break;

                case 'empty':
                    if (!this.profile.values[field.if.field]) return true;
                    break;

                case 'after_brexit':
                    if (this.profile.values['nationality'] != 'gb') return true;

                    if (this.profile.values[field.if.field] && this.profile.values[field.if.field] >= '2021-01-01') return true;

                    return false;
                    break;

                default:
                    return this.profile.values[field.if.field] == field.if.value;
            }

            return false;
        },
        showField: function showField(field) {
            if (!this.may(field.id, 'read')) return false;
            if (!field.if || field.show) return true;

            return this.condition(field);
        },
        may: function may(id, action) {
            return this.fields[id].rights[action];
        },
        isLockable: function isLockable(field) {
            return inArray(field.id, ['fname', 'mname', 'lname_suffix', 'lname', 'email', 'address', 'address_extra', 'zip', 'city', 'phone', 'mobile', 'fax']);
        },
        isPristine: function isPristine(field) {
            // field is not pristine, if filled
            if (this.profile.values[field.id] && this.profile.values[field.id] !== null) return false;

            if (field.type == 'upload') {
                if (this.isUploaded(field.id)) return false;
            }

            // otherwise it is pristine, if default is empty string or null
            return this.profile.values[field.id] === '' || this.profile.values[field.id] === null || typeof this.profile.values[field.id] === 'undefined';
        },
        isReadonly: function isReadonly(field) {
            if (field.id == 'personal_note' && !this.may(field.id, 'update')) {
                return true;
            }

            return false;
        },
        isDisabled: function isDisabled(field) {
            if (field.id == 'personal_note') return false;

            // do not allow to change e-mail adress in profile if employee has access
            if (field.id == 'email' && this.employee && this.employee.access == 'yes' && this.$current.membership.id != this.profile.membership) {
                return true;
            }

            // has data been stored before?
            if (!this.profile.data[field.id] || this.profile.data[field.id] === null) {
                // disable, if user may not create
                return !this.may(field.id, 'create');
            }

            // allow to 'update' already populated name fields if user is not locked
            if (this.employee && !this.employee.locked && this.isLockable(field) && this.may(field.id, 'update')) {
                return false;
            }

            // this is user's own profile
            if (this.$current.membership.id == this.profile.membership && inArray(field.id, ['fname', 'lname', 'email', 'birthday'])) {
                return false;
            }

            // allow to update if user has no access
            if (this.employee.access == 'no') {
                return false;
            }

            // otherwise disable, if user may not update
            return !this.may(field.id, 'update');
        },
        isRequired: function isRequired(field) {
            var req = field.required_if && this.condition(field) ? field.required_if : field.required;

            if (this.isManager) {
                // required fields for employer
                return req.employer && this.showField(field) && !this.isDisabled(field);
            }

            // required fields for employee
            return this.isRequiredForEmployee(field);
        },
        isRequiredForEmployee: function isRequiredForEmployee(field) {
            var req = field.required_if && this.condition(field) ? field.required_if : field.required;

            return (req.employer || req.employee) && this.showField(field) && !this.isDisabled(field);
        },
        showLabel: function showLabel(field) {
            return ['select', 'country', 'checkbox'].indexOf(field.type) == -1;
        },
        getDefaultValue: function getDefaultValue(field) {
            if (this.profile.data[field.id] != null) return this.profile.data[field.id];
            if (field.default != null) return field.default;
            return null;
        },
        getSelectedValue: function getSelectedValue(field) {
            return this.getOptions(field)[this.profile.values[field.id]];
        },
        getOptions: function getOptions(field) {
            if (_.isString(field.options)) {
                // For birth_country field, translate country names based on current language
                if (field.id === 'birth_country' && field.options === 'countries' || field.id === 'country' && field.options === 'countries') {
                    return this.getTranslatedCountries();
                }
                return this.lists[field.options];
            } else {
                return field.options;
            }
        },
        getTranslatedCountries: function getTranslatedCountries() {
            // Get countries list
            var countriesList = this.lists.countries;

            // If current language is English, return the original list
            if (this.$lang === 'en') {
                return countriesList;
            }

            // For other languages, try to translate country names using i18n
            var translatedCountries = {};

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(countriesList)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref = _step.value;

                    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

                    var code = _ref2[0];
                    var name = _ref2[1];

                    // Try to get translation from i18n
                    var translationKey = 'common.countries.' + code;
                    var translation = this.$t(translationKey);

                    // If translation exists and is not the same as the key, use it
                    if (translation !== translationKey) {
                        translatedCountries[code] = translation;
                    } else {
                        // Fallback to original name
                        translatedCountries[code] = name;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return translatedCountries;
        },
        setValue: function setValue(field) {
            this.profile.values[field.id] = this.selection[field.id] ? this.selection[field.id].value : null;
        },
        getSelection: function getSelection(field) {
            return _.find(this.getCollection(field), { value: this.profile.values[field.id] });
        },
        getCollection: function getCollection(field) {
            var collection = [];

            _.forEach(this.getOptions(field), function (val, key) {
                collection.push({
                    label: val,
                    value: key
                });
            });

            collection = _.sortBy(collection, 'label');

            var selection = _.find(collection, { value: this.profile.values[field.id] });

            return _.differenceBy(collection, selection, 'value');
        },
        getDocumentKey: function getDocumentKey(groupKey, docKey) {
            return 'hr_' + groupKey + '-' + docKey;
        },
        getDocumentGroup: function getDocumentGroup(input) {
            if (!input) return input;

            var keys = input.replace('hr_', '').split('-');

            return _.find(this.documentTypes, function (group) {
                return group.key == keys[0];
            }).label;
        },
        getDocumentValue: function getDocumentValue(input) {
            if (!input) return input;

            var keys = input.replace('hr_', '').split('-');

            var group = _.find(this.documentTypes, function (group) {
                return group.key == keys[0];
            });

            return group ? _.find(group.documents, function (doc) {
                return doc.key == keys[1];
            }).label : '';
        },
        cancelDocumentUpload: function cancelDocumentUpload() {
            this.documentType = null;
            this.addDocument = false;
            this.addUpload = {};
        },
        updateAutoInvoice: function updateAutoInvoice(event) {
            this.profile.values.auto_invoice = event.target.checked;
        },
        updateShiftVat: function updateShiftVat(event) {
            this.profile.values.vat_shifted = event.target.checked;
        }
    }
});

/***/ }),
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var countries = { "af": "Afghanistan", "ax": "Åland Islands", "al": "Albania", "dz": "Algeria", "as": "American Samoa", "ad": "Andorra", "ao": "Angola", "ai": "Anguilla", "aq": "Antarctica", "ag": "Antigua and Barbuda", "ar": "Argentina", "am": "Armenia", "aw": "Aruba", "au": "Australia", "at": "Austria", "az": "Azerbaijan", "bs": "Bahamas", "bh": "Bahrain", "bd": "Bangladesh", "bb": "Barbados", "by": "Belarus", "be": "Belgium", "bz": "Belize", "bj": "Benin", "bm": "Bermuda", "bt": "Bhutan", "bo": "Bolivia", "ba": "Bosnia and Herzegovina", "bw": "Botswana", "bv": "Bouvet Island", "br": "Brazil", "io": "British Indian Ocean Territory", "bn": "Brunei Darussalam", "bg": "Bulgaria", "bf": "Burkina Faso", "bi": "Burundi", "kh": "Cambodia", "cm": "Cameroon", "ca": "Canada", "cv": "Cape Verde", "ky": "Cayman Islands", "cf": "Central African Republic", "td": "Chad", "cl": "Chile", "cn": "China", "cx": "Christmas Island", "cc": "Cocos (Keeling) Islands", "co": "Colombia", "km": "Comoros", "cg": "Congo", "cd": "Congo, The Democratic Republic of the", "ck": "Cook Islands", "cr": "Costa Rica", "ci": "Cote D'Ivoire", "hr": "Croatia", "cu": "Cuba", "cy": "Cyprus", "cz": "Czech Republic", "dk": "Denmark", "dj": "Djibouti", "dm": "Dominica", "do": "Dominican Republic", "ec": "Ecuador", "eg": "Egypt", "sv": "El Salvador", "gq": "Equatorial Guinea", "er": "Eritrea", "ee": "Estonia", "et": "Ethiopia", "fk": "Falkland Islands (Malvinas)", "fo": "Faroe Islands", "fj": "Fiji", "fi": "Finland", "fr": "France", "gf": "French Guiana", "pf": "French Polynesia", "tf": "French Southern Territories", "ga": "Gabon", "gm": "Gambia", "ge": "Georgia", "de": "Germany", "gh": "Ghana", "gi": "Gibraltar", "gr": "Greece", "gl": "Greenland", "gd": "Grenada", "gp": "Guadeloupe", "gu": "Guam", "gt": "Guatemala", "gg": "Guernsey", "gn": "Guinea", "gw": "Guinea-Bissau", "gy": "Guyana", "ht": "Haiti", "hm": "Heard Island and Mcdonald Islands", "va": "Holy See (Vatican City State)", "hn": "Honduras", "hk": "Hong Kong", "hu": "Hungary", "is": "Iceland", "in": "India", "id": "Indonesia", "ir": "Iran, Islamic Republic Of", "iq": "Iraq", "ie": "Ireland", "im": "Isle of Man", "il": "Israel", "it": "Italy", "jm": "Jamaica", "jp": "Japan", "je": "Jersey", "jo": "Jordan", "kz": "Kazakhstan", "ke": "Kenya", "ki": "Kiribati", "kp": "Korea, Democratic People's Republic of", "kr": "Korea, Republic of", "kw": "Kuwait", "kg": "Kyrgyzstan", "la": "Lao People's Democratic Republic", "lv": "Latvia", "lb": "Lebanon", "ls": "Lesotho", "lr": "Liberia", "ly": "Libyan Arab Jamahiriya", "li": "Liechtenstein", "lt": "Lithuania", "lu": "Luxembourg", "mo": "Macao", "mk": "Macedonia, The Former Yugoslav Republic of", "mg": "Madagascar", "mw": "Malawi", "my": "Malaysia", "mv": "Maldives", "ml": "Mali", "mt": "Malta", "mh": "Marshall Islands", "mq": "Martinique", "mr": "Mauritania", "mu": "Mauritius", "yt": "Mayotte", "mx": "Mexico", "fm": "Micronesia, Federated States of", "md": "Moldova, Republic of", "mc": "Monaco", "mn": "Mongolia", "ms": "Montserrat", "ma": "Morocco", "mz": "Mozambique", "mm": "Myanmar", "na": "Namibia", "nr": "Nauru", "np": "Nepal", "nl": "Netherlands", "an": "Netherlands Antilles", "nc": "New Caledonia", "nz": "New Zealand", "ni": "Nicaragua", "ne": "Niger", "ng": "Nigeria", "nu": "Niue", "nf": "Norfolk Island", "mp": "Northern Mariana Islands", "no": "Norway", "om": "Oman", "pk": "Pakistan", "pw": "Palau", "ps": "Palestinian Territory, Occupied", "pa": "Panama", "pg": "Papua New Guinea", "py": "Paraguay", "pe": "Peru", "ph": "Philippines", "pn": "Pitcairn", "pl": "Poland", "pt": "Portugal", "pr": "Puerto Rico", "qa": "Qatar", "re": "Reunion", "ro": "Romania", "ru": "Russian Federation", "rw": "RWANDA", "sh": "Saint Helena", "kn": "Saint Kitts and Nevis", "lc": "Saint Lucia", "pm": "Saint Pierre and Miquelon", "vc": "Saint Vincent and the Grenadines", "ws": "Samoa", "sm": "San Marino", "st": "Sao Tome and Principe", "sa": "Saudi Arabia", "sn": "Senegal", "cs": "Serbia and Montenegro", "sc": "Seychelles", "sl": "Sierra Leone", "sg": "Singapore", "sk": "Slovakia", "si": "Slovenia", "sb": "Solomon Islands", "so": "Somalia", "za": "South Africa", "gs": "South Georgia and the South Sandwich Islands", "es": "Spain", "lk": "Sri Lanka", "sd": "Sudan", "sr": "Suriname", "sj": "Svalbard and Jan Mayen", "sz": "Swaziland", "se": "Sweden", "ch": "Switzerland", "sy": "Syrian Arab Republic", "tw": "Taiwan, Province of China", "tj": "Tajikistan", "tz": "Tanzania, United Republic of", "th": "Thailand", "tl": "Timor-Leste", "tg": "Togo", "tk": "Tokelau", "to": "Tonga", "tt": "Trinidad and Tobago", "tn": "Tunisia", "tr": "Turkey", "tm": "Turkmenistan", "tc": "Turks and Caicos Islands", "tv": "Tuvalu", "ug": "Uganda", "ua": "Ukraine", "ae": "United Arab Emirates", "gb": "United Kingdom", "us": "United States", "um": "United States Minor Outlying Islands", "uy": "Uruguay", "uz": "Uzbekistan", "vu": "Vanuatu", "ve": "Venezuela", "vn": "Viet Nam", "vg": "Virgin Islands, British", "vi": "Virgin Islands, U.S.", "wf": "Wallis and Futuna", "eh": "Western Sahara", "ye": "Yemen", "zm": "Zambia", "zw": "Zimbabwe" };

/* harmony default export */ __webpack_exports__["a"] = (countries);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var insurances = {
    'unknown_uninsured': 'unknown / not insured',
    33868451: 'AKA / Augenoptiker Ausgleichskasse VVaG',
    1000080: 'AOK / Nordost in Mecklenburg-Vorpommern',
    1000126: 'AOK / Nordost in Brandenburg',
    1000159: 'AOK / PLUS in Thüringen',
    15039702: 'AOK / Hamburg RD d. AOK Rheinland/Hamburg',
    20012084: 'AOK / Bremen/Bremerhaven',
    30009013: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Mönchengladbach/Kreise Heinsberg - Viersen',
    30025400: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Städteregion Aachen Kreis Düren',
    30137494: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Städteregion Aachen Kreis Düren',
    30900193: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Oberberg - Leverkusen - Rhein.-Berg. Kreis',
    30903777: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Oberberg - Leverkusen - Rhein.-Berg. Kreis',
    32007630: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Bonn Rhein-Sieg-Kreis',
    32063968: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Bonn Rhein-Sieg-Kreis',
    32529960: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Rhein-Erft-Kreis Kreis Euskirchen',
    32591455: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Rhein-Erft-Kreis - Kreis Euskirchen',
    33932950: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Städteregion Aachen - Kreis Düren',
    34216864: 'AOK / Rheinland/Hamburg RD Düsseldorf',
    35072227: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Duisburg - Oberhausen',
    35310394: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Essen - Mülheim an der Ruhr',
    37814547: 'AOK / Rheinland/Hamburg RD Köln',
    38605421: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Mönchengladbach/Kreise Heinsberg - Viersen',
    38605513: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Kreis Kleve - Kreis Wesel',
    38615296: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Rhein-Kreis Neuss - Krefeld',
    39343643: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Rhein-Kreis Neuss - Krefeld',
    40107672: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Duisburg - Oberhausen',
    40134915: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Essen  - Mülheim an der Ruhr',
    41911974: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Wuppertal - Remscheid - Solingen',
    41912602: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Wuppertal - Remscheid - Solingen',
    42031129: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Oberberg - Leverkusen - Rhein.-Berg. Kreis',
    42507954: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Kreis Kleve - Kreis Wesel',
    42807230: 'AOK / Rheinland/Hamburg RD Kreis Mettmann',
    42938922: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Wuppertal - Remscheid - Solingen',
    51605725: 'AOK / Rheinland-Pfalz/Saarland Die Gesundheitskasse',
    55420162: 'AOK / Rheinland-Pfalz/Saarland Die Gesundheitskasse',
    90235319: 'AOK / Nordost in Berlin',
    95940768: 'AOK / Rheinland/Hamburg Die Gesundheitskasse RD Mönchengladbach/ Kreise Heinsberg - Viersen',
    13460004: 'AOK / NordWest Region Schleswig-Holstein',
    45118687: 'AOK / Hessen',
    33526082: 'AOK / NordWest Region Westfalen-Lippe',
    29720865: 'AOK / Die Gesundheitskasse für Niedersachsen',
    1029141: 'AOK / Sachsen-Anhalt',
    5174740: 'AOK / PLUS in Sachsen DAV',
    34364249: 'AOK / Rheinland/Hamburg',
    67450665: 'AOK / Baden-Württemberg',
    87880235: 'AOK / Bayern Die Gesundheitskasse',
    1000672: 'BKK / Deutsche Bank AG Ost Gesch. Ber. Neue Bundesländer',
    1017272: 'BKK / Brandenburgische',
    1068979: 'BKK / Thüringer Betriebskrankenkasse',
    1085106: 'BKK / MEM',
    1085583: 'BKK / Deutsche Ost',
    1085787: 'BKK / SBK HV Ost',
    1085890: 'BKK / R+V Ost',
    15517302: 'BKK / Mobil Oil',
    15517482: 'BKK / SECURVITA',
    20156113: 'BKK / atlas BKK ahlmann',
    21203214: 'BKK / Salzgitter',
    23709856: 'BKK / 24',
    30165364: 'BKK / actimonda krankenkasse',
    30168049: 'BKK / EUREGIO',
    31209131: 'BKK / Heimat Krankenkasse',
    31323584: 'BKK / Bertelsmann AG',
    31323686: 'BKK / Diakonie',
    31323700: 'BKK / Miele',
    31323799: 'BKK / Dürkopp Adler',
    31323802: 'BKK / GILDEMEISTER SEIDENSTICKER',
    34401277: 'BKK / Deutsche Bank AG',
    35430071: 'BKK / E.ON',
    36916935: 'BKK / Melitta plus',
    37416328: 'BKK / VDN',
    40180080: 'BKK / VIACTIV',
    41378558: 'BKK / SIEMAG',
    42039708: 'BKK / Die Bergische Krankenkasse',
    44037562: 'BKK / Werra-Meissner',
    44377882: 'BKK / Merck',
    44953697: 'BKK / Salus',
    45094199: 'BKK / Braun-Gillette',
    45094601: 'BKK / Vereinigte',
    47034920: 'BKK / Henschel Plus',
    47034953: 'BKK / Herkules',
    47034975: 'BKK / B. Braun Melsungen AG',
    47307817: 'BKK / PwC',
    48063096: 'BKK / Karl Mayer',
    48698889: 'BKK / Linde',
    48944809: 'BKK / R+V',
    51588416: 'BKK / Pfaff AG Kaiserslautern',
    52598579: 'BKK / Pfalz',
    60393261: 'BKK / Groz-Beckert',
    61232758: 'BKK / Scheufelen',
    61232769: 'BKK / WMF',
    62332660: 'BKK / Südzucker',
    63494759: 'BKK / mhplus',
    63922962: 'BKK / Freudenberg',
    65710574: 'BKK / MTU',
    66105948: 'BKK / Metzinger',
    66458477: 'BKK / Die Schwenninger Krankenkasse',
    66458503: 'BKK / AESCULAP',
    67161380: 'BKK / Würth',
    67572537: 'BKK / Mahle GmbH',
    67572593: 'BKK / Bosch',
    67573219: 'BKK / Deutsche',
    68659646: 'BKK / Wieland',
    73170269: 'BKK / Textilgruppe Hof',
    74773896: 'BKK / SKD',
    75925585: 'BKK / KBA',
    81211334: 'BKK / Stadt Augsburg',
    82889062: 'BKK / AUDI',
    87271125: 'BKK / BMW Zentrale',
    87954699: 'BKK / SBK',
    16665321: 'BKK / RWE',
    22178373: 'BKK / Exklusiv',
    35087667: 'BKK / Grillo Werke',
    74157435: 'BKK / Krones',
    1073497: 'BKK / Bosch Ost',
    36916980: 'BKK / HMR/West Herford Minden Ravensberg',
    52156763: 'BKK / Debeka',
    69753266: 'BKK / ZF & Partner',
    92644250: 'BKK / VBU Verkehrsbau Union',
    1075558: 'BKK / advita Ost',
    1086050: 'BKK / EWE Ost',
    26515319: 'BKK / EWE',
    29717581: 'BKK / energie',
    30980327: 'BKK / BPW Wiehl',
    51980490: 'BKK / EVM der Energieversorgung Mittelrhein',
    60255652: 'BKK / advita',
    71579930: 'BKK / Akzo Nobel Obernburg',
    86772584: 'BKK / Faber Castell & Partner',
    20156168: 'BKK / firmus',
    33865367: 'BKK / Continentale',
    41378433: 'BKK / Achenbach Buschhütten',
    68216980: 'BKK / Daimler',
    1086312: 'BKK / actimonda krankenkasse',
    1085195: 'BKK / Salus Ost',
    1085037: 'BKK / Bertelsmann AG Ost',
    66614249: 'BKK / SBH',
    1085538: 'BKK / Salzgitter Ost',
    1058922: 'BKK / firmus Ost',
    1013837: 'BKK / Diakonie Ost',
    1085812: 'BKK / energie Ost',
    1020870: 'BKK / ZF & Partner Ost',
    1085026: 'BKK / Würth Ost',
    23446040: 'BKK / Technoform',
    3591039: 'BKK / Exklusiv Ost',
    1085457: 'BKK / Linde Ost',
    1085402: 'BKK / SECURVITA Ost',
    1086243: 'BKK / Debeka Ost',
    21488086: 'BKK / Publik-Partner der BKK Salzgitter',
    1085231: 'BKK / WMF Ost',
    97352653: 'BKK / Voralb HELLER*INDEX*LEUZE',
    5045203: 'BKK / KBA König/Bauer/Albert Ost',
    52654083: 'BKK / Vital',
    69785429: 'BKK / Verbund Plus',
    1085754: 'BKK / BMW AG Ost',
    1049156: 'BKK / Verbund Plus Ost',
    66626976: 'BKK / Rieker Ricosta Weisser',
    4309904: 'BKK / VDN Ost',
    1085823: 'BKK / Südzucker Ost',
    1085242: 'BKK / SKD Ost',
    16839984: 'BKK / Beiersdorf AG',
    46939789: 'BKK / Ernst & Young',
    1085219: 'BKK / Vereinigte Ost',
    8316149: 'BKK / Bahn Rechtskreis Ost',
    49003443: 'BKK / Bahn Rechtskreis West',
    1085082: 'BKK / Braun-Gillette Ost',
    1085446: 'BKK / Pfaff AG Kaiserslautern Ost',
    1086094: 'BKK / Heimat Krankenkasse/Ost',
    2430065: 'BKK / 24 Ost',
    7684386: 'BKK / Miele/Ost',
    7812433: 'BKK / mhplus Ost',
    46967693: 'BKK / Wirtschaft & Finanzen',
    1018182: 'BKK / HMR/Ost Herford Minden Ravensberg',
    1083422: 'BKK / Audi Ost',
    8476370: 'BKK / VBU Verkehrsbau Union Ost Gesch. Bereich Neue Länder',
    7251093: 'BKK / Pfalz Ost',
    29074470: 'BKK / TUI',
    2988673: 'BKK / Daimler Ost',
    6818233: 'BKK / Die Schwenninger Krankenkasse/Ost',
    1011777: 'BKK / GILDEMEISTER SEIDENSTICKER-Ost',
    8090728: 'BKK / ProVita/Ost_(ehem.BKK A.T.U)',
    88571250: 'BKK / ProVita (ehemals BKK A.T.U)',
    3847834: 'BKK / NOVITAS Ost',
    35134022: 'BKK / NOVITAS',
    8227948: 'BKK / TUI Ost',
    6785450: 'BKK / Wirtschaft & Finanzen Ost',
    8596570: 'BKK / PwC Ost',
    15872672: 'BKK / pronova',
    15874275: 'BKK / pronova Ost',
    97565837: 'BKK / Thüringer Betriebskrankenkasse',
    98000006: 'BUN / Knappschaft Hauptverwaltung',
    98000001: 'BUN / Knappschaft Hauptverwaltung',
    15027365: 'EK / Techniker-Krankenkasse',
    15031806: 'EK / Hanseatische Krankenkasse Hauptverwaltung',
    15035218: 'EK / DAK-Gesundheit',
    20013461: 'EK / hkk',
    29137937: 'EK / KKH Kaufmännische Krankenkasse',
    42938966: 'EK / BARMER GEK vormals Barmer Ersatzkasse',
    48698890: 'EK / DAK Gesundheit (ehem.BKK-Gesundheit)',
    66761998: 'EK / BARMER GEK vormals Gmünder Ersatzkasse',
    1031123: 'EK / DAK Gesundheit Ost (ehem.BKK-Gesundheit)',
    1000455: 'IKK / gesund plus (Ost)',
    1005483: 'IKK / Nord Ost',
    14228571: 'IKK / Nord',
    15039837: 'IKK / classic Rechtsk.West Hauptverwaltung',
    20013109: 'IKK / gesund plus (West)',
    55811201: 'IKK / Südwest',
    90397224: 'IKK / Brandenburg und Berlin Regionaldirektion Berlin',
    1020803: 'IKK / Brandenburg und Berlin Ost Regionaldirektion Brandenburg',
    5012943: 'IKK / BIG direkt gesund Ost',
    97141402: 'IKK / BIG direkt gesund West',
    1049203: 'IKK / classic Rechtsk. Ost Hauptverwaltung',
    1000308: 'LKK / SVLFG, Landw.KK, Hoppegarten Geschäftsstelle Hoppegarten',
    1000650: 'LKK / SVLFG, Landw. KK, Kassel ehemals Gartenbau, Kassel',
    13199426: 'LKK / SVLFG, Landw. KK, Kiel Geschäftsstelle Kiel',
    29147110: 'LKK / SVLFG, Landw. KK, Hannover Geschäftsstelle Hannover',
    39873587: 'LKK / SVLFG, Landw. KK, Münster Geschäftsstelle Münster',
    47068420: 'LKK / SVLFG, Landw. KK, Kassel Geschäftsstelle Kassel',
    47069693: 'LKK / SVLFG, Landw.KK, Kassel (ehemals Gartenbau) Kassel (ehemals Gartenbau)',
    67574619: 'LKK / SVLFG, Landw. KK, Stuttgart Geschäftsstelle Stuttgart',
    72360029: 'LKK / SVLFG, Landw. KK, Bayreuth Geschäftsstelle Bayreuth',
    87119868: 'LKK / SVLFG, Landw. KK, Landshut Geschäftsstelle Landshut',
    99086875: 'SEE / Knappschaft (See-Krankenvers.) Hauptverwaltung'
};

/* harmony default export */ __webpack_exports__["a"] = (insurances);

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.profile) ? _c('div', {
    staticClass: "profile-data"
  }, [_c('form', {
    staticClass: "form",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.resetForm.apply(null, arguments)
      },
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      },
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), ((_vm.$current.profile == 'Pier14' || _vm.$current.profile == 'Gieck') && (_vm.isManager || Object.keys(_vm.hrDocuments).length)) ? _c('fieldset', [_c('legend', [_vm._v("HR Dokumente")]), _vm._v(" "), _c('div', {
    staticClass: "fieldset--inner"
  }, [_vm._l((_vm.hrDocuments), function(documents, key) {
    return _c('div', {
      key: key,
      staticClass: "profile--hr-documents"
    }, _vm._l((documents), function(field, index) {
      return _c('div', {
        key: index,
        staticClass: "row"
      }, [_c('label', {
        attrs: {
          "for": "document"
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.getDocumentGroup(key)))])]), _vm._v(" "), _c('div', {
        staticClass: "form-input"
      }, [(_vm.isUploaded(key)) ? _c('div', {
        staticClass: "form-text"
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.downloadFile(key, index)
          }
        }
      }, [_vm._v(_vm._s(field.name))]), _vm._v(" "), (_vm.isManager) ? _c('icon', {
        attrs: {
          "name": "delete"
        },
        nativeOn: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.deleteUpload(key, index)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.getDocumentValue(key)) + ", " + _vm._s(field.date))])], 1) : _vm._e()])])
    }), 0)
  }), _vm._v(" "), (_vm.addDocument) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "dropdown dropdown--framed"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('icon', {
    attrs: {
      "name": "chevron_down",
      "viewBox": "0 0 24 24"
    }
  }), _vm._v("\n                            " + _vm._s(_vm.getDocumentValue(_vm.documentType)) + "\n                            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documentType),
      expression: "documentType"
    }],
    attrs: {
      "id": "document_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.documentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.documentTypes), function(group) {
    return _c('optgroup', {
      key: group.key,
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.documents), function(doc) {
      return _c('option', {
        domProps: {
          "value": _vm.getDocumentKey(group.key, doc.key)
        }
      }, [_vm._v(_vm._s(doc.label) + "\n                                    ")])
    }), 0)
  }), 0)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.documentType) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-text"
  }, [_c('input', {
    attrs: {
      "id": "document",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.uploadFile($event, 'document')
      }
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('small', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelDocumentUpload()
      }
    }
  }, [_vm._v("abbrechen")])])])]) : _vm._e(), _vm._v(" "), ((_vm.isManager) && !_vm.addDocument) ? _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), (!_vm.addDocument) ? _c('action', {
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addDocument = true
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('common.button.add')) + "\n                    ")]) : _vm._e()], 1) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.profile.template), function(fieldset) {
    return (_vm.hasFields(fieldset)) ? _c('fieldset', [_c('legend', [_vm._v(_vm._s(fieldset.name[_vm.$lang]))]), _vm._v(" "), (typeof fieldset.hidden !== 'undefined') ? _c('small', [(fieldset.hidden) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          fieldset.hidden = false
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('text.show_details')))]) : _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          fieldset.hidden = true
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('text.hide_details')))])]) : _vm._e(), _vm._v(" "), (fieldset.note) ? _c('div', {
      staticClass: "note",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_vm._v(_vm._s(fieldset.note[_vm.$lang]))]) : _vm._e(), _vm._v(" "), _c('div', {
      class: ['fieldset--inner', fieldset.hidden ? 'is-hidden' : null]
    }, _vm._l((fieldset.fields), function(field) {
      return (_vm.showField(field)) ? _c('div', {
        class: _vm.getClasses(field)
      }, [(field.type == 'divider') ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.showLabel(field)) ? _c('label', {
        attrs: {
          "for": field.id
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.label(field))
        }
      }), _vm._v(" "), (field.description) ? _c('icon', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: (field.description[_vm.$lang]),
          expression: "field.description[$lang]"
        }],
        attrs: {
          "name": "info"
        }
      }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.type == 'text') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        },
        style: (field.width ? 'width:' + field.width : null)
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "id": field.id,
          "type": "text",
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "value": (_vm.profile.values[field.id])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.profile.values, field.id, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'textarea') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        },
        style: (field.width ? 'width:' + field.width : null)
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "id": field.id,
          "disabled": _vm.isDisabled(field),
          "readonly": _vm.isReadonly(field)
        },
        domProps: {
          "value": (_vm.profile.values[field.id])
        },
        on: {
          "keypress": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            $event.stopPropagation();
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.profile.values, field.id, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'email') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "id": field.id,
          "type": "email",
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "value": (_vm.profile.values[field.id])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.profile.values, field.id, $event.target.value)
          }
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'date') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        },
        staticStyle: {
          "width": "160px"
        }
      }, [_c('pikaday', {
        attrs: {
          "id": field.id,
          "date": _vm.profile.values[field.id],
          "disabled": _vm.isDisabled(field)
        },
        on: {
          "change": _vm.updateDate
        }
      }), _vm._v(" "), _c('icon', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: (_vm.$t('tooltip.date_info')),
          expression: "$t('tooltip.date_info')"
        }],
        staticClass: "date-info",
        attrs: {
          "name": "info"
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'number') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        },
        style: (field.width ? 'width:' + field.width : null)
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "id": field.id,
          "type": "number",
          "step": field.step ? field.step : 1,
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "value": (_vm.profile.values[field.id])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.profile.values, field.id, $event.target.value)
          }
        }
      }), _vm._v(" "), (_vm.$current.profile == 'Gieck' && field.id === 'contract_hours' && _vm.profile.values[field.id]) ? _c('div', {
        staticStyle: {
          "margin-top": "5px",
          "font-size": "0.9em",
          "color": "#666"
        }
      }, [_c('div', [_vm._v("Pro Woche: " + _vm._s((_vm.profile.values[field.id] / 52).toFixed(2)))]), _vm._v(" "), _c('div', [_vm._v("Pro Monat: " + _vm._s((_vm.profile.values[field.id] / 12).toFixed(2)))])]) : _vm._e(), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'upload') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [(_vm.isUploaded(field.id)) ? _c('div', {
        staticClass: "form-text"
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.downloadFile(field.id, 0)
          }
        }
      }, [_vm._v(_vm._s(_vm.uploads[field.id][0].name))]), _vm._v(" "), _c('icon', {
        attrs: {
          "name": "delete"
        },
        nativeOn: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.deleteUpload(field.id, 0)
          }
        }
      })], 1) : _c('input', {
        attrs: {
          "id": field.id,
          "type": "file",
          "disabled": _vm.isDisabled(field)
        },
        on: {
          "change": function($event) {
            return _vm.uploadFile($event, field)
          }
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'multi-upload') ? _c('div', {
        staticClass: "form-input",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [_vm._l((_vm.uploads[field.id]), function(file, index) {
        return _c('div', {
          key: index
        }, [(_vm.isUploaded(field.id)) ? _c('div', {
          staticClass: "form-text"
        }, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.downloadFile(field.id, index)
            }
          }
        }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('icon', {
          attrs: {
            "name": "delete"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteUpload(field.id, index)
            }
          }
        }), _vm._v(" "), _c('br')], 1) : _vm._e()])
      }), _vm._v(" "), (_vm.addUpload[field.id] === true || !_vm.uploads[field.id]) ? _c('div', [_c('input', {
        attrs: {
          "id": field.id,
          "type": "file",
          "disabled": _vm.isDisabled(field)
        },
        on: {
          "change": function($event) {
            return _vm.uploadFile($event, field)
          }
        }
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (_vm.uploads[field.id] && (_vm.addUpload[field.id] === false || _vm.addUpload[field.id] === undefined)) ? _c('div', [_c('action', {
        staticClass: "button--small",
        staticStyle: {
          "margin-left": "0"
        },
        attrs: {
          "color": "blue"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.$set(_vm.addUpload, field.id, true)
          }
        }
      }, [_vm._v("+ " + _vm._s(_vm.$t('common.button.add')) + "\n                            ")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (field.type == 'checkbox') ? _c('div', {
        staticClass: "form-checkbox",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "type": "checkbox",
          "id": field.id,
          "value": "1",
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "checked": Array.isArray(_vm.profile.values[field.id]) ? _vm._i(_vm.profile.values[field.id], "1") > -1 : (_vm.profile.values[field.id])
        },
        on: {
          "change": function($event) {
            var $$a = _vm.profile.values[field.id],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = "1",
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(_vm.profile.values, field.id, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(_vm.profile.values, field.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(_vm.profile.values, field.id, $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.label(field))
        }
      })]), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'auto') ? _c('div', {
        staticClass: "form-input form-input-tags",
        class: {
          error: _vm.$v.hasError(field.id)
        },
        on: {
          "keypress": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            $event.stopPropagation();
          }
        }
      }, [_c('v-select', {
        attrs: {
          "options": _vm.getCollection(field),
          "disabled": _vm.isDisabled(field)
        },
        on: {
          "input": function($event) {
            return _vm.setValue(field)
          }
        },
        model: {
          value: (_vm.selection[field.id]),
          callback: function($$v) {
            _vm.$set(_vm.selection, field.id, $$v)
          },
          expression: "selection[field.id]"
        }
      }, [_c('span', {
        attrs: {
          "slot": "no-options"
        },
        slot: "no-options"
      }, [_vm._v(_vm._s(_vm.$t('text.no_results')))])]), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'radio') ? _c('div', {
        staticClass: "form-radio",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [_vm._l((field.options), function(option, key) {
        return _c('label', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.profile.values[field.id]),
            expression: "profile.values[field.id]"
          }],
          attrs: {
            "type": "radio",
            "id": field.id + '_' + key,
            "disabled": _vm.isDisabled(field)
          },
          domProps: {
            "value": key,
            "checked": _vm._q(_vm.profile.values[field.id], key)
          },
          on: {
            "change": function($event) {
              return _vm.$set(_vm.profile.values, field.id, key)
            }
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(option))])])
      }), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 2) : _vm._e(), _vm._v(" "), (field.type == 'yesno') ? _c('div', {
        staticClass: "form-radio",
        class: {
          error: _vm.$v.hasError(field.id)
        }
      }, [_c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "type": "radio",
          "id": field.id + '_yes',
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "value": 1,
          "checked": _vm._q(_vm.profile.values[field.id], 1)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.profile.values, field.id, 1)
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('text.yes')))])]), _vm._v(" "), _c('label', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "type": "radio",
          "id": field.id + '_no',
          "disabled": _vm.isDisabled(field)
        },
        domProps: {
          "value": 0,
          "checked": _vm._q(_vm.profile.values[field.id], 0)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.profile.values, field.id, 0)
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('text.no')))])]), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (field.type == 'select') ? _c('div', {
        class: ['dropdown', 'dropdown--framed', _vm.isDisabled(field) ? 'disabled' : '', _vm.$v.hasError(field.id) ? 'error' : '']
      }, [_c('span', {
        staticClass: "label"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.label(field))
        }
      }), _vm._v(" "), (field.description) ? _c('icon', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: (field.description[_vm.$lang]),
          expression: "field.description[$lang]"
        }],
        attrs: {
          "name": "info"
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('icon', {
        attrs: {
          "name": "chevron_down",
          "viewBox": "0 0 24 24"
        }
      }), _vm._v("\n                            " + _vm._s(_vm.getSelectedValue(field)) + "\n                            "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.profile.values[field.id]),
          expression: "profile.values[field.id]"
        }],
        attrs: {
          "id": field.id,
          "disabled": _vm.isDisabled(field)
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.profile.values, field.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.getOptions(field)), function(value, key) {
        return _c('option', {
          domProps: {
            "value": key
          }
        }, [_vm._v(_vm._s(value))])
      }), 0)], 1), _vm._v(" "), _c('error', {
        attrs: {
          "message": _vm.$v.message(field.id)
        }
      })], 1) : _vm._e(), _vm._v(" "), (_vm.$current.profile == 'Ryanair' && field.id == 'health_insurance_law' && _vm.profile.values[field.id] == 'unknown_uninsured' && !_vm.mobile) ? _c('div', {
        staticClass: "note",
        staticStyle: {
          "margin-top": "20px"
        }
      }, [_vm._v(_vm._s(_vm.$t('sko.malta.tk.0')) + " "), _c('a', {
        attrs: {
          "href": "https://www.meinsternum.de/tk-airmalta",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.$t('sko.malta.tk.1')))]), _vm._v("\n                        " + _vm._s(_vm.$t('sko.malta.tk.2')) + " "), _c('a', {
        attrs: {
          "href": "/static/Welcome-to-Germany.pdf",
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.$t('sko.malta.tk.3')))]), _vm._v(".")]) : _vm._e()]) : _vm._e()
    }), 0)]) : _vm._e()
  }), _vm._v(" "), (_vm.$onduro.hasModule('freelancers')) ? _c('fieldset', [_c('legend', [_vm._v("Freelancer")]), _vm._v(" "), _c('div', {
    staticClass: "fieldset--inner"
  }, [(_vm.$onduro.hasRole(['owner', 'manager'])) ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "roles"
    }
  }, [_vm._v(_vm._s(_vm.$t('page.team.user_is')))]), _vm._v(" "), _c('div', {
    staticClass: "form-checkbox"
  }, [(_vm.$onduro.hasModule('freelancers')) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['is_freelancer']),
      expression: "profile.values['is_freelancer']"
    }],
    attrs: {
      "type": "checkbox",
      "value": "freelancer"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.values['is_freelancer']) ? _vm._i(_vm.profile.values['is_freelancer'], "freelancer") > -1 : (_vm.profile.values['is_freelancer'])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.profile.values['is_freelancer'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "freelancer",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profile.values, 'is_freelancer', $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profile.values, 'is_freelancer', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profile.values, 'is_freelancer', $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.role.freelancer')))]), _vm._v(" "), _c('div', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('page.team.hint.role_freelancer')))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('input.freelancer.autoInvoice')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['auto_invoice']),
      expression: "profile.values['auto_invoice']"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.values['auto_invoice']) ? _vm._i(_vm.profile.values['auto_invoice'], null) > -1 : (_vm.profile.values['auto_invoice'])
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.profile.values['auto_invoice'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profile.values, 'auto_invoice', $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profile.values, 'auto_invoice', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profile.values, 'auto_invoice', $$c)
        }
      }, _vm.updateAutoInvoice]
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.button.yes')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('input.freelancer.shiftVat')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['vat_shifted']),
      expression: "profile.values['vat_shifted']"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.profile.values['vat_shifted']) ? _vm._i(_vm.profile.values['vat_shifted'], null) > -1 : (_vm.profile.values['vat_shifted'])
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.profile.values['vat_shifted'],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.profile.values, 'vat_shifted', $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.profile.values, 'vat_shifted', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.profile.values, 'vat_shifted', $$c)
        }
      }, _vm.updateShiftVat]
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.button.yes')))])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('common.text.businessNumber')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['business_number']),
      expression: "profile.values['business_number']"
    }],
    attrs: {
      "type": "text",
      "id": "business_number"
    },
    domProps: {
      "value": (_vm.profile.values['business_number'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.values, 'business_number', $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.$t('common.text.vatNumber')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['vat_number']),
      expression: "profile.values['vat_number']"
    }],
    attrs: {
      "type": "text",
      "id": "vat_number"
    },
    domProps: {
      "value": (_vm.profile.values['vat_number'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.values, 'vat_number', $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.values['iban']),
      expression: "profile.values['iban']"
    }],
    attrs: {
      "type": "text",
      "id": "iban",
      "placeholder": "NL12 BANK 1234 5678 90"
    },
    domProps: {
      "value": (_vm.profile.values['iban'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile.values, 'iban', $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input', {
    staticClass: "btn btn--green btn--profile-save",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.$t('layout.footer.save')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm('default')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.$onduro.hasRole(['owner', 'manager', 'accountant'])) ? _c('input', {
    staticClass: "btn btn--orange btn--profile-save",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.$t('layout.footer.saveWithDate')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm('date')
      }
    }
  }) : _vm._e()])], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('span', [_vm._v("Dokumenttyp")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "document"
    }
  }, [_c('span', [_vm._v("Dokument")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', [_vm._v("IBAN")])])
}]}

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Rangepicker',

    props: [],

    data: function data() {
        return {
            area: 'current',
            range: 'week',
            relativeToNow: 0,
            showCalendar: false,
            calendarRange: []
        };
    },


    filters: {
        formatDate: function formatDate(val, range) {
            if (range === 'month') return moment(val[0]).format('MMMM YYYY');
            if (val.length > 1) return moment(val[0]).format('dd, DD.MM.YY') + ' — ' + moment(val[1]).format('dd, DD.MM.YY');
            return moment(val[0]).format('dd, DD.MM.YY');
        }
    },

    created: function created() {
        this.calendarRange = this.fillRange(this.timeframe);
        this.emitDates();
    },


    computed: {
        timeframe: function timeframe() {
            if (this.range === 'day') return this.day;
            if (this.range === 'week') return this.week;
            if (this.range === 'month') return this.month;
            if (this.range === 'year') return this.year;

            //            if (this.calendarRange.length === 1 || this.range === 'day') return [this.calendarRange[0]];
            //            if (this.calendarRange.length > 1) return [this.calendarRange[0], this.calendarRange[this.calendarRange.length - 1]];

            return [];
        },
        day: function day() {
            if (this.area === 'current') return [moment()];

            return [moment().add(this.relativeToNow, 'day')];
        },
        week: function week() {
            if (this.area === 'current') return [moment().startOf('week'), moment().endOf('week')];

            return [moment().add(this.relativeToNow, 'day').startOf('week'), moment().add(this.relativeToNow, 'day').endOf('week')];
        },
        month: function month() {
            if (this.area === 'current') return [moment().startOf('month'), moment().endOf('month')];

            return [moment().add(this.relativeToNow, 'day').startOf('month'), moment().add(this.relativeToNow, 'day').endOf('month')];
        },
        year: function year() {
            if (this.area === 'current') return [moment().startOf('year'), moment().endOf('year')];

            return [moment().add(this.relativeToNow, 'day').startOf('year'), moment().add(this.relativeToNow, 'day').endOf('year')];
        },
        calendarVisible: function calendarVisible() {
            return this.range !== 'month' || this.range !== 'year';
        }
    },

    methods: {
        fillRange: function fillRange(timeframe) {
            if (!timeframe.length) return [];

            var range = [];
            var startDate = moment(timeframe[0]);
            var endDate = moment(timeframe[timeframe.length - 1]);

            while (startDate.isBefore(endDate) || startDate.isSame(endDate)) {
                range.push(startDate.format('YYYY-MM-DD'));
                startDate.add(1, 'days');
            }

            return range;
        },
        toggleCalendar: function toggleCalendar() {
            if (!this.calendarVisible) return;

            this.showCalendar = !this.showCalendar;
        },
        current: function current() {
            this.area = 'current';
            this.relativeToNow = 0;
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },
        prev: function prev() {
            this.area = 'prev';
            if (this.range === 'day') this.relativeToNow--;else if (this.range === 'week') this.relativeToNow -= 7;else if (this.range === 'month') this.relativeToNow -= 31;else if (this.range === 'week') this.relativeToNow -= 365;
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },
        next: function next() {
            this.area = 'next';
            if (this.range === 'day') this.relativeToNow++;else if (this.range === 'week') this.relativeToNow += 7;else if (this.range === 'month') this.relativeToNow += 31;else if (this.range === 'week') this.relativeToNow += 365;
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },
        custom: function custom() {
            this.area = 'custom';
            this.relativeToNow = 0;
            this.emitDates();
        },
        setDay: function setDay() {
            this.range = 'day';
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },
        setWeek: function setWeek() {
            this.range = 'week';
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },
        setMonth: function setMonth() {
            this.range = 'month';
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },
        setYear: function setYear() {
            this.range = 'year';
            this.calendarRange = this.fillRange(this.timeframe);
            this.emitDates();
        },
        emitDates: function emitDates() {
            this.$emit('update', { dates: this.timeframe, range: this.range });
        },
        handleCalendarSelectionFrom: function handleCalendarSelectionFrom(range) {
            this.area = 'custom';
            this.calendarRange = range;
            this.relativeToNow = moment(range[0]).diff(moment().startOf('day'), 'days');

            this.emitDates();
        }
    }
});

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rangepicker"
  }, [_c('div', {
    staticClass: "selection"
  }, [_c('ul', {
    staticClass: "rangepicker-tabs"
  }, [_c('li', {
    class: {
      active: _vm.range === 'day'
    },
    on: {
      "click": _vm.setDay
    }
  }, [_vm._v(_vm._s(_vm.$t('label.day')))]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.range === 'week'
    },
    on: {
      "click": _vm.setWeek
    }
  }, [_vm._v(_vm._s(_vm.$t('label.week')))]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.range === 'month'
    },
    on: {
      "click": _vm.setMonth
    }
  }, [_vm._v(_vm._s(_vm.$t('label.month')))])])]), _vm._v(" "), _c('header', [_c('ul', {
    staticClass: "rangepicker-controls"
  }, [_c('li', {
    on: {
      "click": _vm.prev
    }
  }, [_c('icon', {
    staticClass: "bright",
    attrs: {
      "name": "prev"
    }
  })], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.current
    }
  }, [_c('icon', {
    staticClass: "bright",
    attrs: {
      "name": "circle_o"
    }
  })], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.next
    }
  }, [_c('icon', {
    staticClass: "bright",
    attrs: {
      "name": "next"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleCalendar.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.timeframe, _vm.range)))]), _vm._v(" "), (_vm.range != 'month' && _vm.range != 'year') ? _c('div', {
    staticClass: "rangepicker-controls--right"
  }, [_c('button', {
    staticClass: "btn",
    class: {
      active: _vm.showCalendar && _vm.calendarVisible,
        disabled: !_vm.calendarVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleCalendar.apply(null, arguments)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "calendar"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), (_vm.showCalendar && _vm.range !== 'month' && _vm.range !== 'year') ? _c('calendar', {
    attrs: {
      "callback": _vm.handleCalendarSelectionFrom,
      "selected": _vm.calendarRange,
      "range": _vm.range,
      "mode": "range"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Search',

    data: function data() {
        return {
            style: 'search--framed'
        };
    },


    props: {
        placeholder: {
            type: String,
            default: ''
        },

        value: {
            type: String,
            default: ''
        },

        noBorder: {
            type: String
        }
    },

    created: function created() {
        this.style = typeof this.noBorder == 'undefined' ? this.style : '';
    },


    methods: {
        /**
         * Update value to parent component
         * @param value
         */
        updateValue: function updateValue(value) {
            this.$emit('input', value);
        }
    }
});

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search",
    class: _vm.style
  }, [_c('input', {
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "search",
      "viewBox": "0 0 24 24"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Selection',

    props: {
        collection: {
            type: [Object, Array],
            required: true
        },

        selection: {
            type: [Object, Array],
            required: true
        },

        identifier: {
            type: String,
            required: true
        }
    },

    methods: {
        /**
         * Select all members
         */
        selectAll: function selectAll() {
            this.$emit('updateSelection', _.map(this.collection, this.identifier));
        },


        /**
         * Select no members
         */
        selectNone: function selectNone() {
            this.$emit('updateSelection', []);
        },


        /**
         * Wrapper for lodash _.size
         */
        count: function count(collection) {
            return _.size(collection);
        }
    }
});

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "selection"
  }, [_vm._v("\n    " + _vm._s(_vm.count(_vm.selection)) + " " + _vm._s(_vm.$t('text.of')) + " " + _vm._s(_vm.count(_vm.collection)) + " | " + _vm._s(_vm.$t('text.selection.select')) + "\n    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.selectAll.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('text.selection.all')))]), _vm._v("\n    " + _vm._s(_vm.$t('text.or')) + "\n    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.selectNone.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('text.selection.none')))])])
},staticRenderFns: []}

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sidebar',

    props: {
        'type': {
            type: String
        },
        'position': {
            type: String
        },
        'mainContentTab': {
            type: Boolean,
            default: false
        }
    },

    mounted: function mounted() {
        this.$store.dispatch('sidebar/mainContentTab', this.mainContentTab);
        this.$store.dispatch('sidebar/setPosition', this.position);
        this.$store.dispatch('sidebar/setType', this.type);
    },


    /**
     * Reset sidebar settings to its default values
     */
    beforeDestroy: function beforeDestroy() {
        this.$store.dispatch('sidebar/reset');
    }
});

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type) ? _c('aside', {
    staticClass: "sidebar",
    class: {
      'sidebar--tabs': _vm.type == 'tabs',
        'sidebar--fixed': _vm.type == 'fixed',
        'sidebar--flex': _vm.type == 'flex',

        'top': _vm.position == 'top' && _vm.type == 'flex',
        'bottom': _vm.position == 'bottom' && _vm.type == 'flex',
    }
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'SubHeader'
});

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-header"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Tab',

    props: {
        index: { required: true, default: 0 },
        title: { required: false, default: '' },
        count: { required: false }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        /**
         * Show tab content if
         *  page is in mobile viewport
         *  and page has a tab for the main content
         *  and active tab index equals tab index
         *
         * if page is not in mobile viewport
         *  show tab content when active index equals tab index
         *  or if active tab index equals 0 and tab index equals 1
         *
         * otherwise show content tab if active tab equals tab index
         *
         * @returns {boolean}
         */
        showContent: function showContent() {
            if (this.index == 0 && this.mainContentTab) return false;

            if (this.isMobile && this.mainContentTab) {
                return this.index == this.activeTab;
            } else if (this.mainContentTab) {
                return this.index == this.activeTab || this.activeTab == 0 && this.index == 1;
            } else {
                return this.index == this.activeTab;
            }
        },


        // Is viewport in mobile mode
        isMobile: function isMobile() {
            return this.viewport != 'd' && this.viewport != 'tl';
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        viewport: function viewport(_ref) {
            var layout = _ref.layout;
            return layout.viewport;
        },
        activeTab: function activeTab(_ref2) {
            var sidebar = _ref2.sidebar;
            return sidebar.tab.activeTab;
        },
        mainContentTab: function mainContentTab(_ref3) {
            var sidebar = _ref3.sidebar;
            return sidebar.tab.mainContentTab;
        }
    }))
});

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showContent) ? _c('div', [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Tabs',

    data: function data() {
        return {
            tabs: []
        };
    },
    created: function created() {
        this.tabs = this.$children;
    },


    methods: {
        /**
         * Determine if current tab is a content or a sidebar-content tab.
         *
         * @param index
         * @returns {boolean}
         */
        isContentTab: function isContentTab(index) {
            return this.mainContentTab && this.isMobile && index === 0 || index != 0;
        },


        /**
         * Is current tab active, based on index from the store
         * @param index
         */
        setActiveTab: function setActiveTab(index) {
            this.$store.dispatch('sidebar/setActiveTab', index);
        }
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        /**
         * Is viewport in mobile mode
         *
         * @returns {boolean}
         */
        isMobile: function isMobile() {
            return this.viewport != 'd' && this.viewport != 'tl';
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        viewport: function viewport(_ref) {
            var layout = _ref.layout;
            return layout.viewport;
        },
        activeTab: function activeTab(_ref2) {
            var sidebar = _ref2.sidebar;
            return sidebar.tab.activeTab;
        },
        mainContentTab: function mainContentTab(_ref3) {
            var sidebar = _ref3.sidebar;
            return sidebar.tab.mainContentTab;
        }
    }))
});

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs",
    class: 'tab-active--' + _vm.activeTab
  }, _vm._l((_vm.tabs), function(tab) {
    return (_vm.isContentTab(tab.index)) ? _c('a', {
      class: {
        'is-active': tab.index == _vm.activeTab || tab.index == 1 && _vm.activeTab == 0 && !_vm.isMobile
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.setActiveTab(tab.index)
        }
      }
    }, [_vm._v("\n\n            " + _vm._s(tab.title) + "\n\n            "), (tab.count) ? _c('em', [_vm._v(_vm._s(tab.count))]) : _vm._e()]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-details"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_collections__ = __webpack_require__(331);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Timeframe',

    props: {
        selectedStart: {
            type: [String, Number]
        },

        selectedEnd: {
            type: [String, Number]
        },

        single: {
            type: [Boolean],
            default: false
        },

        label: {
            type: [String, Boolean],
            default: false
        },

        defaultValue: {
            type: String,
            default: '—'
        }
    },

    computed: {
        /**
         * Computed starting hour from parent scope
         */
        startHour: function startHour() {
            return Math.floor(this.selectedStart / 60);
        },


        /**
         * Computed ending hour from parent scope
         */
        endHour: function endHour() {
            return Math.floor(this.selectedEnd / 60);
        },


        /**
         * Computed starting minute from parent scope
         */
        startMinute: function startMinute() {
            return this.selectedStart % 60;
        },


        /**
         * Computed ending minutes from parent scope
         */
        endMinute: function endMinute() {
            return this.selectedEnd % 60;
        },


        /**
         * Available hours
         */
        hours: function hours() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_collections__["a" /* default */].hours();
        },


        /**
         * Available minutes
         */
        minutes: function minutes() {
            return __WEBPACK_IMPORTED_MODULE_0__helpers_collections__["a" /* default */].minutes();
        }
    },

    methods: {
        /**
         * Update period
         *
         * @param value
         * @param type
         * @param position
         */
        updatePeriod: function updatePeriod(value, type, position) {
            var val = parseInt(value);

            if (type == 'minute') {
                if (position == 'start') {
                    this.$emit('updateStart', this.startHour * 60 + val);
                } else {
                    this.$emit('updateEnd', this.endHour * 60 + val);
                }
            } else {
                if (position == 'start') {
                    this.$emit('updateStart', val * 60 + this.startMinute);
                } else {
                    this.$emit('updateEnd', val * 60 + this.endMinute);
                }
            }
        }
    }
});

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeframe"
  }, [(_vm.label) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-s",
    attrs: {
      "select": _vm.startHour,
      "items": _vm.hours,
      "default-value": _vm.defaultValue
    },
    on: {
      "changed": function($event) {
        return _vm.updatePeriod($event, 'hour', 'start')
      }
    }
  }), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-s",
    attrs: {
      "select": _vm.startMinute,
      "items": _vm.minutes
    },
    on: {
      "changed": function($event) {
        return _vm.updatePeriod($event, 'minute', 'start')
      }
    }
  }), _vm._v(" "), (!_vm.single) ? _c('span', [_vm._v(_vm._s(_vm.$t('label.until')))]) : _vm._e(), _vm._v(" "), (!_vm.single) ? _c('dropdown', {
    staticClass: "dropdown-s",
    attrs: {
      "select": _vm.endHour,
      "items": _vm.hours
    },
    on: {
      "changed": function($event) {
        return _vm.updatePeriod($event, 'hour', 'end')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.single) ? _c('dropdown', {
    staticClass: "dropdown-s",
    attrs: {
      "select": _vm.endMinute,
      "items": _vm.minutes
    },
    on: {
      "changed": function($event) {
        return _vm.updatePeriod($event, 'minute', 'end')
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Timepicker',

    props: ['payload'],

    data: function data() {
        return {
            hour: '--',
            minute: '--',
            loading: false
        };
    },


    computed: {
        time: function time() {
            return this.hour + ':' + this.minute;
        },

        minutes: function minutes() {
            return parseInt(this.hour, 10) * 60 + parseInt(this.minute, 10);
        }
    },

    created: function created() {
        this.init();
    },


    watch: {
        payload: function payload() {
            this.init();
        }
    },

    methods: {
        init: function init() {
            if (this.payload && this.payload.time) {
                this.setTime(this.payload.time);
            } else {
                this.reset();
            }
        },

        reset: function reset() {
            this.hour = this.minute = '--';
        },

        setTime: function setTime(time) {
            time = time.split(':');

            this.setHour(time[0]);
            this.setMinute(time[1]);
        },

        setHour: function setHour(hour) {
            this.hour = hour;

            if (this.minute == '--') this.minute = '00';
        },

        setMinute: function setMinute(minute) {
            this.minute = minute;

            if (this.hour == '--') this.hour = '08';
        },

        save: function save() {
            if (this.time != '--:--') {
                this.loading = true;

                if (typeof this.payload.onSave == 'function') {
                    this.payload.onSave(this.time);
                } else {
                    this.close();
                }
            }
        },

        remove: function remove() {
            this.loading = true;

            if (typeof this.payload.onRemove == 'function') {
                this.payload.onRemove(this);
            } else {
                this.close();
            }
        },

        close: function close() {
            this.loading = false;
        }
    }
});

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timepicker"
  }, [_c('table', {
    staticClass: "table table-timepicker equal-padding"
  }, [_c('tr', [_c('td', {
    class: ['box-hour', (_vm.hour == '00') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('00')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '01') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('01')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '02') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('02')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '03') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('03')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '04') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('04')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '05') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('05')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    class: ['box-minute', (_vm.minute == '00') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('00')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("00")])]), _vm._v(" "), _c('tr', [_c('td', {
    class: ['box-hour', (_vm.hour == '06') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('06')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '07') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('07')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '08') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('08')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '09') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('09')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '10') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('10')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '11') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('11')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('td', {
    class: ['box-minute', (_vm.minute == '15') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('15')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('tr', [_c('td', {
    class: ['box-hour', (_vm.hour == '12') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('12')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '13') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('13')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '14') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('14')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '15') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('15')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '16') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('16')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '17') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('17')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('td', {
    class: ['box-minute', (_vm.minute == '30') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('30')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('tr', [_c('td', {
    class: ['box-hour', (_vm.hour == '18') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('18')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '19') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('19')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '20') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('20')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '21') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('21')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '22') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('22')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("22")]), _vm._v(" "), _c('td', {
    class: ['box-hour', (_vm.hour == '23') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('23')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("23")]), _vm._v(" "), _c('td', {
    class: ['box-minute', (_vm.minute == '45') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('45')
      },
      "dblclick": _vm.save
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('tr', {
    staticClass: "box-buttons"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": _vm.remove
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "box-time is-active",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('icon', {
    attrs: {
      "name": "check"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_events__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Toolbox',

    data: function data() {
        return {
            show: false,
            coordinates: {},
            arrowCoordinates: {},
            ready: false,
            posArrow: '',
            type: '',
            toolboxClass: '',
            payload: null,
            replacement: false, // is the payload being replaced?
            hasInput: false
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$on('input.focus', function (focus) {
            _this.hasInput = focus;
        });

        __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$listen('toolbox.payload', function (payload) {
            _this.payload = payload;
            _this.replacement = true;
        });

        __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$listen('toolbox.open', function (type, event, payload) {
            _this.replacement = false;

            if (type == 'tools') {
                var different = false;
                if (payload == null && _this.payload != null) {
                    different = true;
                } else if (payload != null && _this.payload == null) {
                    different = true;
                } else if ((typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(payload)) == 'object' && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(_this.payload) == 'object') {
                    different = payload.id != _this.payload.id;
                } else if (typeof payload == 'string' && typeof _this.payload == 'string') {
                    different = payload != _this.payload;
                } else {
                    different = true;
                }

                if (type != _this.type || !_this.payload || different) {
                    _this.type = type;
                    _this.toolboxClass = _this.$onduro.hasRole('planner') ? 'tools' : 'tools-user';
                    _this.open(event);
                } else {
                    _this.close();
                    return;
                }
            } else if (type == 'timepicker') {
                if (type != _this.type || !_this.payload || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload) != __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.payload)) {
                    _this.type = type;
                    _this.toolboxClass = type;
                    _this.open(event);
                } else {
                    _this.close();
                    return;
                }
            } else if (type == 'calendar') {
                if (type != _this.type || !_this.payload) {
                    _this.type = type;
                    _this.toolboxClass = type;
                    _this.open(event, 'top');
                } else {
                    _this.close();
                    return;
                }
            } else if (type == 'notes') {
                if (type != _this.type || !_this.payload || payload != _this.payload) {
                    _this.type = type;
                    _this.toolboxClass = type;
                    _this.open(event);
                } else {
                    _this.close();
                    return;
                }
            } else if (type == 'chatbox' || type == 'itemchatbox') {
                if (type != _this.type || !_this.payload || payload != _this.payload) {
                    _this.type = type;
                    _this.toolboxClass = type;
                    _this.open(event);
                } else {
                    _this.close();
                    return;
                }
            }

            _this.payload = payload;
        });

        __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$listen('toolbox.close', function () {
            if (_this.show) _this.close();
        });
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
        viewport: function viewport(_ref) {
            var layout = _ref.layout;
            return layout.viewport;
        },
        os: function os(_ref2) {
            var app = _ref2.app;
            return app.os;
        }
    }), {
        tiny: function tiny() {
            return this.viewport !== 'd' && this.viewport !== 'tl' && window.innerHeight < 500;
        }
    }),

    methods: {
        open: function open(event, position) {
            event.stopPropagation();
            this.reset();

            this.setPosition(event, position);

            this.show = true;

            var containerContent = document.querySelector('.container .content');
            var containerContentMain = document.querySelector('.container .content-main');

            // keyboard will trigger resize, so chatbox will be closed immediately
            if (this.type != 'chatbox' && this.type != 'itemchatbox' || !this.$store.state.app.touchDevice) {
                if (containerContent) containerContent.addEventListener('scroll', this.close);
                if (containerContentMain) containerContentMain.addEventListener('scroll', this.close);

                window.addEventListener('resize', this.resizeCLose);
            }

            // do not allow to close tools on click
            if (this.type != 'tools') window.addEventListener('click', this.close);
        },
        reset: function reset() {
            var containerContent = document.querySelector('.container .content');
            var containerContentMain = document.querySelector('.container .content-main');

            if (this.type != 'chatbox' && this.type != 'itemchatbox' || !this.$store.state.app.touchDevice) {
                if (containerContent) containerContent.removeEventListener('scroll', this.close);
                if (containerContentMain) containerContentMain.removeEventListener('scroll', this.close);

                window.removeEventListener('resize', this.close);
            }

            if (this.type != 'tools') window.removeEventListener('click', this.close);

            this.coordinates = {};
            this.arrowCoordinates = {};
            this.posArrow = '';
            this.ready = false;
            this.show = false;
        },
        close: function close() {
            this.hasInput = false;

            if (this.type == 'chatbox' || this.type == 'itemchatbox') __WEBPACK_IMPORTED_MODULE_4__events_events__["a" /* default */].$emit('chatbox.closed');

            this.reset();
            this.payload = null;
            this.type = '';
        },
        resizeClose: function resizeClose() {
            if (!this.hasInput) this.close();
        },
        setPosition: function setPosition(event, position) {
            var _this2 = this;

            if (typeof this.$refs.toolbox === 'undefined') return;

            var body = document.querySelector('body'),
                offset = this.getOffset(event.currentTarget),
                scroll = this.getScroll(event.currentTarget),
                itemHeight = event.currentTarget.offsetHeight,
                itemWidth = event.currentTarget.offsetWidth,
                arrowHeight = 10;

            var coordinates = {
                top: offset.y + scroll.y + Math.round(itemHeight / 2) + 'px',
                left: offset.x + scroll.x + Math.round(itemWidth / 2) + 'px'
            };

            this.$set(this.coordinates, 'top', coordinates.top);
            this.$set(this.coordinates, 'left', coordinates.left);

            this.$nextTick(function () {
                var toolboxHeight = _this2.$refs.toolbox.offsetHeight,
                    toolboxWidth = _this2.$refs.toolbox.offsetWidth,
                    bounds = _this2.$refs.toolbox.getBoundingClientRect(),
                    transX = 'translateX(-' + scroll.x + 'px)',
                    transY = 'translateY(-' + scroll.y + 'px)',
                    posX = 0,
                    // always position in center
                posY = itemHeight / 2 + toolboxHeight / 2 + arrowHeight + scroll.y,
                    top = bounds.top - posY,
                    bottom = body.clientHeight + scroll.y - (bounds.bottom + posY);

                // check Y (vertical)
                if (top > 0) {
                    transY = 'translateY(-' + Math.round(posY) + 'px)';
                    _this2.posArrow = 'is-bottom';
                } else if (bottom + scroll.y > 0) {
                    transY = 'translateY(' + Math.round(posY - scroll.y * 2) + 'px)';
                    _this2.posArrow = 'is-top';
                } else // if (bounds.top < 0 || body.clientHeight - bounds.bottom < 0)
                    {
                        _this2.coordinates.top = 0;
                        transY = 'translateY(50%)';
                    }

                // console.info(
                //     'bounds.left', bounds.left,
                //     'bounds.right', bounds.right,
                //     'body.clientWidth', body.clientWidth,
                //     'scroll.x', scroll.x,
                //     'body.clientWidth + scroll.x', body.clientWidth + scroll.x
                // );

                // if bounds over the right side
                if (bounds.right > body.clientWidth + scroll.x) {
                    // console.info('RIGHT');
                    posX = bounds.right - body.clientWidth;

                    transX = 'translateX(' + Math.round(posX * -1) + 'px)';

                    var arrowX = Math.round(bounds.right - (body.clientWidth + scroll.x));

                    if (arrowX - itemWidth >= -10) {
                        arrowX -= itemWidth / 2 - 10;
                    }

                    _this2.arrowCoordinates = {
                        transform: 'translateX(-50%) translateX(' + arrowX + 'px)'
                    };
                }

                // if bounds over the left side
                else if (bounds.left < scroll.x) {
                        // console.info('LEFT');
                        posX = bounds.left;

                        transX = 'translateX(' + Math.round(posX * -1) + 'px)';

                        var _arrowX = Math.round(bounds.left - scroll.x);

                        if (_arrowX + itemWidth <= 10) {
                            _arrowX += itemWidth / 2 - 10;
                        }

                        _this2.arrowCoordinates = {
                            transform: 'translateX(-50%) translateX(' + _arrowX + 'px)'
                        };
                    }

                if (position == 'top') {
                    _this2.posArrow = 'is-top';
                    _this2.$set(_this2.coordinates, 'transform', 'translate(-50%, 0) translateY(20px) ' + transX);
                } else {
                    _this2.$set(_this2.coordinates, 'transform', 'translate(-50%, -50%) ' + transY + ' ' + transX);
                }

                _this2.ready = true;
            });
        },
        getOffset: function getOffset(el) {
            el = el.getBoundingClientRect();

            var xPos = 0,
                yPos = 0;

            return {
                x: el.left,
                y: el.top
            };
        },
        getScroll: function getScroll(el) {
            var node = el,
                scrollX = 0,
                scrollY = 0;

            while (node.parentNode) {
                node = node.parentNode;

                scrollX += node.scrollLeft || 0;
                scrollY += node.scrollTop || 0;
            }

            return {
                x: Math.round(scrollX),
                y: Math.round(scrollY)
            };
        }
    },

    components: {
        'tools': __webpack_require__(314),
        'notes': __webpack_require__(299),
        'calendar': __webpack_require__(282),
        'timepicker': __webpack_require__(312),
        'chatbox': __webpack_require__(82),
        'itemchatbox': __webpack_require__(297)
    }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Tools',

    props: ['payload', 'replacement'],

    data: function data() {
        return {
            tabs: [],
            activeTab: 'times',
            mobileAdd: false,
            shared: __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__["a" /* default */].state,
            initialized: false,
            showTrash: false
        };
    },
    created: function created() {
        var _this = this;

        this.init();

        // $listen will make sure that event is not being registered multiple times
        __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$listen('toolbox.tab', function (tab) {
            _this.setTab(tab);
        });

        window.addEventListener('keydown', this.keyHandler, false);
        window.addEventListener('keyup', this.keyHandler, false);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('keydown', this.keyHandler, false);
        window.removeEventListener('keyup', this.keyHandler, false);
    },


    watch: {
        payload: function payload() {
            this.init();
        }
    },

    computed: {
        activeDuties: function activeDuties() {
            return _.filter(this.shared.duties, { trashed: false });
        },
        activeShifts: function activeShifts() {
            return _.filter(this.shared.shifts, { trashed: false });
        },
        showUsers: function showUsers() {
            if (this.payload.resource || !this.$onduro.getConfig('restrict.planner')) return true;
            if (this.payload.applications.length) return true;
            return false;
        },


        // number of visible tabs
        visible: function visible() {
            if (!this.tabs.length) return 0;

            return _.reduce(this.tabs, function (count, tab) {
                return tab.show ? count + 1 : count;
            }, 0);
        }
    },

    methods: {
        init: function init() {
            this.initialized = false;

            // reset tab
            this.activeTab = 'times';

            var item = this.payload;

            this.mobileAdd = (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) == 'object' ? false : true;

            if (this.mobileAdd) {
                this.tabs = [{
                    name: 'new-user',
                    icon: 'person',
                    show: this.showUsers
                }, {
                    name: 'new-shift',
                    icon: 'menu',
                    show: this.$onduro.hasModule('shifts') && !this.activeDuties.length
                }, {
                    name: 'new-duty',
                    icon: 'briefcase',
                    show: this.activeDuties.length
                }];

                this.activeTab = 'new-user';
            } else {
                this.tabs = [{
                    name: 'flags',
                    icon: 'warning',
                    show: item.flag == 'signout'
                }, {
                    name: 'conflicts',
                    icon: 'warning',
                    show: item.conflicts
                }, {
                    name: 'times',
                    icon: 'clock',
                    show: true
                }, {
                    name: 'shift',
                    icon: 'shifts',
                    show: this.$onduro.hasModule('shifts') && this.activeShifts.length
                }, {
                    name: 'duty',
                    icon: 'briefcase',
                    show: this.activeDuties.length // TODO: might need to check here already, if a legacy/trashed duty has previously been set on the item, then we might need to show duty selection here
                }, {
                    name: 'user',
                    icon: item.resource ? 'car' : 'person',
                    show: this.showUsers
                }, {
                    name: 'tags',
                    icon: 'tag',
                    show: this.$onduro.hasModule('tags') && !item.resource
                }, {
                    name: 'notes',
                    icon: 'attach',
                    show: true
                }, {
                    name: 'internal',
                    icon: 'eye_off',
                    show: true
                }, {
                    name: 'sick',
                    icon: 'ambulance',
                    show: this.$onduro.hasModule('sickness') && item.assigned && !item.resource
                }, {
                    name: 'delete',
                    icon: 'delete',
                    show: this.$store.state.app.touchDevice,
                    class: 'tab-delete'
                }, {
                    name: 'project',
                    icon: 'project',
                    show: this.$onduro.hasModule('projects')
                }];

                // no other tab has been set
                if (!this.replacement && this.activeTab == 'times') {
                    // set default tab
                    var tab = 'times';

                    if (!item.assigned) this.activeTab = 'user';

                    if (_.size(this.shared.shifts) && !item.shift && !item.times) tab = 'shift';

                    if (_.size(this.shared.duties) && !item.duty) tab = 'duty';

                    if (item.times || item.shift) tab = 'user';

                    // set tab to flags, if action is required!
                    if (item.flag == 'signout') tab = 'flags';

                    if (item.flag == 'sick') tab = 'sick';

                    // does item has conflict?
                    if (item.conflicts) tab = 'conflicts';

                    this.setTab(tab);
                }
            }

            this.initialized = true;
        },

        setTab: function setTab(tab) {
            // check if tab is available at all
            tab = _.find(this.tabs, { name: tab });

            if (tab && tab.show) {
                this.activeTab = tab.name;
            } else {
                // it's always safe to set the active tab to "times"
                this.activeTab = 'times';
            }
        },
        keyHandler: function keyHandler(e) {
            if (e.keyCode == 18) {
                this.showTrash = e.type == 'keydown' ? true : false;
            }
        },
        toggleActive: function toggleActive(type) {
            if (type == 'delete') {
                this.deleteItem(this.payload);
                return;
            }

            this.activeTab = type;
        },
        trash: function trash() {
            this.forceDelete(this.payload);
        },
        deleteItem: function deleteItem(item) {
            var _this2 = this;

            this.$confirm.show(this.$t('tools.remove_item.headline'), this.$t('tools.remove_item.text'), {
                confirm: function confirm() {
                    _this2.forceDelete(item);
                }
            });
        },
        forceDelete: function forceDelete(item) {
            var _this3 = this;

            this.$http.delete('/api/items/' + item.id).then(function (response) {
                var key = _.findIndex(_this3.shared.items, { id: item.id });

                __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('recalculate', item.date);

                // remove item
                _this3.$delete(_this3.shared.items, key);

                _this3.$tools.close();
            }).catch(function (error) {
                switch (error.response.data.error) {
                    case 'ERR_CONFIRMED':
                        // hours have already been entered and confirmed
                        _this3.$modal.show(_this3.$t('page.roster.item.delete.error.headline'), _this3.$t('page.roster.move.error.ERR_CONFIRMED'));

                        _this3.$tools.close();
                        break;

                    case 'ERR_OPEN_CHECKIN':
                        // item has an open checkin, needs to be checked-out first
                        _this3.$modal.show(_this3.$t('page.roster.item.delete.error.headline'), _this3.$t('page.roster.move.error.ERR_OPEN_CHECKIN'));

                        _this3.$tools.close();
                        break;

                    case 'ERR_HOURS':
                        _this3.$confirm.show(_this3.$t('page.roster.item.has_hours.headline'), _this3.$t('page.roster.item.delete.ERR_HOURS'), {
                            confirm: function confirm() {
                                _this3.$http.delete('/api/items/' + item.id, {
                                    params: {
                                        force: true
                                    }
                                }).then(function (response) {
                                    var key = _.findIndex(_this3.shared.items, { id: item.id });

                                    // remove item
                                    _this3.$delete(_this3.shared.items, key);

                                    _this3.$tools.close();
                                });
                            }
                        });
                        break;

                    case "ERR_HOURS_CONFIRMED":
                        // make this a confirmation!
                        _this3.$confirm.show(_this3.$t('page.roster.item.has_hours.headline'), _this3.$t('page.roster.item.delete.ERR_CONFIRMED'), {
                            confirm: function confirm() {
                                _this3.$http.delete('/api/items/' + item.id, {
                                    params: {
                                        force: true
                                    }
                                }).then(function (response) {
                                    var key = _.findIndex(_this3.shared.items, { id: item.id });

                                    // remove item
                                    _this3.$delete(_this3.shared.items, key);

                                    _this3.$tools.close();
                                });
                            }
                        });
                        break;
                }
            });
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('toolbox.close');
        }
    },

    components: {
        tabNotes: __webpack_require__(315),
        tabInternal: __webpack_require__(316),
        tabConflicts: __webpack_require__(317),
        tabTimes: __webpack_require__(318),
        tabShift: __webpack_require__(319),
        tabDuty: __webpack_require__(320),
        tabUser: __webpack_require__(321),
        tabTags: __webpack_require__(322),
        tabSick: __webpack_require__(323),
        tabProject: __webpack_require__(324),
        tabFlags: __webpack_require__(325),
        employee: __webpack_require__(326),
        tabNewShift: __webpack_require__(327),
        tabNewDuty: __webpack_require__(328),
        tabNewUser: __webpack_require__(329)
    }
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Notes',

    props: ['item'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__["a" /* default */].state,
            notes: ''
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
        android: function android(_ref) {
            var app = _ref.app;
            return app.os === 'android';
        }
    })),

    created: function created() {
        this.notes = this.item.notes;
    },


    methods: {
        save: function save(remove) {
            var _this = this;

            var notes = remove ? '' : this.notes;

            this.$http.put('/api/items/' + this.item.id + '/notes', {
                notes: notes // be explicit :)
            }).then(function (response) {
                // update item and local property
                _this.item.notes = notes;
                _this.notes = notes;

                _this.$tools.close();
            });
        },
        remove: function remove() {
            this.save(true); // remove
        },
        handleKeys: function handleKeys(e) {
            // no CTRL or CMD key pressed
            if (!(e.metaKey || e.ctrlKey)) return;

            var key = e.which || e.keyCode || 0;

            // select all (CTRL+A)
            if (key == 65) {
                // prevent roster items from being selected
                e.stopPropagation();
            }
        },
        focus: function focus() {
            if (this.android) __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('input.focus', true);
        }
    }
});

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-notes"
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.$t('tooltip.roster.tools.notes')),
      expression: "$t('tooltip.roster.tools.notes')"
    }],
    attrs: {
      "name": "info"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    attrs: {
      "placeholder": _vm.$t('tooltip.roster.tools.notes'),
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "keydown": _vm.handleKeys,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.item.notes) ? _c('a', {
    staticClass: "remove btn btn--red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.remove()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.delete')))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn--green",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.save')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Internal',

    props: ['item'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__["a" /* default */].state,
            internal: ''
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
        android: function android(_ref) {
            var app = _ref.app;
            return app.os === 'android';
        }
    })),

    created: function created() {
        this.internal = this.item.internal;
    },


    methods: {
        save: function save(remove) {
            var _this = this;

            var internal = remove ? '' : this.internal;

            this.$http.put('/api/items/' + this.item.id + '/internal', {
                internal: internal // be explicit :)
            }).then(function (response) {
                // update item and local property
                _this.item.internal = internal;
                _this.internal = internal;

                _this.$tools.close();
            });
        },
        remove: function remove() {
            this.save(true); // remove
        },
        handleKeys: function handleKeys(e) {
            // no CTRL or CMD key pressed
            if (!(e.metaKey || e.ctrlKey)) return;

            var key = e.which || e.keyCode || 0;

            // select all (CTRL+A)
            if (key == 65) {
                // prevent roster items from being selected
                e.stopPropagation();
            }
        },
        focus: function focus() {
            if (this.android) __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('input.focus', true);
        }
    }
});

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-notes tools-tab-notes--internal"
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.$t('tooltip.roster.internal')),
      expression: "$t('tooltip.roster.internal')"
    }],
    attrs: {
      "name": "info"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.internal),
      expression: "internal"
    }],
    attrs: {
      "placeholder": _vm.$t('tooltip.roster.internal'),
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.internal)
    },
    on: {
      "keydown": _vm.handleKeys,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.internal = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.item.internal) ? _c('a', {
    staticClass: "remove btn btn--red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.remove()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.delete')))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn--green",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.save')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Conflict',

    props: ['item'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_0__pages_planning_shared__["a" /* default */].state
        };
    },


    computed: {
        conflicts: function conflicts() {
            return this.item.conflicts;
        }
    },

    methods: {
        resolve: function resolve(conflict) {
            var _this = this;

            this.$http.delete('/api/items/' + this.item.id + '/conflicts', {
                data: {
                    conflict: conflict
                }
            }).then(function (response) {
                _this.$delete(_this.item.conflicts, _this.conflicts.indexOf(conflict));

                if (!_this.conflicts.length) {
                    _this.$set(_this.item, 'conflicts', null);
                    _this.$tools.close();
                }
            }).catch(function (error) {
                if (error.response.data.message == 'NOT_AVAILABLE') {
                    var user = __WEBPACK_IMPORTED_MODULE_0__pages_planning_shared__["a" /* default */].getUser(_this.item.user);

                    // user is not available, disallow scheduling!
                    _this.$modal.show(_this.$t('page.roster.add.error.headline'), user.name + ' ' + _this.$t('page.roster.add.error.ERR_UNAVAILABLE_DENY'));
                }
            });
        },
        isResolvable: function isResolvable(conflict) {
            return ['ERR_HOURS', 'ERR_CONFIRMED', 'ERR_OVERLAP_REST', 'ERR_OPEN_CHECKIN'].indexOf(conflict) != -1;
        },
        hasConflict: function hasConflict(conflict) {
            if (!this.conflicts) return false;

            return this.conflicts.indexOf(conflict) != -1;
        }
    }
});

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-conflicts"
  }, [_c('span', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.$t('conflict.message')))]), _vm._v(" "), _c('ul', _vm._l((_vm.conflicts), function(conflict) {
    return _c('li', [_vm._v("\n            " + _vm._s(_vm.$t('conflict.' + conflict)) + "\n            "), (_vm.isResolvable(conflict)) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.resolve(conflict)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.button.okay')))]) : _vm._e(), _vm._v(" "), (conflict == 'AVAILABILITY') ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.resolve(conflict)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('page.roster.undroppable.confirm')))]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Times',

    props: ['item'],

    data: function data() {
        return {
            type: 'from',
            shared: __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].state,
            pause: false,

            form: {
                from: null,
                until: null,
                break: 0
            }
        };
    },
    created: function created() {
        this.init();
    },


    watch: {
        item: function item() {
            this.init();
        }
    },

    computed: {
        hour: function hour() {
            return this.type == 'from' ? this.fromHour : this.untilHour;
        },
        minute: function minute() {
            return this.type == 'from' ? this.fromMinute : this.untilMinute;
        },
        fromHour: function fromHour() {
            return this.form.from && this.form.from.split(':')[0];
        },
        fromMinute: function fromMinute() {
            return this.form.from && this.form.from.split(':')[1];
        },
        untilHour: function untilHour() {
            return this.form.until && this.form.until.split(':')[0];
        },
        untilMinute: function untilMinute() {
            return this.form.until && this.form.until.split(':')[1];
        },
        start: function start() {
            return this.$onduro.timeToNumber(this.form.from);
        },
        end: function end() {
            return this.$onduro.timeToNumber(this.form.until);
        },
        timed: function timed() {
            return this.form.from != null && this.form.until != null;
        }
    },

    methods: {
        init: function init() {
            if (this.item.times) {
                this.type = 'from';

                this.form = {
                    from: this.item.times.from,
                    until: this.item.times.until,
                    break: this.item.times.break
                };
            } else {
                this.reset();
            }
        },
        reset: function reset() {
            this.type = 'from';

            this.form = {
                from: null,
                until: null,
                break: 0
            };
        },


        setPause: function setPause(value) {
            this.form.break = value;
            this.pause = false;
        },

        isHour: function isHour(hour) {
            if (this.pause) return;

            return this.hour == hour;
        },

        setHour: function setHour(hour) {
            if (this.pause) return;

            // get current minute
            var minute = !this.minute ? '00' : this.minute;

            this.setTime(hour, minute);
        },

        isMinute: function isMinute(minute) {
            if (this.pause) return;

            return this.minute == minute;
        },

        setMinute: function setMinute(minute) {
            if (this.pause) return;

            // get current hour
            var hour = !this.hour ? '08' : this.hour;

            this.setTime(hour, minute);
        },

        setTime: function setTime(hour, minute) {
            if (this.type == 'from') {
                this.form.from = hour + ':' + minute;
            } else {
                this.form.until = hour + ':' + minute;
            }
        },

        updateUserStats: function updateUserStats(item) {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('recalculate', item.date);

            if (!item.assigned) return;

            __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].getUser(item.user).stats = item.stats;
        },
        save: function save(confirmed) {
            var _this = this;

            if (__WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].hasApplications(this.item)) return;

            if (this.type == 'from' && this.form.from != null) {
                this.type = 'until';
                return;
            }

            if (this.timed) {
                this.$http.put('/api/items/' + this.item.id + '/times', {
                    start: this.start,
                    end: this.end,
                    break: this.form.break,
                    confirmed: confirmed
                }).then(function (response) {
                    var key = _.findIndex(_this.shared.items, { id: _this.item.id });

                    // replace item
                    _this.$set(_this.shared.items, key, response.data.item);

                    // revalidate conflicts
                    __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].revalidate(response.data.revalidated);

                    _this.updateUserStats(response.data.item);

                    _this.$tools.close();
                }).catch(function (error) {
                    var user = __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].getUser(_this.item.user);

                    switch (error.response.data.error) {
                        case 'ERR_EQUAL':
                            // start and end times must differ
                            _this.$modal.show(_this.$t('page.roster.time.error.headline'), _this.$t('page.roster.time.error.ERR_EQUAL'));
                            break;

                        case 'ERR_NEGATIVE':
                            // duration cannot be negative
                            _this.$modal.show(_this.$t('page.roster.time.error.headline'), _this.$t('page.roster.time.error.ERR_NEGATIVE'));
                            break;

                        case 'ERR_OVERLAP':
                        case 'ERR_EXISTING_FULL':
                            // cannot add hours because they overlap with another item
                            _this.$modal.show(_this.$t('page.roster.time.error.headline'), user.name + ' ' + _this.$t('page.roster.time.error.ERR_OVERLAP'));
                            break;

                        case 'ERR_OVERLAP_REST':
                            // overlap in resting period of another item of user
                            _this.$confirm.show(_this.$t('page.roster.time.error.headline'), _this.$t('confirm.resting.conflict', { name: user.name }), {
                                confirm: function confirm() {
                                    _this.save('OVERRULE_REST');
                                }
                            });
                            break;

                        case 'ERR_CONFIRMED':
                            // cannot remove times because hours have already been confirmed
                            _this.$modal.show(_this.$t('page.roster.time.error.headline'), _this.$t('page.roster.time.error.ERR_CONFIRMED'));

                            _this.init();
                            break;

                        case 'ERR_UNAVAILABLE_LIMITED':
                            // user is limited available, schedule anyway?
                            _this.$confirm.show(_this.$t('page.roster.add.error.headline_limited'), user.name + ' ' + _this.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'), {
                                confirm: function confirm() {
                                    _this.save(true);
                                }
                            });
                            break;
                    }
                });
            }
        },
        remove: function remove(force, confirmed) {
            var _this2 = this;

            if (__WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].hasApplications(this.item)) return;

            if (this.item.times && this.item.times.from && this.item.times.until) {
                // ------------------------------------------------------
                // remove times only

                this.$http.delete('/api/items/' + this.item.id + '/times', {
                    params: {
                        force: force,
                        confirmed: confirmed
                    }
                }).then(function (response) {
                    var key = _.findIndex(_this2.shared.items, { id: _this2.item.id });

                    if (response.data) {
                        // replace item
                        _this2.$set(_this2.shared.items, key, response.data.item);

                        _this2.updateUserStats(response.data.item);

                        // revalidate conflicts
                        __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].revalidate(response.data.revalidated);
                    } else {
                        // remove userless, dutlyess item
                        _this2.$delete(_this2.shared.items, key);
                    }

                    _this2.$tools.close();
                }).catch(function (error) {
                    var user = __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].getUser(_this2.item.user);

                    switch (error.response.data.error) {
                        case 'ERR_SICK':
                            // cannot remove times, because assigned user has been marked sick
                            _this2.$modal.show(_this2.$t('page.roster.time.delete.error.headline'), _this2.$t('page.roster.sick.ERR_TIME.text'));
                            break;

                        case 'ERR_OVERLAP':
                            // cannot remove time, because full day item would overlap with other existing items
                            _this2.$modal.show(_this2.$t('page.roster.time.delete.error.headline'), user.name + ' ' + _this2.$t('page.roster.time.error.ERR_OVERLAP_REMOVAL'));
                            break;

                        case 'ERR_OVERLAP_REST':
                            // overlap in resting period of another item of user
                            _this2.$confirm.show(_this2.$t('page.roster.time.delete.error.headline'), _this2.$t('confirm.resting.conflict', { name: user.name }), {
                                confirm: function confirm() {
                                    _this2.remove(force, 'OVERRULE_REST');
                                }
                            });
                            break;

                        case 'ERR_CONFIRMED':
                            // cannot remove item, because hours have been approved
                            _this2.$modal.show(_this2.$t('page.roster.time.delete.error.headline'), _this2.$t('page.roster.shift.error.ERR_CONFIRMED'));

                            _this2.init();
                            break;

                        case 'ERR_OPEN_CHECKIN':
                            // item has an open checkin, needs to be checked-out first
                            _this2.$modal.show(_this2.$t('page.roster.item.delete.error.headline'), _this2.$t('page.roster.move.error.ERR_OPEN_CHECKIN'));
                            break;

                        case 'ERR_UNAVAILABLE_LIMITED':
                            // user is limited available, schedule anyway?
                            _this2.$confirm.show(_this2.$t('page.roster.add.error.headline_limited'), user.name + ' ' + _this2.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'), {
                                confirm: function confirm() {
                                    _this2.remove(force, true); // set confirmed = true;
                                }
                            });
                            break;
                    }
                });
            } else if (this.form.from != null || this.form.until != null) {
                this.reset();
            } else {
                // ------------------------------------------------------
                // remove item completely

                this.$confirm.show(this.$t('tools.remove_item.headline'), this.$t('tools.remove_item.text'), {
                    confirm: function confirm() {
                        _this2.$http.delete('/api/items/' + _this2.item.id, {
                            params: {
                                force: force,
                                confirmed: confirmed
                            }
                        }).then(function (response) {
                            var key = _.findIndex(_this2.shared.items, { id: _this2.item.id });

                            // remove item
                            _this2.$delete(_this2.shared.items, key);

                            _this2.$tools.close();
                        }).catch(function (error) {
                            switch (error.response.data.error) {
                                case 'ERR_CONFIRMED':
                                    // hours have already been entered and confirmed
                                    _this2.$modal.show(_this2.$t('page.roster.item.delete.error.headline'), _this2.$t('page.roster.move.error.ERR_CONFIRMED'));
                                    break;

                                case 'ERR_OPEN_CHECKIN':
                                    // item has an open checkin, needs to be checked-out first
                                    _this2.$modal.show(_this2.$t('page.roster.item.delete.error.headline'), _this2.$t('page.roster.move.error.ERR_OPEN_CHECKIN'));
                                    break;

                                case 'ERR_HOURS':
                                    _this2.$confirm.show(_this2.$t('page.roster.item.has_hours.headline'), _this2.$t('page.roster.item.delete.ERR_HOURS'), {
                                        confirm: function confirm() {
                                            _this2.remove(true, confirmed); // set force = true;
                                        }
                                    });
                                    break;

                                case 'ERR_UNAVAILABLE_LIMITED':
                                    // user is limited available, schedule anyway?
                                    _this2.$confirm.show(_this2.$t('page.roster.add.error.headline_limited'), user.name + ' ' + _this2.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'), {
                                        confirm: function confirm() {
                                            _this2.remove(force, true); // set confirmed = true;
                                        }
                                    });
                                    break;
                            }
                        });
                    }
                });
            }
        }
    }
});

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-time"
  }, [_c('table', {
    staticClass: "table table-timepicker equal-padding"
  }, [_c('tr', {
    class: _vm.pause ? 'is-disabled' : ''
  }, [_c('td', {
    class: ['box-hour', _vm.isHour('00') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('00')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('01') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('01')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('02') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('02')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('03') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('03')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('04') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('04')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('05') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('05')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    class: ['box-minute', _vm.isMinute('00') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('00')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("00")])]), _vm._v(" "), _c('tr', {
    class: _vm.pause ? 'is-disabled' : ''
  }, [_c('td', {
    class: ['box-hour', _vm.isHour('06') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('06')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('07') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('07')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('08') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('08')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('09') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('09')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('10') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('10')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('11') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('11')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('td', {
    class: ['box-minute', _vm.isMinute('15') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('15')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('tr', {
    class: _vm.pause ? 'is-disabled' : ''
  }, [_c('td', {
    class: ['box-hour', _vm.isHour('12') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('12')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('13') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('13')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('14') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('14')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('15') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('15')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('16') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('16')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('17') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('17')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('td', {
    class: ['box-minute', _vm.isMinute('30') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('30')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('tr', {
    class: _vm.pause ? 'is-disabled' : ''
  }, [_c('td', {
    class: ['box-hour', _vm.isHour('18') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('18')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('19') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('19')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('20') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('20')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('21') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('21')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('22') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('22')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("22")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('23') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('23')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("23")]), _vm._v(" "), _c('td', {
    class: ['box-minute', _vm.isMinute('45') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('45')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("45")])]), _vm._v(" "), (_vm.pause) ? _c('tr', {
    staticClass: "break"
  }, [_c('td', {
    staticClass: "box-break",
    on: {
      "click": function($event) {
        _vm.pause = false
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "food"
    }
  })], 1), _vm._v(" "), _c('td', {
    class: ['box-break', (!_vm.form.break) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(0)
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 15) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(15)
      }
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 30) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(30)
      }
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 45) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(45)
      }
    }
  }, [_vm._v("45")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 60) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(60)
      }
    }
  }, [_vm._v("60")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 75) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(75)
      }
    }
  }, [_vm._v("75")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 90) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(90)
      }
    }
  }, [_vm._v("90")])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "box-buttons"
  }, [_c('td', {
    on: {
      "click": function($event) {
        return _vm.remove()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('td', {
    class: ['time', (_vm.type == 'from') ? 'is-active' : ''],
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.type = 'from'
      }
    }
  }, [_c('div', {
    class: ['label', _vm.form.from == null ? 'is-big' : '']
  }, [_vm._v(_vm._s(_vm.$t('text.from')))]), _vm._v(" "), (_vm.form.from != null) ? _c('span', [_vm._v(_vm._s(_vm.form.from))]) : _vm._e()]), _vm._v(" "), _c('td', {
    class: ['time', (_vm.type == 'until') ? 'is-active' : ''],
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.type = 'until'
      }
    }
  }, [_c('div', {
    class: ['label', _vm.form.until == null ? 'is-big' : '']
  }, [_vm._v(_vm._s(_vm.$t('text.until')))]), _vm._v(" "), (_vm.form.until != null) ? _c('span', [_vm._v(_vm._s(_vm.form.until))]) : _vm._e()]), _vm._v(" "), _c('td', {
    class: ['btn-break', _vm.form.break ? 'has-break' : ''],
    on: {
      "click": function($event) {
        _vm.pause = true;
        _vm.type = 'break'
      }
    }
  }, [(_vm.form.break) ? _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('label.break')))]) : _vm._e(), _vm._v(" "), (_vm.form.break) ? _c('span', [_vm._v(_vm._s(_vm.form.break) + "m")]) : _c('icon', {
    attrs: {
      "name": "food"
    }
  })], 1), _vm._v(" "), _c('td', {
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "check"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Shift',

    props: ['item'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].state
        };
    },


    computed: {
        activeShifts: function activeShifts() {
            // TODO: might need to add legacy shift as well, if previously assigned!
            return _.filter(this.shared.shifts, { trashed: false });
        },
        shifts: function shifts() {
            return _.sortBy(this.shared.shifts, ['name']);
        }
    },

    methods: {
        hasShift: function hasShift(shift) {
            return shift.id == this.item.shift;
        },
        select: function select(shift) {
            if (this.hasShift(shift)) {
                this.remove(shift);
            } else {
                this.add(shift);
            }
        },
        updateUserStats: function updateUserStats(item) {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('recalculate', item.date);

            if (!item.assigned) return;

            __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].getUser(item.user).stats = item.stats;
        },
        add: function add(shift, confirmed) {
            var _this = this;

            if (__WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].hasApplications(this.item)) return;

            this.$http.put('/api/items/' + this.item.id + '/shift', {
                shift: shift.id,
                confirmed: confirmed
            }).then(function (response) {
                var key = _.findIndex(_this.shared.items, { id: _this.item.id });

                // replace item
                _this.$set(_this.shared.items, key, response.data);

                _this.updateUserStats(response.data);

                _this.$tools.close();
            }).catch(function (error) {
                var user = __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].getUser(_this.item.user);

                switch (error.response.data.error) {
                    case 'ERR_CONFIRMED':
                        _this.$modal.show(_this.$t('page.roster.shift.error.headline'), _this.$t('page.roster.shift.error.ERR_CONFIRMED'));
                        break;

                    case 'ERR_OVERLAP':
                        _this.$modal.show(_this.$t('page.roster.shift.error.headline'), user.name + ' ' + _this.$t('page.roster.shift.error.ERR_OVERLAP'));
                        break;

                    case 'ERR_OVERLAP_REST':
                        // overlap in resting period of another item of user
                        _this.$confirm.show(_this.$t('page.roster.shift.error.headline'), _this.$t('confirm.resting.conflict', { name: user.name }), {
                            confirm: function confirm() {
                                _this.add(shift, 'OVERRULE_REST');
                            }
                        });
                        break;

                    case 'ERR_UNAVAILABLE_LIMITED':
                        // user is limited available, schedule anyway?
                        _this.$confirm.show(_this.$t('page.roster.add.error.headline_limited'), user.name + ' ' + _this.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'), {
                            confirm: function confirm() {
                                _this.add(shift, true);
                            }
                        });
                        break;
                }
            });
        },
        remove: function remove(shift, confirmed) {
            var _this2 = this;

            if (__WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].hasApplications(this.item)) return;

            this.$http.delete('/api/items/' + this.item.id + '/shift', {
                params: {
                    confirmed: confirmed
                }
            }).then(function (response) {
                _this2.item.shift = null;
                _this2.item.times = null;

                _this2.updateUserStats(_this2.item);

                _this2.$tools.close();
            }).catch(function (error) {
                var user = __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].getUser(_this2.item.user);

                switch (error.response.data.error) {
                    case 'ERR_SICK':
                        // cannot remove times, because assigned user has been marked sick
                        _this2.$modal.show(_this2.$t('page.roster.time.delete.error.headline'), _this2.$t('page.roster.sick.ERR_TIME.text'));
                        break;

                    case 'ERR_OVERLAP':
                        // cannot remove time, because full day item would overlap with other existing items
                        _this2.$modal.show(_this2.$t('page.roster.time.delete.error.headline'), user.name + ' ' + _this2.$t('page.roster.time.error.ERR_OVERLAP_REMOVAL'));
                        break;

                    case 'ERR_OVERLAP_REST':
                        // overlap in resting period of another item of user
                        _this2.$confirm.show(_this2.$t('page.roster.time.delete.error.headline'), _this2.$t('confirm.resting.conflict', { name: user.name }), {
                            confirm: function confirm() {
                                _this2.remove(shift, 'OVERRULE_REST');
                            }
                        });
                        break;

                    case 'ERR_CONFIRMED':
                        // cannot remove item, because hours have been approved
                        _this2.$modal.show(_this2.$t('page.roster.time.delete.error.headline'), _this2.$t('page.roster.shift.error.ERR_CONFIRMED'));
                        break;

                    case 'ERR_UNAVAILABLE_LIMITED':
                        // user is limited available, remove anyway?
                        _this2.$confirm.show(_this2.$t('page.roster.add.error.headline_limited'), user.name + ' ' + _this2.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'), {
                            confirm: function confirm() {
                                _this2.remove(shift, true);
                            }
                        });
                        break;
                }
            });
        }
    }
});

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-shift"
  }, [_c('ul', {
    staticClass: "list list-shifts"
  }, _vm._l((_vm.activeShifts), function(shift) {
    return _c('li', {
      class: [_vm.hasShift(shift) ? 'is-active' : ''],
      on: {
        "click": function($event) {
          return _vm.select(shift)
        }
      }
    }, [_c('em', [_vm._v(_vm._s(shift.identifier))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(shift.name))]), _vm._v(" "), (_vm.hasShift(shift)) ? _c('icon', {
      attrs: {
        "name": "delete"
      }
    }) : _c('icon', {
      attrs: {
        "name": "add"
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.shifts.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.settings.shifts.empty')) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Duty',

    props: ['item'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].state
        };
    },


    computed: {
        activeDuties: function activeDuties() {
            // TODO: might need to add legacy duty as well, if previously assigned!
            return _.filter(this.shared.duties, { trashed: false });
        },


        // only show duties for this user
        duties: function duties() {
            // no user set? return all duties!
            if (!this.item.assigned) return this.sort(this.activeDuties);

            return this.sort(this.filter(this.activeDuties));
        }
    },

    methods: {
        filter: function filter(duties) {
            // get all duties of assigned user
            var user = __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].getUser(this.item.user);

            return _.filter(duties, function (duty) {
                return user.duties.indexOf(duty.id) !== -1;
            });
        },
        sort: function sort(duties) {
            return _.sortBy(duties, ['name']);
        },
        hasDuty: function hasDuty(duty) {
            return duty.id == this.item.duty;
        },
        select: function select(duty) {
            var _this = this;

            if (__WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].hasApplications(this.item)) return;

            this.$http.put('/api/items/' + this.item.id + '/duty', {
                duty: duty.id
            }).then(function (response) {
                var key = _.findIndex(_this.shared.items, { id: _this.item.id });

                // replace item
                _this.$set(_this.shared.items, key, response.data);

                _this.$tools.replacePayload(response.data);

                __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('recalculate', response.data.date);

                // this.$tools.close();
            }).catch(function (error) {
                switch (error.response.data.error) {
                    case 'ERR_CONFIRMED':
                        // cannot remove times because hours have already been confirmed
                        _this.$modal.show(_this.$t('page.roster.duty.error.headline'), _this.$t('page.roster.time.error.ERR_CONFIRMED'));
                        break;
                }
            });
        }
    }
});

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-duty"
  }, [_c('ul', {
    staticClass: "list list-duties"
  }, _vm._l((_vm.duties), function(duty) {
    return _c('li', {
      class: [_vm.hasDuty(duty) ? 'is-active' : ''],
      on: {
        "click": function($event) {
          return _vm.select(duty)
        }
      }
    }, [_c('em', {
      style: ('background:' + duty.color)
    }, [_vm._v(_vm._s(duty.identifier))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(duty.name))]), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_planning_shared__ = __webpack_require__(8);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var availabilitySorting = ['available', 'limited', 'vacation', 'unavailable'];
var weekDays = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'User',

    props: ['item'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_4__pages_planning_shared__["a" /* default */].state,
            multiple: false,
            loading: false,
            available: [],
            applications: []
        };
    },


    computed: {
        // only show users that match the item's duty
        users: function users() {
            // no duty set? return all users!
            if (!this.item.duty) return this.sort(this.map(this.shared.users));

            return this.sort(this.map(this.filter(this.shared.users)));
        },
        applicants: function applicants() {
            return this.sortApplications(this.mapApplications(this.filterApplications(this.shared.users)));
        },
        remaining: function remaining() {
            var _this = this;

            return _.filter(this.users, function (user) {
                return _.indexOf(_.map(_this.applicants, 'id'), user.id) === -1;
            });
        }
    },

    created: function created() {
        this.getData();
    },


    watch: {
        item: function item() {
            this.loading = true;
            this.getData();
        }
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            return this.$http.all([this.fetchAvailable(), this.fetchApplications()]).then(function () {
                _this2.$nextTick(function () {
                    _this2.loading = false;
                });
            });
        },
        fetchAvailable: function fetchAvailable() {
            var _this3 = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return _this3.$http.loader('users').get('/api/items/' + _this3.item.id + '/users').then(function (response) {
                    _this3.available = response.data;
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        },
        humanDate: function humanDate(date) {
            return this.$options.filters.readableDate(date, 'YYYY-MM-DD HH:mm', 'DD. MMMM YYYY, HH:mm');
        },
        fetchApplications: function fetchApplications() {
            var _this4 = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                return _this4.$http.loader('users').get('/api/items/' + _this4.item.id + '/applications').then(function (response) {
                    _this4.applications = response.data;
                    resolve();
                }).catch(function (error) {
                    reject(error);
                });
            });
        },
        getApplicationData: function getApplicationData(id) {
            return _.find(this.applications, function (application) {
                return application.membership.id === id;
            });
        },
        filter: function filter(users) {
            var _this5 = this;

            var tags = this.item.tags;
            return _.filter(users, function (user) {
                // user has not the required duty
                if (user.duties.indexOf(_this5.item.duty) == -1) return false;

                // user has not ALL of the required tag(s)
                if (tags.length && _.intersection(user.tags, tags).length != tags.length) return false;

                // user is not in available user list
                if (_this5.available.indexOf(user.id) == -1) return false;

                return true;
            });
        },
        filterApplications: function filterApplications(users) {
            var _this6 = this;

            var tags = this.item.tags;
            var applicants = _.map(this.applications, 'membership.id');

            return _.filter(users, function (user) {
                // user has not the required duty
                if (user.duties.indexOf(_this6.item.duty) == -1) return false;

                // user has not ALL of the required tag(s)
                if (tags.length && _.intersection(user.tags, tags).length != tags.length) return false;

                // user is not an applicant
                if (applicants.indexOf(user.membership) == -1) return false;

                return true;
            });
        },
        map: function map(users) {
            var _this7 = this;

            if (!this.$onduro.hasModule('availability')) return users;

            return _.map(users, function (user) {
                user.availability = _this7.getAvailability(user);

                return user;
            });
        },
        mapApplications: function mapApplications(users) {
            var _this8 = this;

            if (!this.$onduro.hasModule('availability')) return users;

            return _.map(users, function (user) {
                var applicationData = _this8.getApplicationData(user.membership);

                user.appliedAt = applicationData.appliedAt;
                user.accepted = applicationData.accepted;

                user.availability = _this8.getAvailability(user);

                // has user already been planned?
                user.planned = _this8.available.indexOf(user.id) == -1 ? true : false;

                return user;
            });
        },
        sort: function sort(users) {
            var _this9 = this;

            return _.sortBy(users, [function (user) {
                if (!_this9.$onduro.hasModule('availability')) return 0;
                return user.availability.sorting;
            }, 'name']);
        },
        sortApplications: function sortApplications(users) {
            var _this10 = this;

            return _.sortBy(users, ['accepted', function (user) {
                if (!_this10.$onduro.hasModule('availability')) return 0;
                return user.appliedAt;
            }, 'name']);
        },


        // check if item has this user assigned
        hasUser: function hasUser(user) {
            return this.item.user == user.id;
        },
        select: function select(user) {
            if (this.hasUser(user)) {
                this.remove(user);
            } else {
                this.add(user);
            }
        },
        updateUserStats: function updateUserStats(item, stats) {
            __WEBPACK_IMPORTED_MODULE_3__events_events__["a" /* default */].$emit('recalculate', item.date);

            if (!item.assigned) return;

            var user = __WEBPACK_IMPORTED_MODULE_4__pages_planning_shared__["a" /* default */].getUser(item.user);

            user.stats = stats ? stats : item.stats;
        },
        add: function add(user, params) {
            var _this11 = this;

            var data = {
                user: user.id
            };

            if (params) data = _.merge(data, params);

            this.$http.loader('users').put('/api/items/' + this.item.id + '/user', data).then(function (response) {
                var key = _.findIndex(_this11.shared.items, { id: _this11.item.id });

                // replace item
                _this11.$set(_this11.shared.items, key, response.data.item);

                // revalidate conflicts
                __WEBPACK_IMPORTED_MODULE_4__pages_planning_shared__["a" /* default */].revalidate(response.data.revalidated);

                // need to update both OLD and NEW user's stats!
                _this11.updateUserStats(_this11.item, response.data.stats);
                _this11.updateUserStats(response.data.item);

                _this11.$tools.close();
            }).catch(function (error) {
                switch (error.response.data.error) {
                    case 'ERR_CONFIRMED':
                        _this11.$modal.show(_this11.$t('page.roster.user.error.headline'), _this11.$t('page.roster.user.error.ERR_CONFIRMED'));
                        break;

                    case 'ERR_OVERLAP':
                        _this11.$modal.show(_this11.$t('page.roster.user.error.headline'), user.name + ' ' + _this11.$t('page.roster.user.error.ERR_OVERLAP'));
                        break;

                    case 'ERR_OPEN_CHECKIN':
                        // item has an open checkin, needs to be checked-out first
                        _this11.$modal.show(_this11.$t('page.roster.item.delete.error.headline'), _this11.$t('page.roster.move.error.ERR_OPEN_CHECKIN'));
                        break;

                    case 'ERR_OVERLAP_REST':
                        // overlap in resting period
                        _this11.$confirm.show(_this11.$t('page.roster.user.error.headline'), _this11.$t('confirm.resting.conflict', { name: user.name }), {
                            confirm: function confirm() {
                                _this11.add(user, _.merge({ confirmed: 'OVERRULE_REST' }, params)); // user might have confirmed "force" before
                            }
                        });
                        break;

                    case 'ERR_EXISTING_FULL':
                        _this11.$modal.show(_this11.$t('page.roster.add.error.headline'), user.name + ' ' + _this11.$t('page.roster.add.error.ERR_EXISTING_FULL'));
                        break;

                    case 'ERR_UNAVAILABLE_DENY':
                        _this11.$modal.show(_this11.$t('page.roster.add.error.headline'), user.name + ' ' + _this11.$t('page.roster.add.error.ERR_UNAVAILABLE_DENY'));
                        break;

                    case 'ERR_UNAVAILABLE_LIMITED':
                        // user is limited available, schedule anyway?
                        _this11.$confirm.show(_this11.$t('page.roster.add.error.headline_limited'), user.name + ' ' + _this11.$t('page.roster.add.error.ERR_UNAVAILABLE_LIMITED'), {
                            confirm: function confirm() {
                                _this11.add(user, _.merge({ confirmed: true }, params)); // user might have confirmed "force" before
                            }
                        });
                        break;

                    case 'ERR_HOURS':
                        _this11.$confirm.show(_this11.$t('page.roster.user.has_hours.headline'), _this11.$t('page.roster.user.change.ERR_HOURS'), {
                            confirm: function confirm() {
                                _this11.add(user, { force: true });
                            }
                        });
                        break;

                    case 'ERR_UNAVAILABLE_WARN':
                        _this11.$confirm.show(_this11.$t('page.roster.add.error.headline'), user.name + ' ' + _this11.$t('page.roster.add.error.ERR_UNAVAILABLE_WARN'), {
                            confirm: function confirm() {
                                _this11.add(user, _.merge({ confirmed: true }, params)); // user might have confirmed "force" before
                            }
                        });
                        break;
                }
            });
        },
        remove: function remove(user, params) {
            var _this12 = this;

            this.$http.loader('users').delete('/api/items/' + this.item.id + '/user', params).then(function (response) {
                var key = _.findIndex(_this12.shared.items, { id: _this12.item.id });

                if (response.data.item) {
                    // remove user (by substituting assigned item with placeholder item)
                    _this12.$set(_this12.shared.items, key, response.data.item);
                } else {
                    // remove item completely
                    _this12.$delete(_this12.shared.items, key);
                }

                // update stats for removed user
                _this12.updateUserStats(_this12.item, response.data.stats);

                // revalidate conflicts
                __WEBPACK_IMPORTED_MODULE_4__pages_planning_shared__["a" /* default */].revalidate(response.data.revalidated);

                _this12.$tools.close();
            }).catch(function (error) {
                switch (error.response.data.error) {
                    case 'ERR_HOURS':
                        _this12.$confirm.show(_this12.$t('page.roster.user.delete.error.headline'), _this12.$t('page.roster.user.remove.ERR_HOURS'), {
                            confirm: function confirm() {
                                _this12.remove(user, {
                                    params: {
                                        force: true
                                    }
                                });
                            }
                        });
                        break;

                    case 'ERR_CONFIRMED':
                        _this12.$modal.show(_this12.$t('page.roster.user.delete.error.headline'), _this12.$t('page.roster.user.error.ERR_CONFIRMED'));
                        break;

                    case 'ERR_OPEN_CHECKIN':
                        // item has an open checkin, needs to be checked-out first
                        _this12.$modal.show(_this12.$t('page.roster.item.delete.error.headline'), _this12.$t('page.roster.move.error.ERR_OPEN_CHECKIN'));
                        break;
                }
            });
        },
        getAvailability: function getAvailability(user) {
            var availabilities = this.shared.availability.users[user.id],
                defaultAvailabilities = this.shared.availability.detailedDefaults[user.id];

            // User set availability explicit on date
            if (availabilities && availabilities[this.item.date]) {
                var availability = _.clone(availabilities[this.item.date]);

                if (availability.constraints) availability.status = 'limited';

                availability.sorting = availabilitySorting.indexOf(availability.type);

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                    explicitAvailable: true
                }, availability, {
                    defaultAvailabilities: defaultAvailabilities
                });
            } else {
                var defaultType = this.shared.availability.defaults[user.id];

                return {
                    explicitAvailable: false,
                    constraints: null,
                    status: null,
                    type: defaultType,
                    sorting: availabilitySorting.indexOf(defaultType),
                    defaultAvailabilities: defaultAvailabilities
                };
            }
        },
        getAvailabilityClasses: function getAvailabilityClasses(user) {
            var availability = user.availability.defaultAvailabilities,
                day = moment(this.item.date).isoWeekday() - 1;

            if (user.availability.explicitAvailable) availability = user.availability.type;else availability = availability ? availability[weekDays[day]].value ? 'available' : 'unavailable' : user.availability.type;

            return ['availability', 'is-' + availability, 'is-' + user.availability.status];
        },
        showAvailability: function showAvailability(user) {
            __WEBPACK_IMPORTED_MODULE_3__events_events__["a" /* default */].$emit('availability.show', user);
        },
        hideAvailability: function hideAvailability() {
            __WEBPACK_IMPORTED_MODULE_3__events_events__["a" /* default */].$emit('availability.hide');
        }
    }
});

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loader",
      rawName: "v-loader.users",
      value: ({
        delay: 0
      }),
      expression: "{ delay: 0 }",
      modifiers: {
        "users": true
      }
    }],
    staticClass: "tools-tab tools-tab-user",
    class: [_vm.$onduro.hasModule('availability') ? 'has-availability' : '', _vm.item.tags.length ? 'is-filtered' : '']
  }, [(!_vm.loading) ? [(!_vm.applicants.length) ? _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.users), function(user) {
    return _c('li', {
      class: [_vm.hasUser(user) ? 'is-active' : ''],
      on: {
        "click": function($event) {
          return _vm.select(user)
        }
      }
    }, [(_vm.$onduro.hasModule('availability')) ? _c('span', {
      class: _vm.getAvailabilityClasses(user),
      on: {
        "mouseover": function($event) {
          return _vm.showAvailability(user)
        },
        "mouseout": function($event) {
          return _vm.hideAvailability()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), (_vm.hasUser(user)) ? _c('icon', {
      attrs: {
        "name": "delete"
      }
    }) : (_vm.multiple) ? _c('icon', {
      attrs: {
        "name": "add"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), 0) : _c('ul', {
    staticClass: "list"
  }, [_vm._l((_vm.applicants), function(user) {
    return _c('li', {
      class: [_vm.hasUser(user) ? 'is-active' : '', user.planned ? 'is-planned' : ''],
      on: {
        "click": function($event) {
          return _vm.select(user)
        }
      }
    }, [(_vm.$onduro.hasModule('availability')) ? _c('span', {
      class: _vm.getAvailabilityClasses(user),
      on: {
        "mouseover": function($event) {
          return _vm.showAvailability(user)
        },
        "mouseout": function($event) {
          return _vm.hideAvailability()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('span', {
      staticClass: "applied-at",
      domProps: {
        "innerHTML": _vm._s(_vm.$t('page.roster.tools.applied_at', {
          date: _vm.humanDate(user.appliedAt)
        }))
      }
    }), _vm._v(" "), (_vm.hasUser(user)) ? _c('icon', {
      attrs: {
        "name": "delete"
      }
    }) : (_vm.multiple) ? _c('icon', {
      attrs: {
        "name": "add"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.remaining), function(user, index) {
    return (!_vm.$onduro.getConfig('restrict.planner')) ? _c('li', {
      class: [_vm.hasUser(user) ? 'is-active' : '', index === 0 ? 'border-top' : ''],
      on: {
        "click": function($event) {
          return _vm.select(user)
        }
      }
    }, [(_vm.$onduro.hasModule('availability')) ? _c('span', {
      class: _vm.getAvailabilityClasses(user),
      on: {
        "mouseover": function($event) {
          return _vm.showAvailability(user)
        },
        "mouseout": function($event) {
          return _vm.hideAvailability()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), (_vm.hasUser(user)) ? _c('icon', {
      attrs: {
        "name": "delete"
      }
    }) : (_vm.multiple) ? _c('icon', {
      attrs: {
        "name": "add"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), (!_vm.users.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('page.roster.tools.empty_users')) + "\n        ")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.tags.length),
      expression: "item.tags.length"
    }],
    staticClass: "filtered"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.roster.tools.filtered_tags')) + "\n    ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import events from '../../../events/events';


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Tags',

    props: ['item'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_0__pages_planning_shared__["a" /* default */].state
        };
    },


    computed: {
        tags: function tags() {
            // no user set? return all tags!
            if (!this.item.assigned) return this.sort(this.shared.tags);

            // otherwise filter tags by current user
            return this.sort(this.filter(this.shared.tags));
        }
    },

    methods: {
        filter: function filter(tags) {
            var _this = this;

            // get all tags of assigned user
            var user = __WEBPACK_IMPORTED_MODULE_0__pages_planning_shared__["a" /* default */].getUser(this.item.user);

            return _.filter(tags, function (tag) {
                // allow to include currently selected tag, even though it might
                // not be assigned to user anymore
                if (_this.hasTag(tag)) return true;

                return user.tags.indexOf(tag.id) !== -1;
            });
        },
        sort: function sort(tags) {
            return _.sortBy(tags, ['name']);
        },
        hasTag: function hasTag(tag) {
            return this.item.tags.indexOf(tag.id) !== -1;
        },
        select: function select(tag) {
            var tags = _.clone(this.item.tags);

            if (this.hasTag(tag)) {
                _.pull(tags, tag.id);

                this.update(tags);
            } else {
                tags.push(tag.id);

                this.update(tags);
            }
        },
        update: function update(tags) {
            var _this2 = this;

            this.$http.put('/api/items/' + this.item.id + '/tags', {
                tags: tags
            }).then(function (response) {
                _this2.item.tags = tags;
                // this.$set(this.item, 'tags', tags);

                // this.$tools.close();
            }).catch(function (error) {
                // error
            });
        }
    }
});

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-tags"
  }, [(_vm.tags.length) ? _c('ul', {
    staticClass: "list list-tags"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('li', {
      class: [_vm.hasTag(tag) ? 'is-active' : ''],
      on: {
        "click": function($event) {
          return _vm.select(tag)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(tag.name))]), _vm._v(" "), (_vm.hasTag(tag)) ? _c('icon', {
      attrs: {
        "name": "cancel"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), 0) : _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.roster.tools.tags_none')) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import events from '../../../events/events';


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Sick',

    props: ['item'],

    data: function data() {
        return {
            form: {
                cost: null,
                percentage: 100,
                code: null
            },
            percentages: {
                100: '100%',
                95: '95%',
                90: '90%',
                85: '85%',
                80: '80%',
                75: '75%',
                70: '70%',
                65: '65%',
                60: '60%',
                55: '55%',
                50: '50%',
                45: '45%',
                40: '40%',
                35: '35%',
                30: '30%',
                25: '25%',
                20: '20%',
                15: '15%',
                10: '10%',
                5: '5%',
                0: '0%'
            },
            codes: {
                11: 'Kinderpflege mit Krankengeld',
                14: 'vollst. Freistellung für Betreuung/Begleitung Pflegebedürftiger',
                15: 'Pflegezeit mit vollständiger Freistellung',
                16: 'Kurzzeitige Pflege',
                19: 'unwiderrufliche unbezahlte Freistellung',
                21: 'Unbezahlter Urlaub',
                22: 'Unbezahlte Fehlzeit',
                23: 'Unrechtmäßiger Streik',
                24: 'Kinderpflege ohne Krankengeld',
                25: 'Krank privat Versicherte ohne Krankentagegeld',
                26: 'Krank über 6 Wochen bei Erwerbsminderungs-/Altersrente',
                27: 'Krank über 6 Wochen geringfügig entlohnter AN.',
                28: 'Aussteuerung',
                29: 'Einstellung Krankengeld w. voller Erwerbsm. Rente',
                31: 'Rechtmäßiger Streik',
                32: 'Aussperrung',
                33: 'Entgeltfortzahlung ohne AU-Bescheinigung',
                41: 'Kranken(tage)geld bei Krankheit oder Kur',
                42: 'Verletztengeld bei Krankheit oder Kur',
                43: 'Übergangsgeld bei Krankheit oder Kur',
                44: 'Versorgungskrankengeld bei Krankheit oder Kur',
                45: 'Mutterschutzfrist',
                47: 'Krank bei Eintritt ohne Entgeltfortzahlung',
                51: 'Elternzeit',
                61: 'Wehrdienst',
                62: 'Zivildienst',
                63: 'Wehrübung',
                64: 'Eignungsübung',
                81: 'KUG/S-KUG Krank',
                103: 'Entgeltfortzahlung mit AU-Bescheinigung',
                105: 'unwiderrufliche bezahlte Freistellung',
                106: 'Studienzeit (dualer Studiengang)',
                200: 'Kinderpflege mit Entgeltfortzahlung',
                201: 'Kinderpflege bei Schwersterkrankung',
                210: 'Pflegeunterstützungsgeld',
                260: 'Ende Bezug Krankengeld/Beginn Bezug Arbeitslosengeld',
                300: 'Entgeltfortzahlung wegen Organ-/Gewebespende',
                301: 'Freistellung im Rahmen sonstiger flexibler Arbeitszeitregelungen',
                302: 'Krankengeld bei Organ-/Blut/Gewebespende ohne EEL'
            }
        };
    },
    created: function created() {
        this.init();
    },


    watch: {
        item: function item() {
            this.init();
        }
    },

    computed: {
        user: function user() {
            return __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].getUser(this.item.user);
        },
        sick: function sick() {
            return this.item ? this.item.flag == 'sick' : false;
        }
    },

    methods: {
        init: function init() {
            // set default cost for user
            if (this.user.costs.length) {
                this.form.cost = this.user.costs[0].id;
            }

            if (this.item.hour) {
                // only set defaults if they have been set before
                if (this.item.hour.cost) this.form.cost = this.item.hour.cost;
                if (this.item.hour.code) this.form.code = this.item.hour.code;
                if (typeof this.item.hour.billable != 'undefined') this.form.percentage = this.item.hour.billable;
            }
        },
        saveSickness: function saveSickness() {
            var _this = this;

            this.$http.put('/api/items/' + this.item.id + '/sick', this.form).then(function (response) {
                _this.item.flag = 'sick';
                _this.item.hour = {
                    billable: _this.form.percentage,
                    cost: _this.form.cost,
                    code: _this.form.code
                };

                _this.$tools.close();
            }).catch(function (error) {
                switch (error.response.data.error) {
                    case 'ERR_TIME':
                        _this.$modal.show(_this.$t('page.roster.sick.ERR_TIME.headline'), _this.$t('page.roster.sick.ERR_TIME.text'));
                        break;

                    case 'ERR_COST':
                        alert('Invalid cost!');
                        break;

                    case 'ERR_HOURS':
                        _this.$confirm.show(_this.$t('page.roster.sick.ERR_HOURS.headline'), _this.$t('page.roster.sick.ERR_HOURS.text'), {
                            confirm: function confirm() {
                                _this.$http.put('/api/items/' + _this.item.id + '/sick', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.form, {
                                    force: true
                                })).then(function (response) {
                                    _this.item.flag = 'sick';
                                    _this.item.hour = {
                                        billable: _this.form.percentage,
                                        cost: _this.form.cost,
                                        code: _this.form.code
                                    };

                                    _this.$tools.close();
                                });
                            }
                        });
                        break;
                }

                if (error.response.status == 422 && error.response.data) {
                    _this.$v.setErrors(error.response.data);
                }
            });
        },
        removeSickness: function removeSickness() {
            var _this2 = this;

            this.$http.delete('/api/items/' + this.item.id + '/sick', this.form).then(function (response) {
                _this2.item.flag = null;
                _this2.item.hour = null;

                _this2.$tools.close();
            });
        }
    }
});

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-sick"
  }, [(!_vm.item.shift && !_vm.item.times) ? _c('div', {
    staticClass: "empty is-visible"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('page.roster.tools.sick.needs_time')) + "\n    ")]) : _c('div', [(!_vm.user.billable && !_vm.$onduro.getConfig('hours.everyone')) ? _c('div', {
    staticClass: "box-note",
    staticStyle: {
      "font-size": "12px",
      "color": "#c9635b"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('page.roster.tools.sick.no_costs')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.payroll),
      expression: "user.payroll"
    }],
    staticClass: "box-note"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('page.roster.tools.sick.payroll_payment')) + "\n        ")]), _vm._v(" "), (_vm.$current.profile == 'SKO') ? _c('div', [_c('div', {
    staticClass: "box-note"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('page.roster.tools.sick.sko')) + "\n            ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    staticStyle: {
      "width": "280px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "code", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.codes), function(name, id) {
    return _c('option', {
      domProps: {
        "value": id
      }
    }, [_vm._v(_vm._s(name))])
  }), 0), _vm._v(" "), _c('error', {
    staticStyle: {
      "color": "#c9635b"
    },
    attrs: {
      "message": _vm.$v.message('code')
    }
  })], 1) : [(!_vm.user.payroll) ? _c('div', [(_vm.$onduro.hasModule('balances')) ? _c('div', [(_vm.user.balance && _vm.form.percentage != '100') ? _c('div', {
    staticClass: "box-note"
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.balance_note')))]) : _c('div', {
    staticClass: "box-note"
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.hint')))])]) : _c('div', {
    staticClass: "box-note"
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.hint')))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.payment')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.percentage),
      expression: "form.percentage"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "percentage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.percentages), function(percentage, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(percentage))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasModule('costs') && _vm.user.costs && _vm.user.costs.length > 1) ? _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('label.cost')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cost),
      expression: "form.cost"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "cost", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.user.costs), function(cost) {
    return _c('option', {
      domProps: {
        "value": cost.id
      }
    }, [_vm._v(_vm._s(cost.name))])
  }), 0)]) : _vm._e()], _vm._v(" "), (_vm.sick) ? _c('a', {
    staticClass: "unmark",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeSickness.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.undo')))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "box-button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveSickness.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.sick.apply')))])], 2)])
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_planning_shared__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Projects',

    props: ['item'], // The roster item to assign a project to

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_0__pages_planning_shared__["a" /* default */].state,
            selectedProject: null
        };
    },


    computed: {
        projects: function projects() {
            return this.shared.projects;
        }
    },

    mounted: function mounted() {
        // Preselect the current project if available
        if (this.item.project && this.item.project.id) {
            var p = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.projects, { name: this.item.project.name });
            if (p) {
                this.selectedProject = p;
            }
        }
    },


    watch: {
        /**
         * Watch for changes in item.project and update selectedProject accordingly
         */
        item: {
            immediate: true, // Trigger on initial load
            handler: function handler(newItem) {
                if (newItem.project && newItem.project.id) {
                    var existingProject = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.projects, { id: newItem.project.id });
                    if (existingProject) {
                        this.selectedProject = existingProject;
                    }
                }
            }
        }
    },

    methods: {
        /**
         * Check if a project is currently assigned to the item.
         */
        isSelected: function isSelected(project) {
            return this.selectedProject && this.selectedProject.id === project.id;
        },


        /**
         * Handle the selection/deselection of a project.
         */
        handleSelection: function handleSelection(project) {
            var _this = this;

            if (this.isSelected(project)) {
                this.$confirm.show(this.$t('Are you sure you want to unassign this project?'), '', {
                    confirm: function confirm() {
                        return _this.unassignProject();
                    },
                    decline: function decline() {} // Do nothing on decline
                });
            } else {
                this.$confirm.show(this.$t('Are you sure you want to assign this project?'), '', {
                    confirm: function confirm() {
                        return _this.assignProject(project);
                    },
                    decline: function decline() {} // Do nothing on decline
                });
            }
        },


        /**
         * Assigns the selected project to the item via an API call.
         */
        assignProject: function assignProject(project) {
            var _this2 = this;

            this.$http.post('/api/roster/assign-project', {
                project_id: project.id,
                item_id: this.item.id
            }).then(function () {
                _this2.selectedProject = project;
                _this2.$notify.success(_this2.$t('Project assigned successfully.'));
                window.location.reload(true);
            }).catch(function () {
                _this2.$notify.error(_this2.$t('Error assigning project.'));
            });
        },


        /**
         * Unassigns the project from the item via an API call.
         */
        unassignProject: function unassignProject() {
            var _this3 = this;

            this.$http.post('/api/roster/unassign-project', {
                item_id: this.item.id
            }).then(function () {
                _this3.selectedProject = null;
                _this3.$notify.success(_this3.$t('Project unassigned successfully.'));
                window.location.reload(true);
            }).catch(function () {
                _this3.$notify.error(_this3.$t('Error unassigning project.'));
            });
        },


        /**
         * Formats the date in DD MMM format.
         */
        getDate: function getDate(date) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD MMM');
        }
    }
});

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-tags"
  }, [_c('span', [_vm._v("Project toewijzen aan deze Dienst")]), _c('br'), _vm._v(" "), _c('em', [_vm._v("Current Project: " + _vm._s(_vm.selectedProject ? _vm.selectedProject.name : 'None'))]), _vm._v(" "), (_vm.projects && _vm.projects.length) ? _c('ul', {
    staticClass: "list list-tags"
  }, _vm._l((_vm.projects), function(project) {
    return _c('li', {
      key: project.id,
      class: {
        'is-active': _vm.isSelected(project)
      },
      on: {
        "click": function($event) {
          return _vm.handleSelection(project)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(project.name) + "\n                "), _c('span', {
      staticStyle: {
        "font-size": "12px !important",
        "font-style": "italic !important"
      }
    }, [_vm._v("\n                    (" + _vm._s(project.code) + ")\n                ")])]), _vm._v(" "), (_vm.isSelected(project)) ? _c('icon', {
      attrs: {
        "name": "cancel"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), 0) : _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.roster.tools.projects_none')) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//


// import events from '../../../events/events';


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Flags',

    props: ['item'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].state
        };
    },


    methods: {
        allow: function allow() {
            var _this = this;

            this.$http.put('/api/items/' + this.item.id + '/sign-out', {
                confirm: true
            }).then(function (response) {
                var key = _.findIndex(_this.shared.items, { id: _this.item.id });

                // response contains item, we need to replace the whole item
                _this.$set(_this.shared.items, key, response.data);

                _this.$tools.close();
            });
        },
        deny: function deny() {
            var _this2 = this;

            this.$http.put('/api/items/' + this.item.id + '/sign-out', {
                confirm: false
            }).then(function (response) {
                _this2.item.flag = null;
                _this2.$tools.close();
            });
        }
    }
});

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-flags"
  }, [_vm._v("\n\n    " + _vm._s(_vm.$t('page.roster.tools.application')) + "\n\n    "), _c('br'), _c('br'), _vm._v(" "), _c('action', {
    attrs: {
      "icon": "check",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.allow.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.confirm')))]), _vm._v(" "), _c('action', {
    attrs: {
      "icon": "cancel",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deny.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.deny')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import events from '../../../events/events';


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Employee',

    props: ['item'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_2__pages_planning_shared__["a" /* default */].state
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        myPlaceholder: function myPlaceholder() {
            return !this.item.assigned && this.current.membership.duties.indexOf(this.item.duty) != -1;
        },
        signedOut: function signedOut() {
            return this.item.assigned && this.item.flag == 'signout';
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        current: function current(_ref) {
            var _current = _ref.current;
            return _current;
        }
    })),

    methods: {
        signin: function signin() {
            var _this = this;

            this.$http.put('/api/items/' + this.item.id + '/sign-in').then(function (response) {
                var key = _.findIndex(_this.shared.items, { id: _this.item.id });

                // response contains item, we need to replace the whole item
                _this.$set(_this.shared.items, key, response.data);

                _this.$tools.close();
            }).catch(function (error) {
                // show general error "you already work that day"
                _this.$modal.show(_this.$t('page.roster.signin.error.headline'), _this.$t('page.roster.signin.error.text'));
            });
        },
        signout: function signout() {
            var _this2 = this;

            this.$http.put('/api/items/' + this.item.id + '/sign-out').then(function (response) {
                _this2.$modal.show(_this2.$t('page.roster.signout.headline'), _this2.$t('page.roster.signout.text'), function () {
                    _this2.item.flag = 'signout';
                    _this2.$tools.close();
                });
            });
        },
        cancelSignout: function cancelSignout() {
            var _this3 = this;

            this.$http.delete('/api/items/' + this.item.id + '/sign-out').then(function (response) {
                _this3.item.flag = null;
                _this3.$tools.close();
            });
        }
    }
});

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools--employee"
  }, [(!_vm.item.assigned) ? _c('action', {
    attrs: {
      "icon": "add",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.signin.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.signin')))]) : _vm._e(), _vm._v(" "), (_vm.signedOut) ? _c('action', {
    attrs: {
      "icon": "check",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelSignout.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.work')))]) : _vm._e(), _vm._v(" "), (_vm.item.assigned && !_vm.signedOut) ? _c('action', {
    attrs: {
      "icon": "cancel",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.signout.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('page.roster.tools.signout')))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'NewShift',

    props: ['date'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].state
        };
    },


    computed: {
        activeShifts: function activeShifts() {
            // TODO: might need to add legacy shift as well, if previously assigned!
            return _.filter(this.shared.shifts, { trashed: false });
        },
        shifts: function shifts() {
            return _.sortBy(this.shared.shifts, ['name']);
        }
    },

    methods: {
        select: function select(shift) {
            var item = {
                assigned: false,
                duty: null,
                shift: shift.id
            };

            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('items.add', item, this.date);
        }
    }
});

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-shift"
  }, [_c('ul', {
    staticClass: "list list-shifts"
  }, _vm._l((_vm.activeShifts), function(shift) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.select(shift)
        }
      }
    }, [_c('em', [_vm._v(_vm._s(shift.identifier))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(shift.name))]), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "add"
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.shifts.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.settings.shifts.empty')) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'NewDuty',

    props: ['date'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].state
        };
    },


    computed: {
        // only show duties for this user
        duties: function duties() {
            return this.sort(this.shared.duties);
        },
        activeDuties: function activeDuties() {
            return _.filter(this.duties, { trashed: false });
        }
    },

    methods: {
        sort: function sort(duties) {
            return _.sortBy(duties, ['name']);
        },
        select: function select(duty) {
            var item = {
                assigned: false,
                duty: duty.id,
                shift: null
            };

            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('items.add', item, this.date);
        }
    }
});

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-duty"
  }, [_c('ul', {
    staticClass: "list list-duties"
  }, _vm._l((_vm.activeDuties), function(duty) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.select(duty)
        }
      }
    }, [_c('em', {
      style: ('background:' + duty.color)
    }, [_vm._v(_vm._s(duty.identifier))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(duty.name))]), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var availabilitySorting = ['available', 'limited', 'vacation', 'unavailable'];
var weekDays = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'User',

    props: ['date'],

    data: function data() {
        return {
            shared: __WEBPACK_IMPORTED_MODULE_1__pages_planning_shared__["a" /* default */].state,
            multiple: false,
            loading: false,
            available: []
        };
    },


    computed: {
        users: function users() {
            return this.sort(this.map(this.shared.users));
        },


        // only show duties for this user
        duties: function duties() {
            return _.sortBy(this.shared.duties, ['name']);
        },
        activeDuties: function activeDuties() {
            return _.filter(this.duties, { trashed: false });
        }
    },

    created: function created() {
        this.fetchAvailable();
    },


    methods: {
        fetchAvailable: function fetchAvailable() {
            var _this = this;

            this.loading = true;
            this.$http.get('/api/locations/' + this.shared.location + '/users/' + this.date).then(function (response) {
                _this.loading = false;
                _this.available = response.data;
            });
        },
        filter: function filter(users) {
            var _this2 = this;

            return _.filter(users, function (user) {
                // user is not in available user list
                if (_this2.available.indexOf(user.id) == -1) return false;

                return true;
            });
        },
        filterUsersByDuty: function filterUsersByDuty(duty) {
            // legacy users are users that are visible in the roster (because they have been scheduled someday)
            // but are not currently assigned to the location anymore
            return _.filter(this.users, function (user) {
                if (user.legacy) return false;

                return user.duties.indexOf(duty.id) !== -1;
            });
        },
        map: function map(users) {
            var _this3 = this;

            if (!this.$onduro.hasModule('availability')) return users;

            return _.map(users, function (user) {
                user.availability = _this3.getAvailability(user);

                return user;
            });
        },
        sort: function sort(users) {
            var _this4 = this;

            return _.sortBy(users, [function (user) {
                if (!_this4.$onduro.hasModule('availability')) return 0;
                return user.availability.sorting;
            }, 'name']);
        },
        select: function select(user, duty) {
            var item = {
                assigned: false,
                duty: duty ? duty.id : null,
                shift: null,
                user: user.id
            };

            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('items.add', item, this.date);
        },
        getAvailability: function getAvailability(user) {
            var availabilities = this.shared.availability.users[user.id];

            if (availabilities && availabilities[this.date]) {
                var availability = _.clone(availabilities[this.date]);

                if (availability.constraints) availability.status = 'limited';

                availability.sorting = availabilitySorting.indexOf(availability.type);

                return availability;
            } else {
                var defaultType = this.shared.availability.defaults[user.id];

                return {
                    constraints: null,
                    status: null,
                    type: defaultType,
                    sorting: availabilitySorting.indexOf(defaultType)
                };
            }
        },
        getAvailabilityClasses: function getAvailabilityClasses(user) {
            var availability = user.availability.defaultAvailabilities,
                day = moment(this.date).isoWeekday() - 1;

            availability = availability ? availability[weekDays[day]].value ? 'available' : 'unavailable' : user.availability.type;

            return ['availability', 'is-' + availability, 'is-' + user.availability.status];
        }
    }
});

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-user tools-mobile",
    class: [_vm.$onduro.hasModule('availability') ? 'has-availability' : '']
  }, [(!_vm.loading) ? _c('ul', {
    staticClass: "list"
  }, [_vm._l((_vm.activeDuties), function(duty) {
    return (_vm.filterUsersByDuty(duty).length) ? [(_vm.filterUsersByDuty(duty).length) ? _c('li', {
      staticClass: "box-duty",
      style: ('background:' + duty.color)
    }, [_c('span', [_vm._v(_vm._s(duty.name))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filterUsersByDuty(duty)), function(user) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.select(user, duty)
          }
        }
      }, [(_vm.$onduro.hasModule('availability')) ? _c('span', {
        class: _vm.getAvailabilityClasses(user)
      }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), (_vm.multiple) ? _c('icon', {
        attrs: {
          "name": "add"
        }
      }) : _c('icon', {
        attrs: {
          "name": "check"
        }
      })], 1)
    })] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return (!_vm.activeDuties) ? _c('li', {
      on: {
        "click": function($event) {
          return _vm.select(user)
        }
      }
    }, [(_vm.$onduro.hasModule('availability')) ? _c('span', {
      class: _vm.getAvailabilityClasses(user)
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.name))]), _vm._v(" "), (_vm.multiple) ? _c('icon', {
      attrs: {
        "name": "add"
      }
    }) : _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.users.length) ? _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('page.roster.tools.empty_users')) + "\n    ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools",
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [(_vm.$onduro.hasRole('planner') && _vm.initialized) ? _c('div', {
    staticClass: "tools-tabs"
  }, [_vm._l((_vm.tabs), function(tab) {
    return (tab.show) ? _c('a', {
      class: [(tab.name === _vm.activeTab) ? 'is-active' : '', tab.class ? tab.class : ''],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleActive(tab.name)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": tab.icon
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.showTrash) ? _c('a', {
    class: ['tools-close', 'is-trash', _vm.visible > 7 ? 'has-shadow' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.trash.apply(null, arguments)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "delete"
    }
  })], 1) : _c('a', {
    class: ['tools-close', _vm.visible > 7 ? 'has-shadow' : ''],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.$onduro.hasRole('planner')) ? _c('tab-' + _vm.activeTab, {
    tag: "component",
    attrs: {
      "item": _vm.payload,
      "date": _vm.payload
    }
  }) : _c('employee', {
    attrs: {
      "item": _vm.payload
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    ref: "toolbox",
    class: [
      'toolbox',
      'toolbox--' + _vm.toolboxClass, _vm.show ? 'show' : '',
      _vm.ready ? '' : 'positioning',
      _vm.hasInput ? 'toolbox--has-input' : '',
      _vm.os === 'ios' ? 'ios' : '',
      _vm.tiny && _vm.hasInput ? 'toolbox--tiny' : ''
    ],
    style: (_vm.coordinates),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(!(_vm.tiny && _vm.hasInput)) ? _c('span', {
    staticClass: "toolbox-arrow",
    class: _vm.posArrow,
    style: (_vm.arrowCoordinates)
  }) : _vm._e(), _vm._v(" "), (!(_vm.tiny && _vm.hasInput)) ? _c(_vm.type, {
    tag: "component",
    attrs: {
      "payload": _vm.payload,
      "replacement": _vm.replacement
    }
  }) : _c('div', {
    staticClass: "toolbox-tiny"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.device.rotate')))]), _vm._v(" "), _c('action', {
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Card',

    props: {
        counter: {
            type: Number,
            default: null
        },

        size: {
            type: String,
            default: '1/2'
        }
    }
});

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.counter) ? _c('div', {
    staticClass: "card",
    class: 'card-' + _vm.size
  }, [(_vm.$slots.headline) ? _c('header', [_vm._t("headline")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._t("content")], 2), _vm._v(" "), _c('aside', {
    staticClass: "card-sidebar"
  }, [(_vm.counter !== null) ? _c('span', {
    staticClass: "card-counter"
  }, [_vm._v(_vm._s(_vm.counter))]) : _vm._e(), _vm._v(" "), _vm._t("sidebar")], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var Notify = {};

/**
 * Notification plugin
 *
 * @param Vue
 */
Notify.install = function (Vue) {
    var methods = {
        /**
         * Default notification
         *
         * @param {string} headline
         * @param {string} description
         * @param {string} icon
         * @param {string} type
         */
        default: function _default(headline, description, icon, type) {
            // push notification on event bus
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('notification.open', headline, description, icon, type);
        },


        /**
         * Defined notification for INFO
         *
         * @param {string} headline
         * @param {string} description
         */
        info: function info(headline, description) {
            this.default(headline, description, 'info', 'blue');
        },


        /**
         * Defined notification for WARN
         *
         * @param {string} headline
         * @param {string} description
         */
        warn: function warn(headline, description) {
            this.default(headline, description, 'warning', 'orange');
        },


        /**
         * Defined notification for ERROR
         *
         * @param {string} headline
         * @param {string} description
         */
        error: function error(headline, description) {
            if (!headline && !description) {
                headline = Vue.t('error.whoops.title');
                description = Vue.t('error.whoops.headline');
            }

            this.default(headline, description, 'clear', 'red');
        },


        /**
         * Defined notification for SUCCESS
         *
         * @param {string} headline
         * @param {string} description
         */
        success: function success(headline, description) {
            if (!headline && !description) {
                headline = Vue.t('common.notify.success.headline');
                description = Vue.t('common.notify.success.description');
            }

            this.default(headline, description, 'check', 'green');
        },


        /**
         * Defined notification for DELETE
         *
         * @param {string} headline
         * @param {string} description
         */
        remove: function remove(headline, description) {
            if (!headline && !description) {
                headline = Vue.t('common.notify.delete.headline');
                description = Vue.t('common.notify.delete.description');
            }

            this.default(headline, description, 'delete', 'red');
        }
    };

    // register global methods
    Vue.notify = methods;

    // register instance methods
    Vue.prototype.$notify = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (Notify);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sentry_vue__ = __webpack_require__(49);






var Loader = {};
var minPendingDelay = 450;
var loading = {};

/**
 * Template example with static identifier:
 * <div v-loader.areaIdentifier="{ class: 'class1 class2' }"></div>
 *
 * Template example with dynamic identifier:
 * <div v-loader="{ listen: dynamicAreaIdentifier, class: 'class1 class2' }"></div>
 */

/**
 * Return waiting time for loader to appear earliest
 */
function getPendingDelay(obj) {
    if (typeof obj.value !== 'undefined' && obj.value.hasOwnProperty('delay')) {
        return obj.value.delay;
    }

    return minPendingDelay;
}

/**
 * Get classes from dom element having the v-loader directive
 *
 * @param obj
 * @returns {Array}
 */
function getClasses(obj) {
    var classes = [];
    // Collect classes
    if (typeof obj.value !== 'undefined' && obj.value.hasOwnProperty('class')) {
        classes = obj.value.class.split(' ');
    }

    return classes;
}

/**
 * Injects the loader markup into the specified area
 *
 * @param obj
 * @param el
 * @param area
 */
function showLoader(obj, el, area) {
    try {
        if (typeof el === 'undefined') return;

        // Create loader html
        var e = document.createElement('div'),
            classes = getClasses(obj);

        e.innerHTML = '\n        <div class="rotate">\n            <svg class="circular" viewBox="25 25 50 50">\n                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>\n            </svg>\n        </div>';

        e.classList.add('loader');
        e.classList.add('loader-inline');
        e.classList.add('loader-' + area);

        // Add optional classes to root element
        for (var i = 0; i < classes.length; i++) {
            el.classList.add(classes[i]);
        }

        // Add optional styles
        if (typeof obj.value !== 'undefined' && obj.value.hasOwnProperty('style')) {
            e.style = obj.value.style;
        }

        el.append(e);
    } catch (e) {
        // Sentry.captureException(e);
    }
}

/**
 * @param obj
 * @param el
 * @param area
 */
function hideLoader(obj, el, area) {
    var loader = el.querySelectorAll('.loader-' + area),
        classes = getClasses(obj);

    for (var i = 0; i < loader.length; i++) {
        loader[i].parentNode.removeChild(loader[i]);

        // Remove optional classes from root element
        for (var k = 0; k < classes.length; k++) {
            el.classList.remove(classes[k]);
        }
    }
}

/**
 * Loader plugin
 *
 * @param Vue
 * @param options
 */
Loader.install = function (Vue, options) {
    var methods = {
        up: function up() {
            __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].dispatch('loader/up');
        },
        down: function down() {
            __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].dispatch('loader/down');
        },
        areaUp: function areaUp(area) {
            __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].dispatch('loader/areaUp', area);
        },
        areaDown: function areaDown(area) {
            __WEBPACK_IMPORTED_MODULE_2__vuex_store__["a" /* default */].dispatch('loader/areaDown', area);
        }
    };

    // register global methods
    Vue.loader = methods;

    // register instance methods
    Vue.prototype.$loader = methods;

    Vue.directive('loader', {
        inserted: function inserted(el, binding, vnode) {
            var watchers = [];
            // Get static modifiers
            if (typeof binding.modifiers !== 'undefined') watchers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(binding.modifiers);
            // Get dyn. watchers
            if (typeof binding.value !== 'undefined' && binding.value.hasOwnProperty('listen')) {
                watchers = watchers.concat(binding.value.listen);
            }

            if (watchers.length > 0) {
                var _loop = function _loop(k) {
                    __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$on(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].loaderPrefix + watchers[k], function (event) {
                        if (event === 'on') {
                            loading[watchers[k]] = window._.debounce(function () {
                                showLoader(binding, el, watchers[k]);
                                delete loading[watchers[k]];
                            }, getPendingDelay(binding));

                            loading[watchers[k]]();
                        }

                        if (event === 'off') {
                            var delay = getPendingDelay(binding);

                            if (typeof loading[watchers[k]] !== 'undefined') {
                                loading[watchers[k]].cancel();
                                delay = 0;
                            }

                            window._.debounce(function () {
                                hideLoader(binding, el, watchers[k]);
                            }, delay)();
                        }
                    });
                };

                for (var k in watchers) {
                    _loop(k);
                }
            }
        },
        unbind: function unbind(el, binding, vnode) {
            var watchers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(binding.modifiers);

            if (watchers.length > 0) {
                for (var k in watchers) {
                    __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$off(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* default */].loaderPrefix + watchers[k]);
                }
            }
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var Tools = {};

/**
 * Tools plugin
 *
 * @param Vue
 * @param options
 */
Tools.install = function (Vue, options) {
    var methods = {
        open: function open(event, payload) {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.open', 'tools', event, payload);
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.close');
        },
        setTab: function setTab(tab) {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.tab', tab);
        },
        replacePayload: function replacePayload(payload) {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.payload', payload);
        }
    };

    // register global methods
    Vue.tools = methods;

    // register instance methods
    Vue.prototype.$tools = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (Tools);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var Notes = {};

/**
 * Notes plugin
 *
 * @param Vue
 * @param options
 */
Notes.install = function (Vue, options) {
    var methods = {
        open: function open(event, payload) {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.open', 'notes', event, payload);
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.close');
        }
    };

    // register global methods
    Vue.notes = methods;

    // register instance methods
    Vue.prototype.$notes = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (Notes);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);



var Tooltip = {};

var _enter = void 0;
var _leave = void 0;

Tooltip.install = function (Vue) {
    Vue.directive('tooltip', {
        inserted: function inserted(el, binding, vnode) {
            if (!binding || !binding.value) return;

            // enable to conditionally hide tooltip by using JSON v-tooltip="{text:'abc', visible:false}"
            if (typeof binding.value.visible !== 'undefined' && !binding.value.visible) return;

            var val = typeof binding.value === 'string' ? binding.value : binding.value.text;

            try {
                el.dataset.tooltip = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val);
            } catch (err) {
                el.setAttribute('data-tooltip', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
            }

            _enter = function _enter() {
                var value = void 0;

                try {
                    value = JSON.parse(el.dataset.tooltip);
                } catch (err) {
                    value = JSON.parse(el.getAttribute('data-tooltip'));
                }

                if (value) {
                    __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('tooltip.show', {
                        content: value,
                        trigger: el
                    });
                }
            };

            _leave = function _leave() {
                __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('tooltip.hide');
            };

            el.addEventListener('mouseenter', _enter);
            el.addEventListener('mouseleave', _leave);
        },
        update: function update(el, binding, vnode) {
            if (!binding || !binding.value) {
                el.dataset.tooltip = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()('');
                return;
            }

            // enable to conditionally hide tooltip by using JSON v-tooltip="{text:'abc', visible:false}"
            if (typeof binding.value.visible !== 'undefined' && !binding.value.visible) return;

            var val = typeof binding.value === 'string' ? binding.value : binding.value.text;

            // update value
            try {
                el.dataset.tooltip = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val);
            } catch (err) {
                el.setAttribute('data-tooltip', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
            }
        },
        unbind: function unbind(el, binding, vnode) {
            // remove all event listeners
            el.removeEventListener('mouseenter', _enter);
            el.removeEventListener('mouseleave', _leave);
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var Chatbox = {};

/**
 * Chatbox plugin
 *
 * @param Vue
 * @param options
 */
Chatbox.install = function (Vue, options) {
    var methods = {
        open: function open(event, payload) {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.open', 'chatbox', event, payload);
        },
        openItem: function openItem(event, payload) {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.open', 'itemchatbox', event, payload);
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.close');
        }
    };

    // register global methods
    Vue.chatbox = methods;

    // register instance methods
    Vue.prototype.$chatbox = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (Chatbox);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var Calendar = {};

/**
 * Calendar plugin
 *
 * @param Vue
 * @param options
 */
Calendar.install = function (Vue, options) {
    var methods = {
        open: function open(event, payload) {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.open', 'calendar', event, payload);
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.close');
        }
    };

    // register global methods
    Vue.calendar = methods;

    // register instance methods
    Vue.prototype.$calendar = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (Calendar);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var Timepicker = {};

/**
 * Timepicker plugin
 *
 * @param Vue
 * @param options
 */
Timepicker.install = function (Vue, options) {
    var methods = {
        open: function open(event, payload) {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.open', 'timepicker', event, payload);
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('toolbox.close');
        }
    };

    // register global methods
    Vue.timepicker = methods;

    // register instance methods
    Vue.prototype.$timepicker = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (Timepicker);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events_events__ = __webpack_require__(2);


var University = {};

/**
 * University plugin
 *
 * @param Vue
 * @param options
 */
University.install = function (Vue, options) {
    var methods = {
        lessons: [],
        history: [],

        open: function open() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('university.open');
        },
        close: function close() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('university.close');
        },
        toggle: function toggle() {
            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('university.toggle');
        },
        lesson: function lesson(_lesson, callback) {
            this.history.push(_lesson.id);

            __WEBPACK_IMPORTED_MODULE_0__events_events__["a" /* default */].$emit('lesson.open', _lesson, callback);
        }
    };

    // register global methods
    Vue.university = methods;

    // register instance methods
    Vue.prototype.$university = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (University);

/***/ }),
/* 628 */,
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


// cherry pick lodash methods
var _ = __webpack_require__(27);
var flatten = __webpack_require__(630);

var Validation = {};

Validation.install = function (Vue, options) {
    var _watchers = {}; // container for watchers
    var _messages = {}; // temporary storage for error messages

    /*
     * Unwatch registered watchers
     */
    var _unwatch = function _unwatch() {
        // unwatch previous watchers
        _.forIn(_watchers, function (unwatch) {
            unwatch();
        });
    };

    /*
     * Validators
     *
     * Place all validators in here. Use them in the $rules section of the
     * component.
     */
    var _validators = {
        required: function required(val) {
            if (typeof val === 'array') return val.length !== 0;else if ((typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(val)) === 'object') return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(val).length !== 0;else return val === '' || val === null ? false : true;
        },

        /*
         * @param val
         * @param args, array containing keys for from and until
         */
        overnight: function overnight(val, args) {
            if (args.length != 2) {
                console.error("Entries missing in args: " + args);
                return false;
            }

            return parseInt(val[args[0]]) < parseInt(val[args[1]]) || parseInt(val[args[1]]) == 0;
        },

        /*
         * @param val
         * @param args, value from first validation field to check
         */
        repeat: function repeat(val, args, vm) {
            if (vm[args[0]][args[1]]) return val.localeCompare(vm[args[0]][args[1]]) != -1;

            console.error("Can't find value to compare at: ", args[0], args[1]);
            return false;
        },

        numeric: function numeric(val) {
            return !isNaN(parseFloat(val)) && isFinite(val);
        }
    };

    Vue.mixin({
        data: function data() {
            return {
                $errors: {} // validation errors
            };
        },
        beforeCreate: function beforeCreate() {
            var vm = this;

            this.$v = {
                /**
                 * Check if form field has error
                 *
                 * @param {String} key
                 * @return {Boolean}
                 */
                hasError: function hasError(key) {
                    return !!_.at(vm.$data.$errors, key)[0];
                },


                /**
                 * Returns error message
                 *
                 * @param {String} key
                 * @return {String}
                 */
                message: function message(key) {
                    return this.hasError(key) ? this.getError(key) : '';
                },
                getError: function getError(key) {
                    return typeof _.at(vm.$data.$errors, key)[0] === 'string' ? _.at(vm.$data.$errors, key)[0] : _.at(vm.$data.$errors, key)[0][0];
                },
                isValid: function isValid(namespace) {
                    var errors = namespace ? vm.$data.$errors[namespace] : vm.$data.$errors;

                    if (!errors) return true;

                    var _errors = flatten(errors);

                    var total = 0,
                        count = 0;
                    _.forOwn(_errors, function (value, key) {
                        total++;
                        if (_errors[key] === null) count++;
                    });

                    return total === count;
                },
                resetErrors: function resetErrors() {
                    vm.$data.$errors = {};
                },


                /**
                 * Validate form field
                 *
                 * @param {String} key
                 * @param {Mixed} val
                 */
                validate: function validate(key, val) {
                    var rules = _.get(vm.$data.$rules, key, false);

                    // field has no rules
                    if (rules === false) return true;

                    rules = rules.split('|');

                    var matched = 0,
                        total = rules.length;

                    rules.forEach(function (rule) {
                        var args = rule.match(/\((.*?)\)/);

                        if (args) {
                            var _rule = rule.split('(')[0],
                                _args = args[1].split(',');

                            if (_rule in _validators) {
                                for (var i in _args) {
                                    _args[i] = _.trim(_args[i]);
                                }

                                if (_validators[_rule](val, _args, vm)) matched++;
                                return;
                            }
                        } else {
                            if (rule in _validators) {
                                if (_validators[rule](val)) matched++;
                                return;
                            }
                        }

                        console.info('Validation rule [' + rule + '] is not defined.');
                    });

                    return matched == total;
                },


                /**
                 * Set errors object
                 *
                 * Error object does not have to be namespaced, if multiple forms
                 * are being used in the $data.form object.
                 *
                 * @param {Object} errors
                 * @param {String} namespace
                 */
                setErrors: function setErrors(errors, namespace) {
                    // unwatch all previous watchers
                    _unwatch();

                    _.forIn(errors, function (val, key) {
                        // add namespace to key, if it's set
                        key = namespace ? namespace + '.' + key : key;

                        // register watchers for invalid form fields
                        _watchers[key] = vm.$watch('form.' + key, function (val) {
                            if (vm.$v.validate(key, val)) {
                                // get the error message
                                var error = _.get(vm.$data.$errors, key);

                                // temporary store the error message
                                if (error) _.set(_messages, key, error);

                                // remove the error upon form field change
                                _.set(vm.$data.$errors, key, null);

                                // teardown watcher
                                // _watchers[key]();
                            } else {
                                // get the stored error message
                                var _error = _.get(_messages, key);

                                // re-set the error
                                if (_error) {
                                    _.set(vm.$data.$errors, key, _error);
                                }
                            }
                        }, {
                            deep: true
                        });
                    });

                    // Transform laravel errors to deep object
                    var _errors = _.transform(errors, function (transformed, val, key) {
                        _.set(transformed, key, val);
                    });

                    // set reactive error object
                    if (namespace) {
                        Vue.set(vm.$data.$errors, namespace, _errors);
                        return;
                    }

                    // else...
                    vm.$data.$errors = _errors;
                }
            };
        },
        beforeDestroy: function beforeDestroy() {
            // unwatch all watchers
            _unwatch();
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = (Validation);

/***/ }),
/* 630 */,
/* 631 */,
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('click-outside', {
    bind: function bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                console.info('a');
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };

        document.body.addEventListener('click', el.clickOutsideEvent);
    },

    unbind: function unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('decimal', function (value) {
    return parseFloat(value).toString().replace('.', ',');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('percentage', function (value) {
    if (isNaN(value)) return 0;
    return parseFloat(value).toFixed(2).replace('.', ',') + ' %';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('money_string', function (value, currency) {
    if (!currency) currency = '€';
    return parseFloat(value).toFixed(2).replace('.', ',') + ' ' + currency;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('hours', function (value) {
    return parseFloat(value).toFixed(2).replace('.', ',') + ' ' + __WEBPACK_IMPORTED_MODULE_0_vue__["default"].t('text.hrs');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('distance', function (value, unit) {
    if (!unit) unit = 'km';
    return parseFloat(value).toFixed(2).replace('.', ',') + ' ' + unit;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('floor', function (value, separator) {
    if (separator) return parseFloat(value).toFixed(2).toString().replace('.', ',');

    var floor = parseFloat(value).toFixed(2);

    return floor;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('money_float', {
    read: function read(value) {
        if (!value) return value;
        return parseFloat(value).toFixed(2);
    },
    write: function write(value) {
        return value;
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('readableDate', function (value, formatIn, formatOut) {
    try {
        if (formatIn && formatOut) {
            return moment(value, formatIn).format(formatOut);
        }

        return moment(value).format(formatIn);
    } catch (e) {
        return value;
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('at', function (value, at) {
    return _.at(value, at)[0] || 0;
});

/**
 * Convert dash to 0
 *
 * @param val
 * @returns {*}
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('pause', function (value) {
    return value === '\u2014' ? 0 : value;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('reverse', function (value) {
    return value.splice().reverse();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('factor', function (value, dividendAt, divisorAt) {
    var res = parseFloat(_.at(value, dividendAt)[0]) / parseFloat(_.at(value, divisorAt)[0]);
    return isFinite(res) ? res * 100 : 0.00;
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lockr__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lockr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lockr__);


var Lockr = {};

/**
 * Lockr wrapper plugin
 *
 * @param Vue
 * @param options
 */
Lockr.install = function (Vue, options) {
    __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.prefix = 'ONDURO_';

    var methods = {
        _getInstance: function _getInstance() {
            return __WEBPACK_IMPORTED_MODULE_0_lockr___default.a;
        },


        //@TODO: Remove method
        prefix: function prefix(_prefix2) {
            __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.prefix = _prefix2;
        },
        set: function set(key, value, prefix) {
            if (typeof prefix === 'string') {
                this.tmpPrefix(function () {
                    __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.set(key, value);
                }, prefix);
            } else {
                __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.set(key, value);
            }
        },
        get: function get(key, prefix) {
            if (typeof prefix === 'string') {
                return this.tmpPrefix(function () {
                    return __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.get(key);
                }, prefix);
            } else return __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.get(key);
        },
        getAll: function getAll() {
            return __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.getAll();
        },
        flush: function flush(prefix) {
            if (typeof prefix === 'string') {
                this.tmpPrefix(function () {
                    __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.flush();
                }, prefix);
            } else __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.flush();
        },


        /**
         * remove key from store
         *
         * @param key
         * @param prefix
         */
        rm: function rm(key, prefix) {
            var _prefix = '';
            if (typeof prefix === 'string') _prefix = prefix;

            __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.rm('' + _prefix + key);
        },


        /**
         * Restore previous prefix after
         * assigning new, temporary prefix
         *
         * @param callback
         * @param prefix
         */
        tmpPrefix: function tmpPrefix(callback, prefix) {
            var _prefix = __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.prefix,
                _return = void 0;
            if (typeof callback === 'function') {
                __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.prefix = prefix;
                _return = callback();
            }
            __WEBPACK_IMPORTED_MODULE_0_lockr___default.a.prefix = _prefix;

            return _return;
        }
    };

    // register global methods
    Vue.lockr = methods;

    // register instance methods
    Vue.prototype.$lockr = methods;
};

/* harmony default export */ __webpack_exports__["a"] = (Lockr);

/***/ }),
/* 634 */,
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_events__ = __webpack_require__(2);



var ghost = void 0;
var DnD = {};
var isIE = typeof document.createElement('span').dragDrop === 'function';

DnD.install = function (Vue) {
    Vue.directive('draggable', {
        bind: function bind(el, binding, vnode) {
            if (!binding.value) return;
            if (!Vue.onduro.hasRole('planner')) return;

            el.setAttribute('data-item', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(binding.value));

            var dragStart = function dragStart(ev) {
                el.classList.add('dragging');
                document.body.classList.add('dragging');

                if (ev.dataTransfer.setDragImage) {
                    var offsetX = ev.offsetX,
                        offsetY = ev.offsetY;

                    if (ev.target.classList.contains('item-new')) {
                        offsetX = ev.offsetX - 20;
                        offsetY = ev.offsetY - 10;
                    }

                    ghost = el.cloneNode(true);
                    ghost.style.position = 'absolute';
                    ghost.style.top = '-1000px';
                    ghost.style.right = '-1000px';
                    ghost.classList.add('ghost');
                    document.body.appendChild(ghost);

                    ev.dataTransfer.setDragImage(ghost, offsetX, offsetY);
                }

                ev.dataTransfer.effectAllowed = 'move';
                ev.dataTransfer.setData('text', el.getAttribute('data-item'));

                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('drag.start', binding.value);

                    // close toolbox on drag start
                    __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('toolbox.close');
                });
            };

            var dragEnd = function dragEnd() {
                __WEBPACK_IMPORTED_MODULE_1__events_events__["a" /* default */].$emit('drag.end');

                if (ghost) ghost.parentNode.removeChild(ghost);
                el.classList.remove('dragging');
                document.body.classList.remove('dragging');
            };

            el.setAttribute('draggable', true);
            el.addEventListener('dragstart', dragStart);
            el.addEventListener('dragend', dragEnd);
        },
        componentUpdated: function componentUpdated(el, binding, vnode) {
            if (!binding.value) {
                el.setAttribute('draggable', false);
            } else {
                // update bindings
                el.setAttribute('data-item', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(binding.value));

                el.setAttribute('draggable', true);
            }
        },
        unbind: function unbind(el, binding, vnode) {
            el.setAttribute('draggable', false);
            el.removeEventListener('dragstart', {});
            el.removeEventListener('dragend', {});
        }
    });

    Vue.directive('droppable', {
        bind: function bind(el, binding, vnode) {
            el.setAttribute('data-target', binding.value.target);

            var drop = function drop(ev) {
                if (ev.preventDefault) ev.preventDefault();
                if (ev.stopPropagation) ev.stopPropagation();

                var data = ev.dataTransfer.getData('text');

                binding.value.callback.call(el, data, el.getAttribute('data-target'));
                ev.target.classList.remove('dragover');
            };

            var dragOver = function dragOver(ev) {
                if (ev.preventDefault) ev.preventDefault();
                if (ev.target.classList) ev.target.classList.add('dragover');
            };

            var dragLeave = function dragLeave(ev) {
                if (ev.preventDefault) ev.preventDefault();
                if (ev.target.classList) ev.target.classList.remove('dragover');
            };

            el.addEventListener('drop', drop);
            el.addEventListener('dragover', dragOver);
            el.addEventListener('dragenter', dragOver);
            el.addEventListener('dragleave', dragLeave);
        },
        componentUpdated: function componentUpdated(el, binding, vnode) {
            el.setAttribute('data-target', binding.value.target);
        },
        unbind: function unbind(el, binding, vnode) {
            el.setAttribute('draggable', false);
            el.removeEventListener('dragstart', {});
        }
    });

    Vue.directive('dragenter', {
        bind: function bind(el, binding, vnode) {
            var dragEnter = function dragEnter(ev) {
                if (ev.preventDefault) ev.preventDefault();
                if (ev.stopPropagation) ev.stopPropagation();
                ev.target.classList.add('dragover');
                binding.value.call(el);
            };

            el.addEventListener('dragenter', dragEnter);
        },
        unbind: function unbind(el, binding, vnode) {
            el.removeEventListener('dragenter', {});
        }
    });

    Vue.directive('dragleave', {
        bind: function bind(el, binding, vnode) {
            var dragLeave = function dragLeave(ev) {
                if (ev.preventDefault) ev.preventDefault();
                if (ev.stopPropagation) ev.stopPropagation();
                binding.value.call(el);
            };

            el.addEventListener('dragleave', dragLeave);
        },
        unbind: function unbind(el, binding, vnode) {
            el.removeEventListener('dragleave', {});
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = (DnD);

/***/ }),
/* 636 */,
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_Icon__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__global_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_MainContent__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_MainContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__global_MainContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_Tabs__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_Tab__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__global_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_Sidebar__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__global_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_ButtonBack_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_ButtonBack_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__global_ButtonBack_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_Container_vue__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_Container_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__global_Container_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_SubHeader__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__global_SubHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__global_SubHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_Action__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__global_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__global_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__global_FooterBar__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__global_FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__global_FooterBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__global_Dropdown__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__global_Dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__global_Dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_Search__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__global_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__global_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_Error__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__global_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__global_Toolbox__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__global_Toolbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__global_Toolbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__global_Gravatar__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__global_Gravatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__global_Gravatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__global_GravatarGroup__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__global_GravatarGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__global_GravatarGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_Selection__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_Selection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__global_Selection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__global_Timeframe__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__global_Timeframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__global_Timeframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__global_Pikaday__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__global_Pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__global_Pikaday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__global_Dates__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__global_Dates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__global_Dates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__global_Rangepicker__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__global_Rangepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__global_Rangepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__global_Percents__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__global_Percents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__global_Percents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__global_ChannelList__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__global_ChannelList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__global_ChannelList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__global_ChannelListSingle__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__global_ChannelListSingle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__global_ChannelListSingle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__global_ChannelListGroup__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__global_ChannelListGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__global_ChannelListGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__global_Chat__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__global_Chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__global_Chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__global_Bubble__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__global_Bubble___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__global_Bubble__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__global_ChatBubble__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__global_ChatBubble___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__global_ChatBubble__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__global_Profile__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__global_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__global_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__global_Numeric__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__global_Numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__global_Numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__global_dashboard_Card__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__global_dashboard_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__global_dashboard_Card__);
// Get Vue instance


// Imports

































// Register components in Vue
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_1__global_Icon___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('main-content', __WEBPACK_IMPORTED_MODULE_2__global_MainContent___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tabs', __WEBPACK_IMPORTED_MODULE_3__global_Tabs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tab', __WEBPACK_IMPORTED_MODULE_4__global_Tab___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sidebar', __WEBPACK_IMPORTED_MODULE_5__global_Sidebar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('button-back', __WEBPACK_IMPORTED_MODULE_6__global_ButtonBack_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('container', __WEBPACK_IMPORTED_MODULE_7__global_Container_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('sub-header', __WEBPACK_IMPORTED_MODULE_8__global_SubHeader___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('action', __WEBPACK_IMPORTED_MODULE_9__global_Action___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('footer-bar', __WEBPACK_IMPORTED_MODULE_10__global_FooterBar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('dropdown', __WEBPACK_IMPORTED_MODULE_11__global_Dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('search', __WEBPACK_IMPORTED_MODULE_12__global_Search___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('error', __WEBPACK_IMPORTED_MODULE_13__global_Error___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('toolbox', __WEBPACK_IMPORTED_MODULE_14__global_Toolbox___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('gravatar', __WEBPACK_IMPORTED_MODULE_15__global_Gravatar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('gravatar-group', __WEBPACK_IMPORTED_MODULE_16__global_GravatarGroup___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('selection', __WEBPACK_IMPORTED_MODULE_17__global_Selection___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('timeframe', __WEBPACK_IMPORTED_MODULE_18__global_Timeframe___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_19_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('pikaday', __WEBPACK_IMPORTED_MODULE_20__global_Pikaday___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('calendar', __WEBPACK_IMPORTED_MODULE_21__global_Dates___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('rangepicker', __WEBPACK_IMPORTED_MODULE_22__global_Rangepicker___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('percents', __WEBPACK_IMPORTED_MODULE_23__global_Percents___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('channel-list', __WEBPACK_IMPORTED_MODULE_24__global_ChannelList___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('profile-data', __WEBPACK_IMPORTED_MODULE_30__global_Profile___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('channel-list-single', __WEBPACK_IMPORTED_MODULE_25__global_ChannelListSingle___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('channel-list-group', __WEBPACK_IMPORTED_MODULE_26__global_ChannelListGroup___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('chat', __WEBPACK_IMPORTED_MODULE_27__global_Chat___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Bubble', __WEBPACK_IMPORTED_MODULE_28__global_Bubble___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('chatBubble', __WEBPACK_IMPORTED_MODULE_29__global_ChatBubble___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('numeric', __WEBPACK_IMPORTED_MODULE_31__global_Numeric___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('card', __WEBPACK_IMPORTED_MODULE_32__global_dashboard_Card___default.a);

/***/ })
],[346]);


// WEBPACK FOOTER //
// static/js/app.2c0c6adafc07ec09743b.js